"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Asclepius API 2.71.0
 * Vtable Health Backend
 *
 * The version of the OpenAPI document: 2.71.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.YouthMembershipApi = exports.YouthMembershipApiFactory = exports.YouthMembershipApiFp = exports.YouthMembershipApiAxiosParamCreator = exports.WorkforceIntegrationApi = exports.WorkforceIntegrationApiFactory = exports.WorkforceIntegrationApiFp = exports.WorkforceIntegrationApiAxiosParamCreator = exports.UtilityApi = exports.UtilityApiFactory = exports.UtilityApiFp = exports.UtilityApiAxiosParamCreator = exports.UserApi = exports.UserApiFactory = exports.UserApiFp = exports.UserApiAxiosParamCreator = exports.UrgentCareOrderingApi = exports.UrgentCareOrderingApiFactory = exports.UrgentCareOrderingApiFp = exports.UrgentCareOrderingApiAxiosParamCreator = exports.ToDoApi = exports.ToDoApiFactory = exports.ToDoApiFp = exports.ToDoApiAxiosParamCreator = exports.TaskApi = exports.TaskApiFactory = exports.TaskApiFp = exports.TaskApiAxiosParamCreator = exports.TagApi = exports.TagApiFactory = exports.TagApiFp = exports.TagApiAxiosParamCreator = exports.SurveyApi = exports.SurveyApiFactory = exports.SurveyApiFp = exports.SurveyApiAxiosParamCreator = exports.QuestionnairesApi = exports.QuestionnairesApiFactory = exports.QuestionnairesApiFp = exports.QuestionnairesApiAxiosParamCreator = exports.QuestionnaireFormApi = exports.QuestionnaireFormApiFactory = exports.QuestionnaireFormApiFp = exports.QuestionnaireFormApiAxiosParamCreator = exports.ProviderApi = exports.ProviderApiFactory = exports.ProviderApiFp = exports.ProviderApiAxiosParamCreator = exports.PrimaryCareVisitCheckInApi = exports.PrimaryCareVisitCheckInApiFactory = exports.PrimaryCareVisitCheckInApiFp = exports.PrimaryCareVisitCheckInApiAxiosParamCreator = exports.PartnersApi = exports.PartnersApiFactory = exports.PartnersApiFp = exports.PartnersApiAxiosParamCreator = exports.PBMApi = exports.PBMApiFactory = exports.PBMApiFp = exports.PBMApiAxiosParamCreator = exports.OnsiteClinicApi = exports.OnsiteClinicApiFactory = exports.OnsiteClinicApiFp = exports.OnsiteClinicApiAxiosParamCreator = exports.NotificationPreferencesApi = exports.NotificationPreferencesApiFactory = exports.NotificationPreferencesApiFp = exports.NotificationPreferencesApiAxiosParamCreator = exports.NotificationApi = exports.NotificationApiFactory = exports.NotificationApiFp = exports.NotificationApiAxiosParamCreator = exports.MemberApi = exports.MemberApiFactory = exports.MemberApiFp = exports.MemberApiAxiosParamCreator = exports.MedicalApi = exports.MedicalApiFactory = exports.MedicalApiFp = exports.MedicalApiAxiosParamCreator = exports.LabOrderingApi = exports.LabOrderingApiFactory = exports.LabOrderingApiFp = exports.LabOrderingApiAxiosParamCreator = exports.JournalApi = exports.JournalApiFactory = exports.JournalApiFp = exports.JournalApiAxiosParamCreator = exports.FeaturePolicyApi = exports.FeaturePolicyApiFactory = exports.FeaturePolicyApiFp = exports.FeaturePolicyApiAxiosParamCreator = exports.EntitlementApi = exports.EntitlementApiFactory = exports.EntitlementApiFp = exports.EntitlementApiAxiosParamCreator = exports.EncounterApi = exports.EncounterApiFactory = exports.EncounterApiFp = exports.EncounterApiAxiosParamCreator = exports.EmployeeManagementIntegrationApi = exports.EmployeeManagementIntegrationApiFactory = exports.EmployeeManagementIntegrationApiFp = exports.EmployeeManagementIntegrationApiAxiosParamCreator = exports.EPrescribeAuthApi = exports.EPrescribeAuthApiFactory = exports.EPrescribeAuthApiFp = exports.EPrescribeAuthApiAxiosParamCreator = exports.CompanyMemberApi = exports.CompanyMemberApiFactory = exports.CompanyMemberApiFp = exports.CompanyMemberApiAxiosParamCreator = exports.CompanyAdminApi = exports.CompanyAdminApiFactory = exports.CompanyAdminApiFp = exports.CompanyAdminApiAxiosParamCreator = exports.CompanyApi = exports.CompanyApiFactory = exports.CompanyApiFp = exports.CompanyApiAxiosParamCreator = exports.CommentsApi = exports.CommentsApiFactory = exports.CommentsApiFp = exports.CommentsApiAxiosParamCreator = exports.ClinicalAppointmentApi = exports.ClinicalAppointmentApiFactory = exports.ClinicalAppointmentApiFp = exports.ClinicalAppointmentApiAxiosParamCreator = exports.ClinicalAdminApi = exports.ClinicalAdminApiFactory = exports.ClinicalAdminApiFp = exports.ClinicalAdminApiAxiosParamCreator = exports.ChatApi = exports.ChatApiFactory = exports.ChatApiFp = exports.ChatApiAxiosParamCreator = exports.ChartingApi = exports.ChartingApiFactory = exports.ChartingApiFp = exports.ChartingApiAxiosParamCreator = exports.CensusApi = exports.CensusApiFactory = exports.CensusApiFp = exports.CensusApiAxiosParamCreator = exports.CareTeamApi = exports.CareTeamApiFactory = exports.CareTeamApiFp = exports.CareTeamApiAxiosParamCreator = exports.BillingApi = exports.BillingApiFactory = exports.BillingApiFp = exports.BillingApiAxiosParamCreator = exports.BenefitsApi = exports.BenefitsApiFactory = exports.BenefitsApiFp = exports.BenefitsApiAxiosParamCreator = exports.BatchApi = exports.BatchApiFactory = exports.BatchApiFp = exports.BatchApiAxiosParamCreator = exports.AvailabilityApi = exports.AvailabilityApiFactory = exports.AvailabilityApiFp = exports.AvailabilityApiAxiosParamCreator = exports.AuthenticationApi = exports.AuthenticationApiFactory = exports.AuthenticationApiFp = exports.AuthenticationApiAxiosParamCreator = exports.AsyncAppointmentApi = exports.AsyncAppointmentApiFactory = exports.AsyncAppointmentApiFp = exports.AsyncAppointmentApiAxiosParamCreator = exports.AppointmentRequestApi = exports.AppointmentRequestApiFactory = exports.AppointmentRequestApiFp = exports.AppointmentRequestApiAxiosParamCreator = exports.AppointmentApi = exports.AppointmentApiFactory = exports.AppointmentApiFp = exports.AppointmentApiAxiosParamCreator = exports.AnalyticsApi = exports.AnalyticsApiFactory = exports.AnalyticsApiFp = exports.AnalyticsApiAxiosParamCreator = exports.AddressApi = exports.AddressApiFactory = exports.AddressApiFp = exports.AddressApiAxiosParamCreator = exports.UserTypeEnum = exports.UserMetadataKeyEnum = exports.UrgentCareEnum = exports.ToDoStatusEnum = exports.ToDoFacadeTypeEnum = exports.ToDoCompletionTypeEnum = exports.TimeOfDayPreferenceEnum = exports.TelemedicineEventEnum = exports.TaskPriorityEnum = exports.TaskDesignationEnum = exports.TaskCategoryEnum = exports.TagTargetTypeEnum = exports.TagOwnerTypeEnum = exports.SymptomCriticalityEnum = exports.SupportedTimezoneEnum = exports.SupportChatChannelStatusEnum = exports.SupportChatChannelMetadataKeyEnum = exports.StateEnum = exports.SlackChannelEnum = exports.SexEnum = exports.SeverityEnum = exports.SearchProceduresResponseTypeEnum = exports.RsvpStatusEnum = exports.RestrictionGroupEnum = exports.RestrictionErrorCodeEnum = exports.ResponseCodeEnum = exports.ResourceEnum = exports.RecordTypesEnum = exports.ReasonForReleaseEnum = exports.QuestionnaireFormNameEnum = exports.QuestionEnum = exports.ProviderTypeEnum = exports.ProcedureStatusEnum = exports.ProblemClinicalStatusEnum = exports.PreferredLanguageEnum = exports.PostLabStatusEnum = exports.PostJournalFeedbackEnum = exports.PatientTypeEnum = exports.PartnerTypeEnum = exports.PartnerEmployeeTypeEnum = exports.PartnerEmployeeDealCommissionModel = exports.OrderRequestStatusEnum = exports.OrderRequestFacadeTypeEnum = exports.OccupationalHealthRecordStatusEnum = exports.ObservationStatusEnum = exports.NameSuffixEnum = exports.MoodEnum = exports.MessageTypeEnum = exports.MemberTypeEnum = exports.MemberAssistantChatChannelMetadataKeyEnum = exports.MedicationTypeEnum = exports.MedicationStatusEnum = exports.MedicationFrequencyEnum = exports.MedicationDosageFormEnum = exports.LabTestTypeEnum = exports.LabOrderStatusEnum = exports.LabOrderResultEnum = exports.LabOrderRequestStatusEnum = exports.LabOrderFacadeTypeEnum = exports.LabEnum = exports.LabDrawOptionEnum = exports.InteractionTypeEnum = exports.InteractionCorrespondentEnum = exports.InteractionChannelEnum = exports.IneligibleCompanySubscriptionReasonCodeEnum = exports.GuardianRelationshipEnum = exports.GoalCategoryEnum = exports.GenericQuestionnaireStatusEnum = exports.GenericQuestionnaireRelationTypeEnum = exports.GenderEnum = exports.FieldTypeEnum = exports.FeatureNameEnum = exports.FamilyRelationshipEnum = exports.EntitlementFrequencyEnum = exports.EncounterTypeEnum = exports.EncounterAiInsightTypeEnum = exports.EmployeeClassEnum = exports.EmployeeBenefitEligibilityTerminationReasonEnum = exports.EmployeeBenefitEligibilityPolicyWaitingPeriodEnum = exports.EmployeeBenefitEligibilityPolicyClassificationEnum = exports.EmergencyContactRelationshipEnum = exports.EditClinicAppointmentRequestTypeEnum = exports.EMIVendorEnum = exports.EMISystemTypeEnum = exports.EMISyncTypeEnum = exports.EMISyncOperationStatusEnum = exports.EMISyncOperationEventTypeEnum = exports.EMISyncErrorTypeEnum = exports.EMIConnectionStatusEnum = exports.CoveredByEnum = exports.CompanyYouthMembershipPlanEnrollmentStatusEnum = exports.CompanyTypeEnum = exports.CompanySubscriptionStatusEnum = exports.CompanyMemberTypeEnum = exports.CompanyBenefitEnrollmentStatusEnum = exports.CompanyAdminStatusEnum = exports.CodeableConceptSystemEnum = exports.ClinicalAppointmentRequestStatusEnum = exports.ClinicEditRequestStatusEnum = exports.ClinicEditRequestActionEnum = exports.ClickableMessageTypeEnum = exports.ChatbotInputTypeEnum = exports.ChatbotInputOptionTypeEnum = exports.ChatbotActionOptionEnum = exports.ChartTypeEnum = exports.ChartStatusEnum = exports.ChannelTypeEnum = exports.CareTeamRoleEnum = exports.BusinessTypeEnum = exports.BillCalculationOwnerEnum = exports.BenefitTypeEnum = exports.BenefitPlanNameEnum = exports.BenefitEnrollmentWaiveReasonEnum = exports.BenefitEnrollmentStatusEnum = exports.BenefitDependentTypeEnum = exports.BenefitCarrierEnum = exports.BeneficiaryEnum = exports.AyvaRxOrderStatusEnum = exports.AsyncAppointmentStatusEnum = exports.AppointmentTypesEnum = exports.AppointmentStatusEnum = exports.AppointmentSchedulingChannelMetadataKeyEnum = exports.AppointmentRequestStatusEnum = exports.AppointmentNotificationsChannelMetadataKeyEnum = exports.AppNameEnum = exports.AlternativeSolutionEnum = exports.AllergyTypeEnum = exports.AllergyCriticalityEnum = exports.AllergyClinicalStatusEnum = exports.AllergyCategoryEnum = exports.AllLabOrderFacadeTypeEnum = exports.AchievementStatusEnum = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("./common");
// @ts-ignore
const base_1 = require("./base");
/**
 * * `New` - New * `Improving` - Improving * `Worsening` - Worsening * `No change` - No Change * `Achieved` - Achieved
 * @export
 * @enum {string}
 */
exports.AchievementStatusEnum = {
    New: 'New',
    Improving: 'Improving',
    Worsening: 'Worsening',
    NoChange: 'No change',
    Achieved: 'Achieved'
};
/**
 * * `Lab Order` - Lab Order * `Lab Order Request` - Lab Order Request * `Manual Lab Result` - Manual Lab Result * `Occupational Health Lab Order Request` - Occupational Health Lab Order Request
 * @export
 * @enum {string}
 */
exports.AllLabOrderFacadeTypeEnum = {
    LabOrder: 'Lab Order',
    LabOrderRequest: 'Lab Order Request',
    ManualLabResult: 'Manual Lab Result',
    OccupationalHealthLabOrderRequest: 'Occupational Health Lab Order Request'
};
/**
 * * `Food` - Food * `Medication` - Medication * `Environment` - Environment * `Biologic` - Biologic
 * @export
 * @enum {string}
 */
exports.AllergyCategoryEnum = {
    Food: 'Food',
    Medication: 'Medication',
    Environment: 'Environment',
    Biologic: 'Biologic'
};
/**
 * * `Active` - Active * `Inactive` - Inactive * `Entered in error` - Entered In Error
 * @export
 * @enum {string}
 */
exports.AllergyClinicalStatusEnum = {
    Active: 'Active',
    Inactive: 'Inactive',
    EnteredInError: 'Entered in error'
};
/**
 * * `Low` - Low * `High` - High * `Unable to assess` - Unable To Assess
 * @export
 * @enum {string}
 */
exports.AllergyCriticalityEnum = {
    Low: 'Low',
    High: 'High',
    UnableToAssess: 'Unable to assess'
};
/**
 * * `Allergy` - Allergy * `Intolerance` - Intolerance
 * @export
 * @enum {string}
 */
exports.AllergyTypeEnum = {
    Allergy: 'Allergy',
    Intolerance: 'Intolerance'
};
/**
 * * `Emergency Room` - Emergency Room * `Doctor’s Office` - Doctor’s Office * `Urgent Care` - Urgent Care * `Retail Clinic` - Retail Clinic * `None` - None
 * @export
 * @enum {string}
 */
exports.AlternativeSolutionEnum = {
    EmergencyRoom: 'Emergency Room',
    DoctorsOffice: 'Doctor’s Office',
    UrgentCare: 'Urgent Care',
    RetailClinic: 'Retail Clinic',
    None: 'None'
};
/**
 * * `Company Dashboard` - Company Dashboard * `Provider Dashboard` - Provider Dashboard * `User Dashboard` - User Dashboard * `Member Mobile App` - Member Mobile App * `Operations Dashboard` - Operations Dashboard * `Vitable Admin` - Vitable Admin
 * @export
 * @enum {string}
 */
exports.AppNameEnum = {
    CompanyDashboard: 'Company Dashboard',
    ProviderDashboard: 'Provider Dashboard',
    UserDashboard: 'User Dashboard',
    MemberMobileApp: 'Member Mobile App',
    OperationsDashboard: 'Operations Dashboard',
    VitableAdmin: 'Vitable Admin'
};
/**
 * * `member_id` - member_id
 * @export
 * @enum {string}
 */
exports.AppointmentNotificationsChannelMetadataKeyEnum = {
    MemberId: 'member_id'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.AppointmentRequestStatusEnum = {
    Pending: 'Pending',
    Fulfilled: 'Fulfilled',
    Cancelled: 'Cancelled'
};
/**
 * * `member_id` - member_id * `channel_status` - channel_status
 * @export
 * @enum {string}
 */
exports.AppointmentSchedulingChannelMetadataKeyEnum = {
    MemberId: 'member_id',
    ChannelStatus: 'channel_status'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.AppointmentStatusEnum = {
    Cancelled: 'Cancelled',
    Scheduled: 'Scheduled',
    Contacted: 'Contacted',
    Departed: 'Departed',
    Arrived: 'Arrived',
    Completed: 'Completed',
    AwaitingApproval: 'Awaiting Approval',
    Charted: 'Charted',
    Closed: 'Closed'
};
/**
 * * `In Person` - In Person * `Telemedicine` - Telemedicine
 * @export
 * @enum {string}
 */
exports.AppointmentTypesEnum = {
    InPerson: 'In Person',
    Telemedicine: 'Telemedicine'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.AsyncAppointmentStatusEnum = {
    Submitted: 'Submitted',
    Claimed: 'Claimed',
    OnHold: 'On hold',
    Charted: 'Charted',
    Closed: 'Closed',
    Cancelled: 'Cancelled'
};
/**
 * * `PENDING` - Pending * `PRINTED` - Printed * `XMIT` - Xmit * `XMIT_FAILED` - Xmit Failed * `CANCEL_PENDING` - Cancel Pending * `CANCEL_SUCCESS` - Cancel Success * `CANCEL_FAILED` - Cancel Failed * `RX_CHANGE_APPROVED` - Rx Change Approved * `RX_CHANGE_APPROVED_WITH_CHANGE` - Rx Change Approved With Change * `RX_CHANGE_DENIED` - Rx Change Denied * `RX_CHANGE_SENT` - Rx Change Sent * `ERROR` - Error
 * @export
 * @enum {string}
 */
exports.AyvaRxOrderStatusEnum = {
    Pending: 'PENDING',
    Printed: 'PRINTED',
    Xmit: 'XMIT',
    XmitFailed: 'XMIT_FAILED',
    CancelPending: 'CANCEL_PENDING',
    CancelSuccess: 'CANCEL_SUCCESS',
    CancelFailed: 'CANCEL_FAILED',
    RxChangeApproved: 'RX_CHANGE_APPROVED',
    RxChangeApprovedWithChange: 'RX_CHANGE_APPROVED_WITH_CHANGE',
    RxChangeDenied: 'RX_CHANGE_DENIED',
    RxChangeSent: 'RX_CHANGE_SENT',
    Error: 'ERROR'
};
/**
 * * `Member` - Member * `Company` - Company
 * @export
 * @enum {string}
 */
exports.BeneficiaryEnum = {
    Member: 'Member',
    Company: 'Company'
};
/**
 * * `Essential Benefit Administrators` - Eba * `Liferaft` - Liferaft * `Vitable` - Vitable
 * @export
 * @enum {string}
 */
exports.BenefitCarrierEnum = {
    EssentialBenefitAdministrators: 'Essential Benefit Administrators',
    Liferaft: 'Liferaft',
    Vitable: 'Vitable'
};
/**
 * * `Spouse` - Spouse * `Child` - Child
 * @export
 * @enum {string}
 */
exports.BenefitDependentTypeEnum = {
    Spouse: 'Spouse',
    Child: 'Child'
};
/**
 * * `Unanswered` - Unanswered * `Enrolled` - Enrolled * `Waived` - Waived
 * @export
 * @enum {string}
 */
exports.BenefitEnrollmentStatusEnum = {
    Unanswered: 'Unanswered',
    Enrolled: 'Enrolled',
    Waived: 'Waived'
};
/**
 * * `Already covered` - Already Covered * `Declined` - Declined * `Benefit is too expensive` - Too Expensive * `Benefit is not valuable` - Not Valuable * `Age not covered` - Age Not Covered * `In home not covered` - In Home Not Covered * `Zip not covered` - Zip Not Covered
 * @export
 * @enum {string}
 */
exports.BenefitEnrollmentWaiveReasonEnum = {
    AlreadyCovered: 'Already covered',
    Declined: 'Declined',
    BenefitIsTooExpensive: 'Benefit is too expensive',
    BenefitIsNotValuable: 'Benefit is not valuable',
    AgeNotCovered: 'Age not covered',
    InHomeNotCovered: 'In home not covered',
    ZipNotCovered: 'Zip not covered'
};
/**
 * * `Vitable General Primary Care` - Vitable General Primary Care * `Vitable Premium Primary Care` - Vitable Premium Primary Care * `Vitable Premium Primary Care with MEC Basic` - Vitable Premium Primary Care with MEC Basic * `Vitable Youth Mental Health Program` - Vitable Youth Mental Health Program * `MEC` - MEC * `MEC Plus` - MEC Plus
 * @export
 * @enum {string}
 */
exports.BenefitPlanNameEnum = {
    VitableGeneralPrimaryCare: 'Vitable General Primary Care',
    VitablePremiumPrimaryCare: 'Vitable Premium Primary Care',
    VitablePremiumPrimaryCareWithMecBasic: 'Vitable Premium Primary Care with MEC Basic',
    VitableYouthMentalHealthProgram: 'Vitable Youth Mental Health Program',
    Mec: 'MEC',
    MecPlus: 'MEC Plus'
};
/**
 * * `Health` - Health * `Vision` - Vision * `Dental` - Dental * `EBA` - Eba Mec * `VPC` - Vpc * `MEC` - Vpc Mec * `MEC2` - Mec2
 * @export
 * @enum {string}
 */
exports.BenefitTypeEnum = {
    Health: 'Health',
    Vision: 'Vision',
    Dental: 'Dental',
    Eba: 'EBA',
    Vpc: 'VPC',
    Mec: 'MEC',
    Mec2: 'MEC2'
};
/**
 * * `Chargebee` - Chargebee * `Vitable` - Vitable
 * @export
 * @enum {string}
 */
exports.BillCalculationOwnerEnum = {
    Chargebee: 'Chargebee',
    Vitable: 'Vitable'
};
/**
 * * `Incorporated Non Profit` - Incorporated Non Profit * `LLC` - Llc * `Partnership` - Partnership * `Private Corporation` - Private Corporation * `Public Corporation` - Public Corporation * `Sole Proprietorship` - Sole Proprietorship * `Trust` - Trust * `Unincorporated Association` - Unincorporated Association * `Unincorporated Non Profit` - Unincorporated Non Profit
 * @export
 * @enum {string}
 */
exports.BusinessTypeEnum = {
    IncorporatedNonProfit: 'Incorporated Non Profit',
    Llc: 'LLC',
    Partnership: 'Partnership',
    PrivateCorporation: 'Private Corporation',
    PublicCorporation: 'Public Corporation',
    SoleProprietorship: 'Sole Proprietorship',
    Trust: 'Trust',
    UnincorporatedAssociation: 'Unincorporated Association',
    UnincorporatedNonProfit: 'Unincorporated Non Profit'
};
/**
 * * `Clinical Provider` - Cp * `Therapist` - Therapist * `Mental Health Coach` - Mental Health Coach * `Care Navigator` - Care Navigator
 * @export
 * @enum {string}
 */
exports.CareTeamRoleEnum = {
    ClinicalProvider: 'Clinical Provider',
    Therapist: 'Therapist',
    MentalHealthCoach: 'Mental Health Coach',
    CareNavigator: 'Care Navigator'
};
/**
 * * `Appointment Scheduling` - Appointment Scheduling * `Appointment Notifications` - Appointment Notifications * `Support Chat` - Support Chat * `Physician Chat` - Physician Chat * `Fitness Trainer Chat` - Fitness Trainer Chat * `Mental Health Coach Chat` - Mental Health Coach Chat * `Nutritionist Chat` - Nutritionist Chat
 * @export
 * @enum {string}
 */
exports.ChannelTypeEnum = {
    AppointmentScheduling: 'Appointment Scheduling',
    AppointmentNotifications: 'Appointment Notifications',
    SupportChat: 'Support Chat',
    PhysicianChat: 'Physician Chat',
    FitnessTrainerChat: 'Fitness Trainer Chat',
    MentalHealthCoachChat: 'Mental Health Coach Chat',
    NutritionistChat: 'Nutritionist Chat'
};
/**
 * * `In Progress` - In Progress * `Form Generated` - Form Generated * `Form Locked` - Form Locked * `Published` - Published * `Awaiting Results` - Awaiting Results * `Entered in error` - Entered in error
 * @export
 * @enum {string}
 */
exports.ChartStatusEnum = {
    InProgress: 'In Progress',
    FormGenerated: 'Form Generated',
    FormLocked: 'Form Locked',
    Published: 'Published',
    AwaitingResults: 'Awaiting Results',
    EnteredInError: 'Entered in error'
};
/**
 * * `History of Present Illness` - Hpi * `Physical Exam` - Pe * `Clinical Reasoning` - Clinical Reasoning * `Medical Forms` - Medical Forms * `Additional Files` - Additional Files * `SOAP` - Soap * `Visit Summary` - Visit Summary
 * @export
 * @enum {string}
 */
exports.ChartTypeEnum = {
    HistoryOfPresentIllness: 'History of Present Illness',
    PhysicalExam: 'Physical Exam',
    ClinicalReasoning: 'Clinical Reasoning',
    MedicalForms: 'Medical Forms',
    AdditionalFiles: 'Additional Files',
    Soap: 'SOAP',
    VisitSummary: 'Visit Summary'
};
/**
 * * `CLOSE_SCREEN` - CLOSE_SCREEN * `TO_HOME_SCREEN` - TO_HOME_SCREEN * `OPEN_INTERCOM` - OPEN_INTERCOM * `OPEN_BOTTOM_SHEET_CALENDAR` - OPEN_BOTTOM_SHEET_CALENDAR * `OPEN_VISIT_REASONS` - OPEN_VISIT_REASONS * `OPEN_SYMPTOMS` - OPEN_SYMPTOMS * `OPEN_REQUEST_APPOINTMENT` - OPEN_REQUEST_APPOINTMENT
 * @export
 * @enum {string}
 */
exports.ChatbotActionOptionEnum = {
    CloseScreen: 'CLOSE_SCREEN',
    ToHomeScreen: 'TO_HOME_SCREEN',
    OpenIntercom: 'OPEN_INTERCOM',
    OpenBottomSheetCalendar: 'OPEN_BOTTOM_SHEET_CALENDAR',
    OpenVisitReasons: 'OPEN_VISIT_REASONS',
    OpenSymptoms: 'OPEN_SYMPTOMS',
    OpenRequestAppointment: 'OPEN_REQUEST_APPOINTMENT'
};
/**
 * * `TEXT_OPTIONS` - TEXT_OPTIONS * `MEMBER_OPTIONS` - MEMBER_OPTIONS * `AVAILABILITY_OPTIONS` - AVAILABILITY_OPTIONS * `VISIT_REASON_OPTIONS` - VISIT_REASON_OPTIONS * `SYMPTOM_OPTIONS` - SYMPTOM_OPTIONS * `MEMBER_SINGLE_SELECT_OPTIONS` - MEMBER_SINGLE_SELECT_OPTIONS * `ACTION_OPTIONS` - ACTION_OPTIONS
 * @export
 * @enum {string}
 */
exports.ChatbotInputOptionTypeEnum = {
    TextOptions: 'TEXT_OPTIONS',
    MemberOptions: 'MEMBER_OPTIONS',
    AvailabilityOptions: 'AVAILABILITY_OPTIONS',
    VisitReasonOptions: 'VISIT_REASON_OPTIONS',
    SymptomOptions: 'SYMPTOM_OPTIONS',
    MemberSingleSelectOptions: 'MEMBER_SINGLE_SELECT_OPTIONS',
    ActionOptions: 'ACTION_OPTIONS'
};
/**
 * * `TEXT_INPUT` - TEXT_INPUT * `TEXT_AND_IMAGE_INPUT` - TEXT_AND_IMAGE_INPUT * `ADDRESS_INPUT` - ADDRESS_INPUT * `SINGLE_SELECT_OPTIONS_INPUT` - SINGLE_SELECT_OPTIONS_INPUT * `MULTIPLE_SELECT_OPTIONS_INPUT` - MULTIPLE_SELECT_OPTIONS_INPUT * `OPTION_INPUT` - OPTION_INPUT
 * @export
 * @enum {string}
 */
exports.ChatbotInputTypeEnum = {
    TextInput: 'TEXT_INPUT',
    TextAndImageInput: 'TEXT_AND_IMAGE_INPUT',
    AddressInput: 'ADDRESS_INPUT',
    SingleSelectOptionsInput: 'SINGLE_SELECT_OPTIONS_INPUT',
    MultipleSelectOptionsInput: 'MULTIPLE_SELECT_OPTIONS_INPUT',
    OptionInput: 'OPTION_INPUT'
};
/**
 * * `VISIT_SUMMARY_READY` - VISIT_SUMMARY_READY * `APPOINTMENT_SCHEDULED` - APPOINTMENT_SCHEDULED * `APPOINTMENT_REQUESTED` - APPOINTMENT_REQUESTED * `OPEN_SCHEDULING` - OPEN_SCHEDULING * `OPEN_WEB_BROWSER` - OPEN_WEB_BROWSER * `MEDICATION_PRESCRIBED` - MEDICATION_PRESCRIBED * `OPEN_PHARMACY_CARD` - OPEN_PHARMACY_CARD * `OPEN_QUESTIONNAIRE` - OPEN_QUESTIONNAIRE
 * @export
 * @enum {string}
 */
exports.ClickableMessageTypeEnum = {
    VisitSummaryReady: 'VISIT_SUMMARY_READY',
    AppointmentScheduled: 'APPOINTMENT_SCHEDULED',
    AppointmentRequested: 'APPOINTMENT_REQUESTED',
    OpenScheduling: 'OPEN_SCHEDULING',
    OpenWebBrowser: 'OPEN_WEB_BROWSER',
    MedicationPrescribed: 'MEDICATION_PRESCRIBED',
    OpenPharmacyCard: 'OPEN_PHARMACY_CARD',
    OpenQuestionnaire: 'OPEN_QUESTIONNAIRE'
};
/**
 * * `Change attendees` - Change Attendees * `Change clinic services` - Change Clinic Services * `Change clinic address` - Change Address * `Change clinic requested date` - Change Requested Date
 * @export
 * @enum {string}
 */
exports.ClinicEditRequestActionEnum = {
    Attendees: 'Change attendees',
    ClinicServices: 'Change clinic services',
    ClinicAddress: 'Change clinic address',
    ClinicRequestedDate: 'Change clinic requested date'
};
/**
 * * `Pending` - Pending * `Approved` - Approved * `Rejected` - Rejected
 * @export
 * @enum {string}
 */
exports.ClinicEditRequestStatusEnum = {
    Pending: 'Pending',
    Approved: 'Approved',
    Rejected: 'Rejected'
};
/**
 * * `Denied` - Denied * `Approved` - Approved * `Pending` - Pending
 * @export
 * @enum {string}
 */
exports.ClinicalAppointmentRequestStatusEnum = {
    Denied: 'Denied',
    Approved: 'Approved',
    Pending: 'Pending'
};
/**
 * * `ICD9` - http://hl7.org/fhir/sid/icd-9 * `ICD10` - http://hl7.org/fhir/sid/icd-10 * `ICD10_CM` - http://hl7.org/fhir/sid/icd-10-cm * `SNOMED` - http://snomed.info/sct * `RXCUI` - http://www.nlm.nih.gov/research/umls/rxnorm * `MDDID` - http://terminology.hl7.org/CodeSystem/mddid * `NDC` - http://hl7.org/fhir/us/carin-bb/ValueSet/FDANationalDrugCode * `SUNRISE_MA` - urn:uuid:f:1c4ef4560d71ee2952df99b6 * `LAB_CORP` - urn:uuid:f:a855594f43fe879c6570b92e * `QUEST` - urn:uuid:f:62c98652927b52326b2e112c * `DEV_LABCORP1` - urn:uuid:f:e20f61500ba128d340068ff6 * `DEV_QUEST` - urn:uuid:f:037a4352efe15a7ab6f00a01 * `DEV_TESTINGLAB_FACILITY` - urn:uuid:f:4f0235627ac2d59b49e5575c * `QUEST_CERTIFICATION` - urn:uuid:f:6927735e92bc9c4cc2599d15
 * @export
 * @enum {string}
 */
exports.CodeableConceptSystemEnum = {
    Icd9: 'ICD9',
    Icd10: 'ICD10',
    Icd10Cm: 'ICD10_CM',
    Snomed: 'SNOMED',
    Rxcui: 'RXCUI',
    Mddid: 'MDDID',
    Ndc: 'NDC',
    SunriseMa: 'SUNRISE_MA',
    LabCorp: 'LAB_CORP',
    Quest: 'QUEST',
    DevLabcorp1: 'DEV_LABCORP1',
    DevQuest: 'DEV_QUEST',
    DevTestinglabFacility: 'DEV_TESTINGLAB_FACILITY',
    QuestCertification: 'QUEST_CERTIFICATION'
};
/**
 * * `Invited` - Invited * `Active` - Active
 * @export
 * @enum {string}
 */
exports.CompanyAdminStatusEnum = {
    Invited: 'Invited',
    Active: 'Active'
};
/**
 * * `Eligible` - Eligible * `Expired` - Expired * `Waived` - Waived * `Terminated` - Terminated * `Coverage Upcoming` - Coverage Upcoming * `Covered` - Covered * `Coverage Ended` - Coverage Ended * `Company Churned` - Company Churned
 * @export
 * @enum {string}
 */
exports.CompanyBenefitEnrollmentStatusEnum = {
    Eligible: 'Eligible',
    Expired: 'Expired',
    Waived: 'Waived',
    Terminated: 'Terminated',
    CoverageUpcoming: 'Coverage Upcoming',
    Covered: 'Covered',
    CoverageEnded: 'Coverage Ended',
    CompanyChurned: 'Company Churned'
};
/**
 * * `Employee` - Employee * `Recruit` - Recruit * `Youth` - Youth
 * @export
 * @enum {string}
 */
exports.CompanyMemberTypeEnum = {
    Employee: 'Employee',
    Recruit: 'Recruit',
    Youth: 'Youth'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.CompanySubscriptionStatusEnum = {
    Future: 'Future',
    Active: 'Active',
    Expired: 'Expired'
};
/**
 * * `DEFAULT` - Default * `Daycare` - Daycare * `Restaurant` - Restaurant * `Home Health Care` - Home Health Care
 * @export
 * @enum {string}
 */
exports.CompanyTypeEnum = {
    Default: 'DEFAULT',
    Daycare: 'Daycare',
    Restaurant: 'Restaurant',
    HomeHealthCare: 'Home Health Care'
};
/**
 * * `Enrolled` - Enrolled * `Unanswered` - Unanswered
 * @export
 * @enum {string}
 */
exports.CompanyYouthMembershipPlanEnrollmentStatusEnum = {
    Enrolled: 'Enrolled',
    Unanswered: 'Unanswered'
};
/**
 * * `Ventegra` - Ventegra
 * @export
 * @enum {string}
 */
exports.CoveredByEnum = {
    Ventegra: 'Ventegra'
};
/**
 * * `Pending` - Pending * `Active` - Active * `Inactive` - Inactive * `Terminated` - Terminated
 * @export
 * @enum {string}
 */
exports.EMIConnectionStatusEnum = {
    Pending: 'Pending',
    Active: 'Active',
    Inactive: 'Inactive',
    Terminated: 'Terminated'
};
/**
 * * `Duplicate demographics` - Duplicate Demographics * `Invalid demographics` - Invalid Demographics * `Unknown` - Unknown
 * @export
 * @enum {string}
 */
exports.EMISyncErrorTypeEnum = {
    DuplicateDemographics: 'Duplicate demographics',
    InvalidDemographics: 'Invalid demographics',
    Unknown: 'Unknown'
};
/**
 * * `Added` - Added * `Removed` - Removed * `Updated` - Updated * `Reactivated` - Reactivated
 * @export
 * @enum {string}
 */
exports.EMISyncOperationEventTypeEnum = {
    Added: 'Added',
    Removed: 'Removed',
    Updated: 'Updated',
    Reactivated: 'Reactivated'
};
/**
 * * `Running` - Running * `Success` - Success * `Failure` - Failure
 * @export
 * @enum {string}
 */
exports.EMISyncOperationStatusEnum = {
    Running: 'Running',
    Success: 'Success',
    Failure: 'Failure'
};
/**
 * * `Automated` - Automated * `Manual` - Manual
 * @export
 * @enum {string}
 */
exports.EMISyncTypeEnum = {
    Automated: 'Automated',
    Manual: 'Manual'
};
/**
 * * `HRIS` - Hris * `ATS` - Ats
 * @export
 * @enum {string}
 */
exports.EMISystemTypeEnum = {
    Hris: 'HRIS',
    Ats: 'ATS'
};
/**
 * * `Finch` - Finch * `HHAeXchange` - Hha Exchange
 * @export
 * @enum {string}
 */
exports.EMIVendorEnum = {
    Finch: 'Finch',
    HhaeXchange: 'HHAeXchange'
};
/**
 * * `Add member` - Add member * `Remove member` - Remove member * `Edit address` - Edit address * `Add service` - Add service * `Remove service` - Remove service
 * @export
 * @enum {string}
 */
exports.EditClinicAppointmentRequestTypeEnum = {
    AddMember: 'Add member',
    RemoveMember: 'Remove member',
    EditAddress: 'Edit address',
    AddService: 'Add service',
    RemoveService: 'Remove service'
};
/**
 * * `Child` - Child * `Spouse` - Spouse * `Parent` - Parent * `Guardian` - Guardian * `Grandparent` - Grandparent * `Sibling` - Sibling * `Cousin` - Cousin * `Uncle` - Uncle * `Aunt` - Aunt * `Other` - Other
 * @export
 * @enum {string}
 */
exports.EmergencyContactRelationshipEnum = {
    Child: 'Child',
    Spouse: 'Spouse',
    Parent: 'Parent',
    Guardian: 'Guardian',
    Grandparent: 'Grandparent',
    Sibling: 'Sibling',
    Cousin: 'Cousin',
    Uncle: 'Uncle',
    Aunt: 'Aunt',
    Other: 'Other'
};
/**
 * * `Full time` - Full Time * `Part time` - Part Time * `All` - All
 * @export
 * @enum {string}
 */
exports.EmployeeBenefitEligibilityPolicyClassificationEnum = {
    FullTime: 'Full time',
    PartTime: 'Part time',
    All: 'All'
};
/**
 * * `1st of the following month` - First Of Following Month * `30 days` - Thirty Days * `60 days` - Sixty Days * `None` - None
 * @export
 * @enum {string}
 */
exports.EmployeeBenefitEligibilityPolicyWaitingPeriodEnum = {
    _1stOfTheFollowingMonth: '1st of the following month',
    _30Days: '30 days',
    _60Days: '60 days',
    None: 'None'
};
/**
 * * `Death of employee` - Death * `Employer bankruptcy` - Employer Bankruptcy * `Employee entitled to Medicare` - Medicare Entitlement * `Reduction in hours for employee` - Reduction In Hours * `Employee terminated` - Termination * `Employee declined benefits` - Declined Benefits * `Employee does not qualify for benefits` - Does Not Qualify
 * @export
 * @enum {string}
 */
exports.EmployeeBenefitEligibilityTerminationReasonEnum = {
    DeathOfEmployee: 'Death of employee',
    EmployerBankruptcy: 'Employer bankruptcy',
    EmployeeEntitledToMedicare: 'Employee entitled to Medicare',
    ReductionInHoursForEmployee: 'Reduction in hours for employee',
    EmployeeTerminated: 'Employee terminated',
    EmployeeDeclinedBenefits: 'Employee declined benefits',
    EmployeeDoesNotQualifyForBenefits: 'Employee does not qualify for benefits'
};
/**
 * * `Full Time` - Full Time * `Part Time` - Part Time * `Temporary` - Temporary * `Intern` - Intern * `Seasonal` - Seasonal * `Individual Contractor` - Individual Contractor
 * @export
 * @enum {string}
 */
exports.EmployeeClassEnum = {
    FullTime: 'Full Time',
    PartTime: 'Part Time',
    Temporary: 'Temporary',
    Intern: 'Intern',
    Seasonal: 'Seasonal',
    IndividualContractor: 'Individual Contractor'
};
/**
 * * `Summary` - Summary * `Suggestion` - Suggestion
 * @export
 * @enum {string}
 */
exports.EncounterAiInsightTypeEnum = {
    Summary: 'Summary',
    Suggestion: 'Suggestion'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.EncounterTypeEnum = {
    ClinicAppointment: 'Clinic appointment',
    InHomeAppointment: 'In-home appointment',
    TelehealthAppointment: 'Telehealth appointment',
    AsyncAppointment: 'Async appointment'
};
/**
 * * `Weekly` - Weekly * `Monthly` - Monthly * `Yearly` - Yearly
 * @export
 * @enum {string}
 */
exports.EntitlementFrequencyEnum = {
    Weekly: 'Weekly',
    Monthly: 'Monthly',
    Yearly: 'Yearly'
};
/**
 * * `Mother` - Mother * `Father` - Father * `Sibling` - Sibling * `Child` - Child * `Aunt (Maternal)` - M Aunt * `Aunt (Paternal)` - P Aunt * `Uncle (Maternal)` - M Uncle * `Uncle (Paternal)` - P Uncle * `Cousin (Maternal)` - M Cousin * `Cousin (Paternal)` - P Cousin * `Grandparent (Maternal)` - M G Parent * `Grandparent (Paternal)` - P G Parent * `Great Grandparent (Maternal)` - M Gg Parent * `Great Grandparent (Paternal)` - P Gg Parent * `Niece / Nephew` - Niece Or Nephew
 * @export
 * @enum {string}
 */
exports.FamilyRelationshipEnum = {
    Mother: 'Mother',
    Father: 'Father',
    Sibling: 'Sibling',
    Child: 'Child',
    AuntMaternal: 'Aunt (Maternal)',
    AuntPaternal: 'Aunt (Paternal)',
    UncleMaternal: 'Uncle (Maternal)',
    UnclePaternal: 'Uncle (Paternal)',
    CousinMaternal: 'Cousin (Maternal)',
    CousinPaternal: 'Cousin (Paternal)',
    GrandparentMaternal: 'Grandparent (Maternal)',
    GrandparentPaternal: 'Grandparent (Paternal)',
    GreatGrandparentMaternal: 'Great Grandparent (Maternal)',
    GreatGrandparentPaternal: 'Great Grandparent (Paternal)',
    NieceNephew: 'Niece / Nephew'
};
/**
 * * `Telemedicine coverage` - Telemedicine Coverage * `In-home coverage` - In Home Coverage * `Free medication coverage` - Free Medication Coverage * `Visits` - Visits * `Occupational health LabCorp lab vouchers` - Oh Labcorp Lab Orders * `Occupational health Quest lab vouchers` - Oh Quest Lab Orders * `Occupational health urgent care vouchers` - Oh Cvs Urgent Care Orders * `Occupational health LabCorp drug & alcohol vouchers` - Oh Labcorp Drug Alc Tests * `Occupational health clinics` - Oh Clinics * `Occupational health youth clinics` - Oh Youth Clinics * `HR platform integration` - Hr Platform Integration * `Medical service` - Medical Service * `Incremental membership allotment upgrading` - Incremental Membership Allotment Upgrading
 * @export
 * @enum {string}
 */
exports.FeatureNameEnum = {
    TelemedicineCoverage: 'Telemedicine coverage',
    InHomeCoverage: 'In-home coverage',
    FreeMedicationCoverage: 'Free medication coverage',
    Visits: 'Visits',
    OccupationalHealthLabCorpLabVouchers: 'Occupational health LabCorp lab vouchers',
    OccupationalHealthQuestLabVouchers: 'Occupational health Quest lab vouchers',
    OccupationalHealthUrgentCareVouchers: 'Occupational health urgent care vouchers',
    OccupationalHealthLabCorpDrugAlcoholVouchers: 'Occupational health LabCorp drug & alcohol vouchers',
    OccupationalHealthClinics: 'Occupational health clinics',
    OccupationalHealthYouthClinics: 'Occupational health youth clinics',
    HrPlatformIntegration: 'HR platform integration',
    MedicalService: 'Medical service',
    IncrementalMembershipAllotmentUpgrading: 'Incremental membership allotment upgrading'
};
/**
 * * `TEXT` - Text * `TEXT_AREA` - Text Area * `SELECT` - Select * `MULTI_SELECT` - Multi Select * `CHECKBOX` - Checkbox * `FILE` - File
 * @export
 * @enum {string}
 */
exports.FieldTypeEnum = {
    Text: 'TEXT',
    TextArea: 'TEXT_AREA',
    Select: 'SELECT',
    MultiSelect: 'MULTI_SELECT',
    Checkbox: 'CHECKBOX',
    File: 'FILE'
};
/**
 * * `Male` - Male * `Female` - Female * `Transgender` - Transgender * `Non-binary` - Non Binary * `Prefer not to respond` - Prefer Not To Respond
 * @export
 * @enum {string}
 */
exports.GenderEnum = {
    Male: 'Male',
    Female: 'Female',
    Transgender: 'Transgender',
    NonBinary: 'Non-binary',
    PreferNotToRespond: 'Prefer not to respond'
};
/**
 * * `Async Appointment` - Async Appointment * `Appointment` - Appointment * `Encounter` - Encounter
 * @export
 * @enum {string}
 */
exports.GenericQuestionnaireRelationTypeEnum = {
    AsyncAppointment: 'Async Appointment',
    Appointment: 'Appointment',
    Encounter: 'Encounter'
};
/**
 * * `Pending` - Pending * `Incomplete` - Incomplete * `Complete` - Complete
 * @export
 * @enum {string}
 */
exports.GenericQuestionnaireStatusEnum = {
    Pending: 'Pending',
    Incomplete: 'Incomplete',
    Complete: 'Complete'
};
/**
 * * `Dietary` - Dietary * `Safety` - Safety * `Behavioral` - Behavioral * `Nursing` - Nursing * `Physiotherapy` - Physiotherapy * `Other` - Other
 * @export
 * @enum {string}
 */
exports.GoalCategoryEnum = {
    Dietary: 'Dietary',
    Safety: 'Safety',
    Behavioral: 'Behavioral',
    Nursing: 'Nursing',
    Physiotherapy: 'Physiotherapy',
    Other: 'Other'
};
/**
 * * `Child` - Child * `Spouse` - Spouse * `Roommate` - Roommate * `Other` - Other
 * @export
 * @enum {string}
 */
exports.GuardianRelationshipEnum = {
    Child: 'Child',
    Spouse: 'Spouse',
    Roommate: 'Roommate',
    Other: 'Other'
};
/**
 * * `Expired Subscription` - Expired Subscription * `Invalid Plan Permissions` - Invalid Plan Permissions * `Invalid Plan` - Invalid Plan * `Membership Limit Reached` - Membership Limit Reached
 * @export
 * @enum {string}
 */
exports.IneligibleCompanySubscriptionReasonCodeEnum = {
    ExpiredSubscription: 'Expired Subscription',
    InvalidPlanPermissions: 'Invalid Plan Permissions',
    InvalidPlan: 'Invalid Plan',
    MembershipLimitReached: 'Membership Limit Reached'
};
/**
 * * `Phone` - Phone * `Email` - Email * `SMS` - Sms * `Chat` - Chat * `Documentation` - Documentation
 * @export
 * @enum {string}
 */
exports.InteractionChannelEnum = {
    Phone: 'Phone',
    Email: 'Email',
    Sms: 'SMS',
    Chat: 'Chat',
    Documentation: 'Documentation'
};
/**
 * * `Patient` - Patient * `Patient representative` - Patient Representative * `Internal` - Internal * `None` - None * `Other` - Other
 * @export
 * @enum {string}
 */
exports.InteractionCorrespondentEnum = {
    Patient: 'Patient',
    PatientRepresentative: 'Patient representative',
    Internal: 'Internal',
    None: 'None',
    Other: 'Other'
};
/**
 * * `Follow-up` - Follow Up * `Prescription change` - Prescription Change * `Care coordination` - Care Coordination * `Admin note` - Admin Note * `Lab order` - Lab Order * `Lab review` - Lab Review * `Other` - Other
 * @export
 * @enum {string}
 */
exports.InteractionTypeEnum = {
    FollowUp: 'Follow-up',
    PrescriptionChange: 'Prescription change',
    CareCoordination: 'Care coordination',
    AdminNote: 'Admin note',
    LabOrder: 'Lab order',
    LabReview: 'Lab review',
    Other: 'Other'
};
/**
 * * `GetLabs In-Home` - Getlabs In Home * `LabCorp Service Center` - Labcorp Service Center
 * @export
 * @enum {string}
 */
exports.LabDrawOptionEnum = {
    GetLabsInHome: 'GetLabs In-Home',
    LabCorpServiceCenter: 'LabCorp Service Center'
};
/**
 * * `LabCorp` - Lab Corp * `Quest` - Quest * `Sunrise Medical` - Sunrise Medical
 * @export
 * @enum {string}
 */
exports.LabEnum = {
    LabCorp: 'LabCorp',
    Quest: 'Quest',
    SunriseMedical: 'Sunrise Medical'
};
/**
 * * `Lab Order` - Lab Order * `Lab Order Request` - Lab Order Request
 * @export
 * @enum {string}
 */
exports.LabOrderFacadeTypeEnum = {
    Order: 'Lab Order',
    OrderRequest: 'Lab Order Request'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.LabOrderRequestStatusEnum = {
    NeedsLabDraw: 'Needs Lab Draw',
    LabDrawScheduled: 'Lab Draw Scheduled',
    ResultsReceived: 'Results Received',
    ResultsPublished: 'Results Published',
    Cancelled: 'Cancelled'
};
/**
 * * `Critical` - Critical * `Abnormal` - Abnormal * `Normal` - Normal
 * @export
 * @enum {string}
 */
exports.LabOrderResultEnum = {
    Critical: 'Critical',
    Abnormal: 'Abnormal',
    Normal: 'Normal'
};
/**
 * * `Cancelled` - Cancelled * `Awaiting Results` - Awaiting Results * `Needs Lab Draw` - Needs Lab Draw * `Lab Draw Scheduled` - Lab Draw Scheduled * `Results Received` - Results Received * `Completed` - Completed * `Inconclusive` - Inconclusive
 * @export
 * @enum {string}
 */
exports.LabOrderStatusEnum = {
    Cancelled: 'Cancelled',
    AwaitingResults: 'Awaiting Results',
    NeedsLabDraw: 'Needs Lab Draw',
    LabDrawScheduled: 'Lab Draw Scheduled',
    ResultsReceived: 'Results Received',
    Completed: 'Completed',
    Inconclusive: 'Inconclusive'
};
/**
 * * `TB QTF Test` - Tb Qtf Test * `Ten Panel Drug and Alcohol Test` - Ten Panel Drug And Alcohol Test
 * @export
 * @enum {string}
 */
exports.LabTestTypeEnum = {
    TbQtfTest: 'TB QTF Test',
    TenPanelDrugAndAlcoholTest: 'Ten Panel Drug and Alcohol Test'
};
/**
 * * `Apply` - Apply * `Application` - Application * `Capsule` - Capsule * `Cream` - Cream * `Drop` - Drop * `Emulsion` - Emulsion * `Film` - Film * `Foam` - Foam * `Gel` - Gel * `Gm` - Gm * `Gram` - Gram * `Granule` - Granule * `ML` - ML * `Oz` - Oz * `Tablet` - Tablet * `Unit` - Unit
 * @export
 * @enum {string}
 */
exports.MedicationDosageFormEnum = {
    Apply: 'Apply',
    Application: 'Application',
    Capsule: 'Capsule',
    Cream: 'Cream',
    Drop: 'Drop',
    Emulsion: 'Emulsion',
    Film: 'Film',
    Foam: 'Foam',
    Gel: 'Gel',
    Gm: 'Gm',
    Gram: 'Gram',
    Granule: 'Granule',
    Ml: 'ML',
    Oz: 'Oz',
    Tablet: 'Tablet',
    Unit: 'Unit'
};
/**
 * * `Daily (QD)` - Dqd * `Twice daily (BID)` - Tbid * `3 times daily (TID)` - Tid * `Every morning (QAM)` - Eqam * `At bedtime (QHS)` - Aqhs * `1 time only (1XONLY)` - Xonly * `4 to 6 times daily (Q46D)` - Q46D * `15 minutes before meals (15MINAC)` - Minac * `2 times daily (BID2)` - Bid2 * `3 times daily after meals (TIDPC)` - Tidpc * `3 times daily as needed (TIDP)` - Tidp * `3 times daily before meals (TIDAC)` - Tidac * `3 times daily with food (TIDW)` - Tidw * `3 times daily with meals (TIDWM)` - Tidwm * `3 times weekly 4 times daily 30 min before meals and bed (T4DWM)` - Tdwm * `4 times daily (QID)` - Qid * `4 times daily as needed (QIDP)` - Qidp * `4 times daily before meals and at bedtime (QIDACHS)` - Qidachs * `4 times weekly (4XWK)` - Xwk * `5 times daily (5XD)` - Xd * `After meals and at bedtime (PC&HS)` - Apchs * `As directed by physician (ADBP)` - Aadbp * `As needed (PRN)` - Aprn * `At bedtime as needed (QHSP)` - Aqhsp * `Before meals and at bedtime (ACHS)` - Bachs * `Daily as needed (QDP)` - Dqdp * `Daily for 5 days (QDX5DA)` - Dqdxda * `Daily on empty stomach (QDE)` - Dqde * `Daily with food (QDW)` - Dqdw * `Every 8 to 12 hours (Q812H)` - Eqh * `Every 8 to 12 hours as needed (Q812HP)` - Eqhp * `Every 12 hours for 2 doses (Q12HX2DOSES)` - Eqhxdoses * `Every 8 hours on an empty stomach (Q8HE)` - Eqhe * `Every 6 hours with food (Q6HW)` - Eqhw * `Every 15 min, may repeat 5 times (Q15MINMRX5)` - Eqminmrx * `Every 2 weeks (GQ2W)` - Egqw * `Every 3 days (Q3D)` - Eqd * `Every 3 hours while awake (6 doses) for 7 days (Q3HWAX7D)` - Eqhwaxd * `Every 30 minutes as needed (Q30MINP)` - Eqminp * `Every 4 hours after meals (Q4HPPC)` - Eqhppc * `Every 4 hours while awake (Q4HWA)` - Eqhwa * `Every morning as needed (QAMP)` - Eqamp * `Every other day (QOD)` - Eqod * `Every week (QW)` - Eqw * `Now and repeat 1 time (STATREPEAT)` - Nstatrepeat * `Now, then 1 every 24 hours (NOW1Q24H)` - Nnowqh * `Now. may repeat in 2 hours as needed (STATR2HP)` - Nstatrhp * `Once daily (ONCEDAILY)` - Ooncedaily * `Once in the evening (QDHS)` - Oqdhs * `Once or twice daily for 2 to 3 weeks then every other day thereafter (Q12DX23WQOD)` - Oqdxwqod * `Once or twice daily for 7 days (Q12DX7D)` - Oqdxd * `Twice daily as needed (BIDP)` - Tbidp * `Twice daily with food (BIDW)` - Tbidw * `Twice daily with water (BIDWATER)` - Tbidwater * `Twice weekly (2XW)` - Txw * `Twice weekly for 6 months (2XWKX6M)` - Txwkxm * `With dinner (D)` - Wd * `With each meal or snack (QMS)` - Wqms * `Every 12 hours for 7 days (Q12H)` - Q12H
 * @export
 * @enum {string}
 */
exports.MedicationFrequencyEnum = {
    DailyQd: 'Daily (QD)',
    TwiceDailyBid: 'Twice daily (BID)',
    _3TimesDailyTid: '3 times daily (TID)',
    EveryMorningQam: 'Every morning (QAM)',
    AtBedtimeQhs: 'At bedtime (QHS)',
    _1TimeOnly1Xonly: '1 time only (1XONLY)',
    _4To6TimesDailyQ46D: '4 to 6 times daily (Q46D)',
    _15MinutesBeforeMeals15Minac: '15 minutes before meals (15MINAC)',
    _2TimesDailyBid2: '2 times daily (BID2)',
    _3TimesDailyAfterMealsTidpc: '3 times daily after meals (TIDPC)',
    _3TimesDailyAsNeededTidp: '3 times daily as needed (TIDP)',
    _3TimesDailyBeforeMealsTidac: '3 times daily before meals (TIDAC)',
    _3TimesDailyWithFoodTidw: '3 times daily with food (TIDW)',
    _3TimesDailyWithMealsTidwm: '3 times daily with meals (TIDWM)',
    _3TimesWeekly4TimesDaily30MinBeforeMealsAndBedT4Dwm: '3 times weekly 4 times daily 30 min before meals and bed (T4DWM)',
    _4TimesDailyQid: '4 times daily (QID)',
    _4TimesDailyAsNeededQidp: '4 times daily as needed (QIDP)',
    _4TimesDailyBeforeMealsAndAtBedtimeQidachs: '4 times daily before meals and at bedtime (QIDACHS)',
    _4TimesWeekly4Xwk: '4 times weekly (4XWK)',
    _5TimesDaily5Xd: '5 times daily (5XD)',
    AfterMealsAndAtBedtimePchs: 'After meals and at bedtime (PC&HS)',
    AsDirectedByPhysicianAdbp: 'As directed by physician (ADBP)',
    AsNeededPrn: 'As needed (PRN)',
    AtBedtimeAsNeededQhsp: 'At bedtime as needed (QHSP)',
    BeforeMealsAndAtBedtimeAchs: 'Before meals and at bedtime (ACHS)',
    DailyAsNeededQdp: 'Daily as needed (QDP)',
    DailyFor5DaysQdx5Da: 'Daily for 5 days (QDX5DA)',
    DailyOnEmptyStomachQde: 'Daily on empty stomach (QDE)',
    DailyWithFoodQdw: 'Daily with food (QDW)',
    Every8To12HoursQ812H: 'Every 8 to 12 hours (Q812H)',
    Every8To12HoursAsNeededQ812Hp: 'Every 8 to 12 hours as needed (Q812HP)',
    Every12HoursFor2DosesQ12Hx2Doses: 'Every 12 hours for 2 doses (Q12HX2DOSES)',
    Every8HoursOnAnEmptyStomachQ8He: 'Every 8 hours on an empty stomach (Q8HE)',
    Every6HoursWithFoodQ6Hw: 'Every 6 hours with food (Q6HW)',
    Every15MinMayRepeat5TimesQ15Minmrx5: 'Every 15 min, may repeat 5 times (Q15MINMRX5)',
    Every2WeeksGq2W: 'Every 2 weeks (GQ2W)',
    Every3DaysQ3D: 'Every 3 days (Q3D)',
    Every3HoursWhileAwake6DosesFor7DaysQ3Hwax7D: 'Every 3 hours while awake (6 doses) for 7 days (Q3HWAX7D)',
    Every30MinutesAsNeededQ30Minp: 'Every 30 minutes as needed (Q30MINP)',
    Every4HoursAfterMealsQ4Hppc: 'Every 4 hours after meals (Q4HPPC)',
    Every4HoursWhileAwakeQ4Hwa: 'Every 4 hours while awake (Q4HWA)',
    EveryMorningAsNeededQamp: 'Every morning as needed (QAMP)',
    EveryOtherDayQod: 'Every other day (QOD)',
    EveryWeekQw: 'Every week (QW)',
    NowAndRepeat1TimeStatrepeat: 'Now and repeat 1 time (STATREPEAT)',
    NowThen1Every24HoursNow1Q24H: 'Now, then 1 every 24 hours (NOW1Q24H)',
    NowMayRepeatIn2HoursAsNeededStatr2Hp: 'Now. may repeat in 2 hours as needed (STATR2HP)',
    OnceDailyOncedaily: 'Once daily (ONCEDAILY)',
    OnceInTheEveningQdhs: 'Once in the evening (QDHS)',
    OnceOrTwiceDailyFor2To3WeeksThenEveryOtherDayThereafterQ12Dx23Wqod: 'Once or twice daily for 2 to 3 weeks then every other day thereafter (Q12DX23WQOD)',
    OnceOrTwiceDailyFor7DaysQ12Dx7D: 'Once or twice daily for 7 days (Q12DX7D)',
    TwiceDailyAsNeededBidp: 'Twice daily as needed (BIDP)',
    TwiceDailyWithFoodBidw: 'Twice daily with food (BIDW)',
    TwiceDailyWithWaterBidwater: 'Twice daily with water (BIDWATER)',
    TwiceWeekly2Xw: 'Twice weekly (2XW)',
    TwiceWeeklyFor6Months2Xwkx6M: 'Twice weekly for 6 months (2XWKX6M)',
    WithDinnerD: 'With dinner (D)',
    WithEachMealOrSnackQms: 'With each meal or snack (QMS)',
    Every12HoursFor7DaysQ12H: 'Every 12 hours for 7 days (Q12H)'
};
/**
 * * `Active` - Active * `Inactive` - Inactive * `Entered in Error` - Entered In Error
 * @export
 * @enum {string}
 */
exports.MedicationStatusEnum = {
    Active: 'Active',
    Inactive: 'Inactive',
    EnteredInError: 'Entered in Error'
};
/**
 * * `OTC` - Otc * `Prescription` - E Prescription * `Manual Prescription` - Manual Prescription * `Member Reported` - Member Reported
 * @export
 * @enum {string}
 */
exports.MedicationTypeEnum = {
    Otc: 'OTC',
    Prescription: 'Prescription',
    ManualPrescription: 'Manual Prescription',
    MemberReported: 'Member Reported'
};
/**
 * * `member_id` - member_id * `session_start_ts` - session_start_ts
 * @export
 * @enum {string}
 */
exports.MemberAssistantChatChannelMetadataKeyEnum = {
    MemberId: 'member_id',
    SessionStartTs: 'session_start_ts'
};
/**
 * * `Member` - Member * `Dependent` - Dependent
 * @export
 * @enum {string}
 */
exports.MemberTypeEnum = {
    Member: 'Member',
    Dependent: 'Dependent'
};
/**
 * * `TEXT` - TEXT * `IMAGE` - IMAGE * `CLICKABLE` - CLICKABLE * `NOTICE` - NOTICE
 * @export
 * @enum {string}
 */
exports.MessageTypeEnum = {
    Text: 'TEXT',
    Image: 'IMAGE',
    Clickable: 'CLICKABLE',
    Notice: 'NOTICE'
};
/**
 * * `Very Bad` - Very Bad * `Bad` - Bad * `Okay` - Okay * `Good` - Good * `Very Good` - Very Good
 * @export
 * @enum {string}
 */
exports.MoodEnum = {
    VeryBad: 'Very Bad',
    Bad: 'Bad',
    Okay: 'Okay',
    Good: 'Good',
    VeryGood: 'Very Good'
};
/**
 * * `Sr` - Senior * `Jr` - Junior * `I` - First * `II` - Second * `III` - Third * `IV` - Fourth * `V` - Fifth
 * @export
 * @enum {string}
 */
exports.NameSuffixEnum = {
    Sr: 'Sr',
    Jr: 'Jr',
    I: 'I',
    Ii: 'II',
    Iii: 'III',
    Iv: 'IV',
    V: 'V'
};
/**
 * * `registered` - registered * `preliminary` - preliminary * `final` - final * `amended` - amended * `corrected` - corrected * `cancelled` - cancelled * `entered-in-error` - entered-in-error * `unknown` - unknown
 * @export
 * @enum {string}
 */
exports.ObservationStatusEnum = {
    Registered: 'registered',
    Preliminary: 'preliminary',
    Final: 'final',
    Amended: 'amended',
    Corrected: 'corrected',
    Cancelled: 'cancelled',
    EnteredInError: 'entered-in-error',
    Unknown: 'unknown'
};
/**
 * * `Pending` - Pending * `Approved` - Approved
 * @export
 * @enum {string}
 */
exports.OccupationalHealthRecordStatusEnum = {
    Pending: 'Pending',
    Approved: 'Approved'
};
/**
 * * `Urgent Care` - Urgent Care * `Lab` - Lab
 * @export
 * @enum {string}
 */
exports.OrderRequestFacadeTypeEnum = {
    UrgentCare: 'Urgent Care',
    Lab: 'Lab'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.OrderRequestStatusEnum = {
    Cancelled: 'Cancelled',
    Pending: 'Pending',
    Ordered: 'Ordered',
    Scheduled: 'Scheduled',
    VoucherDelivered: 'Voucher Delivered',
    NeedsRedone: 'Needs Redone',
    NeedsReviewed: 'Needs Reviewed',
    Rescheduled: 'Rescheduled',
    Completed: 'Completed'
};
/**
 * * `PEPM` - Pepm * `FLAT FEE` - Flat Fee
 * @export
 * @enum {string}
 */
exports.PartnerEmployeeDealCommissionModel = {
    Pepm: 'PEPM',
    FlatFee: 'FLAT FEE'
};
/**
 * * `Broker` - Broker * `TPA Staff` - Tpa Staff * `General Agent Staff` - General Agent Staff * `Channel Partner Staff` - Channel Partner Staff
 * @export
 * @enum {string}
 */
exports.PartnerEmployeeTypeEnum = {
    Broker: 'Broker',
    TpaStaff: 'TPA Staff',
    GeneralAgentStaff: 'General Agent Staff',
    ChannelPartnerStaff: 'Channel Partner Staff'
};
/**
 * * `Brokerage` - Brokerage * `Third Party Administrator` - Third Party Administrator * `General Agent` - General Agent * `Channel Partner` - Channel Partner
 * @export
 * @enum {string}
 */
exports.PartnerTypeEnum = {
    Brokerage: 'Brokerage',
    ThirdPartyAdministrator: 'Third Party Administrator',
    GeneralAgent: 'General Agent',
    ChannelPartner: 'Channel Partner'
};
/**
 * * `Child` - Child * `Adult` - Adult * `Child & Adult` - Child And Adult
 * @export
 * @enum {string}
 */
exports.PatientTypeEnum = {
    Child: 'Child',
    Adult: 'Adult',
    ChildAdult: 'Child & Adult'
};
/**
 * * `Better than before` - Better than before * `About the same` - About the same * `Worse than before` - Worse than before
 * @export
 * @enum {string}
 */
exports.PostJournalFeedbackEnum = {
    BetterThanBefore: 'Better than before',
    AboutTheSame: 'About the same',
    WorseThanBefore: 'Worse than before'
};
/**
 * * `Needs Diagnostic Follow Up` - Needs Diagnostic Follow Up * `Diagnostic Follow Up Scheduled` - Diagnostic Follow Up Scheduled * `Diagnostic Follow Up Complete` - Diagnostic Follow Up Complete
 * @export
 * @enum {string}
 */
exports.PostLabStatusEnum = {
    NeedsDiagnosticFollowUp: 'Needs Diagnostic Follow Up',
    DiagnosticFollowUpScheduled: 'Diagnostic Follow Up Scheduled',
    DiagnosticFollowUpComplete: 'Diagnostic Follow Up Complete'
};
/**
 * * `en` - English * `es` - Spanish * `zh` - Chinese * `ru` - Russian * `sw` - Swahili * `th` - Thai
 * @export
 * @enum {string}
 */
exports.PreferredLanguageEnum = {
    En: 'en',
    Es: 'es',
    Zh: 'zh',
    Ru: 'ru',
    Sw: 'sw',
    Th: 'th'
};
/**
 * * `Active` - Active * `Recurrence` - Recurrence * `Relapse` - Relapse * `Inactive` - Inactive * `Remission` - Remission * `Resolved` - Resolved * `Entered in error` - Entered In Error * `Unknown` - Unknown
 * @export
 * @enum {string}
 */
exports.ProblemClinicalStatusEnum = {
    Active: 'Active',
    Recurrence: 'Recurrence',
    Relapse: 'Relapse',
    Inactive: 'Inactive',
    Remission: 'Remission',
    Resolved: 'Resolved',
    EnteredInError: 'Entered in error',
    Unknown: 'Unknown'
};
/**
 * * `Completed` - Completed * `Unknown` - Unknown * `Entered in error` - Entered In Error
 * @export
 * @enum {string}
 */
exports.ProcedureStatusEnum = {
    Completed: 'Completed',
    Unknown: 'Unknown',
    EnteredInError: 'Entered in error'
};
/**
 * * `NursePractitioner` - Nurse Practitioner * `RegisteredNurse` - Registered Nurse * `ClinicalSocialWorker` - Clinical Social Worker * `Phlebotomist` - Phlebotomist
 * @export
 * @enum {string}
 */
exports.ProviderTypeEnum = {
    NursePractitioner: 'NursePractitioner',
    RegisteredNurse: 'RegisteredNurse',
    ClinicalSocialWorker: 'ClinicalSocialWorker',
    Phlebotomist: 'Phlebotomist'
};
/**
 * * `Company Admin NPS Rating` - Company Admin NPS Rating * `Company Admin Clinic Appointment CSAT Rating` - Company Admin Clinic Appointment CSAT Rating * `Company Admin Lab Order Request CSAT Rating` - Company Admin Lab Order Request CSAT Rating * `Members NPS Rating` - Members NPS Rating * `Members Provider Rating` - Members Provider Rating * `Members Employer Retention Rating` - Members Employer Retention Rating * `Members Enjoying Vitable Rating` - Members Enjoying Vitable Rating * `Member Personal Assistant Rating` - Member Personal Assistant Rating * `Providers NPS Rating` - Providers NPS Rating * `Providers Member Rating` - Providers Member Rating * `Providers Company Rating` - Providers Company Rating * `Providers Appointment Rating` - Providers Appointment Rating * `Providers Clinical Appointment Rating` - Providers Clinical Appointment Rating
 * @export
 * @enum {string}
 */
exports.QuestionEnum = {
    CompanyAdminNpsRating: 'Company Admin NPS Rating',
    CompanyAdminClinicAppointmentCsatRating: 'Company Admin Clinic Appointment CSAT Rating',
    CompanyAdminLabOrderRequestCsatRating: 'Company Admin Lab Order Request CSAT Rating',
    MembersNpsRating: 'Members NPS Rating',
    MembersProviderRating: 'Members Provider Rating',
    MembersEmployerRetentionRating: 'Members Employer Retention Rating',
    MembersEnjoyingVitableRating: 'Members Enjoying Vitable Rating',
    MemberPersonalAssistantRating: 'Member Personal Assistant Rating',
    ProvidersNpsRating: 'Providers NPS Rating',
    ProvidersMemberRating: 'Providers Member Rating',
    ProvidersCompanyRating: 'Providers Company Rating',
    ProvidersAppointmentRating: 'Providers Appointment Rating',
    ProvidersClinicalAppointmentRating: 'Providers Clinical Appointment Rating'
};
/**
 * * `Annual Wellness Visit Questionnaire` - Pre Annual Wellness Visit * `Mental Health Visit Questionnaire` - Pre Mental Health Visit * `Sick Visit Questionnaire` - Pre Sick Visit * `Async Prescription Refill` - Async Prescription Refill
 * @export
 * @enum {string}
 */
exports.QuestionnaireFormNameEnum = {
    AnnualWellnessVisitQuestionnaire: 'Annual Wellness Visit Questionnaire',
    MentalHealthVisitQuestionnaire: 'Mental Health Visit Questionnaire',
    SickVisitQuestionnaire: 'Sick Visit Questionnaire',
    AsyncPrescriptionRefill: 'Async Prescription Refill'
};
/**
 * * `At the request of patient` - At The Request Of Patient * `For employer screening` - For Employer Screening * `Other` - Other
 * @export
 * @enum {string}
 */
exports.ReasonForReleaseEnum = {
    AtTheRequestOfPatient: 'At the request of patient',
    ForEmployerScreening: 'For employer screening',
    Other: 'Other'
};
/**
 * * `Entire medical record` - Entire Medical Record * `Diagnostic reports` - Diagnostic Reports * `Minimum data set` - Minimum Data Set * `History and physical` - History And Physical * `Business office file` - Business Office File * `Medication and treatment records` - Medication And Treatment Records * `Nursing documentation or progress Notes` - Nursing Documentation Or Progress Notes * `Rehabilitative and restorative therapy documentation` - Rehabilitative And Restorative Therapy Documentation * `Physician and Professional Consult Progress Notes` - Physician And Professional Consult Progress Notes * `Other` - Other
 * @export
 * @enum {string}
 */
exports.RecordTypesEnum = {
    EntireMedicalRecord: 'Entire medical record',
    DiagnosticReports: 'Diagnostic reports',
    MinimumDataSet: 'Minimum data set',
    HistoryAndPhysical: 'History and physical',
    BusinessOfficeFile: 'Business office file',
    MedicationAndTreatmentRecords: 'Medication and treatment records',
    NursingDocumentationOrProgressNotes: 'Nursing documentation or progress Notes',
    RehabilitativeAndRestorativeTherapyDocumentation: 'Rehabilitative and restorative therapy documentation',
    PhysicianAndProfessionalConsultProgressNotes: 'Physician and Professional Consult Progress Notes',
    Other: 'Other'
};
/**
 * * `RequestGroup` - RequestGroup * `DiagnosticReport` - DiagnosticReport * `Observation` - Observation * `Specimen` - Specimen * `Account` - Account * `Practitioner` - Practitioner * `Organization` - Organization * `Patient` - Patient
 * @export
 * @enum {string}
 */
exports.ResourceEnum = {
    RequestGroup: 'RequestGroup',
    DiagnosticReport: 'DiagnosticReport',
    Observation: 'Observation',
    Specimen: 'Specimen',
    Account: 'Account',
    Practitioner: 'Practitioner',
    Organization: 'Organization',
    Patient: 'Patient'
};
/**
 * * `success` - success * `cancelled` - cancelled * `error` - error
 * @export
 * @enum {string}
 */
exports.ResponseCodeEnum = {
    Success: 'success',
    Cancelled: 'cancelled',
    Error: 'error'
};
/**
 * * `Member not subscribed` - Member Not Subscribed * `Member no visit coverage` - Member No Visits Coverage * `Member no in-person visit coverage` - Member No In Person Coverage * `Member no telemedicine visit coverage` - Member No Telemedicine Coverage * `Member no medical service` - Member No Service Coverage * `Member medical service limit reached` - Member Service Limit Reached * `Member health savings account` - Member Has Health Savings Account * `Company not subscribed` - Company Not Subscribed * `Company no clinics` - Company No Clinics * `Company no youth clinics` - Company No Youth Clinics * `Company no lab vouchers` - Company No Lab Vouchers * `Company no urgent care vouchers` - Company No Urgent Care Vouchers * `Company urgent care disabled` - Company Urgent Care Disabled * `Company no medical service` - Company No Service Coverage * `Company medical service limit reached` - Company Service Limit Reached * `Company no hr platform integration` - Company No Hr Platform Integration * `Company no unlimited memberships` - Company No Unlimited Memberships * `Company no active benefit eligibility policy` - Company No Active Benefit Eligibility Policy * `Company no benefit offerings` - Company No Benefit Offerings
 * @export
 * @enum {string}
 */
exports.RestrictionErrorCodeEnum = {
    MemberNotSubscribed: 'Member not subscribed',
    MemberNoVisitCoverage: 'Member no visit coverage',
    MemberNoInPersonVisitCoverage: 'Member no in-person visit coverage',
    MemberNoTelemedicineVisitCoverage: 'Member no telemedicine visit coverage',
    MemberNoMedicalService: 'Member no medical service',
    MemberMedicalServiceLimitReached: 'Member medical service limit reached',
    MemberHealthSavingsAccount: 'Member health savings account',
    CompanyNotSubscribed: 'Company not subscribed',
    CompanyNoClinics: 'Company no clinics',
    CompanyNoYouthClinics: 'Company no youth clinics',
    CompanyNoLabVouchers: 'Company no lab vouchers',
    CompanyNoUrgentCareVouchers: 'Company no urgent care vouchers',
    CompanyUrgentCareDisabled: 'Company urgent care disabled',
    CompanyNoMedicalService: 'Company no medical service',
    CompanyMedicalServiceLimitReached: 'Company medical service limit reached',
    CompanyNoHrPlatformIntegration: 'Company no hr platform integration',
    CompanyNoUnlimitedMemberships: 'Company no unlimited memberships',
    CompanyNoActiveBenefitEligibilityPolicy: 'Company no active benefit eligibility policy',
    CompanyNoBenefitOfferings: 'Company no benefit offerings'
};
/**
 * * `User` - User * `Household` - Household * `Company` - Company
 * @export
 * @enum {string}
 */
exports.RestrictionGroupEnum = {
    User: 'User',
    Household: 'Household',
    Company: 'Company'
};
/**
 * * `Attending` - Attending * `Not Attending` - Not Attending * `No Answer` - No Answer
 * @export
 * @enum {string}
 */
exports.RsvpStatusEnum = {
    Attending: 'Attending',
    NotAttending: 'Not Attending',
    NoAnswer: 'No Answer'
};
/**
 * * `Provider` - Provider * `Member` - Member
 * @export
 * @enum {string}
 */
exports.SearchProceduresResponseTypeEnum = {
    Provider: 'Provider',
    Member: 'Member'
};
/**
 * * `Low` - Low * `Medium` - Medium * `High` - High
 * @export
 * @enum {string}
 */
exports.SeverityEnum = {
    Low: 'Low',
    Medium: 'Medium',
    High: 'High'
};
/**
 * * `Male` - Male * `Female` - Female * `Other` - Other * `Unknown` - Unknown
 * @export
 * @enum {string}
 */
exports.SexEnum = {
    Male: 'Male',
    Female: 'Female',
    Other: 'Other',
    Unknown: 'Unknown'
};
/**
 * * `#clinic-checkins` - #clinic-checkins * `#patient-appointment` - #patient-appointment * `#vitable-engineering` - #vitable-engineering * `#newmembers` - #newmembers * `#biz-leads` - #biz-leads * `#company-billing` - #company-billing * `#company-employee-removal` - #company-employee-removal * `#appointment-progress` - #appointment-progress * `#customer-feedback` - #customer-feedback * `#occupational-health-records` - #occupational-health-records * `#occupational-health-record-issues` - #occupational-health-record-issues * `#covid-mandate-chart-reporting-batch` - #covid-mandate-chart-reporting-batch * `#telemedicine-issue` - #telemedicine-issue * `#telemedicine-log` - #telemedicine-log * `#ayva-eprescribe-issue` - #ayva-eprescribe-issue * `#appointment-scheduling` - #appointment-scheduling * `#clinic-appointment-status` - #clinic-appointment-status * `#clinical-appointment-scheduling` - #clinical-appointment-scheduling * `#clinic-appointment-notifications` - #clinic-appointment-notifications * `#clinic-edit-request-notifications` - #clinic-edit-request-notifications * `#engineering-alerts` - #engineering-alerts * `#clinical-ops-alerts` - #clinical-ops-alerts * `#chatbot-log` - #chatbot-log * `#non-prod-env-notifications` - #non-prod-env-notifications * `#company-employee-csvs` - #company-employee-csvs * `#lab-order-alerts` - #lab-order-alerts * `#covered-medication-request` - #covered-medication-request * `#company-expansion-inquiries` - #company-expansion-inquiries * `#occ-health-lab-order-requests` - #occ-health-lab-order-requests * `#bug-reports` - #bug-reports * `#benefits-enrollment-notifications` - #benefits-enrollment-notifications * `#clinical-task-notifications` - #clinical-task-notifications * `#hipaa-investigations` - #hipaa-investigations * `#peak-support-shared` - #peak-support-shared * `#async-appointment` - #async-appointment * `#census-management-team` - #census-management-team * `#hris-sync-failure-fix-team` - #hris-sync-failure-fix-team
 * @export
 * @enum {string}
 */
exports.SlackChannelEnum = {
    ClinicCheckins: '#clinic-checkins',
    PatientAppointment: '#patient-appointment',
    VitableEngineering: '#vitable-engineering',
    Newmembers: '#newmembers',
    BizLeads: '#biz-leads',
    CompanyBilling: '#company-billing',
    CompanyEmployeeRemoval: '#company-employee-removal',
    AppointmentProgress: '#appointment-progress',
    CustomerFeedback: '#customer-feedback',
    OccupationalHealthRecords: '#occupational-health-records',
    OccupationalHealthRecordIssues: '#occupational-health-record-issues',
    CovidMandateChartReportingBatch: '#covid-mandate-chart-reporting-batch',
    TelemedicineIssue: '#telemedicine-issue',
    TelemedicineLog: '#telemedicine-log',
    AyvaEprescribeIssue: '#ayva-eprescribe-issue',
    AppointmentScheduling: '#appointment-scheduling',
    ClinicAppointmentStatus: '#clinic-appointment-status',
    ClinicalAppointmentScheduling: '#clinical-appointment-scheduling',
    ClinicAppointmentNotifications: '#clinic-appointment-notifications',
    ClinicEditRequestNotifications: '#clinic-edit-request-notifications',
    EngineeringAlerts: '#engineering-alerts',
    ClinicalOpsAlerts: '#clinical-ops-alerts',
    ChatbotLog: '#chatbot-log',
    NonProdEnvNotifications: '#non-prod-env-notifications',
    CompanyEmployeeCsvs: '#company-employee-csvs',
    LabOrderAlerts: '#lab-order-alerts',
    CoveredMedicationRequest: '#covered-medication-request',
    CompanyExpansionInquiries: '#company-expansion-inquiries',
    OccHealthLabOrderRequests: '#occ-health-lab-order-requests',
    BugReports: '#bug-reports',
    BenefitsEnrollmentNotifications: '#benefits-enrollment-notifications',
    ClinicalTaskNotifications: '#clinical-task-notifications',
    HipaaInvestigations: '#hipaa-investigations',
    PeakSupportShared: '#peak-support-shared',
    AsyncAppointment: '#async-appointment',
    CensusManagementTeam: '#census-management-team',
    HrisSyncFailureFixTeam: '#hris-sync-failure-fix-team'
};
/**
 * * `AL` - AL * `AK` - AK * `AZ` - AZ * `AR` - AR * `CA` - CA * `CO` - CO * `CT` - CT * `DC` - DC * `DE` - DE * `FL` - FL * `GA` - GA * `HI` - HI * `ID` - ID * `IL` - IL * `IN` - IN * `IA` - IA * `KS` - KS * `KY` - KY * `LA` - LA * `ME` - ME * `MD` - MD * `MA` - MA * `MI` - MI * `MN` - MN * `MS` - MS * `MO` - MO * `MT` - MT * `NE` - NE * `NV` - NV * `NH` - NH * `NJ` - NJ * `NM` - NM * `NY` - NY * `NC` - NC * `ND` - ND * `OH` - OH * `OK` - OK * `OR` - OR * `PR` - PR * `PA` - PA * `RI` - RI * `SC` - SC * `SD` - SD * `TN` - TN * `TX` - TX * `UT` - UT * `VT` - VT * `VI` - VI * `VA` - VA * `WA` - WA * `WI` - WI * `WV` - WV * `WY` - WY * `AA` - AA * `AE` - AE * `PW` - PW * `AP` - AP * `FM` - FM * `MH` - MH * `GU` - GU
 * @export
 * @enum {string}
 */
exports.StateEnum = {
    Al: 'AL',
    Ak: 'AK',
    Az: 'AZ',
    Ar: 'AR',
    Ca: 'CA',
    Co: 'CO',
    Ct: 'CT',
    Dc: 'DC',
    De: 'DE',
    Fl: 'FL',
    Ga: 'GA',
    Hi: 'HI',
    Id: 'ID',
    Il: 'IL',
    In: 'IN',
    Ia: 'IA',
    Ks: 'KS',
    Ky: 'KY',
    La: 'LA',
    Me: 'ME',
    Md: 'MD',
    Ma: 'MA',
    Mi: 'MI',
    Mn: 'MN',
    Ms: 'MS',
    Mo: 'MO',
    Mt: 'MT',
    Ne: 'NE',
    Nv: 'NV',
    Nh: 'NH',
    Nj: 'NJ',
    Nm: 'NM',
    Ny: 'NY',
    Nc: 'NC',
    Nd: 'ND',
    Oh: 'OH',
    Ok: 'OK',
    Or: 'OR',
    Pr: 'PR',
    Pa: 'PA',
    Ri: 'RI',
    Sc: 'SC',
    Sd: 'SD',
    Tn: 'TN',
    Tx: 'TX',
    Ut: 'UT',
    Vt: 'VT',
    Vi: 'VI',
    Va: 'VA',
    Wa: 'WA',
    Wi: 'WI',
    Wv: 'WV',
    Wy: 'WY',
    Aa: 'AA',
    Ae: 'AE',
    Pw: 'PW',
    Ap: 'AP',
    Fm: 'FM',
    Mh: 'MH',
    Gu: 'GU'
};
/**
 * * `member_id` - member_id * `member_email` - member_email * `channel_status` - channel_status * `zendesk_ticket_id` - zendesk_ticket_id
 * @export
 * @enum {string}
 */
exports.SupportChatChannelMetadataKeyEnum = {
    MemberId: 'member_id',
    MemberEmail: 'member_email',
    ChannelStatus: 'channel_status',
    ZendeskTicketId: 'zendesk_ticket_id'
};
/**
 * * `Idle` - Idle * `Bot Filtering` - Bot Filtering * `In Progress` - In Progress
 * @export
 * @enum {string}
 */
exports.SupportChatChannelStatusEnum = {
    Idle: 'Idle',
    BotFiltering: 'Bot Filtering',
    InProgress: 'In Progress'
};
/**
 * * `America/Chicago` - America Chicago * `America/New_York` - America New York * `America/Denver` - America Denver * `America/Los_Angeles` - America Los Angeles
 * @export
 * @enum {string}
 */
exports.SupportedTimezoneEnum = {
    Chicago: 'America/Chicago',
    NewYork: 'America/New_York',
    Denver: 'America/Denver',
    LosAngeles: 'America/Los_Angeles'
};
/**
 * * `Urgent` - Urgent * `High` - High * `Normal` - Normal
 * @export
 * @enum {string}
 */
exports.SymptomCriticalityEnum = {
    Urgent: 'Urgent',
    High: 'High',
    Normal: 'Normal'
};
/**
 * * `Company` - Company
 * @export
 * @enum {string}
 */
exports.TagOwnerTypeEnum = {
    Company: 'Company'
};
/**
 * * `Member` - Member
 * @export
 * @enum {string}
 */
exports.TagTargetTypeEnum = {
    Member: 'Member'
};
/**
 * * `Primary Care` - Primary Care * `Occupational Health` - Occupational Health
 * @export
 * @enum {string}
 */
exports.TaskCategoryEnum = {
    PrimaryCare: 'Primary Care',
    OccupationalHealth: 'Occupational Health'
};
/**
 * * `Patient` - Patient * `Provider` - Provider * `Care Team` - Care Team
 * @export
 * @enum {string}
 */
exports.TaskDesignationEnum = {
    Patient: 'Patient',
    Provider: 'Provider',
    CareTeam: 'Care Team'
};
/**
 * * `Normal` - Normal * `STAT` - Stat
 * @export
 * @enum {string}
 */
exports.TaskPriorityEnum = {
    Normal: 'Normal',
    Stat: 'STAT'
};
/**
 * * `Connected` - Connected * `Disconnected` - Disconnected * `Room Ended` - Room Ended
 * @export
 * @enum {string}
 */
exports.TelemedicineEventEnum = {
    Connected: 'Connected',
    Disconnected: 'Disconnected',
    RoomEnded: 'Room Ended'
};
/**
 * * `Morning` - Morning * `Afternoon` - Afternoon * `Evening` - Evening
 * @export
 * @enum {string}
 */
exports.TimeOfDayPreferenceEnum = {
    Morning: 'Morning',
    Afternoon: 'Afternoon',
    Evening: 'Evening'
};
/**
 * * `Manual` - Manual * `Appointment` - Appointment
 * @export
 * @enum {string}
 */
exports.ToDoCompletionTypeEnum = {
    Manual: 'Manual',
    Appointment: 'Appointment'
};
/**
 * * `ToDo` - Todo * `Task` - Task
 * @export
 * @enum {string}
 */
exports.ToDoFacadeTypeEnum = {
    ToDo: 'ToDo',
    Task: 'Task'
};
/**
 * * `Active` - Active * `Completed` - Completed * `Rejected` - Rejected * `Entered in error` - Entered In Error
 * @export
 * @enum {string}
 */
exports.ToDoStatusEnum = {
    Active: 'Active',
    Completed: 'Completed',
    Rejected: 'Rejected',
    EnteredInError: 'Entered in error'
};
/**
 * * `CVS MinuteClinic` - Cvs Minute Clinic
 * @export
 * @enum {string}
 */
exports.UrgentCareEnum = {
    CvsMinuteClinic: 'CVS MinuteClinic'
};
/**
 * * `user_type` - user_type
 * @export
 * @enum {string}
 */
exports.UserMetadataKeyEnum = {
    UserType: 'user_type'
};
/**
 * * `Member` - Member * `NursePractitioner` - Provider * `CompanyAdmin` - Company Admin * `VitableAdmin` - Vitable Admin * `ClinicalAdmin` - Clinical Admin * `PartnerEmployee` - Partner Employee
 * @export
 * @enum {string}
 */
exports.UserTypeEnum = {
    Member: 'Member',
    NursePractitioner: 'NursePractitioner',
    CompanyAdmin: 'CompanyAdmin',
    VitableAdmin: 'VitableAdmin',
    ClinicalAdmin: 'ClinicalAdmin',
    PartnerEmployee: 'PartnerEmployee'
};
/**
 * AddressApi - axios parameter creator
 * @export
 */
exports.AddressApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {Address} address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAddress: (address, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'address' is not null or undefined
            common_1.assertParamExists('validateAddress', 'address', address);
            const localVarPath = `/v1/verify-address`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(address, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAddressForAllMembers: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/verify-address-all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AddressApi - functional programming interface
 * @export
 */
exports.AddressApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.AddressApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {Address} address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAddress(address, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.validateAddress(address, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAddressForAllMembers(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.validateAddressForAllMembers(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AddressApi - factory interface
 * @export
 */
exports.AddressApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.AddressApiFp(configuration);
    return {
        /**
         *
         * @param {Address} address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAddress(address, options) {
            return localVarFp.validateAddress(address, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAddressForAllMembers(options) {
            return localVarFp.validateAddressForAllMembers(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AddressApi - object-oriented interface
 * @export
 * @class AddressApi
 * @extends {BaseAPI}
 */
class AddressApi extends base_1.BaseAPI {
    /**
     *
     * @param {AddressApiValidateAddressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressApi
     */
    validateAddress(requestParameters, options) {
        return exports.AddressApiFp(this.configuration).validateAddress(requestParameters.address, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressApi
     */
    validateAddressForAllMembers(options) {
        return exports.AddressApiFp(this.configuration).validateAddressForAllMembers(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AddressApi = AddressApi;
/**
 * AnalyticsApi - axios parameter creator
 * @export
 */
exports.AnalyticsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} dashboardId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMetabaseJwtForCompanyAdmin: (dashboardId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'dashboardId' is not null or undefined
            common_1.assertParamExists('getMetabaseJwtForCompanyAdmin', 'dashboardId', dashboardId);
            const localVarPath = `/v1/analytics/metabase/dashboard/{dashboard_id}/employers/authenticate`
                .replace(`{${"dashboard_id"}}`, encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} dashboardId
         * @param {string} [companyName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMetabaseJwtForVitableAdmin: (dashboardId, companyName, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'dashboardId' is not null or undefined
            common_1.assertParamExists('getMetabaseJwtForVitableAdmin', 'dashboardId', dashboardId);
            const localVarPath = `/v1/analytics/metabase/dashboard/{dashboard_id}/admins/authenticate`
                .replace(`{${"dashboard_id"}}`, encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (companyName !== undefined) {
                localVarQueryParameter['company_name'] = companyName;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AnalyticsApi - functional programming interface
 * @export
 */
exports.AnalyticsApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.AnalyticsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} dashboardId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMetabaseJwtForCompanyAdmin(dashboardId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMetabaseJwtForCompanyAdmin(dashboardId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} dashboardId
         * @param {string} [companyName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMetabaseJwtForVitableAdmin(dashboardId, companyName, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMetabaseJwtForVitableAdmin(dashboardId, companyName, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AnalyticsApi - factory interface
 * @export
 */
exports.AnalyticsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.AnalyticsApiFp(configuration);
    return {
        /**
         *
         * @param {number} dashboardId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMetabaseJwtForCompanyAdmin(dashboardId, options) {
            return localVarFp.getMetabaseJwtForCompanyAdmin(dashboardId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} dashboardId
         * @param {string} [companyName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMetabaseJwtForVitableAdmin(dashboardId, companyName, options) {
            return localVarFp.getMetabaseJwtForVitableAdmin(dashboardId, companyName, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AnalyticsApi - object-oriented interface
 * @export
 * @class AnalyticsApi
 * @extends {BaseAPI}
 */
class AnalyticsApi extends base_1.BaseAPI {
    /**
     *
     * @param {AnalyticsApiGetMetabaseJwtForCompanyAdminRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsApi
     */
    getMetabaseJwtForCompanyAdmin(requestParameters, options) {
        return exports.AnalyticsApiFp(this.configuration).getMetabaseJwtForCompanyAdmin(requestParameters.dashboardId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AnalyticsApiGetMetabaseJwtForVitableAdminRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsApi
     */
    getMetabaseJwtForVitableAdmin(requestParameters, options) {
        return exports.AnalyticsApiFp(this.configuration).getMetabaseJwtForVitableAdmin(requestParameters.dashboardId, requestParameters.companyName, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AnalyticsApi = AnalyticsApi;
/**
 * AppointmentApi - axios parameter creator
 * @export
 */
exports.AppointmentApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} appointmentId
         * @param {AddPatientToAppointmentRequest} addPatientToAppointmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPatientToAppointment: (appointmentId, addPatientToAppointmentRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'appointmentId' is not null or undefined
            common_1.assertParamExists('addPatientToAppointment', 'appointmentId', appointmentId);
            // verify required parameter 'addPatientToAppointmentRequest' is not null or undefined
            common_1.assertParamExists('addPatientToAppointment', 'addPatientToAppointmentRequest', addPatientToAppointmentRequest);
            const localVarPath = `/v1/appointments/{appointment_id}/patients`
                .replace(`{${"appointment_id"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(addPatientToAppointmentRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} appointmentId
         * @param {CancelAppointmentRequest} cancelAppointmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelAppointment: (appointmentId, cancelAppointmentRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'appointmentId' is not null or undefined
            common_1.assertParamExists('cancelAppointment', 'appointmentId', appointmentId);
            // verify required parameter 'cancelAppointmentRequest' is not null or undefined
            common_1.assertParamExists('cancelAppointment', 'cancelAppointmentRequest', cancelAppointmentRequest);
            const localVarPath = `/v1/appointments/{appointment_id}/cancel`
                .replace(`{${"appointment_id"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(cancelAppointmentRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} appointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeAppointmentRecap: (appointmentId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'appointmentId' is not null or undefined
            common_1.assertParamExists('completeAppointmentRecap', 'appointmentId', appointmentId);
            const localVarPath = `/v1/appointments/{appointment_id}/complete-recap`
                .replace(`{${"appointment_id"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} appointmentId
         * @param {ConfirmAppointmentLabDropOffApiRequest} confirmAppointmentLabDropOffApiRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmAppointmentLabDropOff: (appointmentId, confirmAppointmentLabDropOffApiRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'appointmentId' is not null or undefined
            common_1.assertParamExists('confirmAppointmentLabDropOff', 'appointmentId', appointmentId);
            // verify required parameter 'confirmAppointmentLabDropOffApiRequest' is not null or undefined
            common_1.assertParamExists('confirmAppointmentLabDropOff', 'confirmAppointmentLabDropOffApiRequest', confirmAppointmentLabDropOffApiRequest);
            const localVarPath = `/v1/appointments/{appointment_id}/confirm-lab-drop-off`
                .replace(`{${"appointment_id"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(confirmAppointmentLabDropOffApiRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ScheduleAppointmentRequest} scheduleAppointmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAppointment: (scheduleAppointmentRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'scheduleAppointmentRequest' is not null or undefined
            common_1.assertParamExists('createAppointment', 'scheduleAppointmentRequest', scheduleAppointmentRequest);
            const localVarPath = `/v1/appointments/schedule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(scheduleAppointmentRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forwardTwilioStatusCallbackController: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/twilio-callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCoveredStates: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/covered_areas/states`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} appointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointment: (appointmentId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'appointmentId' is not null or undefined
            common_1.assertParamExists('getAppointment', 'appointmentId', appointmentId);
            const localVarPath = `/v1/appointments/{appointment_id}`
                .replace(`{${"appointment_id"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} zipcode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCoverageByZipcode: (zipcode, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'zipcode' is not null or undefined
            common_1.assertParamExists('getCoverageByZipcode', 'zipcode', zipcode);
            const localVarPath = `/v1/covered_areas/zipcode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (zipcode !== undefined) {
                localVarQueryParameter['zipcode'] = zipcode;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} providerId
         * @param {string} zipcode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCoverageByZipcodeAndProvider: (providerId, zipcode, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'providerId' is not null or undefined
            common_1.assertParamExists('getCoverageByZipcodeAndProvider', 'providerId', providerId);
            // verify required parameter 'zipcode' is not null or undefined
            common_1.assertParamExists('getCoverageByZipcodeAndProvider', 'zipcode', zipcode);
            const localVarPath = `/v1/covered_areas/zipcode-and-provider`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (providerId !== undefined) {
                localVarQueryParameter['provider_id'] = providerId;
            }
            if (zipcode !== undefined) {
                localVarQueryParameter['zipcode'] = zipcode;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberSchedulingPrerequisites: (memberId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'memberId' is not null or undefined
            common_1.assertParamExists('getMemberSchedulingPrerequisites', 'memberId', memberId);
            const localVarPath = `/v1/members/{member_id}/scheduling-prerequisites`
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} appointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrCreateVisitRecap: (appointmentId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'appointmentId' is not null or undefined
            common_1.assertParamExists('getOrCreateVisitRecap', 'appointmentId', appointmentId);
            const localVarPath = `/v1/visit-recap/{appointment_id}`
                .replace(`{${"appointment_id"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} appointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreviousAppointmentWithIncompleteVisitRecap: (appointmentId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'appointmentId' is not null or undefined
            common_1.assertParamExists('getPreviousAppointmentWithIncompleteVisitRecap', 'appointmentId', appointmentId);
            const localVarPath = `/v1/visit-recap/incomplete/{appointment_id}`
                .replace(`{${"appointment_id"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} appointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTwilioAccessToken: (appointmentId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'appointmentId' is not null or undefined
            common_1.assertParamExists('getTwilioAccessToken', 'appointmentId', appointmentId);
            const localVarPath = `/v1/appointments/{appointment_id}/twilio-token`
                .replace(`{${"appointment_id"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} visitReasonId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVisitReasonById: (visitReasonId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'visitReasonId' is not null or undefined
            common_1.assertParamExists('getVisitReasonById', 'visitReasonId', visitReasonId);
            const localVarPath = `/v1/visit-reasons/{visit_reason_id}/`
                .replace(`{${"visit_reason_id"}}`, encodeURIComponent(String(visitReasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * List appointments by filter
         * @param {'In Person' | 'Telemedicine'} [appointmentType] * &#x60;In Person&#x60; - In Person * &#x60;Telemedicine&#x60; - Telemedicine
         * @param {string} [endDatetime]
         * @param {boolean} [hasFollowUp]
         * @param {string} [memberId]
         * @param {boolean} [onlyActiveIn]
         * @param {boolean} [onlyClinicalIn]
         * @param {boolean} [onlyFinishedIn]
         * @param {boolean} [onlyIndividualIn]
         * @param {number} [page]
         * @param {string} [providerId]
         * @param {string} [startDatetime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAppointments: (appointmentType, endDatetime, hasFollowUp, memberId, onlyActiveIn, onlyClinicalIn, onlyFinishedIn, onlyIndividualIn, page, providerId, startDatetime, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/appointments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (appointmentType !== undefined) {
                localVarQueryParameter['appointment_type'] = appointmentType;
            }
            if (endDatetime !== undefined) {
                localVarQueryParameter['end_datetime'] = (endDatetime instanceof Date) ?
                    endDatetime.toISOString() :
                    endDatetime;
            }
            if (hasFollowUp !== undefined) {
                localVarQueryParameter['has_follow_up'] = hasFollowUp;
            }
            if (memberId !== undefined) {
                localVarQueryParameter['member_id'] = memberId;
            }
            if (onlyActiveIn !== undefined) {
                localVarQueryParameter['only_active_in'] = onlyActiveIn;
            }
            if (onlyClinicalIn !== undefined) {
                localVarQueryParameter['only_clinical_in'] = onlyClinicalIn;
            }
            if (onlyFinishedIn !== undefined) {
                localVarQueryParameter['only_finished_in'] = onlyFinishedIn;
            }
            if (onlyIndividualIn !== undefined) {
                localVarQueryParameter['only_individual_in'] = onlyIndividualIn;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (providerId !== undefined) {
                localVarQueryParameter['provider_id'] = providerId;
            }
            if (startDatetime !== undefined) {
                localVarQueryParameter['start_datetime'] = (startDatetime instanceof Date) ?
                    startDatetime.toISOString() :
                    startDatetime;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * List appointments by filter
         * @param {string} clinicalAppointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listClinicAttendancesByClinicalAppointment: (clinicalAppointmentId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clinicalAppointmentId' is not null or undefined
            common_1.assertParamExists('listClinicAttendancesByClinicalAppointment', 'clinicalAppointmentId', clinicalAppointmentId);
            const localVarPath = `/v1/clinical-appointments/{clinical_appointment_id}/attendances`
                .replace(`{${"clinical_appointment_id"}}`, encodeURIComponent(String(clinicalAppointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} clinicalAppointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listClinicAudience: (clinicalAppointmentId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clinicalAppointmentId' is not null or undefined
            common_1.assertParamExists('listClinicAudience', 'clinicalAppointmentId', clinicalAppointmentId);
            const localVarPath = `/v1/clinical-appointments/{clinical_appointment_id}/audience`
                .replace(`{${"clinical_appointment_id"}}`, encodeURIComponent(String(clinicalAppointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} memberId
         * @param {'In Person' | 'Telemedicine'} [appointmentType] * &#x60;In Person&#x60; - In Person * &#x60;Telemedicine&#x60; - Telemedicine
         * @param {string} [endDatetime]
         * @param {boolean} [onlyActiveIn]
         * @param {boolean} [onlyClinicalIn]
         * @param {boolean} [onlyFinishedIn]
         * @param {boolean} [onlyIndividualIn]
         * @param {number} [page]
         * @param {string} [startDatetime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMemberAppointments: (memberId, appointmentType, endDatetime, onlyActiveIn, onlyClinicalIn, onlyFinishedIn, onlyIndividualIn, page, startDatetime, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'memberId' is not null or undefined
            common_1.assertParamExists('listMemberAppointments', 'memberId', memberId);
            const localVarPath = `/v1/members/{member_id}/appointments`
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (appointmentType !== undefined) {
                localVarQueryParameter['appointment_type'] = appointmentType;
            }
            if (endDatetime !== undefined) {
                localVarQueryParameter['end_datetime'] = (endDatetime instanceof Date) ?
                    endDatetime.toISOString() :
                    endDatetime;
            }
            if (onlyActiveIn !== undefined) {
                localVarQueryParameter['only_active_in'] = onlyActiveIn;
            }
            if (onlyClinicalIn !== undefined) {
                localVarQueryParameter['only_clinical_in'] = onlyClinicalIn;
            }
            if (onlyFinishedIn !== undefined) {
                localVarQueryParameter['only_finished_in'] = onlyFinishedIn;
            }
            if (onlyIndividualIn !== undefined) {
                localVarQueryParameter['only_individual_in'] = onlyIndividualIn;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (startDatetime !== undefined) {
                localVarQueryParameter['start_datetime'] = (startDatetime instanceof Date) ?
                    startDatetime.toISOString() :
                    startDatetime;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * List provider appointments by filter
         * @param {string} providerId
         * @param {'In Person' | 'Telemedicine'} [appointmentType] * &#x60;In Person&#x60; - In Person * &#x60;Telemedicine&#x60; - Telemedicine
         * @param {string} [endDatetime]
         * @param {boolean} [onlyActiveIn]
         * @param {boolean} [onlyClinicalIn]
         * @param {boolean} [onlyFinishedIn]
         * @param {boolean} [onlyIndividualIn]
         * @param {number} [page]
         * @param {string} [startDatetime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProviderAppointments: (providerId, appointmentType, endDatetime, onlyActiveIn, onlyClinicalIn, onlyFinishedIn, onlyIndividualIn, page, startDatetime, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'providerId' is not null or undefined
            common_1.assertParamExists('listProviderAppointments', 'providerId', providerId);
            const localVarPath = `/v1/providers/{provider_id}/appointments`
                .replace(`{${"provider_id"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (appointmentType !== undefined) {
                localVarQueryParameter['appointment_type'] = appointmentType;
            }
            if (endDatetime !== undefined) {
                localVarQueryParameter['end_datetime'] = (endDatetime instanceof Date) ?
                    endDatetime.toISOString() :
                    endDatetime;
            }
            if (onlyActiveIn !== undefined) {
                localVarQueryParameter['only_active_in'] = onlyActiveIn;
            }
            if (onlyClinicalIn !== undefined) {
                localVarQueryParameter['only_clinical_in'] = onlyClinicalIn;
            }
            if (onlyFinishedIn !== undefined) {
                localVarQueryParameter['only_finished_in'] = onlyFinishedIn;
            }
            if (onlyIndividualIn !== undefined) {
                localVarQueryParameter['only_individual_in'] = onlyIndividualIn;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (startDatetime !== undefined) {
                localVarQueryParameter['start_datetime'] = (startDatetime instanceof Date) ?
                    startDatetime.toISOString() :
                    startDatetime;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} memberId
         * @param {boolean} [highlightedIn]
         * @param {string} [providerId]
         * @param {boolean} [schedulableIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSchedulableVisitReasonsForMember: (memberId, highlightedIn, providerId, schedulableIn, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'memberId' is not null or undefined
            common_1.assertParamExists('listSchedulableVisitReasonsForMember', 'memberId', memberId);
            const localVarPath = `/v1/members/{member_id}/visit-reasons/schedulable`
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (highlightedIn !== undefined) {
                localVarQueryParameter['highlighted_in'] = highlightedIn;
            }
            if (providerId !== undefined) {
                localVarQueryParameter['provider_id'] = providerId;
            }
            if (schedulableIn !== undefined) {
                localVarQueryParameter['schedulable_in'] = schedulableIn;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {'Connected' | 'Disconnected' | 'Room Ended'} [action] * &#x60;Connected&#x60; - Connected * &#x60;Disconnected&#x60; - Disconnected * &#x60;Room Ended&#x60; - Room Ended
         * @param {string} [appointmentId]
         * @param {string} [userId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTelemedicineLogs: (action, appointmentId, userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/telemedicine-logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (action !== undefined) {
                localVarQueryParameter['action'] = action;
            }
            if (appointmentId !== undefined) {
                localVarQueryParameter['appointment_id'] = appointmentId;
            }
            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} appointmentId
         * @param {string} patientId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removePatientFromAppointment: (appointmentId, patientId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'appointmentId' is not null or undefined
            common_1.assertParamExists('removePatientFromAppointment', 'appointmentId', appointmentId);
            // verify required parameter 'patientId' is not null or undefined
            common_1.assertParamExists('removePatientFromAppointment', 'patientId', patientId);
            const localVarPath = `/v1/appointments/{appointment_id}/patients/{patient_id}`
                .replace(`{${"appointment_id"}}`, encodeURIComponent(String(appointmentId)))
                .replace(`{${"patient_id"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} appointmentId
         * @param {ReportTwilioNetworkIssueRequest} [reportTwilioNetworkIssueRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportTwilioNetworkIssue: (appointmentId, reportTwilioNetworkIssueRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'appointmentId' is not null or undefined
            common_1.assertParamExists('reportTwilioNetworkIssue', 'appointmentId', appointmentId);
            const localVarPath = `/v1/appointments/{appointment_id}/twilio-issue`
                .replace(`{${"appointment_id"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(reportTwilioNetworkIssueRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} appointmentId
         * @param {RescheduleAppointmentRequest} rescheduleAppointmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rescheduleAppointment: (appointmentId, rescheduleAppointmentRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'appointmentId' is not null or undefined
            common_1.assertParamExists('rescheduleAppointment', 'appointmentId', appointmentId);
            // verify required parameter 'rescheduleAppointmentRequest' is not null or undefined
            common_1.assertParamExists('rescheduleAppointment', 'rescheduleAppointmentRequest', rescheduleAppointmentRequest);
            const localVarPath = `/v1/appointments/{appointment_id}/reschedule`
                .replace(`{${"appointment_id"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(rescheduleAppointmentRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} appointmentId
         * @param {UpdateAppointmentProgressRequest} updateAppointmentProgressRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAppointmentProgress: (appointmentId, updateAppointmentProgressRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'appointmentId' is not null or undefined
            common_1.assertParamExists('updateAppointmentProgress', 'appointmentId', appointmentId);
            // verify required parameter 'updateAppointmentProgressRequest' is not null or undefined
            common_1.assertParamExists('updateAppointmentProgress', 'updateAppointmentProgressRequest', updateAppointmentProgressRequest);
            const localVarPath = `/v1/appointments/{appointment_id}/progress`
                .replace(`{${"appointment_id"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateAppointmentProgressRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} appointmentId
         * @param {UpdateVisitRecapRequest} [updateVisitRecapRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVisitRecap: (appointmentId, updateVisitRecapRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'appointmentId' is not null or undefined
            common_1.assertParamExists('updateVisitRecap', 'appointmentId', appointmentId);
            const localVarPath = `/v1/visit-recap/{appointment_id}`
                .replace(`{${"appointment_id"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateVisitRecapRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} csvFile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadRegionsFromCsvFile: (csvFile, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'csvFile' is not null or undefined
            common_1.assertParamExists('uploadRegionsFromCsvFile', 'csvFile', csvFile);
            const localVarPath = `/v1/regions/csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (csvFile !== undefined) {
                localVarFormParams.append('csv_file', csvFile);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AppointmentApi - functional programming interface
 * @export
 */
exports.AppointmentApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.AppointmentApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} appointmentId
         * @param {AddPatientToAppointmentRequest} addPatientToAppointmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPatientToAppointment(appointmentId, addPatientToAppointmentRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addPatientToAppointment(appointmentId, addPatientToAppointmentRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} appointmentId
         * @param {CancelAppointmentRequest} cancelAppointmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelAppointment(appointmentId, cancelAppointmentRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cancelAppointment(appointmentId, cancelAppointmentRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} appointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeAppointmentRecap(appointmentId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.completeAppointmentRecap(appointmentId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} appointmentId
         * @param {ConfirmAppointmentLabDropOffApiRequest} confirmAppointmentLabDropOffApiRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmAppointmentLabDropOff(appointmentId, confirmAppointmentLabDropOffApiRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.confirmAppointmentLabDropOff(appointmentId, confirmAppointmentLabDropOffApiRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {ScheduleAppointmentRequest} scheduleAppointmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAppointment(scheduleAppointmentRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createAppointment(scheduleAppointmentRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forwardTwilioStatusCallbackController(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.forwardTwilioStatusCallbackController(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCoveredStates(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllCoveredStates(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} appointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointment(appointmentId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAppointment(appointmentId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} zipcode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCoverageByZipcode(zipcode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCoverageByZipcode(zipcode, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} providerId
         * @param {string} zipcode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCoverageByZipcodeAndProvider(providerId, zipcode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCoverageByZipcodeAndProvider(providerId, zipcode, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberSchedulingPrerequisites(memberId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMemberSchedulingPrerequisites(memberId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} appointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrCreateVisitRecap(appointmentId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getOrCreateVisitRecap(appointmentId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} appointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreviousAppointmentWithIncompleteVisitRecap(appointmentId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPreviousAppointmentWithIncompleteVisitRecap(appointmentId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} appointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTwilioAccessToken(appointmentId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTwilioAccessToken(appointmentId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} visitReasonId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVisitReasonById(visitReasonId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getVisitReasonById(visitReasonId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * List appointments by filter
         * @param {'In Person' | 'Telemedicine'} [appointmentType] * &#x60;In Person&#x60; - In Person * &#x60;Telemedicine&#x60; - Telemedicine
         * @param {string} [endDatetime]
         * @param {boolean} [hasFollowUp]
         * @param {string} [memberId]
         * @param {boolean} [onlyActiveIn]
         * @param {boolean} [onlyClinicalIn]
         * @param {boolean} [onlyFinishedIn]
         * @param {boolean} [onlyIndividualIn]
         * @param {number} [page]
         * @param {string} [providerId]
         * @param {string} [startDatetime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAppointments(appointmentType, endDatetime, hasFollowUp, memberId, onlyActiveIn, onlyClinicalIn, onlyFinishedIn, onlyIndividualIn, page, providerId, startDatetime, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listAppointments(appointmentType, endDatetime, hasFollowUp, memberId, onlyActiveIn, onlyClinicalIn, onlyFinishedIn, onlyIndividualIn, page, providerId, startDatetime, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * List appointments by filter
         * @param {string} clinicalAppointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listClinicAttendancesByClinicalAppointment(clinicalAppointmentId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listClinicAttendancesByClinicalAppointment(clinicalAppointmentId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} clinicalAppointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listClinicAudience(clinicalAppointmentId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listClinicAudience(clinicalAppointmentId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} memberId
         * @param {'In Person' | 'Telemedicine'} [appointmentType] * &#x60;In Person&#x60; - In Person * &#x60;Telemedicine&#x60; - Telemedicine
         * @param {string} [endDatetime]
         * @param {boolean} [onlyActiveIn]
         * @param {boolean} [onlyClinicalIn]
         * @param {boolean} [onlyFinishedIn]
         * @param {boolean} [onlyIndividualIn]
         * @param {number} [page]
         * @param {string} [startDatetime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMemberAppointments(memberId, appointmentType, endDatetime, onlyActiveIn, onlyClinicalIn, onlyFinishedIn, onlyIndividualIn, page, startDatetime, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listMemberAppointments(memberId, appointmentType, endDatetime, onlyActiveIn, onlyClinicalIn, onlyFinishedIn, onlyIndividualIn, page, startDatetime, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * List provider appointments by filter
         * @param {string} providerId
         * @param {'In Person' | 'Telemedicine'} [appointmentType] * &#x60;In Person&#x60; - In Person * &#x60;Telemedicine&#x60; - Telemedicine
         * @param {string} [endDatetime]
         * @param {boolean} [onlyActiveIn]
         * @param {boolean} [onlyClinicalIn]
         * @param {boolean} [onlyFinishedIn]
         * @param {boolean} [onlyIndividualIn]
         * @param {number} [page]
         * @param {string} [startDatetime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProviderAppointments(providerId, appointmentType, endDatetime, onlyActiveIn, onlyClinicalIn, onlyFinishedIn, onlyIndividualIn, page, startDatetime, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listProviderAppointments(providerId, appointmentType, endDatetime, onlyActiveIn, onlyClinicalIn, onlyFinishedIn, onlyIndividualIn, page, startDatetime, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} memberId
         * @param {boolean} [highlightedIn]
         * @param {string} [providerId]
         * @param {boolean} [schedulableIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSchedulableVisitReasonsForMember(memberId, highlightedIn, providerId, schedulableIn, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listSchedulableVisitReasonsForMember(memberId, highlightedIn, providerId, schedulableIn, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {'Connected' | 'Disconnected' | 'Room Ended'} [action] * &#x60;Connected&#x60; - Connected * &#x60;Disconnected&#x60; - Disconnected * &#x60;Room Ended&#x60; - Room Ended
         * @param {string} [appointmentId]
         * @param {string} [userId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTelemedicineLogs(action, appointmentId, userId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listTelemedicineLogs(action, appointmentId, userId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} appointmentId
         * @param {string} patientId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removePatientFromAppointment(appointmentId, patientId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.removePatientFromAppointment(appointmentId, patientId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} appointmentId
         * @param {ReportTwilioNetworkIssueRequest} [reportTwilioNetworkIssueRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportTwilioNetworkIssue(appointmentId, reportTwilioNetworkIssueRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportTwilioNetworkIssue(appointmentId, reportTwilioNetworkIssueRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} appointmentId
         * @param {RescheduleAppointmentRequest} rescheduleAppointmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rescheduleAppointment(appointmentId, rescheduleAppointmentRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.rescheduleAppointment(appointmentId, rescheduleAppointmentRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} appointmentId
         * @param {UpdateAppointmentProgressRequest} updateAppointmentProgressRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAppointmentProgress(appointmentId, updateAppointmentProgressRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateAppointmentProgress(appointmentId, updateAppointmentProgressRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} appointmentId
         * @param {UpdateVisitRecapRequest} [updateVisitRecapRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVisitRecap(appointmentId, updateVisitRecapRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateVisitRecap(appointmentId, updateVisitRecapRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} csvFile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadRegionsFromCsvFile(csvFile, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.uploadRegionsFromCsvFile(csvFile, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AppointmentApi - factory interface
 * @export
 */
exports.AppointmentApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.AppointmentApiFp(configuration);
    return {
        /**
         *
         * @param {string} appointmentId
         * @param {AddPatientToAppointmentRequest} addPatientToAppointmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPatientToAppointment(appointmentId, addPatientToAppointmentRequest, options) {
            return localVarFp.addPatientToAppointment(appointmentId, addPatientToAppointmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} appointmentId
         * @param {CancelAppointmentRequest} cancelAppointmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelAppointment(appointmentId, cancelAppointmentRequest, options) {
            return localVarFp.cancelAppointment(appointmentId, cancelAppointmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} appointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeAppointmentRecap(appointmentId, options) {
            return localVarFp.completeAppointmentRecap(appointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} appointmentId
         * @param {ConfirmAppointmentLabDropOffApiRequest} confirmAppointmentLabDropOffApiRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmAppointmentLabDropOff(appointmentId, confirmAppointmentLabDropOffApiRequest, options) {
            return localVarFp.confirmAppointmentLabDropOff(appointmentId, confirmAppointmentLabDropOffApiRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ScheduleAppointmentRequest} scheduleAppointmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAppointment(scheduleAppointmentRequest, options) {
            return localVarFp.createAppointment(scheduleAppointmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forwardTwilioStatusCallbackController(options) {
            return localVarFp.forwardTwilioStatusCallbackController(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCoveredStates(options) {
            return localVarFp.getAllCoveredStates(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} appointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointment(appointmentId, options) {
            return localVarFp.getAppointment(appointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} zipcode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCoverageByZipcode(zipcode, options) {
            return localVarFp.getCoverageByZipcode(zipcode, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} providerId
         * @param {string} zipcode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCoverageByZipcodeAndProvider(providerId, zipcode, options) {
            return localVarFp.getCoverageByZipcodeAndProvider(providerId, zipcode, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberSchedulingPrerequisites(memberId, options) {
            return localVarFp.getMemberSchedulingPrerequisites(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} appointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrCreateVisitRecap(appointmentId, options) {
            return localVarFp.getOrCreateVisitRecap(appointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} appointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreviousAppointmentWithIncompleteVisitRecap(appointmentId, options) {
            return localVarFp.getPreviousAppointmentWithIncompleteVisitRecap(appointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} appointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTwilioAccessToken(appointmentId, options) {
            return localVarFp.getTwilioAccessToken(appointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} visitReasonId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVisitReasonById(visitReasonId, options) {
            return localVarFp.getVisitReasonById(visitReasonId, options).then((request) => request(axios, basePath));
        },
        /**
         * List appointments by filter
         * @param {'In Person' | 'Telemedicine'} [appointmentType] * &#x60;In Person&#x60; - In Person * &#x60;Telemedicine&#x60; - Telemedicine
         * @param {string} [endDatetime]
         * @param {boolean} [hasFollowUp]
         * @param {string} [memberId]
         * @param {boolean} [onlyActiveIn]
         * @param {boolean} [onlyClinicalIn]
         * @param {boolean} [onlyFinishedIn]
         * @param {boolean} [onlyIndividualIn]
         * @param {number} [page]
         * @param {string} [providerId]
         * @param {string} [startDatetime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAppointments(appointmentType, endDatetime, hasFollowUp, memberId, onlyActiveIn, onlyClinicalIn, onlyFinishedIn, onlyIndividualIn, page, providerId, startDatetime, options) {
            return localVarFp.listAppointments(appointmentType, endDatetime, hasFollowUp, memberId, onlyActiveIn, onlyClinicalIn, onlyFinishedIn, onlyIndividualIn, page, providerId, startDatetime, options).then((request) => request(axios, basePath));
        },
        /**
         * List appointments by filter
         * @param {string} clinicalAppointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listClinicAttendancesByClinicalAppointment(clinicalAppointmentId, options) {
            return localVarFp.listClinicAttendancesByClinicalAppointment(clinicalAppointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} clinicalAppointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listClinicAudience(clinicalAppointmentId, options) {
            return localVarFp.listClinicAudience(clinicalAppointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} memberId
         * @param {'In Person' | 'Telemedicine'} [appointmentType] * &#x60;In Person&#x60; - In Person * &#x60;Telemedicine&#x60; - Telemedicine
         * @param {string} [endDatetime]
         * @param {boolean} [onlyActiveIn]
         * @param {boolean} [onlyClinicalIn]
         * @param {boolean} [onlyFinishedIn]
         * @param {boolean} [onlyIndividualIn]
         * @param {number} [page]
         * @param {string} [startDatetime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMemberAppointments(memberId, appointmentType, endDatetime, onlyActiveIn, onlyClinicalIn, onlyFinishedIn, onlyIndividualIn, page, startDatetime, options) {
            return localVarFp.listMemberAppointments(memberId, appointmentType, endDatetime, onlyActiveIn, onlyClinicalIn, onlyFinishedIn, onlyIndividualIn, page, startDatetime, options).then((request) => request(axios, basePath));
        },
        /**
         * List provider appointments by filter
         * @param {string} providerId
         * @param {'In Person' | 'Telemedicine'} [appointmentType] * &#x60;In Person&#x60; - In Person * &#x60;Telemedicine&#x60; - Telemedicine
         * @param {string} [endDatetime]
         * @param {boolean} [onlyActiveIn]
         * @param {boolean} [onlyClinicalIn]
         * @param {boolean} [onlyFinishedIn]
         * @param {boolean} [onlyIndividualIn]
         * @param {number} [page]
         * @param {string} [startDatetime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProviderAppointments(providerId, appointmentType, endDatetime, onlyActiveIn, onlyClinicalIn, onlyFinishedIn, onlyIndividualIn, page, startDatetime, options) {
            return localVarFp.listProviderAppointments(providerId, appointmentType, endDatetime, onlyActiveIn, onlyClinicalIn, onlyFinishedIn, onlyIndividualIn, page, startDatetime, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} memberId
         * @param {boolean} [highlightedIn]
         * @param {string} [providerId]
         * @param {boolean} [schedulableIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSchedulableVisitReasonsForMember(memberId, highlightedIn, providerId, schedulableIn, options) {
            return localVarFp.listSchedulableVisitReasonsForMember(memberId, highlightedIn, providerId, schedulableIn, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {'Connected' | 'Disconnected' | 'Room Ended'} [action] * &#x60;Connected&#x60; - Connected * &#x60;Disconnected&#x60; - Disconnected * &#x60;Room Ended&#x60; - Room Ended
         * @param {string} [appointmentId]
         * @param {string} [userId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTelemedicineLogs(action, appointmentId, userId, options) {
            return localVarFp.listTelemedicineLogs(action, appointmentId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} appointmentId
         * @param {string} patientId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removePatientFromAppointment(appointmentId, patientId, options) {
            return localVarFp.removePatientFromAppointment(appointmentId, patientId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} appointmentId
         * @param {ReportTwilioNetworkIssueRequest} [reportTwilioNetworkIssueRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportTwilioNetworkIssue(appointmentId, reportTwilioNetworkIssueRequest, options) {
            return localVarFp.reportTwilioNetworkIssue(appointmentId, reportTwilioNetworkIssueRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} appointmentId
         * @param {RescheduleAppointmentRequest} rescheduleAppointmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rescheduleAppointment(appointmentId, rescheduleAppointmentRequest, options) {
            return localVarFp.rescheduleAppointment(appointmentId, rescheduleAppointmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} appointmentId
         * @param {UpdateAppointmentProgressRequest} updateAppointmentProgressRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAppointmentProgress(appointmentId, updateAppointmentProgressRequest, options) {
            return localVarFp.updateAppointmentProgress(appointmentId, updateAppointmentProgressRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} appointmentId
         * @param {UpdateVisitRecapRequest} [updateVisitRecapRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVisitRecap(appointmentId, updateVisitRecapRequest, options) {
            return localVarFp.updateVisitRecap(appointmentId, updateVisitRecapRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} csvFile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadRegionsFromCsvFile(csvFile, options) {
            return localVarFp.uploadRegionsFromCsvFile(csvFile, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AppointmentApi - object-oriented interface
 * @export
 * @class AppointmentApi
 * @extends {BaseAPI}
 */
class AppointmentApi extends base_1.BaseAPI {
    /**
     *
     * @param {AppointmentApiAddPatientToAppointmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    addPatientToAppointment(requestParameters, options) {
        return exports.AppointmentApiFp(this.configuration).addPatientToAppointment(requestParameters.appointmentId, requestParameters.addPatientToAppointmentRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AppointmentApiCancelAppointmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    cancelAppointment(requestParameters, options) {
        return exports.AppointmentApiFp(this.configuration).cancelAppointment(requestParameters.appointmentId, requestParameters.cancelAppointmentRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AppointmentApiCompleteAppointmentRecapRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    completeAppointmentRecap(requestParameters, options) {
        return exports.AppointmentApiFp(this.configuration).completeAppointmentRecap(requestParameters.appointmentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AppointmentApiConfirmAppointmentLabDropOffRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    confirmAppointmentLabDropOff(requestParameters, options) {
        return exports.AppointmentApiFp(this.configuration).confirmAppointmentLabDropOff(requestParameters.appointmentId, requestParameters.confirmAppointmentLabDropOffApiRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AppointmentApiCreateAppointmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    createAppointment(requestParameters, options) {
        return exports.AppointmentApiFp(this.configuration).createAppointment(requestParameters.scheduleAppointmentRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    forwardTwilioStatusCallbackController(options) {
        return exports.AppointmentApiFp(this.configuration).forwardTwilioStatusCallbackController(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    getAllCoveredStates(options) {
        return exports.AppointmentApiFp(this.configuration).getAllCoveredStates(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AppointmentApiGetAppointmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    getAppointment(requestParameters, options) {
        return exports.AppointmentApiFp(this.configuration).getAppointment(requestParameters.appointmentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AppointmentApiGetCoverageByZipcodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    getCoverageByZipcode(requestParameters, options) {
        return exports.AppointmentApiFp(this.configuration).getCoverageByZipcode(requestParameters.zipcode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AppointmentApiGetCoverageByZipcodeAndProviderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    getCoverageByZipcodeAndProvider(requestParameters, options) {
        return exports.AppointmentApiFp(this.configuration).getCoverageByZipcodeAndProvider(requestParameters.providerId, requestParameters.zipcode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AppointmentApiGetMemberSchedulingPrerequisitesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    getMemberSchedulingPrerequisites(requestParameters, options) {
        return exports.AppointmentApiFp(this.configuration).getMemberSchedulingPrerequisites(requestParameters.memberId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AppointmentApiGetOrCreateVisitRecapRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    getOrCreateVisitRecap(requestParameters, options) {
        return exports.AppointmentApiFp(this.configuration).getOrCreateVisitRecap(requestParameters.appointmentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AppointmentApiGetPreviousAppointmentWithIncompleteVisitRecapRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    getPreviousAppointmentWithIncompleteVisitRecap(requestParameters, options) {
        return exports.AppointmentApiFp(this.configuration).getPreviousAppointmentWithIncompleteVisitRecap(requestParameters.appointmentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AppointmentApiGetTwilioAccessTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    getTwilioAccessToken(requestParameters, options) {
        return exports.AppointmentApiFp(this.configuration).getTwilioAccessToken(requestParameters.appointmentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AppointmentApiGetVisitReasonByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    getVisitReasonById(requestParameters, options) {
        return exports.AppointmentApiFp(this.configuration).getVisitReasonById(requestParameters.visitReasonId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * List appointments by filter
     * @param {AppointmentApiListAppointmentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    listAppointments(requestParameters = {}, options) {
        return exports.AppointmentApiFp(this.configuration).listAppointments(requestParameters.appointmentType, requestParameters.endDatetime, requestParameters.hasFollowUp, requestParameters.memberId, requestParameters.onlyActiveIn, requestParameters.onlyClinicalIn, requestParameters.onlyFinishedIn, requestParameters.onlyIndividualIn, requestParameters.page, requestParameters.providerId, requestParameters.startDatetime, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * List appointments by filter
     * @param {AppointmentApiListClinicAttendancesByClinicalAppointmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    listClinicAttendancesByClinicalAppointment(requestParameters, options) {
        return exports.AppointmentApiFp(this.configuration).listClinicAttendancesByClinicalAppointment(requestParameters.clinicalAppointmentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AppointmentApiListClinicAudienceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    listClinicAudience(requestParameters, options) {
        return exports.AppointmentApiFp(this.configuration).listClinicAudience(requestParameters.clinicalAppointmentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AppointmentApiListMemberAppointmentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    listMemberAppointments(requestParameters, options) {
        return exports.AppointmentApiFp(this.configuration).listMemberAppointments(requestParameters.memberId, requestParameters.appointmentType, requestParameters.endDatetime, requestParameters.onlyActiveIn, requestParameters.onlyClinicalIn, requestParameters.onlyFinishedIn, requestParameters.onlyIndividualIn, requestParameters.page, requestParameters.startDatetime, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * List provider appointments by filter
     * @param {AppointmentApiListProviderAppointmentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    listProviderAppointments(requestParameters, options) {
        return exports.AppointmentApiFp(this.configuration).listProviderAppointments(requestParameters.providerId, requestParameters.appointmentType, requestParameters.endDatetime, requestParameters.onlyActiveIn, requestParameters.onlyClinicalIn, requestParameters.onlyFinishedIn, requestParameters.onlyIndividualIn, requestParameters.page, requestParameters.startDatetime, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AppointmentApiListSchedulableVisitReasonsForMemberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    listSchedulableVisitReasonsForMember(requestParameters, options) {
        return exports.AppointmentApiFp(this.configuration).listSchedulableVisitReasonsForMember(requestParameters.memberId, requestParameters.highlightedIn, requestParameters.providerId, requestParameters.schedulableIn, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AppointmentApiListTelemedicineLogsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    listTelemedicineLogs(requestParameters = {}, options) {
        return exports.AppointmentApiFp(this.configuration).listTelemedicineLogs(requestParameters.action, requestParameters.appointmentId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AppointmentApiRemovePatientFromAppointmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    removePatientFromAppointment(requestParameters, options) {
        return exports.AppointmentApiFp(this.configuration).removePatientFromAppointment(requestParameters.appointmentId, requestParameters.patientId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AppointmentApiReportTwilioNetworkIssueRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    reportTwilioNetworkIssue(requestParameters, options) {
        return exports.AppointmentApiFp(this.configuration).reportTwilioNetworkIssue(requestParameters.appointmentId, requestParameters.reportTwilioNetworkIssueRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AppointmentApiRescheduleAppointmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    rescheduleAppointment(requestParameters, options) {
        return exports.AppointmentApiFp(this.configuration).rescheduleAppointment(requestParameters.appointmentId, requestParameters.rescheduleAppointmentRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AppointmentApiUpdateAppointmentProgressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    updateAppointmentProgress(requestParameters, options) {
        return exports.AppointmentApiFp(this.configuration).updateAppointmentProgress(requestParameters.appointmentId, requestParameters.updateAppointmentProgressRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AppointmentApiUpdateVisitRecapRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    updateVisitRecap(requestParameters, options) {
        return exports.AppointmentApiFp(this.configuration).updateVisitRecap(requestParameters.appointmentId, requestParameters.updateVisitRecapRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AppointmentApiUploadRegionsFromCsvFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentApi
     */
    uploadRegionsFromCsvFile(requestParameters, options) {
        return exports.AppointmentApiFp(this.configuration).uploadRegionsFromCsvFile(requestParameters.csvFile, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AppointmentApi = AppointmentApi;
/**
 * AppointmentRequestApi - axios parameter creator
 * @export
 */
exports.AppointmentRequestApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} appointmentRequestId
         * @param {CancelAppointmentRequestRequest} cancelAppointmentRequestRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelAppointmentRequest: (appointmentRequestId, cancelAppointmentRequestRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'appointmentRequestId' is not null or undefined
            common_1.assertParamExists('cancelAppointmentRequest', 'appointmentRequestId', appointmentRequestId);
            // verify required parameter 'cancelAppointmentRequestRequest' is not null or undefined
            common_1.assertParamExists('cancelAppointmentRequest', 'cancelAppointmentRequestRequest', cancelAppointmentRequestRequest);
            const localVarPath = `/v1/appointment-requests/{appointment_request_id}/cancel`
                .replace(`{${"appointment_request_id"}}`, encodeURIComponent(String(appointmentRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(cancelAppointmentRequestRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CreateAppointmentRequestRequest} createAppointmentRequestRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAppointmentRequest: (createAppointmentRequestRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createAppointmentRequestRequest' is not null or undefined
            common_1.assertParamExists('createAppointmentRequest', 'createAppointmentRequestRequest', createAppointmentRequestRequest);
            const localVarPath = `/v1/appointment-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createAppointmentRequestRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} appointmentRequestId
         * @param {FulfillAppointmentRequestRequest} fulfillAppointmentRequestRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fulfillAppointmentRequest: (appointmentRequestId, fulfillAppointmentRequestRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'appointmentRequestId' is not null or undefined
            common_1.assertParamExists('fulfillAppointmentRequest', 'appointmentRequestId', appointmentRequestId);
            // verify required parameter 'fulfillAppointmentRequestRequest' is not null or undefined
            common_1.assertParamExists('fulfillAppointmentRequest', 'fulfillAppointmentRequestRequest', fulfillAppointmentRequestRequest);
            const localVarPath = `/v1/appointment-requests/{appointment_request_id}/fulfill`
                .replace(`{${"appointment_request_id"}}`, encodeURIComponent(String(appointmentRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(fulfillAppointmentRequestRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} appointmentRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentRequest: (appointmentRequestId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'appointmentRequestId' is not null or undefined
            common_1.assertParamExists('getAppointmentRequest', 'appointmentRequestId', appointmentRequestId);
            const localVarPath = `/v1/appointment-requests/{appointment_request_id}`
                .replace(`{${"appointment_request_id"}}`, encodeURIComponent(String(appointmentRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {'Pending' | 'Fulfilled' | 'Cancelled'} [appointmentRequestStatus] * &#x60;Pending&#x60; - Pending * &#x60;Fulfilled&#x60; - Fulfilled * &#x60;Cancelled&#x60; - Cancelled
         * @param {string} [filterEndDatetime]
         * @param {string} [filterStartDatetime]
         * @param {number} [limit]
         * @param {number} [page]
         * @param {string} [patientId]
         * @param {string} [requestedDateEnd]
         * @param {string} [requestedDateStart]
         * @param {string} [requesterId]
         * @param {'AL' | 'AK' | 'AZ' | 'AR' | 'CA' | 'CO' | 'CT' | 'DC' | 'DE' | 'FL' | 'GA' | 'HI' | 'ID' | 'IL' | 'IN' | 'IA' | 'KS' | 'KY' | 'LA' | 'ME' | 'MD' | 'MA' | 'MI' | 'MN' | 'MS' | 'MO' | 'MT' | 'NE' | 'NV' | 'NH' | 'NJ' | 'NM' | 'NY' | 'NC' | 'ND' | 'OH' | 'OK' | 'OR' | 'PR' | 'PA' | 'RI' | 'SC' | 'SD' | 'TN' | 'TX' | 'UT' | 'VT' | 'VI' | 'VA' | 'WA' | 'WI' | 'WV' | 'WY' | 'AA' | 'AE' | 'PW' | 'AP' | 'FM' | 'MH' | 'GU'} [state] * &#x60;AL&#x60; - AL * &#x60;AK&#x60; - AK * &#x60;AZ&#x60; - AZ * &#x60;AR&#x60; - AR * &#x60;CA&#x60; - CA * &#x60;CO&#x60; - CO * &#x60;CT&#x60; - CT * &#x60;DC&#x60; - DC * &#x60;DE&#x60; - DE * &#x60;FL&#x60; - FL * &#x60;GA&#x60; - GA * &#x60;HI&#x60; - HI * &#x60;ID&#x60; - ID * &#x60;IL&#x60; - IL * &#x60;IN&#x60; - IN * &#x60;IA&#x60; - IA * &#x60;KS&#x60; - KS * &#x60;KY&#x60; - KY * &#x60;LA&#x60; - LA * &#x60;ME&#x60; - ME * &#x60;MD&#x60; - MD * &#x60;MA&#x60; - MA * &#x60;MI&#x60; - MI * &#x60;MN&#x60; - MN * &#x60;MS&#x60; - MS * &#x60;MO&#x60; - MO * &#x60;MT&#x60; - MT * &#x60;NE&#x60; - NE * &#x60;NV&#x60; - NV * &#x60;NH&#x60; - NH * &#x60;NJ&#x60; - NJ * &#x60;NM&#x60; - NM * &#x60;NY&#x60; - NY * &#x60;NC&#x60; - NC * &#x60;ND&#x60; - ND * &#x60;OH&#x60; - OH * &#x60;OK&#x60; - OK * &#x60;OR&#x60; - OR * &#x60;PR&#x60; - PR * &#x60;PA&#x60; - PA * &#x60;RI&#x60; - RI * &#x60;SC&#x60; - SC * &#x60;SD&#x60; - SD * &#x60;TN&#x60; - TN * &#x60;TX&#x60; - TX * &#x60;UT&#x60; - UT * &#x60;VT&#x60; - VT * &#x60;VI&#x60; - VI * &#x60;VA&#x60; - VA * &#x60;WA&#x60; - WA * &#x60;WI&#x60; - WI * &#x60;WV&#x60; - WV * &#x60;WY&#x60; - WY * &#x60;AA&#x60; - AA * &#x60;AE&#x60; - AE * &#x60;PW&#x60; - PW * &#x60;AP&#x60; - AP * &#x60;FM&#x60; - FM * &#x60;MH&#x60; - MH * &#x60;GU&#x60; - GU
         * @param {'Morning' | 'Afternoon' | 'Evening'} [timeOfDayPreference] * &#x60;Morning&#x60; - Morning * &#x60;Afternoon&#x60; - Afternoon * &#x60;Evening&#x60; - Evening
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAppointmentRequests: (appointmentRequestStatus, filterEndDatetime, filterStartDatetime, limit, page, patientId, requestedDateEnd, requestedDateStart, requesterId, state, timeOfDayPreference, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/appointment-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (appointmentRequestStatus !== undefined) {
                localVarQueryParameter['appointment_request_status'] = appointmentRequestStatus;
            }
            if (filterEndDatetime !== undefined) {
                localVarQueryParameter['filter_end_datetime'] = (filterEndDatetime instanceof Date) ?
                    filterEndDatetime.toISOString() :
                    filterEndDatetime;
            }
            if (filterStartDatetime !== undefined) {
                localVarQueryParameter['filter_start_datetime'] = (filterStartDatetime instanceof Date) ?
                    filterStartDatetime.toISOString() :
                    filterStartDatetime;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (patientId !== undefined) {
                localVarQueryParameter['patient_id'] = patientId;
            }
            if (requestedDateEnd !== undefined) {
                localVarQueryParameter['requested_date_end'] = (requestedDateEnd instanceof Date) ?
                    requestedDateEnd.toISOString().substr(0, 10) :
                    requestedDateEnd;
            }
            if (requestedDateStart !== undefined) {
                localVarQueryParameter['requested_date_start'] = (requestedDateStart instanceof Date) ?
                    requestedDateStart.toISOString().substr(0, 10) :
                    requestedDateStart;
            }
            if (requesterId !== undefined) {
                localVarQueryParameter['requester_id'] = requesterId;
            }
            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }
            if (timeOfDayPreference !== undefined) {
                localVarQueryParameter['time_of_day_preference'] = timeOfDayPreference;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPendingAppointmentRequestsForMember: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/appointment-requests/pending`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} appointmentRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRecommendedAvailabilities: (appointmentRequestId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'appointmentRequestId' is not null or undefined
            common_1.assertParamExists('listRecommendedAvailabilities', 'appointmentRequestId', appointmentRequestId);
            const localVarPath = `/v1/appointment-requests/{appointment_request_id}/recommended-availabilities`
                .replace(`{${"appointment_request_id"}}`, encodeURIComponent(String(appointmentRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AppointmentRequestApi - functional programming interface
 * @export
 */
exports.AppointmentRequestApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.AppointmentRequestApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} appointmentRequestId
         * @param {CancelAppointmentRequestRequest} cancelAppointmentRequestRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelAppointmentRequest(appointmentRequestId, cancelAppointmentRequestRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cancelAppointmentRequest(appointmentRequestId, cancelAppointmentRequestRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {CreateAppointmentRequestRequest} createAppointmentRequestRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAppointmentRequest(createAppointmentRequestRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createAppointmentRequest(createAppointmentRequestRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} appointmentRequestId
         * @param {FulfillAppointmentRequestRequest} fulfillAppointmentRequestRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fulfillAppointmentRequest(appointmentRequestId, fulfillAppointmentRequestRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fulfillAppointmentRequest(appointmentRequestId, fulfillAppointmentRequestRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} appointmentRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentRequest(appointmentRequestId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAppointmentRequest(appointmentRequestId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {'Pending' | 'Fulfilled' | 'Cancelled'} [appointmentRequestStatus] * &#x60;Pending&#x60; - Pending * &#x60;Fulfilled&#x60; - Fulfilled * &#x60;Cancelled&#x60; - Cancelled
         * @param {string} [filterEndDatetime]
         * @param {string} [filterStartDatetime]
         * @param {number} [limit]
         * @param {number} [page]
         * @param {string} [patientId]
         * @param {string} [requestedDateEnd]
         * @param {string} [requestedDateStart]
         * @param {string} [requesterId]
         * @param {'AL' | 'AK' | 'AZ' | 'AR' | 'CA' | 'CO' | 'CT' | 'DC' | 'DE' | 'FL' | 'GA' | 'HI' | 'ID' | 'IL' | 'IN' | 'IA' | 'KS' | 'KY' | 'LA' | 'ME' | 'MD' | 'MA' | 'MI' | 'MN' | 'MS' | 'MO' | 'MT' | 'NE' | 'NV' | 'NH' | 'NJ' | 'NM' | 'NY' | 'NC' | 'ND' | 'OH' | 'OK' | 'OR' | 'PR' | 'PA' | 'RI' | 'SC' | 'SD' | 'TN' | 'TX' | 'UT' | 'VT' | 'VI' | 'VA' | 'WA' | 'WI' | 'WV' | 'WY' | 'AA' | 'AE' | 'PW' | 'AP' | 'FM' | 'MH' | 'GU'} [state] * &#x60;AL&#x60; - AL * &#x60;AK&#x60; - AK * &#x60;AZ&#x60; - AZ * &#x60;AR&#x60; - AR * &#x60;CA&#x60; - CA * &#x60;CO&#x60; - CO * &#x60;CT&#x60; - CT * &#x60;DC&#x60; - DC * &#x60;DE&#x60; - DE * &#x60;FL&#x60; - FL * &#x60;GA&#x60; - GA * &#x60;HI&#x60; - HI * &#x60;ID&#x60; - ID * &#x60;IL&#x60; - IL * &#x60;IN&#x60; - IN * &#x60;IA&#x60; - IA * &#x60;KS&#x60; - KS * &#x60;KY&#x60; - KY * &#x60;LA&#x60; - LA * &#x60;ME&#x60; - ME * &#x60;MD&#x60; - MD * &#x60;MA&#x60; - MA * &#x60;MI&#x60; - MI * &#x60;MN&#x60; - MN * &#x60;MS&#x60; - MS * &#x60;MO&#x60; - MO * &#x60;MT&#x60; - MT * &#x60;NE&#x60; - NE * &#x60;NV&#x60; - NV * &#x60;NH&#x60; - NH * &#x60;NJ&#x60; - NJ * &#x60;NM&#x60; - NM * &#x60;NY&#x60; - NY * &#x60;NC&#x60; - NC * &#x60;ND&#x60; - ND * &#x60;OH&#x60; - OH * &#x60;OK&#x60; - OK * &#x60;OR&#x60; - OR * &#x60;PR&#x60; - PR * &#x60;PA&#x60; - PA * &#x60;RI&#x60; - RI * &#x60;SC&#x60; - SC * &#x60;SD&#x60; - SD * &#x60;TN&#x60; - TN * &#x60;TX&#x60; - TX * &#x60;UT&#x60; - UT * &#x60;VT&#x60; - VT * &#x60;VI&#x60; - VI * &#x60;VA&#x60; - VA * &#x60;WA&#x60; - WA * &#x60;WI&#x60; - WI * &#x60;WV&#x60; - WV * &#x60;WY&#x60; - WY * &#x60;AA&#x60; - AA * &#x60;AE&#x60; - AE * &#x60;PW&#x60; - PW * &#x60;AP&#x60; - AP * &#x60;FM&#x60; - FM * &#x60;MH&#x60; - MH * &#x60;GU&#x60; - GU
         * @param {'Morning' | 'Afternoon' | 'Evening'} [timeOfDayPreference] * &#x60;Morning&#x60; - Morning * &#x60;Afternoon&#x60; - Afternoon * &#x60;Evening&#x60; - Evening
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAppointmentRequests(appointmentRequestStatus, filterEndDatetime, filterStartDatetime, limit, page, patientId, requestedDateEnd, requestedDateStart, requesterId, state, timeOfDayPreference, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listAppointmentRequests(appointmentRequestStatus, filterEndDatetime, filterStartDatetime, limit, page, patientId, requestedDateEnd, requestedDateStart, requesterId, state, timeOfDayPreference, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPendingAppointmentRequestsForMember(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listPendingAppointmentRequestsForMember(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} appointmentRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRecommendedAvailabilities(appointmentRequestId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listRecommendedAvailabilities(appointmentRequestId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AppointmentRequestApi - factory interface
 * @export
 */
exports.AppointmentRequestApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.AppointmentRequestApiFp(configuration);
    return {
        /**
         *
         * @param {string} appointmentRequestId
         * @param {CancelAppointmentRequestRequest} cancelAppointmentRequestRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelAppointmentRequest(appointmentRequestId, cancelAppointmentRequestRequest, options) {
            return localVarFp.cancelAppointmentRequest(appointmentRequestId, cancelAppointmentRequestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateAppointmentRequestRequest} createAppointmentRequestRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAppointmentRequest(createAppointmentRequestRequest, options) {
            return localVarFp.createAppointmentRequest(createAppointmentRequestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} appointmentRequestId
         * @param {FulfillAppointmentRequestRequest} fulfillAppointmentRequestRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fulfillAppointmentRequest(appointmentRequestId, fulfillAppointmentRequestRequest, options) {
            return localVarFp.fulfillAppointmentRequest(appointmentRequestId, fulfillAppointmentRequestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} appointmentRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppointmentRequest(appointmentRequestId, options) {
            return localVarFp.getAppointmentRequest(appointmentRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {'Pending' | 'Fulfilled' | 'Cancelled'} [appointmentRequestStatus] * &#x60;Pending&#x60; - Pending * &#x60;Fulfilled&#x60; - Fulfilled * &#x60;Cancelled&#x60; - Cancelled
         * @param {string} [filterEndDatetime]
         * @param {string} [filterStartDatetime]
         * @param {number} [limit]
         * @param {number} [page]
         * @param {string} [patientId]
         * @param {string} [requestedDateEnd]
         * @param {string} [requestedDateStart]
         * @param {string} [requesterId]
         * @param {'AL' | 'AK' | 'AZ' | 'AR' | 'CA' | 'CO' | 'CT' | 'DC' | 'DE' | 'FL' | 'GA' | 'HI' | 'ID' | 'IL' | 'IN' | 'IA' | 'KS' | 'KY' | 'LA' | 'ME' | 'MD' | 'MA' | 'MI' | 'MN' | 'MS' | 'MO' | 'MT' | 'NE' | 'NV' | 'NH' | 'NJ' | 'NM' | 'NY' | 'NC' | 'ND' | 'OH' | 'OK' | 'OR' | 'PR' | 'PA' | 'RI' | 'SC' | 'SD' | 'TN' | 'TX' | 'UT' | 'VT' | 'VI' | 'VA' | 'WA' | 'WI' | 'WV' | 'WY' | 'AA' | 'AE' | 'PW' | 'AP' | 'FM' | 'MH' | 'GU'} [state] * &#x60;AL&#x60; - AL * &#x60;AK&#x60; - AK * &#x60;AZ&#x60; - AZ * &#x60;AR&#x60; - AR * &#x60;CA&#x60; - CA * &#x60;CO&#x60; - CO * &#x60;CT&#x60; - CT * &#x60;DC&#x60; - DC * &#x60;DE&#x60; - DE * &#x60;FL&#x60; - FL * &#x60;GA&#x60; - GA * &#x60;HI&#x60; - HI * &#x60;ID&#x60; - ID * &#x60;IL&#x60; - IL * &#x60;IN&#x60; - IN * &#x60;IA&#x60; - IA * &#x60;KS&#x60; - KS * &#x60;KY&#x60; - KY * &#x60;LA&#x60; - LA * &#x60;ME&#x60; - ME * &#x60;MD&#x60; - MD * &#x60;MA&#x60; - MA * &#x60;MI&#x60; - MI * &#x60;MN&#x60; - MN * &#x60;MS&#x60; - MS * &#x60;MO&#x60; - MO * &#x60;MT&#x60; - MT * &#x60;NE&#x60; - NE * &#x60;NV&#x60; - NV * &#x60;NH&#x60; - NH * &#x60;NJ&#x60; - NJ * &#x60;NM&#x60; - NM * &#x60;NY&#x60; - NY * &#x60;NC&#x60; - NC * &#x60;ND&#x60; - ND * &#x60;OH&#x60; - OH * &#x60;OK&#x60; - OK * &#x60;OR&#x60; - OR * &#x60;PR&#x60; - PR * &#x60;PA&#x60; - PA * &#x60;RI&#x60; - RI * &#x60;SC&#x60; - SC * &#x60;SD&#x60; - SD * &#x60;TN&#x60; - TN * &#x60;TX&#x60; - TX * &#x60;UT&#x60; - UT * &#x60;VT&#x60; - VT * &#x60;VI&#x60; - VI * &#x60;VA&#x60; - VA * &#x60;WA&#x60; - WA * &#x60;WI&#x60; - WI * &#x60;WV&#x60; - WV * &#x60;WY&#x60; - WY * &#x60;AA&#x60; - AA * &#x60;AE&#x60; - AE * &#x60;PW&#x60; - PW * &#x60;AP&#x60; - AP * &#x60;FM&#x60; - FM * &#x60;MH&#x60; - MH * &#x60;GU&#x60; - GU
         * @param {'Morning' | 'Afternoon' | 'Evening'} [timeOfDayPreference] * &#x60;Morning&#x60; - Morning * &#x60;Afternoon&#x60; - Afternoon * &#x60;Evening&#x60; - Evening
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAppointmentRequests(appointmentRequestStatus, filterEndDatetime, filterStartDatetime, limit, page, patientId, requestedDateEnd, requestedDateStart, requesterId, state, timeOfDayPreference, options) {
            return localVarFp.listAppointmentRequests(appointmentRequestStatus, filterEndDatetime, filterStartDatetime, limit, page, patientId, requestedDateEnd, requestedDateStart, requesterId, state, timeOfDayPreference, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPendingAppointmentRequestsForMember(options) {
            return localVarFp.listPendingAppointmentRequestsForMember(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} appointmentRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRecommendedAvailabilities(appointmentRequestId, options) {
            return localVarFp.listRecommendedAvailabilities(appointmentRequestId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AppointmentRequestApi - object-oriented interface
 * @export
 * @class AppointmentRequestApi
 * @extends {BaseAPI}
 */
class AppointmentRequestApi extends base_1.BaseAPI {
    /**
     *
     * @param {AppointmentRequestApiCancelAppointmentRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentRequestApi
     */
    cancelAppointmentRequest(requestParameters, options) {
        return exports.AppointmentRequestApiFp(this.configuration).cancelAppointmentRequest(requestParameters.appointmentRequestId, requestParameters.cancelAppointmentRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AppointmentRequestApiCreateAppointmentRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentRequestApi
     */
    createAppointmentRequest(requestParameters, options) {
        return exports.AppointmentRequestApiFp(this.configuration).createAppointmentRequest(requestParameters.createAppointmentRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AppointmentRequestApiFulfillAppointmentRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentRequestApi
     */
    fulfillAppointmentRequest(requestParameters, options) {
        return exports.AppointmentRequestApiFp(this.configuration).fulfillAppointmentRequest(requestParameters.appointmentRequestId, requestParameters.fulfillAppointmentRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AppointmentRequestApiGetAppointmentRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentRequestApi
     */
    getAppointmentRequest(requestParameters, options) {
        return exports.AppointmentRequestApiFp(this.configuration).getAppointmentRequest(requestParameters.appointmentRequestId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AppointmentRequestApiListAppointmentRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentRequestApi
     */
    listAppointmentRequests(requestParameters = {}, options) {
        return exports.AppointmentRequestApiFp(this.configuration).listAppointmentRequests(requestParameters.appointmentRequestStatus, requestParameters.filterEndDatetime, requestParameters.filterStartDatetime, requestParameters.limit, requestParameters.page, requestParameters.patientId, requestParameters.requestedDateEnd, requestParameters.requestedDateStart, requestParameters.requesterId, requestParameters.state, requestParameters.timeOfDayPreference, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentRequestApi
     */
    listPendingAppointmentRequestsForMember(options) {
        return exports.AppointmentRequestApiFp(this.configuration).listPendingAppointmentRequestsForMember(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AppointmentRequestApiListRecommendedAvailabilitiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppointmentRequestApi
     */
    listRecommendedAvailabilities(requestParameters, options) {
        return exports.AppointmentRequestApiFp(this.configuration).listRecommendedAvailabilities(requestParameters.appointmentRequestId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AppointmentRequestApi = AppointmentRequestApi;
/**
 * AsyncAppointmentApi - axios parameter creator
 * @export
 */
exports.AsyncAppointmentApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} asyncAppointmentId
         * @param {CancelAsyncAppointmentRequest} cancelAsyncAppointmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelAsyncAppointment: (asyncAppointmentId, cancelAsyncAppointmentRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'asyncAppointmentId' is not null or undefined
            common_1.assertParamExists('cancelAsyncAppointment', 'asyncAppointmentId', asyncAppointmentId);
            // verify required parameter 'cancelAsyncAppointmentRequest' is not null or undefined
            common_1.assertParamExists('cancelAsyncAppointment', 'cancelAsyncAppointmentRequest', cancelAsyncAppointmentRequest);
            const localVarPath = `/v1/async-appointments/{async_appointment_id}/cancel`
                .replace(`{${"async_appointment_id"}}`, encodeURIComponent(String(asyncAppointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(cancelAsyncAppointmentRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAsyncAppointmentCandidacy: (memberId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'memberId' is not null or undefined
            common_1.assertParamExists('checkAsyncAppointmentCandidacy', 'memberId', memberId);
            const localVarPath = `/v1/members/{member_id}/async-appointment-candidacy`
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} asyncAppointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimAsyncAppointment: (asyncAppointmentId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'asyncAppointmentId' is not null or undefined
            common_1.assertParamExists('claimAsyncAppointment', 'asyncAppointmentId', asyncAppointmentId);
            const localVarPath = `/v1/async-appointments/{async_appointment_id}/status/claim`
                .replace(`{${"async_appointment_id"}}`, encodeURIComponent(String(asyncAppointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} asyncAppointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAsyncAppointment: (asyncAppointmentId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'asyncAppointmentId' is not null or undefined
            common_1.assertParamExists('getAsyncAppointment', 'asyncAppointmentId', asyncAppointmentId);
            const localVarPath = `/v1/async-appointments/{async_appointment_id}`
                .replace(`{${"async_appointment_id"}}`, encodeURIComponent(String(asyncAppointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} asyncAppointmentId
         * @param {number} [limit]
         * @param {number} [page]
         * @param {'Member' | 'NursePractitioner' | 'CompanyAdmin' | 'VitableAdmin' | 'ClinicalAdmin' | 'PartnerEmployee'} [userType] * &#x60;Member&#x60; - Member * &#x60;NursePractitioner&#x60; - Provider * &#x60;CompanyAdmin&#x60; - Company Admin * &#x60;VitableAdmin&#x60; - Vitable Admin * &#x60;ClinicalAdmin&#x60; - Clinical Admin * &#x60;PartnerEmployee&#x60; - Partner Employee
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAsyncAppointmentContributors: (asyncAppointmentId, limit, page, userType, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'asyncAppointmentId' is not null or undefined
            common_1.assertParamExists('listAsyncAppointmentContributors', 'asyncAppointmentId', asyncAppointmentId);
            const localVarPath = `/v1/async-appointments/{async_appointment_id}/contributors`
                .replace(`{${"async_appointment_id"}}`, encodeURIComponent(String(asyncAppointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (userType !== undefined) {
                localVarQueryParameter['user_type'] = userType;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {boolean} [canceledIn]
         * @param {boolean} [chartedIn]
         * @param {boolean} [claimedIn]
         * @param {boolean} [closedIn]
         * @param {boolean} [holdIn]
         * @param {number} [limit]
         * @param {string} [memberId]
         * @param {boolean} [oldestFirstIn]
         * @param {number} [page]
         * @param {string} [submittedOnEndRange]
         * @param {string} [submittedOnStartRange]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAsyncAppointments: (canceledIn, chartedIn, claimedIn, closedIn, holdIn, limit, memberId, oldestFirstIn, page, submittedOnEndRange, submittedOnStartRange, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/async-appointments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (canceledIn !== undefined) {
                localVarQueryParameter['canceled_in'] = canceledIn;
            }
            if (chartedIn !== undefined) {
                localVarQueryParameter['charted_in'] = chartedIn;
            }
            if (claimedIn !== undefined) {
                localVarQueryParameter['claimed_in'] = claimedIn;
            }
            if (closedIn !== undefined) {
                localVarQueryParameter['closed_in'] = closedIn;
            }
            if (holdIn !== undefined) {
                localVarQueryParameter['hold_in'] = holdIn;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (memberId !== undefined) {
                localVarQueryParameter['member_id'] = memberId;
            }
            if (oldestFirstIn !== undefined) {
                localVarQueryParameter['oldest_first_in'] = oldestFirstIn;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (submittedOnEndRange !== undefined) {
                localVarQueryParameter['submitted_on_end_range'] = (submittedOnEndRange instanceof Date) ?
                    submittedOnEndRange.toISOString() :
                    submittedOnEndRange;
            }
            if (submittedOnStartRange !== undefined) {
                localVarQueryParameter['submitted_on_start_range'] = (submittedOnStartRange instanceof Date) ?
                    submittedOnStartRange.toISOString() :
                    submittedOnStartRange;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} memberId
         * @param {boolean} [canceledIn]
         * @param {boolean} [chartedIn]
         * @param {boolean} [claimedIn]
         * @param {boolean} [closedIn]
         * @param {boolean} [holdIn]
         * @param {number} [limit]
         * @param {string} [memberId2]
         * @param {boolean} [oldestFirstIn]
         * @param {number} [page]
         * @param {string} [submittedOnEndRange]
         * @param {string} [submittedOnStartRange]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMemberAsyncAppointments: (memberId, canceledIn, chartedIn, claimedIn, closedIn, holdIn, limit, memberId2, oldestFirstIn, page, submittedOnEndRange, submittedOnStartRange, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'memberId' is not null or undefined
            common_1.assertParamExists('listMemberAsyncAppointments', 'memberId', memberId);
            const localVarPath = `/v1/members/{member_id}/async-appointments`
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (canceledIn !== undefined) {
                localVarQueryParameter['canceled_in'] = canceledIn;
            }
            if (chartedIn !== undefined) {
                localVarQueryParameter['charted_in'] = chartedIn;
            }
            if (claimedIn !== undefined) {
                localVarQueryParameter['claimed_in'] = claimedIn;
            }
            if (closedIn !== undefined) {
                localVarQueryParameter['closed_in'] = closedIn;
            }
            if (holdIn !== undefined) {
                localVarQueryParameter['hold_in'] = holdIn;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (memberId2 !== undefined) {
                localVarQueryParameter['member_id'] = memberId2;
            }
            if (oldestFirstIn !== undefined) {
                localVarQueryParameter['oldest_first_in'] = oldestFirstIn;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (submittedOnEndRange !== undefined) {
                localVarQueryParameter['submitted_on_end_range'] = (submittedOnEndRange instanceof Date) ?
                    submittedOnEndRange.toISOString() :
                    submittedOnEndRange;
            }
            if (submittedOnStartRange !== undefined) {
                localVarQueryParameter['submitted_on_start_range'] = (submittedOnStartRange instanceof Date) ?
                    submittedOnStartRange.toISOString() :
                    submittedOnStartRange;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} asyncAppointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAsyncAppointmentCharted: (asyncAppointmentId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'asyncAppointmentId' is not null or undefined
            common_1.assertParamExists('markAsyncAppointmentCharted', 'asyncAppointmentId', asyncAppointmentId);
            const localVarPath = `/v1/async-appointments/{async_appointment_id}/status/charted`
                .replace(`{${"async_appointment_id"}}`, encodeURIComponent(String(asyncAppointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} asyncAppointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAsyncAppointmentClosed: (asyncAppointmentId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'asyncAppointmentId' is not null or undefined
            common_1.assertParamExists('markAsyncAppointmentClosed', 'asyncAppointmentId', asyncAppointmentId);
            const localVarPath = `/v1/async-appointments/{async_appointment_id}/status/closed`
                .replace(`{${"async_appointment_id"}}`, encodeURIComponent(String(asyncAppointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} asyncAppointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAsyncAppointmentOnHold: (asyncAppointmentId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'asyncAppointmentId' is not null or undefined
            common_1.assertParamExists('markAsyncAppointmentOnHold', 'asyncAppointmentId', asyncAppointmentId);
            const localVarPath = `/v1/async-appointments/{async_appointment_id}/status/hold`
                .replace(`{${"async_appointment_id"}}`, encodeURIComponent(String(asyncAppointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ScheduleAsyncAppointmentRequest} scheduleAsyncAppointmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleAsyncAppointment: (scheduleAsyncAppointmentRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'scheduleAsyncAppointmentRequest' is not null or undefined
            common_1.assertParamExists('scheduleAsyncAppointment', 'scheduleAsyncAppointmentRequest', scheduleAsyncAppointmentRequest);
            const localVarPath = `/v1/async-appointments/schedule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(scheduleAsyncAppointmentRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AsyncAppointmentApi - functional programming interface
 * @export
 */
exports.AsyncAppointmentApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.AsyncAppointmentApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} asyncAppointmentId
         * @param {CancelAsyncAppointmentRequest} cancelAsyncAppointmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelAsyncAppointment(asyncAppointmentId, cancelAsyncAppointmentRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cancelAsyncAppointment(asyncAppointmentId, cancelAsyncAppointmentRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAsyncAppointmentCandidacy(memberId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.checkAsyncAppointmentCandidacy(memberId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} asyncAppointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimAsyncAppointment(asyncAppointmentId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.claimAsyncAppointment(asyncAppointmentId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} asyncAppointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAsyncAppointment(asyncAppointmentId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAsyncAppointment(asyncAppointmentId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} asyncAppointmentId
         * @param {number} [limit]
         * @param {number} [page]
         * @param {'Member' | 'NursePractitioner' | 'CompanyAdmin' | 'VitableAdmin' | 'ClinicalAdmin' | 'PartnerEmployee'} [userType] * &#x60;Member&#x60; - Member * &#x60;NursePractitioner&#x60; - Provider * &#x60;CompanyAdmin&#x60; - Company Admin * &#x60;VitableAdmin&#x60; - Vitable Admin * &#x60;ClinicalAdmin&#x60; - Clinical Admin * &#x60;PartnerEmployee&#x60; - Partner Employee
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAsyncAppointmentContributors(asyncAppointmentId, limit, page, userType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listAsyncAppointmentContributors(asyncAppointmentId, limit, page, userType, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {boolean} [canceledIn]
         * @param {boolean} [chartedIn]
         * @param {boolean} [claimedIn]
         * @param {boolean} [closedIn]
         * @param {boolean} [holdIn]
         * @param {number} [limit]
         * @param {string} [memberId]
         * @param {boolean} [oldestFirstIn]
         * @param {number} [page]
         * @param {string} [submittedOnEndRange]
         * @param {string} [submittedOnStartRange]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAsyncAppointments(canceledIn, chartedIn, claimedIn, closedIn, holdIn, limit, memberId, oldestFirstIn, page, submittedOnEndRange, submittedOnStartRange, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listAsyncAppointments(canceledIn, chartedIn, claimedIn, closedIn, holdIn, limit, memberId, oldestFirstIn, page, submittedOnEndRange, submittedOnStartRange, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} memberId
         * @param {boolean} [canceledIn]
         * @param {boolean} [chartedIn]
         * @param {boolean} [claimedIn]
         * @param {boolean} [closedIn]
         * @param {boolean} [holdIn]
         * @param {number} [limit]
         * @param {string} [memberId2]
         * @param {boolean} [oldestFirstIn]
         * @param {number} [page]
         * @param {string} [submittedOnEndRange]
         * @param {string} [submittedOnStartRange]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMemberAsyncAppointments(memberId, canceledIn, chartedIn, claimedIn, closedIn, holdIn, limit, memberId2, oldestFirstIn, page, submittedOnEndRange, submittedOnStartRange, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listMemberAsyncAppointments(memberId, canceledIn, chartedIn, claimedIn, closedIn, holdIn, limit, memberId2, oldestFirstIn, page, submittedOnEndRange, submittedOnStartRange, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} asyncAppointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAsyncAppointmentCharted(asyncAppointmentId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.markAsyncAppointmentCharted(asyncAppointmentId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} asyncAppointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAsyncAppointmentClosed(asyncAppointmentId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.markAsyncAppointmentClosed(asyncAppointmentId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} asyncAppointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAsyncAppointmentOnHold(asyncAppointmentId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.markAsyncAppointmentOnHold(asyncAppointmentId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {ScheduleAsyncAppointmentRequest} scheduleAsyncAppointmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleAsyncAppointment(scheduleAsyncAppointmentRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.scheduleAsyncAppointment(scheduleAsyncAppointmentRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AsyncAppointmentApi - factory interface
 * @export
 */
exports.AsyncAppointmentApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.AsyncAppointmentApiFp(configuration);
    return {
        /**
         *
         * @param {string} asyncAppointmentId
         * @param {CancelAsyncAppointmentRequest} cancelAsyncAppointmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelAsyncAppointment(asyncAppointmentId, cancelAsyncAppointmentRequest, options) {
            return localVarFp.cancelAsyncAppointment(asyncAppointmentId, cancelAsyncAppointmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAsyncAppointmentCandidacy(memberId, options) {
            return localVarFp.checkAsyncAppointmentCandidacy(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} asyncAppointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimAsyncAppointment(asyncAppointmentId, options) {
            return localVarFp.claimAsyncAppointment(asyncAppointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} asyncAppointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAsyncAppointment(asyncAppointmentId, options) {
            return localVarFp.getAsyncAppointment(asyncAppointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} asyncAppointmentId
         * @param {number} [limit]
         * @param {number} [page]
         * @param {'Member' | 'NursePractitioner' | 'CompanyAdmin' | 'VitableAdmin' | 'ClinicalAdmin' | 'PartnerEmployee'} [userType] * &#x60;Member&#x60; - Member * &#x60;NursePractitioner&#x60; - Provider * &#x60;CompanyAdmin&#x60; - Company Admin * &#x60;VitableAdmin&#x60; - Vitable Admin * &#x60;ClinicalAdmin&#x60; - Clinical Admin * &#x60;PartnerEmployee&#x60; - Partner Employee
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAsyncAppointmentContributors(asyncAppointmentId, limit, page, userType, options) {
            return localVarFp.listAsyncAppointmentContributors(asyncAppointmentId, limit, page, userType, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {boolean} [canceledIn]
         * @param {boolean} [chartedIn]
         * @param {boolean} [claimedIn]
         * @param {boolean} [closedIn]
         * @param {boolean} [holdIn]
         * @param {number} [limit]
         * @param {string} [memberId]
         * @param {boolean} [oldestFirstIn]
         * @param {number} [page]
         * @param {string} [submittedOnEndRange]
         * @param {string} [submittedOnStartRange]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAsyncAppointments(canceledIn, chartedIn, claimedIn, closedIn, holdIn, limit, memberId, oldestFirstIn, page, submittedOnEndRange, submittedOnStartRange, options) {
            return localVarFp.listAsyncAppointments(canceledIn, chartedIn, claimedIn, closedIn, holdIn, limit, memberId, oldestFirstIn, page, submittedOnEndRange, submittedOnStartRange, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} memberId
         * @param {boolean} [canceledIn]
         * @param {boolean} [chartedIn]
         * @param {boolean} [claimedIn]
         * @param {boolean} [closedIn]
         * @param {boolean} [holdIn]
         * @param {number} [limit]
         * @param {string} [memberId2]
         * @param {boolean} [oldestFirstIn]
         * @param {number} [page]
         * @param {string} [submittedOnEndRange]
         * @param {string} [submittedOnStartRange]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMemberAsyncAppointments(memberId, canceledIn, chartedIn, claimedIn, closedIn, holdIn, limit, memberId2, oldestFirstIn, page, submittedOnEndRange, submittedOnStartRange, options) {
            return localVarFp.listMemberAsyncAppointments(memberId, canceledIn, chartedIn, claimedIn, closedIn, holdIn, limit, memberId2, oldestFirstIn, page, submittedOnEndRange, submittedOnStartRange, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} asyncAppointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAsyncAppointmentCharted(asyncAppointmentId, options) {
            return localVarFp.markAsyncAppointmentCharted(asyncAppointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} asyncAppointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAsyncAppointmentClosed(asyncAppointmentId, options) {
            return localVarFp.markAsyncAppointmentClosed(asyncAppointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} asyncAppointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAsyncAppointmentOnHold(asyncAppointmentId, options) {
            return localVarFp.markAsyncAppointmentOnHold(asyncAppointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ScheduleAsyncAppointmentRequest} scheduleAsyncAppointmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleAsyncAppointment(scheduleAsyncAppointmentRequest, options) {
            return localVarFp.scheduleAsyncAppointment(scheduleAsyncAppointmentRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AsyncAppointmentApi - object-oriented interface
 * @export
 * @class AsyncAppointmentApi
 * @extends {BaseAPI}
 */
class AsyncAppointmentApi extends base_1.BaseAPI {
    /**
     *
     * @param {AsyncAppointmentApiCancelAsyncAppointmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AsyncAppointmentApi
     */
    cancelAsyncAppointment(requestParameters, options) {
        return exports.AsyncAppointmentApiFp(this.configuration).cancelAsyncAppointment(requestParameters.asyncAppointmentId, requestParameters.cancelAsyncAppointmentRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AsyncAppointmentApiCheckAsyncAppointmentCandidacyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AsyncAppointmentApi
     */
    checkAsyncAppointmentCandidacy(requestParameters, options) {
        return exports.AsyncAppointmentApiFp(this.configuration).checkAsyncAppointmentCandidacy(requestParameters.memberId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AsyncAppointmentApiClaimAsyncAppointmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AsyncAppointmentApi
     */
    claimAsyncAppointment(requestParameters, options) {
        return exports.AsyncAppointmentApiFp(this.configuration).claimAsyncAppointment(requestParameters.asyncAppointmentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AsyncAppointmentApiGetAsyncAppointmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AsyncAppointmentApi
     */
    getAsyncAppointment(requestParameters, options) {
        return exports.AsyncAppointmentApiFp(this.configuration).getAsyncAppointment(requestParameters.asyncAppointmentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AsyncAppointmentApiListAsyncAppointmentContributorsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AsyncAppointmentApi
     */
    listAsyncAppointmentContributors(requestParameters, options) {
        return exports.AsyncAppointmentApiFp(this.configuration).listAsyncAppointmentContributors(requestParameters.asyncAppointmentId, requestParameters.limit, requestParameters.page, requestParameters.userType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AsyncAppointmentApiListAsyncAppointmentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AsyncAppointmentApi
     */
    listAsyncAppointments(requestParameters = {}, options) {
        return exports.AsyncAppointmentApiFp(this.configuration).listAsyncAppointments(requestParameters.canceledIn, requestParameters.chartedIn, requestParameters.claimedIn, requestParameters.closedIn, requestParameters.holdIn, requestParameters.limit, requestParameters.memberId, requestParameters.oldestFirstIn, requestParameters.page, requestParameters.submittedOnEndRange, requestParameters.submittedOnStartRange, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AsyncAppointmentApiListMemberAsyncAppointmentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AsyncAppointmentApi
     */
    listMemberAsyncAppointments(requestParameters, options) {
        return exports.AsyncAppointmentApiFp(this.configuration).listMemberAsyncAppointments(requestParameters.memberId, requestParameters.canceledIn, requestParameters.chartedIn, requestParameters.claimedIn, requestParameters.closedIn, requestParameters.holdIn, requestParameters.limit, requestParameters.memberId2, requestParameters.oldestFirstIn, requestParameters.page, requestParameters.submittedOnEndRange, requestParameters.submittedOnStartRange, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AsyncAppointmentApiMarkAsyncAppointmentChartedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AsyncAppointmentApi
     */
    markAsyncAppointmentCharted(requestParameters, options) {
        return exports.AsyncAppointmentApiFp(this.configuration).markAsyncAppointmentCharted(requestParameters.asyncAppointmentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AsyncAppointmentApiMarkAsyncAppointmentClosedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AsyncAppointmentApi
     */
    markAsyncAppointmentClosed(requestParameters, options) {
        return exports.AsyncAppointmentApiFp(this.configuration).markAsyncAppointmentClosed(requestParameters.asyncAppointmentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AsyncAppointmentApiMarkAsyncAppointmentOnHoldRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AsyncAppointmentApi
     */
    markAsyncAppointmentOnHold(requestParameters, options) {
        return exports.AsyncAppointmentApiFp(this.configuration).markAsyncAppointmentOnHold(requestParameters.asyncAppointmentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AsyncAppointmentApiScheduleAsyncAppointmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AsyncAppointmentApi
     */
    scheduleAsyncAppointment(requestParameters, options) {
        return exports.AsyncAppointmentApiFp(this.configuration).scheduleAsyncAppointment(requestParameters.scheduleAsyncAppointmentRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AsyncAppointmentApi = AsyncAppointmentApi;
/**
 * AuthenticationApi - axios parameter creator
 * @export
 */
exports.AuthenticationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Uses Vitable Passwordless Authentication (username / token).
         * @param {VitablePasswordlessAuthenticationRequest} vitablePasswordlessAuthenticationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateWithPasswordless: (vitablePasswordlessAuthenticationRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'vitablePasswordlessAuthenticationRequest' is not null or undefined
            common_1.assertParamExists('authenticateWithPasswordless', 'vitablePasswordlessAuthenticationRequest', vitablePasswordlessAuthenticationRequest);
            const localVarPath = `/v1/auth/passwordless`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(vitablePasswordlessAuthenticationRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Uses Vitable Standard Authentication (username / password). Supports 2FA.
         * @param {VitableStandardAuthenticationRequest} vitableStandardAuthenticationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateWithStandard: (vitableStandardAuthenticationRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'vitableStandardAuthenticationRequest' is not null or undefined
            common_1.assertParamExists('authenticateWithStandard', 'vitableStandardAuthenticationRequest', vitableStandardAuthenticationRequest);
            const localVarPath = `/v1/auth/standard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(vitableStandardAuthenticationRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMe: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * API to refresh existing authenticated access token.
         * @param {RefreshAccessTokenRequest} refreshAccessTokenRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshAccessToken: (refreshAccessTokenRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'refreshAccessTokenRequest' is not null or undefined
            common_1.assertParamExists('refreshAccessToken', 'refreshAccessTokenRequest', refreshAccessTokenRequest);
            const localVarPath = `/v1/auth/renewal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(refreshAccessTokenRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AuthenticationApi - functional programming interface
 * @export
 */
exports.AuthenticationApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.AuthenticationApiAxiosParamCreator(configuration);
    return {
        /**
         * Uses Vitable Passwordless Authentication (username / token).
         * @param {VitablePasswordlessAuthenticationRequest} vitablePasswordlessAuthenticationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateWithPasswordless(vitablePasswordlessAuthenticationRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.authenticateWithPasswordless(vitablePasswordlessAuthenticationRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Uses Vitable Standard Authentication (username / password). Supports 2FA.
         * @param {VitableStandardAuthenticationRequest} vitableStandardAuthenticationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateWithStandard(vitableStandardAuthenticationRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.authenticateWithStandard(vitableStandardAuthenticationRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMe(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMe(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * API to refresh existing authenticated access token.
         * @param {RefreshAccessTokenRequest} refreshAccessTokenRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshAccessToken(refreshAccessTokenRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.refreshAccessToken(refreshAccessTokenRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AuthenticationApi - factory interface
 * @export
 */
exports.AuthenticationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.AuthenticationApiFp(configuration);
    return {
        /**
         * Uses Vitable Passwordless Authentication (username / token).
         * @param {VitablePasswordlessAuthenticationRequest} vitablePasswordlessAuthenticationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateWithPasswordless(vitablePasswordlessAuthenticationRequest, options) {
            return localVarFp.authenticateWithPasswordless(vitablePasswordlessAuthenticationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Uses Vitable Standard Authentication (username / password). Supports 2FA.
         * @param {VitableStandardAuthenticationRequest} vitableStandardAuthenticationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateWithStandard(vitableStandardAuthenticationRequest, options) {
            return localVarFp.authenticateWithStandard(vitableStandardAuthenticationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMe(options) {
            return localVarFp.getMe(options).then((request) => request(axios, basePath));
        },
        /**
         * API to refresh existing authenticated access token.
         * @param {RefreshAccessTokenRequest} refreshAccessTokenRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshAccessToken(refreshAccessTokenRequest, options) {
            return localVarFp.refreshAccessToken(refreshAccessTokenRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AuthenticationApi - object-oriented interface
 * @export
 * @class AuthenticationApi
 * @extends {BaseAPI}
 */
class AuthenticationApi extends base_1.BaseAPI {
    /**
     * Uses Vitable Passwordless Authentication (username / token).
     * @param {AuthenticationApiAuthenticateWithPasswordlessRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    authenticateWithPasswordless(requestParameters, options) {
        return exports.AuthenticationApiFp(this.configuration).authenticateWithPasswordless(requestParameters.vitablePasswordlessAuthenticationRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Uses Vitable Standard Authentication (username / password). Supports 2FA.
     * @param {AuthenticationApiAuthenticateWithStandardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    authenticateWithStandard(requestParameters, options) {
        return exports.AuthenticationApiFp(this.configuration).authenticateWithStandard(requestParameters.vitableStandardAuthenticationRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    getMe(options) {
        return exports.AuthenticationApiFp(this.configuration).getMe(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * API to refresh existing authenticated access token.
     * @param {AuthenticationApiRefreshAccessTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    refreshAccessToken(requestParameters, options) {
        return exports.AuthenticationApiFp(this.configuration).refreshAccessToken(requestParameters.refreshAccessTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AuthenticationApi = AuthenticationApi;
/**
 * AvailabilityApi - axios parameter creator
 * @export
 */
exports.AvailabilityApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} appointmentId
         * @param {AddSupportingAvailabilityToAppointmentRequest} addSupportingAvailabilityToAppointmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSupportingAvailabilityToAppointment: (appointmentId, addSupportingAvailabilityToAppointmentRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'appointmentId' is not null or undefined
            common_1.assertParamExists('addSupportingAvailabilityToAppointment', 'appointmentId', appointmentId);
            // verify required parameter 'addSupportingAvailabilityToAppointmentRequest' is not null or undefined
            common_1.assertParamExists('addSupportingAvailabilityToAppointment', 'addSupportingAvailabilityToAppointmentRequest', addSupportingAvailabilityToAppointmentRequest);
            const localVarPath = `/v1/appointments/{appointment_id}/supporting-availability`
                .replace(`{${"appointment_id"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(addSupportingAvailabilityToAppointmentRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} clinicAppointmentId
         * @param {AddSupportingAvailabilityToClinicAppointmentRequest} addSupportingAvailabilityToClinicAppointmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSupportingAvailabilityToClinicAppointment: (clinicAppointmentId, addSupportingAvailabilityToClinicAppointmentRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clinicAppointmentId' is not null or undefined
            common_1.assertParamExists('addSupportingAvailabilityToClinicAppointment', 'clinicAppointmentId', clinicAppointmentId);
            // verify required parameter 'addSupportingAvailabilityToClinicAppointmentRequest' is not null or undefined
            common_1.assertParamExists('addSupportingAvailabilityToClinicAppointment', 'addSupportingAvailabilityToClinicAppointmentRequest', addSupportingAvailabilityToClinicAppointmentRequest);
            const localVarPath = `/v1/clinical-appointments/{clinic_appointment_id}/supporting-availability`
                .replace(`{${"clinic_appointment_id"}}`, encodeURIComponent(String(clinicAppointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(addSupportingAvailabilityToClinicAppointmentRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CreateAvailabilitiesRequest} createAvailabilitiesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAvailabilities: (createAvailabilitiesRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createAvailabilitiesRequest' is not null or undefined
            common_1.assertParamExists('createAvailabilities', 'createAvailabilitiesRequest', createAvailabilitiesRequest);
            const localVarPath = `/v1/availabilities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createAvailabilitiesRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} availabilityId
         * @param {string} providerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAvailability: (availabilityId, providerId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'availabilityId' is not null or undefined
            common_1.assertParamExists('deleteAvailability', 'availabilityId', availabilityId);
            // verify required parameter 'providerId' is not null or undefined
            common_1.assertParamExists('deleteAvailability', 'providerId', providerId);
            const localVarPath = `/v1/providers/{provider_id}/availabilities/{availability_id}`
                .replace(`{${"availability_id"}}`, encodeURIComponent(String(availabilityId)))
                .replace(`{${"provider_id"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} endDatetime
         * @param {string} startDatetime
         * @param {'In Person' | 'Telemedicine'} [appointmentType] * &#x60;In Person&#x60; - In Person * &#x60;Telemedicine&#x60; - Telemedicine
         * @param {string} [companyId]
         * @param {'In Person' | 'Telemedicine'} [designatedApptType] * &#x60;In Person&#x60; - In Person * &#x60;Telemedicine&#x60; - Telemedicine
         * @param {number} [limit]
         * @param {string} [medicalServiceId]
         * @param {string} [memberId]
         * @param {boolean} [oldestFirstIn]
         * @param {boolean} [onlyActiveIn]
         * @param {boolean} [onlyCancelledIn]
         * @param {boolean} [onlyClinicalIn]
         * @param {boolean} [onlyClosedIn]
         * @param {boolean} [onlyFinishedIn]
         * @param {boolean} [onlyIndividualIn]
         * @param {boolean} [onlyNotCancelledIn]
         * @param {boolean} [onlyScheduledIn]
         * @param {boolean} [onlyVacantIn]
         * @param {boolean} [onlyWaitingForApprovalIn]
         * @param {number} [page]
         * @param {string} [providerId]
         * @param {'NursePractitioner' | 'RegisteredNurse' | 'ClinicalSocialWorker' | 'Phlebotomist'} [providerType] * &#x60;NursePractitioner&#x60; - NursePractitioner * &#x60;RegisteredNurse&#x60; - RegisteredNurse * &#x60;ClinicalSocialWorker&#x60; - ClinicalSocialWorker * &#x60;Phlebotomist&#x60; - Phlebotomist
         * @param {'AL' | 'AK' | 'AZ' | 'AR' | 'CA' | 'CO' | 'CT' | 'DC' | 'DE' | 'FL' | 'GA' | 'HI' | 'ID' | 'IL' | 'IN' | 'IA' | 'KS' | 'KY' | 'LA' | 'ME' | 'MD' | 'MA' | 'MI' | 'MN' | 'MS' | 'MO' | 'MT' | 'NE' | 'NV' | 'NH' | 'NJ' | 'NM' | 'NY' | 'NC' | 'ND' | 'OH' | 'OK' | 'OR' | 'PR' | 'PA' | 'RI' | 'SC' | 'SD' | 'TN' | 'TX' | 'UT' | 'VT' | 'VI' | 'VA' | 'WA' | 'WI' | 'WV' | 'WY' | 'AA' | 'AE' | 'PW' | 'AP' | 'FM' | 'MH' | 'GU'} [state] * &#x60;AL&#x60; - AL * &#x60;AK&#x60; - AK * &#x60;AZ&#x60; - AZ * &#x60;AR&#x60; - AR * &#x60;CA&#x60; - CA * &#x60;CO&#x60; - CO * &#x60;CT&#x60; - CT * &#x60;DC&#x60; - DC * &#x60;DE&#x60; - DE * &#x60;FL&#x60; - FL * &#x60;GA&#x60; - GA * &#x60;HI&#x60; - HI * &#x60;ID&#x60; - ID * &#x60;IL&#x60; - IL * &#x60;IN&#x60; - IN * &#x60;IA&#x60; - IA * &#x60;KS&#x60; - KS * &#x60;KY&#x60; - KY * &#x60;LA&#x60; - LA * &#x60;ME&#x60; - ME * &#x60;MD&#x60; - MD * &#x60;MA&#x60; - MA * &#x60;MI&#x60; - MI * &#x60;MN&#x60; - MN * &#x60;MS&#x60; - MS * &#x60;MO&#x60; - MO * &#x60;MT&#x60; - MT * &#x60;NE&#x60; - NE * &#x60;NV&#x60; - NV * &#x60;NH&#x60; - NH * &#x60;NJ&#x60; - NJ * &#x60;NM&#x60; - NM * &#x60;NY&#x60; - NY * &#x60;NC&#x60; - NC * &#x60;ND&#x60; - ND * &#x60;OH&#x60; - OH * &#x60;OK&#x60; - OK * &#x60;OR&#x60; - OR * &#x60;PR&#x60; - PR * &#x60;PA&#x60; - PA * &#x60;RI&#x60; - RI * &#x60;SC&#x60; - SC * &#x60;SD&#x60; - SD * &#x60;TN&#x60; - TN * &#x60;TX&#x60; - TX * &#x60;UT&#x60; - UT * &#x60;VT&#x60; - VT * &#x60;VI&#x60; - VI * &#x60;VA&#x60; - VA * &#x60;WA&#x60; - WA * &#x60;WI&#x60; - WI * &#x60;WV&#x60; - WV * &#x60;WY&#x60; - WY * &#x60;AA&#x60; - AA * &#x60;AE&#x60; - AE * &#x60;PW&#x60; - PW * &#x60;AP&#x60; - AP * &#x60;FM&#x60; - FM * &#x60;MH&#x60; - MH * &#x60;GU&#x60; - GU
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAvailabilities: (endDatetime, startDatetime, appointmentType, companyId, designatedApptType, limit, medicalServiceId, memberId, oldestFirstIn, onlyActiveIn, onlyCancelledIn, onlyClinicalIn, onlyClosedIn, onlyFinishedIn, onlyIndividualIn, onlyNotCancelledIn, onlyScheduledIn, onlyVacantIn, onlyWaitingForApprovalIn, page, providerId, providerType, state, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'endDatetime' is not null or undefined
            common_1.assertParamExists('listAvailabilities', 'endDatetime', endDatetime);
            // verify required parameter 'startDatetime' is not null or undefined
            common_1.assertParamExists('listAvailabilities', 'startDatetime', startDatetime);
            const localVarPath = `/v1/availabilities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (appointmentType !== undefined) {
                localVarQueryParameter['appointment_type'] = appointmentType;
            }
            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }
            if (designatedApptType !== undefined) {
                localVarQueryParameter['designated_appt_type'] = designatedApptType;
            }
            if (endDatetime !== undefined) {
                localVarQueryParameter['end_datetime'] = (endDatetime instanceof Date) ?
                    endDatetime.toISOString() :
                    endDatetime;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (medicalServiceId !== undefined) {
                localVarQueryParameter['medical_service_id'] = medicalServiceId;
            }
            if (memberId !== undefined) {
                localVarQueryParameter['member_id'] = memberId;
            }
            if (oldestFirstIn !== undefined) {
                localVarQueryParameter['oldest_first_in'] = oldestFirstIn;
            }
            if (onlyActiveIn !== undefined) {
                localVarQueryParameter['only_active_in'] = onlyActiveIn;
            }
            if (onlyCancelledIn !== undefined) {
                localVarQueryParameter['only_cancelled_in'] = onlyCancelledIn;
            }
            if (onlyClinicalIn !== undefined) {
                localVarQueryParameter['only_clinical_in'] = onlyClinicalIn;
            }
            if (onlyClosedIn !== undefined) {
                localVarQueryParameter['only_closed_in'] = onlyClosedIn;
            }
            if (onlyFinishedIn !== undefined) {
                localVarQueryParameter['only_finished_in'] = onlyFinishedIn;
            }
            if (onlyIndividualIn !== undefined) {
                localVarQueryParameter['only_individual_in'] = onlyIndividualIn;
            }
            if (onlyNotCancelledIn !== undefined) {
                localVarQueryParameter['only_not_cancelled_in'] = onlyNotCancelledIn;
            }
            if (onlyScheduledIn !== undefined) {
                localVarQueryParameter['only_scheduled_in'] = onlyScheduledIn;
            }
            if (onlyVacantIn !== undefined) {
                localVarQueryParameter['only_vacant_in'] = onlyVacantIn;
            }
            if (onlyWaitingForApprovalIn !== undefined) {
                localVarQueryParameter['only_waiting_for_approval_in'] = onlyWaitingForApprovalIn;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (providerId !== undefined) {
                localVarQueryParameter['provider_id'] = providerId;
            }
            if (providerType !== undefined) {
                localVarQueryParameter['provider_type'] = providerType;
            }
            if (startDatetime !== undefined) {
                localVarQueryParameter['start_datetime'] = (startDatetime instanceof Date) ?
                    startDatetime.toISOString() :
                    startDatetime;
            }
            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} endDatetime
         * @param {string} startDatetime
         * @param {'In Person' | 'Telemedicine'} [appointmentType] * &#x60;In Person&#x60; - In Person * &#x60;Telemedicine&#x60; - Telemedicine
         * @param {string} [companyId]
         * @param {'In Person' | 'Telemedicine'} [designatedApptType] * &#x60;In Person&#x60; - In Person * &#x60;Telemedicine&#x60; - Telemedicine
         * @param {number} [limit]
         * @param {string} [medicalServiceId]
         * @param {string} [memberId]
         * @param {boolean} [oldestFirstIn]
         * @param {boolean} [onlyActiveIn]
         * @param {boolean} [onlyCancelledIn]
         * @param {boolean} [onlyClinicalIn]
         * @param {boolean} [onlyClosedIn]
         * @param {boolean} [onlyFinishedIn]
         * @param {boolean} [onlyIndividualIn]
         * @param {boolean} [onlyNotCancelledIn]
         * @param {boolean} [onlyScheduledIn]
         * @param {boolean} [onlyVacantIn]
         * @param {boolean} [onlyWaitingForApprovalIn]
         * @param {number} [page]
         * @param {string} [providerId]
         * @param {'NursePractitioner' | 'RegisteredNurse' | 'ClinicalSocialWorker' | 'Phlebotomist'} [providerType] * &#x60;NursePractitioner&#x60; - NursePractitioner * &#x60;RegisteredNurse&#x60; - RegisteredNurse * &#x60;ClinicalSocialWorker&#x60; - ClinicalSocialWorker * &#x60;Phlebotomist&#x60; - Phlebotomist
         * @param {'AL' | 'AK' | 'AZ' | 'AR' | 'CA' | 'CO' | 'CT' | 'DC' | 'DE' | 'FL' | 'GA' | 'HI' | 'ID' | 'IL' | 'IN' | 'IA' | 'KS' | 'KY' | 'LA' | 'ME' | 'MD' | 'MA' | 'MI' | 'MN' | 'MS' | 'MO' | 'MT' | 'NE' | 'NV' | 'NH' | 'NJ' | 'NM' | 'NY' | 'NC' | 'ND' | 'OH' | 'OK' | 'OR' | 'PR' | 'PA' | 'RI' | 'SC' | 'SD' | 'TN' | 'TX' | 'UT' | 'VT' | 'VI' | 'VA' | 'WA' | 'WI' | 'WV' | 'WY' | 'AA' | 'AE' | 'PW' | 'AP' | 'FM' | 'MH' | 'GU'} [state] * &#x60;AL&#x60; - AL * &#x60;AK&#x60; - AK * &#x60;AZ&#x60; - AZ * &#x60;AR&#x60; - AR * &#x60;CA&#x60; - CA * &#x60;CO&#x60; - CO * &#x60;CT&#x60; - CT * &#x60;DC&#x60; - DC * &#x60;DE&#x60; - DE * &#x60;FL&#x60; - FL * &#x60;GA&#x60; - GA * &#x60;HI&#x60; - HI * &#x60;ID&#x60; - ID * &#x60;IL&#x60; - IL * &#x60;IN&#x60; - IN * &#x60;IA&#x60; - IA * &#x60;KS&#x60; - KS * &#x60;KY&#x60; - KY * &#x60;LA&#x60; - LA * &#x60;ME&#x60; - ME * &#x60;MD&#x60; - MD * &#x60;MA&#x60; - MA * &#x60;MI&#x60; - MI * &#x60;MN&#x60; - MN * &#x60;MS&#x60; - MS * &#x60;MO&#x60; - MO * &#x60;MT&#x60; - MT * &#x60;NE&#x60; - NE * &#x60;NV&#x60; - NV * &#x60;NH&#x60; - NH * &#x60;NJ&#x60; - NJ * &#x60;NM&#x60; - NM * &#x60;NY&#x60; - NY * &#x60;NC&#x60; - NC * &#x60;ND&#x60; - ND * &#x60;OH&#x60; - OH * &#x60;OK&#x60; - OK * &#x60;OR&#x60; - OR * &#x60;PR&#x60; - PR * &#x60;PA&#x60; - PA * &#x60;RI&#x60; - RI * &#x60;SC&#x60; - SC * &#x60;SD&#x60; - SD * &#x60;TN&#x60; - TN * &#x60;TX&#x60; - TX * &#x60;UT&#x60; - UT * &#x60;VT&#x60; - VT * &#x60;VI&#x60; - VI * &#x60;VA&#x60; - VA * &#x60;WA&#x60; - WA * &#x60;WI&#x60; - WI * &#x60;WV&#x60; - WV * &#x60;WY&#x60; - WY * &#x60;AA&#x60; - AA * &#x60;AE&#x60; - AE * &#x60;PW&#x60; - PW * &#x60;AP&#x60; - AP * &#x60;FM&#x60; - FM * &#x60;MH&#x60; - MH * &#x60;GU&#x60; - GU
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAvailabilitiesCalendar: (endDatetime, startDatetime, appointmentType, companyId, designatedApptType, limit, medicalServiceId, memberId, oldestFirstIn, onlyActiveIn, onlyCancelledIn, onlyClinicalIn, onlyClosedIn, onlyFinishedIn, onlyIndividualIn, onlyNotCancelledIn, onlyScheduledIn, onlyVacantIn, onlyWaitingForApprovalIn, page, providerId, providerType, state, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'endDatetime' is not null or undefined
            common_1.assertParamExists('listAvailabilitiesCalendar', 'endDatetime', endDatetime);
            // verify required parameter 'startDatetime' is not null or undefined
            common_1.assertParamExists('listAvailabilitiesCalendar', 'startDatetime', startDatetime);
            const localVarPath = `/v1/availabilities/calendar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (appointmentType !== undefined) {
                localVarQueryParameter['appointment_type'] = appointmentType;
            }
            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }
            if (designatedApptType !== undefined) {
                localVarQueryParameter['designated_appt_type'] = designatedApptType;
            }
            if (endDatetime !== undefined) {
                localVarQueryParameter['end_datetime'] = (endDatetime instanceof Date) ?
                    endDatetime.toISOString() :
                    endDatetime;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (medicalServiceId !== undefined) {
                localVarQueryParameter['medical_service_id'] = medicalServiceId;
            }
            if (memberId !== undefined) {
                localVarQueryParameter['member_id'] = memberId;
            }
            if (oldestFirstIn !== undefined) {
                localVarQueryParameter['oldest_first_in'] = oldestFirstIn;
            }
            if (onlyActiveIn !== undefined) {
                localVarQueryParameter['only_active_in'] = onlyActiveIn;
            }
            if (onlyCancelledIn !== undefined) {
                localVarQueryParameter['only_cancelled_in'] = onlyCancelledIn;
            }
            if (onlyClinicalIn !== undefined) {
                localVarQueryParameter['only_clinical_in'] = onlyClinicalIn;
            }
            if (onlyClosedIn !== undefined) {
                localVarQueryParameter['only_closed_in'] = onlyClosedIn;
            }
            if (onlyFinishedIn !== undefined) {
                localVarQueryParameter['only_finished_in'] = onlyFinishedIn;
            }
            if (onlyIndividualIn !== undefined) {
                localVarQueryParameter['only_individual_in'] = onlyIndividualIn;
            }
            if (onlyNotCancelledIn !== undefined) {
                localVarQueryParameter['only_not_cancelled_in'] = onlyNotCancelledIn;
            }
            if (onlyScheduledIn !== undefined) {
                localVarQueryParameter['only_scheduled_in'] = onlyScheduledIn;
            }
            if (onlyVacantIn !== undefined) {
                localVarQueryParameter['only_vacant_in'] = onlyVacantIn;
            }
            if (onlyWaitingForApprovalIn !== undefined) {
                localVarQueryParameter['only_waiting_for_approval_in'] = onlyWaitingForApprovalIn;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (providerId !== undefined) {
                localVarQueryParameter['provider_id'] = providerId;
            }
            if (providerType !== undefined) {
                localVarQueryParameter['provider_type'] = providerType;
            }
            if (startDatetime !== undefined) {
                localVarQueryParameter['start_datetime'] = (startDatetime instanceof Date) ?
                    startDatetime.toISOString() :
                    startDatetime;
            }
            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ListOptimalAvailabilitiesRequest} listOptimalAvailabilitiesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOptimalAvailabilities: (listOptimalAvailabilitiesRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'listOptimalAvailabilitiesRequest' is not null or undefined
            common_1.assertParamExists('listOptimalAvailabilities', 'listOptimalAvailabilitiesRequest', listOptimalAvailabilitiesRequest);
            const localVarPath = `/v1/availabilities/optimal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(listOptimalAvailabilitiesRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ListOptimalClinicAvailabilitiesRequest} listOptimalClinicAvailabilitiesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOptimalClinicAvailabilities: (listOptimalClinicAvailabilitiesRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'listOptimalClinicAvailabilitiesRequest' is not null or undefined
            common_1.assertParamExists('listOptimalClinicAvailabilities', 'listOptimalClinicAvailabilitiesRequest', listOptimalClinicAvailabilitiesRequest);
            const localVarPath = `/v1/availabilities/optimal-clinic`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(listOptimalClinicAvailabilitiesRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ListOptimalClinicRequestAvailabilitiesRequest} listOptimalClinicRequestAvailabilitiesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOptimalClinicRequestAvailabilities: (listOptimalClinicRequestAvailabilitiesRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'listOptimalClinicRequestAvailabilitiesRequest' is not null or undefined
            common_1.assertParamExists('listOptimalClinicRequestAvailabilities', 'listOptimalClinicRequestAvailabilitiesRequest', listOptimalClinicRequestAvailabilitiesRequest);
            const localVarPath = `/v1/availabilities/optimal-clinic-request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(listOptimalClinicRequestAvailabilitiesRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} appointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRescheduleAvailabilitiesForAppointment: (appointmentId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'appointmentId' is not null or undefined
            common_1.assertParamExists('listRescheduleAvailabilitiesForAppointment', 'appointmentId', appointmentId);
            const localVarPath = `/v1/appointments/{appointment_id}/reschedule/availabilities`
                .replace(`{${"appointment_id"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} providerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUpcomingSchedulableProviderAvailabilities: (providerId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'providerId' is not null or undefined
            common_1.assertParamExists('listUpcomingSchedulableProviderAvailabilities', 'providerId', providerId);
            const localVarPath = `/v1/availabilities/provider/{provider_id}`
                .replace(`{${"provider_id"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} supportingAvailabilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeSupportingAvailability: (supportingAvailabilityId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'supportingAvailabilityId' is not null or undefined
            common_1.assertParamExists('removeSupportingAvailability', 'supportingAvailabilityId', supportingAvailabilityId);
            const localVarPath = `/v1/supporting-availabilities/{supporting_availability_id}`
                .replace(`{${"supporting_availability_id"}}`, encodeURIComponent(String(supportingAvailabilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} availabilityId
         * @param {UpdateAvailabilityBlockedStatusRequest} updateAvailabilityBlockedStatusRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAvailabilityBlockedStatus: (availabilityId, updateAvailabilityBlockedStatusRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'availabilityId' is not null or undefined
            common_1.assertParamExists('updateAvailabilityBlockedStatus', 'availabilityId', availabilityId);
            // verify required parameter 'updateAvailabilityBlockedStatusRequest' is not null or undefined
            common_1.assertParamExists('updateAvailabilityBlockedStatus', 'updateAvailabilityBlockedStatusRequest', updateAvailabilityBlockedStatusRequest);
            const localVarPath = `/v1/availabilities/{availability_id}/update-blocked-status`
                .replace(`{${"availability_id"}}`, encodeURIComponent(String(availabilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateAvailabilityBlockedStatusRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AvailabilityApi - functional programming interface
 * @export
 */
exports.AvailabilityApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.AvailabilityApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} appointmentId
         * @param {AddSupportingAvailabilityToAppointmentRequest} addSupportingAvailabilityToAppointmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSupportingAvailabilityToAppointment(appointmentId, addSupportingAvailabilityToAppointmentRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addSupportingAvailabilityToAppointment(appointmentId, addSupportingAvailabilityToAppointmentRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} clinicAppointmentId
         * @param {AddSupportingAvailabilityToClinicAppointmentRequest} addSupportingAvailabilityToClinicAppointmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSupportingAvailabilityToClinicAppointment(clinicAppointmentId, addSupportingAvailabilityToClinicAppointmentRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addSupportingAvailabilityToClinicAppointment(clinicAppointmentId, addSupportingAvailabilityToClinicAppointmentRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {CreateAvailabilitiesRequest} createAvailabilitiesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAvailabilities(createAvailabilitiesRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createAvailabilities(createAvailabilitiesRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} availabilityId
         * @param {string} providerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAvailability(availabilityId, providerId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteAvailability(availabilityId, providerId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} endDatetime
         * @param {string} startDatetime
         * @param {'In Person' | 'Telemedicine'} [appointmentType] * &#x60;In Person&#x60; - In Person * &#x60;Telemedicine&#x60; - Telemedicine
         * @param {string} [companyId]
         * @param {'In Person' | 'Telemedicine'} [designatedApptType] * &#x60;In Person&#x60; - In Person * &#x60;Telemedicine&#x60; - Telemedicine
         * @param {number} [limit]
         * @param {string} [medicalServiceId]
         * @param {string} [memberId]
         * @param {boolean} [oldestFirstIn]
         * @param {boolean} [onlyActiveIn]
         * @param {boolean} [onlyCancelledIn]
         * @param {boolean} [onlyClinicalIn]
         * @param {boolean} [onlyClosedIn]
         * @param {boolean} [onlyFinishedIn]
         * @param {boolean} [onlyIndividualIn]
         * @param {boolean} [onlyNotCancelledIn]
         * @param {boolean} [onlyScheduledIn]
         * @param {boolean} [onlyVacantIn]
         * @param {boolean} [onlyWaitingForApprovalIn]
         * @param {number} [page]
         * @param {string} [providerId]
         * @param {'NursePractitioner' | 'RegisteredNurse' | 'ClinicalSocialWorker' | 'Phlebotomist'} [providerType] * &#x60;NursePractitioner&#x60; - NursePractitioner * &#x60;RegisteredNurse&#x60; - RegisteredNurse * &#x60;ClinicalSocialWorker&#x60; - ClinicalSocialWorker * &#x60;Phlebotomist&#x60; - Phlebotomist
         * @param {'AL' | 'AK' | 'AZ' | 'AR' | 'CA' | 'CO' | 'CT' | 'DC' | 'DE' | 'FL' | 'GA' | 'HI' | 'ID' | 'IL' | 'IN' | 'IA' | 'KS' | 'KY' | 'LA' | 'ME' | 'MD' | 'MA' | 'MI' | 'MN' | 'MS' | 'MO' | 'MT' | 'NE' | 'NV' | 'NH' | 'NJ' | 'NM' | 'NY' | 'NC' | 'ND' | 'OH' | 'OK' | 'OR' | 'PR' | 'PA' | 'RI' | 'SC' | 'SD' | 'TN' | 'TX' | 'UT' | 'VT' | 'VI' | 'VA' | 'WA' | 'WI' | 'WV' | 'WY' | 'AA' | 'AE' | 'PW' | 'AP' | 'FM' | 'MH' | 'GU'} [state] * &#x60;AL&#x60; - AL * &#x60;AK&#x60; - AK * &#x60;AZ&#x60; - AZ * &#x60;AR&#x60; - AR * &#x60;CA&#x60; - CA * &#x60;CO&#x60; - CO * &#x60;CT&#x60; - CT * &#x60;DC&#x60; - DC * &#x60;DE&#x60; - DE * &#x60;FL&#x60; - FL * &#x60;GA&#x60; - GA * &#x60;HI&#x60; - HI * &#x60;ID&#x60; - ID * &#x60;IL&#x60; - IL * &#x60;IN&#x60; - IN * &#x60;IA&#x60; - IA * &#x60;KS&#x60; - KS * &#x60;KY&#x60; - KY * &#x60;LA&#x60; - LA * &#x60;ME&#x60; - ME * &#x60;MD&#x60; - MD * &#x60;MA&#x60; - MA * &#x60;MI&#x60; - MI * &#x60;MN&#x60; - MN * &#x60;MS&#x60; - MS * &#x60;MO&#x60; - MO * &#x60;MT&#x60; - MT * &#x60;NE&#x60; - NE * &#x60;NV&#x60; - NV * &#x60;NH&#x60; - NH * &#x60;NJ&#x60; - NJ * &#x60;NM&#x60; - NM * &#x60;NY&#x60; - NY * &#x60;NC&#x60; - NC * &#x60;ND&#x60; - ND * &#x60;OH&#x60; - OH * &#x60;OK&#x60; - OK * &#x60;OR&#x60; - OR * &#x60;PR&#x60; - PR * &#x60;PA&#x60; - PA * &#x60;RI&#x60; - RI * &#x60;SC&#x60; - SC * &#x60;SD&#x60; - SD * &#x60;TN&#x60; - TN * &#x60;TX&#x60; - TX * &#x60;UT&#x60; - UT * &#x60;VT&#x60; - VT * &#x60;VI&#x60; - VI * &#x60;VA&#x60; - VA * &#x60;WA&#x60; - WA * &#x60;WI&#x60; - WI * &#x60;WV&#x60; - WV * &#x60;WY&#x60; - WY * &#x60;AA&#x60; - AA * &#x60;AE&#x60; - AE * &#x60;PW&#x60; - PW * &#x60;AP&#x60; - AP * &#x60;FM&#x60; - FM * &#x60;MH&#x60; - MH * &#x60;GU&#x60; - GU
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAvailabilities(endDatetime, startDatetime, appointmentType, companyId, designatedApptType, limit, medicalServiceId, memberId, oldestFirstIn, onlyActiveIn, onlyCancelledIn, onlyClinicalIn, onlyClosedIn, onlyFinishedIn, onlyIndividualIn, onlyNotCancelledIn, onlyScheduledIn, onlyVacantIn, onlyWaitingForApprovalIn, page, providerId, providerType, state, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listAvailabilities(endDatetime, startDatetime, appointmentType, companyId, designatedApptType, limit, medicalServiceId, memberId, oldestFirstIn, onlyActiveIn, onlyCancelledIn, onlyClinicalIn, onlyClosedIn, onlyFinishedIn, onlyIndividualIn, onlyNotCancelledIn, onlyScheduledIn, onlyVacantIn, onlyWaitingForApprovalIn, page, providerId, providerType, state, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} endDatetime
         * @param {string} startDatetime
         * @param {'In Person' | 'Telemedicine'} [appointmentType] * &#x60;In Person&#x60; - In Person * &#x60;Telemedicine&#x60; - Telemedicine
         * @param {string} [companyId]
         * @param {'In Person' | 'Telemedicine'} [designatedApptType] * &#x60;In Person&#x60; - In Person * &#x60;Telemedicine&#x60; - Telemedicine
         * @param {number} [limit]
         * @param {string} [medicalServiceId]
         * @param {string} [memberId]
         * @param {boolean} [oldestFirstIn]
         * @param {boolean} [onlyActiveIn]
         * @param {boolean} [onlyCancelledIn]
         * @param {boolean} [onlyClinicalIn]
         * @param {boolean} [onlyClosedIn]
         * @param {boolean} [onlyFinishedIn]
         * @param {boolean} [onlyIndividualIn]
         * @param {boolean} [onlyNotCancelledIn]
         * @param {boolean} [onlyScheduledIn]
         * @param {boolean} [onlyVacantIn]
         * @param {boolean} [onlyWaitingForApprovalIn]
         * @param {number} [page]
         * @param {string} [providerId]
         * @param {'NursePractitioner' | 'RegisteredNurse' | 'ClinicalSocialWorker' | 'Phlebotomist'} [providerType] * &#x60;NursePractitioner&#x60; - NursePractitioner * &#x60;RegisteredNurse&#x60; - RegisteredNurse * &#x60;ClinicalSocialWorker&#x60; - ClinicalSocialWorker * &#x60;Phlebotomist&#x60; - Phlebotomist
         * @param {'AL' | 'AK' | 'AZ' | 'AR' | 'CA' | 'CO' | 'CT' | 'DC' | 'DE' | 'FL' | 'GA' | 'HI' | 'ID' | 'IL' | 'IN' | 'IA' | 'KS' | 'KY' | 'LA' | 'ME' | 'MD' | 'MA' | 'MI' | 'MN' | 'MS' | 'MO' | 'MT' | 'NE' | 'NV' | 'NH' | 'NJ' | 'NM' | 'NY' | 'NC' | 'ND' | 'OH' | 'OK' | 'OR' | 'PR' | 'PA' | 'RI' | 'SC' | 'SD' | 'TN' | 'TX' | 'UT' | 'VT' | 'VI' | 'VA' | 'WA' | 'WI' | 'WV' | 'WY' | 'AA' | 'AE' | 'PW' | 'AP' | 'FM' | 'MH' | 'GU'} [state] * &#x60;AL&#x60; - AL * &#x60;AK&#x60; - AK * &#x60;AZ&#x60; - AZ * &#x60;AR&#x60; - AR * &#x60;CA&#x60; - CA * &#x60;CO&#x60; - CO * &#x60;CT&#x60; - CT * &#x60;DC&#x60; - DC * &#x60;DE&#x60; - DE * &#x60;FL&#x60; - FL * &#x60;GA&#x60; - GA * &#x60;HI&#x60; - HI * &#x60;ID&#x60; - ID * &#x60;IL&#x60; - IL * &#x60;IN&#x60; - IN * &#x60;IA&#x60; - IA * &#x60;KS&#x60; - KS * &#x60;KY&#x60; - KY * &#x60;LA&#x60; - LA * &#x60;ME&#x60; - ME * &#x60;MD&#x60; - MD * &#x60;MA&#x60; - MA * &#x60;MI&#x60; - MI * &#x60;MN&#x60; - MN * &#x60;MS&#x60; - MS * &#x60;MO&#x60; - MO * &#x60;MT&#x60; - MT * &#x60;NE&#x60; - NE * &#x60;NV&#x60; - NV * &#x60;NH&#x60; - NH * &#x60;NJ&#x60; - NJ * &#x60;NM&#x60; - NM * &#x60;NY&#x60; - NY * &#x60;NC&#x60; - NC * &#x60;ND&#x60; - ND * &#x60;OH&#x60; - OH * &#x60;OK&#x60; - OK * &#x60;OR&#x60; - OR * &#x60;PR&#x60; - PR * &#x60;PA&#x60; - PA * &#x60;RI&#x60; - RI * &#x60;SC&#x60; - SC * &#x60;SD&#x60; - SD * &#x60;TN&#x60; - TN * &#x60;TX&#x60; - TX * &#x60;UT&#x60; - UT * &#x60;VT&#x60; - VT * &#x60;VI&#x60; - VI * &#x60;VA&#x60; - VA * &#x60;WA&#x60; - WA * &#x60;WI&#x60; - WI * &#x60;WV&#x60; - WV * &#x60;WY&#x60; - WY * &#x60;AA&#x60; - AA * &#x60;AE&#x60; - AE * &#x60;PW&#x60; - PW * &#x60;AP&#x60; - AP * &#x60;FM&#x60; - FM * &#x60;MH&#x60; - MH * &#x60;GU&#x60; - GU
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAvailabilitiesCalendar(endDatetime, startDatetime, appointmentType, companyId, designatedApptType, limit, medicalServiceId, memberId, oldestFirstIn, onlyActiveIn, onlyCancelledIn, onlyClinicalIn, onlyClosedIn, onlyFinishedIn, onlyIndividualIn, onlyNotCancelledIn, onlyScheduledIn, onlyVacantIn, onlyWaitingForApprovalIn, page, providerId, providerType, state, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listAvailabilitiesCalendar(endDatetime, startDatetime, appointmentType, companyId, designatedApptType, limit, medicalServiceId, memberId, oldestFirstIn, onlyActiveIn, onlyCancelledIn, onlyClinicalIn, onlyClosedIn, onlyFinishedIn, onlyIndividualIn, onlyNotCancelledIn, onlyScheduledIn, onlyVacantIn, onlyWaitingForApprovalIn, page, providerId, providerType, state, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {ListOptimalAvailabilitiesRequest} listOptimalAvailabilitiesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOptimalAvailabilities(listOptimalAvailabilitiesRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listOptimalAvailabilities(listOptimalAvailabilitiesRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {ListOptimalClinicAvailabilitiesRequest} listOptimalClinicAvailabilitiesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOptimalClinicAvailabilities(listOptimalClinicAvailabilitiesRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listOptimalClinicAvailabilities(listOptimalClinicAvailabilitiesRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {ListOptimalClinicRequestAvailabilitiesRequest} listOptimalClinicRequestAvailabilitiesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOptimalClinicRequestAvailabilities(listOptimalClinicRequestAvailabilitiesRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listOptimalClinicRequestAvailabilities(listOptimalClinicRequestAvailabilitiesRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} appointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRescheduleAvailabilitiesForAppointment(appointmentId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listRescheduleAvailabilitiesForAppointment(appointmentId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} providerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUpcomingSchedulableProviderAvailabilities(providerId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listUpcomingSchedulableProviderAvailabilities(providerId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} supportingAvailabilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeSupportingAvailability(supportingAvailabilityId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.removeSupportingAvailability(supportingAvailabilityId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} availabilityId
         * @param {UpdateAvailabilityBlockedStatusRequest} updateAvailabilityBlockedStatusRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAvailabilityBlockedStatus(availabilityId, updateAvailabilityBlockedStatusRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateAvailabilityBlockedStatus(availabilityId, updateAvailabilityBlockedStatusRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AvailabilityApi - factory interface
 * @export
 */
exports.AvailabilityApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.AvailabilityApiFp(configuration);
    return {
        /**
         *
         * @param {string} appointmentId
         * @param {AddSupportingAvailabilityToAppointmentRequest} addSupportingAvailabilityToAppointmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSupportingAvailabilityToAppointment(appointmentId, addSupportingAvailabilityToAppointmentRequest, options) {
            return localVarFp.addSupportingAvailabilityToAppointment(appointmentId, addSupportingAvailabilityToAppointmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} clinicAppointmentId
         * @param {AddSupportingAvailabilityToClinicAppointmentRequest} addSupportingAvailabilityToClinicAppointmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSupportingAvailabilityToClinicAppointment(clinicAppointmentId, addSupportingAvailabilityToClinicAppointmentRequest, options) {
            return localVarFp.addSupportingAvailabilityToClinicAppointment(clinicAppointmentId, addSupportingAvailabilityToClinicAppointmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateAvailabilitiesRequest} createAvailabilitiesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAvailabilities(createAvailabilitiesRequest, options) {
            return localVarFp.createAvailabilities(createAvailabilitiesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} availabilityId
         * @param {string} providerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAvailability(availabilityId, providerId, options) {
            return localVarFp.deleteAvailability(availabilityId, providerId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} endDatetime
         * @param {string} startDatetime
         * @param {'In Person' | 'Telemedicine'} [appointmentType] * &#x60;In Person&#x60; - In Person * &#x60;Telemedicine&#x60; - Telemedicine
         * @param {string} [companyId]
         * @param {'In Person' | 'Telemedicine'} [designatedApptType] * &#x60;In Person&#x60; - In Person * &#x60;Telemedicine&#x60; - Telemedicine
         * @param {number} [limit]
         * @param {string} [medicalServiceId]
         * @param {string} [memberId]
         * @param {boolean} [oldestFirstIn]
         * @param {boolean} [onlyActiveIn]
         * @param {boolean} [onlyCancelledIn]
         * @param {boolean} [onlyClinicalIn]
         * @param {boolean} [onlyClosedIn]
         * @param {boolean} [onlyFinishedIn]
         * @param {boolean} [onlyIndividualIn]
         * @param {boolean} [onlyNotCancelledIn]
         * @param {boolean} [onlyScheduledIn]
         * @param {boolean} [onlyVacantIn]
         * @param {boolean} [onlyWaitingForApprovalIn]
         * @param {number} [page]
         * @param {string} [providerId]
         * @param {'NursePractitioner' | 'RegisteredNurse' | 'ClinicalSocialWorker' | 'Phlebotomist'} [providerType] * &#x60;NursePractitioner&#x60; - NursePractitioner * &#x60;RegisteredNurse&#x60; - RegisteredNurse * &#x60;ClinicalSocialWorker&#x60; - ClinicalSocialWorker * &#x60;Phlebotomist&#x60; - Phlebotomist
         * @param {'AL' | 'AK' | 'AZ' | 'AR' | 'CA' | 'CO' | 'CT' | 'DC' | 'DE' | 'FL' | 'GA' | 'HI' | 'ID' | 'IL' | 'IN' | 'IA' | 'KS' | 'KY' | 'LA' | 'ME' | 'MD' | 'MA' | 'MI' | 'MN' | 'MS' | 'MO' | 'MT' | 'NE' | 'NV' | 'NH' | 'NJ' | 'NM' | 'NY' | 'NC' | 'ND' | 'OH' | 'OK' | 'OR' | 'PR' | 'PA' | 'RI' | 'SC' | 'SD' | 'TN' | 'TX' | 'UT' | 'VT' | 'VI' | 'VA' | 'WA' | 'WI' | 'WV' | 'WY' | 'AA' | 'AE' | 'PW' | 'AP' | 'FM' | 'MH' | 'GU'} [state] * &#x60;AL&#x60; - AL * &#x60;AK&#x60; - AK * &#x60;AZ&#x60; - AZ * &#x60;AR&#x60; - AR * &#x60;CA&#x60; - CA * &#x60;CO&#x60; - CO * &#x60;CT&#x60; - CT * &#x60;DC&#x60; - DC * &#x60;DE&#x60; - DE * &#x60;FL&#x60; - FL * &#x60;GA&#x60; - GA * &#x60;HI&#x60; - HI * &#x60;ID&#x60; - ID * &#x60;IL&#x60; - IL * &#x60;IN&#x60; - IN * &#x60;IA&#x60; - IA * &#x60;KS&#x60; - KS * &#x60;KY&#x60; - KY * &#x60;LA&#x60; - LA * &#x60;ME&#x60; - ME * &#x60;MD&#x60; - MD * &#x60;MA&#x60; - MA * &#x60;MI&#x60; - MI * &#x60;MN&#x60; - MN * &#x60;MS&#x60; - MS * &#x60;MO&#x60; - MO * &#x60;MT&#x60; - MT * &#x60;NE&#x60; - NE * &#x60;NV&#x60; - NV * &#x60;NH&#x60; - NH * &#x60;NJ&#x60; - NJ * &#x60;NM&#x60; - NM * &#x60;NY&#x60; - NY * &#x60;NC&#x60; - NC * &#x60;ND&#x60; - ND * &#x60;OH&#x60; - OH * &#x60;OK&#x60; - OK * &#x60;OR&#x60; - OR * &#x60;PR&#x60; - PR * &#x60;PA&#x60; - PA * &#x60;RI&#x60; - RI * &#x60;SC&#x60; - SC * &#x60;SD&#x60; - SD * &#x60;TN&#x60; - TN * &#x60;TX&#x60; - TX * &#x60;UT&#x60; - UT * &#x60;VT&#x60; - VT * &#x60;VI&#x60; - VI * &#x60;VA&#x60; - VA * &#x60;WA&#x60; - WA * &#x60;WI&#x60; - WI * &#x60;WV&#x60; - WV * &#x60;WY&#x60; - WY * &#x60;AA&#x60; - AA * &#x60;AE&#x60; - AE * &#x60;PW&#x60; - PW * &#x60;AP&#x60; - AP * &#x60;FM&#x60; - FM * &#x60;MH&#x60; - MH * &#x60;GU&#x60; - GU
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAvailabilities(endDatetime, startDatetime, appointmentType, companyId, designatedApptType, limit, medicalServiceId, memberId, oldestFirstIn, onlyActiveIn, onlyCancelledIn, onlyClinicalIn, onlyClosedIn, onlyFinishedIn, onlyIndividualIn, onlyNotCancelledIn, onlyScheduledIn, onlyVacantIn, onlyWaitingForApprovalIn, page, providerId, providerType, state, options) {
            return localVarFp.listAvailabilities(endDatetime, startDatetime, appointmentType, companyId, designatedApptType, limit, medicalServiceId, memberId, oldestFirstIn, onlyActiveIn, onlyCancelledIn, onlyClinicalIn, onlyClosedIn, onlyFinishedIn, onlyIndividualIn, onlyNotCancelledIn, onlyScheduledIn, onlyVacantIn, onlyWaitingForApprovalIn, page, providerId, providerType, state, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} endDatetime
         * @param {string} startDatetime
         * @param {'In Person' | 'Telemedicine'} [appointmentType] * &#x60;In Person&#x60; - In Person * &#x60;Telemedicine&#x60; - Telemedicine
         * @param {string} [companyId]
         * @param {'In Person' | 'Telemedicine'} [designatedApptType] * &#x60;In Person&#x60; - In Person * &#x60;Telemedicine&#x60; - Telemedicine
         * @param {number} [limit]
         * @param {string} [medicalServiceId]
         * @param {string} [memberId]
         * @param {boolean} [oldestFirstIn]
         * @param {boolean} [onlyActiveIn]
         * @param {boolean} [onlyCancelledIn]
         * @param {boolean} [onlyClinicalIn]
         * @param {boolean} [onlyClosedIn]
         * @param {boolean} [onlyFinishedIn]
         * @param {boolean} [onlyIndividualIn]
         * @param {boolean} [onlyNotCancelledIn]
         * @param {boolean} [onlyScheduledIn]
         * @param {boolean} [onlyVacantIn]
         * @param {boolean} [onlyWaitingForApprovalIn]
         * @param {number} [page]
         * @param {string} [providerId]
         * @param {'NursePractitioner' | 'RegisteredNurse' | 'ClinicalSocialWorker' | 'Phlebotomist'} [providerType] * &#x60;NursePractitioner&#x60; - NursePractitioner * &#x60;RegisteredNurse&#x60; - RegisteredNurse * &#x60;ClinicalSocialWorker&#x60; - ClinicalSocialWorker * &#x60;Phlebotomist&#x60; - Phlebotomist
         * @param {'AL' | 'AK' | 'AZ' | 'AR' | 'CA' | 'CO' | 'CT' | 'DC' | 'DE' | 'FL' | 'GA' | 'HI' | 'ID' | 'IL' | 'IN' | 'IA' | 'KS' | 'KY' | 'LA' | 'ME' | 'MD' | 'MA' | 'MI' | 'MN' | 'MS' | 'MO' | 'MT' | 'NE' | 'NV' | 'NH' | 'NJ' | 'NM' | 'NY' | 'NC' | 'ND' | 'OH' | 'OK' | 'OR' | 'PR' | 'PA' | 'RI' | 'SC' | 'SD' | 'TN' | 'TX' | 'UT' | 'VT' | 'VI' | 'VA' | 'WA' | 'WI' | 'WV' | 'WY' | 'AA' | 'AE' | 'PW' | 'AP' | 'FM' | 'MH' | 'GU'} [state] * &#x60;AL&#x60; - AL * &#x60;AK&#x60; - AK * &#x60;AZ&#x60; - AZ * &#x60;AR&#x60; - AR * &#x60;CA&#x60; - CA * &#x60;CO&#x60; - CO * &#x60;CT&#x60; - CT * &#x60;DC&#x60; - DC * &#x60;DE&#x60; - DE * &#x60;FL&#x60; - FL * &#x60;GA&#x60; - GA * &#x60;HI&#x60; - HI * &#x60;ID&#x60; - ID * &#x60;IL&#x60; - IL * &#x60;IN&#x60; - IN * &#x60;IA&#x60; - IA * &#x60;KS&#x60; - KS * &#x60;KY&#x60; - KY * &#x60;LA&#x60; - LA * &#x60;ME&#x60; - ME * &#x60;MD&#x60; - MD * &#x60;MA&#x60; - MA * &#x60;MI&#x60; - MI * &#x60;MN&#x60; - MN * &#x60;MS&#x60; - MS * &#x60;MO&#x60; - MO * &#x60;MT&#x60; - MT * &#x60;NE&#x60; - NE * &#x60;NV&#x60; - NV * &#x60;NH&#x60; - NH * &#x60;NJ&#x60; - NJ * &#x60;NM&#x60; - NM * &#x60;NY&#x60; - NY * &#x60;NC&#x60; - NC * &#x60;ND&#x60; - ND * &#x60;OH&#x60; - OH * &#x60;OK&#x60; - OK * &#x60;OR&#x60; - OR * &#x60;PR&#x60; - PR * &#x60;PA&#x60; - PA * &#x60;RI&#x60; - RI * &#x60;SC&#x60; - SC * &#x60;SD&#x60; - SD * &#x60;TN&#x60; - TN * &#x60;TX&#x60; - TX * &#x60;UT&#x60; - UT * &#x60;VT&#x60; - VT * &#x60;VI&#x60; - VI * &#x60;VA&#x60; - VA * &#x60;WA&#x60; - WA * &#x60;WI&#x60; - WI * &#x60;WV&#x60; - WV * &#x60;WY&#x60; - WY * &#x60;AA&#x60; - AA * &#x60;AE&#x60; - AE * &#x60;PW&#x60; - PW * &#x60;AP&#x60; - AP * &#x60;FM&#x60; - FM * &#x60;MH&#x60; - MH * &#x60;GU&#x60; - GU
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAvailabilitiesCalendar(endDatetime, startDatetime, appointmentType, companyId, designatedApptType, limit, medicalServiceId, memberId, oldestFirstIn, onlyActiveIn, onlyCancelledIn, onlyClinicalIn, onlyClosedIn, onlyFinishedIn, onlyIndividualIn, onlyNotCancelledIn, onlyScheduledIn, onlyVacantIn, onlyWaitingForApprovalIn, page, providerId, providerType, state, options) {
            return localVarFp.listAvailabilitiesCalendar(endDatetime, startDatetime, appointmentType, companyId, designatedApptType, limit, medicalServiceId, memberId, oldestFirstIn, onlyActiveIn, onlyCancelledIn, onlyClinicalIn, onlyClosedIn, onlyFinishedIn, onlyIndividualIn, onlyNotCancelledIn, onlyScheduledIn, onlyVacantIn, onlyWaitingForApprovalIn, page, providerId, providerType, state, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ListOptimalAvailabilitiesRequest} listOptimalAvailabilitiesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOptimalAvailabilities(listOptimalAvailabilitiesRequest, options) {
            return localVarFp.listOptimalAvailabilities(listOptimalAvailabilitiesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ListOptimalClinicAvailabilitiesRequest} listOptimalClinicAvailabilitiesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOptimalClinicAvailabilities(listOptimalClinicAvailabilitiesRequest, options) {
            return localVarFp.listOptimalClinicAvailabilities(listOptimalClinicAvailabilitiesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ListOptimalClinicRequestAvailabilitiesRequest} listOptimalClinicRequestAvailabilitiesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOptimalClinicRequestAvailabilities(listOptimalClinicRequestAvailabilitiesRequest, options) {
            return localVarFp.listOptimalClinicRequestAvailabilities(listOptimalClinicRequestAvailabilitiesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} appointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRescheduleAvailabilitiesForAppointment(appointmentId, options) {
            return localVarFp.listRescheduleAvailabilitiesForAppointment(appointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} providerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUpcomingSchedulableProviderAvailabilities(providerId, options) {
            return localVarFp.listUpcomingSchedulableProviderAvailabilities(providerId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} supportingAvailabilityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeSupportingAvailability(supportingAvailabilityId, options) {
            return localVarFp.removeSupportingAvailability(supportingAvailabilityId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} availabilityId
         * @param {UpdateAvailabilityBlockedStatusRequest} updateAvailabilityBlockedStatusRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAvailabilityBlockedStatus(availabilityId, updateAvailabilityBlockedStatusRequest, options) {
            return localVarFp.updateAvailabilityBlockedStatus(availabilityId, updateAvailabilityBlockedStatusRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AvailabilityApi - object-oriented interface
 * @export
 * @class AvailabilityApi
 * @extends {BaseAPI}
 */
class AvailabilityApi extends base_1.BaseAPI {
    /**
     *
     * @param {AvailabilityApiAddSupportingAvailabilityToAppointmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AvailabilityApi
     */
    addSupportingAvailabilityToAppointment(requestParameters, options) {
        return exports.AvailabilityApiFp(this.configuration).addSupportingAvailabilityToAppointment(requestParameters.appointmentId, requestParameters.addSupportingAvailabilityToAppointmentRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AvailabilityApiAddSupportingAvailabilityToClinicAppointmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AvailabilityApi
     */
    addSupportingAvailabilityToClinicAppointment(requestParameters, options) {
        return exports.AvailabilityApiFp(this.configuration).addSupportingAvailabilityToClinicAppointment(requestParameters.clinicAppointmentId, requestParameters.addSupportingAvailabilityToClinicAppointmentRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AvailabilityApiCreateAvailabilitiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AvailabilityApi
     */
    createAvailabilities(requestParameters, options) {
        return exports.AvailabilityApiFp(this.configuration).createAvailabilities(requestParameters.createAvailabilitiesRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AvailabilityApiDeleteAvailabilityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AvailabilityApi
     */
    deleteAvailability(requestParameters, options) {
        return exports.AvailabilityApiFp(this.configuration).deleteAvailability(requestParameters.availabilityId, requestParameters.providerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AvailabilityApiListAvailabilitiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AvailabilityApi
     */
    listAvailabilities(requestParameters, options) {
        return exports.AvailabilityApiFp(this.configuration).listAvailabilities(requestParameters.endDatetime, requestParameters.startDatetime, requestParameters.appointmentType, requestParameters.companyId, requestParameters.designatedApptType, requestParameters.limit, requestParameters.medicalServiceId, requestParameters.memberId, requestParameters.oldestFirstIn, requestParameters.onlyActiveIn, requestParameters.onlyCancelledIn, requestParameters.onlyClinicalIn, requestParameters.onlyClosedIn, requestParameters.onlyFinishedIn, requestParameters.onlyIndividualIn, requestParameters.onlyNotCancelledIn, requestParameters.onlyScheduledIn, requestParameters.onlyVacantIn, requestParameters.onlyWaitingForApprovalIn, requestParameters.page, requestParameters.providerId, requestParameters.providerType, requestParameters.state, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AvailabilityApiListAvailabilitiesCalendarRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AvailabilityApi
     */
    listAvailabilitiesCalendar(requestParameters, options) {
        return exports.AvailabilityApiFp(this.configuration).listAvailabilitiesCalendar(requestParameters.endDatetime, requestParameters.startDatetime, requestParameters.appointmentType, requestParameters.companyId, requestParameters.designatedApptType, requestParameters.limit, requestParameters.medicalServiceId, requestParameters.memberId, requestParameters.oldestFirstIn, requestParameters.onlyActiveIn, requestParameters.onlyCancelledIn, requestParameters.onlyClinicalIn, requestParameters.onlyClosedIn, requestParameters.onlyFinishedIn, requestParameters.onlyIndividualIn, requestParameters.onlyNotCancelledIn, requestParameters.onlyScheduledIn, requestParameters.onlyVacantIn, requestParameters.onlyWaitingForApprovalIn, requestParameters.page, requestParameters.providerId, requestParameters.providerType, requestParameters.state, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AvailabilityApiListOptimalAvailabilitiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AvailabilityApi
     */
    listOptimalAvailabilities(requestParameters, options) {
        return exports.AvailabilityApiFp(this.configuration).listOptimalAvailabilities(requestParameters.listOptimalAvailabilitiesRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AvailabilityApiListOptimalClinicAvailabilitiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AvailabilityApi
     */
    listOptimalClinicAvailabilities(requestParameters, options) {
        return exports.AvailabilityApiFp(this.configuration).listOptimalClinicAvailabilities(requestParameters.listOptimalClinicAvailabilitiesRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AvailabilityApiListOptimalClinicRequestAvailabilitiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AvailabilityApi
     */
    listOptimalClinicRequestAvailabilities(requestParameters, options) {
        return exports.AvailabilityApiFp(this.configuration).listOptimalClinicRequestAvailabilities(requestParameters.listOptimalClinicRequestAvailabilitiesRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AvailabilityApiListRescheduleAvailabilitiesForAppointmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AvailabilityApi
     */
    listRescheduleAvailabilitiesForAppointment(requestParameters, options) {
        return exports.AvailabilityApiFp(this.configuration).listRescheduleAvailabilitiesForAppointment(requestParameters.appointmentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AvailabilityApiListUpcomingSchedulableProviderAvailabilitiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AvailabilityApi
     */
    listUpcomingSchedulableProviderAvailabilities(requestParameters, options) {
        return exports.AvailabilityApiFp(this.configuration).listUpcomingSchedulableProviderAvailabilities(requestParameters.providerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AvailabilityApiRemoveSupportingAvailabilityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AvailabilityApi
     */
    removeSupportingAvailability(requestParameters, options) {
        return exports.AvailabilityApiFp(this.configuration).removeSupportingAvailability(requestParameters.supportingAvailabilityId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AvailabilityApiUpdateAvailabilityBlockedStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AvailabilityApi
     */
    updateAvailabilityBlockedStatus(requestParameters, options) {
        return exports.AvailabilityApiFp(this.configuration).updateAvailabilityBlockedStatus(requestParameters.availabilityId, requestParameters.updateAvailabilityBlockedStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AvailabilityApi = AvailabilityApi;
/**
 * BatchApi - axios parameter creator
 * @export
 */
exports.BatchApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchSyncAllergiesAndMedications: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/batch/ayva/batch-sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchSyncPharmacyCards: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/batch/pharmacy-cards/batch-sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {OHREmailBatchRequestRequest} [oHREmailBatchRequestRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailNotifyForNewlyCreatedOhrs: (oHREmailBatchRequestRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/batch/occupation-health-records/newly-created`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(oHREmailBatchRequestRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOffTrackAppointments: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/batch/appointments/off_track`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantBenefitEligibilitiesForActivePolicies: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/batch/benefits/policy-sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantEnrollmentsToEligibleEmployees: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/batch/benefits/eligible-employee-enrollment-granting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportCompanyBenefitBillDataToChargebee: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/batch/billing/company-benefits/chargebee-bill-reporting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendBenefitEnrollmentMissedEvents: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/batch/crm/send-enrollment-missed-events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendUnchartedAppointmentReminders: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/batch/appointments/uncharted`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendUpcomingAppointmentReminders: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/batch/appointments/confirmations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncAllActiveEmployeeManagementIntegrations: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/batch/emis-sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncCompaniesFromChargebee: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/batch/billing/companies-sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncCustomerIoContacts: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/batch/crm/update-contacts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncDataToBenefitCarriers: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/batch/benefits/carrier-sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * BatchApi - functional programming interface
 * @export
 */
exports.BatchApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.BatchApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchSyncAllergiesAndMedications(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.batchSyncAllergiesAndMedications(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchSyncPharmacyCards(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.batchSyncPharmacyCards(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {OHREmailBatchRequestRequest} [oHREmailBatchRequestRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailNotifyForNewlyCreatedOhrs(oHREmailBatchRequestRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.emailNotifyForNewlyCreatedOhrs(oHREmailBatchRequestRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOffTrackAppointments(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.findOffTrackAppointments(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantBenefitEligibilitiesForActivePolicies(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.grantBenefitEligibilitiesForActivePolicies(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantEnrollmentsToEligibleEmployees(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.grantEnrollmentsToEligibleEmployees(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportCompanyBenefitBillDataToChargebee(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportCompanyBenefitBillDataToChargebee(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendBenefitEnrollmentMissedEvents(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sendBenefitEnrollmentMissedEvents(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendUnchartedAppointmentReminders(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sendUnchartedAppointmentReminders(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendUpcomingAppointmentReminders(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sendUpcomingAppointmentReminders(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncAllActiveEmployeeManagementIntegrations(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.syncAllActiveEmployeeManagementIntegrations(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncCompaniesFromChargebee(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.syncCompaniesFromChargebee(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncCustomerIoContacts(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.syncCustomerIoContacts(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncDataToBenefitCarriers(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.syncDataToBenefitCarriers(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * BatchApi - factory interface
 * @export
 */
exports.BatchApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.BatchApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchSyncAllergiesAndMedications(options) {
            return localVarFp.batchSyncAllergiesAndMedications(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchSyncPharmacyCards(options) {
            return localVarFp.batchSyncPharmacyCards(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {OHREmailBatchRequestRequest} [oHREmailBatchRequestRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailNotifyForNewlyCreatedOhrs(oHREmailBatchRequestRequest, options) {
            return localVarFp.emailNotifyForNewlyCreatedOhrs(oHREmailBatchRequestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOffTrackAppointments(options) {
            return localVarFp.findOffTrackAppointments(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantBenefitEligibilitiesForActivePolicies(options) {
            return localVarFp.grantBenefitEligibilitiesForActivePolicies(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantEnrollmentsToEligibleEmployees(options) {
            return localVarFp.grantEnrollmentsToEligibleEmployees(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportCompanyBenefitBillDataToChargebee(options) {
            return localVarFp.reportCompanyBenefitBillDataToChargebee(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendBenefitEnrollmentMissedEvents(options) {
            return localVarFp.sendBenefitEnrollmentMissedEvents(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendUnchartedAppointmentReminders(options) {
            return localVarFp.sendUnchartedAppointmentReminders(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendUpcomingAppointmentReminders(options) {
            return localVarFp.sendUpcomingAppointmentReminders(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncAllActiveEmployeeManagementIntegrations(options) {
            return localVarFp.syncAllActiveEmployeeManagementIntegrations(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncCompaniesFromChargebee(options) {
            return localVarFp.syncCompaniesFromChargebee(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncCustomerIoContacts(options) {
            return localVarFp.syncCustomerIoContacts(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncDataToBenefitCarriers(options) {
            return localVarFp.syncDataToBenefitCarriers(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * BatchApi - object-oriented interface
 * @export
 * @class BatchApi
 * @extends {BaseAPI}
 */
class BatchApi extends base_1.BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BatchApi
     */
    batchSyncAllergiesAndMedications(options) {
        return exports.BatchApiFp(this.configuration).batchSyncAllergiesAndMedications(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BatchApi
     */
    batchSyncPharmacyCards(options) {
        return exports.BatchApiFp(this.configuration).batchSyncPharmacyCards(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BatchApiEmailNotifyForNewlyCreatedOhrsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BatchApi
     */
    emailNotifyForNewlyCreatedOhrs(requestParameters = {}, options) {
        return exports.BatchApiFp(this.configuration).emailNotifyForNewlyCreatedOhrs(requestParameters.oHREmailBatchRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BatchApi
     */
    findOffTrackAppointments(options) {
        return exports.BatchApiFp(this.configuration).findOffTrackAppointments(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BatchApi
     */
    grantBenefitEligibilitiesForActivePolicies(options) {
        return exports.BatchApiFp(this.configuration).grantBenefitEligibilitiesForActivePolicies(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BatchApi
     */
    grantEnrollmentsToEligibleEmployees(options) {
        return exports.BatchApiFp(this.configuration).grantEnrollmentsToEligibleEmployees(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BatchApi
     */
    reportCompanyBenefitBillDataToChargebee(options) {
        return exports.BatchApiFp(this.configuration).reportCompanyBenefitBillDataToChargebee(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BatchApi
     */
    sendBenefitEnrollmentMissedEvents(options) {
        return exports.BatchApiFp(this.configuration).sendBenefitEnrollmentMissedEvents(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BatchApi
     */
    sendUnchartedAppointmentReminders(options) {
        return exports.BatchApiFp(this.configuration).sendUnchartedAppointmentReminders(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BatchApi
     */
    sendUpcomingAppointmentReminders(options) {
        return exports.BatchApiFp(this.configuration).sendUpcomingAppointmentReminders(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BatchApi
     */
    syncAllActiveEmployeeManagementIntegrations(options) {
        return exports.BatchApiFp(this.configuration).syncAllActiveEmployeeManagementIntegrations(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BatchApi
     */
    syncCompaniesFromChargebee(options) {
        return exports.BatchApiFp(this.configuration).syncCompaniesFromChargebee(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BatchApi
     */
    syncCustomerIoContacts(options) {
        return exports.BatchApiFp(this.configuration).syncCustomerIoContacts(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BatchApi
     */
    syncDataToBenefitCarriers(options) {
        return exports.BatchApiFp(this.configuration).syncDataToBenefitCarriers(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.BatchApi = BatchApi;
/**
 * BenefitsApi - axios parameter creator
 * @export
 */
exports.BenefitsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} companyBenefitId
         * @param {BulkReissueCompanyBenefitEnrollmentsRequest} [bulkReissueCompanyBenefitEnrollmentsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkReissueCompanyBenefitEnrollments: (companyBenefitId, bulkReissueCompanyBenefitEnrollmentsRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyBenefitId' is not null or undefined
            common_1.assertParamExists('bulkReissueCompanyBenefitEnrollments', 'companyBenefitId', companyBenefitId);
            const localVarPath = `/v1/company-benefits/{company_benefit_id}/bulk-reissue`
                .replace(`{${"company_benefit_id"}}`, encodeURIComponent(String(companyBenefitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(bulkReissueCompanyBenefitEnrollmentsRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} companyBenefitId
         * @param {ConfigureCompanyBenefitRequest} configureCompanyBenefitRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configureCompanyBenefit: (companyBenefitId, configureCompanyBenefitRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyBenefitId' is not null or undefined
            common_1.assertParamExists('configureCompanyBenefit', 'companyBenefitId', companyBenefitId);
            // verify required parameter 'configureCompanyBenefitRequest' is not null or undefined
            common_1.assertParamExists('configureCompanyBenefit', 'configureCompanyBenefitRequest', configureCompanyBenefitRequest);
            const localVarPath = `/v1/company-benefits/{company_benefit_id}/configure`
                .replace(`{${"company_benefit_id"}}`, encodeURIComponent(String(companyBenefitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(configureCompanyBenefitRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} companyId
         * @param {CreateEmployeeBenefitEligibilityPolicyRequest} createEmployeeBenefitEligibilityPolicyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmployeeBenefitEligibilityPolicy: (companyId, createEmployeeBenefitEligibilityPolicyRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyId' is not null or undefined
            common_1.assertParamExists('createEmployeeBenefitEligibilityPolicy', 'companyId', companyId);
            // verify required parameter 'createEmployeeBenefitEligibilityPolicyRequest' is not null or undefined
            common_1.assertParamExists('createEmployeeBenefitEligibilityPolicy', 'createEmployeeBenefitEligibilityPolicyRequest', createEmployeeBenefitEligibilityPolicyRequest);
            const localVarPath = `/v1/companies/{company_id}/benefit-eligibility-policies`
                .replace(`{${"company_id"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createEmployeeBenefitEligibilityPolicyRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {EnrollIntoCompanyBenefitRequest} enrollIntoCompanyBenefitRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollIntoCompanyBenefit: (enrollIntoCompanyBenefitRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'enrollIntoCompanyBenefitRequest' is not null or undefined
            common_1.assertParamExists('enrollIntoCompanyBenefit', 'enrollIntoCompanyBenefitRequest', enrollIntoCompanyBenefitRequest);
            const localVarPath = `/v1/company-benefit-enrollments/enroll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(enrollIntoCompanyBenefitRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveEmployeeBenefitEligibilityPolicy: (companyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyId' is not null or undefined
            common_1.assertParamExists('getActiveEmployeeBenefitEligibilityPolicy', 'companyId', companyId);
            const localVarPath = `/v1/companies/{company_id}/benefit-eligibility-policies`
                .replace(`{${"company_id"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} companyBenefitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyBenefit: (companyBenefitId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyBenefitId' is not null or undefined
            common_1.assertParamExists('getCompanyBenefit', 'companyBenefitId', companyBenefitId);
            const localVarPath = `/v1/company-benefits/{company_benefit_id}`
                .replace(`{${"company_benefit_id"}}`, encodeURIComponent(String(companyBenefitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} billingPeriodStartDate
         * @param {string} companyBenefitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayrollDeductionTotalForCompanyBenefit: (billingPeriodStartDate, companyBenefitId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'billingPeriodStartDate' is not null or undefined
            common_1.assertParamExists('getPayrollDeductionTotalForCompanyBenefit', 'billingPeriodStartDate', billingPeriodStartDate);
            // verify required parameter 'companyBenefitId' is not null or undefined
            common_1.assertParamExists('getPayrollDeductionTotalForCompanyBenefit', 'companyBenefitId', companyBenefitId);
            const localVarPath = `/v1/company-benefits/{company_benefit_id}/metrics/payroll-deduction-total`
                .replace(`{${"company_benefit_id"}}`, encodeURIComponent(String(companyBenefitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (billingPeriodStartDate !== undefined) {
                localVarQueryParameter['billing_period_start_date'] = (billingPeriodStartDate instanceof Date) ?
                    billingPeriodStartDate.toISOString().substr(0, 10) :
                    billingPeriodStartDate;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {GrantBenefitEligibilityToEmployeeRequest} grantBenefitEligibilityToEmployeeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantBenefitEligibilityToEmployee: (grantBenefitEligibilityToEmployeeRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'grantBenefitEligibilityToEmployeeRequest' is not null or undefined
            common_1.assertParamExists('grantBenefitEligibilityToEmployee', 'grantBenefitEligibilityToEmployeeRequest', grantBenefitEligibilityToEmployeeRequest);
            const localVarPath = `/v1/benefits/grant-eligibility`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(grantBenefitEligibilityToEmployeeRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActiveBenefitEnrollmentsForMember: (memberId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'memberId' is not null or undefined
            common_1.assertParamExists('listActiveBenefitEnrollmentsForMember', 'memberId', memberId);
            const localVarPath = `/v1/members/{member_id}/benefits`
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActiveCompanyBenefits: (companyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyId' is not null or undefined
            common_1.assertParamExists('listActiveCompanyBenefits', 'companyId', companyId);
            const localVarPath = `/v1/companies/{company_id}/benefits`
                .replace(`{${"company_id"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActiveDigitalBenefitCardsForMember: (memberId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'memberId' is not null or undefined
            common_1.assertParamExists('listActiveDigitalBenefitCardsForMember', 'memberId', memberId);
            const localVarPath = `/v1/members/{member_id}/digital-benefit-cards`
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} companyBenefitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBenefitPlansOfferedByCompanyBenefit: (companyBenefitId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyBenefitId' is not null or undefined
            common_1.assertParamExists('listBenefitPlansOfferedByCompanyBenefit', 'companyBenefitId', companyBenefitId);
            const localVarPath = `/v1/company-benefits/{company_benefit_id}/plans`
                .replace(`{${"company_benefit_id"}}`, encodeURIComponent(String(companyBenefitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} companyBenefitId
         * @param {string} [answeredOnGt]
         * @param {string} [answeredOnLt]
         * @param {number} [employeeCostGt]
         * @param {string} [employeeName]
         * @param {boolean} [includeTerminatedIn]
         * @param {number} [limit]
         * @param {string} [memberId]
         * @param {boolean} [openForEnrollmentIn]
         * @param {number} [page]
         * @param {string} [sort]
         * @param {'Unanswered' | 'Enrolled' | 'Waived'} [status] * &#x60;Unanswered&#x60; - Unanswered * &#x60;Enrolled&#x60; - Enrolled * &#x60;Waived&#x60; - Waived
         * @param {string} [terminatedOnGt]
         * @param {string} [terminatedOnLt]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompanyBenefitEnrollments: (companyBenefitId, answeredOnGt, answeredOnLt, employeeCostGt, employeeName, includeTerminatedIn, limit, memberId, openForEnrollmentIn, page, sort, status, terminatedOnGt, terminatedOnLt, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyBenefitId' is not null or undefined
            common_1.assertParamExists('listCompanyBenefitEnrollments', 'companyBenefitId', companyBenefitId);
            const localVarPath = `/v1/company-benefits/{company_benefit_id}/enrollments`
                .replace(`{${"company_benefit_id"}}`, encodeURIComponent(String(companyBenefitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (answeredOnGt !== undefined) {
                localVarQueryParameter['answered_on_gt'] = (answeredOnGt instanceof Date) ?
                    answeredOnGt.toISOString().substr(0, 10) :
                    answeredOnGt;
            }
            if (answeredOnLt !== undefined) {
                localVarQueryParameter['answered_on_lt'] = (answeredOnLt instanceof Date) ?
                    answeredOnLt.toISOString().substr(0, 10) :
                    answeredOnLt;
            }
            if (employeeCostGt !== undefined) {
                localVarQueryParameter['employee_cost_gt'] = employeeCostGt;
            }
            if (employeeName !== undefined) {
                localVarQueryParameter['employee_name'] = employeeName;
            }
            if (includeTerminatedIn !== undefined) {
                localVarQueryParameter['include_terminated_in'] = includeTerminatedIn;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (memberId !== undefined) {
                localVarQueryParameter['member_id'] = memberId;
            }
            if (openForEnrollmentIn !== undefined) {
                localVarQueryParameter['open_for_enrollment_in'] = openForEnrollmentIn;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (terminatedOnGt !== undefined) {
                localVarQueryParameter['terminated_on_gt'] = (terminatedOnGt instanceof Date) ?
                    terminatedOnGt.toISOString().substr(0, 10) :
                    terminatedOnGt;
            }
            if (terminatedOnLt !== undefined) {
                localVarQueryParameter['terminated_on_lt'] = (terminatedOnLt instanceof Date) ?
                    terminatedOnLt.toISOString().substr(0, 10) :
                    terminatedOnLt;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} companyBenefitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompanyBenefitPlanTierCosts: (companyBenefitId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyBenefitId' is not null or undefined
            common_1.assertParamExists('listCompanyBenefitPlanTierCosts', 'companyBenefitId', companyBenefitId);
            const localVarPath = `/v1/company-benefits/{company_benefit_id}/tier-costs`
                .replace(`{${"company_benefit_id"}}`, encodeURIComponent(String(companyBenefitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} companyId
         * @param {string} [createdGte]
         * @param {string} [employeeName]
         * @param {number} [limit]
         * @param {number} [page]
         * @param {boolean} [terminatedIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEmployeeBenefitEligibilities: (companyId, createdGte, employeeName, limit, page, terminatedIn, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyId' is not null or undefined
            common_1.assertParamExists('listEmployeeBenefitEligibilities', 'companyId', companyId);
            const localVarPath = `/v1/companies/{company_id}/benefit-eligibilities`
                .replace(`{${"company_id"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (createdGte !== undefined) {
                localVarQueryParameter['created_gte'] = (createdGte instanceof Date) ?
                    createdGte.toISOString().substr(0, 10) :
                    createdGte;
            }
            if (employeeName !== undefined) {
                localVarQueryParameter['employee_name'] = employeeName;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (terminatedIn !== undefined) {
                localVarQueryParameter['terminated_in'] = terminatedIn;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOpenCompanyBenefitEnrollmentsForMember: (memberId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'memberId' is not null or undefined
            common_1.assertParamExists('listOpenCompanyBenefitEnrollmentsForMember', 'memberId', memberId);
            const localVarPath = `/v1/members/{member_id}/open-enrollment-benefits`
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPendingCompanyBenefitEnrollmentsForMember: (memberId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'memberId' is not null or undefined
            common_1.assertParamExists('listPendingCompanyBenefitEnrollmentsForMember', 'memberId', memberId);
            const localVarPath = `/v1/members/{member_id}/pending-company-benefit-enrollments`
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUpcomingCompanyBenefits: (companyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyId' is not null or undefined
            common_1.assertParamExists('listUpcomingCompanyBenefits', 'companyId', companyId);
            const localVarPath = `/v1/companies/{company_id}/benefits/upcoming`
                .replace(`{${"company_id"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} companyBenefitEnrollmentId
         * @param {ProvideEnrollReasonRequest} provideEnrollReasonRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        provideEnrollReason: (companyBenefitEnrollmentId, provideEnrollReasonRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyBenefitEnrollmentId' is not null or undefined
            common_1.assertParamExists('provideEnrollReason', 'companyBenefitEnrollmentId', companyBenefitEnrollmentId);
            // verify required parameter 'provideEnrollReasonRequest' is not null or undefined
            common_1.assertParamExists('provideEnrollReason', 'provideEnrollReasonRequest', provideEnrollReasonRequest);
            const localVarPath = `/v1/company-benefit-enrollments/{company_benefit_enrollment_id}/enroll-reason`
                .replace(`{${"company_benefit_enrollment_id"}}`, encodeURIComponent(String(companyBenefitEnrollmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(provideEnrollReasonRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} companyBenefitEnrollmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reissueCompanyBenefitEnrollment: (companyBenefitEnrollmentId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyBenefitEnrollmentId' is not null or undefined
            common_1.assertParamExists('reissueCompanyBenefitEnrollment', 'companyBenefitEnrollmentId', companyBenefitEnrollmentId);
            const localVarPath = `/v1/company-benefit-enrollments/{company_benefit_enrollment_id}/reissue`
                .replace(`{${"company_benefit_enrollment_id"}}`, encodeURIComponent(String(companyBenefitEnrollmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [companyBenefitEnrollmentId]
         * @param {number} [limit]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCompanyBenefitEnrollmentForDependents: (companyBenefitEnrollmentId, limit, page, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/company-benefit-enrollment-for-dependents/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (companyBenefitEnrollmentId !== undefined) {
                localVarQueryParameter['company_benefit_enrollment_id'] = companyBenefitEnrollmentId;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {'Unanswered' | 'Enrolled' | 'Waived'} [answerStatus] * &#x60;Unanswered&#x60; - Unanswered * &#x60;Enrolled&#x60; - Enrolled * &#x60;Waived&#x60; - Waived
         * @param {string} [answeredOnGt]
         * @param {string} [answeredOnLt]
         * @param {string} [companyBenefitId]
         * @param {string} [companyMemberId]
         * @param {number} [employeeCostGt]
         * @param {string} [employeeName]
         * @param {number} [limit]
         * @param {string} [memberId]
         * @param {boolean} [openForEnrollmentIn]
         * @param {number} [page]
         * @param {string} [sort]
         * @param {boolean} [terminatedIn]
         * @param {string} [terminatedOnGt]
         * @param {string} [terminatedOnLt]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCompanyBenefitEnrollments: (answerStatus, answeredOnGt, answeredOnLt, companyBenefitId, companyMemberId, employeeCostGt, employeeName, limit, memberId, openForEnrollmentIn, page, sort, terminatedIn, terminatedOnGt, terminatedOnLt, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/company-benefits-enrollments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (answerStatus !== undefined) {
                localVarQueryParameter['answer_status'] = answerStatus;
            }
            if (answeredOnGt !== undefined) {
                localVarQueryParameter['answered_on_gt'] = (answeredOnGt instanceof Date) ?
                    answeredOnGt.toISOString().substr(0, 10) :
                    answeredOnGt;
            }
            if (answeredOnLt !== undefined) {
                localVarQueryParameter['answered_on_lt'] = (answeredOnLt instanceof Date) ?
                    answeredOnLt.toISOString().substr(0, 10) :
                    answeredOnLt;
            }
            if (companyBenefitId !== undefined) {
                localVarQueryParameter['company_benefit_id'] = companyBenefitId;
            }
            if (companyMemberId !== undefined) {
                localVarQueryParameter['company_member_id'] = companyMemberId;
            }
            if (employeeCostGt !== undefined) {
                localVarQueryParameter['employee_cost_gt'] = employeeCostGt;
            }
            if (employeeName !== undefined) {
                localVarQueryParameter['employee_name'] = employeeName;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (memberId !== undefined) {
                localVarQueryParameter['member_id'] = memberId;
            }
            if (openForEnrollmentIn !== undefined) {
                localVarQueryParameter['open_for_enrollment_in'] = openForEnrollmentIn;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (terminatedIn !== undefined) {
                localVarQueryParameter['terminated_in'] = terminatedIn;
            }
            if (terminatedOnGt !== undefined) {
                localVarQueryParameter['terminated_on_gt'] = (terminatedOnGt instanceof Date) ?
                    terminatedOnGt.toISOString().substr(0, 10) :
                    terminatedOnGt;
            }
            if (terminatedOnLt !== undefined) {
                localVarQueryParameter['terminated_on_lt'] = (terminatedOnLt instanceof Date) ?
                    terminatedOnLt.toISOString().substr(0, 10) :
                    terminatedOnLt;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} companyId
         * @param {boolean} [activeIn]
         * @param {boolean} [configuredIn]
         * @param {boolean} [nonExpiredCoverageAndSubscriptionIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCompanyBenefits: (companyId, activeIn, configuredIn, nonExpiredCoverageAndSubscriptionIn, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyId' is not null or undefined
            common_1.assertParamExists('searchCompanyBenefits', 'companyId', companyId);
            const localVarPath = `/v1/companies/{company_id}/company-benefits`
                .replace(`{${"company_id"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (activeIn !== undefined) {
                localVarQueryParameter['active_in'] = activeIn;
            }
            if (configuredIn !== undefined) {
                localVarQueryParameter['configured_in'] = configuredIn;
            }
            if (nonExpiredCoverageAndSubscriptionIn !== undefined) {
                localVarQueryParameter['non_expired_coverage_and_subscription_in'] = nonExpiredCoverageAndSubscriptionIn;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} companyBenefitId
         * @param {SignOffOnCompanyBenefitRequest} signOffOnCompanyBenefitRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signOffOnCompanyBenefit: (companyBenefitId, signOffOnCompanyBenefitRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyBenefitId' is not null or undefined
            common_1.assertParamExists('signOffOnCompanyBenefit', 'companyBenefitId', companyBenefitId);
            // verify required parameter 'signOffOnCompanyBenefitRequest' is not null or undefined
            common_1.assertParamExists('signOffOnCompanyBenefit', 'signOffOnCompanyBenefitRequest', signOffOnCompanyBenefitRequest);
            const localVarPath = `/v1/company-benefits/{company_benefit_id}/sign-off`
                .replace(`{${"company_benefit_id"}}`, encodeURIComponent(String(companyBenefitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(signOffOnCompanyBenefitRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startCompanyBenefitEnrollments: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/company-benefit-enrollments/start`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} companyBenefitEnrollmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terminateCompanyBenefitEnrollment: (companyBenefitEnrollmentId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyBenefitEnrollmentId' is not null or undefined
            common_1.assertParamExists('terminateCompanyBenefitEnrollment', 'companyBenefitEnrollmentId', companyBenefitEnrollmentId);
            const localVarPath = `/v1/company-benefit-enrollments/{company_benefit_enrollment_id}/terminate`
                .replace(`{${"company_benefit_enrollment_id"}}`, encodeURIComponent(String(companyBenefitEnrollmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} companyBenefitEnrollmentForDependentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terminateCompanyBenefitEnrollmentForDependent: (companyBenefitEnrollmentForDependentId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyBenefitEnrollmentForDependentId' is not null or undefined
            common_1.assertParamExists('terminateCompanyBenefitEnrollmentForDependent', 'companyBenefitEnrollmentForDependentId', companyBenefitEnrollmentForDependentId);
            const localVarPath = `/v1/company-benefit-enrollment-for-dependents/{company_benefit_enrollment_for_dependent_id}/terminate`
                .replace(`{${"company_benefit_enrollment_for_dependent_id"}}`, encodeURIComponent(String(companyBenefitEnrollmentForDependentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {TerminateEmployeeBenefitEligibilityRequest} terminateEmployeeBenefitEligibilityRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terminateEmployeeBenefitEligibility: (terminateEmployeeBenefitEligibilityRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'terminateEmployeeBenefitEligibilityRequest' is not null or undefined
            common_1.assertParamExists('terminateEmployeeBenefitEligibility', 'terminateEmployeeBenefitEligibilityRequest', terminateEmployeeBenefitEligibilityRequest);
            const localVarPath = `/v1/benefits/terminate-eligibility`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(terminateEmployeeBenefitEligibilityRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} companyBenefitEnrollmentId
         * @param {WaiveCompanyBenefitRequest} waiveCompanyBenefitRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        waiveCompanyBenefit: (companyBenefitEnrollmentId, waiveCompanyBenefitRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyBenefitEnrollmentId' is not null or undefined
            common_1.assertParamExists('waiveCompanyBenefit', 'companyBenefitEnrollmentId', companyBenefitEnrollmentId);
            // verify required parameter 'waiveCompanyBenefitRequest' is not null or undefined
            common_1.assertParamExists('waiveCompanyBenefit', 'waiveCompanyBenefitRequest', waiveCompanyBenefitRequest);
            const localVarPath = `/v1/company-benefit-enrollments/{company_benefit_enrollment_id}/waive`
                .replace(`{${"company_benefit_enrollment_id"}}`, encodeURIComponent(String(companyBenefitEnrollmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(waiveCompanyBenefitRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * BenefitsApi - functional programming interface
 * @export
 */
exports.BenefitsApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.BenefitsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} companyBenefitId
         * @param {BulkReissueCompanyBenefitEnrollmentsRequest} [bulkReissueCompanyBenefitEnrollmentsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkReissueCompanyBenefitEnrollments(companyBenefitId, bulkReissueCompanyBenefitEnrollmentsRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.bulkReissueCompanyBenefitEnrollments(companyBenefitId, bulkReissueCompanyBenefitEnrollmentsRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} companyBenefitId
         * @param {ConfigureCompanyBenefitRequest} configureCompanyBenefitRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configureCompanyBenefit(companyBenefitId, configureCompanyBenefitRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.configureCompanyBenefit(companyBenefitId, configureCompanyBenefitRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} companyId
         * @param {CreateEmployeeBenefitEligibilityPolicyRequest} createEmployeeBenefitEligibilityPolicyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmployeeBenefitEligibilityPolicy(companyId, createEmployeeBenefitEligibilityPolicyRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createEmployeeBenefitEligibilityPolicy(companyId, createEmployeeBenefitEligibilityPolicyRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {EnrollIntoCompanyBenefitRequest} enrollIntoCompanyBenefitRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollIntoCompanyBenefit(enrollIntoCompanyBenefitRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.enrollIntoCompanyBenefit(enrollIntoCompanyBenefitRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveEmployeeBenefitEligibilityPolicy(companyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getActiveEmployeeBenefitEligibilityPolicy(companyId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} companyBenefitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyBenefit(companyBenefitId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCompanyBenefit(companyBenefitId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} billingPeriodStartDate
         * @param {string} companyBenefitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayrollDeductionTotalForCompanyBenefit(billingPeriodStartDate, companyBenefitId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPayrollDeductionTotalForCompanyBenefit(billingPeriodStartDate, companyBenefitId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {GrantBenefitEligibilityToEmployeeRequest} grantBenefitEligibilityToEmployeeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantBenefitEligibilityToEmployee(grantBenefitEligibilityToEmployeeRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.grantBenefitEligibilityToEmployee(grantBenefitEligibilityToEmployeeRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActiveBenefitEnrollmentsForMember(memberId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listActiveBenefitEnrollmentsForMember(memberId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActiveCompanyBenefits(companyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listActiveCompanyBenefits(companyId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActiveDigitalBenefitCardsForMember(memberId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listActiveDigitalBenefitCardsForMember(memberId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} companyBenefitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBenefitPlansOfferedByCompanyBenefit(companyBenefitId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listBenefitPlansOfferedByCompanyBenefit(companyBenefitId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} companyBenefitId
         * @param {string} [answeredOnGt]
         * @param {string} [answeredOnLt]
         * @param {number} [employeeCostGt]
         * @param {string} [employeeName]
         * @param {boolean} [includeTerminatedIn]
         * @param {number} [limit]
         * @param {string} [memberId]
         * @param {boolean} [openForEnrollmentIn]
         * @param {number} [page]
         * @param {string} [sort]
         * @param {'Unanswered' | 'Enrolled' | 'Waived'} [status] * &#x60;Unanswered&#x60; - Unanswered * &#x60;Enrolled&#x60; - Enrolled * &#x60;Waived&#x60; - Waived
         * @param {string} [terminatedOnGt]
         * @param {string} [terminatedOnLt]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompanyBenefitEnrollments(companyBenefitId, answeredOnGt, answeredOnLt, employeeCostGt, employeeName, includeTerminatedIn, limit, memberId, openForEnrollmentIn, page, sort, status, terminatedOnGt, terminatedOnLt, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listCompanyBenefitEnrollments(companyBenefitId, answeredOnGt, answeredOnLt, employeeCostGt, employeeName, includeTerminatedIn, limit, memberId, openForEnrollmentIn, page, sort, status, terminatedOnGt, terminatedOnLt, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} companyBenefitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompanyBenefitPlanTierCosts(companyBenefitId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listCompanyBenefitPlanTierCosts(companyBenefitId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} companyId
         * @param {string} [createdGte]
         * @param {string} [employeeName]
         * @param {number} [limit]
         * @param {number} [page]
         * @param {boolean} [terminatedIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEmployeeBenefitEligibilities(companyId, createdGte, employeeName, limit, page, terminatedIn, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listEmployeeBenefitEligibilities(companyId, createdGte, employeeName, limit, page, terminatedIn, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOpenCompanyBenefitEnrollmentsForMember(memberId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listOpenCompanyBenefitEnrollmentsForMember(memberId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPendingCompanyBenefitEnrollmentsForMember(memberId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listPendingCompanyBenefitEnrollmentsForMember(memberId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUpcomingCompanyBenefits(companyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listUpcomingCompanyBenefits(companyId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} companyBenefitEnrollmentId
         * @param {ProvideEnrollReasonRequest} provideEnrollReasonRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        provideEnrollReason(companyBenefitEnrollmentId, provideEnrollReasonRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.provideEnrollReason(companyBenefitEnrollmentId, provideEnrollReasonRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} companyBenefitEnrollmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reissueCompanyBenefitEnrollment(companyBenefitEnrollmentId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reissueCompanyBenefitEnrollment(companyBenefitEnrollmentId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} [companyBenefitEnrollmentId]
         * @param {number} [limit]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCompanyBenefitEnrollmentForDependents(companyBenefitEnrollmentId, limit, page, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchCompanyBenefitEnrollmentForDependents(companyBenefitEnrollmentId, limit, page, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {'Unanswered' | 'Enrolled' | 'Waived'} [answerStatus] * &#x60;Unanswered&#x60; - Unanswered * &#x60;Enrolled&#x60; - Enrolled * &#x60;Waived&#x60; - Waived
         * @param {string} [answeredOnGt]
         * @param {string} [answeredOnLt]
         * @param {string} [companyBenefitId]
         * @param {string} [companyMemberId]
         * @param {number} [employeeCostGt]
         * @param {string} [employeeName]
         * @param {number} [limit]
         * @param {string} [memberId]
         * @param {boolean} [openForEnrollmentIn]
         * @param {number} [page]
         * @param {string} [sort]
         * @param {boolean} [terminatedIn]
         * @param {string} [terminatedOnGt]
         * @param {string} [terminatedOnLt]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCompanyBenefitEnrollments(answerStatus, answeredOnGt, answeredOnLt, companyBenefitId, companyMemberId, employeeCostGt, employeeName, limit, memberId, openForEnrollmentIn, page, sort, terminatedIn, terminatedOnGt, terminatedOnLt, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchCompanyBenefitEnrollments(answerStatus, answeredOnGt, answeredOnLt, companyBenefitId, companyMemberId, employeeCostGt, employeeName, limit, memberId, openForEnrollmentIn, page, sort, terminatedIn, terminatedOnGt, terminatedOnLt, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} companyId
         * @param {boolean} [activeIn]
         * @param {boolean} [configuredIn]
         * @param {boolean} [nonExpiredCoverageAndSubscriptionIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCompanyBenefits(companyId, activeIn, configuredIn, nonExpiredCoverageAndSubscriptionIn, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchCompanyBenefits(companyId, activeIn, configuredIn, nonExpiredCoverageAndSubscriptionIn, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} companyBenefitId
         * @param {SignOffOnCompanyBenefitRequest} signOffOnCompanyBenefitRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signOffOnCompanyBenefit(companyBenefitId, signOffOnCompanyBenefitRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.signOffOnCompanyBenefit(companyBenefitId, signOffOnCompanyBenefitRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startCompanyBenefitEnrollments(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.startCompanyBenefitEnrollments(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} companyBenefitEnrollmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terminateCompanyBenefitEnrollment(companyBenefitEnrollmentId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.terminateCompanyBenefitEnrollment(companyBenefitEnrollmentId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} companyBenefitEnrollmentForDependentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terminateCompanyBenefitEnrollmentForDependent(companyBenefitEnrollmentForDependentId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.terminateCompanyBenefitEnrollmentForDependent(companyBenefitEnrollmentForDependentId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {TerminateEmployeeBenefitEligibilityRequest} terminateEmployeeBenefitEligibilityRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terminateEmployeeBenefitEligibility(terminateEmployeeBenefitEligibilityRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.terminateEmployeeBenefitEligibility(terminateEmployeeBenefitEligibilityRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} companyBenefitEnrollmentId
         * @param {WaiveCompanyBenefitRequest} waiveCompanyBenefitRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        waiveCompanyBenefit(companyBenefitEnrollmentId, waiveCompanyBenefitRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.waiveCompanyBenefit(companyBenefitEnrollmentId, waiveCompanyBenefitRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * BenefitsApi - factory interface
 * @export
 */
exports.BenefitsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.BenefitsApiFp(configuration);
    return {
        /**
         *
         * @param {string} companyBenefitId
         * @param {BulkReissueCompanyBenefitEnrollmentsRequest} [bulkReissueCompanyBenefitEnrollmentsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkReissueCompanyBenefitEnrollments(companyBenefitId, bulkReissueCompanyBenefitEnrollmentsRequest, options) {
            return localVarFp.bulkReissueCompanyBenefitEnrollments(companyBenefitId, bulkReissueCompanyBenefitEnrollmentsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} companyBenefitId
         * @param {ConfigureCompanyBenefitRequest} configureCompanyBenefitRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configureCompanyBenefit(companyBenefitId, configureCompanyBenefitRequest, options) {
            return localVarFp.configureCompanyBenefit(companyBenefitId, configureCompanyBenefitRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} companyId
         * @param {CreateEmployeeBenefitEligibilityPolicyRequest} createEmployeeBenefitEligibilityPolicyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEmployeeBenefitEligibilityPolicy(companyId, createEmployeeBenefitEligibilityPolicyRequest, options) {
            return localVarFp.createEmployeeBenefitEligibilityPolicy(companyId, createEmployeeBenefitEligibilityPolicyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {EnrollIntoCompanyBenefitRequest} enrollIntoCompanyBenefitRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollIntoCompanyBenefit(enrollIntoCompanyBenefitRequest, options) {
            return localVarFp.enrollIntoCompanyBenefit(enrollIntoCompanyBenefitRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveEmployeeBenefitEligibilityPolicy(companyId, options) {
            return localVarFp.getActiveEmployeeBenefitEligibilityPolicy(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} companyBenefitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyBenefit(companyBenefitId, options) {
            return localVarFp.getCompanyBenefit(companyBenefitId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} billingPeriodStartDate
         * @param {string} companyBenefitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayrollDeductionTotalForCompanyBenefit(billingPeriodStartDate, companyBenefitId, options) {
            return localVarFp.getPayrollDeductionTotalForCompanyBenefit(billingPeriodStartDate, companyBenefitId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {GrantBenefitEligibilityToEmployeeRequest} grantBenefitEligibilityToEmployeeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantBenefitEligibilityToEmployee(grantBenefitEligibilityToEmployeeRequest, options) {
            return localVarFp.grantBenefitEligibilityToEmployee(grantBenefitEligibilityToEmployeeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActiveBenefitEnrollmentsForMember(memberId, options) {
            return localVarFp.listActiveBenefitEnrollmentsForMember(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActiveCompanyBenefits(companyId, options) {
            return localVarFp.listActiveCompanyBenefits(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActiveDigitalBenefitCardsForMember(memberId, options) {
            return localVarFp.listActiveDigitalBenefitCardsForMember(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} companyBenefitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBenefitPlansOfferedByCompanyBenefit(companyBenefitId, options) {
            return localVarFp.listBenefitPlansOfferedByCompanyBenefit(companyBenefitId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} companyBenefitId
         * @param {string} [answeredOnGt]
         * @param {string} [answeredOnLt]
         * @param {number} [employeeCostGt]
         * @param {string} [employeeName]
         * @param {boolean} [includeTerminatedIn]
         * @param {number} [limit]
         * @param {string} [memberId]
         * @param {boolean} [openForEnrollmentIn]
         * @param {number} [page]
         * @param {string} [sort]
         * @param {'Unanswered' | 'Enrolled' | 'Waived'} [status] * &#x60;Unanswered&#x60; - Unanswered * &#x60;Enrolled&#x60; - Enrolled * &#x60;Waived&#x60; - Waived
         * @param {string} [terminatedOnGt]
         * @param {string} [terminatedOnLt]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompanyBenefitEnrollments(companyBenefitId, answeredOnGt, answeredOnLt, employeeCostGt, employeeName, includeTerminatedIn, limit, memberId, openForEnrollmentIn, page, sort, status, terminatedOnGt, terminatedOnLt, options) {
            return localVarFp.listCompanyBenefitEnrollments(companyBenefitId, answeredOnGt, answeredOnLt, employeeCostGt, employeeName, includeTerminatedIn, limit, memberId, openForEnrollmentIn, page, sort, status, terminatedOnGt, terminatedOnLt, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} companyBenefitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompanyBenefitPlanTierCosts(companyBenefitId, options) {
            return localVarFp.listCompanyBenefitPlanTierCosts(companyBenefitId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} companyId
         * @param {string} [createdGte]
         * @param {string} [employeeName]
         * @param {number} [limit]
         * @param {number} [page]
         * @param {boolean} [terminatedIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEmployeeBenefitEligibilities(companyId, createdGte, employeeName, limit, page, terminatedIn, options) {
            return localVarFp.listEmployeeBenefitEligibilities(companyId, createdGte, employeeName, limit, page, terminatedIn, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOpenCompanyBenefitEnrollmentsForMember(memberId, options) {
            return localVarFp.listOpenCompanyBenefitEnrollmentsForMember(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPendingCompanyBenefitEnrollmentsForMember(memberId, options) {
            return localVarFp.listPendingCompanyBenefitEnrollmentsForMember(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUpcomingCompanyBenefits(companyId, options) {
            return localVarFp.listUpcomingCompanyBenefits(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} companyBenefitEnrollmentId
         * @param {ProvideEnrollReasonRequest} provideEnrollReasonRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        provideEnrollReason(companyBenefitEnrollmentId, provideEnrollReasonRequest, options) {
            return localVarFp.provideEnrollReason(companyBenefitEnrollmentId, provideEnrollReasonRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} companyBenefitEnrollmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reissueCompanyBenefitEnrollment(companyBenefitEnrollmentId, options) {
            return localVarFp.reissueCompanyBenefitEnrollment(companyBenefitEnrollmentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [companyBenefitEnrollmentId]
         * @param {number} [limit]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCompanyBenefitEnrollmentForDependents(companyBenefitEnrollmentId, limit, page, options) {
            return localVarFp.searchCompanyBenefitEnrollmentForDependents(companyBenefitEnrollmentId, limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {'Unanswered' | 'Enrolled' | 'Waived'} [answerStatus] * &#x60;Unanswered&#x60; - Unanswered * &#x60;Enrolled&#x60; - Enrolled * &#x60;Waived&#x60; - Waived
         * @param {string} [answeredOnGt]
         * @param {string} [answeredOnLt]
         * @param {string} [companyBenefitId]
         * @param {string} [companyMemberId]
         * @param {number} [employeeCostGt]
         * @param {string} [employeeName]
         * @param {number} [limit]
         * @param {string} [memberId]
         * @param {boolean} [openForEnrollmentIn]
         * @param {number} [page]
         * @param {string} [sort]
         * @param {boolean} [terminatedIn]
         * @param {string} [terminatedOnGt]
         * @param {string} [terminatedOnLt]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCompanyBenefitEnrollments(answerStatus, answeredOnGt, answeredOnLt, companyBenefitId, companyMemberId, employeeCostGt, employeeName, limit, memberId, openForEnrollmentIn, page, sort, terminatedIn, terminatedOnGt, terminatedOnLt, options) {
            return localVarFp.searchCompanyBenefitEnrollments(answerStatus, answeredOnGt, answeredOnLt, companyBenefitId, companyMemberId, employeeCostGt, employeeName, limit, memberId, openForEnrollmentIn, page, sort, terminatedIn, terminatedOnGt, terminatedOnLt, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} companyId
         * @param {boolean} [activeIn]
         * @param {boolean} [configuredIn]
         * @param {boolean} [nonExpiredCoverageAndSubscriptionIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCompanyBenefits(companyId, activeIn, configuredIn, nonExpiredCoverageAndSubscriptionIn, options) {
            return localVarFp.searchCompanyBenefits(companyId, activeIn, configuredIn, nonExpiredCoverageAndSubscriptionIn, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} companyBenefitId
         * @param {SignOffOnCompanyBenefitRequest} signOffOnCompanyBenefitRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signOffOnCompanyBenefit(companyBenefitId, signOffOnCompanyBenefitRequest, options) {
            return localVarFp.signOffOnCompanyBenefit(companyBenefitId, signOffOnCompanyBenefitRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startCompanyBenefitEnrollments(options) {
            return localVarFp.startCompanyBenefitEnrollments(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} companyBenefitEnrollmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terminateCompanyBenefitEnrollment(companyBenefitEnrollmentId, options) {
            return localVarFp.terminateCompanyBenefitEnrollment(companyBenefitEnrollmentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} companyBenefitEnrollmentForDependentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terminateCompanyBenefitEnrollmentForDependent(companyBenefitEnrollmentForDependentId, options) {
            return localVarFp.terminateCompanyBenefitEnrollmentForDependent(companyBenefitEnrollmentForDependentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {TerminateEmployeeBenefitEligibilityRequest} terminateEmployeeBenefitEligibilityRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terminateEmployeeBenefitEligibility(terminateEmployeeBenefitEligibilityRequest, options) {
            return localVarFp.terminateEmployeeBenefitEligibility(terminateEmployeeBenefitEligibilityRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} companyBenefitEnrollmentId
         * @param {WaiveCompanyBenefitRequest} waiveCompanyBenefitRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        waiveCompanyBenefit(companyBenefitEnrollmentId, waiveCompanyBenefitRequest, options) {
            return localVarFp.waiveCompanyBenefit(companyBenefitEnrollmentId, waiveCompanyBenefitRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * BenefitsApi - object-oriented interface
 * @export
 * @class BenefitsApi
 * @extends {BaseAPI}
 */
class BenefitsApi extends base_1.BaseAPI {
    /**
     *
     * @param {BenefitsApiBulkReissueCompanyBenefitEnrollmentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenefitsApi
     */
    bulkReissueCompanyBenefitEnrollments(requestParameters, options) {
        return exports.BenefitsApiFp(this.configuration).bulkReissueCompanyBenefitEnrollments(requestParameters.companyBenefitId, requestParameters.bulkReissueCompanyBenefitEnrollmentsRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BenefitsApiConfigureCompanyBenefitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenefitsApi
     */
    configureCompanyBenefit(requestParameters, options) {
        return exports.BenefitsApiFp(this.configuration).configureCompanyBenefit(requestParameters.companyBenefitId, requestParameters.configureCompanyBenefitRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BenefitsApiCreateEmployeeBenefitEligibilityPolicyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenefitsApi
     */
    createEmployeeBenefitEligibilityPolicy(requestParameters, options) {
        return exports.BenefitsApiFp(this.configuration).createEmployeeBenefitEligibilityPolicy(requestParameters.companyId, requestParameters.createEmployeeBenefitEligibilityPolicyRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BenefitsApiEnrollIntoCompanyBenefitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenefitsApi
     */
    enrollIntoCompanyBenefit(requestParameters, options) {
        return exports.BenefitsApiFp(this.configuration).enrollIntoCompanyBenefit(requestParameters.enrollIntoCompanyBenefitRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BenefitsApiGetActiveEmployeeBenefitEligibilityPolicyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenefitsApi
     */
    getActiveEmployeeBenefitEligibilityPolicy(requestParameters, options) {
        return exports.BenefitsApiFp(this.configuration).getActiveEmployeeBenefitEligibilityPolicy(requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BenefitsApiGetCompanyBenefitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenefitsApi
     */
    getCompanyBenefit(requestParameters, options) {
        return exports.BenefitsApiFp(this.configuration).getCompanyBenefit(requestParameters.companyBenefitId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BenefitsApiGetPayrollDeductionTotalForCompanyBenefitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenefitsApi
     */
    getPayrollDeductionTotalForCompanyBenefit(requestParameters, options) {
        return exports.BenefitsApiFp(this.configuration).getPayrollDeductionTotalForCompanyBenefit(requestParameters.billingPeriodStartDate, requestParameters.companyBenefitId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BenefitsApiGrantBenefitEligibilityToEmployeeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenefitsApi
     */
    grantBenefitEligibilityToEmployee(requestParameters, options) {
        return exports.BenefitsApiFp(this.configuration).grantBenefitEligibilityToEmployee(requestParameters.grantBenefitEligibilityToEmployeeRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BenefitsApiListActiveBenefitEnrollmentsForMemberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenefitsApi
     */
    listActiveBenefitEnrollmentsForMember(requestParameters, options) {
        return exports.BenefitsApiFp(this.configuration).listActiveBenefitEnrollmentsForMember(requestParameters.memberId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BenefitsApiListActiveCompanyBenefitsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenefitsApi
     */
    listActiveCompanyBenefits(requestParameters, options) {
        return exports.BenefitsApiFp(this.configuration).listActiveCompanyBenefits(requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BenefitsApiListActiveDigitalBenefitCardsForMemberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenefitsApi
     */
    listActiveDigitalBenefitCardsForMember(requestParameters, options) {
        return exports.BenefitsApiFp(this.configuration).listActiveDigitalBenefitCardsForMember(requestParameters.memberId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BenefitsApiListBenefitPlansOfferedByCompanyBenefitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenefitsApi
     */
    listBenefitPlansOfferedByCompanyBenefit(requestParameters, options) {
        return exports.BenefitsApiFp(this.configuration).listBenefitPlansOfferedByCompanyBenefit(requestParameters.companyBenefitId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BenefitsApiListCompanyBenefitEnrollmentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenefitsApi
     */
    listCompanyBenefitEnrollments(requestParameters, options) {
        return exports.BenefitsApiFp(this.configuration).listCompanyBenefitEnrollments(requestParameters.companyBenefitId, requestParameters.answeredOnGt, requestParameters.answeredOnLt, requestParameters.employeeCostGt, requestParameters.employeeName, requestParameters.includeTerminatedIn, requestParameters.limit, requestParameters.memberId, requestParameters.openForEnrollmentIn, requestParameters.page, requestParameters.sort, requestParameters.status, requestParameters.terminatedOnGt, requestParameters.terminatedOnLt, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BenefitsApiListCompanyBenefitPlanTierCostsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenefitsApi
     */
    listCompanyBenefitPlanTierCosts(requestParameters, options) {
        return exports.BenefitsApiFp(this.configuration).listCompanyBenefitPlanTierCosts(requestParameters.companyBenefitId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BenefitsApiListEmployeeBenefitEligibilitiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenefitsApi
     */
    listEmployeeBenefitEligibilities(requestParameters, options) {
        return exports.BenefitsApiFp(this.configuration).listEmployeeBenefitEligibilities(requestParameters.companyId, requestParameters.createdGte, requestParameters.employeeName, requestParameters.limit, requestParameters.page, requestParameters.terminatedIn, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BenefitsApiListOpenCompanyBenefitEnrollmentsForMemberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenefitsApi
     */
    listOpenCompanyBenefitEnrollmentsForMember(requestParameters, options) {
        return exports.BenefitsApiFp(this.configuration).listOpenCompanyBenefitEnrollmentsForMember(requestParameters.memberId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BenefitsApiListPendingCompanyBenefitEnrollmentsForMemberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenefitsApi
     */
    listPendingCompanyBenefitEnrollmentsForMember(requestParameters, options) {
        return exports.BenefitsApiFp(this.configuration).listPendingCompanyBenefitEnrollmentsForMember(requestParameters.memberId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BenefitsApiListUpcomingCompanyBenefitsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenefitsApi
     */
    listUpcomingCompanyBenefits(requestParameters, options) {
        return exports.BenefitsApiFp(this.configuration).listUpcomingCompanyBenefits(requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BenefitsApiProvideEnrollReasonRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenefitsApi
     */
    provideEnrollReason(requestParameters, options) {
        return exports.BenefitsApiFp(this.configuration).provideEnrollReason(requestParameters.companyBenefitEnrollmentId, requestParameters.provideEnrollReasonRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BenefitsApiReissueCompanyBenefitEnrollmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenefitsApi
     */
    reissueCompanyBenefitEnrollment(requestParameters, options) {
        return exports.BenefitsApiFp(this.configuration).reissueCompanyBenefitEnrollment(requestParameters.companyBenefitEnrollmentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BenefitsApiSearchCompanyBenefitEnrollmentForDependentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenefitsApi
     */
    searchCompanyBenefitEnrollmentForDependents(requestParameters = {}, options) {
        return exports.BenefitsApiFp(this.configuration).searchCompanyBenefitEnrollmentForDependents(requestParameters.companyBenefitEnrollmentId, requestParameters.limit, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BenefitsApiSearchCompanyBenefitEnrollmentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenefitsApi
     */
    searchCompanyBenefitEnrollments(requestParameters = {}, options) {
        return exports.BenefitsApiFp(this.configuration).searchCompanyBenefitEnrollments(requestParameters.answerStatus, requestParameters.answeredOnGt, requestParameters.answeredOnLt, requestParameters.companyBenefitId, requestParameters.companyMemberId, requestParameters.employeeCostGt, requestParameters.employeeName, requestParameters.limit, requestParameters.memberId, requestParameters.openForEnrollmentIn, requestParameters.page, requestParameters.sort, requestParameters.terminatedIn, requestParameters.terminatedOnGt, requestParameters.terminatedOnLt, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BenefitsApiSearchCompanyBenefitsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenefitsApi
     */
    searchCompanyBenefits(requestParameters, options) {
        return exports.BenefitsApiFp(this.configuration).searchCompanyBenefits(requestParameters.companyId, requestParameters.activeIn, requestParameters.configuredIn, requestParameters.nonExpiredCoverageAndSubscriptionIn, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BenefitsApiSignOffOnCompanyBenefitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenefitsApi
     */
    signOffOnCompanyBenefit(requestParameters, options) {
        return exports.BenefitsApiFp(this.configuration).signOffOnCompanyBenefit(requestParameters.companyBenefitId, requestParameters.signOffOnCompanyBenefitRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenefitsApi
     */
    startCompanyBenefitEnrollments(options) {
        return exports.BenefitsApiFp(this.configuration).startCompanyBenefitEnrollments(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BenefitsApiTerminateCompanyBenefitEnrollmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenefitsApi
     */
    terminateCompanyBenefitEnrollment(requestParameters, options) {
        return exports.BenefitsApiFp(this.configuration).terminateCompanyBenefitEnrollment(requestParameters.companyBenefitEnrollmentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BenefitsApiTerminateCompanyBenefitEnrollmentForDependentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenefitsApi
     */
    terminateCompanyBenefitEnrollmentForDependent(requestParameters, options) {
        return exports.BenefitsApiFp(this.configuration).terminateCompanyBenefitEnrollmentForDependent(requestParameters.companyBenefitEnrollmentForDependentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BenefitsApiTerminateEmployeeBenefitEligibilityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenefitsApi
     */
    terminateEmployeeBenefitEligibility(requestParameters, options) {
        return exports.BenefitsApiFp(this.configuration).terminateEmployeeBenefitEligibility(requestParameters.terminateEmployeeBenefitEligibilityRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BenefitsApiWaiveCompanyBenefitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BenefitsApi
     */
    waiveCompanyBenefit(requestParameters, options) {
        return exports.BenefitsApiFp(this.configuration).waiveCompanyBenefit(requestParameters.companyBenefitEnrollmentId, requestParameters.waiveCompanyBenefitRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.BenefitsApi = BenefitsApi;
/**
 * BillingApi - axios parameter creator
 * @export
 */
exports.BillingApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {GeneratePaymentIntentRequest} generatePaymentIntentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePaymentIntent: (generatePaymentIntentRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'generatePaymentIntentRequest' is not null or undefined
            common_1.assertParamExists('generatePaymentIntent', 'generatePaymentIntentRequest', generatePaymentIntentRequest);
            const localVarPath = `/v1/payment-intents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(generatePaymentIntentRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveCompanySubscription: (companyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyId' is not null or undefined
            common_1.assertParamExists('getActiveCompanySubscription', 'companyId', companyId);
            const localVarPath = `/v1/companies/{company_id}/active-subscription`
                .replace(`{${"company_id"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberActiveSubscription: (memberId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'memberId' is not null or undefined
            common_1.assertParamExists('getMemberActiveSubscription', 'memberId', memberId);
            const localVarPath = `/v1/members/{member_id}/active-subscription`
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} companySubscriptionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberAdditionEligibilityForCompanySubscription: (companySubscriptionId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companySubscriptionId' is not null or undefined
            common_1.assertParamExists('getMemberAdditionEligibilityForCompanySubscription', 'companySubscriptionId', companySubscriptionId);
            const localVarPath = `/v1/company-subscriptions/{company_subscription_id}/member-addition-allowed`
                .replace(`{${"company_subscription_id"}}`, encodeURIComponent(String(companySubscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} companyId
         * @param {boolean} [activeIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompanySubscriptions: (companyId, activeIn, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyId' is not null or undefined
            common_1.assertParamExists('listCompanySubscriptions', 'companyId', companyId);
            const localVarPath = `/v1/companies/{company_id}/subscriptions`
                .replace(`{${"company_id"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (activeIn !== undefined) {
                localVarQueryParameter['active_in'] = activeIn;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncCompanySubscriptionAndPlanFromChargebee: (companyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyId' is not null or undefined
            common_1.assertParamExists('syncCompanySubscriptionAndPlanFromChargebee', 'companyId', companyId);
            const localVarPath = `/v1/companies/{company_id}/sync`
                .replace(`{${"company_id"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} companySubscriptionId
         * @param {UpgradeCompanySubscriptionContractMembershipsRequest} upgradeCompanySubscriptionContractMembershipsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upgradeCompanySubscriptionContractMemberships: (companySubscriptionId, upgradeCompanySubscriptionContractMembershipsRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companySubscriptionId' is not null or undefined
            common_1.assertParamExists('upgradeCompanySubscriptionContractMemberships', 'companySubscriptionId', companySubscriptionId);
            // verify required parameter 'upgradeCompanySubscriptionContractMembershipsRequest' is not null or undefined
            common_1.assertParamExists('upgradeCompanySubscriptionContractMemberships', 'upgradeCompanySubscriptionContractMembershipsRequest', upgradeCompanySubscriptionContractMembershipsRequest);
            const localVarPath = `/v1/company-subscriptions/{company_subscription_id}/membership-upgrade`
                .replace(`{${"company_subscription_id"}}`, encodeURIComponent(String(companySubscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(upgradeCompanySubscriptionContractMembershipsRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * BillingApi - functional programming interface
 * @export
 */
exports.BillingApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.BillingApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {GeneratePaymentIntentRequest} generatePaymentIntentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePaymentIntent(generatePaymentIntentRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.generatePaymentIntent(generatePaymentIntentRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveCompanySubscription(companyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getActiveCompanySubscription(companyId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberActiveSubscription(memberId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMemberActiveSubscription(memberId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} companySubscriptionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberAdditionEligibilityForCompanySubscription(companySubscriptionId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMemberAdditionEligibilityForCompanySubscription(companySubscriptionId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} companyId
         * @param {boolean} [activeIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompanySubscriptions(companyId, activeIn, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listCompanySubscriptions(companyId, activeIn, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncCompanySubscriptionAndPlanFromChargebee(companyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.syncCompanySubscriptionAndPlanFromChargebee(companyId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} companySubscriptionId
         * @param {UpgradeCompanySubscriptionContractMembershipsRequest} upgradeCompanySubscriptionContractMembershipsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upgradeCompanySubscriptionContractMemberships(companySubscriptionId, upgradeCompanySubscriptionContractMembershipsRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.upgradeCompanySubscriptionContractMemberships(companySubscriptionId, upgradeCompanySubscriptionContractMembershipsRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * BillingApi - factory interface
 * @export
 */
exports.BillingApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.BillingApiFp(configuration);
    return {
        /**
         *
         * @param {GeneratePaymentIntentRequest} generatePaymentIntentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePaymentIntent(generatePaymentIntentRequest, options) {
            return localVarFp.generatePaymentIntent(generatePaymentIntentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveCompanySubscription(companyId, options) {
            return localVarFp.getActiveCompanySubscription(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberActiveSubscription(memberId, options) {
            return localVarFp.getMemberActiveSubscription(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} companySubscriptionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberAdditionEligibilityForCompanySubscription(companySubscriptionId, options) {
            return localVarFp.getMemberAdditionEligibilityForCompanySubscription(companySubscriptionId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} companyId
         * @param {boolean} [activeIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompanySubscriptions(companyId, activeIn, options) {
            return localVarFp.listCompanySubscriptions(companyId, activeIn, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncCompanySubscriptionAndPlanFromChargebee(companyId, options) {
            return localVarFp.syncCompanySubscriptionAndPlanFromChargebee(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} companySubscriptionId
         * @param {UpgradeCompanySubscriptionContractMembershipsRequest} upgradeCompanySubscriptionContractMembershipsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upgradeCompanySubscriptionContractMemberships(companySubscriptionId, upgradeCompanySubscriptionContractMembershipsRequest, options) {
            return localVarFp.upgradeCompanySubscriptionContractMemberships(companySubscriptionId, upgradeCompanySubscriptionContractMembershipsRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * BillingApi - object-oriented interface
 * @export
 * @class BillingApi
 * @extends {BaseAPI}
 */
class BillingApi extends base_1.BaseAPI {
    /**
     *
     * @param {BillingApiGeneratePaymentIntentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    generatePaymentIntent(requestParameters, options) {
        return exports.BillingApiFp(this.configuration).generatePaymentIntent(requestParameters.generatePaymentIntentRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BillingApiGetActiveCompanySubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    getActiveCompanySubscription(requestParameters, options) {
        return exports.BillingApiFp(this.configuration).getActiveCompanySubscription(requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BillingApiGetMemberActiveSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    getMemberActiveSubscription(requestParameters, options) {
        return exports.BillingApiFp(this.configuration).getMemberActiveSubscription(requestParameters.memberId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BillingApiGetMemberAdditionEligibilityForCompanySubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    getMemberAdditionEligibilityForCompanySubscription(requestParameters, options) {
        return exports.BillingApiFp(this.configuration).getMemberAdditionEligibilityForCompanySubscription(requestParameters.companySubscriptionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BillingApiListCompanySubscriptionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    listCompanySubscriptions(requestParameters, options) {
        return exports.BillingApiFp(this.configuration).listCompanySubscriptions(requestParameters.companyId, requestParameters.activeIn, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BillingApiSyncCompanySubscriptionAndPlanFromChargebeeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    syncCompanySubscriptionAndPlanFromChargebee(requestParameters, options) {
        return exports.BillingApiFp(this.configuration).syncCompanySubscriptionAndPlanFromChargebee(requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BillingApiUpgradeCompanySubscriptionContractMembershipsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    upgradeCompanySubscriptionContractMemberships(requestParameters, options) {
        return exports.BillingApiFp(this.configuration).upgradeCompanySubscriptionContractMemberships(requestParameters.companySubscriptionId, requestParameters.upgradeCompanySubscriptionContractMembershipsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.BillingApi = BillingApi;
/**
 * CareTeamApi - axios parameter creator
 * @export
 */
exports.CareTeamApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {AssignPersonToCareTeamRequest} assignPersonToCareTeamRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignPersonToCareTeam: (assignPersonToCareTeamRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'assignPersonToCareTeamRequest' is not null or undefined
            common_1.assertParamExists('assignPersonToCareTeam', 'assignPersonToCareTeamRequest', assignPersonToCareTeamRequest);
            const localVarPath = `/v1/care-team/assign`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(assignPersonToCareTeamRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} memberId
         * @param {boolean} [activeIn]
         * @param {number} [limit]
         * @param {boolean} [orderByRankAscIn]
         * @param {boolean} [orderByRankDescIn]
         * @param {number} [page]
         * @param {'Clinical Provider' | 'Therapist' | 'Mental Health Coach' | 'Care Navigator'} [role] * &#x60;Clinical Provider&#x60; - Cp * &#x60;Therapist&#x60; - Therapist * &#x60;Mental Health Coach&#x60; - Mental Health Coach * &#x60;Care Navigator&#x60; - Care Navigator
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCareTeam: (memberId, activeIn, limit, orderByRankAscIn, orderByRankDescIn, page, role, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'memberId' is not null or undefined
            common_1.assertParamExists('listCareTeam', 'memberId', memberId);
            const localVarPath = `/v1/care-team/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (activeIn !== undefined) {
                localVarQueryParameter['active_in'] = activeIn;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (memberId !== undefined) {
                localVarQueryParameter['member_id'] = memberId;
            }
            if (orderByRankAscIn !== undefined) {
                localVarQueryParameter['order_by_rank_asc_in'] = orderByRankAscIn;
            }
            if (orderByRankDescIn !== undefined) {
                localVarQueryParameter['order_by_rank_desc_in'] = orderByRankDescIn;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMemberCareTeam: (memberId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'memberId' is not null or undefined
            common_1.assertParamExists('listMemberCareTeam', 'memberId', memberId);
            const localVarPath = `/v1/care-team/{member_id}`
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} careTeamPersonId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCareTeamPerson: (careTeamPersonId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'careTeamPersonId' is not null or undefined
            common_1.assertParamExists('removeCareTeamPerson', 'careTeamPersonId', careTeamPersonId);
            const localVarPath = `/v1/care-team/{care_team_person_id}/remove`
                .replace(`{${"care_team_person_id"}}`, encodeURIComponent(String(careTeamPersonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CareTeamApi - functional programming interface
 * @export
 */
exports.CareTeamApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.CareTeamApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {AssignPersonToCareTeamRequest} assignPersonToCareTeamRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignPersonToCareTeam(assignPersonToCareTeamRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.assignPersonToCareTeam(assignPersonToCareTeamRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} memberId
         * @param {boolean} [activeIn]
         * @param {number} [limit]
         * @param {boolean} [orderByRankAscIn]
         * @param {boolean} [orderByRankDescIn]
         * @param {number} [page]
         * @param {'Clinical Provider' | 'Therapist' | 'Mental Health Coach' | 'Care Navigator'} [role] * &#x60;Clinical Provider&#x60; - Cp * &#x60;Therapist&#x60; - Therapist * &#x60;Mental Health Coach&#x60; - Mental Health Coach * &#x60;Care Navigator&#x60; - Care Navigator
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCareTeam(memberId, activeIn, limit, orderByRankAscIn, orderByRankDescIn, page, role, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listCareTeam(memberId, activeIn, limit, orderByRankAscIn, orderByRankDescIn, page, role, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMemberCareTeam(memberId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listMemberCareTeam(memberId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} careTeamPersonId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCareTeamPerson(careTeamPersonId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.removeCareTeamPerson(careTeamPersonId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * CareTeamApi - factory interface
 * @export
 */
exports.CareTeamApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.CareTeamApiFp(configuration);
    return {
        /**
         *
         * @param {AssignPersonToCareTeamRequest} assignPersonToCareTeamRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignPersonToCareTeam(assignPersonToCareTeamRequest, options) {
            return localVarFp.assignPersonToCareTeam(assignPersonToCareTeamRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} memberId
         * @param {boolean} [activeIn]
         * @param {number} [limit]
         * @param {boolean} [orderByRankAscIn]
         * @param {boolean} [orderByRankDescIn]
         * @param {number} [page]
         * @param {'Clinical Provider' | 'Therapist' | 'Mental Health Coach' | 'Care Navigator'} [role] * &#x60;Clinical Provider&#x60; - Cp * &#x60;Therapist&#x60; - Therapist * &#x60;Mental Health Coach&#x60; - Mental Health Coach * &#x60;Care Navigator&#x60; - Care Navigator
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCareTeam(memberId, activeIn, limit, orderByRankAscIn, orderByRankDescIn, page, role, options) {
            return localVarFp.listCareTeam(memberId, activeIn, limit, orderByRankAscIn, orderByRankDescIn, page, role, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMemberCareTeam(memberId, options) {
            return localVarFp.listMemberCareTeam(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} careTeamPersonId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCareTeamPerson(careTeamPersonId, options) {
            return localVarFp.removeCareTeamPerson(careTeamPersonId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CareTeamApi - object-oriented interface
 * @export
 * @class CareTeamApi
 * @extends {BaseAPI}
 */
class CareTeamApi extends base_1.BaseAPI {
    /**
     *
     * @param {CareTeamApiAssignPersonToCareTeamRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CareTeamApi
     */
    assignPersonToCareTeam(requestParameters, options) {
        return exports.CareTeamApiFp(this.configuration).assignPersonToCareTeam(requestParameters.assignPersonToCareTeamRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CareTeamApiListCareTeamRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CareTeamApi
     */
    listCareTeam(requestParameters, options) {
        return exports.CareTeamApiFp(this.configuration).listCareTeam(requestParameters.memberId, requestParameters.activeIn, requestParameters.limit, requestParameters.orderByRankAscIn, requestParameters.orderByRankDescIn, requestParameters.page, requestParameters.role, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CareTeamApiListMemberCareTeamRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CareTeamApi
     */
    listMemberCareTeam(requestParameters, options) {
        return exports.CareTeamApiFp(this.configuration).listMemberCareTeam(requestParameters.memberId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CareTeamApiRemoveCareTeamPersonRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CareTeamApi
     */
    removeCareTeamPerson(requestParameters, options) {
        return exports.CareTeamApiFp(this.configuration).removeCareTeamPerson(requestParameters.careTeamPersonId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.CareTeamApi = CareTeamApi;
/**
 * CensusApi - axios parameter creator
 * @export
 */
exports.CensusApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} companyId
         * @param {string} csvFile
         * @param {CompanyMemberTypeEnum} companyMemberType
         * @param {boolean} [grantBenefitEligibilityIn]
         * @param {boolean} [syncIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        simulateUploadCensusFile: (companyId, csvFile, companyMemberType, grantBenefitEligibilityIn, syncIn, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyId' is not null or undefined
            common_1.assertParamExists('simulateUploadCensusFile', 'companyId', companyId);
            // verify required parameter 'csvFile' is not null or undefined
            common_1.assertParamExists('simulateUploadCensusFile', 'csvFile', csvFile);
            // verify required parameter 'companyMemberType' is not null or undefined
            common_1.assertParamExists('simulateUploadCensusFile', 'companyMemberType', companyMemberType);
            const localVarPath = `/v1/companies/{company_id}/census/simulate`
                .replace(`{${"company_id"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (csvFile !== undefined) {
                localVarFormParams.append('csv_file', csvFile);
            }
            if (companyMemberType !== undefined) {
                localVarFormParams.append('company_member_type', new Blob([JSON.stringify(companyMemberType)], { type: "application/json", }));
            }
            if (grantBenefitEligibilityIn !== undefined) {
                localVarFormParams.append('grant_benefit_eligibility_in', grantBenefitEligibilityIn);
            }
            if (syncIn !== undefined) {
                localVarFormParams.append('sync_in', syncIn);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} companyId
         * @param {string} csvFile
         * @param {CompanyMemberTypeEnum} companyMemberType
         * @param {boolean} [grantBenefitEligibilityIn]
         * @param {boolean} [syncIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCensusFile: (companyId, csvFile, companyMemberType, grantBenefitEligibilityIn, syncIn, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyId' is not null or undefined
            common_1.assertParamExists('uploadCensusFile', 'companyId', companyId);
            // verify required parameter 'csvFile' is not null or undefined
            common_1.assertParamExists('uploadCensusFile', 'csvFile', csvFile);
            // verify required parameter 'companyMemberType' is not null or undefined
            common_1.assertParamExists('uploadCensusFile', 'companyMemberType', companyMemberType);
            const localVarPath = `/v1/companies/{company_id}/census/upload`
                .replace(`{${"company_id"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (csvFile !== undefined) {
                localVarFormParams.append('csv_file', csvFile);
            }
            if (companyMemberType !== undefined) {
                localVarFormParams.append('company_member_type', new Blob([JSON.stringify(companyMemberType)], { type: "application/json", }));
            }
            if (grantBenefitEligibilityIn !== undefined) {
                localVarFormParams.append('grant_benefit_eligibility_in', grantBenefitEligibilityIn);
            }
            if (syncIn !== undefined) {
                localVarFormParams.append('sync_in', syncIn);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} companyId
         * @param {string} csvFile
         * @param {CompanyMemberTypeEnum} companyMemberType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCensusFile: (companyId, csvFile, companyMemberType, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyId' is not null or undefined
            common_1.assertParamExists('validateCensusFile', 'companyId', companyId);
            // verify required parameter 'csvFile' is not null or undefined
            common_1.assertParamExists('validateCensusFile', 'csvFile', csvFile);
            // verify required parameter 'companyMemberType' is not null or undefined
            common_1.assertParamExists('validateCensusFile', 'companyMemberType', companyMemberType);
            const localVarPath = `/v1/companies/{company_id}/census/validate`
                .replace(`{${"company_id"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (csvFile !== undefined) {
                localVarFormParams.append('csv_file', csvFile);
            }
            if (companyMemberType !== undefined) {
                localVarFormParams.append('company_member_type', new Blob([JSON.stringify(companyMemberType)], { type: "application/json", }));
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CensusApi - functional programming interface
 * @export
 */
exports.CensusApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.CensusApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} companyId
         * @param {string} csvFile
         * @param {CompanyMemberTypeEnum} companyMemberType
         * @param {boolean} [grantBenefitEligibilityIn]
         * @param {boolean} [syncIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        simulateUploadCensusFile(companyId, csvFile, companyMemberType, grantBenefitEligibilityIn, syncIn, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.simulateUploadCensusFile(companyId, csvFile, companyMemberType, grantBenefitEligibilityIn, syncIn, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} companyId
         * @param {string} csvFile
         * @param {CompanyMemberTypeEnum} companyMemberType
         * @param {boolean} [grantBenefitEligibilityIn]
         * @param {boolean} [syncIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCensusFile(companyId, csvFile, companyMemberType, grantBenefitEligibilityIn, syncIn, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.uploadCensusFile(companyId, csvFile, companyMemberType, grantBenefitEligibilityIn, syncIn, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} companyId
         * @param {string} csvFile
         * @param {CompanyMemberTypeEnum} companyMemberType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCensusFile(companyId, csvFile, companyMemberType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.validateCensusFile(companyId, csvFile, companyMemberType, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * CensusApi - factory interface
 * @export
 */
exports.CensusApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.CensusApiFp(configuration);
    return {
        /**
         *
         * @param {string} companyId
         * @param {string} csvFile
         * @param {CompanyMemberTypeEnum} companyMemberType
         * @param {boolean} [grantBenefitEligibilityIn]
         * @param {boolean} [syncIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        simulateUploadCensusFile(companyId, csvFile, companyMemberType, grantBenefitEligibilityIn, syncIn, options) {
            return localVarFp.simulateUploadCensusFile(companyId, csvFile, companyMemberType, grantBenefitEligibilityIn, syncIn, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} companyId
         * @param {string} csvFile
         * @param {CompanyMemberTypeEnum} companyMemberType
         * @param {boolean} [grantBenefitEligibilityIn]
         * @param {boolean} [syncIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCensusFile(companyId, csvFile, companyMemberType, grantBenefitEligibilityIn, syncIn, options) {
            return localVarFp.uploadCensusFile(companyId, csvFile, companyMemberType, grantBenefitEligibilityIn, syncIn, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} companyId
         * @param {string} csvFile
         * @param {CompanyMemberTypeEnum} companyMemberType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCensusFile(companyId, csvFile, companyMemberType, options) {
            return localVarFp.validateCensusFile(companyId, csvFile, companyMemberType, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CensusApi - object-oriented interface
 * @export
 * @class CensusApi
 * @extends {BaseAPI}
 */
class CensusApi extends base_1.BaseAPI {
    /**
     *
     * @param {CensusApiSimulateUploadCensusFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CensusApi
     */
    simulateUploadCensusFile(requestParameters, options) {
        return exports.CensusApiFp(this.configuration).simulateUploadCensusFile(requestParameters.companyId, requestParameters.csvFile, requestParameters.companyMemberType, requestParameters.grantBenefitEligibilityIn, requestParameters.syncIn, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CensusApiUploadCensusFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CensusApi
     */
    uploadCensusFile(requestParameters, options) {
        return exports.CensusApiFp(this.configuration).uploadCensusFile(requestParameters.companyId, requestParameters.csvFile, requestParameters.companyMemberType, requestParameters.grantBenefitEligibilityIn, requestParameters.syncIn, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CensusApiValidateCensusFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CensusApi
     */
    validateCensusFile(requestParameters, options) {
        return exports.CensusApiFp(this.configuration).validateCensusFile(requestParameters.companyId, requestParameters.csvFile, requestParameters.companyMemberType, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.CensusApi = CensusApi;
/**
 * ChartingApi - axios parameter creator
 * @export
 */
exports.ChartingApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} encounterId
         * @param {CreateEncounterDocumentationAddendumRequest} createEncounterDocumentationAddendumRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEncounterDocumentationAddendum: (encounterId, createEncounterDocumentationAddendumRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'encounterId' is not null or undefined
            common_1.assertParamExists('createEncounterDocumentationAddendum', 'encounterId', encounterId);
            // verify required parameter 'createEncounterDocumentationAddendumRequest' is not null or undefined
            common_1.assertParamExists('createEncounterDocumentationAddendum', 'createEncounterDocumentationAddendumRequest', createEncounterDocumentationAddendumRequest);
            const localVarPath = `/v1/encounters/{encounter_id}/documentation-addendums`
                .replace(`{${"encounter_id"}}`, encodeURIComponent(String(encounterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createEncounterDocumentationAddendumRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CreateTreatedProblemRequest} createTreatedProblemRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTreatedProblem: (createTreatedProblemRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createTreatedProblemRequest' is not null or undefined
            common_1.assertParamExists('createTreatedProblem', 'createTreatedProblemRequest', createTreatedProblemRequest);
            const localVarPath = `/v1/treated-problems`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createTreatedProblemRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} encounterId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEncounterDocumentationAddendums: (encounterId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'encounterId' is not null or undefined
            common_1.assertParamExists('listEncounterDocumentationAddendums', 'encounterId', encounterId);
            const localVarPath = `/v1/encounters/{encounter_id}/documentation-addendums`
                .replace(`{${"encounter_id"}}`, encodeURIComponent(String(encounterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} encounterId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTreatedProblems: (encounterId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'encounterId' is not null or undefined
            common_1.assertParamExists('listTreatedProblems', 'encounterId', encounterId);
            const localVarPath = `/v1/encounters/{encounter_id}/treated-problems`
                .replace(`{${"encounter_id"}}`, encodeURIComponent(String(encounterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} treatedProblemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redactTreatedProblem: (treatedProblemId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'treatedProblemId' is not null or undefined
            common_1.assertParamExists('redactTreatedProblem', 'treatedProblemId', treatedProblemId);
            const localVarPath = `/v1/treated-problems/{treated_problem_id}/redact`
                .replace(`{${"treated_problem_id"}}`, encodeURIComponent(String(treatedProblemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} treatedProblemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTreatedProblem: (treatedProblemId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'treatedProblemId' is not null or undefined
            common_1.assertParamExists('removeTreatedProblem', 'treatedProblemId', treatedProblemId);
            const localVarPath = `/v1/treated-problems/{treated_problem_id}`
                .replace(`{${"treated_problem_id"}}`, encodeURIComponent(String(treatedProblemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ChartingApi - functional programming interface
 * @export
 */
exports.ChartingApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.ChartingApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} encounterId
         * @param {CreateEncounterDocumentationAddendumRequest} createEncounterDocumentationAddendumRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEncounterDocumentationAddendum(encounterId, createEncounterDocumentationAddendumRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createEncounterDocumentationAddendum(encounterId, createEncounterDocumentationAddendumRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {CreateTreatedProblemRequest} createTreatedProblemRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTreatedProblem(createTreatedProblemRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createTreatedProblem(createTreatedProblemRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} encounterId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEncounterDocumentationAddendums(encounterId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listEncounterDocumentationAddendums(encounterId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} encounterId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTreatedProblems(encounterId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listTreatedProblems(encounterId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} treatedProblemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redactTreatedProblem(treatedProblemId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.redactTreatedProblem(treatedProblemId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} treatedProblemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTreatedProblem(treatedProblemId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.removeTreatedProblem(treatedProblemId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ChartingApi - factory interface
 * @export
 */
exports.ChartingApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.ChartingApiFp(configuration);
    return {
        /**
         *
         * @param {string} encounterId
         * @param {CreateEncounterDocumentationAddendumRequest} createEncounterDocumentationAddendumRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEncounterDocumentationAddendum(encounterId, createEncounterDocumentationAddendumRequest, options) {
            return localVarFp.createEncounterDocumentationAddendum(encounterId, createEncounterDocumentationAddendumRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateTreatedProblemRequest} createTreatedProblemRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTreatedProblem(createTreatedProblemRequest, options) {
            return localVarFp.createTreatedProblem(createTreatedProblemRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} encounterId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEncounterDocumentationAddendums(encounterId, options) {
            return localVarFp.listEncounterDocumentationAddendums(encounterId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} encounterId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTreatedProblems(encounterId, options) {
            return localVarFp.listTreatedProblems(encounterId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} treatedProblemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redactTreatedProblem(treatedProblemId, options) {
            return localVarFp.redactTreatedProblem(treatedProblemId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} treatedProblemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTreatedProblem(treatedProblemId, options) {
            return localVarFp.removeTreatedProblem(treatedProblemId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ChartingApi - object-oriented interface
 * @export
 * @class ChartingApi
 * @extends {BaseAPI}
 */
class ChartingApi extends base_1.BaseAPI {
    /**
     *
     * @param {ChartingApiCreateEncounterDocumentationAddendumRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChartingApi
     */
    createEncounterDocumentationAddendum(requestParameters, options) {
        return exports.ChartingApiFp(this.configuration).createEncounterDocumentationAddendum(requestParameters.encounterId, requestParameters.createEncounterDocumentationAddendumRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ChartingApiCreateTreatedProblemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChartingApi
     */
    createTreatedProblem(requestParameters, options) {
        return exports.ChartingApiFp(this.configuration).createTreatedProblem(requestParameters.createTreatedProblemRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ChartingApiListEncounterDocumentationAddendumsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChartingApi
     */
    listEncounterDocumentationAddendums(requestParameters, options) {
        return exports.ChartingApiFp(this.configuration).listEncounterDocumentationAddendums(requestParameters.encounterId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ChartingApiListTreatedProblemsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChartingApi
     */
    listTreatedProblems(requestParameters, options) {
        return exports.ChartingApiFp(this.configuration).listTreatedProblems(requestParameters.encounterId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ChartingApiRedactTreatedProblemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChartingApi
     */
    redactTreatedProblem(requestParameters, options) {
        return exports.ChartingApiFp(this.configuration).redactTreatedProblem(requestParameters.treatedProblemId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ChartingApiRemoveTreatedProblemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChartingApi
     */
    removeTreatedProblem(requestParameters, options) {
        return exports.ChartingApiFp(this.configuration).removeTreatedProblem(requestParameters.treatedProblemId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ChartingApi = ChartingApi;
/**
 * ChatApi - axios parameter creator
 * @export
 */
exports.ChatApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {ChatBotCallbackApiRequest} chatBotCallbackApiRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatBotCallback: (chatBotCallbackApiRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'chatBotCallbackApiRequest' is not null or undefined
            common_1.assertParamExists('chatBotCallback', 'chatBotCallbackApiRequest', chatBotCallbackApiRequest);
            const localVarPath = `/v1/chatbot`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(chatBotCallbackApiRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatAccessToken: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/chat/access-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberAppointmentNotificationsChannel: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/chat-channels/appointment-notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberAppointmentSchedulingChatChannel: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/chat-channels/appointment-scheduling`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberSupportChannel: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/chat-channels/support`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMemberAssistantChannels: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/chat-channels/member-assistant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {StartAppointmentSchedulingChatRequest} [startAppointmentSchedulingChatRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startAppointmentSchedulingChat: (startAppointmentSchedulingChatRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/chat-channels/appointment-scheduling`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(startAppointmentSchedulingChatRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {StartMemberAssistantChatApiRequest} startMemberAssistantChatApiRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startMemberAssistantChat: (startMemberAssistantChatApiRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'startMemberAssistantChatApiRequest' is not null or undefined
            common_1.assertParamExists('startMemberAssistantChat', 'startMemberAssistantChatApiRequest', startMemberAssistantChatApiRequest);
            const localVarPath = `/v1/chat-channels/member-assistant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(startMemberAssistantChatApiRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startSupportChat: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/chat-channels/support`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ChatApi - functional programming interface
 * @export
 */
exports.ChatApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.ChatApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {ChatBotCallbackApiRequest} chatBotCallbackApiRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatBotCallback(chatBotCallbackApiRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.chatBotCallback(chatBotCallbackApiRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatAccessToken(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getChatAccessToken(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberAppointmentNotificationsChannel(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMemberAppointmentNotificationsChannel(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberAppointmentSchedulingChatChannel(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMemberAppointmentSchedulingChatChannel(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberSupportChannel(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMemberSupportChannel(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMemberAssistantChannels(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listMemberAssistantChannels(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {StartAppointmentSchedulingChatRequest} [startAppointmentSchedulingChatRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startAppointmentSchedulingChat(startAppointmentSchedulingChatRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.startAppointmentSchedulingChat(startAppointmentSchedulingChatRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {StartMemberAssistantChatApiRequest} startMemberAssistantChatApiRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startMemberAssistantChat(startMemberAssistantChatApiRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.startMemberAssistantChat(startMemberAssistantChatApiRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startSupportChat(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.startSupportChat(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ChatApi - factory interface
 * @export
 */
exports.ChatApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.ChatApiFp(configuration);
    return {
        /**
         *
         * @param {ChatBotCallbackApiRequest} chatBotCallbackApiRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatBotCallback(chatBotCallbackApiRequest, options) {
            return localVarFp.chatBotCallback(chatBotCallbackApiRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatAccessToken(options) {
            return localVarFp.getChatAccessToken(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberAppointmentNotificationsChannel(options) {
            return localVarFp.getMemberAppointmentNotificationsChannel(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberAppointmentSchedulingChatChannel(options) {
            return localVarFp.getMemberAppointmentSchedulingChatChannel(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberSupportChannel(options) {
            return localVarFp.getMemberSupportChannel(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMemberAssistantChannels(options) {
            return localVarFp.listMemberAssistantChannels(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {StartAppointmentSchedulingChatRequest} [startAppointmentSchedulingChatRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startAppointmentSchedulingChat(startAppointmentSchedulingChatRequest, options) {
            return localVarFp.startAppointmentSchedulingChat(startAppointmentSchedulingChatRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {StartMemberAssistantChatApiRequest} startMemberAssistantChatApiRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startMemberAssistantChat(startMemberAssistantChatApiRequest, options) {
            return localVarFp.startMemberAssistantChat(startMemberAssistantChatApiRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startSupportChat(options) {
            return localVarFp.startSupportChat(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ChatApi - object-oriented interface
 * @export
 * @class ChatApi
 * @extends {BaseAPI}
 */
class ChatApi extends base_1.BaseAPI {
    /**
     *
     * @param {ChatApiChatBotCallbackRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    chatBotCallback(requestParameters, options) {
        return exports.ChatApiFp(this.configuration).chatBotCallback(requestParameters.chatBotCallbackApiRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    getChatAccessToken(options) {
        return exports.ChatApiFp(this.configuration).getChatAccessToken(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    getMemberAppointmentNotificationsChannel(options) {
        return exports.ChatApiFp(this.configuration).getMemberAppointmentNotificationsChannel(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    getMemberAppointmentSchedulingChatChannel(options) {
        return exports.ChatApiFp(this.configuration).getMemberAppointmentSchedulingChatChannel(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    getMemberSupportChannel(options) {
        return exports.ChatApiFp(this.configuration).getMemberSupportChannel(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    listMemberAssistantChannels(options) {
        return exports.ChatApiFp(this.configuration).listMemberAssistantChannels(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ChatApiStartAppointmentSchedulingChatRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    startAppointmentSchedulingChat(requestParameters = {}, options) {
        return exports.ChatApiFp(this.configuration).startAppointmentSchedulingChat(requestParameters.startAppointmentSchedulingChatRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ChatApiStartMemberAssistantChatRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    startMemberAssistantChat(requestParameters, options) {
        return exports.ChatApiFp(this.configuration).startMemberAssistantChat(requestParameters.startMemberAssistantChatApiRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    startSupportChat(options) {
        return exports.ChatApiFp(this.configuration).startSupportChat(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ChatApi = ChatApi;
/**
 * ClinicalAdminApi - axios parameter creator
 * @export
 */
exports.ClinicalAdminApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [email]
         * @param {number} [limit]
         * @param {string} [name]
         * @param {number} [page]
         * @param {string} [phone]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listClinicalAdmins: (email, limit, name, page, phone, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/clinical-admins`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (phone !== undefined) {
                localVarQueryParameter['phone'] = phone;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ClinicalAdminApi - functional programming interface
 * @export
 */
exports.ClinicalAdminApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.ClinicalAdminApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [email]
         * @param {number} [limit]
         * @param {string} [name]
         * @param {number} [page]
         * @param {string} [phone]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listClinicalAdmins(email, limit, name, page, phone, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listClinicalAdmins(email, limit, name, page, phone, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ClinicalAdminApi - factory interface
 * @export
 */
exports.ClinicalAdminApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.ClinicalAdminApiFp(configuration);
    return {
        /**
         *
         * @param {string} [email]
         * @param {number} [limit]
         * @param {string} [name]
         * @param {number} [page]
         * @param {string} [phone]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listClinicalAdmins(email, limit, name, page, phone, options) {
            return localVarFp.listClinicalAdmins(email, limit, name, page, phone, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ClinicalAdminApi - object-oriented interface
 * @export
 * @class ClinicalAdminApi
 * @extends {BaseAPI}
 */
class ClinicalAdminApi extends base_1.BaseAPI {
    /**
     *
     * @param {ClinicalAdminApiListClinicalAdminsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalAdminApi
     */
    listClinicalAdmins(requestParameters = {}, options) {
        return exports.ClinicalAdminApiFp(this.configuration).listClinicalAdmins(requestParameters.email, requestParameters.limit, requestParameters.name, requestParameters.page, requestParameters.phone, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ClinicalAdminApi = ClinicalAdminApi;
/**
 * ClinicalAppointmentApi - axios parameter creator
 * @export
 */
exports.ClinicalAppointmentApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} clinicalAppointmentId
         * @param {AddPatientToClinicalAppointmentRequest} addPatientToClinicalAppointmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPatientToClinicalAppointment: (clinicalAppointmentId, addPatientToClinicalAppointmentRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clinicalAppointmentId' is not null or undefined
            common_1.assertParamExists('addPatientToClinicalAppointment', 'clinicalAppointmentId', clinicalAppointmentId);
            // verify required parameter 'addPatientToClinicalAppointmentRequest' is not null or undefined
            common_1.assertParamExists('addPatientToClinicalAppointment', 'addPatientToClinicalAppointmentRequest', addPatientToClinicalAppointmentRequest);
            const localVarPath = `/v1/clinical-appointments/{clinical_appointment_id}/patients`
                .replace(`{${"clinical_appointment_id"}}`, encodeURIComponent(String(clinicalAppointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(addPatientToClinicalAppointmentRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} clinicAppointmentRequestId
         * @param {ApproveClinicAppointmentRequestRequest} approveClinicAppointmentRequestRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveClinicAppointmentRequest: (clinicAppointmentRequestId, approveClinicAppointmentRequestRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clinicAppointmentRequestId' is not null or undefined
            common_1.assertParamExists('approveClinicAppointmentRequest', 'clinicAppointmentRequestId', clinicAppointmentRequestId);
            // verify required parameter 'approveClinicAppointmentRequestRequest' is not null or undefined
            common_1.assertParamExists('approveClinicAppointmentRequest', 'approveClinicAppointmentRequestRequest', approveClinicAppointmentRequestRequest);
            const localVarPath = `/v1/clinic-appointment-requests/{clinic_appointment_request_id}/approve`
                .replace(`{${"clinic_appointment_request_id"}}`, encodeURIComponent(String(clinicAppointmentRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(approveClinicAppointmentRequestRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} clinicalAppointmentId
         * @param {CancelClinicalAppointmentApiRequest} cancelClinicalAppointmentApiRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelClinicalAppointment: (clinicalAppointmentId, cancelClinicalAppointmentApiRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clinicalAppointmentId' is not null or undefined
            common_1.assertParamExists('cancelClinicalAppointment', 'clinicalAppointmentId', clinicalAppointmentId);
            // verify required parameter 'cancelClinicalAppointmentApiRequest' is not null or undefined
            common_1.assertParamExists('cancelClinicalAppointment', 'cancelClinicalAppointmentApiRequest', cancelClinicalAppointmentApiRequest);
            const localVarPath = `/v1/clinical-appointments/{clinical_appointment_id}/cancel`
                .replace(`{${"clinical_appointment_id"}}`, encodeURIComponent(String(clinicalAppointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(cancelClinicalAppointmentApiRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Check-in for person at a clinic.
         * @param {string} clinicalAppointmentId
         * @param {CheckInPersonAtClinicRequest} checkInPersonAtClinicRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkinPersonAtClinic: (clinicalAppointmentId, checkInPersonAtClinicRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clinicalAppointmentId' is not null or undefined
            common_1.assertParamExists('checkinPersonAtClinic', 'clinicalAppointmentId', clinicalAppointmentId);
            // verify required parameter 'checkInPersonAtClinicRequest' is not null or undefined
            common_1.assertParamExists('checkinPersonAtClinic', 'checkInPersonAtClinicRequest', checkInPersonAtClinicRequest);
            const localVarPath = `/v1/clinical-appointments/{clinical_appointment_id}/checkin`
                .replace(`{${"clinical_appointment_id"}}`, encodeURIComponent(String(clinicalAppointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(checkInPersonAtClinicRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Check-in for person at an actively ongoing clinic. (PUBLIC API)
         * @param {string} clinicalAppointmentId
         * @param {CheckInPersonAtOngoingClinicRequest} [checkInPersonAtOngoingClinicRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkinPersonAtOngoingClinic: (clinicalAppointmentId, checkInPersonAtOngoingClinicRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clinicalAppointmentId' is not null or undefined
            common_1.assertParamExists('checkinPersonAtOngoingClinic', 'clinicalAppointmentId', clinicalAppointmentId);
            const localVarPath = `/v1/ongoing-clinics/{clinical_appointment_id}`
                .replace(`{${"clinical_appointment_id"}}`, encodeURIComponent(String(clinicalAppointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(checkInPersonAtOngoingClinicRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} clinicalAppointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeClinicalAppointmentRecap: (clinicalAppointmentId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clinicalAppointmentId' is not null or undefined
            common_1.assertParamExists('completeClinicalAppointmentRecap', 'clinicalAppointmentId', clinicalAppointmentId);
            const localVarPath = `/v1/clinical-appointments/{clinical_appointment_id}/complete-recap`
                .replace(`{${"clinical_appointment_id"}}`, encodeURIComponent(String(clinicalAppointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} appointmentId
         * @param {string} clinicId
         * @param {ConfirmClinicAttendanceRequest} confirmClinicAttendanceRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmClinicAttendance: (appointmentId, clinicId, confirmClinicAttendanceRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'appointmentId' is not null or undefined
            common_1.assertParamExists('confirmClinicAttendance', 'appointmentId', appointmentId);
            // verify required parameter 'clinicId' is not null or undefined
            common_1.assertParamExists('confirmClinicAttendance', 'clinicId', clinicId);
            // verify required parameter 'confirmClinicAttendanceRequest' is not null or undefined
            common_1.assertParamExists('confirmClinicAttendance', 'confirmClinicAttendanceRequest', confirmClinicAttendanceRequest);
            const localVarPath = `/v1/clinical-appointments/{clinic_id}/appointments/{appointment_id}/attendance-confirmation`
                .replace(`{${"appointment_id"}}`, encodeURIComponent(String(appointmentId)))
                .replace(`{${"clinic_id"}}`, encodeURIComponent(String(clinicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(confirmClinicAttendanceRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} clinicId
         * @param {ConfirmClinicLabDropOffApiRequest} confirmClinicLabDropOffApiRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmClinicLabDropOff: (clinicId, confirmClinicLabDropOffApiRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clinicId' is not null or undefined
            common_1.assertParamExists('confirmClinicLabDropOff', 'clinicId', clinicId);
            // verify required parameter 'confirmClinicLabDropOffApiRequest' is not null or undefined
            common_1.assertParamExists('confirmClinicLabDropOff', 'confirmClinicLabDropOffApiRequest', confirmClinicLabDropOffApiRequest);
            const localVarPath = `/v1/clinical-appointments/{clinic_id}/confirm-lab-drop-off`
                .replace(`{${"clinic_id"}}`, encodeURIComponent(String(clinicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(confirmClinicLabDropOffApiRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} clinicalAppointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClinicalAppointment: (clinicalAppointmentId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clinicalAppointmentId' is not null or undefined
            common_1.assertParamExists('getClinicalAppointment', 'clinicalAppointmentId', clinicalAppointmentId);
            const localVarPath = `/v1/clinical-appointments/{clinical_appointment_id}`
                .replace(`{${"clinical_appointment_id"}}`, encodeURIComponent(String(clinicalAppointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets an actively ongoing clinic. (PUBLIC API)
         * @param {string} clinicalAppointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOngoingClinic: (clinicalAppointmentId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clinicalAppointmentId' is not null or undefined
            common_1.assertParamExists('getOngoingClinic', 'clinicalAppointmentId', clinicalAppointmentId);
            const localVarPath = `/v1/ongoing-clinics/{clinical_appointment_id}`
                .replace(`{${"clinical_appointment_id"}}`, encodeURIComponent(String(clinicalAppointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [companyId]
         * @param {number} [limit]
         * @param {number} [page]
         * @param {'Child' | 'Adult' | 'Child & Adult' | 'null'} [patientType] * &#x60;Child&#x60; - Child * &#x60;Adult&#x60; - Adult * &#x60;Child &amp; Adult&#x60; - Child &amp; Adult
         * @param {boolean} [recurringClinicIn]
         * @param {'AL' | 'AK' | 'AZ' | 'AR' | 'CA' | 'CO' | 'CT' | 'DC' | 'DE' | 'FL' | 'GA' | 'HI' | 'ID' | 'IL' | 'IN' | 'IA' | 'KS' | 'KY' | 'LA' | 'ME' | 'MD' | 'MA' | 'MI' | 'MN' | 'MS' | 'MO' | 'MT' | 'NE' | 'NV' | 'NH' | 'NJ' | 'NM' | 'NY' | 'NC' | 'ND' | 'OH' | 'OK' | 'OR' | 'PR' | 'PA' | 'RI' | 'SC' | 'SD' | 'TN' | 'TX' | 'UT' | 'VT' | 'VI' | 'VA' | 'WA' | 'WI' | 'WV' | 'WY' | 'AA' | 'AE' | 'PW' | 'AP' | 'FM' | 'MH' | 'GU' | 'null'} [stateCode] * &#x60;AL&#x60; - AL * &#x60;AK&#x60; - AK * &#x60;AZ&#x60; - AZ * &#x60;AR&#x60; - AR * &#x60;CA&#x60; - CA * &#x60;CO&#x60; - CO * &#x60;CT&#x60; - CT * &#x60;DC&#x60; - DC * &#x60;DE&#x60; - DE * &#x60;FL&#x60; - FL * &#x60;GA&#x60; - GA * &#x60;HI&#x60; - HI * &#x60;ID&#x60; - ID * &#x60;IL&#x60; - IL * &#x60;IN&#x60; - IN * &#x60;IA&#x60; - IA * &#x60;KS&#x60; - KS * &#x60;KY&#x60; - KY * &#x60;LA&#x60; - LA * &#x60;ME&#x60; - ME * &#x60;MD&#x60; - MD * &#x60;MA&#x60; - MA * &#x60;MI&#x60; - MI * &#x60;MN&#x60; - MN * &#x60;MS&#x60; - MS * &#x60;MO&#x60; - MO * &#x60;MT&#x60; - MT * &#x60;NE&#x60; - NE * &#x60;NV&#x60; - NV * &#x60;NH&#x60; - NH * &#x60;NJ&#x60; - NJ * &#x60;NM&#x60; - NM * &#x60;NY&#x60; - NY * &#x60;NC&#x60; - NC * &#x60;ND&#x60; - ND * &#x60;OH&#x60; - OH * &#x60;OK&#x60; - OK * &#x60;OR&#x60; - OR * &#x60;PR&#x60; - PR * &#x60;PA&#x60; - PA * &#x60;RI&#x60; - RI * &#x60;SC&#x60; - SC * &#x60;SD&#x60; - SD * &#x60;TN&#x60; - TN * &#x60;TX&#x60; - TX * &#x60;UT&#x60; - UT * &#x60;VT&#x60; - VT * &#x60;VI&#x60; - VI * &#x60;VA&#x60; - VA * &#x60;WA&#x60; - WA * &#x60;WI&#x60; - WI * &#x60;WV&#x60; - WV * &#x60;WY&#x60; - WY * &#x60;AA&#x60; - AA * &#x60;AE&#x60; - AE * &#x60;PW&#x60; - PW * &#x60;AP&#x60; - AP * &#x60;FM&#x60; - FM * &#x60;MH&#x60; - MH * &#x60;GU&#x60; - GU
         * @param {'Denied' | 'Approved' | 'Pending' | 'null'} [status] * &#x60;Denied&#x60; - Denied * &#x60;Approved&#x60; - Approved * &#x60;Pending&#x60; - Pending
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listClinicAppointmentRequests: (companyId, limit, page, patientType, recurringClinicIn, stateCode, status, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/clinic-appointment-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (patientType !== undefined) {
                localVarQueryParameter['patient_type'] = patientType;
            }
            if (recurringClinicIn !== undefined) {
                localVarQueryParameter['recurring_clinic_in'] = recurringClinicIn;
            }
            if (stateCode !== undefined) {
                localVarQueryParameter['state_code'] = stateCode;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} clinicalAppointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listClinicalAppointmentTimeslots: (clinicalAppointmentId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clinicalAppointmentId' is not null or undefined
            common_1.assertParamExists('listClinicalAppointmentTimeslots', 'clinicalAppointmentId', clinicalAppointmentId);
            const localVarPath = `/v1/clinical-appointments/{clinical_appointment_id}/timeslots`
                .replace(`{${"clinical_appointment_id"}}`, encodeURIComponent(String(clinicalAppointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * List clinical appointments by filter
         * @param {string} [companyId]
         * @param {string} [endDatetime]
         * @param {boolean} [onlyActiveIn]
         * @param {boolean} [onlyFinishedIn]
         * @param {boolean} [onlyUnscheduledIn]
         * @param {number} [page]
         * @param {string} [providerId]
         * @param {string} [startDatetime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listClinicalAppointments: (companyId, endDatetime, onlyActiveIn, onlyFinishedIn, onlyUnscheduledIn, page, providerId, startDatetime, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/clinical-appointments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }
            if (endDatetime !== undefined) {
                localVarQueryParameter['end_datetime'] = (endDatetime instanceof Date) ?
                    endDatetime.toISOString() :
                    endDatetime;
            }
            if (onlyActiveIn !== undefined) {
                localVarQueryParameter['only_active_in'] = onlyActiveIn;
            }
            if (onlyFinishedIn !== undefined) {
                localVarQueryParameter['only_finished_in'] = onlyFinishedIn;
            }
            if (onlyUnscheduledIn !== undefined) {
                localVarQueryParameter['only_unscheduled_in'] = onlyUnscheduledIn;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (providerId !== undefined) {
                localVarQueryParameter['provider_id'] = providerId;
            }
            if (startDatetime !== undefined) {
                localVarQueryParameter['start_datetime'] = (startDatetime instanceof Date) ?
                    startDatetime.toISOString() :
                    startDatetime;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} companyId
         * @param {string} [endDatetime]
         * @param {boolean} [onlyActiveIn]
         * @param {boolean} [onlyCompletedIn]
         * @param {boolean} [onlyFinishedIn]
         * @param {boolean} [onlyRequestedIn]
         * @param {boolean} [onlyUpcomingIn]
         * @param {number} [page]
         * @param {string} [startDatetime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompanyClinicalAppointment: (companyId, endDatetime, onlyActiveIn, onlyCompletedIn, onlyFinishedIn, onlyRequestedIn, onlyUpcomingIn, page, startDatetime, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyId' is not null or undefined
            common_1.assertParamExists('listCompanyClinicalAppointment', 'companyId', companyId);
            const localVarPath = `/v1/companies/{company_id}/clinical-appointments`
                .replace(`{${"company_id"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (endDatetime !== undefined) {
                localVarQueryParameter['end_datetime'] = (endDatetime instanceof Date) ?
                    endDatetime.toISOString() :
                    endDatetime;
            }
            if (onlyActiveIn !== undefined) {
                localVarQueryParameter['only_active_in'] = onlyActiveIn;
            }
            if (onlyCompletedIn !== undefined) {
                localVarQueryParameter['only_completed_in'] = onlyCompletedIn;
            }
            if (onlyFinishedIn !== undefined) {
                localVarQueryParameter['only_finished_in'] = onlyFinishedIn;
            }
            if (onlyRequestedIn !== undefined) {
                localVarQueryParameter['only_requested_in'] = onlyRequestedIn;
            }
            if (onlyUpcomingIn !== undefined) {
                localVarQueryParameter['only_upcoming_in'] = onlyUpcomingIn;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (startDatetime !== undefined) {
                localVarQueryParameter['start_datetime'] = (startDatetime instanceof Date) ?
                    startDatetime.toISOString() :
                    startDatetime;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Lists all actively ongoing clinics. (PUBLIC API)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOngoingClinics: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/ongoing-clinics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} providerId
         * @param {string} [endDatetime]
         * @param {boolean} [onlyActiveIn]
         * @param {boolean} [onlyCompletedIn]
         * @param {boolean} [onlyFinishedIn]
         * @param {boolean} [onlyRequestedIn]
         * @param {boolean} [onlyUpcomingIn]
         * @param {number} [page]
         * @param {string} [startDatetime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProviderClinicalAppointments: (providerId, endDatetime, onlyActiveIn, onlyCompletedIn, onlyFinishedIn, onlyRequestedIn, onlyUpcomingIn, page, startDatetime, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'providerId' is not null or undefined
            common_1.assertParamExists('listProviderClinicalAppointments', 'providerId', providerId);
            const localVarPath = `/v1/providers/{provider_id}/clinical-appointments`
                .replace(`{${"provider_id"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (endDatetime !== undefined) {
                localVarQueryParameter['end_datetime'] = (endDatetime instanceof Date) ?
                    endDatetime.toISOString() :
                    endDatetime;
            }
            if (onlyActiveIn !== undefined) {
                localVarQueryParameter['only_active_in'] = onlyActiveIn;
            }
            if (onlyCompletedIn !== undefined) {
                localVarQueryParameter['only_completed_in'] = onlyCompletedIn;
            }
            if (onlyFinishedIn !== undefined) {
                localVarQueryParameter['only_finished_in'] = onlyFinishedIn;
            }
            if (onlyRequestedIn !== undefined) {
                localVarQueryParameter['only_requested_in'] = onlyRequestedIn;
            }
            if (onlyUpcomingIn !== undefined) {
                localVarQueryParameter['only_upcoming_in'] = onlyUpcomingIn;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (startDatetime !== undefined) {
                localVarQueryParameter['start_datetime'] = (startDatetime instanceof Date) ?
                    startDatetime.toISOString() :
                    startDatetime;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} clinicAppointmentId
         * @param {number} [page]
         * @param {'Pending' | 'Approved' | 'Rejected' | 'null'} [status] * &#x60;Pending&#x60; - Pending * &#x60;Approved&#x60; - Approved * &#x60;Rejected&#x60; - Rejected
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRequestedChangesForClinic: (clinicAppointmentId, page, status, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clinicAppointmentId' is not null or undefined
            common_1.assertParamExists('listRequestedChangesForClinic', 'clinicAppointmentId', clinicAppointmentId);
            const localVarPath = `/v1/clinical-appointment-changes/{clinic_appointment_id}`
                .replace(`{${"clinic_appointment_id"}}`, encodeURIComponent(String(clinicAppointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} clinicAppointmentRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectClinicAppointmentRequest: (clinicAppointmentRequestId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clinicAppointmentRequestId' is not null or undefined
            common_1.assertParamExists('rejectClinicAppointmentRequest', 'clinicAppointmentRequestId', clinicAppointmentRequestId);
            const localVarPath = `/v1/clinic-appointment-requests/{clinic_appointment_request_id}/reject`
                .replace(`{${"clinic_appointment_request_id"}}`, encodeURIComponent(String(clinicAppointmentRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} clinicAppointmentId
         * @param {RequestChangeForClinicRequest} requestChangeForClinicRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestChangeForClinic: (clinicAppointmentId, requestChangeForClinicRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clinicAppointmentId' is not null or undefined
            common_1.assertParamExists('requestChangeForClinic', 'clinicAppointmentId', clinicAppointmentId);
            // verify required parameter 'requestChangeForClinicRequest' is not null or undefined
            common_1.assertParamExists('requestChangeForClinic', 'requestChangeForClinicRequest', requestChangeForClinicRequest);
            const localVarPath = `/v1/clinical-appointment-changes/{clinic_appointment_id}`
                .replace(`{${"clinic_appointment_id"}}`, encodeURIComponent(String(clinicAppointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(requestChangeForClinicRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {RequestClinicAppointmentRequest} requestClinicAppointmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestClinicAppointment: (requestClinicAppointmentRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'requestClinicAppointmentRequest' is not null or undefined
            common_1.assertParamExists('requestClinicAppointment', 'requestClinicAppointmentRequest', requestClinicAppointmentRequest);
            const localVarPath = `/v1/clinic-appointment-requests/request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(requestClinicAppointmentRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ScheduleClinicAppointmentRequest} scheduleClinicAppointmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleClinicalAppointment: (scheduleClinicAppointmentRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'scheduleClinicAppointmentRequest' is not null or undefined
            common_1.assertParamExists('scheduleClinicalAppointment', 'scheduleClinicAppointmentRequest', scheduleClinicAppointmentRequest);
            const localVarPath = `/v1/clinical-appointments/schedule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(scheduleClinicAppointmentRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} clinicId
         * @param {UpdateClinicPointOfContactApiRequest} updateClinicPointOfContactApiRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClinicPointOfContact: (clinicId, updateClinicPointOfContactApiRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clinicId' is not null or undefined
            common_1.assertParamExists('updateClinicPointOfContact', 'clinicId', clinicId);
            // verify required parameter 'updateClinicPointOfContactApiRequest' is not null or undefined
            common_1.assertParamExists('updateClinicPointOfContact', 'updateClinicPointOfContactApiRequest', updateClinicPointOfContactApiRequest);
            const localVarPath = `/v1/clinical-appointments/{clinic_id}/update-point-of-contact`
                .replace(`{${"clinic_id"}}`, encodeURIComponent(String(clinicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateClinicPointOfContactApiRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} clinicalAppointmentId
         * @param {UpdateClinicalAppointmentProgressRequest} updateClinicalAppointmentProgressRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClinicalAppointmentProgress: (clinicalAppointmentId, updateClinicalAppointmentProgressRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clinicalAppointmentId' is not null or undefined
            common_1.assertParamExists('updateClinicalAppointmentProgress', 'clinicalAppointmentId', clinicalAppointmentId);
            // verify required parameter 'updateClinicalAppointmentProgressRequest' is not null or undefined
            common_1.assertParamExists('updateClinicalAppointmentProgress', 'updateClinicalAppointmentProgressRequest', updateClinicalAppointmentProgressRequest);
            const localVarPath = `/v1/clinical-appointments/{clinical_appointment_id}/progress`
                .replace(`{${"clinical_appointment_id"}}`, encodeURIComponent(String(clinicalAppointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateClinicalAppointmentProgressRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ClinicalAppointmentApi - functional programming interface
 * @export
 */
exports.ClinicalAppointmentApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.ClinicalAppointmentApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} clinicalAppointmentId
         * @param {AddPatientToClinicalAppointmentRequest} addPatientToClinicalAppointmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPatientToClinicalAppointment(clinicalAppointmentId, addPatientToClinicalAppointmentRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addPatientToClinicalAppointment(clinicalAppointmentId, addPatientToClinicalAppointmentRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} clinicAppointmentRequestId
         * @param {ApproveClinicAppointmentRequestRequest} approveClinicAppointmentRequestRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveClinicAppointmentRequest(clinicAppointmentRequestId, approveClinicAppointmentRequestRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.approveClinicAppointmentRequest(clinicAppointmentRequestId, approveClinicAppointmentRequestRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} clinicalAppointmentId
         * @param {CancelClinicalAppointmentApiRequest} cancelClinicalAppointmentApiRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelClinicalAppointment(clinicalAppointmentId, cancelClinicalAppointmentApiRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cancelClinicalAppointment(clinicalAppointmentId, cancelClinicalAppointmentApiRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Check-in for person at a clinic.
         * @param {string} clinicalAppointmentId
         * @param {CheckInPersonAtClinicRequest} checkInPersonAtClinicRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkinPersonAtClinic(clinicalAppointmentId, checkInPersonAtClinicRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.checkinPersonAtClinic(clinicalAppointmentId, checkInPersonAtClinicRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Check-in for person at an actively ongoing clinic. (PUBLIC API)
         * @param {string} clinicalAppointmentId
         * @param {CheckInPersonAtOngoingClinicRequest} [checkInPersonAtOngoingClinicRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkinPersonAtOngoingClinic(clinicalAppointmentId, checkInPersonAtOngoingClinicRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.checkinPersonAtOngoingClinic(clinicalAppointmentId, checkInPersonAtOngoingClinicRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} clinicalAppointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeClinicalAppointmentRecap(clinicalAppointmentId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.completeClinicalAppointmentRecap(clinicalAppointmentId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} appointmentId
         * @param {string} clinicId
         * @param {ConfirmClinicAttendanceRequest} confirmClinicAttendanceRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmClinicAttendance(appointmentId, clinicId, confirmClinicAttendanceRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.confirmClinicAttendance(appointmentId, clinicId, confirmClinicAttendanceRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} clinicId
         * @param {ConfirmClinicLabDropOffApiRequest} confirmClinicLabDropOffApiRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmClinicLabDropOff(clinicId, confirmClinicLabDropOffApiRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.confirmClinicLabDropOff(clinicId, confirmClinicLabDropOffApiRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} clinicalAppointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClinicalAppointment(clinicalAppointmentId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getClinicalAppointment(clinicalAppointmentId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets an actively ongoing clinic. (PUBLIC API)
         * @param {string} clinicalAppointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOngoingClinic(clinicalAppointmentId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getOngoingClinic(clinicalAppointmentId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} [companyId]
         * @param {number} [limit]
         * @param {number} [page]
         * @param {'Child' | 'Adult' | 'Child & Adult' | 'null'} [patientType] * &#x60;Child&#x60; - Child * &#x60;Adult&#x60; - Adult * &#x60;Child &amp; Adult&#x60; - Child &amp; Adult
         * @param {boolean} [recurringClinicIn]
         * @param {'AL' | 'AK' | 'AZ' | 'AR' | 'CA' | 'CO' | 'CT' | 'DC' | 'DE' | 'FL' | 'GA' | 'HI' | 'ID' | 'IL' | 'IN' | 'IA' | 'KS' | 'KY' | 'LA' | 'ME' | 'MD' | 'MA' | 'MI' | 'MN' | 'MS' | 'MO' | 'MT' | 'NE' | 'NV' | 'NH' | 'NJ' | 'NM' | 'NY' | 'NC' | 'ND' | 'OH' | 'OK' | 'OR' | 'PR' | 'PA' | 'RI' | 'SC' | 'SD' | 'TN' | 'TX' | 'UT' | 'VT' | 'VI' | 'VA' | 'WA' | 'WI' | 'WV' | 'WY' | 'AA' | 'AE' | 'PW' | 'AP' | 'FM' | 'MH' | 'GU' | 'null'} [stateCode] * &#x60;AL&#x60; - AL * &#x60;AK&#x60; - AK * &#x60;AZ&#x60; - AZ * &#x60;AR&#x60; - AR * &#x60;CA&#x60; - CA * &#x60;CO&#x60; - CO * &#x60;CT&#x60; - CT * &#x60;DC&#x60; - DC * &#x60;DE&#x60; - DE * &#x60;FL&#x60; - FL * &#x60;GA&#x60; - GA * &#x60;HI&#x60; - HI * &#x60;ID&#x60; - ID * &#x60;IL&#x60; - IL * &#x60;IN&#x60; - IN * &#x60;IA&#x60; - IA * &#x60;KS&#x60; - KS * &#x60;KY&#x60; - KY * &#x60;LA&#x60; - LA * &#x60;ME&#x60; - ME * &#x60;MD&#x60; - MD * &#x60;MA&#x60; - MA * &#x60;MI&#x60; - MI * &#x60;MN&#x60; - MN * &#x60;MS&#x60; - MS * &#x60;MO&#x60; - MO * &#x60;MT&#x60; - MT * &#x60;NE&#x60; - NE * &#x60;NV&#x60; - NV * &#x60;NH&#x60; - NH * &#x60;NJ&#x60; - NJ * &#x60;NM&#x60; - NM * &#x60;NY&#x60; - NY * &#x60;NC&#x60; - NC * &#x60;ND&#x60; - ND * &#x60;OH&#x60; - OH * &#x60;OK&#x60; - OK * &#x60;OR&#x60; - OR * &#x60;PR&#x60; - PR * &#x60;PA&#x60; - PA * &#x60;RI&#x60; - RI * &#x60;SC&#x60; - SC * &#x60;SD&#x60; - SD * &#x60;TN&#x60; - TN * &#x60;TX&#x60; - TX * &#x60;UT&#x60; - UT * &#x60;VT&#x60; - VT * &#x60;VI&#x60; - VI * &#x60;VA&#x60; - VA * &#x60;WA&#x60; - WA * &#x60;WI&#x60; - WI * &#x60;WV&#x60; - WV * &#x60;WY&#x60; - WY * &#x60;AA&#x60; - AA * &#x60;AE&#x60; - AE * &#x60;PW&#x60; - PW * &#x60;AP&#x60; - AP * &#x60;FM&#x60; - FM * &#x60;MH&#x60; - MH * &#x60;GU&#x60; - GU
         * @param {'Denied' | 'Approved' | 'Pending' | 'null'} [status] * &#x60;Denied&#x60; - Denied * &#x60;Approved&#x60; - Approved * &#x60;Pending&#x60; - Pending
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listClinicAppointmentRequests(companyId, limit, page, patientType, recurringClinicIn, stateCode, status, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listClinicAppointmentRequests(companyId, limit, page, patientType, recurringClinicIn, stateCode, status, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} clinicalAppointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listClinicalAppointmentTimeslots(clinicalAppointmentId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listClinicalAppointmentTimeslots(clinicalAppointmentId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * List clinical appointments by filter
         * @param {string} [companyId]
         * @param {string} [endDatetime]
         * @param {boolean} [onlyActiveIn]
         * @param {boolean} [onlyFinishedIn]
         * @param {boolean} [onlyUnscheduledIn]
         * @param {number} [page]
         * @param {string} [providerId]
         * @param {string} [startDatetime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listClinicalAppointments(companyId, endDatetime, onlyActiveIn, onlyFinishedIn, onlyUnscheduledIn, page, providerId, startDatetime, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listClinicalAppointments(companyId, endDatetime, onlyActiveIn, onlyFinishedIn, onlyUnscheduledIn, page, providerId, startDatetime, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} companyId
         * @param {string} [endDatetime]
         * @param {boolean} [onlyActiveIn]
         * @param {boolean} [onlyCompletedIn]
         * @param {boolean} [onlyFinishedIn]
         * @param {boolean} [onlyRequestedIn]
         * @param {boolean} [onlyUpcomingIn]
         * @param {number} [page]
         * @param {string} [startDatetime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompanyClinicalAppointment(companyId, endDatetime, onlyActiveIn, onlyCompletedIn, onlyFinishedIn, onlyRequestedIn, onlyUpcomingIn, page, startDatetime, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listCompanyClinicalAppointment(companyId, endDatetime, onlyActiveIn, onlyCompletedIn, onlyFinishedIn, onlyRequestedIn, onlyUpcomingIn, page, startDatetime, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Lists all actively ongoing clinics. (PUBLIC API)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOngoingClinics(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listOngoingClinics(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} providerId
         * @param {string} [endDatetime]
         * @param {boolean} [onlyActiveIn]
         * @param {boolean} [onlyCompletedIn]
         * @param {boolean} [onlyFinishedIn]
         * @param {boolean} [onlyRequestedIn]
         * @param {boolean} [onlyUpcomingIn]
         * @param {number} [page]
         * @param {string} [startDatetime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProviderClinicalAppointments(providerId, endDatetime, onlyActiveIn, onlyCompletedIn, onlyFinishedIn, onlyRequestedIn, onlyUpcomingIn, page, startDatetime, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listProviderClinicalAppointments(providerId, endDatetime, onlyActiveIn, onlyCompletedIn, onlyFinishedIn, onlyRequestedIn, onlyUpcomingIn, page, startDatetime, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} clinicAppointmentId
         * @param {number} [page]
         * @param {'Pending' | 'Approved' | 'Rejected' | 'null'} [status] * &#x60;Pending&#x60; - Pending * &#x60;Approved&#x60; - Approved * &#x60;Rejected&#x60; - Rejected
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRequestedChangesForClinic(clinicAppointmentId, page, status, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listRequestedChangesForClinic(clinicAppointmentId, page, status, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} clinicAppointmentRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectClinicAppointmentRequest(clinicAppointmentRequestId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.rejectClinicAppointmentRequest(clinicAppointmentRequestId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} clinicAppointmentId
         * @param {RequestChangeForClinicRequest} requestChangeForClinicRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestChangeForClinic(clinicAppointmentId, requestChangeForClinicRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.requestChangeForClinic(clinicAppointmentId, requestChangeForClinicRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {RequestClinicAppointmentRequest} requestClinicAppointmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestClinicAppointment(requestClinicAppointmentRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.requestClinicAppointment(requestClinicAppointmentRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {ScheduleClinicAppointmentRequest} scheduleClinicAppointmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleClinicalAppointment(scheduleClinicAppointmentRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.scheduleClinicalAppointment(scheduleClinicAppointmentRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} clinicId
         * @param {UpdateClinicPointOfContactApiRequest} updateClinicPointOfContactApiRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClinicPointOfContact(clinicId, updateClinicPointOfContactApiRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateClinicPointOfContact(clinicId, updateClinicPointOfContactApiRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} clinicalAppointmentId
         * @param {UpdateClinicalAppointmentProgressRequest} updateClinicalAppointmentProgressRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClinicalAppointmentProgress(clinicalAppointmentId, updateClinicalAppointmentProgressRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateClinicalAppointmentProgress(clinicalAppointmentId, updateClinicalAppointmentProgressRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ClinicalAppointmentApi - factory interface
 * @export
 */
exports.ClinicalAppointmentApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.ClinicalAppointmentApiFp(configuration);
    return {
        /**
         *
         * @param {string} clinicalAppointmentId
         * @param {AddPatientToClinicalAppointmentRequest} addPatientToClinicalAppointmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPatientToClinicalAppointment(clinicalAppointmentId, addPatientToClinicalAppointmentRequest, options) {
            return localVarFp.addPatientToClinicalAppointment(clinicalAppointmentId, addPatientToClinicalAppointmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} clinicAppointmentRequestId
         * @param {ApproveClinicAppointmentRequestRequest} approveClinicAppointmentRequestRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveClinicAppointmentRequest(clinicAppointmentRequestId, approveClinicAppointmentRequestRequest, options) {
            return localVarFp.approveClinicAppointmentRequest(clinicAppointmentRequestId, approveClinicAppointmentRequestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} clinicalAppointmentId
         * @param {CancelClinicalAppointmentApiRequest} cancelClinicalAppointmentApiRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelClinicalAppointment(clinicalAppointmentId, cancelClinicalAppointmentApiRequest, options) {
            return localVarFp.cancelClinicalAppointment(clinicalAppointmentId, cancelClinicalAppointmentApiRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Check-in for person at a clinic.
         * @param {string} clinicalAppointmentId
         * @param {CheckInPersonAtClinicRequest} checkInPersonAtClinicRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkinPersonAtClinic(clinicalAppointmentId, checkInPersonAtClinicRequest, options) {
            return localVarFp.checkinPersonAtClinic(clinicalAppointmentId, checkInPersonAtClinicRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Check-in for person at an actively ongoing clinic. (PUBLIC API)
         * @param {string} clinicalAppointmentId
         * @param {CheckInPersonAtOngoingClinicRequest} [checkInPersonAtOngoingClinicRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkinPersonAtOngoingClinic(clinicalAppointmentId, checkInPersonAtOngoingClinicRequest, options) {
            return localVarFp.checkinPersonAtOngoingClinic(clinicalAppointmentId, checkInPersonAtOngoingClinicRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} clinicalAppointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeClinicalAppointmentRecap(clinicalAppointmentId, options) {
            return localVarFp.completeClinicalAppointmentRecap(clinicalAppointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} appointmentId
         * @param {string} clinicId
         * @param {ConfirmClinicAttendanceRequest} confirmClinicAttendanceRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmClinicAttendance(appointmentId, clinicId, confirmClinicAttendanceRequest, options) {
            return localVarFp.confirmClinicAttendance(appointmentId, clinicId, confirmClinicAttendanceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} clinicId
         * @param {ConfirmClinicLabDropOffApiRequest} confirmClinicLabDropOffApiRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmClinicLabDropOff(clinicId, confirmClinicLabDropOffApiRequest, options) {
            return localVarFp.confirmClinicLabDropOff(clinicId, confirmClinicLabDropOffApiRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} clinicalAppointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClinicalAppointment(clinicalAppointmentId, options) {
            return localVarFp.getClinicalAppointment(clinicalAppointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets an actively ongoing clinic. (PUBLIC API)
         * @param {string} clinicalAppointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOngoingClinic(clinicalAppointmentId, options) {
            return localVarFp.getOngoingClinic(clinicalAppointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [companyId]
         * @param {number} [limit]
         * @param {number} [page]
         * @param {'Child' | 'Adult' | 'Child & Adult' | 'null'} [patientType] * &#x60;Child&#x60; - Child * &#x60;Adult&#x60; - Adult * &#x60;Child &amp; Adult&#x60; - Child &amp; Adult
         * @param {boolean} [recurringClinicIn]
         * @param {'AL' | 'AK' | 'AZ' | 'AR' | 'CA' | 'CO' | 'CT' | 'DC' | 'DE' | 'FL' | 'GA' | 'HI' | 'ID' | 'IL' | 'IN' | 'IA' | 'KS' | 'KY' | 'LA' | 'ME' | 'MD' | 'MA' | 'MI' | 'MN' | 'MS' | 'MO' | 'MT' | 'NE' | 'NV' | 'NH' | 'NJ' | 'NM' | 'NY' | 'NC' | 'ND' | 'OH' | 'OK' | 'OR' | 'PR' | 'PA' | 'RI' | 'SC' | 'SD' | 'TN' | 'TX' | 'UT' | 'VT' | 'VI' | 'VA' | 'WA' | 'WI' | 'WV' | 'WY' | 'AA' | 'AE' | 'PW' | 'AP' | 'FM' | 'MH' | 'GU' | 'null'} [stateCode] * &#x60;AL&#x60; - AL * &#x60;AK&#x60; - AK * &#x60;AZ&#x60; - AZ * &#x60;AR&#x60; - AR * &#x60;CA&#x60; - CA * &#x60;CO&#x60; - CO * &#x60;CT&#x60; - CT * &#x60;DC&#x60; - DC * &#x60;DE&#x60; - DE * &#x60;FL&#x60; - FL * &#x60;GA&#x60; - GA * &#x60;HI&#x60; - HI * &#x60;ID&#x60; - ID * &#x60;IL&#x60; - IL * &#x60;IN&#x60; - IN * &#x60;IA&#x60; - IA * &#x60;KS&#x60; - KS * &#x60;KY&#x60; - KY * &#x60;LA&#x60; - LA * &#x60;ME&#x60; - ME * &#x60;MD&#x60; - MD * &#x60;MA&#x60; - MA * &#x60;MI&#x60; - MI * &#x60;MN&#x60; - MN * &#x60;MS&#x60; - MS * &#x60;MO&#x60; - MO * &#x60;MT&#x60; - MT * &#x60;NE&#x60; - NE * &#x60;NV&#x60; - NV * &#x60;NH&#x60; - NH * &#x60;NJ&#x60; - NJ * &#x60;NM&#x60; - NM * &#x60;NY&#x60; - NY * &#x60;NC&#x60; - NC * &#x60;ND&#x60; - ND * &#x60;OH&#x60; - OH * &#x60;OK&#x60; - OK * &#x60;OR&#x60; - OR * &#x60;PR&#x60; - PR * &#x60;PA&#x60; - PA * &#x60;RI&#x60; - RI * &#x60;SC&#x60; - SC * &#x60;SD&#x60; - SD * &#x60;TN&#x60; - TN * &#x60;TX&#x60; - TX * &#x60;UT&#x60; - UT * &#x60;VT&#x60; - VT * &#x60;VI&#x60; - VI * &#x60;VA&#x60; - VA * &#x60;WA&#x60; - WA * &#x60;WI&#x60; - WI * &#x60;WV&#x60; - WV * &#x60;WY&#x60; - WY * &#x60;AA&#x60; - AA * &#x60;AE&#x60; - AE * &#x60;PW&#x60; - PW * &#x60;AP&#x60; - AP * &#x60;FM&#x60; - FM * &#x60;MH&#x60; - MH * &#x60;GU&#x60; - GU
         * @param {'Denied' | 'Approved' | 'Pending' | 'null'} [status] * &#x60;Denied&#x60; - Denied * &#x60;Approved&#x60; - Approved * &#x60;Pending&#x60; - Pending
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listClinicAppointmentRequests(companyId, limit, page, patientType, recurringClinicIn, stateCode, status, options) {
            return localVarFp.listClinicAppointmentRequests(companyId, limit, page, patientType, recurringClinicIn, stateCode, status, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} clinicalAppointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listClinicalAppointmentTimeslots(clinicalAppointmentId, options) {
            return localVarFp.listClinicalAppointmentTimeslots(clinicalAppointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * List clinical appointments by filter
         * @param {string} [companyId]
         * @param {string} [endDatetime]
         * @param {boolean} [onlyActiveIn]
         * @param {boolean} [onlyFinishedIn]
         * @param {boolean} [onlyUnscheduledIn]
         * @param {number} [page]
         * @param {string} [providerId]
         * @param {string} [startDatetime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listClinicalAppointments(companyId, endDatetime, onlyActiveIn, onlyFinishedIn, onlyUnscheduledIn, page, providerId, startDatetime, options) {
            return localVarFp.listClinicalAppointments(companyId, endDatetime, onlyActiveIn, onlyFinishedIn, onlyUnscheduledIn, page, providerId, startDatetime, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} companyId
         * @param {string} [endDatetime]
         * @param {boolean} [onlyActiveIn]
         * @param {boolean} [onlyCompletedIn]
         * @param {boolean} [onlyFinishedIn]
         * @param {boolean} [onlyRequestedIn]
         * @param {boolean} [onlyUpcomingIn]
         * @param {number} [page]
         * @param {string} [startDatetime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompanyClinicalAppointment(companyId, endDatetime, onlyActiveIn, onlyCompletedIn, onlyFinishedIn, onlyRequestedIn, onlyUpcomingIn, page, startDatetime, options) {
            return localVarFp.listCompanyClinicalAppointment(companyId, endDatetime, onlyActiveIn, onlyCompletedIn, onlyFinishedIn, onlyRequestedIn, onlyUpcomingIn, page, startDatetime, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists all actively ongoing clinics. (PUBLIC API)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOngoingClinics(options) {
            return localVarFp.listOngoingClinics(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} providerId
         * @param {string} [endDatetime]
         * @param {boolean} [onlyActiveIn]
         * @param {boolean} [onlyCompletedIn]
         * @param {boolean} [onlyFinishedIn]
         * @param {boolean} [onlyRequestedIn]
         * @param {boolean} [onlyUpcomingIn]
         * @param {number} [page]
         * @param {string} [startDatetime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProviderClinicalAppointments(providerId, endDatetime, onlyActiveIn, onlyCompletedIn, onlyFinishedIn, onlyRequestedIn, onlyUpcomingIn, page, startDatetime, options) {
            return localVarFp.listProviderClinicalAppointments(providerId, endDatetime, onlyActiveIn, onlyCompletedIn, onlyFinishedIn, onlyRequestedIn, onlyUpcomingIn, page, startDatetime, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} clinicAppointmentId
         * @param {number} [page]
         * @param {'Pending' | 'Approved' | 'Rejected' | 'null'} [status] * &#x60;Pending&#x60; - Pending * &#x60;Approved&#x60; - Approved * &#x60;Rejected&#x60; - Rejected
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRequestedChangesForClinic(clinicAppointmentId, page, status, options) {
            return localVarFp.listRequestedChangesForClinic(clinicAppointmentId, page, status, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} clinicAppointmentRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectClinicAppointmentRequest(clinicAppointmentRequestId, options) {
            return localVarFp.rejectClinicAppointmentRequest(clinicAppointmentRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} clinicAppointmentId
         * @param {RequestChangeForClinicRequest} requestChangeForClinicRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestChangeForClinic(clinicAppointmentId, requestChangeForClinicRequest, options) {
            return localVarFp.requestChangeForClinic(clinicAppointmentId, requestChangeForClinicRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {RequestClinicAppointmentRequest} requestClinicAppointmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestClinicAppointment(requestClinicAppointmentRequest, options) {
            return localVarFp.requestClinicAppointment(requestClinicAppointmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ScheduleClinicAppointmentRequest} scheduleClinicAppointmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleClinicalAppointment(scheduleClinicAppointmentRequest, options) {
            return localVarFp.scheduleClinicalAppointment(scheduleClinicAppointmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} clinicId
         * @param {UpdateClinicPointOfContactApiRequest} updateClinicPointOfContactApiRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClinicPointOfContact(clinicId, updateClinicPointOfContactApiRequest, options) {
            return localVarFp.updateClinicPointOfContact(clinicId, updateClinicPointOfContactApiRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} clinicalAppointmentId
         * @param {UpdateClinicalAppointmentProgressRequest} updateClinicalAppointmentProgressRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClinicalAppointmentProgress(clinicalAppointmentId, updateClinicalAppointmentProgressRequest, options) {
            return localVarFp.updateClinicalAppointmentProgress(clinicalAppointmentId, updateClinicalAppointmentProgressRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ClinicalAppointmentApi - object-oriented interface
 * @export
 * @class ClinicalAppointmentApi
 * @extends {BaseAPI}
 */
class ClinicalAppointmentApi extends base_1.BaseAPI {
    /**
     *
     * @param {ClinicalAppointmentApiAddPatientToClinicalAppointmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalAppointmentApi
     */
    addPatientToClinicalAppointment(requestParameters, options) {
        return exports.ClinicalAppointmentApiFp(this.configuration).addPatientToClinicalAppointment(requestParameters.clinicalAppointmentId, requestParameters.addPatientToClinicalAppointmentRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ClinicalAppointmentApiApproveClinicAppointmentRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalAppointmentApi
     */
    approveClinicAppointmentRequest(requestParameters, options) {
        return exports.ClinicalAppointmentApiFp(this.configuration).approveClinicAppointmentRequest(requestParameters.clinicAppointmentRequestId, requestParameters.approveClinicAppointmentRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ClinicalAppointmentApiCancelClinicalAppointmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalAppointmentApi
     */
    cancelClinicalAppointment(requestParameters, options) {
        return exports.ClinicalAppointmentApiFp(this.configuration).cancelClinicalAppointment(requestParameters.clinicalAppointmentId, requestParameters.cancelClinicalAppointmentApiRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Check-in for person at a clinic.
     * @param {ClinicalAppointmentApiCheckinPersonAtClinicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalAppointmentApi
     */
    checkinPersonAtClinic(requestParameters, options) {
        return exports.ClinicalAppointmentApiFp(this.configuration).checkinPersonAtClinic(requestParameters.clinicalAppointmentId, requestParameters.checkInPersonAtClinicRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Check-in for person at an actively ongoing clinic. (PUBLIC API)
     * @param {ClinicalAppointmentApiCheckinPersonAtOngoingClinicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalAppointmentApi
     */
    checkinPersonAtOngoingClinic(requestParameters, options) {
        return exports.ClinicalAppointmentApiFp(this.configuration).checkinPersonAtOngoingClinic(requestParameters.clinicalAppointmentId, requestParameters.checkInPersonAtOngoingClinicRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ClinicalAppointmentApiCompleteClinicalAppointmentRecapRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalAppointmentApi
     */
    completeClinicalAppointmentRecap(requestParameters, options) {
        return exports.ClinicalAppointmentApiFp(this.configuration).completeClinicalAppointmentRecap(requestParameters.clinicalAppointmentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ClinicalAppointmentApiConfirmClinicAttendanceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalAppointmentApi
     */
    confirmClinicAttendance(requestParameters, options) {
        return exports.ClinicalAppointmentApiFp(this.configuration).confirmClinicAttendance(requestParameters.appointmentId, requestParameters.clinicId, requestParameters.confirmClinicAttendanceRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ClinicalAppointmentApiConfirmClinicLabDropOffRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalAppointmentApi
     */
    confirmClinicLabDropOff(requestParameters, options) {
        return exports.ClinicalAppointmentApiFp(this.configuration).confirmClinicLabDropOff(requestParameters.clinicId, requestParameters.confirmClinicLabDropOffApiRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ClinicalAppointmentApiGetClinicalAppointmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalAppointmentApi
     */
    getClinicalAppointment(requestParameters, options) {
        return exports.ClinicalAppointmentApiFp(this.configuration).getClinicalAppointment(requestParameters.clinicalAppointmentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets an actively ongoing clinic. (PUBLIC API)
     * @param {ClinicalAppointmentApiGetOngoingClinicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalAppointmentApi
     */
    getOngoingClinic(requestParameters, options) {
        return exports.ClinicalAppointmentApiFp(this.configuration).getOngoingClinic(requestParameters.clinicalAppointmentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ClinicalAppointmentApiListClinicAppointmentRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalAppointmentApi
     */
    listClinicAppointmentRequests(requestParameters = {}, options) {
        return exports.ClinicalAppointmentApiFp(this.configuration).listClinicAppointmentRequests(requestParameters.companyId, requestParameters.limit, requestParameters.page, requestParameters.patientType, requestParameters.recurringClinicIn, requestParameters.stateCode, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ClinicalAppointmentApiListClinicalAppointmentTimeslotsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalAppointmentApi
     */
    listClinicalAppointmentTimeslots(requestParameters, options) {
        return exports.ClinicalAppointmentApiFp(this.configuration).listClinicalAppointmentTimeslots(requestParameters.clinicalAppointmentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * List clinical appointments by filter
     * @param {ClinicalAppointmentApiListClinicalAppointmentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalAppointmentApi
     */
    listClinicalAppointments(requestParameters = {}, options) {
        return exports.ClinicalAppointmentApiFp(this.configuration).listClinicalAppointments(requestParameters.companyId, requestParameters.endDatetime, requestParameters.onlyActiveIn, requestParameters.onlyFinishedIn, requestParameters.onlyUnscheduledIn, requestParameters.page, requestParameters.providerId, requestParameters.startDatetime, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ClinicalAppointmentApiListCompanyClinicalAppointmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalAppointmentApi
     */
    listCompanyClinicalAppointment(requestParameters, options) {
        return exports.ClinicalAppointmentApiFp(this.configuration).listCompanyClinicalAppointment(requestParameters.companyId, requestParameters.endDatetime, requestParameters.onlyActiveIn, requestParameters.onlyCompletedIn, requestParameters.onlyFinishedIn, requestParameters.onlyRequestedIn, requestParameters.onlyUpcomingIn, requestParameters.page, requestParameters.startDatetime, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Lists all actively ongoing clinics. (PUBLIC API)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalAppointmentApi
     */
    listOngoingClinics(options) {
        return exports.ClinicalAppointmentApiFp(this.configuration).listOngoingClinics(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ClinicalAppointmentApiListProviderClinicalAppointmentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalAppointmentApi
     */
    listProviderClinicalAppointments(requestParameters, options) {
        return exports.ClinicalAppointmentApiFp(this.configuration).listProviderClinicalAppointments(requestParameters.providerId, requestParameters.endDatetime, requestParameters.onlyActiveIn, requestParameters.onlyCompletedIn, requestParameters.onlyFinishedIn, requestParameters.onlyRequestedIn, requestParameters.onlyUpcomingIn, requestParameters.page, requestParameters.startDatetime, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ClinicalAppointmentApiListRequestedChangesForClinicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalAppointmentApi
     */
    listRequestedChangesForClinic(requestParameters, options) {
        return exports.ClinicalAppointmentApiFp(this.configuration).listRequestedChangesForClinic(requestParameters.clinicAppointmentId, requestParameters.page, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ClinicalAppointmentApiRejectClinicAppointmentRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalAppointmentApi
     */
    rejectClinicAppointmentRequest(requestParameters, options) {
        return exports.ClinicalAppointmentApiFp(this.configuration).rejectClinicAppointmentRequest(requestParameters.clinicAppointmentRequestId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ClinicalAppointmentApiRequestChangeForClinicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalAppointmentApi
     */
    requestChangeForClinic(requestParameters, options) {
        return exports.ClinicalAppointmentApiFp(this.configuration).requestChangeForClinic(requestParameters.clinicAppointmentId, requestParameters.requestChangeForClinicRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ClinicalAppointmentApiRequestClinicAppointmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalAppointmentApi
     */
    requestClinicAppointment(requestParameters, options) {
        return exports.ClinicalAppointmentApiFp(this.configuration).requestClinicAppointment(requestParameters.requestClinicAppointmentRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ClinicalAppointmentApiScheduleClinicalAppointmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalAppointmentApi
     */
    scheduleClinicalAppointment(requestParameters, options) {
        return exports.ClinicalAppointmentApiFp(this.configuration).scheduleClinicalAppointment(requestParameters.scheduleClinicAppointmentRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ClinicalAppointmentApiUpdateClinicPointOfContactRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalAppointmentApi
     */
    updateClinicPointOfContact(requestParameters, options) {
        return exports.ClinicalAppointmentApiFp(this.configuration).updateClinicPointOfContact(requestParameters.clinicId, requestParameters.updateClinicPointOfContactApiRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ClinicalAppointmentApiUpdateClinicalAppointmentProgressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalAppointmentApi
     */
    updateClinicalAppointmentProgress(requestParameters, options) {
        return exports.ClinicalAppointmentApiFp(this.configuration).updateClinicalAppointmentProgress(requestParameters.clinicalAppointmentId, requestParameters.updateClinicalAppointmentProgressRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ClinicalAppointmentApi = ClinicalAppointmentApi;
/**
 * CommentsApi - axios parameter creator
 * @export
 */
exports.CommentsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreateCommentRequest} createCommentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createComment: (createCommentRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createCommentRequest' is not null or undefined
            common_1.assertParamExists('createComment', 'createCommentRequest', createCommentRequest);
            const localVarPath = `/v1/comments/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createCommentRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {GetOrCreateCommentThreadRequest} [getOrCreateCommentThreadRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrCreateCommentThread: (getOrCreateCommentThreadRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/comment-threads/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(getOrCreateCommentThreadRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} commentThreadId
         * @param {boolean} [orderByNewest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listComments: (commentThreadId, orderByNewest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'commentThreadId' is not null or undefined
            common_1.assertParamExists('listComments', 'commentThreadId', commentThreadId);
            const localVarPath = `/v1/comments/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (commentThreadId !== undefined) {
                localVarQueryParameter['comment_thread_id'] = commentThreadId;
            }
            if (orderByNewest !== undefined) {
                localVarQueryParameter['order_by_newest'] = orderByNewest;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} commentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeComment: (commentId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'commentId' is not null or undefined
            common_1.assertParamExists('removeComment', 'commentId', commentId);
            const localVarPath = `/v1/comments/{comment_id}`
                .replace(`{${"comment_id"}}`, encodeURIComponent(String(commentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} commentId
         * @param {UpdateCommentRequest} updateCommentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateComment: (commentId, updateCommentRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'commentId' is not null or undefined
            common_1.assertParamExists('updateComment', 'commentId', commentId);
            // verify required parameter 'updateCommentRequest' is not null or undefined
            common_1.assertParamExists('updateComment', 'updateCommentRequest', updateCommentRequest);
            const localVarPath = `/v1/comments/{comment_id}`
                .replace(`{${"comment_id"}}`, encodeURIComponent(String(commentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateCommentRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CommentsApi - functional programming interface
 * @export
 */
exports.CommentsApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.CommentsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CreateCommentRequest} createCommentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createComment(createCommentRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createComment(createCommentRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {GetOrCreateCommentThreadRequest} [getOrCreateCommentThreadRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrCreateCommentThread(getOrCreateCommentThreadRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getOrCreateCommentThread(getOrCreateCommentThreadRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} commentThreadId
         * @param {boolean} [orderByNewest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listComments(commentThreadId, orderByNewest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listComments(commentThreadId, orderByNewest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} commentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeComment(commentId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.removeComment(commentId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} commentId
         * @param {UpdateCommentRequest} updateCommentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateComment(commentId, updateCommentRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateComment(commentId, updateCommentRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * CommentsApi - factory interface
 * @export
 */
exports.CommentsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.CommentsApiFp(configuration);
    return {
        /**
         *
         * @param {CreateCommentRequest} createCommentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createComment(createCommentRequest, options) {
            return localVarFp.createComment(createCommentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {GetOrCreateCommentThreadRequest} [getOrCreateCommentThreadRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrCreateCommentThread(getOrCreateCommentThreadRequest, options) {
            return localVarFp.getOrCreateCommentThread(getOrCreateCommentThreadRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} commentThreadId
         * @param {boolean} [orderByNewest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listComments(commentThreadId, orderByNewest, options) {
            return localVarFp.listComments(commentThreadId, orderByNewest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} commentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeComment(commentId, options) {
            return localVarFp.removeComment(commentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} commentId
         * @param {UpdateCommentRequest} updateCommentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateComment(commentId, updateCommentRequest, options) {
            return localVarFp.updateComment(commentId, updateCommentRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CommentsApi - object-oriented interface
 * @export
 * @class CommentsApi
 * @extends {BaseAPI}
 */
class CommentsApi extends base_1.BaseAPI {
    /**
     *
     * @param {CommentsApiCreateCommentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentsApi
     */
    createComment(requestParameters, options) {
        return exports.CommentsApiFp(this.configuration).createComment(requestParameters.createCommentRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CommentsApiGetOrCreateCommentThreadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentsApi
     */
    getOrCreateCommentThread(requestParameters = {}, options) {
        return exports.CommentsApiFp(this.configuration).getOrCreateCommentThread(requestParameters.getOrCreateCommentThreadRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CommentsApiListCommentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentsApi
     */
    listComments(requestParameters, options) {
        return exports.CommentsApiFp(this.configuration).listComments(requestParameters.commentThreadId, requestParameters.orderByNewest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CommentsApiRemoveCommentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentsApi
     */
    removeComment(requestParameters, options) {
        return exports.CommentsApiFp(this.configuration).removeComment(requestParameters.commentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CommentsApiUpdateCommentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentsApi
     */
    updateComment(requestParameters, options) {
        return exports.CommentsApiFp(this.configuration).updateComment(requestParameters.commentId, requestParameters.updateCommentRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.CommentsApi = CommentsApi;
/**
 * CompanyApi - axios parameter creator
 * @export
 */
exports.CompanyApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} companyId
         * @param {string} benefitName
         * @param {string} benefitDescription
         * @param {string} [image]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompanyExternalBenefit: (companyId, benefitName, benefitDescription, image, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyId' is not null or undefined
            common_1.assertParamExists('createCompanyExternalBenefit', 'companyId', companyId);
            // verify required parameter 'benefitName' is not null or undefined
            common_1.assertParamExists('createCompanyExternalBenefit', 'benefitName', benefitName);
            // verify required parameter 'benefitDescription' is not null or undefined
            common_1.assertParamExists('createCompanyExternalBenefit', 'benefitDescription', benefitDescription);
            const localVarPath = `/v1/companies/{company_id}/external-benefits`
                .replace(`{${"company_id"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (benefitName !== undefined) {
                localVarFormParams.append('benefit_name', benefitName);
            }
            if (benefitDescription !== undefined) {
                localVarFormParams.append('benefit_description', benefitDescription);
            }
            if (image !== undefined) {
                localVarFormParams.append('image', image);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CreatePointOfContactRequest} createPointOfContactRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPointOfContact: (createPointOfContactRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createPointOfContactRequest' is not null or undefined
            common_1.assertParamExists('createPointOfContact', 'createPointOfContactRequest', createPointOfContactRequest);
            const localVarPath = `/v1/points-of-contact/new`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createPointOfContactRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} benefitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompanyExternalBenefit: (benefitId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'benefitId' is not null or undefined
            common_1.assertParamExists('deleteCompanyExternalBenefit', 'benefitId', benefitId);
            const localVarPath = `/v1/companies/external-benefits/{benefit_id}`
                .replace(`{${"benefit_id"}}`, encodeURIComponent(String(benefitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} pointOfContactId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePointOfContact: (pointOfContactId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'pointOfContactId' is not null or undefined
            common_1.assertParamExists('deletePointOfContact', 'pointOfContactId', pointOfContactId);
            const localVarPath = `/v1/points-of-contact/{point_of_contact_id}`
                .replace(`{${"point_of_contact_id"}}`, encodeURIComponent(String(pointOfContactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompany: (companyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyId' is not null or undefined
            common_1.assertParamExists('getCompany', 'companyId', companyId);
            const localVarPath = `/v1/companies/{company_id}`
                .replace(`{${"company_id"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} benefitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyExternalBenefit: (benefitId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'benefitId' is not null or undefined
            common_1.assertParamExists('getCompanyExternalBenefit', 'benefitId', benefitId);
            const localVarPath = `/v1/companies/external-benefits/{benefit_id}`
                .replace(`{${"benefit_id"}}`, encodeURIComponent(String(benefitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} pointOfContactId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPointOfContact: (pointOfContactId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'pointOfContactId' is not null or undefined
            common_1.assertParamExists('getPointOfContact', 'pointOfContactId', pointOfContactId);
            const localVarPath = `/v1/points-of-contact/{point_of_contact_id}`
                .replace(`{${"point_of_contact_id"}}`, encodeURIComponent(String(pointOfContactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} publicCompanyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicCompanyDetails: (publicCompanyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'publicCompanyId' is not null or undefined
            common_1.assertParamExists('getPublicCompanyDetails', 'publicCompanyId', publicCompanyId);
            const localVarPath = `/v1/companies/{public_company_id}/public`
                .replace(`{${"public_company_id"}}`, encodeURIComponent(String(publicCompanyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {boolean} [activeIn]
         * @param {string} [name]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompanies: (activeIn, name, page, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (activeIn !== undefined) {
                localVarQueryParameter['active_in'] = activeIn;
            }
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompanyExternalBenefits: (companyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyId' is not null or undefined
            common_1.assertParamExists('listCompanyExternalBenefits', 'companyId', companyId);
            const localVarPath = `/v1/companies/{company_id}/external-benefits`
                .replace(`{${"company_id"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [companyId]
         * @param {number} [limit]
         * @param {boolean} [orderByMostRecentlyUsed]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPointsOfContact: (companyId, limit, orderByMostRecentlyUsed, page, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/points-of-contact/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (orderByMostRecentlyUsed !== undefined) {
                localVarQueryParameter['order_by_most_recently_used'] = orderByMostRecentlyUsed;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {OnboardCompanyApiRequest} onboardCompanyApiRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onboardCompany: (onboardCompanyApiRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'onboardCompanyApiRequest' is not null or undefined
            common_1.assertParamExists('onboardCompany', 'onboardCompanyApiRequest', onboardCompanyApiRequest);
            const localVarPath = `/v1/companies/onboarding`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(onboardCompanyApiRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} companyId
         * @param {UpdateCompanyDetailsRequest} [updateCompanyDetailsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyDetails: (companyId, updateCompanyDetailsRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyId' is not null or undefined
            common_1.assertParamExists('updateCompanyDetails', 'companyId', companyId);
            const localVarPath = `/v1/companies/{company_id}/details`
                .replace(`{${"company_id"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateCompanyDetailsRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} benefitId
         * @param {string} [benefitName]
         * @param {string} [benefitDescription]
         * @param {string} [image]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyExternalBenefit: (benefitId, benefitName, benefitDescription, image, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'benefitId' is not null or undefined
            common_1.assertParamExists('updateCompanyExternalBenefit', 'benefitId', benefitId);
            const localVarPath = `/v1/companies/external-benefits/{benefit_id}`
                .replace(`{${"benefit_id"}}`, encodeURIComponent(String(benefitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (benefitName !== undefined) {
                localVarFormParams.append('benefit_name', benefitName);
            }
            if (benefitDescription !== undefined) {
                localVarFormParams.append('benefit_description', benefitDescription);
            }
            if (image !== undefined) {
                localVarFormParams.append('image', image);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} companyId
         * @param {string} logoFile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyLogo: (companyId, logoFile, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyId' is not null or undefined
            common_1.assertParamExists('updateCompanyLogo', 'companyId', companyId);
            // verify required parameter 'logoFile' is not null or undefined
            common_1.assertParamExists('updateCompanyLogo', 'logoFile', logoFile);
            const localVarPath = `/v1/companies/{company_id}/logo`
                .replace(`{${"company_id"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (logoFile !== undefined) {
                localVarFormParams.append('logo_file', logoFile);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} companyId
         * @param {UpdateCompanyMaintainedFieldsRequest} [updateCompanyMaintainedFieldsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyMaintainedFields: (companyId, updateCompanyMaintainedFieldsRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyId' is not null or undefined
            common_1.assertParamExists('updateCompanyMaintainedFields', 'companyId', companyId);
            const localVarPath = `/v1/companies/{company_id}/our-details`
                .replace(`{${"company_id"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateCompanyMaintainedFieldsRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} pointOfContactId
         * @param {UpdatePointOfContactRequest} updatePointOfContactRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePointOfContact: (pointOfContactId, updatePointOfContactRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'pointOfContactId' is not null or undefined
            common_1.assertParamExists('updatePointOfContact', 'pointOfContactId', pointOfContactId);
            // verify required parameter 'updatePointOfContactRequest' is not null or undefined
            common_1.assertParamExists('updatePointOfContact', 'updatePointOfContactRequest', updatePointOfContactRequest);
            const localVarPath = `/v1/points-of-contact/{point_of_contact_id}`
                .replace(`{${"point_of_contact_id"}}`, encodeURIComponent(String(pointOfContactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updatePointOfContactRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CompanyApi - functional programming interface
 * @export
 */
exports.CompanyApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.CompanyApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} companyId
         * @param {string} benefitName
         * @param {string} benefitDescription
         * @param {string} [image]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompanyExternalBenefit(companyId, benefitName, benefitDescription, image, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createCompanyExternalBenefit(companyId, benefitName, benefitDescription, image, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {CreatePointOfContactRequest} createPointOfContactRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPointOfContact(createPointOfContactRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createPointOfContact(createPointOfContactRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} benefitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompanyExternalBenefit(benefitId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteCompanyExternalBenefit(benefitId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} pointOfContactId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePointOfContact(pointOfContactId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deletePointOfContact(pointOfContactId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompany(companyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCompany(companyId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} benefitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyExternalBenefit(benefitId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCompanyExternalBenefit(benefitId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} pointOfContactId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPointOfContact(pointOfContactId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPointOfContact(pointOfContactId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} publicCompanyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicCompanyDetails(publicCompanyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPublicCompanyDetails(publicCompanyId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {boolean} [activeIn]
         * @param {string} [name]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompanies(activeIn, name, page, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listCompanies(activeIn, name, page, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompanyExternalBenefits(companyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listCompanyExternalBenefits(companyId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} [companyId]
         * @param {number} [limit]
         * @param {boolean} [orderByMostRecentlyUsed]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPointsOfContact(companyId, limit, orderByMostRecentlyUsed, page, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listPointsOfContact(companyId, limit, orderByMostRecentlyUsed, page, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {OnboardCompanyApiRequest} onboardCompanyApiRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onboardCompany(onboardCompanyApiRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.onboardCompany(onboardCompanyApiRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} companyId
         * @param {UpdateCompanyDetailsRequest} [updateCompanyDetailsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyDetails(companyId, updateCompanyDetailsRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateCompanyDetails(companyId, updateCompanyDetailsRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} benefitId
         * @param {string} [benefitName]
         * @param {string} [benefitDescription]
         * @param {string} [image]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyExternalBenefit(benefitId, benefitName, benefitDescription, image, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateCompanyExternalBenefit(benefitId, benefitName, benefitDescription, image, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} companyId
         * @param {string} logoFile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyLogo(companyId, logoFile, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateCompanyLogo(companyId, logoFile, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} companyId
         * @param {UpdateCompanyMaintainedFieldsRequest} [updateCompanyMaintainedFieldsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyMaintainedFields(companyId, updateCompanyMaintainedFieldsRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateCompanyMaintainedFields(companyId, updateCompanyMaintainedFieldsRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} pointOfContactId
         * @param {UpdatePointOfContactRequest} updatePointOfContactRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePointOfContact(pointOfContactId, updatePointOfContactRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updatePointOfContact(pointOfContactId, updatePointOfContactRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * CompanyApi - factory interface
 * @export
 */
exports.CompanyApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.CompanyApiFp(configuration);
    return {
        /**
         *
         * @param {string} companyId
         * @param {string} benefitName
         * @param {string} benefitDescription
         * @param {string} [image]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompanyExternalBenefit(companyId, benefitName, benefitDescription, image, options) {
            return localVarFp.createCompanyExternalBenefit(companyId, benefitName, benefitDescription, image, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreatePointOfContactRequest} createPointOfContactRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPointOfContact(createPointOfContactRequest, options) {
            return localVarFp.createPointOfContact(createPointOfContactRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} benefitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompanyExternalBenefit(benefitId, options) {
            return localVarFp.deleteCompanyExternalBenefit(benefitId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} pointOfContactId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePointOfContact(pointOfContactId, options) {
            return localVarFp.deletePointOfContact(pointOfContactId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompany(companyId, options) {
            return localVarFp.getCompany(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} benefitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyExternalBenefit(benefitId, options) {
            return localVarFp.getCompanyExternalBenefit(benefitId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} pointOfContactId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPointOfContact(pointOfContactId, options) {
            return localVarFp.getPointOfContact(pointOfContactId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} publicCompanyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicCompanyDetails(publicCompanyId, options) {
            return localVarFp.getPublicCompanyDetails(publicCompanyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {boolean} [activeIn]
         * @param {string} [name]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompanies(activeIn, name, page, options) {
            return localVarFp.listCompanies(activeIn, name, page, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompanyExternalBenefits(companyId, options) {
            return localVarFp.listCompanyExternalBenefits(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [companyId]
         * @param {number} [limit]
         * @param {boolean} [orderByMostRecentlyUsed]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPointsOfContact(companyId, limit, orderByMostRecentlyUsed, page, options) {
            return localVarFp.listPointsOfContact(companyId, limit, orderByMostRecentlyUsed, page, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {OnboardCompanyApiRequest} onboardCompanyApiRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onboardCompany(onboardCompanyApiRequest, options) {
            return localVarFp.onboardCompany(onboardCompanyApiRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} companyId
         * @param {UpdateCompanyDetailsRequest} [updateCompanyDetailsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyDetails(companyId, updateCompanyDetailsRequest, options) {
            return localVarFp.updateCompanyDetails(companyId, updateCompanyDetailsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} benefitId
         * @param {string} [benefitName]
         * @param {string} [benefitDescription]
         * @param {string} [image]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyExternalBenefit(benefitId, benefitName, benefitDescription, image, options) {
            return localVarFp.updateCompanyExternalBenefit(benefitId, benefitName, benefitDescription, image, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} companyId
         * @param {string} logoFile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyLogo(companyId, logoFile, options) {
            return localVarFp.updateCompanyLogo(companyId, logoFile, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} companyId
         * @param {UpdateCompanyMaintainedFieldsRequest} [updateCompanyMaintainedFieldsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyMaintainedFields(companyId, updateCompanyMaintainedFieldsRequest, options) {
            return localVarFp.updateCompanyMaintainedFields(companyId, updateCompanyMaintainedFieldsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} pointOfContactId
         * @param {UpdatePointOfContactRequest} updatePointOfContactRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePointOfContact(pointOfContactId, updatePointOfContactRequest, options) {
            return localVarFp.updatePointOfContact(pointOfContactId, updatePointOfContactRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CompanyApi - object-oriented interface
 * @export
 * @class CompanyApi
 * @extends {BaseAPI}
 */
class CompanyApi extends base_1.BaseAPI {
    /**
     *
     * @param {CompanyApiCreateCompanyExternalBenefitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    createCompanyExternalBenefit(requestParameters, options) {
        return exports.CompanyApiFp(this.configuration).createCompanyExternalBenefit(requestParameters.companyId, requestParameters.benefitName, requestParameters.benefitDescription, requestParameters.image, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CompanyApiCreatePointOfContactRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    createPointOfContact(requestParameters, options) {
        return exports.CompanyApiFp(this.configuration).createPointOfContact(requestParameters.createPointOfContactRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CompanyApiDeleteCompanyExternalBenefitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    deleteCompanyExternalBenefit(requestParameters, options) {
        return exports.CompanyApiFp(this.configuration).deleteCompanyExternalBenefit(requestParameters.benefitId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CompanyApiDeletePointOfContactRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    deletePointOfContact(requestParameters, options) {
        return exports.CompanyApiFp(this.configuration).deletePointOfContact(requestParameters.pointOfContactId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CompanyApiGetCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    getCompany(requestParameters, options) {
        return exports.CompanyApiFp(this.configuration).getCompany(requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CompanyApiGetCompanyExternalBenefitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    getCompanyExternalBenefit(requestParameters, options) {
        return exports.CompanyApiFp(this.configuration).getCompanyExternalBenefit(requestParameters.benefitId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CompanyApiGetPointOfContactRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    getPointOfContact(requestParameters, options) {
        return exports.CompanyApiFp(this.configuration).getPointOfContact(requestParameters.pointOfContactId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CompanyApiGetPublicCompanyDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    getPublicCompanyDetails(requestParameters, options) {
        return exports.CompanyApiFp(this.configuration).getPublicCompanyDetails(requestParameters.publicCompanyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CompanyApiListCompaniesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    listCompanies(requestParameters = {}, options) {
        return exports.CompanyApiFp(this.configuration).listCompanies(requestParameters.activeIn, requestParameters.name, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CompanyApiListCompanyExternalBenefitsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    listCompanyExternalBenefits(requestParameters, options) {
        return exports.CompanyApiFp(this.configuration).listCompanyExternalBenefits(requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CompanyApiListPointsOfContactRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    listPointsOfContact(requestParameters = {}, options) {
        return exports.CompanyApiFp(this.configuration).listPointsOfContact(requestParameters.companyId, requestParameters.limit, requestParameters.orderByMostRecentlyUsed, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CompanyApiOnboardCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    onboardCompany(requestParameters, options) {
        return exports.CompanyApiFp(this.configuration).onboardCompany(requestParameters.onboardCompanyApiRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CompanyApiUpdateCompanyDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    updateCompanyDetails(requestParameters, options) {
        return exports.CompanyApiFp(this.configuration).updateCompanyDetails(requestParameters.companyId, requestParameters.updateCompanyDetailsRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CompanyApiUpdateCompanyExternalBenefitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    updateCompanyExternalBenefit(requestParameters, options) {
        return exports.CompanyApiFp(this.configuration).updateCompanyExternalBenefit(requestParameters.benefitId, requestParameters.benefitName, requestParameters.benefitDescription, requestParameters.image, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CompanyApiUpdateCompanyLogoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    updateCompanyLogo(requestParameters, options) {
        return exports.CompanyApiFp(this.configuration).updateCompanyLogo(requestParameters.companyId, requestParameters.logoFile, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CompanyApiUpdateCompanyMaintainedFieldsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    updateCompanyMaintainedFields(requestParameters, options) {
        return exports.CompanyApiFp(this.configuration).updateCompanyMaintainedFields(requestParameters.companyId, requestParameters.updateCompanyMaintainedFieldsRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CompanyApiUpdatePointOfContactRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    updatePointOfContact(requestParameters, options) {
        return exports.CompanyApiFp(this.configuration).updatePointOfContact(requestParameters.pointOfContactId, requestParameters.updatePointOfContactRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.CompanyApi = CompanyApi;
/**
 * CompanyAdminApi - axios parameter creator
 * @export
 */
exports.CompanyAdminApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} companyAdminId
         * @param {ActivateCompanyAdminRequest} [activateCompanyAdminRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateCompanyAdmin: (companyAdminId, activateCompanyAdminRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyAdminId' is not null or undefined
            common_1.assertParamExists('activateCompanyAdmin', 'companyAdminId', companyAdminId);
            const localVarPath = `/v1/company-admins/{company_admin_id}/activate`
                .replace(`{${"company_admin_id"}}`, encodeURIComponent(String(companyAdminId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(activateCompanyAdminRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} companyId
         * @param {InviteCompanyAdminRequest} inviteCompanyAdminRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteCompanyAdmin: (companyId, inviteCompanyAdminRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyId' is not null or undefined
            common_1.assertParamExists('inviteCompanyAdmin', 'companyId', companyId);
            // verify required parameter 'inviteCompanyAdminRequest' is not null or undefined
            common_1.assertParamExists('inviteCompanyAdmin', 'inviteCompanyAdminRequest', inviteCompanyAdminRequest);
            const localVarPath = `/v1/companies/{company_id}/company-admins/invite`
                .replace(`{${"company_id"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(inviteCompanyAdminRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompanyAdmins: (companyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyId' is not null or undefined
            common_1.assertParamExists('listCompanyAdmins', 'companyId', companyId);
            const localVarPath = `/v1/companies/{company_id}/company-admins`
                .replace(`{${"company_id"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} companyAdminId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCompanyAdmin: (companyAdminId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyAdminId' is not null or undefined
            common_1.assertParamExists('removeCompanyAdmin', 'companyAdminId', companyAdminId);
            const localVarPath = `/v1/company-admins/{company_admin_id}/remove`
                .replace(`{${"company_admin_id"}}`, encodeURIComponent(String(companyAdminId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CompanyAdminApi - functional programming interface
 * @export
 */
exports.CompanyAdminApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.CompanyAdminApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} companyAdminId
         * @param {ActivateCompanyAdminRequest} [activateCompanyAdminRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateCompanyAdmin(companyAdminId, activateCompanyAdminRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.activateCompanyAdmin(companyAdminId, activateCompanyAdminRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} companyId
         * @param {InviteCompanyAdminRequest} inviteCompanyAdminRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteCompanyAdmin(companyId, inviteCompanyAdminRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.inviteCompanyAdmin(companyId, inviteCompanyAdminRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompanyAdmins(companyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listCompanyAdmins(companyId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} companyAdminId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCompanyAdmin(companyAdminId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.removeCompanyAdmin(companyAdminId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * CompanyAdminApi - factory interface
 * @export
 */
exports.CompanyAdminApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.CompanyAdminApiFp(configuration);
    return {
        /**
         *
         * @param {string} companyAdminId
         * @param {ActivateCompanyAdminRequest} [activateCompanyAdminRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateCompanyAdmin(companyAdminId, activateCompanyAdminRequest, options) {
            return localVarFp.activateCompanyAdmin(companyAdminId, activateCompanyAdminRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} companyId
         * @param {InviteCompanyAdminRequest} inviteCompanyAdminRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteCompanyAdmin(companyId, inviteCompanyAdminRequest, options) {
            return localVarFp.inviteCompanyAdmin(companyId, inviteCompanyAdminRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompanyAdmins(companyId, options) {
            return localVarFp.listCompanyAdmins(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} companyAdminId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCompanyAdmin(companyAdminId, options) {
            return localVarFp.removeCompanyAdmin(companyAdminId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CompanyAdminApi - object-oriented interface
 * @export
 * @class CompanyAdminApi
 * @extends {BaseAPI}
 */
class CompanyAdminApi extends base_1.BaseAPI {
    /**
     *
     * @param {CompanyAdminApiActivateCompanyAdminRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyAdminApi
     */
    activateCompanyAdmin(requestParameters, options) {
        return exports.CompanyAdminApiFp(this.configuration).activateCompanyAdmin(requestParameters.companyAdminId, requestParameters.activateCompanyAdminRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CompanyAdminApiInviteCompanyAdminRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyAdminApi
     */
    inviteCompanyAdmin(requestParameters, options) {
        return exports.CompanyAdminApiFp(this.configuration).inviteCompanyAdmin(requestParameters.companyId, requestParameters.inviteCompanyAdminRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CompanyAdminApiListCompanyAdminsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyAdminApi
     */
    listCompanyAdmins(requestParameters, options) {
        return exports.CompanyAdminApiFp(this.configuration).listCompanyAdmins(requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CompanyAdminApiRemoveCompanyAdminRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyAdminApi
     */
    removeCompanyAdmin(requestParameters, options) {
        return exports.CompanyAdminApiFp(this.configuration).removeCompanyAdmin(requestParameters.companyAdminId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.CompanyAdminApi = CompanyAdminApi;
/**
 * CompanyMemberApi - axios parameter creator
 * @export
 */
exports.CompanyMemberApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} companyId
         * @param {CreateCompanyEmployeeRequest} createCompanyEmployeeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompanyEmployee: (companyId, createCompanyEmployeeRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyId' is not null or undefined
            common_1.assertParamExists('createCompanyEmployee', 'companyId', companyId);
            // verify required parameter 'createCompanyEmployeeRequest' is not null or undefined
            common_1.assertParamExists('createCompanyEmployee', 'createCompanyEmployeeRequest', createCompanyEmployeeRequest);
            const localVarPath = `/v1/companies/{company_id}/employees`
                .replace(`{${"company_id"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createCompanyEmployeeRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} companyId
         * @param {CreateCompanyRecruitRequest} createCompanyRecruitRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompanyRecruit: (companyId, createCompanyRecruitRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyId' is not null or undefined
            common_1.assertParamExists('createCompanyRecruit', 'companyId', companyId);
            // verify required parameter 'createCompanyRecruitRequest' is not null or undefined
            common_1.assertParamExists('createCompanyRecruit', 'createCompanyRecruitRequest', createCompanyRecruitRequest);
            const localVarPath = `/v1/companies/{company_id}/recruits`
                .replace(`{${"company_id"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createCompanyRecruitRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} companyId
         * @param {CreateCompanyYouthRequest} createCompanyYouthRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompanyYouth: (companyId, createCompanyYouthRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyId' is not null or undefined
            common_1.assertParamExists('createCompanyYouth', 'companyId', companyId);
            // verify required parameter 'createCompanyYouthRequest' is not null or undefined
            common_1.assertParamExists('createCompanyYouth', 'createCompanyYouthRequest', createCompanyYouthRequest);
            const localVarPath = `/v1/companies/{company_id}/youths`
                .replace(`{${"company_id"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createCompanyYouthRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} companyMemberId
         * @param {DeactivateCompanyMemberRequest} deactivateCompanyMemberRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateCompanyMember: (companyMemberId, deactivateCompanyMemberRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyMemberId' is not null or undefined
            common_1.assertParamExists('deactivateCompanyMember', 'companyMemberId', companyMemberId);
            // verify required parameter 'deactivateCompanyMemberRequest' is not null or undefined
            common_1.assertParamExists('deactivateCompanyMember', 'deactivateCompanyMemberRequest', deactivateCompanyMemberRequest);
            const localVarPath = `/v1/company-members/{company_member_id}/deactivate`
                .replace(`{${"company_member_id"}}`, encodeURIComponent(String(companyMemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(deactivateCompanyMemberRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} companyMemberId
         * @param {boolean} [includeTagsIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyMember: (companyMemberId, includeTagsIn, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyMemberId' is not null or undefined
            common_1.assertParamExists('getCompanyMember', 'companyMemberId', companyMemberId);
            const localVarPath = `/v1/company-members/{company_member_id}`
                .replace(`{${"company_member_id"}}`, encodeURIComponent(String(companyMemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (includeTagsIn !== undefined) {
                localVarQueryParameter['include_tags_in'] = includeTagsIn;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {boolean} [activeIn]
         * @param {boolean} [benefitsEligibleIn]
         * @param {string} [companyId]
         * @param {'Full Time' | 'Part Time' | 'Temporary' | 'Intern' | 'Seasonal' | 'Individual Contractor' | 'null'} [employeeClass] * &#x60;Full Time&#x60; - Full Time * &#x60;Part Time&#x60; - Part Time * &#x60;Temporary&#x60; - Temporary * &#x60;Intern&#x60; - Intern * &#x60;Seasonal&#x60; - Seasonal * &#x60;Individual Contractor&#x60; - Individual Contractor
         * @param {boolean} [includeTagsIn]
         * @param {number} [limit]
         * @param {string} [memberEmail]
         * @param {string} [memberId]
         * @param {string} [memberName]
         * @param {string} [memberPhone]
         * @param {boolean} [missingCriticalEmployeeInfoIn]
         * @param {number} [page]
         * @param {Array<string>} [tagsIds]
         * @param {'Employee' | 'Recruit' | 'Youth' | 'null'} [type] * &#x60;Employee&#x60; - Employee * &#x60;Recruit&#x60; - Recruit * &#x60;Youth&#x60; - Youth
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompanyMembers: (activeIn, benefitsEligibleIn, companyId, employeeClass, includeTagsIn, limit, memberEmail, memberId, memberName, memberPhone, missingCriticalEmployeeInfoIn, page, tagsIds, type, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/company-members`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (activeIn !== undefined) {
                localVarQueryParameter['active_in'] = activeIn;
            }
            if (benefitsEligibleIn !== undefined) {
                localVarQueryParameter['benefits_eligible_in'] = benefitsEligibleIn;
            }
            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }
            if (employeeClass !== undefined) {
                localVarQueryParameter['employee_class'] = employeeClass;
            }
            if (includeTagsIn !== undefined) {
                localVarQueryParameter['include_tags_in'] = includeTagsIn;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (memberEmail !== undefined) {
                localVarQueryParameter['member_email'] = memberEmail;
            }
            if (memberId !== undefined) {
                localVarQueryParameter['member_id'] = memberId;
            }
            if (memberName !== undefined) {
                localVarQueryParameter['member_name'] = memberName;
            }
            if (memberPhone !== undefined) {
                localVarQueryParameter['member_phone'] = memberPhone;
            }
            if (missingCriticalEmployeeInfoIn !== undefined) {
                localVarQueryParameter['missing_critical_employee_info_in'] = missingCriticalEmployeeInfoIn;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (tagsIds) {
                localVarQueryParameter['tags_ids'] = tagsIds;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompanyMembersByMemberId: (memberId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'memberId' is not null or undefined
            common_1.assertParamExists('listCompanyMembersByMemberId', 'memberId', memberId);
            const localVarPath = `/v1/members/{member_id}/company-members`
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} companyMemberId
         * @param {PromoteCompanyRecruitToEmployeeRequest} [promoteCompanyRecruitToEmployeeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promoteCompanyRecruitToEmployee: (companyMemberId, promoteCompanyRecruitToEmployeeRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyMemberId' is not null or undefined
            common_1.assertParamExists('promoteCompanyRecruitToEmployee', 'companyMemberId', companyMemberId);
            const localVarPath = `/v1/company-members/{company_member_id}/promote-recruit`
                .replace(`{${"company_member_id"}}`, encodeURIComponent(String(companyMemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(promoteCompanyRecruitToEmployeeRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} companyMemberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateCompanyMember: (companyMemberId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyMemberId' is not null or undefined
            common_1.assertParamExists('reactivateCompanyMember', 'companyMemberId', companyMemberId);
            const localVarPath = `/v1/company-members/{company_member_id}/reactivate`
                .replace(`{${"company_member_id"}}`, encodeURIComponent(String(companyMemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} companyMemberId
         * @param {UpdateCompanyMemberRequest} [updateCompanyMemberRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyMember: (companyMemberId, updateCompanyMemberRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyMemberId' is not null or undefined
            common_1.assertParamExists('updateCompanyMember', 'companyMemberId', companyMemberId);
            const localVarPath = `/v1/company-members/{company_member_id}`
                .replace(`{${"company_member_id"}}`, encodeURIComponent(String(companyMemberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateCompanyMemberRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CompanyMemberApi - functional programming interface
 * @export
 */
exports.CompanyMemberApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.CompanyMemberApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} companyId
         * @param {CreateCompanyEmployeeRequest} createCompanyEmployeeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompanyEmployee(companyId, createCompanyEmployeeRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createCompanyEmployee(companyId, createCompanyEmployeeRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} companyId
         * @param {CreateCompanyRecruitRequest} createCompanyRecruitRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompanyRecruit(companyId, createCompanyRecruitRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createCompanyRecruit(companyId, createCompanyRecruitRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} companyId
         * @param {CreateCompanyYouthRequest} createCompanyYouthRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompanyYouth(companyId, createCompanyYouthRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createCompanyYouth(companyId, createCompanyYouthRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} companyMemberId
         * @param {DeactivateCompanyMemberRequest} deactivateCompanyMemberRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateCompanyMember(companyMemberId, deactivateCompanyMemberRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deactivateCompanyMember(companyMemberId, deactivateCompanyMemberRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} companyMemberId
         * @param {boolean} [includeTagsIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyMember(companyMemberId, includeTagsIn, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCompanyMember(companyMemberId, includeTagsIn, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {boolean} [activeIn]
         * @param {boolean} [benefitsEligibleIn]
         * @param {string} [companyId]
         * @param {'Full Time' | 'Part Time' | 'Temporary' | 'Intern' | 'Seasonal' | 'Individual Contractor' | 'null'} [employeeClass] * &#x60;Full Time&#x60; - Full Time * &#x60;Part Time&#x60; - Part Time * &#x60;Temporary&#x60; - Temporary * &#x60;Intern&#x60; - Intern * &#x60;Seasonal&#x60; - Seasonal * &#x60;Individual Contractor&#x60; - Individual Contractor
         * @param {boolean} [includeTagsIn]
         * @param {number} [limit]
         * @param {string} [memberEmail]
         * @param {string} [memberId]
         * @param {string} [memberName]
         * @param {string} [memberPhone]
         * @param {boolean} [missingCriticalEmployeeInfoIn]
         * @param {number} [page]
         * @param {Array<string>} [tagsIds]
         * @param {'Employee' | 'Recruit' | 'Youth' | 'null'} [type] * &#x60;Employee&#x60; - Employee * &#x60;Recruit&#x60; - Recruit * &#x60;Youth&#x60; - Youth
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompanyMembers(activeIn, benefitsEligibleIn, companyId, employeeClass, includeTagsIn, limit, memberEmail, memberId, memberName, memberPhone, missingCriticalEmployeeInfoIn, page, tagsIds, type, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listCompanyMembers(activeIn, benefitsEligibleIn, companyId, employeeClass, includeTagsIn, limit, memberEmail, memberId, memberName, memberPhone, missingCriticalEmployeeInfoIn, page, tagsIds, type, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompanyMembersByMemberId(memberId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listCompanyMembersByMemberId(memberId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} companyMemberId
         * @param {PromoteCompanyRecruitToEmployeeRequest} [promoteCompanyRecruitToEmployeeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promoteCompanyRecruitToEmployee(companyMemberId, promoteCompanyRecruitToEmployeeRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.promoteCompanyRecruitToEmployee(companyMemberId, promoteCompanyRecruitToEmployeeRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} companyMemberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateCompanyMember(companyMemberId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reactivateCompanyMember(companyMemberId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} companyMemberId
         * @param {UpdateCompanyMemberRequest} [updateCompanyMemberRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyMember(companyMemberId, updateCompanyMemberRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateCompanyMember(companyMemberId, updateCompanyMemberRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * CompanyMemberApi - factory interface
 * @export
 */
exports.CompanyMemberApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.CompanyMemberApiFp(configuration);
    return {
        /**
         *
         * @param {string} companyId
         * @param {CreateCompanyEmployeeRequest} createCompanyEmployeeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompanyEmployee(companyId, createCompanyEmployeeRequest, options) {
            return localVarFp.createCompanyEmployee(companyId, createCompanyEmployeeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} companyId
         * @param {CreateCompanyRecruitRequest} createCompanyRecruitRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompanyRecruit(companyId, createCompanyRecruitRequest, options) {
            return localVarFp.createCompanyRecruit(companyId, createCompanyRecruitRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} companyId
         * @param {CreateCompanyYouthRequest} createCompanyYouthRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompanyYouth(companyId, createCompanyYouthRequest, options) {
            return localVarFp.createCompanyYouth(companyId, createCompanyYouthRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} companyMemberId
         * @param {DeactivateCompanyMemberRequest} deactivateCompanyMemberRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateCompanyMember(companyMemberId, deactivateCompanyMemberRequest, options) {
            return localVarFp.deactivateCompanyMember(companyMemberId, deactivateCompanyMemberRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} companyMemberId
         * @param {boolean} [includeTagsIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyMember(companyMemberId, includeTagsIn, options) {
            return localVarFp.getCompanyMember(companyMemberId, includeTagsIn, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {boolean} [activeIn]
         * @param {boolean} [benefitsEligibleIn]
         * @param {string} [companyId]
         * @param {'Full Time' | 'Part Time' | 'Temporary' | 'Intern' | 'Seasonal' | 'Individual Contractor' | 'null'} [employeeClass] * &#x60;Full Time&#x60; - Full Time * &#x60;Part Time&#x60; - Part Time * &#x60;Temporary&#x60; - Temporary * &#x60;Intern&#x60; - Intern * &#x60;Seasonal&#x60; - Seasonal * &#x60;Individual Contractor&#x60; - Individual Contractor
         * @param {boolean} [includeTagsIn]
         * @param {number} [limit]
         * @param {string} [memberEmail]
         * @param {string} [memberId]
         * @param {string} [memberName]
         * @param {string} [memberPhone]
         * @param {boolean} [missingCriticalEmployeeInfoIn]
         * @param {number} [page]
         * @param {Array<string>} [tagsIds]
         * @param {'Employee' | 'Recruit' | 'Youth' | 'null'} [type] * &#x60;Employee&#x60; - Employee * &#x60;Recruit&#x60; - Recruit * &#x60;Youth&#x60; - Youth
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompanyMembers(activeIn, benefitsEligibleIn, companyId, employeeClass, includeTagsIn, limit, memberEmail, memberId, memberName, memberPhone, missingCriticalEmployeeInfoIn, page, tagsIds, type, options) {
            return localVarFp.listCompanyMembers(activeIn, benefitsEligibleIn, companyId, employeeClass, includeTagsIn, limit, memberEmail, memberId, memberName, memberPhone, missingCriticalEmployeeInfoIn, page, tagsIds, type, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompanyMembersByMemberId(memberId, options) {
            return localVarFp.listCompanyMembersByMemberId(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} companyMemberId
         * @param {PromoteCompanyRecruitToEmployeeRequest} [promoteCompanyRecruitToEmployeeRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promoteCompanyRecruitToEmployee(companyMemberId, promoteCompanyRecruitToEmployeeRequest, options) {
            return localVarFp.promoteCompanyRecruitToEmployee(companyMemberId, promoteCompanyRecruitToEmployeeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} companyMemberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateCompanyMember(companyMemberId, options) {
            return localVarFp.reactivateCompanyMember(companyMemberId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} companyMemberId
         * @param {UpdateCompanyMemberRequest} [updateCompanyMemberRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyMember(companyMemberId, updateCompanyMemberRequest, options) {
            return localVarFp.updateCompanyMember(companyMemberId, updateCompanyMemberRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CompanyMemberApi - object-oriented interface
 * @export
 * @class CompanyMemberApi
 * @extends {BaseAPI}
 */
class CompanyMemberApi extends base_1.BaseAPI {
    /**
     *
     * @param {CompanyMemberApiCreateCompanyEmployeeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyMemberApi
     */
    createCompanyEmployee(requestParameters, options) {
        return exports.CompanyMemberApiFp(this.configuration).createCompanyEmployee(requestParameters.companyId, requestParameters.createCompanyEmployeeRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CompanyMemberApiCreateCompanyRecruitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyMemberApi
     */
    createCompanyRecruit(requestParameters, options) {
        return exports.CompanyMemberApiFp(this.configuration).createCompanyRecruit(requestParameters.companyId, requestParameters.createCompanyRecruitRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CompanyMemberApiCreateCompanyYouthRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyMemberApi
     */
    createCompanyYouth(requestParameters, options) {
        return exports.CompanyMemberApiFp(this.configuration).createCompanyYouth(requestParameters.companyId, requestParameters.createCompanyYouthRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CompanyMemberApiDeactivateCompanyMemberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyMemberApi
     */
    deactivateCompanyMember(requestParameters, options) {
        return exports.CompanyMemberApiFp(this.configuration).deactivateCompanyMember(requestParameters.companyMemberId, requestParameters.deactivateCompanyMemberRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CompanyMemberApiGetCompanyMemberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyMemberApi
     */
    getCompanyMember(requestParameters, options) {
        return exports.CompanyMemberApiFp(this.configuration).getCompanyMember(requestParameters.companyMemberId, requestParameters.includeTagsIn, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CompanyMemberApiListCompanyMembersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyMemberApi
     */
    listCompanyMembers(requestParameters = {}, options) {
        return exports.CompanyMemberApiFp(this.configuration).listCompanyMembers(requestParameters.activeIn, requestParameters.benefitsEligibleIn, requestParameters.companyId, requestParameters.employeeClass, requestParameters.includeTagsIn, requestParameters.limit, requestParameters.memberEmail, requestParameters.memberId, requestParameters.memberName, requestParameters.memberPhone, requestParameters.missingCriticalEmployeeInfoIn, requestParameters.page, requestParameters.tagsIds, requestParameters.type, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CompanyMemberApiListCompanyMembersByMemberIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyMemberApi
     */
    listCompanyMembersByMemberId(requestParameters, options) {
        return exports.CompanyMemberApiFp(this.configuration).listCompanyMembersByMemberId(requestParameters.memberId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CompanyMemberApiPromoteCompanyRecruitToEmployeeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyMemberApi
     */
    promoteCompanyRecruitToEmployee(requestParameters, options) {
        return exports.CompanyMemberApiFp(this.configuration).promoteCompanyRecruitToEmployee(requestParameters.companyMemberId, requestParameters.promoteCompanyRecruitToEmployeeRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CompanyMemberApiReactivateCompanyMemberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyMemberApi
     */
    reactivateCompanyMember(requestParameters, options) {
        return exports.CompanyMemberApiFp(this.configuration).reactivateCompanyMember(requestParameters.companyMemberId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CompanyMemberApiUpdateCompanyMemberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyMemberApi
     */
    updateCompanyMember(requestParameters, options) {
        return exports.CompanyMemberApiFp(this.configuration).updateCompanyMember(requestParameters.companyMemberId, requestParameters.updateCompanyMemberRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.CompanyMemberApi = CompanyMemberApi;
/**
 * EPrescribeAuthApi - axios parameter creator
 * @export
 */
exports.EPrescribeAuthApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {GenerateEPrescribeRefreshTokenForProviderRequest} generateEPrescribeRefreshTokenForProviderRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateEPrescribeRefreshTokenForProvider: (generateEPrescribeRefreshTokenForProviderRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'generateEPrescribeRefreshTokenForProviderRequest' is not null or undefined
            common_1.assertParamExists('generateEPrescribeRefreshTokenForProvider', 'generateEPrescribeRefreshTokenForProviderRequest', generateEPrescribeRefreshTokenForProviderRequest);
            const localVarPath = `/v1/e-prescribe-auth/refresh-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(generateEPrescribeRefreshTokenForProviderRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEPrescribeAccessTokenForProvider: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/e-prescribe-auth/access-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * EPrescribeAuthApi - functional programming interface
 * @export
 */
exports.EPrescribeAuthApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.EPrescribeAuthApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {GenerateEPrescribeRefreshTokenForProviderRequest} generateEPrescribeRefreshTokenForProviderRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateEPrescribeRefreshTokenForProvider(generateEPrescribeRefreshTokenForProviderRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.generateEPrescribeRefreshTokenForProvider(generateEPrescribeRefreshTokenForProviderRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEPrescribeAccessTokenForProvider(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEPrescribeAccessTokenForProvider(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * EPrescribeAuthApi - factory interface
 * @export
 */
exports.EPrescribeAuthApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.EPrescribeAuthApiFp(configuration);
    return {
        /**
         *
         * @param {GenerateEPrescribeRefreshTokenForProviderRequest} generateEPrescribeRefreshTokenForProviderRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateEPrescribeRefreshTokenForProvider(generateEPrescribeRefreshTokenForProviderRequest, options) {
            return localVarFp.generateEPrescribeRefreshTokenForProvider(generateEPrescribeRefreshTokenForProviderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEPrescribeAccessTokenForProvider(options) {
            return localVarFp.getEPrescribeAccessTokenForProvider(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * EPrescribeAuthApi - object-oriented interface
 * @export
 * @class EPrescribeAuthApi
 * @extends {BaseAPI}
 */
class EPrescribeAuthApi extends base_1.BaseAPI {
    /**
     *
     * @param {EPrescribeAuthApiGenerateEPrescribeRefreshTokenForProviderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EPrescribeAuthApi
     */
    generateEPrescribeRefreshTokenForProvider(requestParameters, options) {
        return exports.EPrescribeAuthApiFp(this.configuration).generateEPrescribeRefreshTokenForProvider(requestParameters.generateEPrescribeRefreshTokenForProviderRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EPrescribeAuthApi
     */
    getEPrescribeAccessTokenForProvider(options) {
        return exports.EPrescribeAuthApiFp(this.configuration).getEPrescribeAccessTokenForProvider(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.EPrescribeAuthApi = EPrescribeAuthApi;
/**
 * EmployeeManagementIntegrationApi - axios parameter creator
 * @export
 */
exports.EmployeeManagementIntegrationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pingSlackWithIntegrationCensusCsv: (companyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyId' is not null or undefined
            common_1.assertParamExists('pingSlackWithIntegrationCensusCsv', 'companyId', companyId);
            const localVarPath = `/v1/companies/{company_id}/workforce-integrations/census`
                .replace(`{${"company_id"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * EmployeeManagementIntegrationApi - functional programming interface
 * @export
 */
exports.EmployeeManagementIntegrationApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.EmployeeManagementIntegrationApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pingSlackWithIntegrationCensusCsv(companyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pingSlackWithIntegrationCensusCsv(companyId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * EmployeeManagementIntegrationApi - factory interface
 * @export
 */
exports.EmployeeManagementIntegrationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.EmployeeManagementIntegrationApiFp(configuration);
    return {
        /**
         *
         * @param {string} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pingSlackWithIntegrationCensusCsv(companyId, options) {
            return localVarFp.pingSlackWithIntegrationCensusCsv(companyId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * EmployeeManagementIntegrationApi - object-oriented interface
 * @export
 * @class EmployeeManagementIntegrationApi
 * @extends {BaseAPI}
 */
class EmployeeManagementIntegrationApi extends base_1.BaseAPI {
    /**
     *
     * @param {EmployeeManagementIntegrationApiPingSlackWithIntegrationCensusCsvRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeManagementIntegrationApi
     */
    pingSlackWithIntegrationCensusCsv(requestParameters, options) {
        return exports.EmployeeManagementIntegrationApiFp(this.configuration).pingSlackWithIntegrationCensusCsv(requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.EmployeeManagementIntegrationApi = EmployeeManagementIntegrationApi;
/**
 * EncounterApi - axios parameter creator
 * @export
 */
exports.EncounterApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} encounterId
         * @param {AddMedicalServicesToEncounterRequest} addMedicalServicesToEncounterRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMedicalServicesToEncounter: (encounterId, addMedicalServicesToEncounterRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'encounterId' is not null or undefined
            common_1.assertParamExists('addMedicalServicesToEncounter', 'encounterId', encounterId);
            // verify required parameter 'addMedicalServicesToEncounterRequest' is not null or undefined
            common_1.assertParamExists('addMedicalServicesToEncounter', 'addMedicalServicesToEncounterRequest', addMedicalServicesToEncounterRequest);
            const localVarPath = `/v1/encounters/{encounter_id}/medical-services`
                .replace(`{${"encounter_id"}}`, encodeURIComponent(String(encounterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(addMedicalServicesToEncounterRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} encounterId
         * @param {string} fileFieldId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEncounterAdditionalFile: (encounterId, fileFieldId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'encounterId' is not null or undefined
            common_1.assertParamExists('deleteEncounterAdditionalFile', 'encounterId', encounterId);
            // verify required parameter 'fileFieldId' is not null or undefined
            common_1.assertParamExists('deleteEncounterAdditionalFile', 'fileFieldId', fileFieldId);
            const localVarPath = `/v1/encounters/{encounter_id}/additional-files/{file_field_id}`
                .replace(`{${"encounter_id"}}`, encodeURIComponent(String(encounterId)))
                .replace(`{${"file_field_id"}}`, encodeURIComponent(String(fileFieldId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} encounterId
         * @param {string} insightType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateEncounterAiInsights: (encounterId, insightType, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'encounterId' is not null or undefined
            common_1.assertParamExists('generateEncounterAiInsights', 'encounterId', encounterId);
            // verify required parameter 'insightType' is not null or undefined
            common_1.assertParamExists('generateEncounterAiInsights', 'insightType', insightType);
            const localVarPath = `/v1/encounters/{encounter_id}/ai-insight/{insight_type}`
                .replace(`{${"encounter_id"}}`, encodeURIComponent(String(encounterId)))
                .replace(`{${"insight_type"}}`, encodeURIComponent(String(insightType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} encounterId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEncounter: (encounterId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'encounterId' is not null or undefined
            common_1.assertParamExists('getEncounter', 'encounterId', encounterId);
            const localVarPath = `/v1/encounters/{encounter_id}`
                .replace(`{${"encounter_id"}}`, encodeURIComponent(String(encounterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} encounterId
         * @param {string} insightType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEncounterAiInsights: (encounterId, insightType, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'encounterId' is not null or undefined
            common_1.assertParamExists('getEncounterAiInsights', 'encounterId', encounterId);
            // verify required parameter 'insightType' is not null or undefined
            common_1.assertParamExists('getEncounterAiInsights', 'insightType', insightType);
            const localVarPath = `/v1/encounters/{encounter_id}/ai-insight/{insight_type}`
                .replace(`{${"encounter_id"}}`, encodeURIComponent(String(encounterId)))
                .replace(`{${"insight_type"}}`, encodeURIComponent(String(insightType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} encounterId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEncounterSymptoms: (encounterId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'encounterId' is not null or undefined
            common_1.assertParamExists('listEncounterSymptoms', 'encounterId', encounterId);
            const localVarPath = `/v1/encounters/{encounter_id}/symptoms`
                .replace(`{${"encounter_id"}}`, encodeURIComponent(String(encounterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} encounterId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEncounterVisitReasons: (encounterId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'encounterId' is not null or undefined
            common_1.assertParamExists('listEncounterVisitReasons', 'encounterId', encounterId);
            const localVarPath = `/v1/encounters/{encounter_id}/visit-reasons`
                .replace(`{${"encounter_id"}}`, encodeURIComponent(String(encounterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [appointmentId]
         * @param {'AL' | 'AK' | 'AZ' | 'AR' | 'CA' | 'CO' | 'CT' | 'DC' | 'DE' | 'FL' | 'GA' | 'HI' | 'ID' | 'IL' | 'IN' | 'IA' | 'KS' | 'KY' | 'LA' | 'ME' | 'MD' | 'MA' | 'MI' | 'MN' | 'MS' | 'MO' | 'MT' | 'NE' | 'NV' | 'NH' | 'NJ' | 'NM' | 'NY' | 'NC' | 'ND' | 'OH' | 'OK' | 'OR' | 'PR' | 'PA' | 'RI' | 'SC' | 'SD' | 'TN' | 'TX' | 'UT' | 'VT' | 'VI' | 'VA' | 'WA' | 'WI' | 'WV' | 'WY' | 'AA' | 'AE' | 'PW' | 'AP' | 'FM' | 'MH' | 'GU'} [appointmentState] * &#x60;AL&#x60; - AL * &#x60;AK&#x60; - AK * &#x60;AZ&#x60; - AZ * &#x60;AR&#x60; - AR * &#x60;CA&#x60; - CA * &#x60;CO&#x60; - CO * &#x60;CT&#x60; - CT * &#x60;DC&#x60; - DC * &#x60;DE&#x60; - DE * &#x60;FL&#x60; - FL * &#x60;GA&#x60; - GA * &#x60;HI&#x60; - HI * &#x60;ID&#x60; - ID * &#x60;IL&#x60; - IL * &#x60;IN&#x60; - IN * &#x60;IA&#x60; - IA * &#x60;KS&#x60; - KS * &#x60;KY&#x60; - KY * &#x60;LA&#x60; - LA * &#x60;ME&#x60; - ME * &#x60;MD&#x60; - MD * &#x60;MA&#x60; - MA * &#x60;MI&#x60; - MI * &#x60;MN&#x60; - MN * &#x60;MS&#x60; - MS * &#x60;MO&#x60; - MO * &#x60;MT&#x60; - MT * &#x60;NE&#x60; - NE * &#x60;NV&#x60; - NV * &#x60;NH&#x60; - NH * &#x60;NJ&#x60; - NJ * &#x60;NM&#x60; - NM * &#x60;NY&#x60; - NY * &#x60;NC&#x60; - NC * &#x60;ND&#x60; - ND * &#x60;OH&#x60; - OH * &#x60;OK&#x60; - OK * &#x60;OR&#x60; - OR * &#x60;PR&#x60; - PR * &#x60;PA&#x60; - PA * &#x60;RI&#x60; - RI * &#x60;SC&#x60; - SC * &#x60;SD&#x60; - SD * &#x60;TN&#x60; - TN * &#x60;TX&#x60; - TX * &#x60;UT&#x60; - UT * &#x60;VT&#x60; - VT * &#x60;VI&#x60; - VI * &#x60;VA&#x60; - VA * &#x60;WA&#x60; - WA * &#x60;WI&#x60; - WI * &#x60;WV&#x60; - WV * &#x60;WY&#x60; - WY * &#x60;AA&#x60; - AA * &#x60;AE&#x60; - AE * &#x60;PW&#x60; - PW * &#x60;AP&#x60; - AP * &#x60;FM&#x60; - FM * &#x60;MH&#x60; - MH * &#x60;GU&#x60; - GU
         * @param {'In Person' | 'Telemedicine'} [appointmentType] * &#x60;In Person&#x60; - In Person * &#x60;Telemedicine&#x60; - Telemedicine
         * @param {string} [asyncAppointmentId]
         * @param {boolean} [cancelled]
         * @param {string} [companyId]
         * @param {string} [endDatetime]
         * @param {number} [limit]
         * @param {string} [medicalServiceId]
         * @param {boolean} [missingCharts]
         * @param {boolean} [missingHpi]
         * @param {boolean} [onlyClinicalIn]
         * @param {boolean} [onlyIndividualIn]
         * @param {boolean} [orderByAppointmentStartTime]
         * @param {number} [page]
         * @param {string} [patientId]
         * @param {string} [problemId]
         * @param {string} [providerId]
         * @param {string} [startDatetime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEncounters: (appointmentId, appointmentState, appointmentType, asyncAppointmentId, cancelled, companyId, endDatetime, limit, medicalServiceId, missingCharts, missingHpi, onlyClinicalIn, onlyIndividualIn, orderByAppointmentStartTime, page, patientId, problemId, providerId, startDatetime, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/encounters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (appointmentId !== undefined) {
                localVarQueryParameter['appointment_id'] = appointmentId;
            }
            if (appointmentState !== undefined) {
                localVarQueryParameter['appointment_state'] = appointmentState;
            }
            if (appointmentType !== undefined) {
                localVarQueryParameter['appointment_type'] = appointmentType;
            }
            if (asyncAppointmentId !== undefined) {
                localVarQueryParameter['async_appointment_id'] = asyncAppointmentId;
            }
            if (cancelled !== undefined) {
                localVarQueryParameter['cancelled'] = cancelled;
            }
            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }
            if (endDatetime !== undefined) {
                localVarQueryParameter['end_datetime'] = (endDatetime instanceof Date) ?
                    endDatetime.toISOString() :
                    endDatetime;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (medicalServiceId !== undefined) {
                localVarQueryParameter['medical_service_id'] = medicalServiceId;
            }
            if (missingCharts !== undefined) {
                localVarQueryParameter['missing_charts'] = missingCharts;
            }
            if (missingHpi !== undefined) {
                localVarQueryParameter['missing_hpi'] = missingHpi;
            }
            if (onlyClinicalIn !== undefined) {
                localVarQueryParameter['only_clinical_in'] = onlyClinicalIn;
            }
            if (onlyIndividualIn !== undefined) {
                localVarQueryParameter['only_individual_in'] = onlyIndividualIn;
            }
            if (orderByAppointmentStartTime !== undefined) {
                localVarQueryParameter['order_by_appointment_start_time'] = orderByAppointmentStartTime;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (patientId !== undefined) {
                localVarQueryParameter['patient_id'] = patientId;
            }
            if (problemId !== undefined) {
                localVarQueryParameter['problem_id'] = problemId;
            }
            if (providerId !== undefined) {
                localVarQueryParameter['provider_id'] = providerId;
            }
            if (startDatetime !== undefined) {
                localVarQueryParameter['start_datetime'] = (startDatetime instanceof Date) ?
                    startDatetime.toISOString() :
                    startDatetime;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} appointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEncountersByAppointment: (appointmentId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'appointmentId' is not null or undefined
            common_1.assertParamExists('listEncountersByAppointment', 'appointmentId', appointmentId);
            const localVarPath = `/v1/appointments/{appointment_id}/encounters`
                .replace(`{${"appointment_id"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} clinicalAppointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEncountersByClinicalAppointment: (clinicalAppointmentId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clinicalAppointmentId' is not null or undefined
            common_1.assertParamExists('listEncountersByClinicalAppointment', 'clinicalAppointmentId', clinicalAppointmentId);
            const localVarPath = `/v1/clinical-appointments/{clinical_appointment_id}/encounters`
                .replace(`{${"clinical_appointment_id"}}`, encodeURIComponent(String(clinicalAppointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} problemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEncountersByProblem: (problemId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'problemId' is not null or undefined
            common_1.assertParamExists('listEncountersByProblem', 'problemId', problemId);
            const localVarPath = `/v1/problems/{problem_id}/encounters`
                .replace(`{${"problem_id"}}`, encodeURIComponent(String(problemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} memberId
         * @param {string} [medicalServiceId]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMemberEncounters: (memberId, medicalServiceId, page, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'memberId' is not null or undefined
            common_1.assertParamExists('listMemberEncounters', 'memberId', memberId);
            const localVarPath = `/v1/members/{member_id}/encounters`
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (medicalServiceId !== undefined) {
                localVarQueryParameter['medical_service_id'] = medicalServiceId;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} encounterId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRequiredOhrTypes: (encounterId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'encounterId' is not null or undefined
            common_1.assertParamExists('listRequiredOhrTypes', 'encounterId', encounterId);
            const localVarPath = `/v1/encounters/{encounter_id}/required-ohr-types`
                .replace(`{${"encounter_id"}}`, encodeURIComponent(String(encounterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} encounterId
         * @param {string} medicalServiceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeMedicalServiceFromEncounter: (encounterId, medicalServiceId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'encounterId' is not null or undefined
            common_1.assertParamExists('removeMedicalServiceFromEncounter', 'encounterId', encounterId);
            // verify required parameter 'medicalServiceId' is not null or undefined
            common_1.assertParamExists('removeMedicalServiceFromEncounter', 'medicalServiceId', medicalServiceId);
            const localVarPath = `/v1/encounters/{encounter_id}/medical-services/{medical_service_id}`
                .replace(`{${"encounter_id"}}`, encodeURIComponent(String(encounterId)))
                .replace(`{${"medical_service_id"}}`, encodeURIComponent(String(medicalServiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} encounterId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewEncounter: (encounterId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'encounterId' is not null or undefined
            common_1.assertParamExists('reviewEncounter', 'encounterId', encounterId);
            const localVarPath = `/v1/encounters/{encounter_id}/review`
                .replace(`{${"encounter_id"}}`, encodeURIComponent(String(encounterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} encounterId
         * @param {UpdateEncounterRequest} [updateEncounterRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEncounter: (encounterId, updateEncounterRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'encounterId' is not null or undefined
            common_1.assertParamExists('updateEncounter', 'encounterId', encounterId);
            const localVarPath = `/v1/encounters/{encounter_id}`
                .replace(`{${"encounter_id"}}`, encodeURIComponent(String(encounterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateEncounterRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} encounterId
         * @param {string} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadEncounterAdditionalFile: (encounterId, file, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'encounterId' is not null or undefined
            common_1.assertParamExists('uploadEncounterAdditionalFile', 'encounterId', encounterId);
            // verify required parameter 'file' is not null or undefined
            common_1.assertParamExists('uploadEncounterAdditionalFile', 'file', file);
            const localVarPath = `/v1/encounters/{encounter_id}/additional-files`
                .replace(`{${"encounter_id"}}`, encodeURIComponent(String(encounterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * EncounterApi - functional programming interface
 * @export
 */
exports.EncounterApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.EncounterApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} encounterId
         * @param {AddMedicalServicesToEncounterRequest} addMedicalServicesToEncounterRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMedicalServicesToEncounter(encounterId, addMedicalServicesToEncounterRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addMedicalServicesToEncounter(encounterId, addMedicalServicesToEncounterRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} encounterId
         * @param {string} fileFieldId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEncounterAdditionalFile(encounterId, fileFieldId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteEncounterAdditionalFile(encounterId, fileFieldId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} encounterId
         * @param {string} insightType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateEncounterAiInsights(encounterId, insightType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.generateEncounterAiInsights(encounterId, insightType, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} encounterId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEncounter(encounterId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEncounter(encounterId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} encounterId
         * @param {string} insightType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEncounterAiInsights(encounterId, insightType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEncounterAiInsights(encounterId, insightType, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} encounterId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEncounterSymptoms(encounterId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listEncounterSymptoms(encounterId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} encounterId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEncounterVisitReasons(encounterId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listEncounterVisitReasons(encounterId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} [appointmentId]
         * @param {'AL' | 'AK' | 'AZ' | 'AR' | 'CA' | 'CO' | 'CT' | 'DC' | 'DE' | 'FL' | 'GA' | 'HI' | 'ID' | 'IL' | 'IN' | 'IA' | 'KS' | 'KY' | 'LA' | 'ME' | 'MD' | 'MA' | 'MI' | 'MN' | 'MS' | 'MO' | 'MT' | 'NE' | 'NV' | 'NH' | 'NJ' | 'NM' | 'NY' | 'NC' | 'ND' | 'OH' | 'OK' | 'OR' | 'PR' | 'PA' | 'RI' | 'SC' | 'SD' | 'TN' | 'TX' | 'UT' | 'VT' | 'VI' | 'VA' | 'WA' | 'WI' | 'WV' | 'WY' | 'AA' | 'AE' | 'PW' | 'AP' | 'FM' | 'MH' | 'GU'} [appointmentState] * &#x60;AL&#x60; - AL * &#x60;AK&#x60; - AK * &#x60;AZ&#x60; - AZ * &#x60;AR&#x60; - AR * &#x60;CA&#x60; - CA * &#x60;CO&#x60; - CO * &#x60;CT&#x60; - CT * &#x60;DC&#x60; - DC * &#x60;DE&#x60; - DE * &#x60;FL&#x60; - FL * &#x60;GA&#x60; - GA * &#x60;HI&#x60; - HI * &#x60;ID&#x60; - ID * &#x60;IL&#x60; - IL * &#x60;IN&#x60; - IN * &#x60;IA&#x60; - IA * &#x60;KS&#x60; - KS * &#x60;KY&#x60; - KY * &#x60;LA&#x60; - LA * &#x60;ME&#x60; - ME * &#x60;MD&#x60; - MD * &#x60;MA&#x60; - MA * &#x60;MI&#x60; - MI * &#x60;MN&#x60; - MN * &#x60;MS&#x60; - MS * &#x60;MO&#x60; - MO * &#x60;MT&#x60; - MT * &#x60;NE&#x60; - NE * &#x60;NV&#x60; - NV * &#x60;NH&#x60; - NH * &#x60;NJ&#x60; - NJ * &#x60;NM&#x60; - NM * &#x60;NY&#x60; - NY * &#x60;NC&#x60; - NC * &#x60;ND&#x60; - ND * &#x60;OH&#x60; - OH * &#x60;OK&#x60; - OK * &#x60;OR&#x60; - OR * &#x60;PR&#x60; - PR * &#x60;PA&#x60; - PA * &#x60;RI&#x60; - RI * &#x60;SC&#x60; - SC * &#x60;SD&#x60; - SD * &#x60;TN&#x60; - TN * &#x60;TX&#x60; - TX * &#x60;UT&#x60; - UT * &#x60;VT&#x60; - VT * &#x60;VI&#x60; - VI * &#x60;VA&#x60; - VA * &#x60;WA&#x60; - WA * &#x60;WI&#x60; - WI * &#x60;WV&#x60; - WV * &#x60;WY&#x60; - WY * &#x60;AA&#x60; - AA * &#x60;AE&#x60; - AE * &#x60;PW&#x60; - PW * &#x60;AP&#x60; - AP * &#x60;FM&#x60; - FM * &#x60;MH&#x60; - MH * &#x60;GU&#x60; - GU
         * @param {'In Person' | 'Telemedicine'} [appointmentType] * &#x60;In Person&#x60; - In Person * &#x60;Telemedicine&#x60; - Telemedicine
         * @param {string} [asyncAppointmentId]
         * @param {boolean} [cancelled]
         * @param {string} [companyId]
         * @param {string} [endDatetime]
         * @param {number} [limit]
         * @param {string} [medicalServiceId]
         * @param {boolean} [missingCharts]
         * @param {boolean} [missingHpi]
         * @param {boolean} [onlyClinicalIn]
         * @param {boolean} [onlyIndividualIn]
         * @param {boolean} [orderByAppointmentStartTime]
         * @param {number} [page]
         * @param {string} [patientId]
         * @param {string} [problemId]
         * @param {string} [providerId]
         * @param {string} [startDatetime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEncounters(appointmentId, appointmentState, appointmentType, asyncAppointmentId, cancelled, companyId, endDatetime, limit, medicalServiceId, missingCharts, missingHpi, onlyClinicalIn, onlyIndividualIn, orderByAppointmentStartTime, page, patientId, problemId, providerId, startDatetime, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listEncounters(appointmentId, appointmentState, appointmentType, asyncAppointmentId, cancelled, companyId, endDatetime, limit, medicalServiceId, missingCharts, missingHpi, onlyClinicalIn, onlyIndividualIn, orderByAppointmentStartTime, page, patientId, problemId, providerId, startDatetime, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} appointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEncountersByAppointment(appointmentId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listEncountersByAppointment(appointmentId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} clinicalAppointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEncountersByClinicalAppointment(clinicalAppointmentId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listEncountersByClinicalAppointment(clinicalAppointmentId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} problemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEncountersByProblem(problemId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listEncountersByProblem(problemId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} memberId
         * @param {string} [medicalServiceId]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMemberEncounters(memberId, medicalServiceId, page, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listMemberEncounters(memberId, medicalServiceId, page, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} encounterId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRequiredOhrTypes(encounterId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listRequiredOhrTypes(encounterId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} encounterId
         * @param {string} medicalServiceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeMedicalServiceFromEncounter(encounterId, medicalServiceId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.removeMedicalServiceFromEncounter(encounterId, medicalServiceId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} encounterId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewEncounter(encounterId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reviewEncounter(encounterId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} encounterId
         * @param {UpdateEncounterRequest} [updateEncounterRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEncounter(encounterId, updateEncounterRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateEncounter(encounterId, updateEncounterRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} encounterId
         * @param {string} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadEncounterAdditionalFile(encounterId, file, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.uploadEncounterAdditionalFile(encounterId, file, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * EncounterApi - factory interface
 * @export
 */
exports.EncounterApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.EncounterApiFp(configuration);
    return {
        /**
         *
         * @param {string} encounterId
         * @param {AddMedicalServicesToEncounterRequest} addMedicalServicesToEncounterRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMedicalServicesToEncounter(encounterId, addMedicalServicesToEncounterRequest, options) {
            return localVarFp.addMedicalServicesToEncounter(encounterId, addMedicalServicesToEncounterRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} encounterId
         * @param {string} fileFieldId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEncounterAdditionalFile(encounterId, fileFieldId, options) {
            return localVarFp.deleteEncounterAdditionalFile(encounterId, fileFieldId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} encounterId
         * @param {string} insightType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateEncounterAiInsights(encounterId, insightType, options) {
            return localVarFp.generateEncounterAiInsights(encounterId, insightType, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} encounterId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEncounter(encounterId, options) {
            return localVarFp.getEncounter(encounterId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} encounterId
         * @param {string} insightType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEncounterAiInsights(encounterId, insightType, options) {
            return localVarFp.getEncounterAiInsights(encounterId, insightType, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} encounterId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEncounterSymptoms(encounterId, options) {
            return localVarFp.listEncounterSymptoms(encounterId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} encounterId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEncounterVisitReasons(encounterId, options) {
            return localVarFp.listEncounterVisitReasons(encounterId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [appointmentId]
         * @param {'AL' | 'AK' | 'AZ' | 'AR' | 'CA' | 'CO' | 'CT' | 'DC' | 'DE' | 'FL' | 'GA' | 'HI' | 'ID' | 'IL' | 'IN' | 'IA' | 'KS' | 'KY' | 'LA' | 'ME' | 'MD' | 'MA' | 'MI' | 'MN' | 'MS' | 'MO' | 'MT' | 'NE' | 'NV' | 'NH' | 'NJ' | 'NM' | 'NY' | 'NC' | 'ND' | 'OH' | 'OK' | 'OR' | 'PR' | 'PA' | 'RI' | 'SC' | 'SD' | 'TN' | 'TX' | 'UT' | 'VT' | 'VI' | 'VA' | 'WA' | 'WI' | 'WV' | 'WY' | 'AA' | 'AE' | 'PW' | 'AP' | 'FM' | 'MH' | 'GU'} [appointmentState] * &#x60;AL&#x60; - AL * &#x60;AK&#x60; - AK * &#x60;AZ&#x60; - AZ * &#x60;AR&#x60; - AR * &#x60;CA&#x60; - CA * &#x60;CO&#x60; - CO * &#x60;CT&#x60; - CT * &#x60;DC&#x60; - DC * &#x60;DE&#x60; - DE * &#x60;FL&#x60; - FL * &#x60;GA&#x60; - GA * &#x60;HI&#x60; - HI * &#x60;ID&#x60; - ID * &#x60;IL&#x60; - IL * &#x60;IN&#x60; - IN * &#x60;IA&#x60; - IA * &#x60;KS&#x60; - KS * &#x60;KY&#x60; - KY * &#x60;LA&#x60; - LA * &#x60;ME&#x60; - ME * &#x60;MD&#x60; - MD * &#x60;MA&#x60; - MA * &#x60;MI&#x60; - MI * &#x60;MN&#x60; - MN * &#x60;MS&#x60; - MS * &#x60;MO&#x60; - MO * &#x60;MT&#x60; - MT * &#x60;NE&#x60; - NE * &#x60;NV&#x60; - NV * &#x60;NH&#x60; - NH * &#x60;NJ&#x60; - NJ * &#x60;NM&#x60; - NM * &#x60;NY&#x60; - NY * &#x60;NC&#x60; - NC * &#x60;ND&#x60; - ND * &#x60;OH&#x60; - OH * &#x60;OK&#x60; - OK * &#x60;OR&#x60; - OR * &#x60;PR&#x60; - PR * &#x60;PA&#x60; - PA * &#x60;RI&#x60; - RI * &#x60;SC&#x60; - SC * &#x60;SD&#x60; - SD * &#x60;TN&#x60; - TN * &#x60;TX&#x60; - TX * &#x60;UT&#x60; - UT * &#x60;VT&#x60; - VT * &#x60;VI&#x60; - VI * &#x60;VA&#x60; - VA * &#x60;WA&#x60; - WA * &#x60;WI&#x60; - WI * &#x60;WV&#x60; - WV * &#x60;WY&#x60; - WY * &#x60;AA&#x60; - AA * &#x60;AE&#x60; - AE * &#x60;PW&#x60; - PW * &#x60;AP&#x60; - AP * &#x60;FM&#x60; - FM * &#x60;MH&#x60; - MH * &#x60;GU&#x60; - GU
         * @param {'In Person' | 'Telemedicine'} [appointmentType] * &#x60;In Person&#x60; - In Person * &#x60;Telemedicine&#x60; - Telemedicine
         * @param {string} [asyncAppointmentId]
         * @param {boolean} [cancelled]
         * @param {string} [companyId]
         * @param {string} [endDatetime]
         * @param {number} [limit]
         * @param {string} [medicalServiceId]
         * @param {boolean} [missingCharts]
         * @param {boolean} [missingHpi]
         * @param {boolean} [onlyClinicalIn]
         * @param {boolean} [onlyIndividualIn]
         * @param {boolean} [orderByAppointmentStartTime]
         * @param {number} [page]
         * @param {string} [patientId]
         * @param {string} [problemId]
         * @param {string} [providerId]
         * @param {string} [startDatetime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEncounters(appointmentId, appointmentState, appointmentType, asyncAppointmentId, cancelled, companyId, endDatetime, limit, medicalServiceId, missingCharts, missingHpi, onlyClinicalIn, onlyIndividualIn, orderByAppointmentStartTime, page, patientId, problemId, providerId, startDatetime, options) {
            return localVarFp.listEncounters(appointmentId, appointmentState, appointmentType, asyncAppointmentId, cancelled, companyId, endDatetime, limit, medicalServiceId, missingCharts, missingHpi, onlyClinicalIn, onlyIndividualIn, orderByAppointmentStartTime, page, patientId, problemId, providerId, startDatetime, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} appointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEncountersByAppointment(appointmentId, options) {
            return localVarFp.listEncountersByAppointment(appointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} clinicalAppointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEncountersByClinicalAppointment(clinicalAppointmentId, options) {
            return localVarFp.listEncountersByClinicalAppointment(clinicalAppointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} problemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEncountersByProblem(problemId, options) {
            return localVarFp.listEncountersByProblem(problemId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} memberId
         * @param {string} [medicalServiceId]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMemberEncounters(memberId, medicalServiceId, page, options) {
            return localVarFp.listMemberEncounters(memberId, medicalServiceId, page, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} encounterId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRequiredOhrTypes(encounterId, options) {
            return localVarFp.listRequiredOhrTypes(encounterId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} encounterId
         * @param {string} medicalServiceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeMedicalServiceFromEncounter(encounterId, medicalServiceId, options) {
            return localVarFp.removeMedicalServiceFromEncounter(encounterId, medicalServiceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} encounterId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewEncounter(encounterId, options) {
            return localVarFp.reviewEncounter(encounterId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} encounterId
         * @param {UpdateEncounterRequest} [updateEncounterRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEncounter(encounterId, updateEncounterRequest, options) {
            return localVarFp.updateEncounter(encounterId, updateEncounterRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} encounterId
         * @param {string} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadEncounterAdditionalFile(encounterId, file, options) {
            return localVarFp.uploadEncounterAdditionalFile(encounterId, file, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * EncounterApi - object-oriented interface
 * @export
 * @class EncounterApi
 * @extends {BaseAPI}
 */
class EncounterApi extends base_1.BaseAPI {
    /**
     *
     * @param {EncounterApiAddMedicalServicesToEncounterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncounterApi
     */
    addMedicalServicesToEncounter(requestParameters, options) {
        return exports.EncounterApiFp(this.configuration).addMedicalServicesToEncounter(requestParameters.encounterId, requestParameters.addMedicalServicesToEncounterRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {EncounterApiDeleteEncounterAdditionalFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncounterApi
     */
    deleteEncounterAdditionalFile(requestParameters, options) {
        return exports.EncounterApiFp(this.configuration).deleteEncounterAdditionalFile(requestParameters.encounterId, requestParameters.fileFieldId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {EncounterApiGenerateEncounterAiInsightsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncounterApi
     */
    generateEncounterAiInsights(requestParameters, options) {
        return exports.EncounterApiFp(this.configuration).generateEncounterAiInsights(requestParameters.encounterId, requestParameters.insightType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {EncounterApiGetEncounterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncounterApi
     */
    getEncounter(requestParameters, options) {
        return exports.EncounterApiFp(this.configuration).getEncounter(requestParameters.encounterId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {EncounterApiGetEncounterAiInsightsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncounterApi
     */
    getEncounterAiInsights(requestParameters, options) {
        return exports.EncounterApiFp(this.configuration).getEncounterAiInsights(requestParameters.encounterId, requestParameters.insightType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {EncounterApiListEncounterSymptomsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncounterApi
     */
    listEncounterSymptoms(requestParameters, options) {
        return exports.EncounterApiFp(this.configuration).listEncounterSymptoms(requestParameters.encounterId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {EncounterApiListEncounterVisitReasonsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncounterApi
     */
    listEncounterVisitReasons(requestParameters, options) {
        return exports.EncounterApiFp(this.configuration).listEncounterVisitReasons(requestParameters.encounterId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {EncounterApiListEncountersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncounterApi
     */
    listEncounters(requestParameters = {}, options) {
        return exports.EncounterApiFp(this.configuration).listEncounters(requestParameters.appointmentId, requestParameters.appointmentState, requestParameters.appointmentType, requestParameters.asyncAppointmentId, requestParameters.cancelled, requestParameters.companyId, requestParameters.endDatetime, requestParameters.limit, requestParameters.medicalServiceId, requestParameters.missingCharts, requestParameters.missingHpi, requestParameters.onlyClinicalIn, requestParameters.onlyIndividualIn, requestParameters.orderByAppointmentStartTime, requestParameters.page, requestParameters.patientId, requestParameters.problemId, requestParameters.providerId, requestParameters.startDatetime, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {EncounterApiListEncountersByAppointmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncounterApi
     */
    listEncountersByAppointment(requestParameters, options) {
        return exports.EncounterApiFp(this.configuration).listEncountersByAppointment(requestParameters.appointmentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {EncounterApiListEncountersByClinicalAppointmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncounterApi
     */
    listEncountersByClinicalAppointment(requestParameters, options) {
        return exports.EncounterApiFp(this.configuration).listEncountersByClinicalAppointment(requestParameters.clinicalAppointmentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {EncounterApiListEncountersByProblemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncounterApi
     */
    listEncountersByProblem(requestParameters, options) {
        return exports.EncounterApiFp(this.configuration).listEncountersByProblem(requestParameters.problemId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {EncounterApiListMemberEncountersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncounterApi
     */
    listMemberEncounters(requestParameters, options) {
        return exports.EncounterApiFp(this.configuration).listMemberEncounters(requestParameters.memberId, requestParameters.medicalServiceId, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {EncounterApiListRequiredOhrTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncounterApi
     */
    listRequiredOhrTypes(requestParameters, options) {
        return exports.EncounterApiFp(this.configuration).listRequiredOhrTypes(requestParameters.encounterId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {EncounterApiRemoveMedicalServiceFromEncounterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncounterApi
     */
    removeMedicalServiceFromEncounter(requestParameters, options) {
        return exports.EncounterApiFp(this.configuration).removeMedicalServiceFromEncounter(requestParameters.encounterId, requestParameters.medicalServiceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {EncounterApiReviewEncounterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncounterApi
     */
    reviewEncounter(requestParameters, options) {
        return exports.EncounterApiFp(this.configuration).reviewEncounter(requestParameters.encounterId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {EncounterApiUpdateEncounterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncounterApi
     */
    updateEncounter(requestParameters, options) {
        return exports.EncounterApiFp(this.configuration).updateEncounter(requestParameters.encounterId, requestParameters.updateEncounterRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {EncounterApiUploadEncounterAdditionalFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EncounterApi
     */
    uploadEncounterAdditionalFile(requestParameters, options) {
        return exports.EncounterApiFp(this.configuration).uploadEncounterAdditionalFile(requestParameters.encounterId, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.EncounterApi = EncounterApi;
/**
 * EntitlementApi - axios parameter creator
 * @export
 */
exports.EntitlementApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllEntitledMedicalServicesForCompany: (companyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyId' is not null or undefined
            common_1.assertParamExists('listAllEntitledMedicalServicesForCompany', 'companyId', companyId);
            const localVarPath = `/v1/company/{company_id}/entitled-medical-services`
                .replace(`{${"company_id"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllEntitledMedicalServicesForMember: (memberId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'memberId' is not null or undefined
            common_1.assertParamExists('listAllEntitledMedicalServicesForMember', 'memberId', memberId);
            const localVarPath = `/v1/member{member_id}/entitled-medical-services`
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllEntitlementsForCompany: (companyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyId' is not null or undefined
            common_1.assertParamExists('listAllEntitlementsForCompany', 'companyId', companyId);
            const localVarPath = `/v1/company/{company_id}/entitlements`
                .replace(`{${"company_id"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllEntitlementsForMember: (memberId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'memberId' is not null or undefined
            common_1.assertParamExists('listAllEntitlementsForMember', 'memberId', memberId);
            const localVarPath = `/v1/member/{member_id}/entitlements`
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * EntitlementApi - functional programming interface
 * @export
 */
exports.EntitlementApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.EntitlementApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllEntitledMedicalServicesForCompany(companyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listAllEntitledMedicalServicesForCompany(companyId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllEntitledMedicalServicesForMember(memberId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listAllEntitledMedicalServicesForMember(memberId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllEntitlementsForCompany(companyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listAllEntitlementsForCompany(companyId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllEntitlementsForMember(memberId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listAllEntitlementsForMember(memberId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * EntitlementApi - factory interface
 * @export
 */
exports.EntitlementApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.EntitlementApiFp(configuration);
    return {
        /**
         *
         * @param {string} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllEntitledMedicalServicesForCompany(companyId, options) {
            return localVarFp.listAllEntitledMedicalServicesForCompany(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllEntitledMedicalServicesForMember(memberId, options) {
            return localVarFp.listAllEntitledMedicalServicesForMember(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllEntitlementsForCompany(companyId, options) {
            return localVarFp.listAllEntitlementsForCompany(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllEntitlementsForMember(memberId, options) {
            return localVarFp.listAllEntitlementsForMember(memberId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * EntitlementApi - object-oriented interface
 * @export
 * @class EntitlementApi
 * @extends {BaseAPI}
 */
class EntitlementApi extends base_1.BaseAPI {
    /**
     *
     * @param {EntitlementApiListAllEntitledMedicalServicesForCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitlementApi
     */
    listAllEntitledMedicalServicesForCompany(requestParameters, options) {
        return exports.EntitlementApiFp(this.configuration).listAllEntitledMedicalServicesForCompany(requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {EntitlementApiListAllEntitledMedicalServicesForMemberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitlementApi
     */
    listAllEntitledMedicalServicesForMember(requestParameters, options) {
        return exports.EntitlementApiFp(this.configuration).listAllEntitledMedicalServicesForMember(requestParameters.memberId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {EntitlementApiListAllEntitlementsForCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitlementApi
     */
    listAllEntitlementsForCompany(requestParameters, options) {
        return exports.EntitlementApiFp(this.configuration).listAllEntitlementsForCompany(requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {EntitlementApiListAllEntitlementsForMemberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitlementApi
     */
    listAllEntitlementsForMember(requestParameters, options) {
        return exports.EntitlementApiFp(this.configuration).listAllEntitlementsForMember(requestParameters.memberId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.EntitlementApi = EntitlementApi;
/**
 * FeaturePolicyApi - axios parameter creator
 * @export
 */
exports.FeaturePolicyApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CheckIfMemberCanScheduleAppointmentRequest} checkIfMemberCanScheduleAppointmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkIfMemberCanScheduleAppointment: (checkIfMemberCanScheduleAppointmentRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'checkIfMemberCanScheduleAppointmentRequest' is not null or undefined
            common_1.assertParamExists('checkIfMemberCanScheduleAppointment', 'checkIfMemberCanScheduleAppointmentRequest', checkIfMemberCanScheduleAppointmentRequest);
            const localVarPath = `/v1/feature-policy/check-member-can-schedule-appointment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(checkIfMemberCanScheduleAppointmentRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRestrictedFeatureUsagesForMember: (memberId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'memberId' is not null or undefined
            common_1.assertParamExists('listRestrictedFeatureUsagesForMember', 'memberId', memberId);
            const localVarPath = `/v1/member/{member_id}/restricted-feature-usages`
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * FeaturePolicyApi - functional programming interface
 * @export
 */
exports.FeaturePolicyApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.FeaturePolicyApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CheckIfMemberCanScheduleAppointmentRequest} checkIfMemberCanScheduleAppointmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkIfMemberCanScheduleAppointment(checkIfMemberCanScheduleAppointmentRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.checkIfMemberCanScheduleAppointment(checkIfMemberCanScheduleAppointmentRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRestrictedFeatureUsagesForMember(memberId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listRestrictedFeatureUsagesForMember(memberId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * FeaturePolicyApi - factory interface
 * @export
 */
exports.FeaturePolicyApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.FeaturePolicyApiFp(configuration);
    return {
        /**
         *
         * @param {CheckIfMemberCanScheduleAppointmentRequest} checkIfMemberCanScheduleAppointmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkIfMemberCanScheduleAppointment(checkIfMemberCanScheduleAppointmentRequest, options) {
            return localVarFp.checkIfMemberCanScheduleAppointment(checkIfMemberCanScheduleAppointmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRestrictedFeatureUsagesForMember(memberId, options) {
            return localVarFp.listRestrictedFeatureUsagesForMember(memberId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * FeaturePolicyApi - object-oriented interface
 * @export
 * @class FeaturePolicyApi
 * @extends {BaseAPI}
 */
class FeaturePolicyApi extends base_1.BaseAPI {
    /**
     *
     * @param {FeaturePolicyApiCheckIfMemberCanScheduleAppointmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturePolicyApi
     */
    checkIfMemberCanScheduleAppointment(requestParameters, options) {
        return exports.FeaturePolicyApiFp(this.configuration).checkIfMemberCanScheduleAppointment(requestParameters.checkIfMemberCanScheduleAppointmentRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {FeaturePolicyApiListRestrictedFeatureUsagesForMemberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeaturePolicyApi
     */
    listRestrictedFeatureUsagesForMember(requestParameters, options) {
        return exports.FeaturePolicyApiFp(this.configuration).listRestrictedFeatureUsagesForMember(requestParameters.memberId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.FeaturePolicyApi = FeaturePolicyApi;
/**
 * JournalApi - axios parameter creator
 * @export
 */
exports.JournalApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} memberId
         * @param {CreateJournalEntryRequest} [createJournalEntryRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJournalEntry: (memberId, createJournalEntryRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'memberId' is not null or undefined
            common_1.assertParamExists('createJournalEntry', 'memberId', memberId);
            const localVarPath = `/v1/members/{member_id}/journals`
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createJournalEntryRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} journalEntryId
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJournalEntry: (journalEntryId, memberId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'journalEntryId' is not null or undefined
            common_1.assertParamExists('getJournalEntry', 'journalEntryId', journalEntryId);
            // verify required parameter 'memberId' is not null or undefined
            common_1.assertParamExists('getJournalEntry', 'memberId', memberId);
            const localVarPath = `/v1/members/{member_id}/journals/{journal_entry_id}`
                .replace(`{${"journal_entry_id"}}`, encodeURIComponent(String(journalEntryId)))
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJournalEntryOfTodayForMember: (memberId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'memberId' is not null or undefined
            common_1.assertParamExists('getJournalEntryOfTodayForMember', 'memberId', memberId);
            const localVarPath = `/v1/members/{member_id}/journals/today`
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} mood
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEmotionsByMood: (mood, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'mood' is not null or undefined
            common_1.assertParamExists('listEmotionsByMood', 'mood', mood);
            const localVarPath = `/v1/emotions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (mood !== undefined) {
                localVarQueryParameter['mood'] = mood;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listJournalEntries: (memberId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'memberId' is not null or undefined
            common_1.assertParamExists('listJournalEntries', 'memberId', memberId);
            const localVarPath = `/v1/members/{member_id}/journals`
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} journalEntryId
         * @param {string} memberId
         * @param {UpdateJournalEntryRequest} [updateJournalEntryRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateJournalEntry: (journalEntryId, memberId, updateJournalEntryRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'journalEntryId' is not null or undefined
            common_1.assertParamExists('updateJournalEntry', 'journalEntryId', journalEntryId);
            // verify required parameter 'memberId' is not null or undefined
            common_1.assertParamExists('updateJournalEntry', 'memberId', memberId);
            const localVarPath = `/v1/members/{member_id}/journals/{journal_entry_id}`
                .replace(`{${"journal_entry_id"}}`, encodeURIComponent(String(journalEntryId)))
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateJournalEntryRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * JournalApi - functional programming interface
 * @export
 */
exports.JournalApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.JournalApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} memberId
         * @param {CreateJournalEntryRequest} [createJournalEntryRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJournalEntry(memberId, createJournalEntryRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createJournalEntry(memberId, createJournalEntryRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} journalEntryId
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJournalEntry(journalEntryId, memberId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getJournalEntry(journalEntryId, memberId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJournalEntryOfTodayForMember(memberId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getJournalEntryOfTodayForMember(memberId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} mood
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEmotionsByMood(mood, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listEmotionsByMood(mood, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listJournalEntries(memberId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listJournalEntries(memberId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} journalEntryId
         * @param {string} memberId
         * @param {UpdateJournalEntryRequest} [updateJournalEntryRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateJournalEntry(journalEntryId, memberId, updateJournalEntryRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateJournalEntry(journalEntryId, memberId, updateJournalEntryRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * JournalApi - factory interface
 * @export
 */
exports.JournalApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.JournalApiFp(configuration);
    return {
        /**
         *
         * @param {string} memberId
         * @param {CreateJournalEntryRequest} [createJournalEntryRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJournalEntry(memberId, createJournalEntryRequest, options) {
            return localVarFp.createJournalEntry(memberId, createJournalEntryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} journalEntryId
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJournalEntry(journalEntryId, memberId, options) {
            return localVarFp.getJournalEntry(journalEntryId, memberId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJournalEntryOfTodayForMember(memberId, options) {
            return localVarFp.getJournalEntryOfTodayForMember(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} mood
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEmotionsByMood(mood, options) {
            return localVarFp.listEmotionsByMood(mood, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listJournalEntries(memberId, options) {
            return localVarFp.listJournalEntries(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} journalEntryId
         * @param {string} memberId
         * @param {UpdateJournalEntryRequest} [updateJournalEntryRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateJournalEntry(journalEntryId, memberId, updateJournalEntryRequest, options) {
            return localVarFp.updateJournalEntry(journalEntryId, memberId, updateJournalEntryRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * JournalApi - object-oriented interface
 * @export
 * @class JournalApi
 * @extends {BaseAPI}
 */
class JournalApi extends base_1.BaseAPI {
    /**
     *
     * @param {JournalApiCreateJournalEntryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JournalApi
     */
    createJournalEntry(requestParameters, options) {
        return exports.JournalApiFp(this.configuration).createJournalEntry(requestParameters.memberId, requestParameters.createJournalEntryRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {JournalApiGetJournalEntryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JournalApi
     */
    getJournalEntry(requestParameters, options) {
        return exports.JournalApiFp(this.configuration).getJournalEntry(requestParameters.journalEntryId, requestParameters.memberId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {JournalApiGetJournalEntryOfTodayForMemberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JournalApi
     */
    getJournalEntryOfTodayForMember(requestParameters, options) {
        return exports.JournalApiFp(this.configuration).getJournalEntryOfTodayForMember(requestParameters.memberId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {JournalApiListEmotionsByMoodRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JournalApi
     */
    listEmotionsByMood(requestParameters, options) {
        return exports.JournalApiFp(this.configuration).listEmotionsByMood(requestParameters.mood, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {JournalApiListJournalEntriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JournalApi
     */
    listJournalEntries(requestParameters, options) {
        return exports.JournalApiFp(this.configuration).listJournalEntries(requestParameters.memberId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {JournalApiUpdateJournalEntryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JournalApi
     */
    updateJournalEntry(requestParameters, options) {
        return exports.JournalApiFp(this.configuration).updateJournalEntry(requestParameters.journalEntryId, requestParameters.memberId, requestParameters.updateJournalEntryRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.JournalApi = JournalApi;
/**
 * LabOrderingApi - axios parameter creator
 * @export
 */
exports.LabOrderingApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} labOrderId
         * @param {CancelHealthGorillaLabOrderRequest} cancelHealthGorillaLabOrderRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelHealthGorillaLabOrder: (labOrderId, cancelHealthGorillaLabOrderRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'labOrderId' is not null or undefined
            common_1.assertParamExists('cancelHealthGorillaLabOrder', 'labOrderId', labOrderId);
            // verify required parameter 'cancelHealthGorillaLabOrderRequest' is not null or undefined
            common_1.assertParamExists('cancelHealthGorillaLabOrder', 'cancelHealthGorillaLabOrderRequest', cancelHealthGorillaLabOrderRequest);
            const localVarPath = `/v1/hg-lab-orders/{lab_order_id}/cancel`
                .replace(`{${"lab_order_id"}}`, encodeURIComponent(String(labOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(cancelHealthGorillaLabOrderRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} labOrderRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelOccupationalHealthLabOrder: (labOrderRequestId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'labOrderRequestId' is not null or undefined
            common_1.assertParamExists('cancelOccupationalHealthLabOrder', 'labOrderRequestId', labOrderRequestId);
            const localVarPath = `/v1/occupational-health-lab-order-requests/{lab_order_request_id}/cancel`
                .replace(`{${"lab_order_request_id"}}`, encodeURIComponent(String(labOrderRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} labOrderRequestId
         * @param {string} labReferenceNumber
         * @param {string} orderFile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fulfillExternalOccupationalHealthLabOrder: (labOrderRequestId, labReferenceNumber, orderFile, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'labOrderRequestId' is not null or undefined
            common_1.assertParamExists('fulfillExternalOccupationalHealthLabOrder', 'labOrderRequestId', labOrderRequestId);
            // verify required parameter 'labReferenceNumber' is not null or undefined
            common_1.assertParamExists('fulfillExternalOccupationalHealthLabOrder', 'labReferenceNumber', labReferenceNumber);
            // verify required parameter 'orderFile' is not null or undefined
            common_1.assertParamExists('fulfillExternalOccupationalHealthLabOrder', 'orderFile', orderFile);
            const localVarPath = `/v1/occupational-health-lab-order-requests/{lab_order_request_id}/fulfill-external`
                .replace(`{${"lab_order_request_id"}}`, encodeURIComponent(String(labOrderRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (labReferenceNumber !== undefined) {
                localVarFormParams.append('lab_reference_number', labReferenceNumber);
            }
            if (orderFile !== undefined) {
                localVarFormParams.append('order_file', orderFile);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} labOrderRequestId
         * @param {FulfillOccupationalHealthLabOrderRequest} fulfillOccupationalHealthLabOrderRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fulfillOccupationalHealthLabOrder: (labOrderRequestId, fulfillOccupationalHealthLabOrderRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'labOrderRequestId' is not null or undefined
            common_1.assertParamExists('fulfillOccupationalHealthLabOrder', 'labOrderRequestId', labOrderRequestId);
            // verify required parameter 'fulfillOccupationalHealthLabOrderRequest' is not null or undefined
            common_1.assertParamExists('fulfillOccupationalHealthLabOrder', 'fulfillOccupationalHealthLabOrderRequest', fulfillOccupationalHealthLabOrderRequest);
            const localVarPath = `/v1/occupational-health-lab-order-requests/{lab_order_request_id}/fulfill`
                .replace(`{${"lab_order_request_id"}}`, encodeURIComponent(String(labOrderRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(fulfillOccupationalHealthLabOrderRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} labOrderRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLabOrderRequest: (labOrderRequestId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'labOrderRequestId' is not null or undefined
            common_1.assertParamExists('getLabOrderRequest', 'labOrderRequestId', labOrderRequestId);
            const localVarPath = `/v1/lab-order-requests/{lab_order_request_id}`
                .replace(`{${"lab_order_request_id"}}`, encodeURIComponent(String(labOrderRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} labOrderRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOccupationalHealthLabOrderRequest: (labOrderRequestId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'labOrderRequestId' is not null or undefined
            common_1.assertParamExists('getOccupationalHealthLabOrderRequest', 'labOrderRequestId', labOrderRequestId);
            const localVarPath = `/v1/occupational-health-lab-order-requests/{lab_order_request_id}`
                .replace(`{${"lab_order_request_id"}}`, encodeURIComponent(String(labOrderRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} labOrderRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicOccupationalHealthLabOrderRequestDetails: (labOrderRequestId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'labOrderRequestId' is not null or undefined
            common_1.assertParamExists('getPublicOccupationalHealthLabOrderRequestDetails', 'labOrderRequestId', labOrderRequestId);
            const localVarPath = `/v1/occupational-health-lab-order-requests/public/{lab_order_request_id}`
                .replace(`{${"lab_order_request_id"}}`, encodeURIComponent(String(labOrderRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {HandleHealthGorillaWebhookRequest} handleHealthGorillaWebhookRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleHealthGorillaWebhook: (handleHealthGorillaWebhookRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'handleHealthGorillaWebhookRequest' is not null or undefined
            common_1.assertParamExists('handleHealthGorillaWebhook', 'handleHealthGorillaWebhookRequest', handleHealthGorillaWebhookRequest);
            const localVarPath = `/v1/health-gorilla/subscription-callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(handleHealthGorillaWebhookRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [limit]
         * @param {string} [memberId]
         * @param {number} [page]
         * @param {boolean} [pendingIn]
         * @param {boolean} [publishedResultsIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllLabOrdersFacade: (limit, memberId, page, pendingIn, publishedResultsIn, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/all-lab-orders-facade`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (memberId !== undefined) {
                localVarQueryParameter['member_id'] = memberId;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (pendingIn !== undefined) {
                localVarQueryParameter['pending_in'] = pendingIn;
            }
            if (publishedResultsIn !== undefined) {
                localVarQueryParameter['published_results_in'] = publishedResultsIn;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [appointmentProviderId]
         * @param {string} [createdEndDatetime]
         * @param {string} [createdStartDatetime]
         * @param {string} [encounterId]
         * @param {'Lab Order' | 'Lab Order Request'} [facadeType] * &#x60;Lab Order&#x60; - Lab Order * &#x60;Lab Order Request&#x60; - Lab Order Request
         * @param {string} [labName]
         * @param {number} [limit]
         * @param {string} [memberId]
         * @param {number} [page]
         * @param {'Needs Lab Draw' | 'Lab Draw Scheduled' | 'Results Received' | 'Results Published' | 'Cancelled'} [status] * &#x60;Needs Lab Draw&#x60; - Needs Lab Draw * &#x60;Lab Draw Scheduled&#x60; - Lab Draw Scheduled * &#x60;Results Received&#x60; - Results Received * &#x60;Results Published&#x60; - Results Published * &#x60;Cancelled&#x60; - Cancelled
         * @param {string} [testCodeableConceptId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLabOrdersFacade: (appointmentProviderId, createdEndDatetime, createdStartDatetime, encounterId, facadeType, labName, limit, memberId, page, status, testCodeableConceptId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/lab-orders-facade`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (appointmentProviderId !== undefined) {
                localVarQueryParameter['appointment_provider_id'] = appointmentProviderId;
            }
            if (createdEndDatetime !== undefined) {
                localVarQueryParameter['created_end_datetime'] = (createdEndDatetime instanceof Date) ?
                    createdEndDatetime.toISOString() :
                    createdEndDatetime;
            }
            if (createdStartDatetime !== undefined) {
                localVarQueryParameter['created_start_datetime'] = (createdStartDatetime instanceof Date) ?
                    createdStartDatetime.toISOString() :
                    createdStartDatetime;
            }
            if (encounterId !== undefined) {
                localVarQueryParameter['encounter_id'] = encounterId;
            }
            if (facadeType !== undefined) {
                localVarQueryParameter['facade_type'] = facadeType;
            }
            if (labName !== undefined) {
                localVarQueryParameter['lab_name'] = labName;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (memberId !== undefined) {
                localVarQueryParameter['member_id'] = memberId;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (testCodeableConceptId !== undefined) {
                localVarQueryParameter['test_codeable_concept_id'] = testCodeableConceptId;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} memberId
         * @param {string} [encounterId]
         * @param {'Lab Order' | 'Lab Order Request'} [facadeType] * &#x60;Lab Order&#x60; - Lab Order * &#x60;Lab Order Request&#x60; - Lab Order Request
         * @param {number} [limit]
         * @param {number} [page]
         * @param {'Needs Lab Draw' | 'Lab Draw Scheduled' | 'Results Received' | 'Results Published' | 'Cancelled'} [status] * &#x60;Needs Lab Draw&#x60; - Needs Lab Draw * &#x60;Lab Draw Scheduled&#x60; - Lab Draw Scheduled * &#x60;Results Received&#x60; - Results Received * &#x60;Results Published&#x60; - Results Published * &#x60;Cancelled&#x60; - Cancelled
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMemberLabOrdersFacade: (memberId, encounterId, facadeType, limit, page, status, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'memberId' is not null or undefined
            common_1.assertParamExists('listMemberLabOrdersFacade', 'memberId', memberId);
            const localVarPath = `/v1/members/{member_id}/lab-orders-facade`
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (encounterId !== undefined) {
                localVarQueryParameter['encounter_id'] = encounterId;
            }
            if (facadeType !== undefined) {
                localVarQueryParameter['facade_type'] = facadeType;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [companyId]
         * @param {boolean} [completedIn]
         * @param {boolean} [includeTagsIn]
         * @param {'LabCorp' | 'Quest' | 'Sunrise Medical'} [lab] * &#x60;LabCorp&#x60; - LabCorp * &#x60;Quest&#x60; - Quest * &#x60;Sunrise Medical&#x60; - Sunrise Medical
         * @param {'TB QTF Test' | 'Ten Panel Drug and Alcohol Test'} [labTest] * &#x60;TB QTF Test&#x60; - TB QTF Test * &#x60;Ten Panel Drug and Alcohol Test&#x60; - Ten Panel Drug and Alcohol Test
         * @param {number} [limit]
         * @param {string} [memberId]
         * @param {string} [memberName]
         * @param {boolean} [needsReviewedIn]
         * @param {boolean} [notCompletedOrNeedsReviewedIn]
         * @param {number} [page]
         * @param {boolean} [pendingIn]
         * @param {string} [requestedOnEndDatetime]
         * @param {string} [requestedOnGte]
         * @param {string} [requestedOnStartDatetime]
         * @param {Array<string>} [tagsIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOccupationalHealthLabOrderRequests: (companyId, completedIn, includeTagsIn, lab, labTest, limit, memberId, memberName, needsReviewedIn, notCompletedOrNeedsReviewedIn, page, pendingIn, requestedOnEndDatetime, requestedOnGte, requestedOnStartDatetime, tagsIds, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/occupational-health-lab-order-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }
            if (completedIn !== undefined) {
                localVarQueryParameter['completed_in'] = completedIn;
            }
            if (includeTagsIn !== undefined) {
                localVarQueryParameter['include_tags_in'] = includeTagsIn;
            }
            if (lab !== undefined) {
                localVarQueryParameter['lab'] = lab;
            }
            if (labTest !== undefined) {
                localVarQueryParameter['lab_test'] = labTest;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (memberId !== undefined) {
                localVarQueryParameter['member_id'] = memberId;
            }
            if (memberName !== undefined) {
                localVarQueryParameter['member_name'] = memberName;
            }
            if (needsReviewedIn !== undefined) {
                localVarQueryParameter['needs_reviewed_in'] = needsReviewedIn;
            }
            if (notCompletedOrNeedsReviewedIn !== undefined) {
                localVarQueryParameter['not_completed_or_needs_reviewed_in'] = notCompletedOrNeedsReviewedIn;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (pendingIn !== undefined) {
                localVarQueryParameter['pending_in'] = pendingIn;
            }
            if (requestedOnEndDatetime !== undefined) {
                localVarQueryParameter['requested_on_end_datetime'] = (requestedOnEndDatetime instanceof Date) ?
                    requestedOnEndDatetime.toISOString() :
                    requestedOnEndDatetime;
            }
            if (requestedOnGte !== undefined) {
                localVarQueryParameter['requested_on_gte'] = (requestedOnGte instanceof Date) ?
                    requestedOnGte.toISOString().substr(0, 10) :
                    requestedOnGte;
            }
            if (requestedOnStartDatetime !== undefined) {
                localVarQueryParameter['requested_on_start_datetime'] = (requestedOnStartDatetime instanceof Date) ?
                    requestedOnStartDatetime.toISOString() :
                    requestedOnStartDatetime;
            }
            if (tagsIds) {
                localVarQueryParameter['tags_ids'] = tagsIds;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {PlaceLabOrderRequestsRequest} placeLabOrderRequestsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placeLabOrderRequests: (placeLabOrderRequestsRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'placeLabOrderRequestsRequest' is not null or undefined
            common_1.assertParamExists('placeLabOrderRequests', 'placeLabOrderRequestsRequest', placeLabOrderRequestsRequest);
            const localVarPath = `/v1/lab-order-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(placeLabOrderRequestsRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} companyId
         * @param {string} memberId
         * @param {RequestOccupationalHealthLabOrderForMemberRequest} requestOccupationalHealthLabOrderForMemberRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestOccupationalHealthLabOrderForMember: (companyId, memberId, requestOccupationalHealthLabOrderForMemberRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyId' is not null or undefined
            common_1.assertParamExists('requestOccupationalHealthLabOrderForMember', 'companyId', companyId);
            // verify required parameter 'memberId' is not null or undefined
            common_1.assertParamExists('requestOccupationalHealthLabOrderForMember', 'memberId', memberId);
            // verify required parameter 'requestOccupationalHealthLabOrderForMemberRequest' is not null or undefined
            common_1.assertParamExists('requestOccupationalHealthLabOrderForMember', 'requestOccupationalHealthLabOrderForMemberRequest', requestOccupationalHealthLabOrderForMemberRequest);
            const localVarPath = `/v1/companies/{company_id}/members/{member_id}/occupational-health-lab-order-requests`
                .replace(`{${"company_id"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(requestOccupationalHealthLabOrderForMemberRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} companyId
         * @param {RequestOccupationalHealthLabOrderForUnknownPersonRequest} requestOccupationalHealthLabOrderForUnknownPersonRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestOccupationalHealthLabOrderForUnknownPerson: (companyId, requestOccupationalHealthLabOrderForUnknownPersonRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyId' is not null or undefined
            common_1.assertParamExists('requestOccupationalHealthLabOrderForUnknownPerson', 'companyId', companyId);
            // verify required parameter 'requestOccupationalHealthLabOrderForUnknownPersonRequest' is not null or undefined
            common_1.assertParamExists('requestOccupationalHealthLabOrderForUnknownPerson', 'requestOccupationalHealthLabOrderForUnknownPersonRequest', requestOccupationalHealthLabOrderForUnknownPersonRequest);
            const localVarPath = `/v1/companies/{company_id}/occupational-health-lab-order-requests`
                .replace(`{${"company_id"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(requestOccupationalHealthLabOrderForUnknownPersonRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} labOrderRequestId
         * @param {RsvpToLabOrderRequestRequest} rsvpToLabOrderRequestRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rsvpToLabOrderRequest: (labOrderRequestId, rsvpToLabOrderRequestRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'labOrderRequestId' is not null or undefined
            common_1.assertParamExists('rsvpToLabOrderRequest', 'labOrderRequestId', labOrderRequestId);
            // verify required parameter 'rsvpToLabOrderRequestRequest' is not null or undefined
            common_1.assertParamExists('rsvpToLabOrderRequest', 'rsvpToLabOrderRequestRequest', rsvpToLabOrderRequestRequest);
            const localVarPath = `/v1/lab-order-requests/{lab_order_request_id}/rsvp`
                .replace(`{${"lab_order_request_id"}}`, encodeURIComponent(String(labOrderRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(rsvpToLabOrderRequestRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} labOrderRequestId
         * @param {RsvpToOccupationalHealthLabOrderRequest} rsvpToOccupationalHealthLabOrderRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rsvpToOccupationalHealthLabOrder: (labOrderRequestId, rsvpToOccupationalHealthLabOrderRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'labOrderRequestId' is not null or undefined
            common_1.assertParamExists('rsvpToOccupationalHealthLabOrder', 'labOrderRequestId', labOrderRequestId);
            // verify required parameter 'rsvpToOccupationalHealthLabOrderRequest' is not null or undefined
            common_1.assertParamExists('rsvpToOccupationalHealthLabOrder', 'rsvpToOccupationalHealthLabOrderRequest', rsvpToOccupationalHealthLabOrderRequest);
            const localVarPath = `/v1/occupational-health-lab-order-requests/{lab_order_request_id}/rsvp`
                .replace(`{${"lab_order_request_id"}}`, encodeURIComponent(String(labOrderRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(rsvpToOccupationalHealthLabOrderRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} labOrderRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendOccupationalHealthLabOrderInstructions: (labOrderRequestId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'labOrderRequestId' is not null or undefined
            common_1.assertParamExists('sendOccupationalHealthLabOrderInstructions', 'labOrderRequestId', labOrderRequestId);
            const localVarPath = `/v1/occupational-health-lab-order-requests/{lab_order_request_id}/send-instructions`
                .replace(`{${"lab_order_request_id"}}`, encodeURIComponent(String(labOrderRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} externalLabOrderId
         * @param {string} resultsFile
         * @param {boolean} [positiveResultIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadExternalLabOrderResults: (externalLabOrderId, resultsFile, positiveResultIn, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'externalLabOrderId' is not null or undefined
            common_1.assertParamExists('uploadExternalLabOrderResults', 'externalLabOrderId', externalLabOrderId);
            // verify required parameter 'resultsFile' is not null or undefined
            common_1.assertParamExists('uploadExternalLabOrderResults', 'resultsFile', resultsFile);
            const localVarPath = `/v1/external-lab-orders/{external_lab_order_id}/upload-results`
                .replace(`{${"external_lab_order_id"}}`, encodeURIComponent(String(externalLabOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (resultsFile !== undefined) {
                localVarFormParams.append('results_file', resultsFile);
            }
            if (positiveResultIn !== undefined) {
                localVarFormParams.append('positive_result_in', positiveResultIn);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} labOrderId
         * @param {string} resultsFile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadLabOrderResults: (labOrderId, resultsFile, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'labOrderId' is not null or undefined
            common_1.assertParamExists('uploadLabOrderResults', 'labOrderId', labOrderId);
            // verify required parameter 'resultsFile' is not null or undefined
            common_1.assertParamExists('uploadLabOrderResults', 'resultsFile', resultsFile);
            const localVarPath = `/v1/hg-lab-orders/{lab_order_id}/upload-results`
                .replace(`{${"lab_order_id"}}`, encodeURIComponent(String(labOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (resultsFile !== undefined) {
                localVarFormParams.append('results_file', resultsFile);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * LabOrderingApi - functional programming interface
 * @export
 */
exports.LabOrderingApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.LabOrderingApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} labOrderId
         * @param {CancelHealthGorillaLabOrderRequest} cancelHealthGorillaLabOrderRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelHealthGorillaLabOrder(labOrderId, cancelHealthGorillaLabOrderRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cancelHealthGorillaLabOrder(labOrderId, cancelHealthGorillaLabOrderRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} labOrderRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelOccupationalHealthLabOrder(labOrderRequestId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cancelOccupationalHealthLabOrder(labOrderRequestId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} labOrderRequestId
         * @param {string} labReferenceNumber
         * @param {string} orderFile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fulfillExternalOccupationalHealthLabOrder(labOrderRequestId, labReferenceNumber, orderFile, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fulfillExternalOccupationalHealthLabOrder(labOrderRequestId, labReferenceNumber, orderFile, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} labOrderRequestId
         * @param {FulfillOccupationalHealthLabOrderRequest} fulfillOccupationalHealthLabOrderRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fulfillOccupationalHealthLabOrder(labOrderRequestId, fulfillOccupationalHealthLabOrderRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.fulfillOccupationalHealthLabOrder(labOrderRequestId, fulfillOccupationalHealthLabOrderRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} labOrderRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLabOrderRequest(labOrderRequestId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getLabOrderRequest(labOrderRequestId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} labOrderRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOccupationalHealthLabOrderRequest(labOrderRequestId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getOccupationalHealthLabOrderRequest(labOrderRequestId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} labOrderRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicOccupationalHealthLabOrderRequestDetails(labOrderRequestId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPublicOccupationalHealthLabOrderRequestDetails(labOrderRequestId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {HandleHealthGorillaWebhookRequest} handleHealthGorillaWebhookRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleHealthGorillaWebhook(handleHealthGorillaWebhookRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.handleHealthGorillaWebhook(handleHealthGorillaWebhookRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} [limit]
         * @param {string} [memberId]
         * @param {number} [page]
         * @param {boolean} [pendingIn]
         * @param {boolean} [publishedResultsIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllLabOrdersFacade(limit, memberId, page, pendingIn, publishedResultsIn, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listAllLabOrdersFacade(limit, memberId, page, pendingIn, publishedResultsIn, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} [appointmentProviderId]
         * @param {string} [createdEndDatetime]
         * @param {string} [createdStartDatetime]
         * @param {string} [encounterId]
         * @param {'Lab Order' | 'Lab Order Request'} [facadeType] * &#x60;Lab Order&#x60; - Lab Order * &#x60;Lab Order Request&#x60; - Lab Order Request
         * @param {string} [labName]
         * @param {number} [limit]
         * @param {string} [memberId]
         * @param {number} [page]
         * @param {'Needs Lab Draw' | 'Lab Draw Scheduled' | 'Results Received' | 'Results Published' | 'Cancelled'} [status] * &#x60;Needs Lab Draw&#x60; - Needs Lab Draw * &#x60;Lab Draw Scheduled&#x60; - Lab Draw Scheduled * &#x60;Results Received&#x60; - Results Received * &#x60;Results Published&#x60; - Results Published * &#x60;Cancelled&#x60; - Cancelled
         * @param {string} [testCodeableConceptId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLabOrdersFacade(appointmentProviderId, createdEndDatetime, createdStartDatetime, encounterId, facadeType, labName, limit, memberId, page, status, testCodeableConceptId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listLabOrdersFacade(appointmentProviderId, createdEndDatetime, createdStartDatetime, encounterId, facadeType, labName, limit, memberId, page, status, testCodeableConceptId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} memberId
         * @param {string} [encounterId]
         * @param {'Lab Order' | 'Lab Order Request'} [facadeType] * &#x60;Lab Order&#x60; - Lab Order * &#x60;Lab Order Request&#x60; - Lab Order Request
         * @param {number} [limit]
         * @param {number} [page]
         * @param {'Needs Lab Draw' | 'Lab Draw Scheduled' | 'Results Received' | 'Results Published' | 'Cancelled'} [status] * &#x60;Needs Lab Draw&#x60; - Needs Lab Draw * &#x60;Lab Draw Scheduled&#x60; - Lab Draw Scheduled * &#x60;Results Received&#x60; - Results Received * &#x60;Results Published&#x60; - Results Published * &#x60;Cancelled&#x60; - Cancelled
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMemberLabOrdersFacade(memberId, encounterId, facadeType, limit, page, status, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listMemberLabOrdersFacade(memberId, encounterId, facadeType, limit, page, status, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} [companyId]
         * @param {boolean} [completedIn]
         * @param {boolean} [includeTagsIn]
         * @param {'LabCorp' | 'Quest' | 'Sunrise Medical'} [lab] * &#x60;LabCorp&#x60; - LabCorp * &#x60;Quest&#x60; - Quest * &#x60;Sunrise Medical&#x60; - Sunrise Medical
         * @param {'TB QTF Test' | 'Ten Panel Drug and Alcohol Test'} [labTest] * &#x60;TB QTF Test&#x60; - TB QTF Test * &#x60;Ten Panel Drug and Alcohol Test&#x60; - Ten Panel Drug and Alcohol Test
         * @param {number} [limit]
         * @param {string} [memberId]
         * @param {string} [memberName]
         * @param {boolean} [needsReviewedIn]
         * @param {boolean} [notCompletedOrNeedsReviewedIn]
         * @param {number} [page]
         * @param {boolean} [pendingIn]
         * @param {string} [requestedOnEndDatetime]
         * @param {string} [requestedOnGte]
         * @param {string} [requestedOnStartDatetime]
         * @param {Array<string>} [tagsIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOccupationalHealthLabOrderRequests(companyId, completedIn, includeTagsIn, lab, labTest, limit, memberId, memberName, needsReviewedIn, notCompletedOrNeedsReviewedIn, page, pendingIn, requestedOnEndDatetime, requestedOnGte, requestedOnStartDatetime, tagsIds, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listOccupationalHealthLabOrderRequests(companyId, completedIn, includeTagsIn, lab, labTest, limit, memberId, memberName, needsReviewedIn, notCompletedOrNeedsReviewedIn, page, pendingIn, requestedOnEndDatetime, requestedOnGte, requestedOnStartDatetime, tagsIds, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {PlaceLabOrderRequestsRequest} placeLabOrderRequestsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placeLabOrderRequests(placeLabOrderRequestsRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.placeLabOrderRequests(placeLabOrderRequestsRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} companyId
         * @param {string} memberId
         * @param {RequestOccupationalHealthLabOrderForMemberRequest} requestOccupationalHealthLabOrderForMemberRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestOccupationalHealthLabOrderForMember(companyId, memberId, requestOccupationalHealthLabOrderForMemberRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.requestOccupationalHealthLabOrderForMember(companyId, memberId, requestOccupationalHealthLabOrderForMemberRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} companyId
         * @param {RequestOccupationalHealthLabOrderForUnknownPersonRequest} requestOccupationalHealthLabOrderForUnknownPersonRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestOccupationalHealthLabOrderForUnknownPerson(companyId, requestOccupationalHealthLabOrderForUnknownPersonRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.requestOccupationalHealthLabOrderForUnknownPerson(companyId, requestOccupationalHealthLabOrderForUnknownPersonRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} labOrderRequestId
         * @param {RsvpToLabOrderRequestRequest} rsvpToLabOrderRequestRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rsvpToLabOrderRequest(labOrderRequestId, rsvpToLabOrderRequestRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.rsvpToLabOrderRequest(labOrderRequestId, rsvpToLabOrderRequestRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} labOrderRequestId
         * @param {RsvpToOccupationalHealthLabOrderRequest} rsvpToOccupationalHealthLabOrderRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rsvpToOccupationalHealthLabOrder(labOrderRequestId, rsvpToOccupationalHealthLabOrderRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.rsvpToOccupationalHealthLabOrder(labOrderRequestId, rsvpToOccupationalHealthLabOrderRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} labOrderRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendOccupationalHealthLabOrderInstructions(labOrderRequestId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sendOccupationalHealthLabOrderInstructions(labOrderRequestId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} externalLabOrderId
         * @param {string} resultsFile
         * @param {boolean} [positiveResultIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadExternalLabOrderResults(externalLabOrderId, resultsFile, positiveResultIn, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.uploadExternalLabOrderResults(externalLabOrderId, resultsFile, positiveResultIn, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} labOrderId
         * @param {string} resultsFile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadLabOrderResults(labOrderId, resultsFile, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.uploadLabOrderResults(labOrderId, resultsFile, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * LabOrderingApi - factory interface
 * @export
 */
exports.LabOrderingApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.LabOrderingApiFp(configuration);
    return {
        /**
         *
         * @param {string} labOrderId
         * @param {CancelHealthGorillaLabOrderRequest} cancelHealthGorillaLabOrderRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelHealthGorillaLabOrder(labOrderId, cancelHealthGorillaLabOrderRequest, options) {
            return localVarFp.cancelHealthGorillaLabOrder(labOrderId, cancelHealthGorillaLabOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} labOrderRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelOccupationalHealthLabOrder(labOrderRequestId, options) {
            return localVarFp.cancelOccupationalHealthLabOrder(labOrderRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} labOrderRequestId
         * @param {string} labReferenceNumber
         * @param {string} orderFile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fulfillExternalOccupationalHealthLabOrder(labOrderRequestId, labReferenceNumber, orderFile, options) {
            return localVarFp.fulfillExternalOccupationalHealthLabOrder(labOrderRequestId, labReferenceNumber, orderFile, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} labOrderRequestId
         * @param {FulfillOccupationalHealthLabOrderRequest} fulfillOccupationalHealthLabOrderRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fulfillOccupationalHealthLabOrder(labOrderRequestId, fulfillOccupationalHealthLabOrderRequest, options) {
            return localVarFp.fulfillOccupationalHealthLabOrder(labOrderRequestId, fulfillOccupationalHealthLabOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} labOrderRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLabOrderRequest(labOrderRequestId, options) {
            return localVarFp.getLabOrderRequest(labOrderRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} labOrderRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOccupationalHealthLabOrderRequest(labOrderRequestId, options) {
            return localVarFp.getOccupationalHealthLabOrderRequest(labOrderRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} labOrderRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicOccupationalHealthLabOrderRequestDetails(labOrderRequestId, options) {
            return localVarFp.getPublicOccupationalHealthLabOrderRequestDetails(labOrderRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {HandleHealthGorillaWebhookRequest} handleHealthGorillaWebhookRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleHealthGorillaWebhook(handleHealthGorillaWebhookRequest, options) {
            return localVarFp.handleHealthGorillaWebhook(handleHealthGorillaWebhookRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [limit]
         * @param {string} [memberId]
         * @param {number} [page]
         * @param {boolean} [pendingIn]
         * @param {boolean} [publishedResultsIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllLabOrdersFacade(limit, memberId, page, pendingIn, publishedResultsIn, options) {
            return localVarFp.listAllLabOrdersFacade(limit, memberId, page, pendingIn, publishedResultsIn, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [appointmentProviderId]
         * @param {string} [createdEndDatetime]
         * @param {string} [createdStartDatetime]
         * @param {string} [encounterId]
         * @param {'Lab Order' | 'Lab Order Request'} [facadeType] * &#x60;Lab Order&#x60; - Lab Order * &#x60;Lab Order Request&#x60; - Lab Order Request
         * @param {string} [labName]
         * @param {number} [limit]
         * @param {string} [memberId]
         * @param {number} [page]
         * @param {'Needs Lab Draw' | 'Lab Draw Scheduled' | 'Results Received' | 'Results Published' | 'Cancelled'} [status] * &#x60;Needs Lab Draw&#x60; - Needs Lab Draw * &#x60;Lab Draw Scheduled&#x60; - Lab Draw Scheduled * &#x60;Results Received&#x60; - Results Received * &#x60;Results Published&#x60; - Results Published * &#x60;Cancelled&#x60; - Cancelled
         * @param {string} [testCodeableConceptId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLabOrdersFacade(appointmentProviderId, createdEndDatetime, createdStartDatetime, encounterId, facadeType, labName, limit, memberId, page, status, testCodeableConceptId, options) {
            return localVarFp.listLabOrdersFacade(appointmentProviderId, createdEndDatetime, createdStartDatetime, encounterId, facadeType, labName, limit, memberId, page, status, testCodeableConceptId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} memberId
         * @param {string} [encounterId]
         * @param {'Lab Order' | 'Lab Order Request'} [facadeType] * &#x60;Lab Order&#x60; - Lab Order * &#x60;Lab Order Request&#x60; - Lab Order Request
         * @param {number} [limit]
         * @param {number} [page]
         * @param {'Needs Lab Draw' | 'Lab Draw Scheduled' | 'Results Received' | 'Results Published' | 'Cancelled'} [status] * &#x60;Needs Lab Draw&#x60; - Needs Lab Draw * &#x60;Lab Draw Scheduled&#x60; - Lab Draw Scheduled * &#x60;Results Received&#x60; - Results Received * &#x60;Results Published&#x60; - Results Published * &#x60;Cancelled&#x60; - Cancelled
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMemberLabOrdersFacade(memberId, encounterId, facadeType, limit, page, status, options) {
            return localVarFp.listMemberLabOrdersFacade(memberId, encounterId, facadeType, limit, page, status, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [companyId]
         * @param {boolean} [completedIn]
         * @param {boolean} [includeTagsIn]
         * @param {'LabCorp' | 'Quest' | 'Sunrise Medical'} [lab] * &#x60;LabCorp&#x60; - LabCorp * &#x60;Quest&#x60; - Quest * &#x60;Sunrise Medical&#x60; - Sunrise Medical
         * @param {'TB QTF Test' | 'Ten Panel Drug and Alcohol Test'} [labTest] * &#x60;TB QTF Test&#x60; - TB QTF Test * &#x60;Ten Panel Drug and Alcohol Test&#x60; - Ten Panel Drug and Alcohol Test
         * @param {number} [limit]
         * @param {string} [memberId]
         * @param {string} [memberName]
         * @param {boolean} [needsReviewedIn]
         * @param {boolean} [notCompletedOrNeedsReviewedIn]
         * @param {number} [page]
         * @param {boolean} [pendingIn]
         * @param {string} [requestedOnEndDatetime]
         * @param {string} [requestedOnGte]
         * @param {string} [requestedOnStartDatetime]
         * @param {Array<string>} [tagsIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOccupationalHealthLabOrderRequests(companyId, completedIn, includeTagsIn, lab, labTest, limit, memberId, memberName, needsReviewedIn, notCompletedOrNeedsReviewedIn, page, pendingIn, requestedOnEndDatetime, requestedOnGte, requestedOnStartDatetime, tagsIds, options) {
            return localVarFp.listOccupationalHealthLabOrderRequests(companyId, completedIn, includeTagsIn, lab, labTest, limit, memberId, memberName, needsReviewedIn, notCompletedOrNeedsReviewedIn, page, pendingIn, requestedOnEndDatetime, requestedOnGte, requestedOnStartDatetime, tagsIds, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PlaceLabOrderRequestsRequest} placeLabOrderRequestsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placeLabOrderRequests(placeLabOrderRequestsRequest, options) {
            return localVarFp.placeLabOrderRequests(placeLabOrderRequestsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} companyId
         * @param {string} memberId
         * @param {RequestOccupationalHealthLabOrderForMemberRequest} requestOccupationalHealthLabOrderForMemberRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestOccupationalHealthLabOrderForMember(companyId, memberId, requestOccupationalHealthLabOrderForMemberRequest, options) {
            return localVarFp.requestOccupationalHealthLabOrderForMember(companyId, memberId, requestOccupationalHealthLabOrderForMemberRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} companyId
         * @param {RequestOccupationalHealthLabOrderForUnknownPersonRequest} requestOccupationalHealthLabOrderForUnknownPersonRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestOccupationalHealthLabOrderForUnknownPerson(companyId, requestOccupationalHealthLabOrderForUnknownPersonRequest, options) {
            return localVarFp.requestOccupationalHealthLabOrderForUnknownPerson(companyId, requestOccupationalHealthLabOrderForUnknownPersonRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} labOrderRequestId
         * @param {RsvpToLabOrderRequestRequest} rsvpToLabOrderRequestRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rsvpToLabOrderRequest(labOrderRequestId, rsvpToLabOrderRequestRequest, options) {
            return localVarFp.rsvpToLabOrderRequest(labOrderRequestId, rsvpToLabOrderRequestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} labOrderRequestId
         * @param {RsvpToOccupationalHealthLabOrderRequest} rsvpToOccupationalHealthLabOrderRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rsvpToOccupationalHealthLabOrder(labOrderRequestId, rsvpToOccupationalHealthLabOrderRequest, options) {
            return localVarFp.rsvpToOccupationalHealthLabOrder(labOrderRequestId, rsvpToOccupationalHealthLabOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} labOrderRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendOccupationalHealthLabOrderInstructions(labOrderRequestId, options) {
            return localVarFp.sendOccupationalHealthLabOrderInstructions(labOrderRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} externalLabOrderId
         * @param {string} resultsFile
         * @param {boolean} [positiveResultIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadExternalLabOrderResults(externalLabOrderId, resultsFile, positiveResultIn, options) {
            return localVarFp.uploadExternalLabOrderResults(externalLabOrderId, resultsFile, positiveResultIn, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} labOrderId
         * @param {string} resultsFile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadLabOrderResults(labOrderId, resultsFile, options) {
            return localVarFp.uploadLabOrderResults(labOrderId, resultsFile, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * LabOrderingApi - object-oriented interface
 * @export
 * @class LabOrderingApi
 * @extends {BaseAPI}
 */
class LabOrderingApi extends base_1.BaseAPI {
    /**
     *
     * @param {LabOrderingApiCancelHealthGorillaLabOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabOrderingApi
     */
    cancelHealthGorillaLabOrder(requestParameters, options) {
        return exports.LabOrderingApiFp(this.configuration).cancelHealthGorillaLabOrder(requestParameters.labOrderId, requestParameters.cancelHealthGorillaLabOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {LabOrderingApiCancelOccupationalHealthLabOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabOrderingApi
     */
    cancelOccupationalHealthLabOrder(requestParameters, options) {
        return exports.LabOrderingApiFp(this.configuration).cancelOccupationalHealthLabOrder(requestParameters.labOrderRequestId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {LabOrderingApiFulfillExternalOccupationalHealthLabOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabOrderingApi
     */
    fulfillExternalOccupationalHealthLabOrder(requestParameters, options) {
        return exports.LabOrderingApiFp(this.configuration).fulfillExternalOccupationalHealthLabOrder(requestParameters.labOrderRequestId, requestParameters.labReferenceNumber, requestParameters.orderFile, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {LabOrderingApiFulfillOccupationalHealthLabOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabOrderingApi
     */
    fulfillOccupationalHealthLabOrder(requestParameters, options) {
        return exports.LabOrderingApiFp(this.configuration).fulfillOccupationalHealthLabOrder(requestParameters.labOrderRequestId, requestParameters.fulfillOccupationalHealthLabOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {LabOrderingApiGetLabOrderRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabOrderingApi
     */
    getLabOrderRequest(requestParameters, options) {
        return exports.LabOrderingApiFp(this.configuration).getLabOrderRequest(requestParameters.labOrderRequestId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {LabOrderingApiGetOccupationalHealthLabOrderRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabOrderingApi
     */
    getOccupationalHealthLabOrderRequest(requestParameters, options) {
        return exports.LabOrderingApiFp(this.configuration).getOccupationalHealthLabOrderRequest(requestParameters.labOrderRequestId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {LabOrderingApiGetPublicOccupationalHealthLabOrderRequestDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabOrderingApi
     */
    getPublicOccupationalHealthLabOrderRequestDetails(requestParameters, options) {
        return exports.LabOrderingApiFp(this.configuration).getPublicOccupationalHealthLabOrderRequestDetails(requestParameters.labOrderRequestId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {LabOrderingApiHandleHealthGorillaWebhookRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabOrderingApi
     */
    handleHealthGorillaWebhook(requestParameters, options) {
        return exports.LabOrderingApiFp(this.configuration).handleHealthGorillaWebhook(requestParameters.handleHealthGorillaWebhookRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {LabOrderingApiListAllLabOrdersFacadeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabOrderingApi
     */
    listAllLabOrdersFacade(requestParameters = {}, options) {
        return exports.LabOrderingApiFp(this.configuration).listAllLabOrdersFacade(requestParameters.limit, requestParameters.memberId, requestParameters.page, requestParameters.pendingIn, requestParameters.publishedResultsIn, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {LabOrderingApiListLabOrdersFacadeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabOrderingApi
     */
    listLabOrdersFacade(requestParameters = {}, options) {
        return exports.LabOrderingApiFp(this.configuration).listLabOrdersFacade(requestParameters.appointmentProviderId, requestParameters.createdEndDatetime, requestParameters.createdStartDatetime, requestParameters.encounterId, requestParameters.facadeType, requestParameters.labName, requestParameters.limit, requestParameters.memberId, requestParameters.page, requestParameters.status, requestParameters.testCodeableConceptId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {LabOrderingApiListMemberLabOrdersFacadeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabOrderingApi
     */
    listMemberLabOrdersFacade(requestParameters, options) {
        return exports.LabOrderingApiFp(this.configuration).listMemberLabOrdersFacade(requestParameters.memberId, requestParameters.encounterId, requestParameters.facadeType, requestParameters.limit, requestParameters.page, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {LabOrderingApiListOccupationalHealthLabOrderRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabOrderingApi
     */
    listOccupationalHealthLabOrderRequests(requestParameters = {}, options) {
        return exports.LabOrderingApiFp(this.configuration).listOccupationalHealthLabOrderRequests(requestParameters.companyId, requestParameters.completedIn, requestParameters.includeTagsIn, requestParameters.lab, requestParameters.labTest, requestParameters.limit, requestParameters.memberId, requestParameters.memberName, requestParameters.needsReviewedIn, requestParameters.notCompletedOrNeedsReviewedIn, requestParameters.page, requestParameters.pendingIn, requestParameters.requestedOnEndDatetime, requestParameters.requestedOnGte, requestParameters.requestedOnStartDatetime, requestParameters.tagsIds, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {LabOrderingApiPlaceLabOrderRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabOrderingApi
     */
    placeLabOrderRequests(requestParameters, options) {
        return exports.LabOrderingApiFp(this.configuration).placeLabOrderRequests(requestParameters.placeLabOrderRequestsRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {LabOrderingApiRequestOccupationalHealthLabOrderForMemberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabOrderingApi
     */
    requestOccupationalHealthLabOrderForMember(requestParameters, options) {
        return exports.LabOrderingApiFp(this.configuration).requestOccupationalHealthLabOrderForMember(requestParameters.companyId, requestParameters.memberId, requestParameters.requestOccupationalHealthLabOrderForMemberRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {LabOrderingApiRequestOccupationalHealthLabOrderForUnknownPersonRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabOrderingApi
     */
    requestOccupationalHealthLabOrderForUnknownPerson(requestParameters, options) {
        return exports.LabOrderingApiFp(this.configuration).requestOccupationalHealthLabOrderForUnknownPerson(requestParameters.companyId, requestParameters.requestOccupationalHealthLabOrderForUnknownPersonRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {LabOrderingApiRsvpToLabOrderRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabOrderingApi
     */
    rsvpToLabOrderRequest(requestParameters, options) {
        return exports.LabOrderingApiFp(this.configuration).rsvpToLabOrderRequest(requestParameters.labOrderRequestId, requestParameters.rsvpToLabOrderRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {LabOrderingApiRsvpToOccupationalHealthLabOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabOrderingApi
     */
    rsvpToOccupationalHealthLabOrder(requestParameters, options) {
        return exports.LabOrderingApiFp(this.configuration).rsvpToOccupationalHealthLabOrder(requestParameters.labOrderRequestId, requestParameters.rsvpToOccupationalHealthLabOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {LabOrderingApiSendOccupationalHealthLabOrderInstructionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabOrderingApi
     */
    sendOccupationalHealthLabOrderInstructions(requestParameters, options) {
        return exports.LabOrderingApiFp(this.configuration).sendOccupationalHealthLabOrderInstructions(requestParameters.labOrderRequestId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {LabOrderingApiUploadExternalLabOrderResultsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabOrderingApi
     */
    uploadExternalLabOrderResults(requestParameters, options) {
        return exports.LabOrderingApiFp(this.configuration).uploadExternalLabOrderResults(requestParameters.externalLabOrderId, requestParameters.resultsFile, requestParameters.positiveResultIn, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {LabOrderingApiUploadLabOrderResultsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabOrderingApi
     */
    uploadLabOrderResults(requestParameters, options) {
        return exports.LabOrderingApiFp(this.configuration).uploadLabOrderResults(requestParameters.labOrderId, requestParameters.resultsFile, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.LabOrderingApi = LabOrderingApi;
/**
 * MedicalApi - axios parameter creator
 * @export
 */
exports.MedicalApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {AddLabDrawToLabOrdersRequest} addLabDrawToLabOrdersRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addLabDrawToLabOrders: (addLabDrawToLabOrdersRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'addLabDrawToLabOrdersRequest' is not null or undefined
            common_1.assertParamExists('addLabDrawToLabOrders', 'addLabDrawToLabOrdersRequest', addLabDrawToLabOrdersRequest);
            const localVarPath = `/v1/lab-orders/add-lab-draw`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(addLabDrawToLabOrdersRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} allergyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assertAllergy: (allergyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'allergyId' is not null or undefined
            common_1.assertParamExists('assertAllergy', 'allergyId', allergyId);
            const localVarPath = `/v1/allergies/{allergy_id}/assert`
                .replace(`{${"allergy_id"}}`, encodeURIComponent(String(allergyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} problemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assertCarePlanProblem: (problemId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'problemId' is not null or undefined
            common_1.assertParamExists('assertCarePlanProblem', 'problemId', problemId);
            const localVarPath = `/v1/care-plans/problems/{problem_id}/assert`
                .replace(`{${"problem_id"}}`, encodeURIComponent(String(problemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} problemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assertFamilyMedicalHistoryProblem: (problemId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'problemId' is not null or undefined
            common_1.assertParamExists('assertFamilyMedicalHistoryProblem', 'problemId', problemId);
            const localVarPath = `/v1/family-medical-history/problems/{problem_id}/assert`
                .replace(`{${"problem_id"}}`, encodeURIComponent(String(problemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} medicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assertMedication: (medicationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'medicationId' is not null or undefined
            common_1.assertParamExists('assertMedication', 'medicationId', medicationId);
            const localVarPath = `/v1/medications/{medication_id}/assert`
                .replace(`{${"medication_id"}}`, encodeURIComponent(String(medicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} procedureId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assertProcedure: (procedureId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'procedureId' is not null or undefined
            common_1.assertParamExists('assertProcedure', 'procedureId', procedureId);
            const localVarPath = `/v1/procedures/{procedure_id}/assert`
                .replace(`{${"procedure_id"}}`, encodeURIComponent(String(procedureId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {AssignManualLabResultRequest} assignManualLabResultRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignManualLabResult: (assignManualLabResultRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'assignManualLabResultRequest' is not null or undefined
            common_1.assertParamExists('assignManualLabResult', 'assignManualLabResultRequest', assignManualLabResultRequest);
            const localVarPath = `/v1/manual-lab-results/assign`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(assignManualLabResultRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} occupationalHealthRecordId
         * @param {AuthorizePendingOccupationalHealthRecordRequest} authorizePendingOccupationalHealthRecordRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizePendingOccupationalHealthRecord: (occupationalHealthRecordId, authorizePendingOccupationalHealthRecordRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'occupationalHealthRecordId' is not null or undefined
            common_1.assertParamExists('authorizePendingOccupationalHealthRecord', 'occupationalHealthRecordId', occupationalHealthRecordId);
            // verify required parameter 'authorizePendingOccupationalHealthRecordRequest' is not null or undefined
            common_1.assertParamExists('authorizePendingOccupationalHealthRecord', 'authorizePendingOccupationalHealthRecordRequest', authorizePendingOccupationalHealthRecordRequest);
            const localVarPath = `/v1/occupational-health-records/{occupational_health_record_id}/authorizations`
                .replace(`{${"occupational_health_record_id"}}`, encodeURIComponent(String(occupationalHealthRecordId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(authorizePendingOccupationalHealthRecordRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} dynamicMedicalChartId
         * @param {BlockDynamicMedicalChartRequest} [blockDynamicMedicalChartRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockDynamicMedicalChart: (dynamicMedicalChartId, blockDynamicMedicalChartRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'dynamicMedicalChartId' is not null or undefined
            common_1.assertParamExists('blockDynamicMedicalChart', 'dynamicMedicalChartId', dynamicMedicalChartId);
            const localVarPath = `/v1/dynamic-medical-charts/{dynamic_medical_chart_id}/block-status`
                .replace(`{${"dynamic_medical_chart_id"}}`, encodeURIComponent(String(dynamicMedicalChartId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(blockDynamicMedicalChartRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} labOrderId
         * @param {CancelLabOrderRequest} cancelLabOrderRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelLabOrder: (labOrderId, cancelLabOrderRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'labOrderId' is not null or undefined
            common_1.assertParamExists('cancelLabOrder', 'labOrderId', labOrderId);
            // verify required parameter 'cancelLabOrderRequest' is not null or undefined
            common_1.assertParamExists('cancelLabOrder', 'cancelLabOrderRequest', cancelLabOrderRequest);
            const localVarPath = `/v1/lab-orders/{lab_order_id}/cancel`
                .replace(`{${"lab_order_id"}}`, encodeURIComponent(String(labOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(cancelLabOrderRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} encounterId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkIfUserCanPerformChartingForEncounter: (encounterId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'encounterId' is not null or undefined
            common_1.assertParamExists('checkIfUserCanPerformChartingForEncounter', 'encounterId', encounterId);
            const localVarPath = `/v1/charting-permissions/{encounter_id}`
                .replace(`{${"encounter_id"}}`, encodeURIComponent(String(encounterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} fileName
         * @param {string} file
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdministrativeFile: (fileName, file, memberId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'fileName' is not null or undefined
            common_1.assertParamExists('createAdministrativeFile', 'fileName', fileName);
            // verify required parameter 'file' is not null or undefined
            common_1.assertParamExists('createAdministrativeFile', 'file', file);
            // verify required parameter 'memberId' is not null or undefined
            common_1.assertParamExists('createAdministrativeFile', 'memberId', memberId);
            const localVarPath = `/v1/administrative-files/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (fileName !== undefined) {
                localVarFormParams.append('file_name', fileName);
            }
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            if (memberId !== undefined) {
                localVarFormParams.append('member_id', memberId);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} carePlanId
         * @param {CreateAllergyRequest} createAllergyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAllergy: (carePlanId, createAllergyRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'carePlanId' is not null or undefined
            common_1.assertParamExists('createAllergy', 'carePlanId', carePlanId);
            // verify required parameter 'createAllergyRequest' is not null or undefined
            common_1.assertParamExists('createAllergy', 'createAllergyRequest', createAllergyRequest);
            const localVarPath = `/v1/care-plans/{care_plan_id}/allergies`
                .replace(`{${"care_plan_id"}}`, encodeURIComponent(String(carePlanId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createAllergyRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CreateChartingMacroRequest} createChartingMacroRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createChartingMacro: (createChartingMacroRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createChartingMacroRequest' is not null or undefined
            common_1.assertParamExists('createChartingMacro', 'createChartingMacroRequest', createChartingMacroRequest);
            const localVarPath = `/v1/charting-macros`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createChartingMacroRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CreateDynamicMedicalChartRequest} createDynamicMedicalChartRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDynamicMedicalChart: (createDynamicMedicalChartRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createDynamicMedicalChartRequest' is not null or undefined
            common_1.assertParamExists('createDynamicMedicalChart', 'createDynamicMedicalChartRequest', createDynamicMedicalChartRequest);
            const localVarPath = `/v1/dynamic-medical-charts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createDynamicMedicalChartRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} medicalProfileId
         * @param {CreateFamilyMedicalHistoryRequest} createFamilyMedicalHistoryRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFamilyMedicalHistory: (medicalProfileId, createFamilyMedicalHistoryRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'medicalProfileId' is not null or undefined
            common_1.assertParamExists('createFamilyMedicalHistory', 'medicalProfileId', medicalProfileId);
            // verify required parameter 'createFamilyMedicalHistoryRequest' is not null or undefined
            common_1.assertParamExists('createFamilyMedicalHistory', 'createFamilyMedicalHistoryRequest', createFamilyMedicalHistoryRequest);
            const localVarPath = `/v1/medical-profile/{medical_profile_id}/family_medical_history`
                .replace(`{${"medical_profile_id"}}`, encodeURIComponent(String(medicalProfileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createFamilyMedicalHistoryRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} goalId
         * @param {string} problemId
         * @param {CreateProblemGoalTargetRequest} createProblemGoalTargetRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGoalTarget: (goalId, problemId, createProblemGoalTargetRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'goalId' is not null or undefined
            common_1.assertParamExists('createGoalTarget', 'goalId', goalId);
            // verify required parameter 'problemId' is not null or undefined
            common_1.assertParamExists('createGoalTarget', 'problemId', problemId);
            // verify required parameter 'createProblemGoalTargetRequest' is not null or undefined
            common_1.assertParamExists('createGoalTarget', 'createProblemGoalTargetRequest', createProblemGoalTargetRequest);
            const localVarPath = `/v1/problems/{problem_id}/goals/{goal_id}/targets`
                .replace(`{${"goal_id"}}`, encodeURIComponent(String(goalId)))
                .replace(`{${"problem_id"}}`, encodeURIComponent(String(problemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createProblemGoalTargetRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CreateInteractionRequest} createInteractionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInteraction: (createInteractionRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createInteractionRequest' is not null or undefined
            common_1.assertParamExists('createInteraction', 'createInteractionRequest', createInteractionRequest);
            const localVarPath = `/v1/interactions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createInteractionRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CreateLabOrdersCallbackRequest} createLabOrdersCallbackRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLabOrders: (createLabOrdersCallbackRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createLabOrdersCallbackRequest' is not null or undefined
            common_1.assertParamExists('createLabOrders', 'createLabOrdersCallbackRequest', createLabOrdersCallbackRequest);
            const localVarPath = `/v1/lab-orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createLabOrdersCallbackRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CreateMedicalRecordReleaseConsentRequest} createMedicalRecordReleaseConsentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMedicalRecordReleaseConsent: (createMedicalRecordReleaseConsentRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createMedicalRecordReleaseConsentRequest' is not null or undefined
            common_1.assertParamExists('createMedicalRecordReleaseConsent', 'createMedicalRecordReleaseConsentRequest', createMedicalRecordReleaseConsentRequest);
            const localVarPath = `/v1/medical-record-release-consent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createMedicalRecordReleaseConsentRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CreateMedicationRequest} createMedicationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMedication: (createMedicationRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createMedicationRequest' is not null or undefined
            common_1.assertParamExists('createMedication', 'createMedicationRequest', createMedicationRequest);
            const localVarPath = `/v1/medications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createMedicationRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} memberId
         * @param {CreateMemberEmergencyContactRequest} createMemberEmergencyContactRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMemberEmergencyContact: (memberId, createMemberEmergencyContactRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'memberId' is not null or undefined
            common_1.assertParamExists('createMemberEmergencyContact', 'memberId', memberId);
            // verify required parameter 'createMemberEmergencyContactRequest' is not null or undefined
            common_1.assertParamExists('createMemberEmergencyContact', 'createMemberEmergencyContactRequest', createMemberEmergencyContactRequest);
            const localVarPath = `/v1/members/{member_id}/emergency-contacts`
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createMemberEmergencyContactRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} recordTypeId
         * @param {string} memberId
         * @param {string} companyId
         * @param {string} dateOfCompletion
         * @param {boolean} performedAtVitableIn
         * @param {string} [file]
         * @param {string} [chartId]
         * @param {string} [medicalFileId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOccupationalHealthRecord: (recordTypeId, memberId, companyId, dateOfCompletion, performedAtVitableIn, file, chartId, medicalFileId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'recordTypeId' is not null or undefined
            common_1.assertParamExists('createOccupationalHealthRecord', 'recordTypeId', recordTypeId);
            // verify required parameter 'memberId' is not null or undefined
            common_1.assertParamExists('createOccupationalHealthRecord', 'memberId', memberId);
            // verify required parameter 'companyId' is not null or undefined
            common_1.assertParamExists('createOccupationalHealthRecord', 'companyId', companyId);
            // verify required parameter 'dateOfCompletion' is not null or undefined
            common_1.assertParamExists('createOccupationalHealthRecord', 'dateOfCompletion', dateOfCompletion);
            // verify required parameter 'performedAtVitableIn' is not null or undefined
            common_1.assertParamExists('createOccupationalHealthRecord', 'performedAtVitableIn', performedAtVitableIn);
            const localVarPath = `/v1/occupational-health-records`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (recordTypeId !== undefined) {
                localVarFormParams.append('record_type_id', recordTypeId);
            }
            if (memberId !== undefined) {
                localVarFormParams.append('member_id', memberId);
            }
            if (companyId !== undefined) {
                localVarFormParams.append('company_id', companyId);
            }
            if (dateOfCompletion !== undefined) {
                localVarFormParams.append('date_of_completion', dateOfCompletion);
            }
            if (performedAtVitableIn !== undefined) {
                localVarFormParams.append('performed_at_vitable_in', performedAtVitableIn);
            }
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            if (chartId !== undefined) {
                localVarFormParams.append('chart_id', chartId);
            }
            if (medicalFileId !== undefined) {
                localVarFormParams.append('medical_file_id', medicalFileId);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} carePlanId
         * @param {CreateProblemRequest} createProblemRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProblemForCarePlan: (carePlanId, createProblemRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'carePlanId' is not null or undefined
            common_1.assertParamExists('createProblemForCarePlan', 'carePlanId', carePlanId);
            // verify required parameter 'createProblemRequest' is not null or undefined
            common_1.assertParamExists('createProblemForCarePlan', 'createProblemRequest', createProblemRequest);
            const localVarPath = `/v1/care-plans/{care_plan_id}/problems`
                .replace(`{${"care_plan_id"}}`, encodeURIComponent(String(carePlanId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createProblemRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} familyMedicalHistoryId
         * @param {CreateProblemRequest} createProblemRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProblemForFamilyMedicalHistory: (familyMedicalHistoryId, createProblemRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'familyMedicalHistoryId' is not null or undefined
            common_1.assertParamExists('createProblemForFamilyMedicalHistory', 'familyMedicalHistoryId', familyMedicalHistoryId);
            // verify required parameter 'createProblemRequest' is not null or undefined
            common_1.assertParamExists('createProblemForFamilyMedicalHistory', 'createProblemRequest', createProblemRequest);
            const localVarPath = `/v1/family-medical-history/{family_medical_history_id}/problems`
                .replace(`{${"family_medical_history_id"}}`, encodeURIComponent(String(familyMedicalHistoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createProblemRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} problemId
         * @param {CreateProblemGoalRequest} createProblemGoalRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProblemGoal: (problemId, createProblemGoalRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'problemId' is not null or undefined
            common_1.assertParamExists('createProblemGoal', 'problemId', problemId);
            // verify required parameter 'createProblemGoalRequest' is not null or undefined
            common_1.assertParamExists('createProblemGoal', 'createProblemGoalRequest', createProblemGoalRequest);
            const localVarPath = `/v1/problems/{problem_id}/goals`
                .replace(`{${"problem_id"}}`, encodeURIComponent(String(problemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createProblemGoalRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} medicalProfileId
         * @param {CreateProcedureRequest} createProcedureRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProcedure: (medicalProfileId, createProcedureRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'medicalProfileId' is not null or undefined
            common_1.assertParamExists('createProcedure', 'medicalProfileId', medicalProfileId);
            // verify required parameter 'createProcedureRequest' is not null or undefined
            common_1.assertParamExists('createProcedure', 'createProcedureRequest', createProcedureRequest);
            const localVarPath = `/v1/medical-profiles/{medical_profile_id}/procedures`
                .replace(`{${"medical_profile_id"}}`, encodeURIComponent(String(medicalProfileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createProcedureRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {RxOrderCallBackRequest} [rxOrderCallBackRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRxOrder: (rxOrderCallBackRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/rx-orders/webhook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(rxOrderCallBackRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CreateVitalsRecordRequest} createVitalsRecordRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVitalsRecord: (createVitalsRecordRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createVitalsRecordRequest' is not null or undefined
            common_1.assertParamExists('createVitalsRecord', 'createVitalsRecordRequest', createVitalsRecordRequest);
            const localVarPath = `/v1/vitals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createVitalsRecordRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} chartingMacroId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteChartingMacro: (chartingMacroId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'chartingMacroId' is not null or undefined
            common_1.assertParamExists('deleteChartingMacro', 'chartingMacroId', chartingMacroId);
            const localVarPath = `/v1/charting-macros/{charting_macro_id}`
                .replace(`{${"charting_macro_id"}}`, encodeURIComponent(String(chartingMacroId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} dynamicMedicalChartId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDynamicMedicalChart: (dynamicMedicalChartId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'dynamicMedicalChartId' is not null or undefined
            common_1.assertParamExists('deleteDynamicMedicalChart', 'dynamicMedicalChartId', dynamicMedicalChartId);
            const localVarPath = `/v1/dynamic-medical-charts/{dynamic_medical_chart_id}`
                .replace(`{${"dynamic_medical_chart_id"}}`, encodeURIComponent(String(dynamicMedicalChartId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} dynamicMedicalChartId
         * @param {string} fileFieldId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDynamicMedicalChartAdditionalFile: (dynamicMedicalChartId, fileFieldId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'dynamicMedicalChartId' is not null or undefined
            common_1.assertParamExists('deleteDynamicMedicalChartAdditionalFile', 'dynamicMedicalChartId', dynamicMedicalChartId);
            // verify required parameter 'fileFieldId' is not null or undefined
            common_1.assertParamExists('deleteDynamicMedicalChartAdditionalFile', 'fileFieldId', fileFieldId);
            const localVarPath = `/v1/dynamic-medical-charts/{dynamic_medical_chart_id}/additional-files/{file_field_id}`
                .replace(`{${"dynamic_medical_chart_id"}}`, encodeURIComponent(String(dynamicMedicalChartId)))
                .replace(`{${"file_field_id"}}`, encodeURIComponent(String(fileFieldId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} contactId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmergencyContact: (contactId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'contactId' is not null or undefined
            common_1.assertParamExists('deleteEmergencyContact', 'contactId', contactId);
            const localVarPath = `/v1/emergency-contacts/{contact_id}`
                .replace(`{${"contact_id"}}`, encodeURIComponent(String(contactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} medicalProfileFileId
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMedicalProfileFile: (medicalProfileFileId, memberId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'medicalProfileFileId' is not null or undefined
            common_1.assertParamExists('deleteMedicalProfileFile', 'medicalProfileFileId', medicalProfileFileId);
            // verify required parameter 'memberId' is not null or undefined
            common_1.assertParamExists('deleteMedicalProfileFile', 'memberId', memberId);
            const localVarPath = `/v1/members/{member_id}/medical-profile/files/{medical_profile_file_id}`
                .replace(`{${"medical_profile_file_id"}}`, encodeURIComponent(String(medicalProfileFileId)))
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} dynamicMedicalChartId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateDynamicMedicalChartResultsFile: (dynamicMedicalChartId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'dynamicMedicalChartId' is not null or undefined
            common_1.assertParamExists('generateDynamicMedicalChartResultsFile', 'dynamicMedicalChartId', dynamicMedicalChartId);
            const localVarPath = `/v1/dynamic-medical-charts/{dynamic_medical_chart_id}/results-file`
                .replace(`{${"dynamic_medical_chart_id"}}`, encodeURIComponent(String(dynamicMedicalChartId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} administrativeFileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdministrativeFile: (administrativeFileId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'administrativeFileId' is not null or undefined
            common_1.assertParamExists('getAdministrativeFile', 'administrativeFileId', administrativeFileId);
            const localVarPath = `/v1/administrative-files/{administrative_file_id}`
                .replace(`{${"administrative_file_id"}}`, encodeURIComponent(String(administrativeFileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} carePlanId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCarePlan: (carePlanId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'carePlanId' is not null or undefined
            common_1.assertParamExists('getCarePlan', 'carePlanId', carePlanId);
            const localVarPath = `/v1/care-plans/{care_plan_id}`
                .replace(`{${"care_plan_id"}}`, encodeURIComponent(String(carePlanId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} codeableConceptsId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCodeableConcept: (codeableConceptsId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'codeableConceptsId' is not null or undefined
            common_1.assertParamExists('getCodeableConcept', 'codeableConceptsId', codeableConceptsId);
            const localVarPath = `/v1/codeable-concepts/{codeable_concepts_id}`
                .replace(`{${"codeable_concepts_id"}}`, encodeURIComponent(String(codeableConceptsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} contactId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmergencyContact: (contactId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'contactId' is not null or undefined
            common_1.assertParamExists('getEmergencyContact', 'contactId', contactId);
            const localVarPath = `/v1/emergency-contacts/{contact_id}`
                .replace(`{${"contact_id"}}`, encodeURIComponent(String(contactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} goalId
         * @param {string} problemId
         * @param {string} targetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGoalTarget: (goalId, problemId, targetId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'goalId' is not null or undefined
            common_1.assertParamExists('getGoalTarget', 'goalId', goalId);
            // verify required parameter 'problemId' is not null or undefined
            common_1.assertParamExists('getGoalTarget', 'problemId', problemId);
            // verify required parameter 'targetId' is not null or undefined
            common_1.assertParamExists('getGoalTarget', 'targetId', targetId);
            const localVarPath = `/v1/problems/{problem_id}/goals/{goal_id}/targets/{target_id}`
                .replace(`{${"goal_id"}}`, encodeURIComponent(String(goalId)))
                .replace(`{${"problem_id"}}`, encodeURIComponent(String(problemId)))
                .replace(`{${"target_id"}}`, encodeURIComponent(String(targetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} labOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLabOrder: (labOrderId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'labOrderId' is not null or undefined
            common_1.assertParamExists('getLabOrder', 'labOrderId', labOrderId);
            const localVarPath = `/v1/lab-orders/{lab_order_id}`
                .replace(`{${"lab_order_id"}}`, encodeURIComponent(String(labOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {GetLabOrderIframeUrlRequest} getLabOrderIframeUrlRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLabOrderIframeUrl: (getLabOrderIframeUrlRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'getLabOrderIframeUrlRequest' is not null or undefined
            common_1.assertParamExists('getLabOrderIframeUrl', 'getLabOrderIframeUrlRequest', getLabOrderIframeUrlRequest);
            const localVarPath = `/v1/lab-orders/iframe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(getLabOrderIframeUrlRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} manualLabResultId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManualLabResult: (manualLabResultId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'manualLabResultId' is not null or undefined
            common_1.assertParamExists('getManualLabResult', 'manualLabResultId', manualLabResultId);
            const localVarPath = `/v1/manual-lab-results/{manual_lab_result_id}`
                .replace(`{${"manual_lab_result_id"}}`, encodeURIComponent(String(manualLabResultId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} medicalFileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMedicalFile: (medicalFileId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'medicalFileId' is not null or undefined
            common_1.assertParamExists('getMedicalFile', 'medicalFileId', medicalFileId);
            const localVarPath = `/v1/medical-files/{medical_file_id}`
                .replace(`{${"medical_file_id"}}`, encodeURIComponent(String(medicalFileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMedicalProfile: (memberId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'memberId' is not null or undefined
            common_1.assertParamExists('getMedicalProfile', 'memberId', memberId);
            const localVarPath = `/v1/members/{member_id}/medical-profile`
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} medicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMedication: (medicationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'medicationId' is not null or undefined
            common_1.assertParamExists('getMedication', 'medicationId', medicationId);
            const localVarPath = `/v1/medications/{medication_id}`
                .replace(`{${"medication_id"}}`, encodeURIComponent(String(medicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberCarePlan: (memberId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'memberId' is not null or undefined
            common_1.assertParamExists('getMemberCarePlan', 'memberId', memberId);
            const localVarPath = `/v1/members/{member_id}/care-plan`
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} memberId
         * @param {string} problemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberProblem: (memberId, problemId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'memberId' is not null or undefined
            common_1.assertParamExists('getMemberProblem', 'memberId', memberId);
            // verify required parameter 'problemId' is not null or undefined
            common_1.assertParamExists('getMemberProblem', 'problemId', problemId);
            const localVarPath = `/v1/members/{member_id}/problems/{problem_id}`
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)))
                .replace(`{${"problem_id"}}`, encodeURIComponent(String(problemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} occupationalHealthRecordId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOccupationalHealthRecord: (occupationalHealthRecordId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'occupationalHealthRecordId' is not null or undefined
            common_1.assertParamExists('getOccupationalHealthRecord', 'occupationalHealthRecordId', occupationalHealthRecordId);
            const localVarPath = `/v1/occupational-health-records/{occupational_health_record_id}`
                .replace(`{${"occupational_health_record_id"}}`, encodeURIComponent(String(occupationalHealthRecordId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {GetOrCreateCodeableConceptRequest} getOrCreateCodeableConceptRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrCreateCodeableConcept: (getOrCreateCodeableConceptRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'getOrCreateCodeableConceptRequest' is not null or undefined
            common_1.assertParamExists('getOrCreateCodeableConcept', 'getOrCreateCodeableConceptRequest', getOrCreateCodeableConceptRequest);
            const localVarPath = `/v1/codeable-concepts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(getOrCreateCodeableConceptRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreferredPharmacyForMember: (memberId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'memberId' is not null or undefined
            common_1.assertParamExists('getPreferredPharmacyForMember', 'memberId', memberId);
            const localVarPath = `/v1/members/{member_id}/preferred-pharmacy`
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} problemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProblem: (problemId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'problemId' is not null or undefined
            common_1.assertParamExists('getProblem', 'problemId', problemId);
            const localVarPath = `/v1/problems/{problem_id}`
                .replace(`{${"problem_id"}}`, encodeURIComponent(String(problemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} vitalsRecordId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVitalsRecord: (vitalsRecordId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'vitalsRecordId' is not null or undefined
            common_1.assertParamExists('getVitalsRecord', 'vitalsRecordId', vitalsRecordId);
            const localVarPath = `/v1/vitals/{vitals_record_id}`
                .replace(`{${"vitals_record_id"}}`, encodeURIComponent(String(vitalsRecordId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} codeId
         * @param {string} medicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkMedicationCode: (codeId, medicationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'codeId' is not null or undefined
            common_1.assertParamExists('linkMedicationCode', 'codeId', codeId);
            // verify required parameter 'medicationId' is not null or undefined
            common_1.assertParamExists('linkMedicationCode', 'medicationId', medicationId);
            const localVarPath = `/v1/medications/{medication_id}/codes/{code_id}`
                .replace(`{${"code_id"}}`, encodeURIComponent(String(codeId)))
                .replace(`{${"medication_id"}}`, encodeURIComponent(String(medicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} medicationId
         * @param {string} problemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkMedicationProblem: (medicationId, problemId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'medicationId' is not null or undefined
            common_1.assertParamExists('linkMedicationProblem', 'medicationId', medicationId);
            // verify required parameter 'problemId' is not null or undefined
            common_1.assertParamExists('linkMedicationProblem', 'problemId', problemId);
            const localVarPath = `/v1/medications/{medication_id}/problems/{problem_id}`
                .replace(`{${"medication_id"}}`, encodeURIComponent(String(medicationId)))
                .replace(`{${"problem_id"}}`, encodeURIComponent(String(problemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} memberId
         * @param {boolean} [enteredInErrorIn]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAdministrativeFiles: (memberId, enteredInErrorIn, page, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'memberId' is not null or undefined
            common_1.assertParamExists('listAdministrativeFiles', 'memberId', memberId);
            const localVarPath = `/v1/administrative-files`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (enteredInErrorIn !== undefined) {
                localVarQueryParameter['entered_in_error_in'] = enteredInErrorIn;
            }
            if (memberId !== undefined) {
                localVarQueryParameter['member_id'] = memberId;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} carePlanId
         * @param {boolean} [includeEnteredInErrorIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllergies: (carePlanId, includeEnteredInErrorIn, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'carePlanId' is not null or undefined
            common_1.assertParamExists('listAllergies', 'carePlanId', carePlanId);
            const localVarPath = `/v1/care-plans/{care_plan_id}/allergies`
                .replace(`{${"care_plan_id"}}`, encodeURIComponent(String(carePlanId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (includeEnteredInErrorIn !== undefined) {
                localVarQueryParameter['include_entered_in_error_in'] = includeEnteredInErrorIn;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} carePlanId
         * @param {string} [encounterId]
         * @param {string} [familyMedicalHistoryId]
         * @param {boolean} [includeEnteredInErrorIn]
         * @param {string} [medicationId]
         * @param {string} [taskId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCarePlanProblems: (carePlanId, encounterId, familyMedicalHistoryId, includeEnteredInErrorIn, medicationId, taskId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'carePlanId' is not null or undefined
            common_1.assertParamExists('listCarePlanProblems', 'carePlanId', carePlanId);
            const localVarPath = `/v1/care-plans/{care_plan_id}/problems`
                .replace(`{${"care_plan_id"}}`, encodeURIComponent(String(carePlanId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (encounterId !== undefined) {
                localVarQueryParameter['encounter_id'] = encounterId;
            }
            if (familyMedicalHistoryId !== undefined) {
                localVarQueryParameter['family_medical_history_id'] = familyMedicalHistoryId;
            }
            if (includeEnteredInErrorIn !== undefined) {
                localVarQueryParameter['include_entered_in_error_in'] = includeEnteredInErrorIn;
            }
            if (medicationId !== undefined) {
                localVarQueryParameter['medication_id'] = medicationId;
            }
            if (taskId !== undefined) {
                localVarQueryParameter['task_id'] = taskId;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {boolean} [ownedByVitableIn]
         * @param {number} [page]
         * @param {string} [providerId]
         * @param {string} [title]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listChartingMacros: (ownedByVitableIn, page, providerId, title, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/charting-macros`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (ownedByVitableIn !== undefined) {
                localVarQueryParameter['owned_by_vitable_in'] = ownedByVitableIn;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (providerId !== undefined) {
                localVarQueryParameter['provider_id'] = providerId;
            }
            if (title !== undefined) {
                localVarQueryParameter['title'] = title;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [carePlanId]
         * @param {string} [creatorId]
         * @param {boolean} [enteredInErrorIn]
         * @param {string} [noteContents]
         * @param {string} [orderByLinkedTaskId]
         * @param {number} [page]
         * @param {string} [taskId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listClinicalNotes: (carePlanId, creatorId, enteredInErrorIn, noteContents, orderByLinkedTaskId, page, taskId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/clinical-notes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (carePlanId !== undefined) {
                localVarQueryParameter['care_plan_id'] = carePlanId;
            }
            if (creatorId !== undefined) {
                localVarQueryParameter['creator_id'] = creatorId;
            }
            if (enteredInErrorIn !== undefined) {
                localVarQueryParameter['entered_in_error_in'] = enteredInErrorIn;
            }
            if (noteContents !== undefined) {
                localVarQueryParameter['note_contents'] = noteContents;
            }
            if (orderByLinkedTaskId !== undefined) {
                localVarQueryParameter['order_by_linked_task_id'] = orderByLinkedTaskId;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (taskId !== undefined) {
                localVarQueryParameter['task_id'] = taskId;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} companyId
         * @param {string} ohrTypeId
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompanyMembersWithMissingOccupationalHealthRecord: (companyId, ohrTypeId, page, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyId' is not null or undefined
            common_1.assertParamExists('listCompanyMembersWithMissingOccupationalHealthRecord', 'companyId', companyId);
            // verify required parameter 'ohrTypeId' is not null or undefined
            common_1.assertParamExists('listCompanyMembersWithMissingOccupationalHealthRecord', 'ohrTypeId', ohrTypeId);
            const localVarPath = `/v1/companies/{company_id}/members-with-missing-ohr`
                .replace(`{${"company_id"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (ohrTypeId !== undefined) {
                localVarQueryParameter['ohr_type_id'] = ohrTypeId;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [appointmentDateEnd]
         * @param {string} [appointmentDateStart]
         * @param {string} [appointmentId]
         * @param {'AL' | 'AK' | 'AZ' | 'AR' | 'CA' | 'CO' | 'CT' | 'DC' | 'DE' | 'FL' | 'GA' | 'HI' | 'ID' | 'IL' | 'IN' | 'IA' | 'KS' | 'KY' | 'LA' | 'ME' | 'MD' | 'MA' | 'MI' | 'MN' | 'MS' | 'MO' | 'MT' | 'NE' | 'NV' | 'NH' | 'NJ' | 'NM' | 'NY' | 'NC' | 'ND' | 'OH' | 'OK' | 'OR' | 'PR' | 'PA' | 'RI' | 'SC' | 'SD' | 'TN' | 'TX' | 'UT' | 'VT' | 'VI' | 'VA' | 'WA' | 'WI' | 'WV' | 'WY' | 'AA' | 'AE' | 'PW' | 'AP' | 'FM' | 'MH' | 'GU'} [appointmentState] * &#x60;AL&#x60; - AL * &#x60;AK&#x60; - AK * &#x60;AZ&#x60; - AZ * &#x60;AR&#x60; - AR * &#x60;CA&#x60; - CA * &#x60;CO&#x60; - CO * &#x60;CT&#x60; - CT * &#x60;DC&#x60; - DC * &#x60;DE&#x60; - DE * &#x60;FL&#x60; - FL * &#x60;GA&#x60; - GA * &#x60;HI&#x60; - HI * &#x60;ID&#x60; - ID * &#x60;IL&#x60; - IL * &#x60;IN&#x60; - IN * &#x60;IA&#x60; - IA * &#x60;KS&#x60; - KS * &#x60;KY&#x60; - KY * &#x60;LA&#x60; - LA * &#x60;ME&#x60; - ME * &#x60;MD&#x60; - MD * &#x60;MA&#x60; - MA * &#x60;MI&#x60; - MI * &#x60;MN&#x60; - MN * &#x60;MS&#x60; - MS * &#x60;MO&#x60; - MO * &#x60;MT&#x60; - MT * &#x60;NE&#x60; - NE * &#x60;NV&#x60; - NV * &#x60;NH&#x60; - NH * &#x60;NJ&#x60; - NJ * &#x60;NM&#x60; - NM * &#x60;NY&#x60; - NY * &#x60;NC&#x60; - NC * &#x60;ND&#x60; - ND * &#x60;OH&#x60; - OH * &#x60;OK&#x60; - OK * &#x60;OR&#x60; - OR * &#x60;PR&#x60; - PR * &#x60;PA&#x60; - PA * &#x60;RI&#x60; - RI * &#x60;SC&#x60; - SC * &#x60;SD&#x60; - SD * &#x60;TN&#x60; - TN * &#x60;TX&#x60; - TX * &#x60;UT&#x60; - UT * &#x60;VT&#x60; - VT * &#x60;VI&#x60; - VI * &#x60;VA&#x60; - VA * &#x60;WA&#x60; - WA * &#x60;WI&#x60; - WI * &#x60;WV&#x60; - WV * &#x60;WY&#x60; - WY * &#x60;AA&#x60; - AA * &#x60;AE&#x60; - AE * &#x60;PW&#x60; - PW * &#x60;AP&#x60; - AP * &#x60;FM&#x60; - FM * &#x60;MH&#x60; - MH * &#x60;GU&#x60; - GU
         * @param {boolean} [blockedIn]
         * @param {'History of Present Illness' | 'Physical Exam' | 'Clinical Reasoning' | 'Medical Forms' | 'Additional Files' | 'SOAP' | 'Visit Summary'} [chartType] * &#x60;History of Present Illness&#x60; - Hpi * &#x60;Physical Exam&#x60; - Pe * &#x60;Clinical Reasoning&#x60; - Clinical Reasoning * &#x60;Medical Forms&#x60; - Medical Forms * &#x60;Additional Files&#x60; - Additional Files * &#x60;SOAP&#x60; - Soap * &#x60;Visit Summary&#x60; - Visit Summary
         * @param {string} [clinicId]
         * @param {string} [companyId]
         * @param {boolean} [hasResultsFile]
         * @param {string} [medicalServiceId]
         * @param {string} [memberId]
         * @param {number} [orderByOverdue]
         * @param {boolean} [overdueIn]
         * @param {number} [page]
         * @param {string} [providerId]
         * @param {boolean} [publishedIn]
         * @param {string} [templateId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDynamicMedicalCharts: (appointmentDateEnd, appointmentDateStart, appointmentId, appointmentState, blockedIn, chartType, clinicId, companyId, hasResultsFile, medicalServiceId, memberId, orderByOverdue, overdueIn, page, providerId, publishedIn, templateId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/dynamic-medical-charts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (appointmentDateEnd !== undefined) {
                localVarQueryParameter['appointment_date_end'] = (appointmentDateEnd instanceof Date) ?
                    appointmentDateEnd.toISOString() :
                    appointmentDateEnd;
            }
            if (appointmentDateStart !== undefined) {
                localVarQueryParameter['appointment_date_start'] = (appointmentDateStart instanceof Date) ?
                    appointmentDateStart.toISOString() :
                    appointmentDateStart;
            }
            if (appointmentId !== undefined) {
                localVarQueryParameter['appointment_id'] = appointmentId;
            }
            if (appointmentState !== undefined) {
                localVarQueryParameter['appointment_state'] = appointmentState;
            }
            if (blockedIn !== undefined) {
                localVarQueryParameter['blocked_in'] = blockedIn;
            }
            if (chartType !== undefined) {
                localVarQueryParameter['chart_type'] = chartType;
            }
            if (clinicId !== undefined) {
                localVarQueryParameter['clinic_id'] = clinicId;
            }
            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }
            if (hasResultsFile !== undefined) {
                localVarQueryParameter['has_results_file'] = hasResultsFile;
            }
            if (medicalServiceId !== undefined) {
                localVarQueryParameter['medical_service_id'] = medicalServiceId;
            }
            if (memberId !== undefined) {
                localVarQueryParameter['member_id'] = memberId;
            }
            if (orderByOverdue !== undefined) {
                localVarQueryParameter['order_by_overdue'] = orderByOverdue;
            }
            if (overdueIn !== undefined) {
                localVarQueryParameter['overdue_in'] = overdueIn;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (providerId !== undefined) {
                localVarQueryParameter['provider_id'] = providerId;
            }
            if (publishedIn !== undefined) {
                localVarQueryParameter['published_in'] = publishedIn;
            }
            if (templateId !== undefined) {
                localVarQueryParameter['template_id'] = templateId;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} encounterId
         * @param {'History of Present Illness' | 'Physical Exam' | 'Clinical Reasoning' | 'Medical Forms' | 'Additional Files' | 'SOAP' | 'Visit Summary'} [chartType] * &#x60;History of Present Illness&#x60; - Hpi * &#x60;Physical Exam&#x60; - Pe * &#x60;Clinical Reasoning&#x60; - Clinical Reasoning * &#x60;Medical Forms&#x60; - Medical Forms * &#x60;Additional Files&#x60; - Additional Files * &#x60;SOAP&#x60; - Soap * &#x60;Visit Summary&#x60; - Visit Summary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDynamicMedicalChartsByEncounter: (encounterId, chartType, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'encounterId' is not null or undefined
            common_1.assertParamExists('listDynamicMedicalChartsByEncounter', 'encounterId', encounterId);
            const localVarPath = `/v1/encounters/{encounter_id}/dynamic-medical-charts`
                .replace(`{${"encounter_id"}}`, encodeURIComponent(String(encounterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (chartType !== undefined) {
                localVarQueryParameter['chart_type'] = chartType;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} encounterId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEncounterProblems: (encounterId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'encounterId' is not null or undefined
            common_1.assertParamExists('listEncounterProblems', 'encounterId', encounterId);
            const localVarPath = `/v1/encounter/{encounter_id}/problems`
                .replace(`{${"encounter_id"}}`, encodeURIComponent(String(encounterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} numDays
         * @param {'Alabama' | 'Alaska' | 'Arizona' | 'Arkansas' | 'California' | 'Colorado' | 'Connecticut' | 'Washington D.C.' | 'Delaware' | 'Florida' | 'Georgia' | 'Hawaii' | 'Idaho' | 'Illinois' | 'Indiana' | 'Iowa' | 'Kansas' | 'Kentucky' | 'Louisiana' | 'Maine' | 'Maryland' | 'Massachusetts' | 'Michigan' | 'Minnesota' | 'Mississippi' | 'Missouri' | 'Montana' | 'Nebraska' | 'Nevada' | 'New Hampshire' | 'New Jersey' | 'New Mexico' | 'New York' | 'North Carolina' | 'North Dakota' | 'Ohio' | 'Oklahoma' | 'Oregon' | 'Pennsylvania' | 'Puerto Rico' | 'Rhode Island' | 'South Carolina' | 'South Dakota' | 'Tennessee' | 'Texas' | 'Utah' | 'Vermont' | 'Virgin Islands' | 'Virginia' | 'Washington' | 'Wisconsin' | 'West Virginia' | 'Wyoming' | 'AA' | 'AE' | 'PW' | 'AP' | 'FM' | 'MH' | 'GU'} state * &#x60;Alabama&#x60; - Al * &#x60;Alaska&#x60; - Ak * &#x60;Arizona&#x60; - Az * &#x60;Arkansas&#x60; - Ar * &#x60;California&#x60; - Ca * &#x60;Colorado&#x60; - Co * &#x60;Connecticut&#x60; - Ct * &#x60;Washington D.C.&#x60; - Dc * &#x60;Delaware&#x60; - De * &#x60;Florida&#x60; - Fl * &#x60;Georgia&#x60; - Ga * &#x60;Hawaii&#x60; - Hi * &#x60;Idaho&#x60; - Id * &#x60;Illinois&#x60; - Il * &#x60;Indiana&#x60; - In * &#x60;Iowa&#x60; - Ia * &#x60;Kansas&#x60; - Ks * &#x60;Kentucky&#x60; - Ky * &#x60;Louisiana&#x60; - La * &#x60;Maine&#x60; - Me * &#x60;Maryland&#x60; - Md * &#x60;Massachusetts&#x60; - Ma * &#x60;Michigan&#x60; - Mi * &#x60;Minnesota&#x60; - Mn * &#x60;Mississippi&#x60; - Ms * &#x60;Missouri&#x60; - Mo * &#x60;Montana&#x60; - Mt * &#x60;Nebraska&#x60; - Ne * &#x60;Nevada&#x60; - Nv * &#x60;New Hampshire&#x60; - Nh * &#x60;New Jersey&#x60; - Nj * &#x60;New Mexico&#x60; - Nm * &#x60;New York&#x60; - Ny * &#x60;North Carolina&#x60; - Nc * &#x60;North Dakota&#x60; - Nd * &#x60;Ohio&#x60; - Oh * &#x60;Oklahoma&#x60; - Ok * &#x60;Oregon&#x60; - Or * &#x60;Pennsylvania&#x60; - Pa * &#x60;Puerto Rico&#x60; - Pr * &#x60;Rhode Island&#x60; - Ri * &#x60;South Carolina&#x60; - Sc * &#x60;South Dakota&#x60; - Sd * &#x60;Tennessee&#x60; - Tn * &#x60;Texas&#x60; - Tx * &#x60;Utah&#x60; - Ut * &#x60;Vermont&#x60; - Vt * &#x60;Virgin Islands&#x60; - Vi * &#x60;Virginia&#x60; - Va * &#x60;Washington&#x60; - Wa * &#x60;Wisconsin&#x60; - Wi * &#x60;West Virginia&#x60; - Wv * &#x60;Wyoming&#x60; - Wy * &#x60;AA&#x60; - Aa * &#x60;AE&#x60; - Ae * &#x60;PW&#x60; - Pw * &#x60;AP&#x60; - Ap * &#x60;FM&#x60; - Fm * &#x60;MH&#x60; - Mh * &#x60;GU&#x60; - Gu
         * @param {string} [companyId]
         * @param {string} [ohrTypeId]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listExpiringOccupationalHealthRecords: (numDays, state, companyId, ohrTypeId, page, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'numDays' is not null or undefined
            common_1.assertParamExists('listExpiringOccupationalHealthRecords', 'numDays', numDays);
            // verify required parameter 'state' is not null or undefined
            common_1.assertParamExists('listExpiringOccupationalHealthRecords', 'state', state);
            const localVarPath = `/v1/occupational-health-records/expiring`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }
            if (numDays !== undefined) {
                localVarQueryParameter['num_days'] = numDays;
            }
            if (ohrTypeId !== undefined) {
                localVarQueryParameter['ohr_type_id'] = ohrTypeId;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} medicalProfileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFamilyMedicalHistory: (medicalProfileId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'medicalProfileId' is not null or undefined
            common_1.assertParamExists('listFamilyMedicalHistory', 'medicalProfileId', medicalProfileId);
            const localVarPath = `/v1/medical-profile/{medical_profile_id}/family_medical_history`
                .replace(`{${"medical_profile_id"}}`, encodeURIComponent(String(medicalProfileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} familyMedicalHistoryId
         * @param {boolean} [includeEnteredInErrorIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFamilyMedicalHistoryProblems: (familyMedicalHistoryId, includeEnteredInErrorIn, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'familyMedicalHistoryId' is not null or undefined
            common_1.assertParamExists('listFamilyMedicalHistoryProblems', 'familyMedicalHistoryId', familyMedicalHistoryId);
            const localVarPath = `/v1/family-medical-history/{family_medical_history_id}/problems`
                .replace(`{${"family_medical_history_id"}}`, encodeURIComponent(String(familyMedicalHistoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (includeEnteredInErrorIn !== undefined) {
                localVarQueryParameter['include_entered_in_error_in'] = includeEnteredInErrorIn;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} goalId
         * @param {string} problemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGoalTargets: (goalId, problemId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'goalId' is not null or undefined
            common_1.assertParamExists('listGoalTargets', 'goalId', goalId);
            // verify required parameter 'problemId' is not null or undefined
            common_1.assertParamExists('listGoalTargets', 'problemId', problemId);
            const localVarPath = `/v1/problems/{problem_id}/goals/{goal_id}/targets`
                .replace(`{${"goal_id"}}`, encodeURIComponent(String(goalId)))
                .replace(`{${"problem_id"}}`, encodeURIComponent(String(problemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [authorId]
         * @param {'Patient' | 'Patient representative' | 'Internal' | 'None' | 'Other' | 'null'} [correspondentType] * &#x60;Patient&#x60; - Patient * &#x60;Patient representative&#x60; - Patient Representative * &#x60;Internal&#x60; - Internal * &#x60;None&#x60; - None * &#x60;Other&#x60; - Other
         * @param {'Phone' | 'Email' | 'SMS' | 'Chat' | 'Documentation' | 'null'} [interactionChannel] * &#x60;Phone&#x60; - Phone * &#x60;Email&#x60; - Email * &#x60;SMS&#x60; - Sms * &#x60;Chat&#x60; - Chat * &#x60;Documentation&#x60; - Documentation
         * @param {'Follow-up' | 'Prescription change' | 'Care coordination' | 'Admin note' | 'Lab order' | 'Lab review' | 'Other' | 'null'} [interactionType] * &#x60;Follow-up&#x60; - Follow Up * &#x60;Prescription change&#x60; - Prescription Change * &#x60;Care coordination&#x60; - Care Coordination * &#x60;Admin note&#x60; - Admin Note * &#x60;Lab order&#x60; - Lab Order * &#x60;Lab review&#x60; - Lab Review * &#x60;Other&#x60; - Other
         * @param {number} [limit]
         * @param {number} [page]
         * @param {string} [patientId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInteractions: (authorId, correspondentType, interactionChannel, interactionType, limit, page, patientId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/interactions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (authorId !== undefined) {
                localVarQueryParameter['author_id'] = authorId;
            }
            if (correspondentType !== undefined) {
                localVarQueryParameter['correspondent_type'] = correspondentType;
            }
            if (interactionChannel !== undefined) {
                localVarQueryParameter['interaction_channel'] = interactionChannel;
            }
            if (interactionType !== undefined) {
                localVarQueryParameter['interaction_type'] = interactionType;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (patientId !== undefined) {
                localVarQueryParameter['patient_id'] = patientId;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [createdEndDatetime]
         * @param {string} [createdStartDatetime]
         * @param {boolean} [hasAddedLabDraws]
         * @param {boolean} [hasReceivedResults]
         * @param {string} [labName]
         * @param {boolean} [labOrderConfirmationCompletedIn]
         * @param {'registered' | 'preliminary' | 'final' | 'amended' | 'corrected' | 'cancelled' | 'entered-in-error' | 'unknown'} [labTestStatus] * &#x60;registered&#x60; - registered * &#x60;preliminary&#x60; - preliminary * &#x60;final&#x60; - final * &#x60;amended&#x60; - amended * &#x60;corrected&#x60; - corrected * &#x60;cancelled&#x60; - cancelled * &#x60;entered-in-error&#x60; - entered-in-error * &#x60;unknown&#x60; - unknown
         * @param {string} [memberId]
         * @param {string} [orderingEncounterId]
         * @param {number} [page]
         * @param {'Needs Diagnostic Follow Up' | 'Diagnostic Follow Up Scheduled' | 'Diagnostic Follow Up Complete'} [postLabStatus] * &#x60;Needs Diagnostic Follow Up&#x60; - Needs Diagnostic Follow Up * &#x60;Diagnostic Follow Up Scheduled&#x60; - Diagnostic Follow Up Scheduled * &#x60;Diagnostic Follow Up Complete&#x60; - Diagnostic Follow Up Complete
         * @param {string} [providerId]
         * @param {string} [renderingEncounterId]
         * @param {'Cancelled' | 'Awaiting Results' | 'Needs Lab Draw' | 'Lab Draw Scheduled' | 'Results Received' | 'Completed' | 'Inconclusive'} [status] * &#x60;Cancelled&#x60; - Cancelled * &#x60;Awaiting Results&#x60; - Awaiting Results * &#x60;Needs Lab Draw&#x60; - Needs Lab Draw * &#x60;Lab Draw Scheduled&#x60; - Lab Draw Scheduled * &#x60;Results Received&#x60; - Results Received * &#x60;Completed&#x60; - Completed * &#x60;Inconclusive&#x60; - Inconclusive
         * @param {string} [testCodeableConceptId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLabOrders: (createdEndDatetime, createdStartDatetime, hasAddedLabDraws, hasReceivedResults, labName, labOrderConfirmationCompletedIn, labTestStatus, memberId, orderingEncounterId, page, postLabStatus, providerId, renderingEncounterId, status, testCodeableConceptId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/lab-orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (createdEndDatetime !== undefined) {
                localVarQueryParameter['created_end_datetime'] = (createdEndDatetime instanceof Date) ?
                    createdEndDatetime.toISOString() :
                    createdEndDatetime;
            }
            if (createdStartDatetime !== undefined) {
                localVarQueryParameter['created_start_datetime'] = (createdStartDatetime instanceof Date) ?
                    createdStartDatetime.toISOString() :
                    createdStartDatetime;
            }
            if (hasAddedLabDraws !== undefined) {
                localVarQueryParameter['has_added_lab_draws'] = hasAddedLabDraws;
            }
            if (hasReceivedResults !== undefined) {
                localVarQueryParameter['has_received_results'] = hasReceivedResults;
            }
            if (labName !== undefined) {
                localVarQueryParameter['lab_name'] = labName;
            }
            if (labOrderConfirmationCompletedIn !== undefined) {
                localVarQueryParameter['lab_order_confirmation_completed_in'] = labOrderConfirmationCompletedIn;
            }
            if (labTestStatus !== undefined) {
                localVarQueryParameter['lab_test_status'] = labTestStatus;
            }
            if (memberId !== undefined) {
                localVarQueryParameter['member_id'] = memberId;
            }
            if (orderingEncounterId !== undefined) {
                localVarQueryParameter['ordering_encounter_id'] = orderingEncounterId;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (postLabStatus !== undefined) {
                localVarQueryParameter['post_lab_status'] = postLabStatus;
            }
            if (providerId !== undefined) {
                localVarQueryParameter['provider_id'] = providerId;
            }
            if (renderingEncounterId !== undefined) {
                localVarQueryParameter['rendering_encounter_id'] = renderingEncounterId;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (testCodeableConceptId !== undefined) {
                localVarQueryParameter['test_codeable_concept_id'] = testCodeableConceptId;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [name]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLabTestCodeableConcepts: (name, page, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/lab-test-codeable-concepts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [createdEndDatetime]
         * @param {string} [createdStartDatetime]
         * @param {boolean} [enteredInErrorIn]
         * @param {string} [labName]
         * @param {string} [labResultPatientName]
         * @param {number} [page]
         * @param {string} [patientId]
         * @param {boolean} [reviewedIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listManualLabResults: (createdEndDatetime, createdStartDatetime, enteredInErrorIn, labName, labResultPatientName, page, patientId, reviewedIn, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/manual-lab-results`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (createdEndDatetime !== undefined) {
                localVarQueryParameter['created_end_datetime'] = (createdEndDatetime instanceof Date) ?
                    createdEndDatetime.toISOString() :
                    createdEndDatetime;
            }
            if (createdStartDatetime !== undefined) {
                localVarQueryParameter['created_start_datetime'] = (createdStartDatetime instanceof Date) ?
                    createdStartDatetime.toISOString() :
                    createdStartDatetime;
            }
            if (enteredInErrorIn !== undefined) {
                localVarQueryParameter['entered_in_error_in'] = enteredInErrorIn;
            }
            if (labName !== undefined) {
                localVarQueryParameter['lab_name'] = labName;
            }
            if (labResultPatientName !== undefined) {
                localVarQueryParameter['lab_result_patient_name'] = labResultPatientName;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (patientId !== undefined) {
                localVarQueryParameter['patient_id'] = patientId;
            }
            if (reviewedIn !== undefined) {
                localVarQueryParameter['reviewed_in'] = reviewedIn;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {'History of Present Illness' | 'Physical Exam' | 'Clinical Reasoning' | 'Medical Forms' | 'Additional Files' | 'SOAP' | 'Visit Summary'} [chartType] * &#x60;History of Present Illness&#x60; - Hpi * &#x60;Physical Exam&#x60; - Pe * &#x60;Clinical Reasoning&#x60; - Clinical Reasoning * &#x60;Medical Forms&#x60; - Medical Forms * &#x60;Additional Files&#x60; - Additional Files * &#x60;SOAP&#x60; - Soap * &#x60;Visit Summary&#x60; - Visit Summary
         * @param {string} [name]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMedicalChartTemplates: (chartType, name, page, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/medical-chart-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (chartType !== undefined) {
                localVarQueryParameter['chart_type'] = chartType;
            }
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {'History of Present Illness' | 'Physical Exam' | 'Clinical Reasoning' | 'Medical Forms' | 'Additional Files' | 'SOAP' | 'Visit Summary'} chartType * &#x60;History of Present Illness&#x60; - Hpi * &#x60;Physical Exam&#x60; - Pe * &#x60;Clinical Reasoning&#x60; - Clinical Reasoning * &#x60;Medical Forms&#x60; - Medical Forms * &#x60;Additional Files&#x60; - Additional Files * &#x60;SOAP&#x60; - Soap * &#x60;Visit Summary&#x60; - Visit Summary
         * @param {string} encounterId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMedicalChartTemplatesForEncounter: (chartType, encounterId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'chartType' is not null or undefined
            common_1.assertParamExists('listMedicalChartTemplatesForEncounter', 'chartType', chartType);
            // verify required parameter 'encounterId' is not null or undefined
            common_1.assertParamExists('listMedicalChartTemplatesForEncounter', 'encounterId', encounterId);
            const localVarPath = `/v1/encounters/{encounter_id}/medical-chart-templates`
                .replace(`{${"encounter_id"}}`, encodeURIComponent(String(encounterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (chartType !== undefined) {
                localVarQueryParameter['chart_type'] = chartType;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} memberId
         * @param {string} [encounterId]
         * @param {number} [limit]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMedicalFilesForMember: (memberId, encounterId, limit, page, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'memberId' is not null or undefined
            common_1.assertParamExists('listMedicalFilesForMember', 'memberId', memberId);
            const localVarPath = `/v1/members/{member_id}/medical-files`
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (encounterId !== undefined) {
                localVarQueryParameter['encounter_id'] = encounterId;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} memberId
         * @param {number} [limit]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMedicalProfileFiles: (memberId, limit, page, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'memberId' is not null or undefined
            common_1.assertParamExists('listMedicalProfileFiles', 'memberId', memberId);
            const localVarPath = `/v1/members/{member_id}/medical-profile/files`
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [memberId]
         * @param {string} [occupationalHealthLabOrderRequestId]
         * @param {string} [urgentCareOrderRequestId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMedicalRecordReleaseConsents: (memberId, occupationalHealthLabOrderRequestId, urgentCareOrderRequestId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/medical-record-release-consent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (memberId !== undefined) {
                localVarQueryParameter['member_id'] = memberId;
            }
            if (occupationalHealthLabOrderRequestId !== undefined) {
                localVarQueryParameter['occupational_health_lab_order_request_id'] = occupationalHealthLabOrderRequestId;
            }
            if (urgentCareOrderRequestId !== undefined) {
                localVarQueryParameter['urgent_care_order_request_id'] = urgentCareOrderRequestId;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {boolean} [inHomePerformableIn]
         * @param {string} [medicalServiceId]
         * @param {string} [name]
         * @param {boolean} [onsiteClinicPerformableIn]
         * @param {boolean} [schedulableByMemberIn]
         * @param {boolean} [telemedicinePerformableIn]
         * @param {boolean} [urgentCarePerformableIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMedicalServices: (inHomePerformableIn, medicalServiceId, name, onsiteClinicPerformableIn, schedulableByMemberIn, telemedicinePerformableIn, urgentCarePerformableIn, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/medical-services`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (inHomePerformableIn !== undefined) {
                localVarQueryParameter['in_home_performable_in'] = inHomePerformableIn;
            }
            if (medicalServiceId !== undefined) {
                localVarQueryParameter['medical_service_id'] = medicalServiceId;
            }
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (onsiteClinicPerformableIn !== undefined) {
                localVarQueryParameter['onsite_clinic_performable_in'] = onsiteClinicPerformableIn;
            }
            if (schedulableByMemberIn !== undefined) {
                localVarQueryParameter['schedulable_by_member_in'] = schedulableByMemberIn;
            }
            if (telemedicinePerformableIn !== undefined) {
                localVarQueryParameter['telemedicine_performable_in'] = telemedicinePerformableIn;
            }
            if (urgentCarePerformableIn !== undefined) {
                localVarQueryParameter['urgent_care_performable_in'] = urgentCarePerformableIn;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} carePlanId
         * @param {string} [asserterId]
         * @param {string} [encounterId]
         * @param {boolean} [includeEnteredInErrorIn]
         * @param {string} [problemId]
         * @param {string} [recorderId]
         * @param {'Active' | 'Inactive' | 'Entered in Error' | '' | 'null'} [status] * &#x60;Active&#x60; - Active * &#x60;Inactive&#x60; - Inactive * &#x60;Entered in Error&#x60; - Entered In Error
         * @param {'OTC' | 'Prescription' | 'Manual Prescription' | 'Member Reported' | '' | 'null'} [type] * &#x60;OTC&#x60; - Otc * &#x60;Prescription&#x60; - E Prescription * &#x60;Manual Prescription&#x60; - Manual Prescription * &#x60;Member Reported&#x60; - Member Reported
         * @param {boolean} [unlinkedIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMedications: (carePlanId, asserterId, encounterId, includeEnteredInErrorIn, problemId, recorderId, status, type, unlinkedIn, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'carePlanId' is not null or undefined
            common_1.assertParamExists('listMedications', 'carePlanId', carePlanId);
            const localVarPath = `/v1/medications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (asserterId !== undefined) {
                localVarQueryParameter['asserter_id'] = asserterId;
            }
            if (carePlanId !== undefined) {
                localVarQueryParameter['care_plan_id'] = carePlanId;
            }
            if (encounterId !== undefined) {
                localVarQueryParameter['encounter_id'] = encounterId;
            }
            if (includeEnteredInErrorIn !== undefined) {
                localVarQueryParameter['include_entered_in_error_in'] = includeEnteredInErrorIn;
            }
            if (problemId !== undefined) {
                localVarQueryParameter['problem_id'] = problemId;
            }
            if (recorderId !== undefined) {
                localVarQueryParameter['recorder_id'] = recorderId;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (unlinkedIn !== undefined) {
                localVarQueryParameter['unlinked_in'] = unlinkedIn;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} memberId
         * @param {string} [email]
         * @param {string} [phone]
         * @param {boolean} [primaryIn]
         * @param {boolean} [removedIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMemberEmergencyContacts: (memberId, email, phone, primaryIn, removedIn, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'memberId' is not null or undefined
            common_1.assertParamExists('listMemberEmergencyContacts', 'memberId', memberId);
            const localVarPath = `/v1/members/{member_id}/emergency-contacts`
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }
            if (phone !== undefined) {
                localVarQueryParameter['phone'] = phone;
            }
            if (primaryIn !== undefined) {
                localVarQueryParameter['primary_in'] = primaryIn;
            }
            if (removedIn !== undefined) {
                localVarQueryParameter['removed_in'] = removedIn;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMemberProblemHistory: (memberId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'memberId' is not null or undefined
            common_1.assertParamExists('listMemberProblemHistory', 'memberId', memberId);
            const localVarPath = `/v1/members/{member_id}/problems`
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [appointmentEndDatetime]
         * @param {string} [appointmentStartDatetime]
         * @param {string} [clinicId]
         * @param {string} [companyId]
         * @param {string} [memberId]
         * @param {string} [occupationalHealthRecordTypeId]
         * @param {boolean} [onlyClinics]
         * @param {boolean} [onlyIndividualAppointments]
         * @param {boolean} [orderByMostRecent]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMissingOccupationalHealthRecords: (appointmentEndDatetime, appointmentStartDatetime, clinicId, companyId, memberId, occupationalHealthRecordTypeId, onlyClinics, onlyIndividualAppointments, orderByMostRecent, page, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/occupational-health-records/missing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (appointmentEndDatetime !== undefined) {
                localVarQueryParameter['appointment_end_datetime'] = (appointmentEndDatetime instanceof Date) ?
                    appointmentEndDatetime.toISOString() :
                    appointmentEndDatetime;
            }
            if (appointmentStartDatetime !== undefined) {
                localVarQueryParameter['appointment_start_datetime'] = (appointmentStartDatetime instanceof Date) ?
                    appointmentStartDatetime.toISOString() :
                    appointmentStartDatetime;
            }
            if (clinicId !== undefined) {
                localVarQueryParameter['clinic_id'] = clinicId;
            }
            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }
            if (memberId !== undefined) {
                localVarQueryParameter['member_id'] = memberId;
            }
            if (occupationalHealthRecordTypeId !== undefined) {
                localVarQueryParameter['occupational_health_record_type_id'] = occupationalHealthRecordTypeId;
            }
            if (onlyClinics !== undefined) {
                localVarQueryParameter['only_clinics'] = onlyClinics;
            }
            if (onlyIndividualAppointments !== undefined) {
                localVarQueryParameter['only_individual_appointments'] = onlyIndividualAppointments;
            }
            if (orderByMostRecent !== undefined) {
                localVarQueryParameter['order_by_most_recent'] = orderByMostRecent;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOccupationalHealthRecordTypes: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/occupational-health-record-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [chartTypeId]
         * @param {string} [companyId]
         * @param {string} [completionEndDate]
         * @param {string} [completionStartDate]
         * @param {string} [dateOfCompletion]
         * @param {string} [encounterId]
         * @param {boolean} [enteredInErrorIn]
         * @param {string} [medicalFileId]
         * @param {string} [memberId]
         * @param {string} [occupationalHealthLabOrderRequestId]
         * @param {boolean} [orderByMostRecentlyCompleted]
         * @param {number} [page]
         * @param {boolean} [pendingApprovalIn]
         * @param {string} [urgentCareOrderRequestId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOccupationalHealthRecords: (chartTypeId, companyId, completionEndDate, completionStartDate, dateOfCompletion, encounterId, enteredInErrorIn, medicalFileId, memberId, occupationalHealthLabOrderRequestId, orderByMostRecentlyCompleted, page, pendingApprovalIn, urgentCareOrderRequestId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/occupational-health-records`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (chartTypeId !== undefined) {
                localVarQueryParameter['chart_type_id'] = chartTypeId;
            }
            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }
            if (completionEndDate !== undefined) {
                localVarQueryParameter['completion_end_date'] = (completionEndDate instanceof Date) ?
                    completionEndDate.toISOString().substr(0, 10) :
                    completionEndDate;
            }
            if (completionStartDate !== undefined) {
                localVarQueryParameter['completion_start_date'] = (completionStartDate instanceof Date) ?
                    completionStartDate.toISOString().substr(0, 10) :
                    completionStartDate;
            }
            if (dateOfCompletion !== undefined) {
                localVarQueryParameter['date_of_completion'] = (dateOfCompletion instanceof Date) ?
                    dateOfCompletion.toISOString().substr(0, 10) :
                    dateOfCompletion;
            }
            if (encounterId !== undefined) {
                localVarQueryParameter['encounter_id'] = encounterId;
            }
            if (enteredInErrorIn !== undefined) {
                localVarQueryParameter['entered_in_error_in'] = enteredInErrorIn;
            }
            if (medicalFileId !== undefined) {
                localVarQueryParameter['medical_file_id'] = medicalFileId;
            }
            if (memberId !== undefined) {
                localVarQueryParameter['member_id'] = memberId;
            }
            if (occupationalHealthLabOrderRequestId !== undefined) {
                localVarQueryParameter['occupational_health_lab_order_request_id'] = occupationalHealthLabOrderRequestId;
            }
            if (orderByMostRecentlyCompleted !== undefined) {
                localVarQueryParameter['order_by_most_recently_completed'] = orderByMostRecentlyCompleted;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (pendingApprovalIn !== undefined) {
                localVarQueryParameter['pending_approval_in'] = pendingApprovalIn;
            }
            if (urgentCareOrderRequestId !== undefined) {
                localVarQueryParameter['urgent_care_order_request_id'] = urgentCareOrderRequestId;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} companyId
         * @param {string} [approvedOnGte]
         * @param {string} [completedOnGte]
         * @param {boolean} [enteredInErrorIn]
         * @param {boolean} [includeTagsIn]
         * @param {number} [limit]
         * @param {string} [memberId]
         * @param {string} [memberName]
         * @param {string} [occupationalHealthLabOrderRequestId]
         * @param {string} [ohrTypeId]
         * @param {number} [page]
         * @param {Array<string>} [tagsIds]
         * @param {string} [urgentCareOrderRequestId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOccupationalHealthRecordsByCompany: (companyId, approvedOnGte, completedOnGte, enteredInErrorIn, includeTagsIn, limit, memberId, memberName, occupationalHealthLabOrderRequestId, ohrTypeId, page, tagsIds, urgentCareOrderRequestId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyId' is not null or undefined
            common_1.assertParamExists('listOccupationalHealthRecordsByCompany', 'companyId', companyId);
            const localVarPath = `/v1/companies/{company_id}/ohrs`
                .replace(`{${"company_id"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (approvedOnGte !== undefined) {
                localVarQueryParameter['approved_on_gte'] = (approvedOnGte instanceof Date) ?
                    approvedOnGte.toISOString().substr(0, 10) :
                    approvedOnGte;
            }
            if (completedOnGte !== undefined) {
                localVarQueryParameter['completed_on_gte'] = (completedOnGte instanceof Date) ?
                    completedOnGte.toISOString().substr(0, 10) :
                    completedOnGte;
            }
            if (enteredInErrorIn !== undefined) {
                localVarQueryParameter['entered_in_error_in'] = enteredInErrorIn;
            }
            if (includeTagsIn !== undefined) {
                localVarQueryParameter['include_tags_in'] = includeTagsIn;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (memberId !== undefined) {
                localVarQueryParameter['member_id'] = memberId;
            }
            if (memberName !== undefined) {
                localVarQueryParameter['member_name'] = memberName;
            }
            if (occupationalHealthLabOrderRequestId !== undefined) {
                localVarQueryParameter['occupational_health_lab_order_request_id'] = occupationalHealthLabOrderRequestId;
            }
            if (ohrTypeId !== undefined) {
                localVarQueryParameter['ohr_type_id'] = ohrTypeId;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (tagsIds) {
                localVarQueryParameter['tags_ids'] = tagsIds;
            }
            if (urgentCareOrderRequestId !== undefined) {
                localVarQueryParameter['urgent_care_order_request_id'] = urgentCareOrderRequestId;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} problemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProblemGoals: (problemId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'problemId' is not null or undefined
            common_1.assertParamExists('listProblemGoals', 'problemId', problemId);
            const localVarPath = `/v1/problems/{problem_id}/goals`
                .replace(`{${"problem_id"}}`, encodeURIComponent(String(problemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} medicalProfileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProcedures: (medicalProfileId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'medicalProfileId' is not null or undefined
            common_1.assertParamExists('listProcedures', 'medicalProfileId', medicalProfileId);
            const localVarPath = `/v1/medical-profiles/{medical_profile_id}/procedures`
                .replace(`{${"medical_profile_id"}}`, encodeURIComponent(String(medicalProfileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [appointmentId]
         * @param {string} [encounterId]
         * @param {string} [memberId]
         * @param {number} [page]
         * @param {string} [providerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRxOrders: (appointmentId, encounterId, memberId, page, providerId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/rx-orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (appointmentId !== undefined) {
                localVarQueryParameter['appointment_id'] = appointmentId;
            }
            if (encounterId !== undefined) {
                localVarQueryParameter['encounter_id'] = encounterId;
            }
            if (memberId !== undefined) {
                localVarQueryParameter['member_id'] = memberId;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (providerId !== undefined) {
                localVarQueryParameter['provider_id'] = providerId;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ListSchedulableMedicalServicesRequest} listSchedulableMedicalServicesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSchedulableMedicalServices: (listSchedulableMedicalServicesRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'listSchedulableMedicalServicesRequest' is not null or undefined
            common_1.assertParamExists('listSchedulableMedicalServices', 'listSchedulableMedicalServicesRequest', listSchedulableMedicalServicesRequest);
            const localVarPath = `/v1/medical-services/schedulable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(listSchedulableMedicalServicesRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [visitReasonId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSymptoms: (visitReasonId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/symptoms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (visitReasonId !== undefined) {
                localVarQueryParameter['visit_reason_id'] = visitReasonId;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {MarkManualLabResultEnteredInErrorRequest} markManualLabResultEnteredInErrorRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markManualLabResultEnteredInError: (markManualLabResultEnteredInErrorRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'markManualLabResultEnteredInErrorRequest' is not null or undefined
            common_1.assertParamExists('markManualLabResultEnteredInError', 'markManualLabResultEnteredInErrorRequest', markManualLabResultEnteredInErrorRequest);
            const localVarPath = `/v1/manual-lab-results/enter-in-error`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(markManualLabResultEnteredInErrorRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} occupationalHealthRecordId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markOccupationalHealthRecordEnteredInError: (occupationalHealthRecordId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'occupationalHealthRecordId' is not null or undefined
            common_1.assertParamExists('markOccupationalHealthRecordEnteredInError', 'occupationalHealthRecordId', occupationalHealthRecordId);
            const localVarPath = `/v1/occupational-health-records/{occupational_health_record_id}/enter-in-error`
                .replace(`{${"occupational_health_record_id"}}`, encodeURIComponent(String(occupationalHealthRecordId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} dynamicMedicalChartId
         * @param {PublishDynamicMedicalChartRequest} [publishDynamicMedicalChartRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishDynamicMedicalChart: (dynamicMedicalChartId, publishDynamicMedicalChartRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'dynamicMedicalChartId' is not null or undefined
            common_1.assertParamExists('publishDynamicMedicalChart', 'dynamicMedicalChartId', dynamicMedicalChartId);
            const localVarPath = `/v1/dynamic-medical-charts/{dynamic_medical_chart_id}/publish`
                .replace(`{${"dynamic_medical_chart_id"}}`, encodeURIComponent(String(dynamicMedicalChartId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(publishDynamicMedicalChartRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} labOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishLabOrder: (labOrderId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'labOrderId' is not null or undefined
            common_1.assertParamExists('publishLabOrder', 'labOrderId', labOrderId);
            const localVarPath = `/v1/lab-orders/{lab_order_id}/publish`
                .replace(`{${"lab_order_id"}}`, encodeURIComponent(String(labOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} medicalFileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishMedicalFile: (medicalFileId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'medicalFileId' is not null or undefined
            common_1.assertParamExists('publishMedicalFile', 'medicalFileId', medicalFileId);
            const localVarPath = `/v1/medical-files/{medical_file_id}/publish`
                .replace(`{${"medical_file_id"}}`, encodeURIComponent(String(medicalFileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} dynamicMedicalChartId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redactDynamicMedicalChart: (dynamicMedicalChartId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'dynamicMedicalChartId' is not null or undefined
            common_1.assertParamExists('redactDynamicMedicalChart', 'dynamicMedicalChartId', dynamicMedicalChartId);
            const localVarPath = `/v1/dynamic-medical-charts/{dynamic_medical_chart_id}/redact`
                .replace(`{${"dynamic_medical_chart_id"}}`, encodeURIComponent(String(dynamicMedicalChartId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} interactionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redactInteraction: (interactionId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'interactionId' is not null or undefined
            common_1.assertParamExists('redactInteraction', 'interactionId', interactionId);
            const localVarPath = `/v1/interactions/{interaction_id}/redact`
                .replace(`{${"interaction_id"}}`, encodeURIComponent(String(interactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} medicalChartFieldId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redactMedicalChartField: (medicalChartFieldId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'medicalChartFieldId' is not null or undefined
            common_1.assertParamExists('redactMedicalChartField', 'medicalChartFieldId', medicalChartFieldId);
            const localVarPath = `/v1/medical-chart-fields/{medical_chart_field_id}/redact`
                .replace(`{${"medical_chart_field_id"}}`, encodeURIComponent(String(medicalChartFieldId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} labOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeLabDrawFromLabOrder: (labOrderId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'labOrderId' is not null or undefined
            common_1.assertParamExists('removeLabDrawFromLabOrder', 'labOrderId', labOrderId);
            const localVarPath = `/v1/lab-orders/{lab_order_id}/remove-lab-draw`
                .replace(`{${"lab_order_id"}}`, encodeURIComponent(String(labOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} term
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAllergies: (term, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'term' is not null or undefined
            common_1.assertParamExists('searchAllergies', 'term', term);
            const localVarPath = `/v1/encyclopedia/allergies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} term
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchConditions: (term, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'term' is not null or undefined
            common_1.assertParamExists('searchConditions', 'term', term);
            const localVarPath = `/v1/encyclopedia/conditions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} term
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchIcd10Terms: (term, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'term' is not null or undefined
            common_1.assertParamExists('searchIcd10Terms', 'term', term);
            const localVarPath = `/v1/encyclopedia/icd10-terms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} term
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchMedications: (term, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'term' is not null or undefined
            common_1.assertParamExists('searchMedications', 'term', term);
            const localVarPath = `/v1/encyclopedia/medications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {'Provider' | 'Member'} responseType * &#x60;Provider&#x60; - Provider * &#x60;Member&#x60; - Member
         * @param {string} term
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProcedures: (responseType, term, limit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'responseType' is not null or undefined
            common_1.assertParamExists('searchProcedures', 'responseType', responseType);
            // verify required parameter 'term' is not null or undefined
            common_1.assertParamExists('searchProcedures', 'term', term);
            const localVarPath = `/v1/encyclopedia/procedures`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (responseType !== undefined) {
                localVarQueryParameter['response_type'] = responseType;
            }
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} codeId
         * @param {string} medicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlinkMedicationCode: (codeId, medicationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'codeId' is not null or undefined
            common_1.assertParamExists('unlinkMedicationCode', 'codeId', codeId);
            // verify required parameter 'medicationId' is not null or undefined
            common_1.assertParamExists('unlinkMedicationCode', 'medicationId', medicationId);
            const localVarPath = `/v1/medications/{medication_id}/codes/{code_id}`
                .replace(`{${"code_id"}}`, encodeURIComponent(String(codeId)))
                .replace(`{${"medication_id"}}`, encodeURIComponent(String(medicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} medicationId
         * @param {string} problemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlinkMedicationProblem: (medicationId, problemId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'medicationId' is not null or undefined
            common_1.assertParamExists('unlinkMedicationProblem', 'medicationId', medicationId);
            // verify required parameter 'problemId' is not null or undefined
            common_1.assertParamExists('unlinkMedicationProblem', 'problemId', problemId);
            const localVarPath = `/v1/medications/{medication_id}/problems/{problem_id}`
                .replace(`{${"medication_id"}}`, encodeURIComponent(String(medicationId)))
                .replace(`{${"problem_id"}}`, encodeURIComponent(String(problemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} allergyId
         * @param {UpdateAllergyRequest} [updateAllergyRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAllergy: (allergyId, updateAllergyRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'allergyId' is not null or undefined
            common_1.assertParamExists('updateAllergy', 'allergyId', allergyId);
            const localVarPath = `/v1/allergies/{allergy_id}`
                .replace(`{${"allergy_id"}}`, encodeURIComponent(String(allergyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateAllergyRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} problemId
         * @param {UpdateProblemRequest} [updateProblemRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCarePlanProblem: (problemId, updateProblemRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'problemId' is not null or undefined
            common_1.assertParamExists('updateCarePlanProblem', 'problemId', problemId);
            const localVarPath = `/v1/care-plans/problems/{problem_id}`
                .replace(`{${"problem_id"}}`, encodeURIComponent(String(problemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateProblemRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} chartingMacroId
         * @param {UpdateChartingMacroRequest} [updateChartingMacroRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateChartingMacro: (chartingMacroId, updateChartingMacroRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'chartingMacroId' is not null or undefined
            common_1.assertParamExists('updateChartingMacro', 'chartingMacroId', chartingMacroId);
            const localVarPath = `/v1/charting-macros/{charting_macro_id}`
                .replace(`{${"charting_macro_id"}}`, encodeURIComponent(String(chartingMacroId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateChartingMacroRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} dynamicMedicalChartId
         * @param {UpdateDynamicMedicalChartRequest} updateDynamicMedicalChartRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDynamicMedicalChart: (dynamicMedicalChartId, updateDynamicMedicalChartRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'dynamicMedicalChartId' is not null or undefined
            common_1.assertParamExists('updateDynamicMedicalChart', 'dynamicMedicalChartId', dynamicMedicalChartId);
            // verify required parameter 'updateDynamicMedicalChartRequest' is not null or undefined
            common_1.assertParamExists('updateDynamicMedicalChart', 'updateDynamicMedicalChartRequest', updateDynamicMedicalChartRequest);
            const localVarPath = `/v1/dynamic-medical-charts/{dynamic_medical_chart_id}`
                .replace(`{${"dynamic_medical_chart_id"}}`, encodeURIComponent(String(dynamicMedicalChartId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateDynamicMedicalChartRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} dynamicMedicalChartId
         * @param {string} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDynamicMedicalChartResultsFile: (dynamicMedicalChartId, file, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'dynamicMedicalChartId' is not null or undefined
            common_1.assertParamExists('updateDynamicMedicalChartResultsFile', 'dynamicMedicalChartId', dynamicMedicalChartId);
            // verify required parameter 'file' is not null or undefined
            common_1.assertParamExists('updateDynamicMedicalChartResultsFile', 'file', file);
            const localVarPath = `/v1/dynamic-medical-charts/{dynamic_medical_chart_id}/results-file`
                .replace(`{${"dynamic_medical_chart_id"}}`, encodeURIComponent(String(dynamicMedicalChartId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} contactId
         * @param {UpdateEmergencyContactRequest} [updateEmergencyContactRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmergencyContact: (contactId, updateEmergencyContactRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'contactId' is not null or undefined
            common_1.assertParamExists('updateEmergencyContact', 'contactId', contactId);
            const localVarPath = `/v1/emergency-contacts/{contact_id}`
                .replace(`{${"contact_id"}}`, encodeURIComponent(String(contactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateEmergencyContactRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} familyMedicalHistoryId
         * @param {UpdateFamilyMedicalHistoryRequest} updateFamilyMedicalHistoryRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFamilyMedicalHistory: (familyMedicalHistoryId, updateFamilyMedicalHistoryRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'familyMedicalHistoryId' is not null or undefined
            common_1.assertParamExists('updateFamilyMedicalHistory', 'familyMedicalHistoryId', familyMedicalHistoryId);
            // verify required parameter 'updateFamilyMedicalHistoryRequest' is not null or undefined
            common_1.assertParamExists('updateFamilyMedicalHistory', 'updateFamilyMedicalHistoryRequest', updateFamilyMedicalHistoryRequest);
            const localVarPath = `/v1/family-medical-history/{family_medical_history_id}`
                .replace(`{${"family_medical_history_id"}}`, encodeURIComponent(String(familyMedicalHistoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateFamilyMedicalHistoryRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} problemId
         * @param {UpdateProblemRequest} [updateProblemRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFamilyMedicalHistoryProblem: (problemId, updateProblemRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'problemId' is not null or undefined
            common_1.assertParamExists('updateFamilyMedicalHistoryProblem', 'problemId', problemId);
            const localVarPath = `/v1/family-medical-history/problems/{problem_id}`
                .replace(`{${"problem_id"}}`, encodeURIComponent(String(problemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateProblemRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} goalId
         * @param {string} problemId
         * @param {string} targetId
         * @param {UpdateProblemGoalTargetRequest} [updateProblemGoalTargetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGoalTarget: (goalId, problemId, targetId, updateProblemGoalTargetRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'goalId' is not null or undefined
            common_1.assertParamExists('updateGoalTarget', 'goalId', goalId);
            // verify required parameter 'problemId' is not null or undefined
            common_1.assertParamExists('updateGoalTarget', 'problemId', problemId);
            // verify required parameter 'targetId' is not null or undefined
            common_1.assertParamExists('updateGoalTarget', 'targetId', targetId);
            const localVarPath = `/v1/problems/{problem_id}/goals/{goal_id}/targets/{target_id}`
                .replace(`{${"goal_id"}}`, encodeURIComponent(String(goalId)))
                .replace(`{${"problem_id"}}`, encodeURIComponent(String(problemId)))
                .replace(`{${"target_id"}}`, encodeURIComponent(String(targetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateProblemGoalTargetRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} labOrderId
         * @param {UpdateLabOrderRequest} [updateLabOrderRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLabOrder: (labOrderId, updateLabOrderRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'labOrderId' is not null or undefined
            common_1.assertParamExists('updateLabOrder', 'labOrderId', labOrderId);
            const localVarPath = `/v1/lab-orders/{lab_order_id}`
                .replace(`{${"lab_order_id"}}`, encodeURIComponent(String(labOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateLabOrderRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} manualLabResultId
         * @param {UpdateManualLabResultRequest} [updateManualLabResultRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateManualLabResult: (manualLabResultId, updateManualLabResultRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'manualLabResultId' is not null or undefined
            common_1.assertParamExists('updateManualLabResult', 'manualLabResultId', manualLabResultId);
            const localVarPath = `/v1/manual-lab-results/{manual_lab_result_id}`
                .replace(`{${"manual_lab_result_id"}}`, encodeURIComponent(String(manualLabResultId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateManualLabResultRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} memberId
         * @param {UpdateMedicalProfileRequest} [updateMedicalProfileRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMedicalProfile: (memberId, updateMedicalProfileRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'memberId' is not null or undefined
            common_1.assertParamExists('updateMedicalProfile', 'memberId', memberId);
            const localVarPath = `/v1/members/{member_id}/medical-profile`
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateMedicalProfileRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} medicationId
         * @param {UpdateMedicationRequest} [updateMedicationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMedication: (medicationId, updateMedicationRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'medicationId' is not null or undefined
            common_1.assertParamExists('updateMedication', 'medicationId', medicationId);
            const localVarPath = `/v1/medications/{medication_id}`
                .replace(`{${"medication_id"}}`, encodeURIComponent(String(medicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateMedicationRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} memberId
         * @param {UpdatePreferredPharmacyRequest} updatePreferredPharmacyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePreferredPharmacyForMember: (memberId, updatePreferredPharmacyRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'memberId' is not null or undefined
            common_1.assertParamExists('updatePreferredPharmacyForMember', 'memberId', memberId);
            // verify required parameter 'updatePreferredPharmacyRequest' is not null or undefined
            common_1.assertParamExists('updatePreferredPharmacyForMember', 'updatePreferredPharmacyRequest', updatePreferredPharmacyRequest);
            const localVarPath = `/v1/members/{member_id}/preferred-pharmacy`
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updatePreferredPharmacyRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} goalId
         * @param {string} problemId
         * @param {UpdateProblemGoalRequest} updateProblemGoalRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProblemGoal: (goalId, problemId, updateProblemGoalRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'goalId' is not null or undefined
            common_1.assertParamExists('updateProblemGoal', 'goalId', goalId);
            // verify required parameter 'problemId' is not null or undefined
            common_1.assertParamExists('updateProblemGoal', 'problemId', problemId);
            // verify required parameter 'updateProblemGoalRequest' is not null or undefined
            common_1.assertParamExists('updateProblemGoal', 'updateProblemGoalRequest', updateProblemGoalRequest);
            const localVarPath = `/v1/problems/{problem_id}/goals/{goal_id}`
                .replace(`{${"goal_id"}}`, encodeURIComponent(String(goalId)))
                .replace(`{${"problem_id"}}`, encodeURIComponent(String(problemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateProblemGoalRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} procedureId
         * @param {UpdateProcedureRequest} [updateProcedureRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcedure: (procedureId, updateProcedureRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'procedureId' is not null or undefined
            common_1.assertParamExists('updateProcedure', 'procedureId', procedureId);
            const localVarPath = `/v1/procedures/{procedure_id}`
                .replace(`{${"procedure_id"}}`, encodeURIComponent(String(procedureId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateProcedureRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} vitalsRecordId
         * @param {UpdateVitalsRecordRequest} [updateVitalsRecordRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVitalsRecord: (vitalsRecordId, updateVitalsRecordRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'vitalsRecordId' is not null or undefined
            common_1.assertParamExists('updateVitalsRecord', 'vitalsRecordId', vitalsRecordId);
            const localVarPath = `/v1/vitals/{vitals_record_id}`
                .replace(`{${"vitals_record_id"}}`, encodeURIComponent(String(vitalsRecordId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateVitalsRecordRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} dynamicMedicalChartId
         * @param {string} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDynamicMedicalChartAdditionalFile: (dynamicMedicalChartId, file, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'dynamicMedicalChartId' is not null or undefined
            common_1.assertParamExists('uploadDynamicMedicalChartAdditionalFile', 'dynamicMedicalChartId', dynamicMedicalChartId);
            // verify required parameter 'file' is not null or undefined
            common_1.assertParamExists('uploadDynamicMedicalChartAdditionalFile', 'file', file);
            const localVarPath = `/v1/dynamic-medical-charts/{dynamic_medical_chart_id}/additional-files`
                .replace(`{${"dynamic_medical_chart_id"}}`, encodeURIComponent(String(dynamicMedicalChartId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} memberId
         * @param {string} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadMedicalProfileFile: (memberId, file, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'memberId' is not null or undefined
            common_1.assertParamExists('uploadMedicalProfileFile', 'memberId', memberId);
            // verify required parameter 'file' is not null or undefined
            common_1.assertParamExists('uploadMedicalProfileFile', 'file', file);
            const localVarPath = `/v1/members/{member_id}/medical-profile/files`
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * MedicalApi - functional programming interface
 * @export
 */
exports.MedicalApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.MedicalApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {AddLabDrawToLabOrdersRequest} addLabDrawToLabOrdersRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addLabDrawToLabOrders(addLabDrawToLabOrdersRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addLabDrawToLabOrders(addLabDrawToLabOrdersRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} allergyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assertAllergy(allergyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.assertAllergy(allergyId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} problemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assertCarePlanProblem(problemId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.assertCarePlanProblem(problemId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} problemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assertFamilyMedicalHistoryProblem(problemId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.assertFamilyMedicalHistoryProblem(problemId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} medicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assertMedication(medicationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.assertMedication(medicationId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} procedureId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assertProcedure(procedureId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.assertProcedure(procedureId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {AssignManualLabResultRequest} assignManualLabResultRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignManualLabResult(assignManualLabResultRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.assignManualLabResult(assignManualLabResultRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} occupationalHealthRecordId
         * @param {AuthorizePendingOccupationalHealthRecordRequest} authorizePendingOccupationalHealthRecordRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizePendingOccupationalHealthRecord(occupationalHealthRecordId, authorizePendingOccupationalHealthRecordRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.authorizePendingOccupationalHealthRecord(occupationalHealthRecordId, authorizePendingOccupationalHealthRecordRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} dynamicMedicalChartId
         * @param {BlockDynamicMedicalChartRequest} [blockDynamicMedicalChartRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockDynamicMedicalChart(dynamicMedicalChartId, blockDynamicMedicalChartRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.blockDynamicMedicalChart(dynamicMedicalChartId, blockDynamicMedicalChartRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} labOrderId
         * @param {CancelLabOrderRequest} cancelLabOrderRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelLabOrder(labOrderId, cancelLabOrderRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cancelLabOrder(labOrderId, cancelLabOrderRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} encounterId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkIfUserCanPerformChartingForEncounter(encounterId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.checkIfUserCanPerformChartingForEncounter(encounterId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} fileName
         * @param {string} file
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdministrativeFile(fileName, file, memberId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createAdministrativeFile(fileName, file, memberId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} carePlanId
         * @param {CreateAllergyRequest} createAllergyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAllergy(carePlanId, createAllergyRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createAllergy(carePlanId, createAllergyRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {CreateChartingMacroRequest} createChartingMacroRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createChartingMacro(createChartingMacroRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createChartingMacro(createChartingMacroRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {CreateDynamicMedicalChartRequest} createDynamicMedicalChartRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDynamicMedicalChart(createDynamicMedicalChartRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createDynamicMedicalChart(createDynamicMedicalChartRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} medicalProfileId
         * @param {CreateFamilyMedicalHistoryRequest} createFamilyMedicalHistoryRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFamilyMedicalHistory(medicalProfileId, createFamilyMedicalHistoryRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createFamilyMedicalHistory(medicalProfileId, createFamilyMedicalHistoryRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} goalId
         * @param {string} problemId
         * @param {CreateProblemGoalTargetRequest} createProblemGoalTargetRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGoalTarget(goalId, problemId, createProblemGoalTargetRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createGoalTarget(goalId, problemId, createProblemGoalTargetRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {CreateInteractionRequest} createInteractionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInteraction(createInteractionRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createInteraction(createInteractionRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {CreateLabOrdersCallbackRequest} createLabOrdersCallbackRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLabOrders(createLabOrdersCallbackRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createLabOrders(createLabOrdersCallbackRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {CreateMedicalRecordReleaseConsentRequest} createMedicalRecordReleaseConsentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMedicalRecordReleaseConsent(createMedicalRecordReleaseConsentRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createMedicalRecordReleaseConsent(createMedicalRecordReleaseConsentRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {CreateMedicationRequest} createMedicationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMedication(createMedicationRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createMedication(createMedicationRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} memberId
         * @param {CreateMemberEmergencyContactRequest} createMemberEmergencyContactRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMemberEmergencyContact(memberId, createMemberEmergencyContactRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createMemberEmergencyContact(memberId, createMemberEmergencyContactRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} recordTypeId
         * @param {string} memberId
         * @param {string} companyId
         * @param {string} dateOfCompletion
         * @param {boolean} performedAtVitableIn
         * @param {string} [file]
         * @param {string} [chartId]
         * @param {string} [medicalFileId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOccupationalHealthRecord(recordTypeId, memberId, companyId, dateOfCompletion, performedAtVitableIn, file, chartId, medicalFileId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createOccupationalHealthRecord(recordTypeId, memberId, companyId, dateOfCompletion, performedAtVitableIn, file, chartId, medicalFileId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} carePlanId
         * @param {CreateProblemRequest} createProblemRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProblemForCarePlan(carePlanId, createProblemRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createProblemForCarePlan(carePlanId, createProblemRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} familyMedicalHistoryId
         * @param {CreateProblemRequest} createProblemRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProblemForFamilyMedicalHistory(familyMedicalHistoryId, createProblemRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createProblemForFamilyMedicalHistory(familyMedicalHistoryId, createProblemRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} problemId
         * @param {CreateProblemGoalRequest} createProblemGoalRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProblemGoal(problemId, createProblemGoalRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createProblemGoal(problemId, createProblemGoalRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} medicalProfileId
         * @param {CreateProcedureRequest} createProcedureRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProcedure(medicalProfileId, createProcedureRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createProcedure(medicalProfileId, createProcedureRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {RxOrderCallBackRequest} [rxOrderCallBackRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRxOrder(rxOrderCallBackRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createRxOrder(rxOrderCallBackRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {CreateVitalsRecordRequest} createVitalsRecordRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVitalsRecord(createVitalsRecordRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createVitalsRecord(createVitalsRecordRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} chartingMacroId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteChartingMacro(chartingMacroId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteChartingMacro(chartingMacroId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} dynamicMedicalChartId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDynamicMedicalChart(dynamicMedicalChartId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteDynamicMedicalChart(dynamicMedicalChartId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} dynamicMedicalChartId
         * @param {string} fileFieldId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDynamicMedicalChartAdditionalFile(dynamicMedicalChartId, fileFieldId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteDynamicMedicalChartAdditionalFile(dynamicMedicalChartId, fileFieldId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} contactId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmergencyContact(contactId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteEmergencyContact(contactId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} medicalProfileFileId
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMedicalProfileFile(medicalProfileFileId, memberId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteMedicalProfileFile(medicalProfileFileId, memberId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} dynamicMedicalChartId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateDynamicMedicalChartResultsFile(dynamicMedicalChartId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.generateDynamicMedicalChartResultsFile(dynamicMedicalChartId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} administrativeFileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdministrativeFile(administrativeFileId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAdministrativeFile(administrativeFileId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} carePlanId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCarePlan(carePlanId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCarePlan(carePlanId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} codeableConceptsId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCodeableConcept(codeableConceptsId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCodeableConcept(codeableConceptsId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} contactId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmergencyContact(contactId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEmergencyContact(contactId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} goalId
         * @param {string} problemId
         * @param {string} targetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGoalTarget(goalId, problemId, targetId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getGoalTarget(goalId, problemId, targetId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} labOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLabOrder(labOrderId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getLabOrder(labOrderId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {GetLabOrderIframeUrlRequest} getLabOrderIframeUrlRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLabOrderIframeUrl(getLabOrderIframeUrlRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getLabOrderIframeUrl(getLabOrderIframeUrlRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} manualLabResultId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManualLabResult(manualLabResultId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getManualLabResult(manualLabResultId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} medicalFileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMedicalFile(medicalFileId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMedicalFile(medicalFileId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMedicalProfile(memberId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMedicalProfile(memberId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} medicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMedication(medicationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMedication(medicationId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberCarePlan(memberId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMemberCarePlan(memberId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} memberId
         * @param {string} problemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberProblem(memberId, problemId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMemberProblem(memberId, problemId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} occupationalHealthRecordId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOccupationalHealthRecord(occupationalHealthRecordId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getOccupationalHealthRecord(occupationalHealthRecordId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {GetOrCreateCodeableConceptRequest} getOrCreateCodeableConceptRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrCreateCodeableConcept(getOrCreateCodeableConceptRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getOrCreateCodeableConcept(getOrCreateCodeableConceptRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreferredPharmacyForMember(memberId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPreferredPharmacyForMember(memberId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} problemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProblem(problemId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProblem(problemId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} vitalsRecordId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVitalsRecord(vitalsRecordId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getVitalsRecord(vitalsRecordId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} codeId
         * @param {string} medicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkMedicationCode(codeId, medicationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.linkMedicationCode(codeId, medicationId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} medicationId
         * @param {string} problemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkMedicationProblem(medicationId, problemId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.linkMedicationProblem(medicationId, problemId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} memberId
         * @param {boolean} [enteredInErrorIn]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAdministrativeFiles(memberId, enteredInErrorIn, page, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listAdministrativeFiles(memberId, enteredInErrorIn, page, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} carePlanId
         * @param {boolean} [includeEnteredInErrorIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllergies(carePlanId, includeEnteredInErrorIn, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listAllergies(carePlanId, includeEnteredInErrorIn, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} carePlanId
         * @param {string} [encounterId]
         * @param {string} [familyMedicalHistoryId]
         * @param {boolean} [includeEnteredInErrorIn]
         * @param {string} [medicationId]
         * @param {string} [taskId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCarePlanProblems(carePlanId, encounterId, familyMedicalHistoryId, includeEnteredInErrorIn, medicationId, taskId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listCarePlanProblems(carePlanId, encounterId, familyMedicalHistoryId, includeEnteredInErrorIn, medicationId, taskId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {boolean} [ownedByVitableIn]
         * @param {number} [page]
         * @param {string} [providerId]
         * @param {string} [title]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listChartingMacros(ownedByVitableIn, page, providerId, title, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listChartingMacros(ownedByVitableIn, page, providerId, title, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} [carePlanId]
         * @param {string} [creatorId]
         * @param {boolean} [enteredInErrorIn]
         * @param {string} [noteContents]
         * @param {string} [orderByLinkedTaskId]
         * @param {number} [page]
         * @param {string} [taskId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listClinicalNotes(carePlanId, creatorId, enteredInErrorIn, noteContents, orderByLinkedTaskId, page, taskId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listClinicalNotes(carePlanId, creatorId, enteredInErrorIn, noteContents, orderByLinkedTaskId, page, taskId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} companyId
         * @param {string} ohrTypeId
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompanyMembersWithMissingOccupationalHealthRecord(companyId, ohrTypeId, page, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listCompanyMembersWithMissingOccupationalHealthRecord(companyId, ohrTypeId, page, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} [appointmentDateEnd]
         * @param {string} [appointmentDateStart]
         * @param {string} [appointmentId]
         * @param {'AL' | 'AK' | 'AZ' | 'AR' | 'CA' | 'CO' | 'CT' | 'DC' | 'DE' | 'FL' | 'GA' | 'HI' | 'ID' | 'IL' | 'IN' | 'IA' | 'KS' | 'KY' | 'LA' | 'ME' | 'MD' | 'MA' | 'MI' | 'MN' | 'MS' | 'MO' | 'MT' | 'NE' | 'NV' | 'NH' | 'NJ' | 'NM' | 'NY' | 'NC' | 'ND' | 'OH' | 'OK' | 'OR' | 'PR' | 'PA' | 'RI' | 'SC' | 'SD' | 'TN' | 'TX' | 'UT' | 'VT' | 'VI' | 'VA' | 'WA' | 'WI' | 'WV' | 'WY' | 'AA' | 'AE' | 'PW' | 'AP' | 'FM' | 'MH' | 'GU'} [appointmentState] * &#x60;AL&#x60; - AL * &#x60;AK&#x60; - AK * &#x60;AZ&#x60; - AZ * &#x60;AR&#x60; - AR * &#x60;CA&#x60; - CA * &#x60;CO&#x60; - CO * &#x60;CT&#x60; - CT * &#x60;DC&#x60; - DC * &#x60;DE&#x60; - DE * &#x60;FL&#x60; - FL * &#x60;GA&#x60; - GA * &#x60;HI&#x60; - HI * &#x60;ID&#x60; - ID * &#x60;IL&#x60; - IL * &#x60;IN&#x60; - IN * &#x60;IA&#x60; - IA * &#x60;KS&#x60; - KS * &#x60;KY&#x60; - KY * &#x60;LA&#x60; - LA * &#x60;ME&#x60; - ME * &#x60;MD&#x60; - MD * &#x60;MA&#x60; - MA * &#x60;MI&#x60; - MI * &#x60;MN&#x60; - MN * &#x60;MS&#x60; - MS * &#x60;MO&#x60; - MO * &#x60;MT&#x60; - MT * &#x60;NE&#x60; - NE * &#x60;NV&#x60; - NV * &#x60;NH&#x60; - NH * &#x60;NJ&#x60; - NJ * &#x60;NM&#x60; - NM * &#x60;NY&#x60; - NY * &#x60;NC&#x60; - NC * &#x60;ND&#x60; - ND * &#x60;OH&#x60; - OH * &#x60;OK&#x60; - OK * &#x60;OR&#x60; - OR * &#x60;PR&#x60; - PR * &#x60;PA&#x60; - PA * &#x60;RI&#x60; - RI * &#x60;SC&#x60; - SC * &#x60;SD&#x60; - SD * &#x60;TN&#x60; - TN * &#x60;TX&#x60; - TX * &#x60;UT&#x60; - UT * &#x60;VT&#x60; - VT * &#x60;VI&#x60; - VI * &#x60;VA&#x60; - VA * &#x60;WA&#x60; - WA * &#x60;WI&#x60; - WI * &#x60;WV&#x60; - WV * &#x60;WY&#x60; - WY * &#x60;AA&#x60; - AA * &#x60;AE&#x60; - AE * &#x60;PW&#x60; - PW * &#x60;AP&#x60; - AP * &#x60;FM&#x60; - FM * &#x60;MH&#x60; - MH * &#x60;GU&#x60; - GU
         * @param {boolean} [blockedIn]
         * @param {'History of Present Illness' | 'Physical Exam' | 'Clinical Reasoning' | 'Medical Forms' | 'Additional Files' | 'SOAP' | 'Visit Summary'} [chartType] * &#x60;History of Present Illness&#x60; - Hpi * &#x60;Physical Exam&#x60; - Pe * &#x60;Clinical Reasoning&#x60; - Clinical Reasoning * &#x60;Medical Forms&#x60; - Medical Forms * &#x60;Additional Files&#x60; - Additional Files * &#x60;SOAP&#x60; - Soap * &#x60;Visit Summary&#x60; - Visit Summary
         * @param {string} [clinicId]
         * @param {string} [companyId]
         * @param {boolean} [hasResultsFile]
         * @param {string} [medicalServiceId]
         * @param {string} [memberId]
         * @param {number} [orderByOverdue]
         * @param {boolean} [overdueIn]
         * @param {number} [page]
         * @param {string} [providerId]
         * @param {boolean} [publishedIn]
         * @param {string} [templateId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDynamicMedicalCharts(appointmentDateEnd, appointmentDateStart, appointmentId, appointmentState, blockedIn, chartType, clinicId, companyId, hasResultsFile, medicalServiceId, memberId, orderByOverdue, overdueIn, page, providerId, publishedIn, templateId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listDynamicMedicalCharts(appointmentDateEnd, appointmentDateStart, appointmentId, appointmentState, blockedIn, chartType, clinicId, companyId, hasResultsFile, medicalServiceId, memberId, orderByOverdue, overdueIn, page, providerId, publishedIn, templateId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} encounterId
         * @param {'History of Present Illness' | 'Physical Exam' | 'Clinical Reasoning' | 'Medical Forms' | 'Additional Files' | 'SOAP' | 'Visit Summary'} [chartType] * &#x60;History of Present Illness&#x60; - Hpi * &#x60;Physical Exam&#x60; - Pe * &#x60;Clinical Reasoning&#x60; - Clinical Reasoning * &#x60;Medical Forms&#x60; - Medical Forms * &#x60;Additional Files&#x60; - Additional Files * &#x60;SOAP&#x60; - Soap * &#x60;Visit Summary&#x60; - Visit Summary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDynamicMedicalChartsByEncounter(encounterId, chartType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listDynamicMedicalChartsByEncounter(encounterId, chartType, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} encounterId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEncounterProblems(encounterId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listEncounterProblems(encounterId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} numDays
         * @param {'Alabama' | 'Alaska' | 'Arizona' | 'Arkansas' | 'California' | 'Colorado' | 'Connecticut' | 'Washington D.C.' | 'Delaware' | 'Florida' | 'Georgia' | 'Hawaii' | 'Idaho' | 'Illinois' | 'Indiana' | 'Iowa' | 'Kansas' | 'Kentucky' | 'Louisiana' | 'Maine' | 'Maryland' | 'Massachusetts' | 'Michigan' | 'Minnesota' | 'Mississippi' | 'Missouri' | 'Montana' | 'Nebraska' | 'Nevada' | 'New Hampshire' | 'New Jersey' | 'New Mexico' | 'New York' | 'North Carolina' | 'North Dakota' | 'Ohio' | 'Oklahoma' | 'Oregon' | 'Pennsylvania' | 'Puerto Rico' | 'Rhode Island' | 'South Carolina' | 'South Dakota' | 'Tennessee' | 'Texas' | 'Utah' | 'Vermont' | 'Virgin Islands' | 'Virginia' | 'Washington' | 'Wisconsin' | 'West Virginia' | 'Wyoming' | 'AA' | 'AE' | 'PW' | 'AP' | 'FM' | 'MH' | 'GU'} state * &#x60;Alabama&#x60; - Al * &#x60;Alaska&#x60; - Ak * &#x60;Arizona&#x60; - Az * &#x60;Arkansas&#x60; - Ar * &#x60;California&#x60; - Ca * &#x60;Colorado&#x60; - Co * &#x60;Connecticut&#x60; - Ct * &#x60;Washington D.C.&#x60; - Dc * &#x60;Delaware&#x60; - De * &#x60;Florida&#x60; - Fl * &#x60;Georgia&#x60; - Ga * &#x60;Hawaii&#x60; - Hi * &#x60;Idaho&#x60; - Id * &#x60;Illinois&#x60; - Il * &#x60;Indiana&#x60; - In * &#x60;Iowa&#x60; - Ia * &#x60;Kansas&#x60; - Ks * &#x60;Kentucky&#x60; - Ky * &#x60;Louisiana&#x60; - La * &#x60;Maine&#x60; - Me * &#x60;Maryland&#x60; - Md * &#x60;Massachusetts&#x60; - Ma * &#x60;Michigan&#x60; - Mi * &#x60;Minnesota&#x60; - Mn * &#x60;Mississippi&#x60; - Ms * &#x60;Missouri&#x60; - Mo * &#x60;Montana&#x60; - Mt * &#x60;Nebraska&#x60; - Ne * &#x60;Nevada&#x60; - Nv * &#x60;New Hampshire&#x60; - Nh * &#x60;New Jersey&#x60; - Nj * &#x60;New Mexico&#x60; - Nm * &#x60;New York&#x60; - Ny * &#x60;North Carolina&#x60; - Nc * &#x60;North Dakota&#x60; - Nd * &#x60;Ohio&#x60; - Oh * &#x60;Oklahoma&#x60; - Ok * &#x60;Oregon&#x60; - Or * &#x60;Pennsylvania&#x60; - Pa * &#x60;Puerto Rico&#x60; - Pr * &#x60;Rhode Island&#x60; - Ri * &#x60;South Carolina&#x60; - Sc * &#x60;South Dakota&#x60; - Sd * &#x60;Tennessee&#x60; - Tn * &#x60;Texas&#x60; - Tx * &#x60;Utah&#x60; - Ut * &#x60;Vermont&#x60; - Vt * &#x60;Virgin Islands&#x60; - Vi * &#x60;Virginia&#x60; - Va * &#x60;Washington&#x60; - Wa * &#x60;Wisconsin&#x60; - Wi * &#x60;West Virginia&#x60; - Wv * &#x60;Wyoming&#x60; - Wy * &#x60;AA&#x60; - Aa * &#x60;AE&#x60; - Ae * &#x60;PW&#x60; - Pw * &#x60;AP&#x60; - Ap * &#x60;FM&#x60; - Fm * &#x60;MH&#x60; - Mh * &#x60;GU&#x60; - Gu
         * @param {string} [companyId]
         * @param {string} [ohrTypeId]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listExpiringOccupationalHealthRecords(numDays, state, companyId, ohrTypeId, page, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listExpiringOccupationalHealthRecords(numDays, state, companyId, ohrTypeId, page, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} medicalProfileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFamilyMedicalHistory(medicalProfileId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listFamilyMedicalHistory(medicalProfileId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} familyMedicalHistoryId
         * @param {boolean} [includeEnteredInErrorIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFamilyMedicalHistoryProblems(familyMedicalHistoryId, includeEnteredInErrorIn, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listFamilyMedicalHistoryProblems(familyMedicalHistoryId, includeEnteredInErrorIn, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} goalId
         * @param {string} problemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGoalTargets(goalId, problemId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listGoalTargets(goalId, problemId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} [authorId]
         * @param {'Patient' | 'Patient representative' | 'Internal' | 'None' | 'Other' | 'null'} [correspondentType] * &#x60;Patient&#x60; - Patient * &#x60;Patient representative&#x60; - Patient Representative * &#x60;Internal&#x60; - Internal * &#x60;None&#x60; - None * &#x60;Other&#x60; - Other
         * @param {'Phone' | 'Email' | 'SMS' | 'Chat' | 'Documentation' | 'null'} [interactionChannel] * &#x60;Phone&#x60; - Phone * &#x60;Email&#x60; - Email * &#x60;SMS&#x60; - Sms * &#x60;Chat&#x60; - Chat * &#x60;Documentation&#x60; - Documentation
         * @param {'Follow-up' | 'Prescription change' | 'Care coordination' | 'Admin note' | 'Lab order' | 'Lab review' | 'Other' | 'null'} [interactionType] * &#x60;Follow-up&#x60; - Follow Up * &#x60;Prescription change&#x60; - Prescription Change * &#x60;Care coordination&#x60; - Care Coordination * &#x60;Admin note&#x60; - Admin Note * &#x60;Lab order&#x60; - Lab Order * &#x60;Lab review&#x60; - Lab Review * &#x60;Other&#x60; - Other
         * @param {number} [limit]
         * @param {number} [page]
         * @param {string} [patientId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInteractions(authorId, correspondentType, interactionChannel, interactionType, limit, page, patientId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listInteractions(authorId, correspondentType, interactionChannel, interactionType, limit, page, patientId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} [createdEndDatetime]
         * @param {string} [createdStartDatetime]
         * @param {boolean} [hasAddedLabDraws]
         * @param {boolean} [hasReceivedResults]
         * @param {string} [labName]
         * @param {boolean} [labOrderConfirmationCompletedIn]
         * @param {'registered' | 'preliminary' | 'final' | 'amended' | 'corrected' | 'cancelled' | 'entered-in-error' | 'unknown'} [labTestStatus] * &#x60;registered&#x60; - registered * &#x60;preliminary&#x60; - preliminary * &#x60;final&#x60; - final * &#x60;amended&#x60; - amended * &#x60;corrected&#x60; - corrected * &#x60;cancelled&#x60; - cancelled * &#x60;entered-in-error&#x60; - entered-in-error * &#x60;unknown&#x60; - unknown
         * @param {string} [memberId]
         * @param {string} [orderingEncounterId]
         * @param {number} [page]
         * @param {'Needs Diagnostic Follow Up' | 'Diagnostic Follow Up Scheduled' | 'Diagnostic Follow Up Complete'} [postLabStatus] * &#x60;Needs Diagnostic Follow Up&#x60; - Needs Diagnostic Follow Up * &#x60;Diagnostic Follow Up Scheduled&#x60; - Diagnostic Follow Up Scheduled * &#x60;Diagnostic Follow Up Complete&#x60; - Diagnostic Follow Up Complete
         * @param {string} [providerId]
         * @param {string} [renderingEncounterId]
         * @param {'Cancelled' | 'Awaiting Results' | 'Needs Lab Draw' | 'Lab Draw Scheduled' | 'Results Received' | 'Completed' | 'Inconclusive'} [status] * &#x60;Cancelled&#x60; - Cancelled * &#x60;Awaiting Results&#x60; - Awaiting Results * &#x60;Needs Lab Draw&#x60; - Needs Lab Draw * &#x60;Lab Draw Scheduled&#x60; - Lab Draw Scheduled * &#x60;Results Received&#x60; - Results Received * &#x60;Completed&#x60; - Completed * &#x60;Inconclusive&#x60; - Inconclusive
         * @param {string} [testCodeableConceptId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLabOrders(createdEndDatetime, createdStartDatetime, hasAddedLabDraws, hasReceivedResults, labName, labOrderConfirmationCompletedIn, labTestStatus, memberId, orderingEncounterId, page, postLabStatus, providerId, renderingEncounterId, status, testCodeableConceptId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listLabOrders(createdEndDatetime, createdStartDatetime, hasAddedLabDraws, hasReceivedResults, labName, labOrderConfirmationCompletedIn, labTestStatus, memberId, orderingEncounterId, page, postLabStatus, providerId, renderingEncounterId, status, testCodeableConceptId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} [name]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLabTestCodeableConcepts(name, page, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listLabTestCodeableConcepts(name, page, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} [createdEndDatetime]
         * @param {string} [createdStartDatetime]
         * @param {boolean} [enteredInErrorIn]
         * @param {string} [labName]
         * @param {string} [labResultPatientName]
         * @param {number} [page]
         * @param {string} [patientId]
         * @param {boolean} [reviewedIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listManualLabResults(createdEndDatetime, createdStartDatetime, enteredInErrorIn, labName, labResultPatientName, page, patientId, reviewedIn, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listManualLabResults(createdEndDatetime, createdStartDatetime, enteredInErrorIn, labName, labResultPatientName, page, patientId, reviewedIn, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {'History of Present Illness' | 'Physical Exam' | 'Clinical Reasoning' | 'Medical Forms' | 'Additional Files' | 'SOAP' | 'Visit Summary'} [chartType] * &#x60;History of Present Illness&#x60; - Hpi * &#x60;Physical Exam&#x60; - Pe * &#x60;Clinical Reasoning&#x60; - Clinical Reasoning * &#x60;Medical Forms&#x60; - Medical Forms * &#x60;Additional Files&#x60; - Additional Files * &#x60;SOAP&#x60; - Soap * &#x60;Visit Summary&#x60; - Visit Summary
         * @param {string} [name]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMedicalChartTemplates(chartType, name, page, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listMedicalChartTemplates(chartType, name, page, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {'History of Present Illness' | 'Physical Exam' | 'Clinical Reasoning' | 'Medical Forms' | 'Additional Files' | 'SOAP' | 'Visit Summary'} chartType * &#x60;History of Present Illness&#x60; - Hpi * &#x60;Physical Exam&#x60; - Pe * &#x60;Clinical Reasoning&#x60; - Clinical Reasoning * &#x60;Medical Forms&#x60; - Medical Forms * &#x60;Additional Files&#x60; - Additional Files * &#x60;SOAP&#x60; - Soap * &#x60;Visit Summary&#x60; - Visit Summary
         * @param {string} encounterId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMedicalChartTemplatesForEncounter(chartType, encounterId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listMedicalChartTemplatesForEncounter(chartType, encounterId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} memberId
         * @param {string} [encounterId]
         * @param {number} [limit]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMedicalFilesForMember(memberId, encounterId, limit, page, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listMedicalFilesForMember(memberId, encounterId, limit, page, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} memberId
         * @param {number} [limit]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMedicalProfileFiles(memberId, limit, page, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listMedicalProfileFiles(memberId, limit, page, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} [memberId]
         * @param {string} [occupationalHealthLabOrderRequestId]
         * @param {string} [urgentCareOrderRequestId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMedicalRecordReleaseConsents(memberId, occupationalHealthLabOrderRequestId, urgentCareOrderRequestId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listMedicalRecordReleaseConsents(memberId, occupationalHealthLabOrderRequestId, urgentCareOrderRequestId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {boolean} [inHomePerformableIn]
         * @param {string} [medicalServiceId]
         * @param {string} [name]
         * @param {boolean} [onsiteClinicPerformableIn]
         * @param {boolean} [schedulableByMemberIn]
         * @param {boolean} [telemedicinePerformableIn]
         * @param {boolean} [urgentCarePerformableIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMedicalServices(inHomePerformableIn, medicalServiceId, name, onsiteClinicPerformableIn, schedulableByMemberIn, telemedicinePerformableIn, urgentCarePerformableIn, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listMedicalServices(inHomePerformableIn, medicalServiceId, name, onsiteClinicPerformableIn, schedulableByMemberIn, telemedicinePerformableIn, urgentCarePerformableIn, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} carePlanId
         * @param {string} [asserterId]
         * @param {string} [encounterId]
         * @param {boolean} [includeEnteredInErrorIn]
         * @param {string} [problemId]
         * @param {string} [recorderId]
         * @param {'Active' | 'Inactive' | 'Entered in Error' | '' | 'null'} [status] * &#x60;Active&#x60; - Active * &#x60;Inactive&#x60; - Inactive * &#x60;Entered in Error&#x60; - Entered In Error
         * @param {'OTC' | 'Prescription' | 'Manual Prescription' | 'Member Reported' | '' | 'null'} [type] * &#x60;OTC&#x60; - Otc * &#x60;Prescription&#x60; - E Prescription * &#x60;Manual Prescription&#x60; - Manual Prescription * &#x60;Member Reported&#x60; - Member Reported
         * @param {boolean} [unlinkedIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMedications(carePlanId, asserterId, encounterId, includeEnteredInErrorIn, problemId, recorderId, status, type, unlinkedIn, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listMedications(carePlanId, asserterId, encounterId, includeEnteredInErrorIn, problemId, recorderId, status, type, unlinkedIn, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} memberId
         * @param {string} [email]
         * @param {string} [phone]
         * @param {boolean} [primaryIn]
         * @param {boolean} [removedIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMemberEmergencyContacts(memberId, email, phone, primaryIn, removedIn, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listMemberEmergencyContacts(memberId, email, phone, primaryIn, removedIn, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMemberProblemHistory(memberId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listMemberProblemHistory(memberId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} [appointmentEndDatetime]
         * @param {string} [appointmentStartDatetime]
         * @param {string} [clinicId]
         * @param {string} [companyId]
         * @param {string} [memberId]
         * @param {string} [occupationalHealthRecordTypeId]
         * @param {boolean} [onlyClinics]
         * @param {boolean} [onlyIndividualAppointments]
         * @param {boolean} [orderByMostRecent]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMissingOccupationalHealthRecords(appointmentEndDatetime, appointmentStartDatetime, clinicId, companyId, memberId, occupationalHealthRecordTypeId, onlyClinics, onlyIndividualAppointments, orderByMostRecent, page, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listMissingOccupationalHealthRecords(appointmentEndDatetime, appointmentStartDatetime, clinicId, companyId, memberId, occupationalHealthRecordTypeId, onlyClinics, onlyIndividualAppointments, orderByMostRecent, page, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOccupationalHealthRecordTypes(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listOccupationalHealthRecordTypes(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} [chartTypeId]
         * @param {string} [companyId]
         * @param {string} [completionEndDate]
         * @param {string} [completionStartDate]
         * @param {string} [dateOfCompletion]
         * @param {string} [encounterId]
         * @param {boolean} [enteredInErrorIn]
         * @param {string} [medicalFileId]
         * @param {string} [memberId]
         * @param {string} [occupationalHealthLabOrderRequestId]
         * @param {boolean} [orderByMostRecentlyCompleted]
         * @param {number} [page]
         * @param {boolean} [pendingApprovalIn]
         * @param {string} [urgentCareOrderRequestId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOccupationalHealthRecords(chartTypeId, companyId, completionEndDate, completionStartDate, dateOfCompletion, encounterId, enteredInErrorIn, medicalFileId, memberId, occupationalHealthLabOrderRequestId, orderByMostRecentlyCompleted, page, pendingApprovalIn, urgentCareOrderRequestId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listOccupationalHealthRecords(chartTypeId, companyId, completionEndDate, completionStartDate, dateOfCompletion, encounterId, enteredInErrorIn, medicalFileId, memberId, occupationalHealthLabOrderRequestId, orderByMostRecentlyCompleted, page, pendingApprovalIn, urgentCareOrderRequestId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} companyId
         * @param {string} [approvedOnGte]
         * @param {string} [completedOnGte]
         * @param {boolean} [enteredInErrorIn]
         * @param {boolean} [includeTagsIn]
         * @param {number} [limit]
         * @param {string} [memberId]
         * @param {string} [memberName]
         * @param {string} [occupationalHealthLabOrderRequestId]
         * @param {string} [ohrTypeId]
         * @param {number} [page]
         * @param {Array<string>} [tagsIds]
         * @param {string} [urgentCareOrderRequestId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOccupationalHealthRecordsByCompany(companyId, approvedOnGte, completedOnGte, enteredInErrorIn, includeTagsIn, limit, memberId, memberName, occupationalHealthLabOrderRequestId, ohrTypeId, page, tagsIds, urgentCareOrderRequestId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listOccupationalHealthRecordsByCompany(companyId, approvedOnGte, completedOnGte, enteredInErrorIn, includeTagsIn, limit, memberId, memberName, occupationalHealthLabOrderRequestId, ohrTypeId, page, tagsIds, urgentCareOrderRequestId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} problemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProblemGoals(problemId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listProblemGoals(problemId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} medicalProfileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProcedures(medicalProfileId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listProcedures(medicalProfileId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} [appointmentId]
         * @param {string} [encounterId]
         * @param {string} [memberId]
         * @param {number} [page]
         * @param {string} [providerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRxOrders(appointmentId, encounterId, memberId, page, providerId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listRxOrders(appointmentId, encounterId, memberId, page, providerId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {ListSchedulableMedicalServicesRequest} listSchedulableMedicalServicesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSchedulableMedicalServices(listSchedulableMedicalServicesRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listSchedulableMedicalServices(listSchedulableMedicalServicesRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} [visitReasonId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSymptoms(visitReasonId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listSymptoms(visitReasonId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {MarkManualLabResultEnteredInErrorRequest} markManualLabResultEnteredInErrorRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markManualLabResultEnteredInError(markManualLabResultEnteredInErrorRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.markManualLabResultEnteredInError(markManualLabResultEnteredInErrorRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} occupationalHealthRecordId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markOccupationalHealthRecordEnteredInError(occupationalHealthRecordId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.markOccupationalHealthRecordEnteredInError(occupationalHealthRecordId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} dynamicMedicalChartId
         * @param {PublishDynamicMedicalChartRequest} [publishDynamicMedicalChartRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishDynamicMedicalChart(dynamicMedicalChartId, publishDynamicMedicalChartRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.publishDynamicMedicalChart(dynamicMedicalChartId, publishDynamicMedicalChartRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} labOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishLabOrder(labOrderId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.publishLabOrder(labOrderId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} medicalFileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishMedicalFile(medicalFileId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.publishMedicalFile(medicalFileId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} dynamicMedicalChartId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redactDynamicMedicalChart(dynamicMedicalChartId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.redactDynamicMedicalChart(dynamicMedicalChartId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} interactionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redactInteraction(interactionId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.redactInteraction(interactionId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} medicalChartFieldId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redactMedicalChartField(medicalChartFieldId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.redactMedicalChartField(medicalChartFieldId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} labOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeLabDrawFromLabOrder(labOrderId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.removeLabDrawFromLabOrder(labOrderId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} term
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAllergies(term, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchAllergies(term, limit, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} term
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchConditions(term, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchConditions(term, limit, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} term
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchIcd10Terms(term, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchIcd10Terms(term, limit, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} term
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchMedications(term, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchMedications(term, limit, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {'Provider' | 'Member'} responseType * &#x60;Provider&#x60; - Provider * &#x60;Member&#x60; - Member
         * @param {string} term
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProcedures(responseType, term, limit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchProcedures(responseType, term, limit, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} codeId
         * @param {string} medicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlinkMedicationCode(codeId, medicationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.unlinkMedicationCode(codeId, medicationId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} medicationId
         * @param {string} problemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlinkMedicationProblem(medicationId, problemId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.unlinkMedicationProblem(medicationId, problemId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} allergyId
         * @param {UpdateAllergyRequest} [updateAllergyRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAllergy(allergyId, updateAllergyRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateAllergy(allergyId, updateAllergyRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} problemId
         * @param {UpdateProblemRequest} [updateProblemRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCarePlanProblem(problemId, updateProblemRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateCarePlanProblem(problemId, updateProblemRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} chartingMacroId
         * @param {UpdateChartingMacroRequest} [updateChartingMacroRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateChartingMacro(chartingMacroId, updateChartingMacroRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateChartingMacro(chartingMacroId, updateChartingMacroRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} dynamicMedicalChartId
         * @param {UpdateDynamicMedicalChartRequest} updateDynamicMedicalChartRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDynamicMedicalChart(dynamicMedicalChartId, updateDynamicMedicalChartRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateDynamicMedicalChart(dynamicMedicalChartId, updateDynamicMedicalChartRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} dynamicMedicalChartId
         * @param {string} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDynamicMedicalChartResultsFile(dynamicMedicalChartId, file, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateDynamicMedicalChartResultsFile(dynamicMedicalChartId, file, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} contactId
         * @param {UpdateEmergencyContactRequest} [updateEmergencyContactRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmergencyContact(contactId, updateEmergencyContactRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateEmergencyContact(contactId, updateEmergencyContactRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} familyMedicalHistoryId
         * @param {UpdateFamilyMedicalHistoryRequest} updateFamilyMedicalHistoryRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFamilyMedicalHistory(familyMedicalHistoryId, updateFamilyMedicalHistoryRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateFamilyMedicalHistory(familyMedicalHistoryId, updateFamilyMedicalHistoryRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} problemId
         * @param {UpdateProblemRequest} [updateProblemRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFamilyMedicalHistoryProblem(problemId, updateProblemRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateFamilyMedicalHistoryProblem(problemId, updateProblemRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} goalId
         * @param {string} problemId
         * @param {string} targetId
         * @param {UpdateProblemGoalTargetRequest} [updateProblemGoalTargetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGoalTarget(goalId, problemId, targetId, updateProblemGoalTargetRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateGoalTarget(goalId, problemId, targetId, updateProblemGoalTargetRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} labOrderId
         * @param {UpdateLabOrderRequest} [updateLabOrderRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLabOrder(labOrderId, updateLabOrderRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateLabOrder(labOrderId, updateLabOrderRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} manualLabResultId
         * @param {UpdateManualLabResultRequest} [updateManualLabResultRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateManualLabResult(manualLabResultId, updateManualLabResultRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateManualLabResult(manualLabResultId, updateManualLabResultRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} memberId
         * @param {UpdateMedicalProfileRequest} [updateMedicalProfileRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMedicalProfile(memberId, updateMedicalProfileRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateMedicalProfile(memberId, updateMedicalProfileRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} medicationId
         * @param {UpdateMedicationRequest} [updateMedicationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMedication(medicationId, updateMedicationRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateMedication(medicationId, updateMedicationRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} memberId
         * @param {UpdatePreferredPharmacyRequest} updatePreferredPharmacyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePreferredPharmacyForMember(memberId, updatePreferredPharmacyRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updatePreferredPharmacyForMember(memberId, updatePreferredPharmacyRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} goalId
         * @param {string} problemId
         * @param {UpdateProblemGoalRequest} updateProblemGoalRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProblemGoal(goalId, problemId, updateProblemGoalRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateProblemGoal(goalId, problemId, updateProblemGoalRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} procedureId
         * @param {UpdateProcedureRequest} [updateProcedureRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcedure(procedureId, updateProcedureRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateProcedure(procedureId, updateProcedureRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} vitalsRecordId
         * @param {UpdateVitalsRecordRequest} [updateVitalsRecordRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVitalsRecord(vitalsRecordId, updateVitalsRecordRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateVitalsRecord(vitalsRecordId, updateVitalsRecordRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} dynamicMedicalChartId
         * @param {string} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDynamicMedicalChartAdditionalFile(dynamicMedicalChartId, file, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.uploadDynamicMedicalChartAdditionalFile(dynamicMedicalChartId, file, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} memberId
         * @param {string} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadMedicalProfileFile(memberId, file, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.uploadMedicalProfileFile(memberId, file, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * MedicalApi - factory interface
 * @export
 */
exports.MedicalApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.MedicalApiFp(configuration);
    return {
        /**
         *
         * @param {AddLabDrawToLabOrdersRequest} addLabDrawToLabOrdersRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addLabDrawToLabOrders(addLabDrawToLabOrdersRequest, options) {
            return localVarFp.addLabDrawToLabOrders(addLabDrawToLabOrdersRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} allergyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assertAllergy(allergyId, options) {
            return localVarFp.assertAllergy(allergyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} problemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assertCarePlanProblem(problemId, options) {
            return localVarFp.assertCarePlanProblem(problemId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} problemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assertFamilyMedicalHistoryProblem(problemId, options) {
            return localVarFp.assertFamilyMedicalHistoryProblem(problemId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} medicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assertMedication(medicationId, options) {
            return localVarFp.assertMedication(medicationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} procedureId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assertProcedure(procedureId, options) {
            return localVarFp.assertProcedure(procedureId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AssignManualLabResultRequest} assignManualLabResultRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignManualLabResult(assignManualLabResultRequest, options) {
            return localVarFp.assignManualLabResult(assignManualLabResultRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} occupationalHealthRecordId
         * @param {AuthorizePendingOccupationalHealthRecordRequest} authorizePendingOccupationalHealthRecordRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizePendingOccupationalHealthRecord(occupationalHealthRecordId, authorizePendingOccupationalHealthRecordRequest, options) {
            return localVarFp.authorizePendingOccupationalHealthRecord(occupationalHealthRecordId, authorizePendingOccupationalHealthRecordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} dynamicMedicalChartId
         * @param {BlockDynamicMedicalChartRequest} [blockDynamicMedicalChartRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockDynamicMedicalChart(dynamicMedicalChartId, blockDynamicMedicalChartRequest, options) {
            return localVarFp.blockDynamicMedicalChart(dynamicMedicalChartId, blockDynamicMedicalChartRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} labOrderId
         * @param {CancelLabOrderRequest} cancelLabOrderRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelLabOrder(labOrderId, cancelLabOrderRequest, options) {
            return localVarFp.cancelLabOrder(labOrderId, cancelLabOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} encounterId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkIfUserCanPerformChartingForEncounter(encounterId, options) {
            return localVarFp.checkIfUserCanPerformChartingForEncounter(encounterId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} fileName
         * @param {string} file
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdministrativeFile(fileName, file, memberId, options) {
            return localVarFp.createAdministrativeFile(fileName, file, memberId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} carePlanId
         * @param {CreateAllergyRequest} createAllergyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAllergy(carePlanId, createAllergyRequest, options) {
            return localVarFp.createAllergy(carePlanId, createAllergyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateChartingMacroRequest} createChartingMacroRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createChartingMacro(createChartingMacroRequest, options) {
            return localVarFp.createChartingMacro(createChartingMacroRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateDynamicMedicalChartRequest} createDynamicMedicalChartRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDynamicMedicalChart(createDynamicMedicalChartRequest, options) {
            return localVarFp.createDynamicMedicalChart(createDynamicMedicalChartRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} medicalProfileId
         * @param {CreateFamilyMedicalHistoryRequest} createFamilyMedicalHistoryRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFamilyMedicalHistory(medicalProfileId, createFamilyMedicalHistoryRequest, options) {
            return localVarFp.createFamilyMedicalHistory(medicalProfileId, createFamilyMedicalHistoryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} goalId
         * @param {string} problemId
         * @param {CreateProblemGoalTargetRequest} createProblemGoalTargetRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGoalTarget(goalId, problemId, createProblemGoalTargetRequest, options) {
            return localVarFp.createGoalTarget(goalId, problemId, createProblemGoalTargetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateInteractionRequest} createInteractionRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInteraction(createInteractionRequest, options) {
            return localVarFp.createInteraction(createInteractionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateLabOrdersCallbackRequest} createLabOrdersCallbackRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLabOrders(createLabOrdersCallbackRequest, options) {
            return localVarFp.createLabOrders(createLabOrdersCallbackRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateMedicalRecordReleaseConsentRequest} createMedicalRecordReleaseConsentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMedicalRecordReleaseConsent(createMedicalRecordReleaseConsentRequest, options) {
            return localVarFp.createMedicalRecordReleaseConsent(createMedicalRecordReleaseConsentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateMedicationRequest} createMedicationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMedication(createMedicationRequest, options) {
            return localVarFp.createMedication(createMedicationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} memberId
         * @param {CreateMemberEmergencyContactRequest} createMemberEmergencyContactRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMemberEmergencyContact(memberId, createMemberEmergencyContactRequest, options) {
            return localVarFp.createMemberEmergencyContact(memberId, createMemberEmergencyContactRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} recordTypeId
         * @param {string} memberId
         * @param {string} companyId
         * @param {string} dateOfCompletion
         * @param {boolean} performedAtVitableIn
         * @param {string} [file]
         * @param {string} [chartId]
         * @param {string} [medicalFileId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOccupationalHealthRecord(recordTypeId, memberId, companyId, dateOfCompletion, performedAtVitableIn, file, chartId, medicalFileId, options) {
            return localVarFp.createOccupationalHealthRecord(recordTypeId, memberId, companyId, dateOfCompletion, performedAtVitableIn, file, chartId, medicalFileId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} carePlanId
         * @param {CreateProblemRequest} createProblemRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProblemForCarePlan(carePlanId, createProblemRequest, options) {
            return localVarFp.createProblemForCarePlan(carePlanId, createProblemRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} familyMedicalHistoryId
         * @param {CreateProblemRequest} createProblemRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProblemForFamilyMedicalHistory(familyMedicalHistoryId, createProblemRequest, options) {
            return localVarFp.createProblemForFamilyMedicalHistory(familyMedicalHistoryId, createProblemRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} problemId
         * @param {CreateProblemGoalRequest} createProblemGoalRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProblemGoal(problemId, createProblemGoalRequest, options) {
            return localVarFp.createProblemGoal(problemId, createProblemGoalRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} medicalProfileId
         * @param {CreateProcedureRequest} createProcedureRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProcedure(medicalProfileId, createProcedureRequest, options) {
            return localVarFp.createProcedure(medicalProfileId, createProcedureRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {RxOrderCallBackRequest} [rxOrderCallBackRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRxOrder(rxOrderCallBackRequest, options) {
            return localVarFp.createRxOrder(rxOrderCallBackRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateVitalsRecordRequest} createVitalsRecordRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVitalsRecord(createVitalsRecordRequest, options) {
            return localVarFp.createVitalsRecord(createVitalsRecordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} chartingMacroId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteChartingMacro(chartingMacroId, options) {
            return localVarFp.deleteChartingMacro(chartingMacroId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} dynamicMedicalChartId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDynamicMedicalChart(dynamicMedicalChartId, options) {
            return localVarFp.deleteDynamicMedicalChart(dynamicMedicalChartId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} dynamicMedicalChartId
         * @param {string} fileFieldId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDynamicMedicalChartAdditionalFile(dynamicMedicalChartId, fileFieldId, options) {
            return localVarFp.deleteDynamicMedicalChartAdditionalFile(dynamicMedicalChartId, fileFieldId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} contactId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmergencyContact(contactId, options) {
            return localVarFp.deleteEmergencyContact(contactId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} medicalProfileFileId
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMedicalProfileFile(medicalProfileFileId, memberId, options) {
            return localVarFp.deleteMedicalProfileFile(medicalProfileFileId, memberId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} dynamicMedicalChartId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateDynamicMedicalChartResultsFile(dynamicMedicalChartId, options) {
            return localVarFp.generateDynamicMedicalChartResultsFile(dynamicMedicalChartId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} administrativeFileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdministrativeFile(administrativeFileId, options) {
            return localVarFp.getAdministrativeFile(administrativeFileId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} carePlanId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCarePlan(carePlanId, options) {
            return localVarFp.getCarePlan(carePlanId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} codeableConceptsId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCodeableConcept(codeableConceptsId, options) {
            return localVarFp.getCodeableConcept(codeableConceptsId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} contactId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmergencyContact(contactId, options) {
            return localVarFp.getEmergencyContact(contactId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} goalId
         * @param {string} problemId
         * @param {string} targetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGoalTarget(goalId, problemId, targetId, options) {
            return localVarFp.getGoalTarget(goalId, problemId, targetId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} labOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLabOrder(labOrderId, options) {
            return localVarFp.getLabOrder(labOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {GetLabOrderIframeUrlRequest} getLabOrderIframeUrlRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLabOrderIframeUrl(getLabOrderIframeUrlRequest, options) {
            return localVarFp.getLabOrderIframeUrl(getLabOrderIframeUrlRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} manualLabResultId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManualLabResult(manualLabResultId, options) {
            return localVarFp.getManualLabResult(manualLabResultId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} medicalFileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMedicalFile(medicalFileId, options) {
            return localVarFp.getMedicalFile(medicalFileId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMedicalProfile(memberId, options) {
            return localVarFp.getMedicalProfile(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} medicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMedication(medicationId, options) {
            return localVarFp.getMedication(medicationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberCarePlan(memberId, options) {
            return localVarFp.getMemberCarePlan(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} memberId
         * @param {string} problemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberProblem(memberId, problemId, options) {
            return localVarFp.getMemberProblem(memberId, problemId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} occupationalHealthRecordId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOccupationalHealthRecord(occupationalHealthRecordId, options) {
            return localVarFp.getOccupationalHealthRecord(occupationalHealthRecordId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {GetOrCreateCodeableConceptRequest} getOrCreateCodeableConceptRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrCreateCodeableConcept(getOrCreateCodeableConceptRequest, options) {
            return localVarFp.getOrCreateCodeableConcept(getOrCreateCodeableConceptRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreferredPharmacyForMember(memberId, options) {
            return localVarFp.getPreferredPharmacyForMember(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} problemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProblem(problemId, options) {
            return localVarFp.getProblem(problemId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} vitalsRecordId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVitalsRecord(vitalsRecordId, options) {
            return localVarFp.getVitalsRecord(vitalsRecordId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} codeId
         * @param {string} medicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkMedicationCode(codeId, medicationId, options) {
            return localVarFp.linkMedicationCode(codeId, medicationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} medicationId
         * @param {string} problemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkMedicationProblem(medicationId, problemId, options) {
            return localVarFp.linkMedicationProblem(medicationId, problemId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} memberId
         * @param {boolean} [enteredInErrorIn]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAdministrativeFiles(memberId, enteredInErrorIn, page, options) {
            return localVarFp.listAdministrativeFiles(memberId, enteredInErrorIn, page, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} carePlanId
         * @param {boolean} [includeEnteredInErrorIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllergies(carePlanId, includeEnteredInErrorIn, options) {
            return localVarFp.listAllergies(carePlanId, includeEnteredInErrorIn, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} carePlanId
         * @param {string} [encounterId]
         * @param {string} [familyMedicalHistoryId]
         * @param {boolean} [includeEnteredInErrorIn]
         * @param {string} [medicationId]
         * @param {string} [taskId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCarePlanProblems(carePlanId, encounterId, familyMedicalHistoryId, includeEnteredInErrorIn, medicationId, taskId, options) {
            return localVarFp.listCarePlanProblems(carePlanId, encounterId, familyMedicalHistoryId, includeEnteredInErrorIn, medicationId, taskId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {boolean} [ownedByVitableIn]
         * @param {number} [page]
         * @param {string} [providerId]
         * @param {string} [title]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listChartingMacros(ownedByVitableIn, page, providerId, title, options) {
            return localVarFp.listChartingMacros(ownedByVitableIn, page, providerId, title, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [carePlanId]
         * @param {string} [creatorId]
         * @param {boolean} [enteredInErrorIn]
         * @param {string} [noteContents]
         * @param {string} [orderByLinkedTaskId]
         * @param {number} [page]
         * @param {string} [taskId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listClinicalNotes(carePlanId, creatorId, enteredInErrorIn, noteContents, orderByLinkedTaskId, page, taskId, options) {
            return localVarFp.listClinicalNotes(carePlanId, creatorId, enteredInErrorIn, noteContents, orderByLinkedTaskId, page, taskId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} companyId
         * @param {string} ohrTypeId
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompanyMembersWithMissingOccupationalHealthRecord(companyId, ohrTypeId, page, options) {
            return localVarFp.listCompanyMembersWithMissingOccupationalHealthRecord(companyId, ohrTypeId, page, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [appointmentDateEnd]
         * @param {string} [appointmentDateStart]
         * @param {string} [appointmentId]
         * @param {'AL' | 'AK' | 'AZ' | 'AR' | 'CA' | 'CO' | 'CT' | 'DC' | 'DE' | 'FL' | 'GA' | 'HI' | 'ID' | 'IL' | 'IN' | 'IA' | 'KS' | 'KY' | 'LA' | 'ME' | 'MD' | 'MA' | 'MI' | 'MN' | 'MS' | 'MO' | 'MT' | 'NE' | 'NV' | 'NH' | 'NJ' | 'NM' | 'NY' | 'NC' | 'ND' | 'OH' | 'OK' | 'OR' | 'PR' | 'PA' | 'RI' | 'SC' | 'SD' | 'TN' | 'TX' | 'UT' | 'VT' | 'VI' | 'VA' | 'WA' | 'WI' | 'WV' | 'WY' | 'AA' | 'AE' | 'PW' | 'AP' | 'FM' | 'MH' | 'GU'} [appointmentState] * &#x60;AL&#x60; - AL * &#x60;AK&#x60; - AK * &#x60;AZ&#x60; - AZ * &#x60;AR&#x60; - AR * &#x60;CA&#x60; - CA * &#x60;CO&#x60; - CO * &#x60;CT&#x60; - CT * &#x60;DC&#x60; - DC * &#x60;DE&#x60; - DE * &#x60;FL&#x60; - FL * &#x60;GA&#x60; - GA * &#x60;HI&#x60; - HI * &#x60;ID&#x60; - ID * &#x60;IL&#x60; - IL * &#x60;IN&#x60; - IN * &#x60;IA&#x60; - IA * &#x60;KS&#x60; - KS * &#x60;KY&#x60; - KY * &#x60;LA&#x60; - LA * &#x60;ME&#x60; - ME * &#x60;MD&#x60; - MD * &#x60;MA&#x60; - MA * &#x60;MI&#x60; - MI * &#x60;MN&#x60; - MN * &#x60;MS&#x60; - MS * &#x60;MO&#x60; - MO * &#x60;MT&#x60; - MT * &#x60;NE&#x60; - NE * &#x60;NV&#x60; - NV * &#x60;NH&#x60; - NH * &#x60;NJ&#x60; - NJ * &#x60;NM&#x60; - NM * &#x60;NY&#x60; - NY * &#x60;NC&#x60; - NC * &#x60;ND&#x60; - ND * &#x60;OH&#x60; - OH * &#x60;OK&#x60; - OK * &#x60;OR&#x60; - OR * &#x60;PR&#x60; - PR * &#x60;PA&#x60; - PA * &#x60;RI&#x60; - RI * &#x60;SC&#x60; - SC * &#x60;SD&#x60; - SD * &#x60;TN&#x60; - TN * &#x60;TX&#x60; - TX * &#x60;UT&#x60; - UT * &#x60;VT&#x60; - VT * &#x60;VI&#x60; - VI * &#x60;VA&#x60; - VA * &#x60;WA&#x60; - WA * &#x60;WI&#x60; - WI * &#x60;WV&#x60; - WV * &#x60;WY&#x60; - WY * &#x60;AA&#x60; - AA * &#x60;AE&#x60; - AE * &#x60;PW&#x60; - PW * &#x60;AP&#x60; - AP * &#x60;FM&#x60; - FM * &#x60;MH&#x60; - MH * &#x60;GU&#x60; - GU
         * @param {boolean} [blockedIn]
         * @param {'History of Present Illness' | 'Physical Exam' | 'Clinical Reasoning' | 'Medical Forms' | 'Additional Files' | 'SOAP' | 'Visit Summary'} [chartType] * &#x60;History of Present Illness&#x60; - Hpi * &#x60;Physical Exam&#x60; - Pe * &#x60;Clinical Reasoning&#x60; - Clinical Reasoning * &#x60;Medical Forms&#x60; - Medical Forms * &#x60;Additional Files&#x60; - Additional Files * &#x60;SOAP&#x60; - Soap * &#x60;Visit Summary&#x60; - Visit Summary
         * @param {string} [clinicId]
         * @param {string} [companyId]
         * @param {boolean} [hasResultsFile]
         * @param {string} [medicalServiceId]
         * @param {string} [memberId]
         * @param {number} [orderByOverdue]
         * @param {boolean} [overdueIn]
         * @param {number} [page]
         * @param {string} [providerId]
         * @param {boolean} [publishedIn]
         * @param {string} [templateId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDynamicMedicalCharts(appointmentDateEnd, appointmentDateStart, appointmentId, appointmentState, blockedIn, chartType, clinicId, companyId, hasResultsFile, medicalServiceId, memberId, orderByOverdue, overdueIn, page, providerId, publishedIn, templateId, options) {
            return localVarFp.listDynamicMedicalCharts(appointmentDateEnd, appointmentDateStart, appointmentId, appointmentState, blockedIn, chartType, clinicId, companyId, hasResultsFile, medicalServiceId, memberId, orderByOverdue, overdueIn, page, providerId, publishedIn, templateId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} encounterId
         * @param {'History of Present Illness' | 'Physical Exam' | 'Clinical Reasoning' | 'Medical Forms' | 'Additional Files' | 'SOAP' | 'Visit Summary'} [chartType] * &#x60;History of Present Illness&#x60; - Hpi * &#x60;Physical Exam&#x60; - Pe * &#x60;Clinical Reasoning&#x60; - Clinical Reasoning * &#x60;Medical Forms&#x60; - Medical Forms * &#x60;Additional Files&#x60; - Additional Files * &#x60;SOAP&#x60; - Soap * &#x60;Visit Summary&#x60; - Visit Summary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDynamicMedicalChartsByEncounter(encounterId, chartType, options) {
            return localVarFp.listDynamicMedicalChartsByEncounter(encounterId, chartType, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} encounterId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEncounterProblems(encounterId, options) {
            return localVarFp.listEncounterProblems(encounterId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} numDays
         * @param {'Alabama' | 'Alaska' | 'Arizona' | 'Arkansas' | 'California' | 'Colorado' | 'Connecticut' | 'Washington D.C.' | 'Delaware' | 'Florida' | 'Georgia' | 'Hawaii' | 'Idaho' | 'Illinois' | 'Indiana' | 'Iowa' | 'Kansas' | 'Kentucky' | 'Louisiana' | 'Maine' | 'Maryland' | 'Massachusetts' | 'Michigan' | 'Minnesota' | 'Mississippi' | 'Missouri' | 'Montana' | 'Nebraska' | 'Nevada' | 'New Hampshire' | 'New Jersey' | 'New Mexico' | 'New York' | 'North Carolina' | 'North Dakota' | 'Ohio' | 'Oklahoma' | 'Oregon' | 'Pennsylvania' | 'Puerto Rico' | 'Rhode Island' | 'South Carolina' | 'South Dakota' | 'Tennessee' | 'Texas' | 'Utah' | 'Vermont' | 'Virgin Islands' | 'Virginia' | 'Washington' | 'Wisconsin' | 'West Virginia' | 'Wyoming' | 'AA' | 'AE' | 'PW' | 'AP' | 'FM' | 'MH' | 'GU'} state * &#x60;Alabama&#x60; - Al * &#x60;Alaska&#x60; - Ak * &#x60;Arizona&#x60; - Az * &#x60;Arkansas&#x60; - Ar * &#x60;California&#x60; - Ca * &#x60;Colorado&#x60; - Co * &#x60;Connecticut&#x60; - Ct * &#x60;Washington D.C.&#x60; - Dc * &#x60;Delaware&#x60; - De * &#x60;Florida&#x60; - Fl * &#x60;Georgia&#x60; - Ga * &#x60;Hawaii&#x60; - Hi * &#x60;Idaho&#x60; - Id * &#x60;Illinois&#x60; - Il * &#x60;Indiana&#x60; - In * &#x60;Iowa&#x60; - Ia * &#x60;Kansas&#x60; - Ks * &#x60;Kentucky&#x60; - Ky * &#x60;Louisiana&#x60; - La * &#x60;Maine&#x60; - Me * &#x60;Maryland&#x60; - Md * &#x60;Massachusetts&#x60; - Ma * &#x60;Michigan&#x60; - Mi * &#x60;Minnesota&#x60; - Mn * &#x60;Mississippi&#x60; - Ms * &#x60;Missouri&#x60; - Mo * &#x60;Montana&#x60; - Mt * &#x60;Nebraska&#x60; - Ne * &#x60;Nevada&#x60; - Nv * &#x60;New Hampshire&#x60; - Nh * &#x60;New Jersey&#x60; - Nj * &#x60;New Mexico&#x60; - Nm * &#x60;New York&#x60; - Ny * &#x60;North Carolina&#x60; - Nc * &#x60;North Dakota&#x60; - Nd * &#x60;Ohio&#x60; - Oh * &#x60;Oklahoma&#x60; - Ok * &#x60;Oregon&#x60; - Or * &#x60;Pennsylvania&#x60; - Pa * &#x60;Puerto Rico&#x60; - Pr * &#x60;Rhode Island&#x60; - Ri * &#x60;South Carolina&#x60; - Sc * &#x60;South Dakota&#x60; - Sd * &#x60;Tennessee&#x60; - Tn * &#x60;Texas&#x60; - Tx * &#x60;Utah&#x60; - Ut * &#x60;Vermont&#x60; - Vt * &#x60;Virgin Islands&#x60; - Vi * &#x60;Virginia&#x60; - Va * &#x60;Washington&#x60; - Wa * &#x60;Wisconsin&#x60; - Wi * &#x60;West Virginia&#x60; - Wv * &#x60;Wyoming&#x60; - Wy * &#x60;AA&#x60; - Aa * &#x60;AE&#x60; - Ae * &#x60;PW&#x60; - Pw * &#x60;AP&#x60; - Ap * &#x60;FM&#x60; - Fm * &#x60;MH&#x60; - Mh * &#x60;GU&#x60; - Gu
         * @param {string} [companyId]
         * @param {string} [ohrTypeId]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listExpiringOccupationalHealthRecords(numDays, state, companyId, ohrTypeId, page, options) {
            return localVarFp.listExpiringOccupationalHealthRecords(numDays, state, companyId, ohrTypeId, page, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} medicalProfileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFamilyMedicalHistory(medicalProfileId, options) {
            return localVarFp.listFamilyMedicalHistory(medicalProfileId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} familyMedicalHistoryId
         * @param {boolean} [includeEnteredInErrorIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFamilyMedicalHistoryProblems(familyMedicalHistoryId, includeEnteredInErrorIn, options) {
            return localVarFp.listFamilyMedicalHistoryProblems(familyMedicalHistoryId, includeEnteredInErrorIn, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} goalId
         * @param {string} problemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGoalTargets(goalId, problemId, options) {
            return localVarFp.listGoalTargets(goalId, problemId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [authorId]
         * @param {'Patient' | 'Patient representative' | 'Internal' | 'None' | 'Other' | 'null'} [correspondentType] * &#x60;Patient&#x60; - Patient * &#x60;Patient representative&#x60; - Patient Representative * &#x60;Internal&#x60; - Internal * &#x60;None&#x60; - None * &#x60;Other&#x60; - Other
         * @param {'Phone' | 'Email' | 'SMS' | 'Chat' | 'Documentation' | 'null'} [interactionChannel] * &#x60;Phone&#x60; - Phone * &#x60;Email&#x60; - Email * &#x60;SMS&#x60; - Sms * &#x60;Chat&#x60; - Chat * &#x60;Documentation&#x60; - Documentation
         * @param {'Follow-up' | 'Prescription change' | 'Care coordination' | 'Admin note' | 'Lab order' | 'Lab review' | 'Other' | 'null'} [interactionType] * &#x60;Follow-up&#x60; - Follow Up * &#x60;Prescription change&#x60; - Prescription Change * &#x60;Care coordination&#x60; - Care Coordination * &#x60;Admin note&#x60; - Admin Note * &#x60;Lab order&#x60; - Lab Order * &#x60;Lab review&#x60; - Lab Review * &#x60;Other&#x60; - Other
         * @param {number} [limit]
         * @param {number} [page]
         * @param {string} [patientId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInteractions(authorId, correspondentType, interactionChannel, interactionType, limit, page, patientId, options) {
            return localVarFp.listInteractions(authorId, correspondentType, interactionChannel, interactionType, limit, page, patientId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [createdEndDatetime]
         * @param {string} [createdStartDatetime]
         * @param {boolean} [hasAddedLabDraws]
         * @param {boolean} [hasReceivedResults]
         * @param {string} [labName]
         * @param {boolean} [labOrderConfirmationCompletedIn]
         * @param {'registered' | 'preliminary' | 'final' | 'amended' | 'corrected' | 'cancelled' | 'entered-in-error' | 'unknown'} [labTestStatus] * &#x60;registered&#x60; - registered * &#x60;preliminary&#x60; - preliminary * &#x60;final&#x60; - final * &#x60;amended&#x60; - amended * &#x60;corrected&#x60; - corrected * &#x60;cancelled&#x60; - cancelled * &#x60;entered-in-error&#x60; - entered-in-error * &#x60;unknown&#x60; - unknown
         * @param {string} [memberId]
         * @param {string} [orderingEncounterId]
         * @param {number} [page]
         * @param {'Needs Diagnostic Follow Up' | 'Diagnostic Follow Up Scheduled' | 'Diagnostic Follow Up Complete'} [postLabStatus] * &#x60;Needs Diagnostic Follow Up&#x60; - Needs Diagnostic Follow Up * &#x60;Diagnostic Follow Up Scheduled&#x60; - Diagnostic Follow Up Scheduled * &#x60;Diagnostic Follow Up Complete&#x60; - Diagnostic Follow Up Complete
         * @param {string} [providerId]
         * @param {string} [renderingEncounterId]
         * @param {'Cancelled' | 'Awaiting Results' | 'Needs Lab Draw' | 'Lab Draw Scheduled' | 'Results Received' | 'Completed' | 'Inconclusive'} [status] * &#x60;Cancelled&#x60; - Cancelled * &#x60;Awaiting Results&#x60; - Awaiting Results * &#x60;Needs Lab Draw&#x60; - Needs Lab Draw * &#x60;Lab Draw Scheduled&#x60; - Lab Draw Scheduled * &#x60;Results Received&#x60; - Results Received * &#x60;Completed&#x60; - Completed * &#x60;Inconclusive&#x60; - Inconclusive
         * @param {string} [testCodeableConceptId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLabOrders(createdEndDatetime, createdStartDatetime, hasAddedLabDraws, hasReceivedResults, labName, labOrderConfirmationCompletedIn, labTestStatus, memberId, orderingEncounterId, page, postLabStatus, providerId, renderingEncounterId, status, testCodeableConceptId, options) {
            return localVarFp.listLabOrders(createdEndDatetime, createdStartDatetime, hasAddedLabDraws, hasReceivedResults, labName, labOrderConfirmationCompletedIn, labTestStatus, memberId, orderingEncounterId, page, postLabStatus, providerId, renderingEncounterId, status, testCodeableConceptId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [name]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLabTestCodeableConcepts(name, page, options) {
            return localVarFp.listLabTestCodeableConcepts(name, page, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [createdEndDatetime]
         * @param {string} [createdStartDatetime]
         * @param {boolean} [enteredInErrorIn]
         * @param {string} [labName]
         * @param {string} [labResultPatientName]
         * @param {number} [page]
         * @param {string} [patientId]
         * @param {boolean} [reviewedIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listManualLabResults(createdEndDatetime, createdStartDatetime, enteredInErrorIn, labName, labResultPatientName, page, patientId, reviewedIn, options) {
            return localVarFp.listManualLabResults(createdEndDatetime, createdStartDatetime, enteredInErrorIn, labName, labResultPatientName, page, patientId, reviewedIn, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {'History of Present Illness' | 'Physical Exam' | 'Clinical Reasoning' | 'Medical Forms' | 'Additional Files' | 'SOAP' | 'Visit Summary'} [chartType] * &#x60;History of Present Illness&#x60; - Hpi * &#x60;Physical Exam&#x60; - Pe * &#x60;Clinical Reasoning&#x60; - Clinical Reasoning * &#x60;Medical Forms&#x60; - Medical Forms * &#x60;Additional Files&#x60; - Additional Files * &#x60;SOAP&#x60; - Soap * &#x60;Visit Summary&#x60; - Visit Summary
         * @param {string} [name]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMedicalChartTemplates(chartType, name, page, options) {
            return localVarFp.listMedicalChartTemplates(chartType, name, page, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {'History of Present Illness' | 'Physical Exam' | 'Clinical Reasoning' | 'Medical Forms' | 'Additional Files' | 'SOAP' | 'Visit Summary'} chartType * &#x60;History of Present Illness&#x60; - Hpi * &#x60;Physical Exam&#x60; - Pe * &#x60;Clinical Reasoning&#x60; - Clinical Reasoning * &#x60;Medical Forms&#x60; - Medical Forms * &#x60;Additional Files&#x60; - Additional Files * &#x60;SOAP&#x60; - Soap * &#x60;Visit Summary&#x60; - Visit Summary
         * @param {string} encounterId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMedicalChartTemplatesForEncounter(chartType, encounterId, options) {
            return localVarFp.listMedicalChartTemplatesForEncounter(chartType, encounterId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} memberId
         * @param {string} [encounterId]
         * @param {number} [limit]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMedicalFilesForMember(memberId, encounterId, limit, page, options) {
            return localVarFp.listMedicalFilesForMember(memberId, encounterId, limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} memberId
         * @param {number} [limit]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMedicalProfileFiles(memberId, limit, page, options) {
            return localVarFp.listMedicalProfileFiles(memberId, limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [memberId]
         * @param {string} [occupationalHealthLabOrderRequestId]
         * @param {string} [urgentCareOrderRequestId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMedicalRecordReleaseConsents(memberId, occupationalHealthLabOrderRequestId, urgentCareOrderRequestId, options) {
            return localVarFp.listMedicalRecordReleaseConsents(memberId, occupationalHealthLabOrderRequestId, urgentCareOrderRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {boolean} [inHomePerformableIn]
         * @param {string} [medicalServiceId]
         * @param {string} [name]
         * @param {boolean} [onsiteClinicPerformableIn]
         * @param {boolean} [schedulableByMemberIn]
         * @param {boolean} [telemedicinePerformableIn]
         * @param {boolean} [urgentCarePerformableIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMedicalServices(inHomePerformableIn, medicalServiceId, name, onsiteClinicPerformableIn, schedulableByMemberIn, telemedicinePerformableIn, urgentCarePerformableIn, options) {
            return localVarFp.listMedicalServices(inHomePerformableIn, medicalServiceId, name, onsiteClinicPerformableIn, schedulableByMemberIn, telemedicinePerformableIn, urgentCarePerformableIn, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} carePlanId
         * @param {string} [asserterId]
         * @param {string} [encounterId]
         * @param {boolean} [includeEnteredInErrorIn]
         * @param {string} [problemId]
         * @param {string} [recorderId]
         * @param {'Active' | 'Inactive' | 'Entered in Error' | '' | 'null'} [status] * &#x60;Active&#x60; - Active * &#x60;Inactive&#x60; - Inactive * &#x60;Entered in Error&#x60; - Entered In Error
         * @param {'OTC' | 'Prescription' | 'Manual Prescription' | 'Member Reported' | '' | 'null'} [type] * &#x60;OTC&#x60; - Otc * &#x60;Prescription&#x60; - E Prescription * &#x60;Manual Prescription&#x60; - Manual Prescription * &#x60;Member Reported&#x60; - Member Reported
         * @param {boolean} [unlinkedIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMedications(carePlanId, asserterId, encounterId, includeEnteredInErrorIn, problemId, recorderId, status, type, unlinkedIn, options) {
            return localVarFp.listMedications(carePlanId, asserterId, encounterId, includeEnteredInErrorIn, problemId, recorderId, status, type, unlinkedIn, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} memberId
         * @param {string} [email]
         * @param {string} [phone]
         * @param {boolean} [primaryIn]
         * @param {boolean} [removedIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMemberEmergencyContacts(memberId, email, phone, primaryIn, removedIn, options) {
            return localVarFp.listMemberEmergencyContacts(memberId, email, phone, primaryIn, removedIn, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMemberProblemHistory(memberId, options) {
            return localVarFp.listMemberProblemHistory(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [appointmentEndDatetime]
         * @param {string} [appointmentStartDatetime]
         * @param {string} [clinicId]
         * @param {string} [companyId]
         * @param {string} [memberId]
         * @param {string} [occupationalHealthRecordTypeId]
         * @param {boolean} [onlyClinics]
         * @param {boolean} [onlyIndividualAppointments]
         * @param {boolean} [orderByMostRecent]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMissingOccupationalHealthRecords(appointmentEndDatetime, appointmentStartDatetime, clinicId, companyId, memberId, occupationalHealthRecordTypeId, onlyClinics, onlyIndividualAppointments, orderByMostRecent, page, options) {
            return localVarFp.listMissingOccupationalHealthRecords(appointmentEndDatetime, appointmentStartDatetime, clinicId, companyId, memberId, occupationalHealthRecordTypeId, onlyClinics, onlyIndividualAppointments, orderByMostRecent, page, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOccupationalHealthRecordTypes(options) {
            return localVarFp.listOccupationalHealthRecordTypes(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [chartTypeId]
         * @param {string} [companyId]
         * @param {string} [completionEndDate]
         * @param {string} [completionStartDate]
         * @param {string} [dateOfCompletion]
         * @param {string} [encounterId]
         * @param {boolean} [enteredInErrorIn]
         * @param {string} [medicalFileId]
         * @param {string} [memberId]
         * @param {string} [occupationalHealthLabOrderRequestId]
         * @param {boolean} [orderByMostRecentlyCompleted]
         * @param {number} [page]
         * @param {boolean} [pendingApprovalIn]
         * @param {string} [urgentCareOrderRequestId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOccupationalHealthRecords(chartTypeId, companyId, completionEndDate, completionStartDate, dateOfCompletion, encounterId, enteredInErrorIn, medicalFileId, memberId, occupationalHealthLabOrderRequestId, orderByMostRecentlyCompleted, page, pendingApprovalIn, urgentCareOrderRequestId, options) {
            return localVarFp.listOccupationalHealthRecords(chartTypeId, companyId, completionEndDate, completionStartDate, dateOfCompletion, encounterId, enteredInErrorIn, medicalFileId, memberId, occupationalHealthLabOrderRequestId, orderByMostRecentlyCompleted, page, pendingApprovalIn, urgentCareOrderRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} companyId
         * @param {string} [approvedOnGte]
         * @param {string} [completedOnGte]
         * @param {boolean} [enteredInErrorIn]
         * @param {boolean} [includeTagsIn]
         * @param {number} [limit]
         * @param {string} [memberId]
         * @param {string} [memberName]
         * @param {string} [occupationalHealthLabOrderRequestId]
         * @param {string} [ohrTypeId]
         * @param {number} [page]
         * @param {Array<string>} [tagsIds]
         * @param {string} [urgentCareOrderRequestId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOccupationalHealthRecordsByCompany(companyId, approvedOnGte, completedOnGte, enteredInErrorIn, includeTagsIn, limit, memberId, memberName, occupationalHealthLabOrderRequestId, ohrTypeId, page, tagsIds, urgentCareOrderRequestId, options) {
            return localVarFp.listOccupationalHealthRecordsByCompany(companyId, approvedOnGte, completedOnGte, enteredInErrorIn, includeTagsIn, limit, memberId, memberName, occupationalHealthLabOrderRequestId, ohrTypeId, page, tagsIds, urgentCareOrderRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} problemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProblemGoals(problemId, options) {
            return localVarFp.listProblemGoals(problemId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} medicalProfileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProcedures(medicalProfileId, options) {
            return localVarFp.listProcedures(medicalProfileId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [appointmentId]
         * @param {string} [encounterId]
         * @param {string} [memberId]
         * @param {number} [page]
         * @param {string} [providerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRxOrders(appointmentId, encounterId, memberId, page, providerId, options) {
            return localVarFp.listRxOrders(appointmentId, encounterId, memberId, page, providerId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ListSchedulableMedicalServicesRequest} listSchedulableMedicalServicesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSchedulableMedicalServices(listSchedulableMedicalServicesRequest, options) {
            return localVarFp.listSchedulableMedicalServices(listSchedulableMedicalServicesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [visitReasonId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSymptoms(visitReasonId, options) {
            return localVarFp.listSymptoms(visitReasonId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {MarkManualLabResultEnteredInErrorRequest} markManualLabResultEnteredInErrorRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markManualLabResultEnteredInError(markManualLabResultEnteredInErrorRequest, options) {
            return localVarFp.markManualLabResultEnteredInError(markManualLabResultEnteredInErrorRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} occupationalHealthRecordId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markOccupationalHealthRecordEnteredInError(occupationalHealthRecordId, options) {
            return localVarFp.markOccupationalHealthRecordEnteredInError(occupationalHealthRecordId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} dynamicMedicalChartId
         * @param {PublishDynamicMedicalChartRequest} [publishDynamicMedicalChartRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishDynamicMedicalChart(dynamicMedicalChartId, publishDynamicMedicalChartRequest, options) {
            return localVarFp.publishDynamicMedicalChart(dynamicMedicalChartId, publishDynamicMedicalChartRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} labOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishLabOrder(labOrderId, options) {
            return localVarFp.publishLabOrder(labOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} medicalFileId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishMedicalFile(medicalFileId, options) {
            return localVarFp.publishMedicalFile(medicalFileId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} dynamicMedicalChartId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redactDynamicMedicalChart(dynamicMedicalChartId, options) {
            return localVarFp.redactDynamicMedicalChart(dynamicMedicalChartId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} interactionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redactInteraction(interactionId, options) {
            return localVarFp.redactInteraction(interactionId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} medicalChartFieldId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redactMedicalChartField(medicalChartFieldId, options) {
            return localVarFp.redactMedicalChartField(medicalChartFieldId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} labOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeLabDrawFromLabOrder(labOrderId, options) {
            return localVarFp.removeLabDrawFromLabOrder(labOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} term
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAllergies(term, limit, options) {
            return localVarFp.searchAllergies(term, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} term
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchConditions(term, limit, options) {
            return localVarFp.searchConditions(term, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} term
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchIcd10Terms(term, limit, options) {
            return localVarFp.searchIcd10Terms(term, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} term
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchMedications(term, limit, options) {
            return localVarFp.searchMedications(term, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {'Provider' | 'Member'} responseType * &#x60;Provider&#x60; - Provider * &#x60;Member&#x60; - Member
         * @param {string} term
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProcedures(responseType, term, limit, options) {
            return localVarFp.searchProcedures(responseType, term, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} codeId
         * @param {string} medicationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlinkMedicationCode(codeId, medicationId, options) {
            return localVarFp.unlinkMedicationCode(codeId, medicationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} medicationId
         * @param {string} problemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlinkMedicationProblem(medicationId, problemId, options) {
            return localVarFp.unlinkMedicationProblem(medicationId, problemId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} allergyId
         * @param {UpdateAllergyRequest} [updateAllergyRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAllergy(allergyId, updateAllergyRequest, options) {
            return localVarFp.updateAllergy(allergyId, updateAllergyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} problemId
         * @param {UpdateProblemRequest} [updateProblemRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCarePlanProblem(problemId, updateProblemRequest, options) {
            return localVarFp.updateCarePlanProblem(problemId, updateProblemRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} chartingMacroId
         * @param {UpdateChartingMacroRequest} [updateChartingMacroRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateChartingMacro(chartingMacroId, updateChartingMacroRequest, options) {
            return localVarFp.updateChartingMacro(chartingMacroId, updateChartingMacroRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} dynamicMedicalChartId
         * @param {UpdateDynamicMedicalChartRequest} updateDynamicMedicalChartRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDynamicMedicalChart(dynamicMedicalChartId, updateDynamicMedicalChartRequest, options) {
            return localVarFp.updateDynamicMedicalChart(dynamicMedicalChartId, updateDynamicMedicalChartRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} dynamicMedicalChartId
         * @param {string} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDynamicMedicalChartResultsFile(dynamicMedicalChartId, file, options) {
            return localVarFp.updateDynamicMedicalChartResultsFile(dynamicMedicalChartId, file, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} contactId
         * @param {UpdateEmergencyContactRequest} [updateEmergencyContactRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmergencyContact(contactId, updateEmergencyContactRequest, options) {
            return localVarFp.updateEmergencyContact(contactId, updateEmergencyContactRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} familyMedicalHistoryId
         * @param {UpdateFamilyMedicalHistoryRequest} updateFamilyMedicalHistoryRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFamilyMedicalHistory(familyMedicalHistoryId, updateFamilyMedicalHistoryRequest, options) {
            return localVarFp.updateFamilyMedicalHistory(familyMedicalHistoryId, updateFamilyMedicalHistoryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} problemId
         * @param {UpdateProblemRequest} [updateProblemRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFamilyMedicalHistoryProblem(problemId, updateProblemRequest, options) {
            return localVarFp.updateFamilyMedicalHistoryProblem(problemId, updateProblemRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} goalId
         * @param {string} problemId
         * @param {string} targetId
         * @param {UpdateProblemGoalTargetRequest} [updateProblemGoalTargetRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGoalTarget(goalId, problemId, targetId, updateProblemGoalTargetRequest, options) {
            return localVarFp.updateGoalTarget(goalId, problemId, targetId, updateProblemGoalTargetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} labOrderId
         * @param {UpdateLabOrderRequest} [updateLabOrderRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLabOrder(labOrderId, updateLabOrderRequest, options) {
            return localVarFp.updateLabOrder(labOrderId, updateLabOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} manualLabResultId
         * @param {UpdateManualLabResultRequest} [updateManualLabResultRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateManualLabResult(manualLabResultId, updateManualLabResultRequest, options) {
            return localVarFp.updateManualLabResult(manualLabResultId, updateManualLabResultRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} memberId
         * @param {UpdateMedicalProfileRequest} [updateMedicalProfileRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMedicalProfile(memberId, updateMedicalProfileRequest, options) {
            return localVarFp.updateMedicalProfile(memberId, updateMedicalProfileRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} medicationId
         * @param {UpdateMedicationRequest} [updateMedicationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMedication(medicationId, updateMedicationRequest, options) {
            return localVarFp.updateMedication(medicationId, updateMedicationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} memberId
         * @param {UpdatePreferredPharmacyRequest} updatePreferredPharmacyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePreferredPharmacyForMember(memberId, updatePreferredPharmacyRequest, options) {
            return localVarFp.updatePreferredPharmacyForMember(memberId, updatePreferredPharmacyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} goalId
         * @param {string} problemId
         * @param {UpdateProblemGoalRequest} updateProblemGoalRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProblemGoal(goalId, problemId, updateProblemGoalRequest, options) {
            return localVarFp.updateProblemGoal(goalId, problemId, updateProblemGoalRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} procedureId
         * @param {UpdateProcedureRequest} [updateProcedureRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcedure(procedureId, updateProcedureRequest, options) {
            return localVarFp.updateProcedure(procedureId, updateProcedureRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} vitalsRecordId
         * @param {UpdateVitalsRecordRequest} [updateVitalsRecordRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVitalsRecord(vitalsRecordId, updateVitalsRecordRequest, options) {
            return localVarFp.updateVitalsRecord(vitalsRecordId, updateVitalsRecordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} dynamicMedicalChartId
         * @param {string} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDynamicMedicalChartAdditionalFile(dynamicMedicalChartId, file, options) {
            return localVarFp.uploadDynamicMedicalChartAdditionalFile(dynamicMedicalChartId, file, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} memberId
         * @param {string} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadMedicalProfileFile(memberId, file, options) {
            return localVarFp.uploadMedicalProfileFile(memberId, file, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * MedicalApi - object-oriented interface
 * @export
 * @class MedicalApi
 * @extends {BaseAPI}
 */
class MedicalApi extends base_1.BaseAPI {
    /**
     *
     * @param {MedicalApiAddLabDrawToLabOrdersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    addLabDrawToLabOrders(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).addLabDrawToLabOrders(requestParameters.addLabDrawToLabOrdersRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiAssertAllergyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    assertAllergy(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).assertAllergy(requestParameters.allergyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiAssertCarePlanProblemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    assertCarePlanProblem(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).assertCarePlanProblem(requestParameters.problemId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiAssertFamilyMedicalHistoryProblemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    assertFamilyMedicalHistoryProblem(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).assertFamilyMedicalHistoryProblem(requestParameters.problemId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiAssertMedicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    assertMedication(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).assertMedication(requestParameters.medicationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiAssertProcedureRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    assertProcedure(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).assertProcedure(requestParameters.procedureId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiAssignManualLabResultRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    assignManualLabResult(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).assignManualLabResult(requestParameters.assignManualLabResultRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiAuthorizePendingOccupationalHealthRecordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    authorizePendingOccupationalHealthRecord(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).authorizePendingOccupationalHealthRecord(requestParameters.occupationalHealthRecordId, requestParameters.authorizePendingOccupationalHealthRecordRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiBlockDynamicMedicalChartRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    blockDynamicMedicalChart(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).blockDynamicMedicalChart(requestParameters.dynamicMedicalChartId, requestParameters.blockDynamicMedicalChartRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiCancelLabOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    cancelLabOrder(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).cancelLabOrder(requestParameters.labOrderId, requestParameters.cancelLabOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiCheckIfUserCanPerformChartingForEncounterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    checkIfUserCanPerformChartingForEncounter(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).checkIfUserCanPerformChartingForEncounter(requestParameters.encounterId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiCreateAdministrativeFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    createAdministrativeFile(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).createAdministrativeFile(requestParameters.fileName, requestParameters.file, requestParameters.memberId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiCreateAllergyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    createAllergy(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).createAllergy(requestParameters.carePlanId, requestParameters.createAllergyRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiCreateChartingMacroRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    createChartingMacro(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).createChartingMacro(requestParameters.createChartingMacroRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiCreateDynamicMedicalChartRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    createDynamicMedicalChart(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).createDynamicMedicalChart(requestParameters.createDynamicMedicalChartRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiCreateFamilyMedicalHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    createFamilyMedicalHistory(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).createFamilyMedicalHistory(requestParameters.medicalProfileId, requestParameters.createFamilyMedicalHistoryRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiCreateGoalTargetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    createGoalTarget(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).createGoalTarget(requestParameters.goalId, requestParameters.problemId, requestParameters.createProblemGoalTargetRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiCreateInteractionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    createInteraction(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).createInteraction(requestParameters.createInteractionRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiCreateLabOrdersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    createLabOrders(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).createLabOrders(requestParameters.createLabOrdersCallbackRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiCreateMedicalRecordReleaseConsentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    createMedicalRecordReleaseConsent(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).createMedicalRecordReleaseConsent(requestParameters.createMedicalRecordReleaseConsentRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiCreateMedicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    createMedication(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).createMedication(requestParameters.createMedicationRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiCreateMemberEmergencyContactRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    createMemberEmergencyContact(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).createMemberEmergencyContact(requestParameters.memberId, requestParameters.createMemberEmergencyContactRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiCreateOccupationalHealthRecordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    createOccupationalHealthRecord(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).createOccupationalHealthRecord(requestParameters.recordTypeId, requestParameters.memberId, requestParameters.companyId, requestParameters.dateOfCompletion, requestParameters.performedAtVitableIn, requestParameters.file, requestParameters.chartId, requestParameters.medicalFileId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiCreateProblemForCarePlanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    createProblemForCarePlan(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).createProblemForCarePlan(requestParameters.carePlanId, requestParameters.createProblemRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiCreateProblemForFamilyMedicalHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    createProblemForFamilyMedicalHistory(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).createProblemForFamilyMedicalHistory(requestParameters.familyMedicalHistoryId, requestParameters.createProblemRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiCreateProblemGoalRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    createProblemGoal(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).createProblemGoal(requestParameters.problemId, requestParameters.createProblemGoalRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiCreateProcedureRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    createProcedure(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).createProcedure(requestParameters.medicalProfileId, requestParameters.createProcedureRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiCreateRxOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    createRxOrder(requestParameters = {}, options) {
        return exports.MedicalApiFp(this.configuration).createRxOrder(requestParameters.rxOrderCallBackRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiCreateVitalsRecordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    createVitalsRecord(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).createVitalsRecord(requestParameters.createVitalsRecordRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiDeleteChartingMacroRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    deleteChartingMacro(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).deleteChartingMacro(requestParameters.chartingMacroId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiDeleteDynamicMedicalChartRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    deleteDynamicMedicalChart(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).deleteDynamicMedicalChart(requestParameters.dynamicMedicalChartId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiDeleteDynamicMedicalChartAdditionalFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    deleteDynamicMedicalChartAdditionalFile(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).deleteDynamicMedicalChartAdditionalFile(requestParameters.dynamicMedicalChartId, requestParameters.fileFieldId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiDeleteEmergencyContactRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    deleteEmergencyContact(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).deleteEmergencyContact(requestParameters.contactId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiDeleteMedicalProfileFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    deleteMedicalProfileFile(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).deleteMedicalProfileFile(requestParameters.medicalProfileFileId, requestParameters.memberId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiGenerateDynamicMedicalChartResultsFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    generateDynamicMedicalChartResultsFile(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).generateDynamicMedicalChartResultsFile(requestParameters.dynamicMedicalChartId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiGetAdministrativeFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    getAdministrativeFile(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).getAdministrativeFile(requestParameters.administrativeFileId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiGetCarePlanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    getCarePlan(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).getCarePlan(requestParameters.carePlanId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiGetCodeableConceptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    getCodeableConcept(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).getCodeableConcept(requestParameters.codeableConceptsId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiGetEmergencyContactRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    getEmergencyContact(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).getEmergencyContact(requestParameters.contactId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiGetGoalTargetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    getGoalTarget(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).getGoalTarget(requestParameters.goalId, requestParameters.problemId, requestParameters.targetId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiGetLabOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    getLabOrder(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).getLabOrder(requestParameters.labOrderId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiGetLabOrderIframeUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    getLabOrderIframeUrl(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).getLabOrderIframeUrl(requestParameters.getLabOrderIframeUrlRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiGetManualLabResultRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    getManualLabResult(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).getManualLabResult(requestParameters.manualLabResultId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiGetMedicalFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    getMedicalFile(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).getMedicalFile(requestParameters.medicalFileId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiGetMedicalProfileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    getMedicalProfile(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).getMedicalProfile(requestParameters.memberId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiGetMedicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    getMedication(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).getMedication(requestParameters.medicationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiGetMemberCarePlanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    getMemberCarePlan(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).getMemberCarePlan(requestParameters.memberId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiGetMemberProblemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    getMemberProblem(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).getMemberProblem(requestParameters.memberId, requestParameters.problemId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiGetOccupationalHealthRecordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    getOccupationalHealthRecord(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).getOccupationalHealthRecord(requestParameters.occupationalHealthRecordId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiGetOrCreateCodeableConceptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    getOrCreateCodeableConcept(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).getOrCreateCodeableConcept(requestParameters.getOrCreateCodeableConceptRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiGetPreferredPharmacyForMemberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    getPreferredPharmacyForMember(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).getPreferredPharmacyForMember(requestParameters.memberId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiGetProblemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    getProblem(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).getProblem(requestParameters.problemId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiGetVitalsRecordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    getVitalsRecord(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).getVitalsRecord(requestParameters.vitalsRecordId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiLinkMedicationCodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    linkMedicationCode(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).linkMedicationCode(requestParameters.codeId, requestParameters.medicationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiLinkMedicationProblemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    linkMedicationProblem(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).linkMedicationProblem(requestParameters.medicationId, requestParameters.problemId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiListAdministrativeFilesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    listAdministrativeFiles(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).listAdministrativeFiles(requestParameters.memberId, requestParameters.enteredInErrorIn, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiListAllergiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    listAllergies(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).listAllergies(requestParameters.carePlanId, requestParameters.includeEnteredInErrorIn, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiListCarePlanProblemsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    listCarePlanProblems(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).listCarePlanProblems(requestParameters.carePlanId, requestParameters.encounterId, requestParameters.familyMedicalHistoryId, requestParameters.includeEnteredInErrorIn, requestParameters.medicationId, requestParameters.taskId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiListChartingMacrosRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    listChartingMacros(requestParameters = {}, options) {
        return exports.MedicalApiFp(this.configuration).listChartingMacros(requestParameters.ownedByVitableIn, requestParameters.page, requestParameters.providerId, requestParameters.title, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiListClinicalNotesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    listClinicalNotes(requestParameters = {}, options) {
        return exports.MedicalApiFp(this.configuration).listClinicalNotes(requestParameters.carePlanId, requestParameters.creatorId, requestParameters.enteredInErrorIn, requestParameters.noteContents, requestParameters.orderByLinkedTaskId, requestParameters.page, requestParameters.taskId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiListCompanyMembersWithMissingOccupationalHealthRecordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    listCompanyMembersWithMissingOccupationalHealthRecord(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).listCompanyMembersWithMissingOccupationalHealthRecord(requestParameters.companyId, requestParameters.ohrTypeId, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiListDynamicMedicalChartsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    listDynamicMedicalCharts(requestParameters = {}, options) {
        return exports.MedicalApiFp(this.configuration).listDynamicMedicalCharts(requestParameters.appointmentDateEnd, requestParameters.appointmentDateStart, requestParameters.appointmentId, requestParameters.appointmentState, requestParameters.blockedIn, requestParameters.chartType, requestParameters.clinicId, requestParameters.companyId, requestParameters.hasResultsFile, requestParameters.medicalServiceId, requestParameters.memberId, requestParameters.orderByOverdue, requestParameters.overdueIn, requestParameters.page, requestParameters.providerId, requestParameters.publishedIn, requestParameters.templateId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiListDynamicMedicalChartsByEncounterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    listDynamicMedicalChartsByEncounter(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).listDynamicMedicalChartsByEncounter(requestParameters.encounterId, requestParameters.chartType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiListEncounterProblemsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    listEncounterProblems(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).listEncounterProblems(requestParameters.encounterId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiListExpiringOccupationalHealthRecordsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    listExpiringOccupationalHealthRecords(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).listExpiringOccupationalHealthRecords(requestParameters.numDays, requestParameters.state, requestParameters.companyId, requestParameters.ohrTypeId, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiListFamilyMedicalHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    listFamilyMedicalHistory(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).listFamilyMedicalHistory(requestParameters.medicalProfileId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiListFamilyMedicalHistoryProblemsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    listFamilyMedicalHistoryProblems(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).listFamilyMedicalHistoryProblems(requestParameters.familyMedicalHistoryId, requestParameters.includeEnteredInErrorIn, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiListGoalTargetsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    listGoalTargets(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).listGoalTargets(requestParameters.goalId, requestParameters.problemId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiListInteractionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    listInteractions(requestParameters = {}, options) {
        return exports.MedicalApiFp(this.configuration).listInteractions(requestParameters.authorId, requestParameters.correspondentType, requestParameters.interactionChannel, requestParameters.interactionType, requestParameters.limit, requestParameters.page, requestParameters.patientId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiListLabOrdersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    listLabOrders(requestParameters = {}, options) {
        return exports.MedicalApiFp(this.configuration).listLabOrders(requestParameters.createdEndDatetime, requestParameters.createdStartDatetime, requestParameters.hasAddedLabDraws, requestParameters.hasReceivedResults, requestParameters.labName, requestParameters.labOrderConfirmationCompletedIn, requestParameters.labTestStatus, requestParameters.memberId, requestParameters.orderingEncounterId, requestParameters.page, requestParameters.postLabStatus, requestParameters.providerId, requestParameters.renderingEncounterId, requestParameters.status, requestParameters.testCodeableConceptId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiListLabTestCodeableConceptsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    listLabTestCodeableConcepts(requestParameters = {}, options) {
        return exports.MedicalApiFp(this.configuration).listLabTestCodeableConcepts(requestParameters.name, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiListManualLabResultsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    listManualLabResults(requestParameters = {}, options) {
        return exports.MedicalApiFp(this.configuration).listManualLabResults(requestParameters.createdEndDatetime, requestParameters.createdStartDatetime, requestParameters.enteredInErrorIn, requestParameters.labName, requestParameters.labResultPatientName, requestParameters.page, requestParameters.patientId, requestParameters.reviewedIn, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiListMedicalChartTemplatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    listMedicalChartTemplates(requestParameters = {}, options) {
        return exports.MedicalApiFp(this.configuration).listMedicalChartTemplates(requestParameters.chartType, requestParameters.name, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiListMedicalChartTemplatesForEncounterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    listMedicalChartTemplatesForEncounter(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).listMedicalChartTemplatesForEncounter(requestParameters.chartType, requestParameters.encounterId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiListMedicalFilesForMemberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    listMedicalFilesForMember(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).listMedicalFilesForMember(requestParameters.memberId, requestParameters.encounterId, requestParameters.limit, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiListMedicalProfileFilesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    listMedicalProfileFiles(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).listMedicalProfileFiles(requestParameters.memberId, requestParameters.limit, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiListMedicalRecordReleaseConsentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    listMedicalRecordReleaseConsents(requestParameters = {}, options) {
        return exports.MedicalApiFp(this.configuration).listMedicalRecordReleaseConsents(requestParameters.memberId, requestParameters.occupationalHealthLabOrderRequestId, requestParameters.urgentCareOrderRequestId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiListMedicalServicesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    listMedicalServices(requestParameters = {}, options) {
        return exports.MedicalApiFp(this.configuration).listMedicalServices(requestParameters.inHomePerformableIn, requestParameters.medicalServiceId, requestParameters.name, requestParameters.onsiteClinicPerformableIn, requestParameters.schedulableByMemberIn, requestParameters.telemedicinePerformableIn, requestParameters.urgentCarePerformableIn, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiListMedicationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    listMedications(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).listMedications(requestParameters.carePlanId, requestParameters.asserterId, requestParameters.encounterId, requestParameters.includeEnteredInErrorIn, requestParameters.problemId, requestParameters.recorderId, requestParameters.status, requestParameters.type, requestParameters.unlinkedIn, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiListMemberEmergencyContactsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    listMemberEmergencyContacts(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).listMemberEmergencyContacts(requestParameters.memberId, requestParameters.email, requestParameters.phone, requestParameters.primaryIn, requestParameters.removedIn, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiListMemberProblemHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    listMemberProblemHistory(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).listMemberProblemHistory(requestParameters.memberId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiListMissingOccupationalHealthRecordsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    listMissingOccupationalHealthRecords(requestParameters = {}, options) {
        return exports.MedicalApiFp(this.configuration).listMissingOccupationalHealthRecords(requestParameters.appointmentEndDatetime, requestParameters.appointmentStartDatetime, requestParameters.clinicId, requestParameters.companyId, requestParameters.memberId, requestParameters.occupationalHealthRecordTypeId, requestParameters.onlyClinics, requestParameters.onlyIndividualAppointments, requestParameters.orderByMostRecent, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    listOccupationalHealthRecordTypes(options) {
        return exports.MedicalApiFp(this.configuration).listOccupationalHealthRecordTypes(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiListOccupationalHealthRecordsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    listOccupationalHealthRecords(requestParameters = {}, options) {
        return exports.MedicalApiFp(this.configuration).listOccupationalHealthRecords(requestParameters.chartTypeId, requestParameters.companyId, requestParameters.completionEndDate, requestParameters.completionStartDate, requestParameters.dateOfCompletion, requestParameters.encounterId, requestParameters.enteredInErrorIn, requestParameters.medicalFileId, requestParameters.memberId, requestParameters.occupationalHealthLabOrderRequestId, requestParameters.orderByMostRecentlyCompleted, requestParameters.page, requestParameters.pendingApprovalIn, requestParameters.urgentCareOrderRequestId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiListOccupationalHealthRecordsByCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    listOccupationalHealthRecordsByCompany(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).listOccupationalHealthRecordsByCompany(requestParameters.companyId, requestParameters.approvedOnGte, requestParameters.completedOnGte, requestParameters.enteredInErrorIn, requestParameters.includeTagsIn, requestParameters.limit, requestParameters.memberId, requestParameters.memberName, requestParameters.occupationalHealthLabOrderRequestId, requestParameters.ohrTypeId, requestParameters.page, requestParameters.tagsIds, requestParameters.urgentCareOrderRequestId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiListProblemGoalsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    listProblemGoals(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).listProblemGoals(requestParameters.problemId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiListProceduresRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    listProcedures(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).listProcedures(requestParameters.medicalProfileId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiListRxOrdersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    listRxOrders(requestParameters = {}, options) {
        return exports.MedicalApiFp(this.configuration).listRxOrders(requestParameters.appointmentId, requestParameters.encounterId, requestParameters.memberId, requestParameters.page, requestParameters.providerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiListSchedulableMedicalServicesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    listSchedulableMedicalServices(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).listSchedulableMedicalServices(requestParameters.listSchedulableMedicalServicesRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiListSymptomsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    listSymptoms(requestParameters = {}, options) {
        return exports.MedicalApiFp(this.configuration).listSymptoms(requestParameters.visitReasonId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiMarkManualLabResultEnteredInErrorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    markManualLabResultEnteredInError(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).markManualLabResultEnteredInError(requestParameters.markManualLabResultEnteredInErrorRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiMarkOccupationalHealthRecordEnteredInErrorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    markOccupationalHealthRecordEnteredInError(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).markOccupationalHealthRecordEnteredInError(requestParameters.occupationalHealthRecordId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiPublishDynamicMedicalChartRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    publishDynamicMedicalChart(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).publishDynamicMedicalChart(requestParameters.dynamicMedicalChartId, requestParameters.publishDynamicMedicalChartRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiPublishLabOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    publishLabOrder(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).publishLabOrder(requestParameters.labOrderId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiPublishMedicalFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    publishMedicalFile(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).publishMedicalFile(requestParameters.medicalFileId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiRedactDynamicMedicalChartRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    redactDynamicMedicalChart(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).redactDynamicMedicalChart(requestParameters.dynamicMedicalChartId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiRedactInteractionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    redactInteraction(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).redactInteraction(requestParameters.interactionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiRedactMedicalChartFieldRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    redactMedicalChartField(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).redactMedicalChartField(requestParameters.medicalChartFieldId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiRemoveLabDrawFromLabOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    removeLabDrawFromLabOrder(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).removeLabDrawFromLabOrder(requestParameters.labOrderId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiSearchAllergiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    searchAllergies(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).searchAllergies(requestParameters.term, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiSearchConditionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    searchConditions(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).searchConditions(requestParameters.term, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiSearchIcd10TermsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    searchIcd10Terms(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).searchIcd10Terms(requestParameters.term, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiSearchMedicationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    searchMedications(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).searchMedications(requestParameters.term, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiSearchProceduresRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    searchProcedures(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).searchProcedures(requestParameters.responseType, requestParameters.term, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiUnlinkMedicationCodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    unlinkMedicationCode(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).unlinkMedicationCode(requestParameters.codeId, requestParameters.medicationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiUnlinkMedicationProblemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    unlinkMedicationProblem(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).unlinkMedicationProblem(requestParameters.medicationId, requestParameters.problemId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiUpdateAllergyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    updateAllergy(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).updateAllergy(requestParameters.allergyId, requestParameters.updateAllergyRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiUpdateCarePlanProblemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    updateCarePlanProblem(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).updateCarePlanProblem(requestParameters.problemId, requestParameters.updateProblemRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiUpdateChartingMacroRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    updateChartingMacro(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).updateChartingMacro(requestParameters.chartingMacroId, requestParameters.updateChartingMacroRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiUpdateDynamicMedicalChartRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    updateDynamicMedicalChart(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).updateDynamicMedicalChart(requestParameters.dynamicMedicalChartId, requestParameters.updateDynamicMedicalChartRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiUpdateDynamicMedicalChartResultsFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    updateDynamicMedicalChartResultsFile(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).updateDynamicMedicalChartResultsFile(requestParameters.dynamicMedicalChartId, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiUpdateEmergencyContactRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    updateEmergencyContact(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).updateEmergencyContact(requestParameters.contactId, requestParameters.updateEmergencyContactRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiUpdateFamilyMedicalHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    updateFamilyMedicalHistory(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).updateFamilyMedicalHistory(requestParameters.familyMedicalHistoryId, requestParameters.updateFamilyMedicalHistoryRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiUpdateFamilyMedicalHistoryProblemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    updateFamilyMedicalHistoryProblem(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).updateFamilyMedicalHistoryProblem(requestParameters.problemId, requestParameters.updateProblemRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiUpdateGoalTargetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    updateGoalTarget(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).updateGoalTarget(requestParameters.goalId, requestParameters.problemId, requestParameters.targetId, requestParameters.updateProblemGoalTargetRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiUpdateLabOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    updateLabOrder(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).updateLabOrder(requestParameters.labOrderId, requestParameters.updateLabOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiUpdateManualLabResultRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    updateManualLabResult(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).updateManualLabResult(requestParameters.manualLabResultId, requestParameters.updateManualLabResultRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiUpdateMedicalProfileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    updateMedicalProfile(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).updateMedicalProfile(requestParameters.memberId, requestParameters.updateMedicalProfileRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiUpdateMedicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    updateMedication(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).updateMedication(requestParameters.medicationId, requestParameters.updateMedicationRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiUpdatePreferredPharmacyForMemberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    updatePreferredPharmacyForMember(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).updatePreferredPharmacyForMember(requestParameters.memberId, requestParameters.updatePreferredPharmacyRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiUpdateProblemGoalRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    updateProblemGoal(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).updateProblemGoal(requestParameters.goalId, requestParameters.problemId, requestParameters.updateProblemGoalRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiUpdateProcedureRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    updateProcedure(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).updateProcedure(requestParameters.procedureId, requestParameters.updateProcedureRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiUpdateVitalsRecordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    updateVitalsRecord(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).updateVitalsRecord(requestParameters.vitalsRecordId, requestParameters.updateVitalsRecordRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiUploadDynamicMedicalChartAdditionalFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    uploadDynamicMedicalChartAdditionalFile(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).uploadDynamicMedicalChartAdditionalFile(requestParameters.dynamicMedicalChartId, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MedicalApiUploadMedicalProfileFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedicalApi
     */
    uploadMedicalProfileFile(requestParameters, options) {
        return exports.MedicalApiFp(this.configuration).uploadMedicalProfileFile(requestParameters.memberId, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.MedicalApi = MedicalApi;
/**
 * MemberApi - axios parameter creator
 * @export
 */
exports.MemberApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateMember: (memberId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'memberId' is not null or undefined
            common_1.assertParamExists('activateMember', 'memberId', memberId);
            const localVarPath = `/v1/members/{member_id}/activations`
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} memberId
         * @param {CreateDependentRequest} createDependentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDependent: (memberId, createDependentRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'memberId' is not null or undefined
            common_1.assertParamExists('createDependent', 'memberId', memberId);
            // verify required parameter 'createDependentRequest' is not null or undefined
            common_1.assertParamExists('createDependent', 'createDependentRequest', createDependentRequest);
            const localVarPath = `/v1/members/{member_id}/dependents`
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createDependentRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDependents: (memberId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'memberId' is not null or undefined
            common_1.assertParamExists('listDependents', 'memberId', memberId);
            const localVarPath = `/v1/members/{member_id}/dependents`
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [companyId]
         * @param {string} [dateOfBirth]
         * @param {string} [email]
         * @param {string} [guardianId]
         * @param {number} [limit]
         * @param {string} [memberId]
         * @param {'Member' | 'Dependent'} [memberType] * &#x60;Member&#x60; - Member * &#x60;Dependent&#x60; - Dependent
         * @param {string} [name]
         * @param {number} [page]
         * @param {string} [phone]
         * @param {string} [userId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMembers: (companyId, dateOfBirth, email, guardianId, limit, memberId, memberType, name, page, phone, userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/members`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }
            if (dateOfBirth !== undefined) {
                localVarQueryParameter['date_of_birth'] = (dateOfBirth instanceof Date) ?
                    dateOfBirth.toISOString().substr(0, 10) :
                    dateOfBirth;
            }
            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }
            if (guardianId !== undefined) {
                localVarQueryParameter['guardian_id'] = guardianId;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (memberId !== undefined) {
                localVarQueryParameter['member_id'] = memberId;
            }
            if (memberType !== undefined) {
                localVarQueryParameter['member_type'] = memberType;
            }
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (phone !== undefined) {
                localVarQueryParameter['phone'] = phone;
            }
            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveMember: (memberId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'memberId' is not null or undefined
            common_1.assertParamExists('retrieveMember', 'memberId', memberId);
            const localVarPath = `/v1/members/{member_id}`
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update member\'s dependent or remove dependent for member
         * @param {string} dependentId
         * @param {string} memberId
         * @param {UpdateDependentRequest} updateDependentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDependent: (dependentId, memberId, updateDependentRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'dependentId' is not null or undefined
            common_1.assertParamExists('updateDependent', 'dependentId', dependentId);
            // verify required parameter 'memberId' is not null or undefined
            common_1.assertParamExists('updateDependent', 'memberId', memberId);
            // verify required parameter 'updateDependentRequest' is not null or undefined
            common_1.assertParamExists('updateDependent', 'updateDependentRequest', updateDependentRequest);
            const localVarPath = `/v1/members/{member_id}/dependents/{dependent_id}`
                .replace(`{${"dependent_id"}}`, encodeURIComponent(String(dependentId)))
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateDependentRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} memberId
         * @param {UpdateMemberRequest} [updateMemberRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMember: (memberId, updateMemberRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'memberId' is not null or undefined
            common_1.assertParamExists('updateMember', 'memberId', memberId);
            const localVarPath = `/v1/members/{member_id}`
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateMemberRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * MemberApi - functional programming interface
 * @export
 */
exports.MemberApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.MemberApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateMember(memberId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.activateMember(memberId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} memberId
         * @param {CreateDependentRequest} createDependentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDependent(memberId, createDependentRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createDependent(memberId, createDependentRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDependents(memberId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listDependents(memberId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} [companyId]
         * @param {string} [dateOfBirth]
         * @param {string} [email]
         * @param {string} [guardianId]
         * @param {number} [limit]
         * @param {string} [memberId]
         * @param {'Member' | 'Dependent'} [memberType] * &#x60;Member&#x60; - Member * &#x60;Dependent&#x60; - Dependent
         * @param {string} [name]
         * @param {number} [page]
         * @param {string} [phone]
         * @param {string} [userId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMembers(companyId, dateOfBirth, email, guardianId, limit, memberId, memberType, name, page, phone, userId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listMembers(companyId, dateOfBirth, email, guardianId, limit, memberId, memberType, name, page, phone, userId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveMember(memberId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.retrieveMember(memberId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Update member\'s dependent or remove dependent for member
         * @param {string} dependentId
         * @param {string} memberId
         * @param {UpdateDependentRequest} updateDependentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDependent(dependentId, memberId, updateDependentRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateDependent(dependentId, memberId, updateDependentRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} memberId
         * @param {UpdateMemberRequest} [updateMemberRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMember(memberId, updateMemberRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateMember(memberId, updateMemberRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * MemberApi - factory interface
 * @export
 */
exports.MemberApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.MemberApiFp(configuration);
    return {
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateMember(memberId, options) {
            return localVarFp.activateMember(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} memberId
         * @param {CreateDependentRequest} createDependentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDependent(memberId, createDependentRequest, options) {
            return localVarFp.createDependent(memberId, createDependentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDependents(memberId, options) {
            return localVarFp.listDependents(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [companyId]
         * @param {string} [dateOfBirth]
         * @param {string} [email]
         * @param {string} [guardianId]
         * @param {number} [limit]
         * @param {string} [memberId]
         * @param {'Member' | 'Dependent'} [memberType] * &#x60;Member&#x60; - Member * &#x60;Dependent&#x60; - Dependent
         * @param {string} [name]
         * @param {number} [page]
         * @param {string} [phone]
         * @param {string} [userId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMembers(companyId, dateOfBirth, email, guardianId, limit, memberId, memberType, name, page, phone, userId, options) {
            return localVarFp.listMembers(companyId, dateOfBirth, email, guardianId, limit, memberId, memberType, name, page, phone, userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveMember(memberId, options) {
            return localVarFp.retrieveMember(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update member\'s dependent or remove dependent for member
         * @param {string} dependentId
         * @param {string} memberId
         * @param {UpdateDependentRequest} updateDependentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDependent(dependentId, memberId, updateDependentRequest, options) {
            return localVarFp.updateDependent(dependentId, memberId, updateDependentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} memberId
         * @param {UpdateMemberRequest} [updateMemberRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMember(memberId, updateMemberRequest, options) {
            return localVarFp.updateMember(memberId, updateMemberRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * MemberApi - object-oriented interface
 * @export
 * @class MemberApi
 * @extends {BaseAPI}
 */
class MemberApi extends base_1.BaseAPI {
    /**
     *
     * @param {MemberApiActivateMemberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberApi
     */
    activateMember(requestParameters, options) {
        return exports.MemberApiFp(this.configuration).activateMember(requestParameters.memberId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MemberApiCreateDependentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberApi
     */
    createDependent(requestParameters, options) {
        return exports.MemberApiFp(this.configuration).createDependent(requestParameters.memberId, requestParameters.createDependentRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MemberApiListDependentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberApi
     */
    listDependents(requestParameters, options) {
        return exports.MemberApiFp(this.configuration).listDependents(requestParameters.memberId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MemberApiListMembersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberApi
     */
    listMembers(requestParameters = {}, options) {
        return exports.MemberApiFp(this.configuration).listMembers(requestParameters.companyId, requestParameters.dateOfBirth, requestParameters.email, requestParameters.guardianId, requestParameters.limit, requestParameters.memberId, requestParameters.memberType, requestParameters.name, requestParameters.page, requestParameters.phone, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MemberApiRetrieveMemberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberApi
     */
    retrieveMember(requestParameters, options) {
        return exports.MemberApiFp(this.configuration).retrieveMember(requestParameters.memberId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Update member\'s dependent or remove dependent for member
     * @param {MemberApiUpdateDependentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberApi
     */
    updateDependent(requestParameters, options) {
        return exports.MemberApiFp(this.configuration).updateDependent(requestParameters.dependentId, requestParameters.memberId, requestParameters.updateDependentRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MemberApiUpdateMemberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberApi
     */
    updateMember(requestParameters, options) {
        return exports.MemberApiFp(this.configuration).updateMember(requestParameters.memberId, requestParameters.updateMemberRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.MemberApi = MemberApi;
/**
 * NotificationApi - axios parameter creator
 * @export
 */
exports.NotificationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {SendSlackNotificationApiRequest} sendSlackNotificationApiRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendSlackNotification: (sendSlackNotificationApiRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'sendSlackNotificationApiRequest' is not null or undefined
            common_1.assertParamExists('sendSlackNotification', 'sendSlackNotificationApiRequest', sendSlackNotificationApiRequest);
            const localVarPath = `/v1/notifications/slack`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(sendSlackNotificationApiRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * NotificationApi - functional programming interface
 * @export
 */
exports.NotificationApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.NotificationApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {SendSlackNotificationApiRequest} sendSlackNotificationApiRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendSlackNotification(sendSlackNotificationApiRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sendSlackNotification(sendSlackNotificationApiRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * NotificationApi - factory interface
 * @export
 */
exports.NotificationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.NotificationApiFp(configuration);
    return {
        /**
         *
         * @param {SendSlackNotificationApiRequest} sendSlackNotificationApiRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendSlackNotification(sendSlackNotificationApiRequest, options) {
            return localVarFp.sendSlackNotification(sendSlackNotificationApiRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * NotificationApi - object-oriented interface
 * @export
 * @class NotificationApi
 * @extends {BaseAPI}
 */
class NotificationApi extends base_1.BaseAPI {
    /**
     *
     * @param {NotificationApiSendSlackNotificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    sendSlackNotification(requestParameters, options) {
        return exports.NotificationApiFp(this.configuration).sendSlackNotification(requestParameters.sendSlackNotificationApiRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.NotificationApi = NotificationApi;
/**
 * NotificationPreferencesApi - axios parameter creator
 * @export
 */
exports.NotificationPreferencesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} notificationPreferencesId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationPreferences: (notificationPreferencesId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'notificationPreferencesId' is not null or undefined
            common_1.assertParamExists('getNotificationPreferences', 'notificationPreferencesId', notificationPreferencesId);
            const localVarPath = `/v1/notification-preferences/{notification_preferences_id}`
                .replace(`{${"notification_preferences_id"}}`, encodeURIComponent(String(notificationPreferencesId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} notificationPreferencesId
         * @param {UpdateNotificationPreferencesRequest} [updateNotificationPreferencesRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotificationPreferences: (notificationPreferencesId, updateNotificationPreferencesRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'notificationPreferencesId' is not null or undefined
            common_1.assertParamExists('updateNotificationPreferences', 'notificationPreferencesId', notificationPreferencesId);
            const localVarPath = `/v1/notification-preferences/{notification_preferences_id}`
                .replace(`{${"notification_preferences_id"}}`, encodeURIComponent(String(notificationPreferencesId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateNotificationPreferencesRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * NotificationPreferencesApi - functional programming interface
 * @export
 */
exports.NotificationPreferencesApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.NotificationPreferencesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} notificationPreferencesId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationPreferences(notificationPreferencesId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getNotificationPreferences(notificationPreferencesId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} notificationPreferencesId
         * @param {UpdateNotificationPreferencesRequest} [updateNotificationPreferencesRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotificationPreferences(notificationPreferencesId, updateNotificationPreferencesRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateNotificationPreferences(notificationPreferencesId, updateNotificationPreferencesRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * NotificationPreferencesApi - factory interface
 * @export
 */
exports.NotificationPreferencesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.NotificationPreferencesApiFp(configuration);
    return {
        /**
         *
         * @param {string} notificationPreferencesId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationPreferences(notificationPreferencesId, options) {
            return localVarFp.getNotificationPreferences(notificationPreferencesId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} notificationPreferencesId
         * @param {UpdateNotificationPreferencesRequest} [updateNotificationPreferencesRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotificationPreferences(notificationPreferencesId, updateNotificationPreferencesRequest, options) {
            return localVarFp.updateNotificationPreferences(notificationPreferencesId, updateNotificationPreferencesRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * NotificationPreferencesApi - object-oriented interface
 * @export
 * @class NotificationPreferencesApi
 * @extends {BaseAPI}
 */
class NotificationPreferencesApi extends base_1.BaseAPI {
    /**
     *
     * @param {NotificationPreferencesApiGetNotificationPreferencesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationPreferencesApi
     */
    getNotificationPreferences(requestParameters, options) {
        return exports.NotificationPreferencesApiFp(this.configuration).getNotificationPreferences(requestParameters.notificationPreferencesId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {NotificationPreferencesApiUpdateNotificationPreferencesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationPreferencesApi
     */
    updateNotificationPreferences(requestParameters, options) {
        return exports.NotificationPreferencesApiFp(this.configuration).updateNotificationPreferences(requestParameters.notificationPreferencesId, requestParameters.updateNotificationPreferencesRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.NotificationPreferencesApi = NotificationPreferencesApi;
/**
 * OnsiteClinicApi - axios parameter creator
 * @export
 */
exports.OnsiteClinicApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} onsiteClinicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnsiteClinic: (onsiteClinicId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'onsiteClinicId' is not null or undefined
            common_1.assertParamExists('getOnsiteClinic', 'onsiteClinicId', onsiteClinicId);
            const localVarPath = `/v1/onsite-clinics/{onsite_clinic_id}`
                .replace(`{${"onsite_clinic_id"}}`, encodeURIComponent(String(onsiteClinicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOnsiteClinics: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/onsite-clinics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * OnsiteClinicApi - functional programming interface
 * @export
 */
exports.OnsiteClinicApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.OnsiteClinicApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} onsiteClinicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnsiteClinic(onsiteClinicId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getOnsiteClinic(onsiteClinicId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOnsiteClinics(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listOnsiteClinics(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * OnsiteClinicApi - factory interface
 * @export
 */
exports.OnsiteClinicApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.OnsiteClinicApiFp(configuration);
    return {
        /**
         *
         * @param {string} onsiteClinicId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnsiteClinic(onsiteClinicId, options) {
            return localVarFp.getOnsiteClinic(onsiteClinicId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOnsiteClinics(options) {
            return localVarFp.listOnsiteClinics(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * OnsiteClinicApi - object-oriented interface
 * @export
 * @class OnsiteClinicApi
 * @extends {BaseAPI}
 */
class OnsiteClinicApi extends base_1.BaseAPI {
    /**
     *
     * @param {OnsiteClinicApiGetOnsiteClinicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnsiteClinicApi
     */
    getOnsiteClinic(requestParameters, options) {
        return exports.OnsiteClinicApiFp(this.configuration).getOnsiteClinic(requestParameters.onsiteClinicId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnsiteClinicApi
     */
    listOnsiteClinics(options) {
        return exports.OnsiteClinicApiFp(this.configuration).listOnsiteClinics(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.OnsiteClinicApi = OnsiteClinicApi;
/**
 * PBMApi - axios parameter creator
 * @export
 */
exports.PBMApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPharmacyCardsForCompany: (companyId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyId' is not null or undefined
            common_1.assertParamExists('createPharmacyCardsForCompany', 'companyId', companyId);
            const localVarPath = `/v1/companies/{company_id}/pharmacy-cards`
                .replace(`{${"company_id"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {'Ventegra' | 'null'} [coveredBy] * &#x60;Ventegra&#x60; - Ventegra
         * @param {boolean} [distinctDisplay]
         * @param {number} [limit]
         * @param {string} [medicationName]
         * @param {string} [ndcCodes]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCoveredMedications: (coveredBy, distinctDisplay, limit, medicationName, ndcCodes, page, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/covered-medications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (coveredBy !== undefined) {
                localVarQueryParameter['covered_by'] = coveredBy;
            }
            if (distinctDisplay !== undefined) {
                localVarQueryParameter['distinct_display'] = distinctDisplay;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (medicationName !== undefined) {
                localVarQueryParameter['medication_name'] = medicationName;
            }
            if (ndcCodes !== undefined) {
                localVarQueryParameter['ndc_codes'] = ndcCodes;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<string>} [ncpdpids]
         * @param {string} [pharmacyName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCoveredPharmacies: (ncpdpids, pharmacyName, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/covered-pharmacies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (ncpdpids) {
                localVarQueryParameter['ncpdpids'] = ncpdpids;
            }
            if (pharmacyName !== undefined) {
                localVarQueryParameter['pharmacy_name'] = pharmacyName;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {boolean} [activeIn]
         * @param {'Ventegra' | 'null'} [coveredBy] * &#x60;Ventegra&#x60; - Ventegra
         * @param {string} [memberId]
         * @param {string} [rxGroupNum]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPharmacyCards: (activeIn, coveredBy, memberId, rxGroupNum, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/pharmacy-cards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (activeIn !== undefined) {
                localVarQueryParameter['active_in'] = activeIn;
            }
            if (coveredBy !== undefined) {
                localVarQueryParameter['covered_by'] = coveredBy;
            }
            if (memberId !== undefined) {
                localVarQueryParameter['member_id'] = memberId;
            }
            if (rxGroupNum !== undefined) {
                localVarQueryParameter['rx_group_num'] = rxGroupNum;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {RequestCoveredMedicationApiRequest} requestCoveredMedicationApiRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestCoveredMedication: (requestCoveredMedicationApiRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'requestCoveredMedicationApiRequest' is not null or undefined
            common_1.assertParamExists('requestCoveredMedication', 'requestCoveredMedicationApiRequest', requestCoveredMedicationApiRequest);
            const localVarPath = `/v1/covered-medications/request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(requestCoveredMedicationApiRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SearchPharmaciesRequest} [searchPharmaciesRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPharmacies: (searchPharmaciesRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/search-pharmacies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(searchPharmaciesRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} csvFile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCoveredMedications: (csvFile, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'csvFile' is not null or undefined
            common_1.assertParamExists('uploadCoveredMedications', 'csvFile', csvFile);
            const localVarPath = `/v1/covered-medications/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (csvFile !== undefined) {
                localVarFormParams.append('csv_file', csvFile);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} csvFile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCoveredPharmacies: (csvFile, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'csvFile' is not null or undefined
            common_1.assertParamExists('uploadCoveredPharmacies', 'csvFile', csvFile);
            const localVarPath = `/v1/covered-pharmacies/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (csvFile !== undefined) {
                localVarFormParams.append('csv_file', csvFile);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PBMApi - functional programming interface
 * @export
 */
exports.PBMApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.PBMApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPharmacyCardsForCompany(companyId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createPharmacyCardsForCompany(companyId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {'Ventegra' | 'null'} [coveredBy] * &#x60;Ventegra&#x60; - Ventegra
         * @param {boolean} [distinctDisplay]
         * @param {number} [limit]
         * @param {string} [medicationName]
         * @param {string} [ndcCodes]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCoveredMedications(coveredBy, distinctDisplay, limit, medicationName, ndcCodes, page, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listCoveredMedications(coveredBy, distinctDisplay, limit, medicationName, ndcCodes, page, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {Array<string>} [ncpdpids]
         * @param {string} [pharmacyName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCoveredPharmacies(ncpdpids, pharmacyName, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listCoveredPharmacies(ncpdpids, pharmacyName, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {boolean} [activeIn]
         * @param {'Ventegra' | 'null'} [coveredBy] * &#x60;Ventegra&#x60; - Ventegra
         * @param {string} [memberId]
         * @param {string} [rxGroupNum]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPharmacyCards(activeIn, coveredBy, memberId, rxGroupNum, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listPharmacyCards(activeIn, coveredBy, memberId, rxGroupNum, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {RequestCoveredMedicationApiRequest} requestCoveredMedicationApiRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestCoveredMedication(requestCoveredMedicationApiRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.requestCoveredMedication(requestCoveredMedicationApiRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {SearchPharmaciesRequest} [searchPharmaciesRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPharmacies(searchPharmaciesRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchPharmacies(searchPharmaciesRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} csvFile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCoveredMedications(csvFile, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.uploadCoveredMedications(csvFile, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} csvFile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCoveredPharmacies(csvFile, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.uploadCoveredPharmacies(csvFile, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * PBMApi - factory interface
 * @export
 */
exports.PBMApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.PBMApiFp(configuration);
    return {
        /**
         *
         * @param {string} companyId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPharmacyCardsForCompany(companyId, options) {
            return localVarFp.createPharmacyCardsForCompany(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {'Ventegra' | 'null'} [coveredBy] * &#x60;Ventegra&#x60; - Ventegra
         * @param {boolean} [distinctDisplay]
         * @param {number} [limit]
         * @param {string} [medicationName]
         * @param {string} [ndcCodes]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCoveredMedications(coveredBy, distinctDisplay, limit, medicationName, ndcCodes, page, options) {
            return localVarFp.listCoveredMedications(coveredBy, distinctDisplay, limit, medicationName, ndcCodes, page, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<string>} [ncpdpids]
         * @param {string} [pharmacyName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCoveredPharmacies(ncpdpids, pharmacyName, options) {
            return localVarFp.listCoveredPharmacies(ncpdpids, pharmacyName, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {boolean} [activeIn]
         * @param {'Ventegra' | 'null'} [coveredBy] * &#x60;Ventegra&#x60; - Ventegra
         * @param {string} [memberId]
         * @param {string} [rxGroupNum]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPharmacyCards(activeIn, coveredBy, memberId, rxGroupNum, options) {
            return localVarFp.listPharmacyCards(activeIn, coveredBy, memberId, rxGroupNum, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {RequestCoveredMedicationApiRequest} requestCoveredMedicationApiRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestCoveredMedication(requestCoveredMedicationApiRequest, options) {
            return localVarFp.requestCoveredMedication(requestCoveredMedicationApiRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SearchPharmaciesRequest} [searchPharmaciesRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPharmacies(searchPharmaciesRequest, options) {
            return localVarFp.searchPharmacies(searchPharmaciesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} csvFile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCoveredMedications(csvFile, options) {
            return localVarFp.uploadCoveredMedications(csvFile, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} csvFile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCoveredPharmacies(csvFile, options) {
            return localVarFp.uploadCoveredPharmacies(csvFile, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PBMApi - object-oriented interface
 * @export
 * @class PBMApi
 * @extends {BaseAPI}
 */
class PBMApi extends base_1.BaseAPI {
    /**
     *
     * @param {PBMApiCreatePharmacyCardsForCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PBMApi
     */
    createPharmacyCardsForCompany(requestParameters, options) {
        return exports.PBMApiFp(this.configuration).createPharmacyCardsForCompany(requestParameters.companyId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PBMApiListCoveredMedicationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PBMApi
     */
    listCoveredMedications(requestParameters = {}, options) {
        return exports.PBMApiFp(this.configuration).listCoveredMedications(requestParameters.coveredBy, requestParameters.distinctDisplay, requestParameters.limit, requestParameters.medicationName, requestParameters.ndcCodes, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PBMApiListCoveredPharmaciesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PBMApi
     */
    listCoveredPharmacies(requestParameters = {}, options) {
        return exports.PBMApiFp(this.configuration).listCoveredPharmacies(requestParameters.ncpdpids, requestParameters.pharmacyName, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PBMApiListPharmacyCardsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PBMApi
     */
    listPharmacyCards(requestParameters = {}, options) {
        return exports.PBMApiFp(this.configuration).listPharmacyCards(requestParameters.activeIn, requestParameters.coveredBy, requestParameters.memberId, requestParameters.rxGroupNum, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PBMApiRequestCoveredMedicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PBMApi
     */
    requestCoveredMedication(requestParameters, options) {
        return exports.PBMApiFp(this.configuration).requestCoveredMedication(requestParameters.requestCoveredMedicationApiRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PBMApiSearchPharmaciesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PBMApi
     */
    searchPharmacies(requestParameters = {}, options) {
        return exports.PBMApiFp(this.configuration).searchPharmacies(requestParameters.searchPharmaciesRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PBMApiUploadCoveredMedicationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PBMApi
     */
    uploadCoveredMedications(requestParameters, options) {
        return exports.PBMApiFp(this.configuration).uploadCoveredMedications(requestParameters.csvFile, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PBMApiUploadCoveredPharmaciesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PBMApi
     */
    uploadCoveredPharmacies(requestParameters, options) {
        return exports.PBMApiFp(this.configuration).uploadCoveredPharmacies(requestParameters.csvFile, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PBMApi = PBMApi;
/**
 * PartnersApi - axios parameter creator
 * @export
 */
exports.PartnersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreatePartnerRequest} createPartnerRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPartner: (createPartnerRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createPartnerRequest' is not null or undefined
            common_1.assertParamExists('createPartner', 'createPartnerRequest', createPartnerRequest);
            const localVarPath = `/v1/partners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createPartnerRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CreatePartnerDealRequest} createPartnerDealRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPartnerDeal: (createPartnerDealRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createPartnerDealRequest' is not null or undefined
            common_1.assertParamExists('createPartnerDeal', 'createPartnerDealRequest', createPartnerDealRequest);
            const localVarPath = `/v1/partners/deals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createPartnerDealRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} partnerId
         * @param {CreatePartnerEmployeeRequest} createPartnerEmployeeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPartnerEmployee: (partnerId, createPartnerEmployeeRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partnerId' is not null or undefined
            common_1.assertParamExists('createPartnerEmployee', 'partnerId', partnerId);
            // verify required parameter 'createPartnerEmployeeRequest' is not null or undefined
            common_1.assertParamExists('createPartnerEmployee', 'createPartnerEmployeeRequest', createPartnerEmployeeRequest);
            const localVarPath = `/v1/partners/{partner_id}/employees`
                .replace(`{${"partner_id"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createPartnerEmployeeRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CreatePartnerEmployeeDealRequest} createPartnerEmployeeDealRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPartnerEmployeeDeal: (createPartnerEmployeeDealRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createPartnerEmployeeDealRequest' is not null or undefined
            common_1.assertParamExists('createPartnerEmployeeDeal', 'createPartnerEmployeeDealRequest', createPartnerEmployeeDealRequest);
            const localVarPath = `/v1/partners/employees/deals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createPartnerEmployeeDealRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} partnerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartner: (partnerId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partnerId' is not null or undefined
            common_1.assertParamExists('getPartner', 'partnerId', partnerId);
            const localVarPath = `/v1/partners/{partner_id}`
                .replace(`{${"partner_id"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} partnerDealId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerDeal: (partnerDealId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partnerDealId' is not null or undefined
            common_1.assertParamExists('getPartnerDeal', 'partnerDealId', partnerDealId);
            const localVarPath = `/v1/partners/deals/{partner_deal_id}`
                .replace(`{${"partner_deal_id"}}`, encodeURIComponent(String(partnerDealId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {boolean} [activeIn]
         * @param {string} [companyId]
         * @param {string} [partnerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPartnerDeals: (activeIn, companyId, partnerId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/partners/deals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (activeIn !== undefined) {
                localVarQueryParameter['active_in'] = activeIn;
            }
            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }
            if (partnerId !== undefined) {
                localVarQueryParameter['partner_id'] = partnerId;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {boolean} [activeIn]
         * @param {string} [partnerDealId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPartnerEmployeeDeals: (activeIn, partnerDealId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/partners/employees/deals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (activeIn !== undefined) {
                localVarQueryParameter['active_in'] = activeIn;
            }
            if (partnerDealId !== undefined) {
                localVarQueryParameter['partner_deal_id'] = partnerDealId;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} partnerId
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPartnerEmployees: (partnerId, page, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partnerId' is not null or undefined
            common_1.assertParamExists('listPartnerEmployees', 'partnerId', partnerId);
            const localVarPath = `/v1/partners/{partner_id}/employees`
                .replace(`{${"partner_id"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [name]
         * @param {number} [page]
         * @param {'Brokerage' | 'Third Party Administrator' | 'General Agent' | 'Channel Partner'} [partnerType] * &#x60;Brokerage&#x60; - Brokerage * &#x60;Third Party Administrator&#x60; - Third Party Administrator * &#x60;General Agent&#x60; - General Agent * &#x60;Channel Partner&#x60; - Channel Partner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPartners: (name, page, partnerType, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/partners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (partnerType !== undefined) {
                localVarQueryParameter['partner_type'] = partnerType;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {TerminatePartnerDealRequest} terminatePartnerDealRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terminatePartnerDeal: (terminatePartnerDealRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'terminatePartnerDealRequest' is not null or undefined
            common_1.assertParamExists('terminatePartnerDeal', 'terminatePartnerDealRequest', terminatePartnerDealRequest);
            const localVarPath = `/v1/partners/deals/terminate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(terminatePartnerDealRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {TerminatePartnerEmployeeDealRequest} terminatePartnerEmployeeDealRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terminatePartnerEmployeeDeal: (terminatePartnerEmployeeDealRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'terminatePartnerEmployeeDealRequest' is not null or undefined
            common_1.assertParamExists('terminatePartnerEmployeeDeal', 'terminatePartnerEmployeeDealRequest', terminatePartnerEmployeeDealRequest);
            const localVarPath = `/v1/partners/employees/deals/terminate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(terminatePartnerEmployeeDealRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PartnersApi - functional programming interface
 * @export
 */
exports.PartnersApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.PartnersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CreatePartnerRequest} createPartnerRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPartner(createPartnerRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createPartner(createPartnerRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {CreatePartnerDealRequest} createPartnerDealRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPartnerDeal(createPartnerDealRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createPartnerDeal(createPartnerDealRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} partnerId
         * @param {CreatePartnerEmployeeRequest} createPartnerEmployeeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPartnerEmployee(partnerId, createPartnerEmployeeRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createPartnerEmployee(partnerId, createPartnerEmployeeRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {CreatePartnerEmployeeDealRequest} createPartnerEmployeeDealRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPartnerEmployeeDeal(createPartnerEmployeeDealRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createPartnerEmployeeDeal(createPartnerEmployeeDealRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} partnerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartner(partnerId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPartner(partnerId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} partnerDealId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerDeal(partnerDealId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPartnerDeal(partnerDealId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {boolean} [activeIn]
         * @param {string} [companyId]
         * @param {string} [partnerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPartnerDeals(activeIn, companyId, partnerId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listPartnerDeals(activeIn, companyId, partnerId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {boolean} [activeIn]
         * @param {string} [partnerDealId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPartnerEmployeeDeals(activeIn, partnerDealId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listPartnerEmployeeDeals(activeIn, partnerDealId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} partnerId
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPartnerEmployees(partnerId, page, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listPartnerEmployees(partnerId, page, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} [name]
         * @param {number} [page]
         * @param {'Brokerage' | 'Third Party Administrator' | 'General Agent' | 'Channel Partner'} [partnerType] * &#x60;Brokerage&#x60; - Brokerage * &#x60;Third Party Administrator&#x60; - Third Party Administrator * &#x60;General Agent&#x60; - General Agent * &#x60;Channel Partner&#x60; - Channel Partner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPartners(name, page, partnerType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listPartners(name, page, partnerType, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {TerminatePartnerDealRequest} terminatePartnerDealRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terminatePartnerDeal(terminatePartnerDealRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.terminatePartnerDeal(terminatePartnerDealRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {TerminatePartnerEmployeeDealRequest} terminatePartnerEmployeeDealRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terminatePartnerEmployeeDeal(terminatePartnerEmployeeDealRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.terminatePartnerEmployeeDeal(terminatePartnerEmployeeDealRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * PartnersApi - factory interface
 * @export
 */
exports.PartnersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.PartnersApiFp(configuration);
    return {
        /**
         *
         * @param {CreatePartnerRequest} createPartnerRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPartner(createPartnerRequest, options) {
            return localVarFp.createPartner(createPartnerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreatePartnerDealRequest} createPartnerDealRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPartnerDeal(createPartnerDealRequest, options) {
            return localVarFp.createPartnerDeal(createPartnerDealRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} partnerId
         * @param {CreatePartnerEmployeeRequest} createPartnerEmployeeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPartnerEmployee(partnerId, createPartnerEmployeeRequest, options) {
            return localVarFp.createPartnerEmployee(partnerId, createPartnerEmployeeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreatePartnerEmployeeDealRequest} createPartnerEmployeeDealRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPartnerEmployeeDeal(createPartnerEmployeeDealRequest, options) {
            return localVarFp.createPartnerEmployeeDeal(createPartnerEmployeeDealRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} partnerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartner(partnerId, options) {
            return localVarFp.getPartner(partnerId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} partnerDealId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerDeal(partnerDealId, options) {
            return localVarFp.getPartnerDeal(partnerDealId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {boolean} [activeIn]
         * @param {string} [companyId]
         * @param {string} [partnerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPartnerDeals(activeIn, companyId, partnerId, options) {
            return localVarFp.listPartnerDeals(activeIn, companyId, partnerId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {boolean} [activeIn]
         * @param {string} [partnerDealId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPartnerEmployeeDeals(activeIn, partnerDealId, options) {
            return localVarFp.listPartnerEmployeeDeals(activeIn, partnerDealId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} partnerId
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPartnerEmployees(partnerId, page, options) {
            return localVarFp.listPartnerEmployees(partnerId, page, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [name]
         * @param {number} [page]
         * @param {'Brokerage' | 'Third Party Administrator' | 'General Agent' | 'Channel Partner'} [partnerType] * &#x60;Brokerage&#x60; - Brokerage * &#x60;Third Party Administrator&#x60; - Third Party Administrator * &#x60;General Agent&#x60; - General Agent * &#x60;Channel Partner&#x60; - Channel Partner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPartners(name, page, partnerType, options) {
            return localVarFp.listPartners(name, page, partnerType, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {TerminatePartnerDealRequest} terminatePartnerDealRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terminatePartnerDeal(terminatePartnerDealRequest, options) {
            return localVarFp.terminatePartnerDeal(terminatePartnerDealRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {TerminatePartnerEmployeeDealRequest} terminatePartnerEmployeeDealRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        terminatePartnerEmployeeDeal(terminatePartnerEmployeeDealRequest, options) {
            return localVarFp.terminatePartnerEmployeeDeal(terminatePartnerEmployeeDealRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PartnersApi - object-oriented interface
 * @export
 * @class PartnersApi
 * @extends {BaseAPI}
 */
class PartnersApi extends base_1.BaseAPI {
    /**
     *
     * @param {PartnersApiCreatePartnerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    createPartner(requestParameters, options) {
        return exports.PartnersApiFp(this.configuration).createPartner(requestParameters.createPartnerRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PartnersApiCreatePartnerDealRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    createPartnerDeal(requestParameters, options) {
        return exports.PartnersApiFp(this.configuration).createPartnerDeal(requestParameters.createPartnerDealRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PartnersApiCreatePartnerEmployeeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    createPartnerEmployee(requestParameters, options) {
        return exports.PartnersApiFp(this.configuration).createPartnerEmployee(requestParameters.partnerId, requestParameters.createPartnerEmployeeRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PartnersApiCreatePartnerEmployeeDealRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    createPartnerEmployeeDeal(requestParameters, options) {
        return exports.PartnersApiFp(this.configuration).createPartnerEmployeeDeal(requestParameters.createPartnerEmployeeDealRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PartnersApiGetPartnerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    getPartner(requestParameters, options) {
        return exports.PartnersApiFp(this.configuration).getPartner(requestParameters.partnerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PartnersApiGetPartnerDealRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    getPartnerDeal(requestParameters, options) {
        return exports.PartnersApiFp(this.configuration).getPartnerDeal(requestParameters.partnerDealId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PartnersApiListPartnerDealsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    listPartnerDeals(requestParameters = {}, options) {
        return exports.PartnersApiFp(this.configuration).listPartnerDeals(requestParameters.activeIn, requestParameters.companyId, requestParameters.partnerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PartnersApiListPartnerEmployeeDealsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    listPartnerEmployeeDeals(requestParameters = {}, options) {
        return exports.PartnersApiFp(this.configuration).listPartnerEmployeeDeals(requestParameters.activeIn, requestParameters.partnerDealId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PartnersApiListPartnerEmployeesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    listPartnerEmployees(requestParameters, options) {
        return exports.PartnersApiFp(this.configuration).listPartnerEmployees(requestParameters.partnerId, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PartnersApiListPartnersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    listPartners(requestParameters = {}, options) {
        return exports.PartnersApiFp(this.configuration).listPartners(requestParameters.name, requestParameters.page, requestParameters.partnerType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PartnersApiTerminatePartnerDealRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    terminatePartnerDeal(requestParameters, options) {
        return exports.PartnersApiFp(this.configuration).terminatePartnerDeal(requestParameters.terminatePartnerDealRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PartnersApiTerminatePartnerEmployeeDealRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    terminatePartnerEmployeeDeal(requestParameters, options) {
        return exports.PartnersApiFp(this.configuration).terminatePartnerEmployeeDeal(requestParameters.terminatePartnerEmployeeDealRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PartnersApi = PartnersApi;
/**
 * PrimaryCareVisitCheckInApi - axios parameter creator
 * @export
 */
exports.PrimaryCareVisitCheckInApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} checkInId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completePrimaryCareCheckin: (checkInId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'checkInId' is not null or undefined
            common_1.assertParamExists('completePrimaryCareCheckin', 'checkInId', checkInId);
            const localVarPath = `/v1/primary-care-visit_checkins/{check_in_id}/complete`
                .replace(`{${"check_in_id"}}`, encodeURIComponent(String(checkInId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} checkInId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrimaryCareCheckin: (checkInId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'checkInId' is not null or undefined
            common_1.assertParamExists('getPrimaryCareCheckin', 'checkInId', checkInId);
            const localVarPath = `/v1/primary-care-visit_checkins/{check_in_id}`
                .replace(`{${"check_in_id"}}`, encodeURIComponent(String(checkInId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {boolean} [completedIn]
         * @param {string} [encounterId]
         * @param {string} [memberId]
         * @param {boolean} [pendingOnlyIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPrimaryCareCheckins: (completedIn, encounterId, memberId, pendingOnlyIn, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/primary-care-visit-checkins`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (completedIn !== undefined) {
                localVarQueryParameter['completed_in'] = completedIn;
            }
            if (encounterId !== undefined) {
                localVarQueryParameter['encounter_id'] = encounterId;
            }
            if (memberId !== undefined) {
                localVarQueryParameter['member_id'] = memberId;
            }
            if (pendingOnlyIn !== undefined) {
                localVarQueryParameter['pending_only_in'] = pendingOnlyIn;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PrimaryCareVisitCheckInApi - functional programming interface
 * @export
 */
exports.PrimaryCareVisitCheckInApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.PrimaryCareVisitCheckInApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} checkInId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completePrimaryCareCheckin(checkInId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.completePrimaryCareCheckin(checkInId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} checkInId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrimaryCareCheckin(checkInId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPrimaryCareCheckin(checkInId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {boolean} [completedIn]
         * @param {string} [encounterId]
         * @param {string} [memberId]
         * @param {boolean} [pendingOnlyIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPrimaryCareCheckins(completedIn, encounterId, memberId, pendingOnlyIn, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listPrimaryCareCheckins(completedIn, encounterId, memberId, pendingOnlyIn, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * PrimaryCareVisitCheckInApi - factory interface
 * @export
 */
exports.PrimaryCareVisitCheckInApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.PrimaryCareVisitCheckInApiFp(configuration);
    return {
        /**
         *
         * @param {string} checkInId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completePrimaryCareCheckin(checkInId, options) {
            return localVarFp.completePrimaryCareCheckin(checkInId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} checkInId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrimaryCareCheckin(checkInId, options) {
            return localVarFp.getPrimaryCareCheckin(checkInId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {boolean} [completedIn]
         * @param {string} [encounterId]
         * @param {string} [memberId]
         * @param {boolean} [pendingOnlyIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPrimaryCareCheckins(completedIn, encounterId, memberId, pendingOnlyIn, options) {
            return localVarFp.listPrimaryCareCheckins(completedIn, encounterId, memberId, pendingOnlyIn, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PrimaryCareVisitCheckInApi - object-oriented interface
 * @export
 * @class PrimaryCareVisitCheckInApi
 * @extends {BaseAPI}
 */
class PrimaryCareVisitCheckInApi extends base_1.BaseAPI {
    /**
     *
     * @param {PrimaryCareVisitCheckInApiCompletePrimaryCareCheckinRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrimaryCareVisitCheckInApi
     */
    completePrimaryCareCheckin(requestParameters, options) {
        return exports.PrimaryCareVisitCheckInApiFp(this.configuration).completePrimaryCareCheckin(requestParameters.checkInId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PrimaryCareVisitCheckInApiGetPrimaryCareCheckinRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrimaryCareVisitCheckInApi
     */
    getPrimaryCareCheckin(requestParameters, options) {
        return exports.PrimaryCareVisitCheckInApiFp(this.configuration).getPrimaryCareCheckin(requestParameters.checkInId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PrimaryCareVisitCheckInApiListPrimaryCareCheckinsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrimaryCareVisitCheckInApi
     */
    listPrimaryCareCheckins(requestParameters = {}, options) {
        return exports.PrimaryCareVisitCheckInApiFp(this.configuration).listPrimaryCareCheckins(requestParameters.completedIn, requestParameters.encounterId, requestParameters.memberId, requestParameters.pendingOnlyIn, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PrimaryCareVisitCheckInApi = PrimaryCareVisitCheckInApi;
/**
 * ProviderApi - axios parameter creator
 * @export
 */
exports.ProviderApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} providerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEPrescribingToken: (providerId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'providerId' is not null or undefined
            common_1.assertParamExists('getEPrescribingToken', 'providerId', providerId);
            const localVarPath = `/v1/providers/{provider_id}/e-prescribing-token`
                .replace(`{${"provider_id"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} providerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProvider: (providerId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'providerId' is not null or undefined
            common_1.assertParamExists('getProvider', 'providerId', providerId);
            const localVarPath = `/v1/providers/{provider_id}`
                .replace(`{${"provider_id"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {'AL' | 'AK' | 'AZ' | 'AR' | 'CA' | 'CO' | 'CT' | 'DC' | 'DE' | 'FL' | 'GA' | 'HI' | 'ID' | 'IL' | 'IN' | 'IA' | 'KS' | 'KY' | 'LA' | 'ME' | 'MD' | 'MA' | 'MI' | 'MN' | 'MS' | 'MO' | 'MT' | 'NE' | 'NV' | 'NH' | 'NJ' | 'NM' | 'NY' | 'NC' | 'ND' | 'OH' | 'OK' | 'OR' | 'PR' | 'PA' | 'RI' | 'SC' | 'SD' | 'TN' | 'TX' | 'UT' | 'VT' | 'VI' | 'VA' | 'WA' | 'WI' | 'WV' | 'WY' | 'AA' | 'AE' | 'PW' | 'AP' | 'FM' | 'MH' | 'GU'} [coveredState] * &#x60;AL&#x60; - AL * &#x60;AK&#x60; - AK * &#x60;AZ&#x60; - AZ * &#x60;AR&#x60; - AR * &#x60;CA&#x60; - CA * &#x60;CO&#x60; - CO * &#x60;CT&#x60; - CT * &#x60;DC&#x60; - DC * &#x60;DE&#x60; - DE * &#x60;FL&#x60; - FL * &#x60;GA&#x60; - GA * &#x60;HI&#x60; - HI * &#x60;ID&#x60; - ID * &#x60;IL&#x60; - IL * &#x60;IN&#x60; - IN * &#x60;IA&#x60; - IA * &#x60;KS&#x60; - KS * &#x60;KY&#x60; - KY * &#x60;LA&#x60; - LA * &#x60;ME&#x60; - ME * &#x60;MD&#x60; - MD * &#x60;MA&#x60; - MA * &#x60;MI&#x60; - MI * &#x60;MN&#x60; - MN * &#x60;MS&#x60; - MS * &#x60;MO&#x60; - MO * &#x60;MT&#x60; - MT * &#x60;NE&#x60; - NE * &#x60;NV&#x60; - NV * &#x60;NH&#x60; - NH * &#x60;NJ&#x60; - NJ * &#x60;NM&#x60; - NM * &#x60;NY&#x60; - NY * &#x60;NC&#x60; - NC * &#x60;ND&#x60; - ND * &#x60;OH&#x60; - OH * &#x60;OK&#x60; - OK * &#x60;OR&#x60; - OR * &#x60;PR&#x60; - PR * &#x60;PA&#x60; - PA * &#x60;RI&#x60; - RI * &#x60;SC&#x60; - SC * &#x60;SD&#x60; - SD * &#x60;TN&#x60; - TN * &#x60;TX&#x60; - TX * &#x60;UT&#x60; - UT * &#x60;VT&#x60; - VT * &#x60;VI&#x60; - VI * &#x60;VA&#x60; - VA * &#x60;WA&#x60; - WA * &#x60;WI&#x60; - WI * &#x60;WV&#x60; - WV * &#x60;WY&#x60; - WY * &#x60;AA&#x60; - AA * &#x60;AE&#x60; - AE * &#x60;PW&#x60; - PW * &#x60;AP&#x60; - AP * &#x60;FM&#x60; - FM * &#x60;MH&#x60; - MH * &#x60;GU&#x60; - GU
         * @param {string} [email]
         * @param {number} [limit]
         * @param {string} [name]
         * @param {number} [page]
         * @param {string} [phone]
         * @param {'NursePractitioner' | 'RegisteredNurse' | 'ClinicalSocialWorker' | 'Phlebotomist'} [providerType] * &#x60;NursePractitioner&#x60; - NursePractitioner * &#x60;RegisteredNurse&#x60; - RegisteredNurse * &#x60;ClinicalSocialWorker&#x60; - ClinicalSocialWorker * &#x60;Phlebotomist&#x60; - Phlebotomist
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProviders: (coveredState, email, limit, name, page, phone, providerType, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/providers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (coveredState !== undefined) {
                localVarQueryParameter['covered_state'] = coveredState;
            }
            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (phone !== undefined) {
                localVarQueryParameter['phone'] = phone;
            }
            if (providerType !== undefined) {
                localVarQueryParameter['provider_type'] = providerType;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} clinicAppointmentRequestId
         * @param {string} wantedEndDatetime
         * @param {string} wantedStartDatetime
         * @param {number} [limit]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSchedulableProvidersForClinicRequest: (clinicAppointmentRequestId, wantedEndDatetime, wantedStartDatetime, limit, page, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clinicAppointmentRequestId' is not null or undefined
            common_1.assertParamExists('listSchedulableProvidersForClinicRequest', 'clinicAppointmentRequestId', clinicAppointmentRequestId);
            // verify required parameter 'wantedEndDatetime' is not null or undefined
            common_1.assertParamExists('listSchedulableProvidersForClinicRequest', 'wantedEndDatetime', wantedEndDatetime);
            // verify required parameter 'wantedStartDatetime' is not null or undefined
            common_1.assertParamExists('listSchedulableProvidersForClinicRequest', 'wantedStartDatetime', wantedStartDatetime);
            const localVarPath = `/v1/providers/clinic-request-schedulable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (clinicAppointmentRequestId !== undefined) {
                localVarQueryParameter['clinic_appointment_request_id'] = clinicAppointmentRequestId;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (wantedEndDatetime !== undefined) {
                localVarQueryParameter['wanted_end_datetime'] = (wantedEndDatetime instanceof Date) ?
                    wantedEndDatetime.toISOString() :
                    wantedEndDatetime;
            }
            if (wantedStartDatetime !== undefined) {
                localVarQueryParameter['wanted_start_datetime'] = (wantedStartDatetime instanceof Date) ?
                    wantedStartDatetime.toISOString() :
                    wantedStartDatetime;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * List subordinates by filter
         * @param {string} providerId
         * @param {'AL' | 'AK' | 'AZ' | 'AR' | 'CA' | 'CO' | 'CT' | 'DC' | 'DE' | 'FL' | 'GA' | 'HI' | 'ID' | 'IL' | 'IN' | 'IA' | 'KS' | 'KY' | 'LA' | 'ME' | 'MD' | 'MA' | 'MI' | 'MN' | 'MS' | 'MO' | 'MT' | 'NE' | 'NV' | 'NH' | 'NJ' | 'NM' | 'NY' | 'NC' | 'ND' | 'OH' | 'OK' | 'OR' | 'PR' | 'PA' | 'RI' | 'SC' | 'SD' | 'TN' | 'TX' | 'UT' | 'VT' | 'VI' | 'VA' | 'WA' | 'WI' | 'WV' | 'WY' | 'AA' | 'AE' | 'PW' | 'AP' | 'FM' | 'MH' | 'GU'} [coveredState] * &#x60;AL&#x60; - AL * &#x60;AK&#x60; - AK * &#x60;AZ&#x60; - AZ * &#x60;AR&#x60; - AR * &#x60;CA&#x60; - CA * &#x60;CO&#x60; - CO * &#x60;CT&#x60; - CT * &#x60;DC&#x60; - DC * &#x60;DE&#x60; - DE * &#x60;FL&#x60; - FL * &#x60;GA&#x60; - GA * &#x60;HI&#x60; - HI * &#x60;ID&#x60; - ID * &#x60;IL&#x60; - IL * &#x60;IN&#x60; - IN * &#x60;IA&#x60; - IA * &#x60;KS&#x60; - KS * &#x60;KY&#x60; - KY * &#x60;LA&#x60; - LA * &#x60;ME&#x60; - ME * &#x60;MD&#x60; - MD * &#x60;MA&#x60; - MA * &#x60;MI&#x60; - MI * &#x60;MN&#x60; - MN * &#x60;MS&#x60; - MS * &#x60;MO&#x60; - MO * &#x60;MT&#x60; - MT * &#x60;NE&#x60; - NE * &#x60;NV&#x60; - NV * &#x60;NH&#x60; - NH * &#x60;NJ&#x60; - NJ * &#x60;NM&#x60; - NM * &#x60;NY&#x60; - NY * &#x60;NC&#x60; - NC * &#x60;ND&#x60; - ND * &#x60;OH&#x60; - OH * &#x60;OK&#x60; - OK * &#x60;OR&#x60; - OR * &#x60;PR&#x60; - PR * &#x60;PA&#x60; - PA * &#x60;RI&#x60; - RI * &#x60;SC&#x60; - SC * &#x60;SD&#x60; - SD * &#x60;TN&#x60; - TN * &#x60;TX&#x60; - TX * &#x60;UT&#x60; - UT * &#x60;VT&#x60; - VT * &#x60;VI&#x60; - VI * &#x60;VA&#x60; - VA * &#x60;WA&#x60; - WA * &#x60;WI&#x60; - WI * &#x60;WV&#x60; - WV * &#x60;WY&#x60; - WY * &#x60;AA&#x60; - AA * &#x60;AE&#x60; - AE * &#x60;PW&#x60; - PW * &#x60;AP&#x60; - AP * &#x60;FM&#x60; - FM * &#x60;MH&#x60; - MH * &#x60;GU&#x60; - GU
         * @param {string} [email]
         * @param {number} [limit]
         * @param {string} [name]
         * @param {number} [page]
         * @param {string} [phone]
         * @param {'NursePractitioner' | 'RegisteredNurse' | 'ClinicalSocialWorker' | 'Phlebotomist'} [providerType] * &#x60;NursePractitioner&#x60; - NursePractitioner * &#x60;RegisteredNurse&#x60; - RegisteredNurse * &#x60;ClinicalSocialWorker&#x60; - ClinicalSocialWorker * &#x60;Phlebotomist&#x60; - Phlebotomist
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSubordinates: (providerId, coveredState, email, limit, name, page, phone, providerType, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'providerId' is not null or undefined
            common_1.assertParamExists('listSubordinates', 'providerId', providerId);
            const localVarPath = `/v1/providers/{provider_id}/subordinates`
                .replace(`{${"provider_id"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (coveredState !== undefined) {
                localVarQueryParameter['covered_state'] = coveredState;
            }
            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (phone !== undefined) {
                localVarQueryParameter['phone'] = phone;
            }
            if (providerType !== undefined) {
                localVarQueryParameter['provider_type'] = providerType;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} providerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offboardProvider: (providerId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'providerId' is not null or undefined
            common_1.assertParamExists('offboardProvider', 'providerId', providerId);
            const localVarPath = `/v1/providers/{provider_id}/offboard`
                .replace(`{${"provider_id"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} providerId
         * @param {UpdateEPrescribingTokenRequest} updateEPrescribingTokenRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEPrescribingToken: (providerId, updateEPrescribingTokenRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'providerId' is not null or undefined
            common_1.assertParamExists('updateEPrescribingToken', 'providerId', providerId);
            // verify required parameter 'updateEPrescribingTokenRequest' is not null or undefined
            common_1.assertParamExists('updateEPrescribingToken', 'updateEPrescribingTokenRequest', updateEPrescribingTokenRequest);
            const localVarPath = `/v1/providers/{provider_id}/e-prescribing-token`
                .replace(`{${"provider_id"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateEPrescribingTokenRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} providerId
         * @param {string} [firstName]
         * @param {string} [lastName]
         * @param {string} [title]
         * @param {string} [bio]
         * @param {string} [education]
         * @param {string} [avatarFile]
         * @param {number} [appointmentTypeSplitRatio]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProvider: (providerId, firstName, lastName, title, bio, education, avatarFile, appointmentTypeSplitRatio, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'providerId' is not null or undefined
            common_1.assertParamExists('updateProvider', 'providerId', providerId);
            const localVarPath = `/v1/providers/{provider_id}`
                .replace(`{${"provider_id"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (firstName !== undefined) {
                localVarFormParams.append('first_name', firstName);
            }
            if (lastName !== undefined) {
                localVarFormParams.append('last_name', lastName);
            }
            if (title !== undefined) {
                localVarFormParams.append('title', title);
            }
            if (bio !== undefined) {
                localVarFormParams.append('bio', bio);
            }
            if (education !== undefined) {
                localVarFormParams.append('education', education);
            }
            if (avatarFile !== undefined) {
                localVarFormParams.append('avatar_file', avatarFile);
            }
            if (appointmentTypeSplitRatio !== undefined) {
                localVarFormParams.append('appointment_type_split_ratio', appointmentTypeSplitRatio);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ProviderApi - functional programming interface
 * @export
 */
exports.ProviderApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.ProviderApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} providerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEPrescribingToken(providerId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEPrescribingToken(providerId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} providerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProvider(providerId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProvider(providerId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {'AL' | 'AK' | 'AZ' | 'AR' | 'CA' | 'CO' | 'CT' | 'DC' | 'DE' | 'FL' | 'GA' | 'HI' | 'ID' | 'IL' | 'IN' | 'IA' | 'KS' | 'KY' | 'LA' | 'ME' | 'MD' | 'MA' | 'MI' | 'MN' | 'MS' | 'MO' | 'MT' | 'NE' | 'NV' | 'NH' | 'NJ' | 'NM' | 'NY' | 'NC' | 'ND' | 'OH' | 'OK' | 'OR' | 'PR' | 'PA' | 'RI' | 'SC' | 'SD' | 'TN' | 'TX' | 'UT' | 'VT' | 'VI' | 'VA' | 'WA' | 'WI' | 'WV' | 'WY' | 'AA' | 'AE' | 'PW' | 'AP' | 'FM' | 'MH' | 'GU'} [coveredState] * &#x60;AL&#x60; - AL * &#x60;AK&#x60; - AK * &#x60;AZ&#x60; - AZ * &#x60;AR&#x60; - AR * &#x60;CA&#x60; - CA * &#x60;CO&#x60; - CO * &#x60;CT&#x60; - CT * &#x60;DC&#x60; - DC * &#x60;DE&#x60; - DE * &#x60;FL&#x60; - FL * &#x60;GA&#x60; - GA * &#x60;HI&#x60; - HI * &#x60;ID&#x60; - ID * &#x60;IL&#x60; - IL * &#x60;IN&#x60; - IN * &#x60;IA&#x60; - IA * &#x60;KS&#x60; - KS * &#x60;KY&#x60; - KY * &#x60;LA&#x60; - LA * &#x60;ME&#x60; - ME * &#x60;MD&#x60; - MD * &#x60;MA&#x60; - MA * &#x60;MI&#x60; - MI * &#x60;MN&#x60; - MN * &#x60;MS&#x60; - MS * &#x60;MO&#x60; - MO * &#x60;MT&#x60; - MT * &#x60;NE&#x60; - NE * &#x60;NV&#x60; - NV * &#x60;NH&#x60; - NH * &#x60;NJ&#x60; - NJ * &#x60;NM&#x60; - NM * &#x60;NY&#x60; - NY * &#x60;NC&#x60; - NC * &#x60;ND&#x60; - ND * &#x60;OH&#x60; - OH * &#x60;OK&#x60; - OK * &#x60;OR&#x60; - OR * &#x60;PR&#x60; - PR * &#x60;PA&#x60; - PA * &#x60;RI&#x60; - RI * &#x60;SC&#x60; - SC * &#x60;SD&#x60; - SD * &#x60;TN&#x60; - TN * &#x60;TX&#x60; - TX * &#x60;UT&#x60; - UT * &#x60;VT&#x60; - VT * &#x60;VI&#x60; - VI * &#x60;VA&#x60; - VA * &#x60;WA&#x60; - WA * &#x60;WI&#x60; - WI * &#x60;WV&#x60; - WV * &#x60;WY&#x60; - WY * &#x60;AA&#x60; - AA * &#x60;AE&#x60; - AE * &#x60;PW&#x60; - PW * &#x60;AP&#x60; - AP * &#x60;FM&#x60; - FM * &#x60;MH&#x60; - MH * &#x60;GU&#x60; - GU
         * @param {string} [email]
         * @param {number} [limit]
         * @param {string} [name]
         * @param {number} [page]
         * @param {string} [phone]
         * @param {'NursePractitioner' | 'RegisteredNurse' | 'ClinicalSocialWorker' | 'Phlebotomist'} [providerType] * &#x60;NursePractitioner&#x60; - NursePractitioner * &#x60;RegisteredNurse&#x60; - RegisteredNurse * &#x60;ClinicalSocialWorker&#x60; - ClinicalSocialWorker * &#x60;Phlebotomist&#x60; - Phlebotomist
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProviders(coveredState, email, limit, name, page, phone, providerType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listProviders(coveredState, email, limit, name, page, phone, providerType, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} clinicAppointmentRequestId
         * @param {string} wantedEndDatetime
         * @param {string} wantedStartDatetime
         * @param {number} [limit]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSchedulableProvidersForClinicRequest(clinicAppointmentRequestId, wantedEndDatetime, wantedStartDatetime, limit, page, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listSchedulableProvidersForClinicRequest(clinicAppointmentRequestId, wantedEndDatetime, wantedStartDatetime, limit, page, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * List subordinates by filter
         * @param {string} providerId
         * @param {'AL' | 'AK' | 'AZ' | 'AR' | 'CA' | 'CO' | 'CT' | 'DC' | 'DE' | 'FL' | 'GA' | 'HI' | 'ID' | 'IL' | 'IN' | 'IA' | 'KS' | 'KY' | 'LA' | 'ME' | 'MD' | 'MA' | 'MI' | 'MN' | 'MS' | 'MO' | 'MT' | 'NE' | 'NV' | 'NH' | 'NJ' | 'NM' | 'NY' | 'NC' | 'ND' | 'OH' | 'OK' | 'OR' | 'PR' | 'PA' | 'RI' | 'SC' | 'SD' | 'TN' | 'TX' | 'UT' | 'VT' | 'VI' | 'VA' | 'WA' | 'WI' | 'WV' | 'WY' | 'AA' | 'AE' | 'PW' | 'AP' | 'FM' | 'MH' | 'GU'} [coveredState] * &#x60;AL&#x60; - AL * &#x60;AK&#x60; - AK * &#x60;AZ&#x60; - AZ * &#x60;AR&#x60; - AR * &#x60;CA&#x60; - CA * &#x60;CO&#x60; - CO * &#x60;CT&#x60; - CT * &#x60;DC&#x60; - DC * &#x60;DE&#x60; - DE * &#x60;FL&#x60; - FL * &#x60;GA&#x60; - GA * &#x60;HI&#x60; - HI * &#x60;ID&#x60; - ID * &#x60;IL&#x60; - IL * &#x60;IN&#x60; - IN * &#x60;IA&#x60; - IA * &#x60;KS&#x60; - KS * &#x60;KY&#x60; - KY * &#x60;LA&#x60; - LA * &#x60;ME&#x60; - ME * &#x60;MD&#x60; - MD * &#x60;MA&#x60; - MA * &#x60;MI&#x60; - MI * &#x60;MN&#x60; - MN * &#x60;MS&#x60; - MS * &#x60;MO&#x60; - MO * &#x60;MT&#x60; - MT * &#x60;NE&#x60; - NE * &#x60;NV&#x60; - NV * &#x60;NH&#x60; - NH * &#x60;NJ&#x60; - NJ * &#x60;NM&#x60; - NM * &#x60;NY&#x60; - NY * &#x60;NC&#x60; - NC * &#x60;ND&#x60; - ND * &#x60;OH&#x60; - OH * &#x60;OK&#x60; - OK * &#x60;OR&#x60; - OR * &#x60;PR&#x60; - PR * &#x60;PA&#x60; - PA * &#x60;RI&#x60; - RI * &#x60;SC&#x60; - SC * &#x60;SD&#x60; - SD * &#x60;TN&#x60; - TN * &#x60;TX&#x60; - TX * &#x60;UT&#x60; - UT * &#x60;VT&#x60; - VT * &#x60;VI&#x60; - VI * &#x60;VA&#x60; - VA * &#x60;WA&#x60; - WA * &#x60;WI&#x60; - WI * &#x60;WV&#x60; - WV * &#x60;WY&#x60; - WY * &#x60;AA&#x60; - AA * &#x60;AE&#x60; - AE * &#x60;PW&#x60; - PW * &#x60;AP&#x60; - AP * &#x60;FM&#x60; - FM * &#x60;MH&#x60; - MH * &#x60;GU&#x60; - GU
         * @param {string} [email]
         * @param {number} [limit]
         * @param {string} [name]
         * @param {number} [page]
         * @param {string} [phone]
         * @param {'NursePractitioner' | 'RegisteredNurse' | 'ClinicalSocialWorker' | 'Phlebotomist'} [providerType] * &#x60;NursePractitioner&#x60; - NursePractitioner * &#x60;RegisteredNurse&#x60; - RegisteredNurse * &#x60;ClinicalSocialWorker&#x60; - ClinicalSocialWorker * &#x60;Phlebotomist&#x60; - Phlebotomist
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSubordinates(providerId, coveredState, email, limit, name, page, phone, providerType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listSubordinates(providerId, coveredState, email, limit, name, page, phone, providerType, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} providerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offboardProvider(providerId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.offboardProvider(providerId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} providerId
         * @param {UpdateEPrescribingTokenRequest} updateEPrescribingTokenRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEPrescribingToken(providerId, updateEPrescribingTokenRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateEPrescribingToken(providerId, updateEPrescribingTokenRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} providerId
         * @param {string} [firstName]
         * @param {string} [lastName]
         * @param {string} [title]
         * @param {string} [bio]
         * @param {string} [education]
         * @param {string} [avatarFile]
         * @param {number} [appointmentTypeSplitRatio]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProvider(providerId, firstName, lastName, title, bio, education, avatarFile, appointmentTypeSplitRatio, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateProvider(providerId, firstName, lastName, title, bio, education, avatarFile, appointmentTypeSplitRatio, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ProviderApi - factory interface
 * @export
 */
exports.ProviderApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.ProviderApiFp(configuration);
    return {
        /**
         *
         * @param {string} providerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEPrescribingToken(providerId, options) {
            return localVarFp.getEPrescribingToken(providerId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} providerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProvider(providerId, options) {
            return localVarFp.getProvider(providerId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {'AL' | 'AK' | 'AZ' | 'AR' | 'CA' | 'CO' | 'CT' | 'DC' | 'DE' | 'FL' | 'GA' | 'HI' | 'ID' | 'IL' | 'IN' | 'IA' | 'KS' | 'KY' | 'LA' | 'ME' | 'MD' | 'MA' | 'MI' | 'MN' | 'MS' | 'MO' | 'MT' | 'NE' | 'NV' | 'NH' | 'NJ' | 'NM' | 'NY' | 'NC' | 'ND' | 'OH' | 'OK' | 'OR' | 'PR' | 'PA' | 'RI' | 'SC' | 'SD' | 'TN' | 'TX' | 'UT' | 'VT' | 'VI' | 'VA' | 'WA' | 'WI' | 'WV' | 'WY' | 'AA' | 'AE' | 'PW' | 'AP' | 'FM' | 'MH' | 'GU'} [coveredState] * &#x60;AL&#x60; - AL * &#x60;AK&#x60; - AK * &#x60;AZ&#x60; - AZ * &#x60;AR&#x60; - AR * &#x60;CA&#x60; - CA * &#x60;CO&#x60; - CO * &#x60;CT&#x60; - CT * &#x60;DC&#x60; - DC * &#x60;DE&#x60; - DE * &#x60;FL&#x60; - FL * &#x60;GA&#x60; - GA * &#x60;HI&#x60; - HI * &#x60;ID&#x60; - ID * &#x60;IL&#x60; - IL * &#x60;IN&#x60; - IN * &#x60;IA&#x60; - IA * &#x60;KS&#x60; - KS * &#x60;KY&#x60; - KY * &#x60;LA&#x60; - LA * &#x60;ME&#x60; - ME * &#x60;MD&#x60; - MD * &#x60;MA&#x60; - MA * &#x60;MI&#x60; - MI * &#x60;MN&#x60; - MN * &#x60;MS&#x60; - MS * &#x60;MO&#x60; - MO * &#x60;MT&#x60; - MT * &#x60;NE&#x60; - NE * &#x60;NV&#x60; - NV * &#x60;NH&#x60; - NH * &#x60;NJ&#x60; - NJ * &#x60;NM&#x60; - NM * &#x60;NY&#x60; - NY * &#x60;NC&#x60; - NC * &#x60;ND&#x60; - ND * &#x60;OH&#x60; - OH * &#x60;OK&#x60; - OK * &#x60;OR&#x60; - OR * &#x60;PR&#x60; - PR * &#x60;PA&#x60; - PA * &#x60;RI&#x60; - RI * &#x60;SC&#x60; - SC * &#x60;SD&#x60; - SD * &#x60;TN&#x60; - TN * &#x60;TX&#x60; - TX * &#x60;UT&#x60; - UT * &#x60;VT&#x60; - VT * &#x60;VI&#x60; - VI * &#x60;VA&#x60; - VA * &#x60;WA&#x60; - WA * &#x60;WI&#x60; - WI * &#x60;WV&#x60; - WV * &#x60;WY&#x60; - WY * &#x60;AA&#x60; - AA * &#x60;AE&#x60; - AE * &#x60;PW&#x60; - PW * &#x60;AP&#x60; - AP * &#x60;FM&#x60; - FM * &#x60;MH&#x60; - MH * &#x60;GU&#x60; - GU
         * @param {string} [email]
         * @param {number} [limit]
         * @param {string} [name]
         * @param {number} [page]
         * @param {string} [phone]
         * @param {'NursePractitioner' | 'RegisteredNurse' | 'ClinicalSocialWorker' | 'Phlebotomist'} [providerType] * &#x60;NursePractitioner&#x60; - NursePractitioner * &#x60;RegisteredNurse&#x60; - RegisteredNurse * &#x60;ClinicalSocialWorker&#x60; - ClinicalSocialWorker * &#x60;Phlebotomist&#x60; - Phlebotomist
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProviders(coveredState, email, limit, name, page, phone, providerType, options) {
            return localVarFp.listProviders(coveredState, email, limit, name, page, phone, providerType, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} clinicAppointmentRequestId
         * @param {string} wantedEndDatetime
         * @param {string} wantedStartDatetime
         * @param {number} [limit]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSchedulableProvidersForClinicRequest(clinicAppointmentRequestId, wantedEndDatetime, wantedStartDatetime, limit, page, options) {
            return localVarFp.listSchedulableProvidersForClinicRequest(clinicAppointmentRequestId, wantedEndDatetime, wantedStartDatetime, limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         * List subordinates by filter
         * @param {string} providerId
         * @param {'AL' | 'AK' | 'AZ' | 'AR' | 'CA' | 'CO' | 'CT' | 'DC' | 'DE' | 'FL' | 'GA' | 'HI' | 'ID' | 'IL' | 'IN' | 'IA' | 'KS' | 'KY' | 'LA' | 'ME' | 'MD' | 'MA' | 'MI' | 'MN' | 'MS' | 'MO' | 'MT' | 'NE' | 'NV' | 'NH' | 'NJ' | 'NM' | 'NY' | 'NC' | 'ND' | 'OH' | 'OK' | 'OR' | 'PR' | 'PA' | 'RI' | 'SC' | 'SD' | 'TN' | 'TX' | 'UT' | 'VT' | 'VI' | 'VA' | 'WA' | 'WI' | 'WV' | 'WY' | 'AA' | 'AE' | 'PW' | 'AP' | 'FM' | 'MH' | 'GU'} [coveredState] * &#x60;AL&#x60; - AL * &#x60;AK&#x60; - AK * &#x60;AZ&#x60; - AZ * &#x60;AR&#x60; - AR * &#x60;CA&#x60; - CA * &#x60;CO&#x60; - CO * &#x60;CT&#x60; - CT * &#x60;DC&#x60; - DC * &#x60;DE&#x60; - DE * &#x60;FL&#x60; - FL * &#x60;GA&#x60; - GA * &#x60;HI&#x60; - HI * &#x60;ID&#x60; - ID * &#x60;IL&#x60; - IL * &#x60;IN&#x60; - IN * &#x60;IA&#x60; - IA * &#x60;KS&#x60; - KS * &#x60;KY&#x60; - KY * &#x60;LA&#x60; - LA * &#x60;ME&#x60; - ME * &#x60;MD&#x60; - MD * &#x60;MA&#x60; - MA * &#x60;MI&#x60; - MI * &#x60;MN&#x60; - MN * &#x60;MS&#x60; - MS * &#x60;MO&#x60; - MO * &#x60;MT&#x60; - MT * &#x60;NE&#x60; - NE * &#x60;NV&#x60; - NV * &#x60;NH&#x60; - NH * &#x60;NJ&#x60; - NJ * &#x60;NM&#x60; - NM * &#x60;NY&#x60; - NY * &#x60;NC&#x60; - NC * &#x60;ND&#x60; - ND * &#x60;OH&#x60; - OH * &#x60;OK&#x60; - OK * &#x60;OR&#x60; - OR * &#x60;PR&#x60; - PR * &#x60;PA&#x60; - PA * &#x60;RI&#x60; - RI * &#x60;SC&#x60; - SC * &#x60;SD&#x60; - SD * &#x60;TN&#x60; - TN * &#x60;TX&#x60; - TX * &#x60;UT&#x60; - UT * &#x60;VT&#x60; - VT * &#x60;VI&#x60; - VI * &#x60;VA&#x60; - VA * &#x60;WA&#x60; - WA * &#x60;WI&#x60; - WI * &#x60;WV&#x60; - WV * &#x60;WY&#x60; - WY * &#x60;AA&#x60; - AA * &#x60;AE&#x60; - AE * &#x60;PW&#x60; - PW * &#x60;AP&#x60; - AP * &#x60;FM&#x60; - FM * &#x60;MH&#x60; - MH * &#x60;GU&#x60; - GU
         * @param {string} [email]
         * @param {number} [limit]
         * @param {string} [name]
         * @param {number} [page]
         * @param {string} [phone]
         * @param {'NursePractitioner' | 'RegisteredNurse' | 'ClinicalSocialWorker' | 'Phlebotomist'} [providerType] * &#x60;NursePractitioner&#x60; - NursePractitioner * &#x60;RegisteredNurse&#x60; - RegisteredNurse * &#x60;ClinicalSocialWorker&#x60; - ClinicalSocialWorker * &#x60;Phlebotomist&#x60; - Phlebotomist
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSubordinates(providerId, coveredState, email, limit, name, page, phone, providerType, options) {
            return localVarFp.listSubordinates(providerId, coveredState, email, limit, name, page, phone, providerType, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} providerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offboardProvider(providerId, options) {
            return localVarFp.offboardProvider(providerId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} providerId
         * @param {UpdateEPrescribingTokenRequest} updateEPrescribingTokenRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEPrescribingToken(providerId, updateEPrescribingTokenRequest, options) {
            return localVarFp.updateEPrescribingToken(providerId, updateEPrescribingTokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} providerId
         * @param {string} [firstName]
         * @param {string} [lastName]
         * @param {string} [title]
         * @param {string} [bio]
         * @param {string} [education]
         * @param {string} [avatarFile]
         * @param {number} [appointmentTypeSplitRatio]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProvider(providerId, firstName, lastName, title, bio, education, avatarFile, appointmentTypeSplitRatio, options) {
            return localVarFp.updateProvider(providerId, firstName, lastName, title, bio, education, avatarFile, appointmentTypeSplitRatio, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ProviderApi - object-oriented interface
 * @export
 * @class ProviderApi
 * @extends {BaseAPI}
 */
class ProviderApi extends base_1.BaseAPI {
    /**
     *
     * @param {ProviderApiGetEPrescribingTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderApi
     */
    getEPrescribingToken(requestParameters, options) {
        return exports.ProviderApiFp(this.configuration).getEPrescribingToken(requestParameters.providerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ProviderApiGetProviderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderApi
     */
    getProvider(requestParameters, options) {
        return exports.ProviderApiFp(this.configuration).getProvider(requestParameters.providerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ProviderApiListProvidersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderApi
     */
    listProviders(requestParameters = {}, options) {
        return exports.ProviderApiFp(this.configuration).listProviders(requestParameters.coveredState, requestParameters.email, requestParameters.limit, requestParameters.name, requestParameters.page, requestParameters.phone, requestParameters.providerType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ProviderApiListSchedulableProvidersForClinicRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderApi
     */
    listSchedulableProvidersForClinicRequest(requestParameters, options) {
        return exports.ProviderApiFp(this.configuration).listSchedulableProvidersForClinicRequest(requestParameters.clinicAppointmentRequestId, requestParameters.wantedEndDatetime, requestParameters.wantedStartDatetime, requestParameters.limit, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * List subordinates by filter
     * @param {ProviderApiListSubordinatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderApi
     */
    listSubordinates(requestParameters, options) {
        return exports.ProviderApiFp(this.configuration).listSubordinates(requestParameters.providerId, requestParameters.coveredState, requestParameters.email, requestParameters.limit, requestParameters.name, requestParameters.page, requestParameters.phone, requestParameters.providerType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ProviderApiOffboardProviderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderApi
     */
    offboardProvider(requestParameters, options) {
        return exports.ProviderApiFp(this.configuration).offboardProvider(requestParameters.providerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ProviderApiUpdateEPrescribingTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderApi
     */
    updateEPrescribingToken(requestParameters, options) {
        return exports.ProviderApiFp(this.configuration).updateEPrescribingToken(requestParameters.providerId, requestParameters.updateEPrescribingTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ProviderApiUpdateProviderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProviderApi
     */
    updateProvider(requestParameters, options) {
        return exports.ProviderApiFp(this.configuration).updateProvider(requestParameters.providerId, requestParameters.firstName, requestParameters.lastName, requestParameters.title, requestParameters.bio, requestParameters.education, requestParameters.avatarFile, requestParameters.appointmentTypeSplitRatio, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ProviderApi = ProviderApi;
/**
 * QuestionnaireFormApi - axios parameter creator
 * @export
 */
exports.QuestionnaireFormApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} visitReasonId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionnaireFormForVisitReason: (visitReasonId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'visitReasonId' is not null or undefined
            common_1.assertParamExists('getQuestionnaireFormForVisitReason', 'visitReasonId', visitReasonId);
            const localVarPath = `/v1/visit-reasons/{visit_reason_id}/questionnaire-form`
                .replace(`{${"visit_reason_id"}}`, encodeURIComponent(String(visitReasonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * QuestionnaireFormApi - functional programming interface
 * @export
 */
exports.QuestionnaireFormApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.QuestionnaireFormApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} visitReasonId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionnaireFormForVisitReason(visitReasonId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getQuestionnaireFormForVisitReason(visitReasonId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * QuestionnaireFormApi - factory interface
 * @export
 */
exports.QuestionnaireFormApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.QuestionnaireFormApiFp(configuration);
    return {
        /**
         *
         * @param {string} visitReasonId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionnaireFormForVisitReason(visitReasonId, options) {
            return localVarFp.getQuestionnaireFormForVisitReason(visitReasonId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * QuestionnaireFormApi - object-oriented interface
 * @export
 * @class QuestionnaireFormApi
 * @extends {BaseAPI}
 */
class QuestionnaireFormApi extends base_1.BaseAPI {
    /**
     *
     * @param {QuestionnaireFormApiGetQuestionnaireFormForVisitReasonRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionnaireFormApi
     */
    getQuestionnaireFormForVisitReason(requestParameters, options) {
        return exports.QuestionnaireFormApiFp(this.configuration).getQuestionnaireFormForVisitReason(requestParameters.visitReasonId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.QuestionnaireFormApi = QuestionnaireFormApi;
/**
 * QuestionnairesApi - axios parameter creator
 * @export
 */
exports.QuestionnairesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Invoked by FormSort when a user submits an Appointment Questionnaire.
         * @param {FormSortQuestionnaireResponseWebHookRequest} formSortQuestionnaireResponseWebHookRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsortAppointmentQuestionnaireWebhook: (formSortQuestionnaireResponseWebHookRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'formSortQuestionnaireResponseWebHookRequest' is not null or undefined
            common_1.assertParamExists('formsortAppointmentQuestionnaireWebhook', 'formSortQuestionnaireResponseWebHookRequest', formSortQuestionnaireResponseWebHookRequest);
            const localVarPath = `/v1/questionnaires/formsort-webhook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(formSortQuestionnaireResponseWebHookRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Invoked by FormSort when a user submits a Qualifier Questionnaire.
         * @param {FormSortQuestionnaireResponseWebHookRequest} formSortQuestionnaireResponseWebHookRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsortAsyncQualifierQuestionnaireWebhook: (formSortQuestionnaireResponseWebHookRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'formSortQuestionnaireResponseWebHookRequest' is not null or undefined
            common_1.assertParamExists('formsortAsyncQualifierQuestionnaireWebhook', 'formSortQuestionnaireResponseWebHookRequest', formSortQuestionnaireResponseWebHookRequest);
            const localVarPath = `/v1/questionnaires/formsort-qualifier-webhook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(formSortQuestionnaireResponseWebHookRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} appointmentId
         * @param {string} [patientId]
         * @param {'Pending' | 'Incomplete' | 'Complete' | 'null'} [status] * &#x60;Pending&#x60; - Pending * &#x60;Incomplete&#x60; - Incomplete * &#x60;Complete&#x60; - Complete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAppointmentQuestionnaires: (appointmentId, patientId, status, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'appointmentId' is not null or undefined
            common_1.assertParamExists('listAppointmentQuestionnaires', 'appointmentId', appointmentId);
            const localVarPath = `/v1/appointments/{appointment_id}/questionnaires`
                .replace(`{${"appointment_id"}}`, encodeURIComponent(String(appointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (patientId !== undefined) {
                localVarQueryParameter['patient_id'] = patientId;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} asyncAppointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAsyncAppointmentQualifierQuestionnaires: (asyncAppointmentId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'asyncAppointmentId' is not null or undefined
            common_1.assertParamExists('listAsyncAppointmentQualifierQuestionnaires', 'asyncAppointmentId', asyncAppointmentId);
            const localVarPath = `/v1/async-appointments/{async_appointment_id}/qualifiers`
                .replace(`{${"async_appointment_id"}}`, encodeURIComponent(String(asyncAppointmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} encounterId
         * @param {'Pending' | 'Incomplete' | 'Complete' | 'null'} [status] * &#x60;Pending&#x60; - Pending * &#x60;Incomplete&#x60; - Incomplete * &#x60;Complete&#x60; - Complete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEncounterQuestionnaires: (encounterId, status, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'encounterId' is not null or undefined
            common_1.assertParamExists('listEncounterQuestionnaires', 'encounterId', encounterId);
            const localVarPath = `/v1/encounters/{encounter_id}/questionnaires`
                .replace(`{${"encounter_id"}}`, encodeURIComponent(String(encounterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} memberId
         * @param {'Pending' | 'Incomplete' | 'Complete' | 'null'} [status] * &#x60;Pending&#x60; - Pending * &#x60;Incomplete&#x60; - Incomplete * &#x60;Complete&#x60; - Complete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMemberQuestionnaires: (memberId, status, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'memberId' is not null or undefined
            common_1.assertParamExists('listMemberQuestionnaires', 'memberId', memberId);
            const localVarPath = `/v1/members/{member_id}/questionnaires`
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * QuestionnairesApi - functional programming interface
 * @export
 */
exports.QuestionnairesApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.QuestionnairesApiAxiosParamCreator(configuration);
    return {
        /**
         * Invoked by FormSort when a user submits an Appointment Questionnaire.
         * @param {FormSortQuestionnaireResponseWebHookRequest} formSortQuestionnaireResponseWebHookRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsortAppointmentQuestionnaireWebhook(formSortQuestionnaireResponseWebHookRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.formsortAppointmentQuestionnaireWebhook(formSortQuestionnaireResponseWebHookRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Invoked by FormSort when a user submits a Qualifier Questionnaire.
         * @param {FormSortQuestionnaireResponseWebHookRequest} formSortQuestionnaireResponseWebHookRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsortAsyncQualifierQuestionnaireWebhook(formSortQuestionnaireResponseWebHookRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.formsortAsyncQualifierQuestionnaireWebhook(formSortQuestionnaireResponseWebHookRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} appointmentId
         * @param {string} [patientId]
         * @param {'Pending' | 'Incomplete' | 'Complete' | 'null'} [status] * &#x60;Pending&#x60; - Pending * &#x60;Incomplete&#x60; - Incomplete * &#x60;Complete&#x60; - Complete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAppointmentQuestionnaires(appointmentId, patientId, status, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listAppointmentQuestionnaires(appointmentId, patientId, status, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} asyncAppointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAsyncAppointmentQualifierQuestionnaires(asyncAppointmentId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listAsyncAppointmentQualifierQuestionnaires(asyncAppointmentId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} encounterId
         * @param {'Pending' | 'Incomplete' | 'Complete' | 'null'} [status] * &#x60;Pending&#x60; - Pending * &#x60;Incomplete&#x60; - Incomplete * &#x60;Complete&#x60; - Complete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEncounterQuestionnaires(encounterId, status, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listEncounterQuestionnaires(encounterId, status, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} memberId
         * @param {'Pending' | 'Incomplete' | 'Complete' | 'null'} [status] * &#x60;Pending&#x60; - Pending * &#x60;Incomplete&#x60; - Incomplete * &#x60;Complete&#x60; - Complete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMemberQuestionnaires(memberId, status, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listMemberQuestionnaires(memberId, status, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * QuestionnairesApi - factory interface
 * @export
 */
exports.QuestionnairesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.QuestionnairesApiFp(configuration);
    return {
        /**
         * Invoked by FormSort when a user submits an Appointment Questionnaire.
         * @param {FormSortQuestionnaireResponseWebHookRequest} formSortQuestionnaireResponseWebHookRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsortAppointmentQuestionnaireWebhook(formSortQuestionnaireResponseWebHookRequest, options) {
            return localVarFp.formsortAppointmentQuestionnaireWebhook(formSortQuestionnaireResponseWebHookRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Invoked by FormSort when a user submits a Qualifier Questionnaire.
         * @param {FormSortQuestionnaireResponseWebHookRequest} formSortQuestionnaireResponseWebHookRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formsortAsyncQualifierQuestionnaireWebhook(formSortQuestionnaireResponseWebHookRequest, options) {
            return localVarFp.formsortAsyncQualifierQuestionnaireWebhook(formSortQuestionnaireResponseWebHookRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} appointmentId
         * @param {string} [patientId]
         * @param {'Pending' | 'Incomplete' | 'Complete' | 'null'} [status] * &#x60;Pending&#x60; - Pending * &#x60;Incomplete&#x60; - Incomplete * &#x60;Complete&#x60; - Complete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAppointmentQuestionnaires(appointmentId, patientId, status, options) {
            return localVarFp.listAppointmentQuestionnaires(appointmentId, patientId, status, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} asyncAppointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAsyncAppointmentQualifierQuestionnaires(asyncAppointmentId, options) {
            return localVarFp.listAsyncAppointmentQualifierQuestionnaires(asyncAppointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} encounterId
         * @param {'Pending' | 'Incomplete' | 'Complete' | 'null'} [status] * &#x60;Pending&#x60; - Pending * &#x60;Incomplete&#x60; - Incomplete * &#x60;Complete&#x60; - Complete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEncounterQuestionnaires(encounterId, status, options) {
            return localVarFp.listEncounterQuestionnaires(encounterId, status, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} memberId
         * @param {'Pending' | 'Incomplete' | 'Complete' | 'null'} [status] * &#x60;Pending&#x60; - Pending * &#x60;Incomplete&#x60; - Incomplete * &#x60;Complete&#x60; - Complete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMemberQuestionnaires(memberId, status, options) {
            return localVarFp.listMemberQuestionnaires(memberId, status, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * QuestionnairesApi - object-oriented interface
 * @export
 * @class QuestionnairesApi
 * @extends {BaseAPI}
 */
class QuestionnairesApi extends base_1.BaseAPI {
    /**
     * Invoked by FormSort when a user submits an Appointment Questionnaire.
     * @param {QuestionnairesApiFormsortAppointmentQuestionnaireWebhookRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionnairesApi
     */
    formsortAppointmentQuestionnaireWebhook(requestParameters, options) {
        return exports.QuestionnairesApiFp(this.configuration).formsortAppointmentQuestionnaireWebhook(requestParameters.formSortQuestionnaireResponseWebHookRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Invoked by FormSort when a user submits a Qualifier Questionnaire.
     * @param {QuestionnairesApiFormsortAsyncQualifierQuestionnaireWebhookRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionnairesApi
     */
    formsortAsyncQualifierQuestionnaireWebhook(requestParameters, options) {
        return exports.QuestionnairesApiFp(this.configuration).formsortAsyncQualifierQuestionnaireWebhook(requestParameters.formSortQuestionnaireResponseWebHookRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {QuestionnairesApiListAppointmentQuestionnairesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionnairesApi
     */
    listAppointmentQuestionnaires(requestParameters, options) {
        return exports.QuestionnairesApiFp(this.configuration).listAppointmentQuestionnaires(requestParameters.appointmentId, requestParameters.patientId, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {QuestionnairesApiListAsyncAppointmentQualifierQuestionnairesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionnairesApi
     */
    listAsyncAppointmentQualifierQuestionnaires(requestParameters, options) {
        return exports.QuestionnairesApiFp(this.configuration).listAsyncAppointmentQualifierQuestionnaires(requestParameters.asyncAppointmentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {QuestionnairesApiListEncounterQuestionnairesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionnairesApi
     */
    listEncounterQuestionnaires(requestParameters, options) {
        return exports.QuestionnairesApiFp(this.configuration).listEncounterQuestionnaires(requestParameters.encounterId, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {QuestionnairesApiListMemberQuestionnairesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionnairesApi
     */
    listMemberQuestionnaires(requestParameters, options) {
        return exports.QuestionnairesApiFp(this.configuration).listMemberQuestionnaires(requestParameters.memberId, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.QuestionnairesApi = QuestionnairesApi;
/**
 * SurveyApi - axios parameter creator
 * @export
 */
exports.SurveyApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {AddSurveyRequest} addSurveyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSurvey: (addSurveyRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'addSurveyRequest' is not null or undefined
            common_1.assertParamExists('addSurvey', 'addSurveyRequest', addSurveyRequest);
            const localVarPath = `/v1/surveys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(addSurveyRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkShowCompanyAdminNps: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/surveys/company-admin/rating`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkShowMemberEmployerRetentionRating: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/surveys/member/employer-retention-rating`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkShowMemberNps: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/surveys/member/rating`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} appointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkShowMemberProviderRating: (appointmentId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'appointmentId' is not null or undefined
            common_1.assertParamExists('checkShowMemberProviderRating', 'appointmentId', appointmentId);
            const localVarPath = `/v1/surveys/member/provider-rating`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (appointmentId !== undefined) {
                localVarQueryParameter['appointment_id'] = appointmentId;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkShowProviderNpsRating: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/surveys/providers/rating`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} providerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAverageMemberProviderRating: (providerId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'providerId' is not null or undefined
            common_1.assertParamExists('getAverageMemberProviderRating', 'providerId', providerId);
            const localVarPath = `/v1/surveys/member/provider-rating/{provider_id}`
                .replace(`{${"provider_id"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the next appointment uid ready for 5-Star survey.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nextAppointmentSurvey: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/surveys/next/appointment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nextAppointmentToSurveyForMember: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/surveys/member/next-appointment-to-rate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the next clinic appointment uid ready for CSAT survey.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nextClinicAppointmentSurvey: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/surveys/next/clinic-appointment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nextClinicToSurveyForCompanyAdmin: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/surveys/company-admin/next-clinic-to-rate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the next Occupational Health Lab Order Request uid ready for CSAT survey.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nextVoucherSurvey: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/surveys/next/voucher`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nextVoucherToSurveyForCompanyAdmin: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/surveys/company-admin/next-voucher-to-rate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ShowSurveyRequest} showSurveyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shouldShowSurvey: (showSurveyRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'showSurveyRequest' is not null or undefined
            common_1.assertParamExists('shouldShowSurvey', 'showSurveyRequest', showSurveyRequest);
            const localVarPath = `/v1/surveys-check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(showSurveyRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SubmitCompanyAdminClinicRatingRequest} submitCompanyAdminClinicRatingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitCompanyAdminClinicRating: (submitCompanyAdminClinicRatingRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'submitCompanyAdminClinicRatingRequest' is not null or undefined
            common_1.assertParamExists('submitCompanyAdminClinicRating', 'submitCompanyAdminClinicRatingRequest', submitCompanyAdminClinicRatingRequest);
            const localVarPath = `/v1/surveys/company-admin/clinic-rating`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(submitCompanyAdminClinicRatingRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SubmitCompanyAdminNPSRatingRequest} submitCompanyAdminNPSRatingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitCompanyAdminNpsRating: (submitCompanyAdminNPSRatingRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'submitCompanyAdminNPSRatingRequest' is not null or undefined
            common_1.assertParamExists('submitCompanyAdminNpsRating', 'submitCompanyAdminNPSRatingRequest', submitCompanyAdminNPSRatingRequest);
            const localVarPath = `/v1/surveys/company-admin/rating`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(submitCompanyAdminNPSRatingRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SubmitCompanyAdminVoucherRatingRequest} submitCompanyAdminVoucherRatingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitCompanyAdminVoucherRating: (submitCompanyAdminVoucherRatingRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'submitCompanyAdminVoucherRatingRequest' is not null or undefined
            common_1.assertParamExists('submitCompanyAdminVoucherRating', 'submitCompanyAdminVoucherRatingRequest', submitCompanyAdminVoucherRatingRequest);
            const localVarPath = `/v1/surveys/company-admin/voucher-rating`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(submitCompanyAdminVoucherRatingRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SubmitMemberEmployerRetentionRatingRequest} submitMemberEmployerRetentionRatingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitMemberEmployerRetentionRating: (submitMemberEmployerRetentionRatingRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'submitMemberEmployerRetentionRatingRequest' is not null or undefined
            common_1.assertParamExists('submitMemberEmployerRetentionRating', 'submitMemberEmployerRetentionRatingRequest', submitMemberEmployerRetentionRatingRequest);
            const localVarPath = `/v1/surveys/member/employer-retention-rating`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(submitMemberEmployerRetentionRatingRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SubmitMemberEnjoyingVitableRatingRequest} submitMemberEnjoyingVitableRatingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitMemberEnjoyingVitableRating: (submitMemberEnjoyingVitableRatingRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'submitMemberEnjoyingVitableRatingRequest' is not null or undefined
            common_1.assertParamExists('submitMemberEnjoyingVitableRating', 'submitMemberEnjoyingVitableRatingRequest', submitMemberEnjoyingVitableRatingRequest);
            const localVarPath = `/v1/surveys/member/enjoying-vitable-rating`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(submitMemberEnjoyingVitableRatingRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SubmitMemberNPSRatingRequest} submitMemberNPSRatingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitMemberNpsRating: (submitMemberNPSRatingRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'submitMemberNPSRatingRequest' is not null or undefined
            common_1.assertParamExists('submitMemberNpsRating', 'submitMemberNPSRatingRequest', submitMemberNPSRatingRequest);
            const localVarPath = `/v1/surveys/member/rating`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(submitMemberNPSRatingRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SubmitMemberPersonalAssistantRatingRequest} submitMemberPersonalAssistantRatingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitMemberPersonalAssistanceRating: (submitMemberPersonalAssistantRatingRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'submitMemberPersonalAssistantRatingRequest' is not null or undefined
            common_1.assertParamExists('submitMemberPersonalAssistanceRating', 'submitMemberPersonalAssistantRatingRequest', submitMemberPersonalAssistantRatingRequest);
            const localVarPath = `/v1/surveys/member/personal-assistant-rating`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(submitMemberPersonalAssistantRatingRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SubmitMemberProviderRatingRequest} submitMemberProviderRatingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitMemberProviderRating: (submitMemberProviderRatingRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'submitMemberProviderRatingRequest' is not null or undefined
            common_1.assertParamExists('submitMemberProviderRating', 'submitMemberProviderRatingRequest', submitMemberProviderRatingRequest);
            const localVarPath = `/v1/surveys/member/provider-rating`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(submitMemberProviderRatingRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SubmitProviderAppointmentRatingRequest} submitProviderAppointmentRatingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitProviderAppointmentRating: (submitProviderAppointmentRatingRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'submitProviderAppointmentRatingRequest' is not null or undefined
            common_1.assertParamExists('submitProviderAppointmentRating', 'submitProviderAppointmentRatingRequest', submitProviderAppointmentRatingRequest);
            const localVarPath = `/v1/surveys/providers/appointment-rating`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(submitProviderAppointmentRatingRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SubmitProviderClinicRatingRequest} submitProviderClinicRatingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitProviderClinicRating: (submitProviderClinicRatingRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'submitProviderClinicRatingRequest' is not null or undefined
            common_1.assertParamExists('submitProviderClinicRating', 'submitProviderClinicRatingRequest', submitProviderClinicRatingRequest);
            const localVarPath = `/v1/surveys/providers/clinic-rating`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(submitProviderClinicRatingRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SubmitProviderCompanyRatingRequest} submitProviderCompanyRatingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitProviderCompanyRating: (submitProviderCompanyRatingRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'submitProviderCompanyRatingRequest' is not null or undefined
            common_1.assertParamExists('submitProviderCompanyRating', 'submitProviderCompanyRatingRequest', submitProviderCompanyRatingRequest);
            const localVarPath = `/v1/surveys/providers/company-rating`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(submitProviderCompanyRatingRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SubmitProviderMemberRatingRequest} submitProviderMemberRatingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitProviderMemberRating: (submitProviderMemberRatingRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'submitProviderMemberRatingRequest' is not null or undefined
            common_1.assertParamExists('submitProviderMemberRating', 'submitProviderMemberRatingRequest', submitProviderMemberRatingRequest);
            const localVarPath = `/v1/surveys/providers/member-rating`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(submitProviderMemberRatingRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {SubmitProviderNPSRatingRequest} submitProviderNPSRatingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitProviderNpsRating: (submitProviderNPSRatingRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'submitProviderNPSRatingRequest' is not null or undefined
            common_1.assertParamExists('submitProviderNpsRating', 'submitProviderNPSRatingRequest', submitProviderNPSRatingRequest);
            const localVarPath = `/v1/surveys/providers/rating`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(submitProviderNPSRatingRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * SurveyApi - functional programming interface
 * @export
 */
exports.SurveyApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.SurveyApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {AddSurveyRequest} addSurveyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSurvey(addSurveyRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addSurvey(addSurveyRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkShowCompanyAdminNps(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.checkShowCompanyAdminNps(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkShowMemberEmployerRetentionRating(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.checkShowMemberEmployerRetentionRating(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkShowMemberNps(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.checkShowMemberNps(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} appointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkShowMemberProviderRating(appointmentId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.checkShowMemberProviderRating(appointmentId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkShowProviderNpsRating(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.checkShowProviderNpsRating(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} providerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAverageMemberProviderRating(providerId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAverageMemberProviderRating(providerId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets the next appointment uid ready for 5-Star survey.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nextAppointmentSurvey(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.nextAppointmentSurvey(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nextAppointmentToSurveyForMember(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.nextAppointmentToSurveyForMember(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets the next clinic appointment uid ready for CSAT survey.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nextClinicAppointmentSurvey(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.nextClinicAppointmentSurvey(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nextClinicToSurveyForCompanyAdmin(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.nextClinicToSurveyForCompanyAdmin(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets the next Occupational Health Lab Order Request uid ready for CSAT survey.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nextVoucherSurvey(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.nextVoucherSurvey(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nextVoucherToSurveyForCompanyAdmin(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.nextVoucherToSurveyForCompanyAdmin(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {ShowSurveyRequest} showSurveyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shouldShowSurvey(showSurveyRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.shouldShowSurvey(showSurveyRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {SubmitCompanyAdminClinicRatingRequest} submitCompanyAdminClinicRatingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitCompanyAdminClinicRating(submitCompanyAdminClinicRatingRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.submitCompanyAdminClinicRating(submitCompanyAdminClinicRatingRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {SubmitCompanyAdminNPSRatingRequest} submitCompanyAdminNPSRatingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitCompanyAdminNpsRating(submitCompanyAdminNPSRatingRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.submitCompanyAdminNpsRating(submitCompanyAdminNPSRatingRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {SubmitCompanyAdminVoucherRatingRequest} submitCompanyAdminVoucherRatingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitCompanyAdminVoucherRating(submitCompanyAdminVoucherRatingRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.submitCompanyAdminVoucherRating(submitCompanyAdminVoucherRatingRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {SubmitMemberEmployerRetentionRatingRequest} submitMemberEmployerRetentionRatingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitMemberEmployerRetentionRating(submitMemberEmployerRetentionRatingRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.submitMemberEmployerRetentionRating(submitMemberEmployerRetentionRatingRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {SubmitMemberEnjoyingVitableRatingRequest} submitMemberEnjoyingVitableRatingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitMemberEnjoyingVitableRating(submitMemberEnjoyingVitableRatingRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.submitMemberEnjoyingVitableRating(submitMemberEnjoyingVitableRatingRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {SubmitMemberNPSRatingRequest} submitMemberNPSRatingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitMemberNpsRating(submitMemberNPSRatingRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.submitMemberNpsRating(submitMemberNPSRatingRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {SubmitMemberPersonalAssistantRatingRequest} submitMemberPersonalAssistantRatingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitMemberPersonalAssistanceRating(submitMemberPersonalAssistantRatingRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.submitMemberPersonalAssistanceRating(submitMemberPersonalAssistantRatingRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {SubmitMemberProviderRatingRequest} submitMemberProviderRatingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitMemberProviderRating(submitMemberProviderRatingRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.submitMemberProviderRating(submitMemberProviderRatingRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {SubmitProviderAppointmentRatingRequest} submitProviderAppointmentRatingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitProviderAppointmentRating(submitProviderAppointmentRatingRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.submitProviderAppointmentRating(submitProviderAppointmentRatingRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {SubmitProviderClinicRatingRequest} submitProviderClinicRatingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitProviderClinicRating(submitProviderClinicRatingRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.submitProviderClinicRating(submitProviderClinicRatingRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {SubmitProviderCompanyRatingRequest} submitProviderCompanyRatingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitProviderCompanyRating(submitProviderCompanyRatingRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.submitProviderCompanyRating(submitProviderCompanyRatingRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {SubmitProviderMemberRatingRequest} submitProviderMemberRatingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitProviderMemberRating(submitProviderMemberRatingRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.submitProviderMemberRating(submitProviderMemberRatingRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {SubmitProviderNPSRatingRequest} submitProviderNPSRatingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitProviderNpsRating(submitProviderNPSRatingRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.submitProviderNpsRating(submitProviderNPSRatingRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * SurveyApi - factory interface
 * @export
 */
exports.SurveyApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.SurveyApiFp(configuration);
    return {
        /**
         *
         * @param {AddSurveyRequest} addSurveyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSurvey(addSurveyRequest, options) {
            return localVarFp.addSurvey(addSurveyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkShowCompanyAdminNps(options) {
            return localVarFp.checkShowCompanyAdminNps(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkShowMemberEmployerRetentionRating(options) {
            return localVarFp.checkShowMemberEmployerRetentionRating(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkShowMemberNps(options) {
            return localVarFp.checkShowMemberNps(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} appointmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkShowMemberProviderRating(appointmentId, options) {
            return localVarFp.checkShowMemberProviderRating(appointmentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkShowProviderNpsRating(options) {
            return localVarFp.checkShowProviderNpsRating(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} providerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAverageMemberProviderRating(providerId, options) {
            return localVarFp.getAverageMemberProviderRating(providerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the next appointment uid ready for 5-Star survey.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nextAppointmentSurvey(options) {
            return localVarFp.nextAppointmentSurvey(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nextAppointmentToSurveyForMember(options) {
            return localVarFp.nextAppointmentToSurveyForMember(options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the next clinic appointment uid ready for CSAT survey.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nextClinicAppointmentSurvey(options) {
            return localVarFp.nextClinicAppointmentSurvey(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nextClinicToSurveyForCompanyAdmin(options) {
            return localVarFp.nextClinicToSurveyForCompanyAdmin(options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the next Occupational Health Lab Order Request uid ready for CSAT survey.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nextVoucherSurvey(options) {
            return localVarFp.nextVoucherSurvey(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nextVoucherToSurveyForCompanyAdmin(options) {
            return localVarFp.nextVoucherToSurveyForCompanyAdmin(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ShowSurveyRequest} showSurveyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shouldShowSurvey(showSurveyRequest, options) {
            return localVarFp.shouldShowSurvey(showSurveyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SubmitCompanyAdminClinicRatingRequest} submitCompanyAdminClinicRatingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitCompanyAdminClinicRating(submitCompanyAdminClinicRatingRequest, options) {
            return localVarFp.submitCompanyAdminClinicRating(submitCompanyAdminClinicRatingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SubmitCompanyAdminNPSRatingRequest} submitCompanyAdminNPSRatingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitCompanyAdminNpsRating(submitCompanyAdminNPSRatingRequest, options) {
            return localVarFp.submitCompanyAdminNpsRating(submitCompanyAdminNPSRatingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SubmitCompanyAdminVoucherRatingRequest} submitCompanyAdminVoucherRatingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitCompanyAdminVoucherRating(submitCompanyAdminVoucherRatingRequest, options) {
            return localVarFp.submitCompanyAdminVoucherRating(submitCompanyAdminVoucherRatingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SubmitMemberEmployerRetentionRatingRequest} submitMemberEmployerRetentionRatingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitMemberEmployerRetentionRating(submitMemberEmployerRetentionRatingRequest, options) {
            return localVarFp.submitMemberEmployerRetentionRating(submitMemberEmployerRetentionRatingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SubmitMemberEnjoyingVitableRatingRequest} submitMemberEnjoyingVitableRatingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitMemberEnjoyingVitableRating(submitMemberEnjoyingVitableRatingRequest, options) {
            return localVarFp.submitMemberEnjoyingVitableRating(submitMemberEnjoyingVitableRatingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SubmitMemberNPSRatingRequest} submitMemberNPSRatingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitMemberNpsRating(submitMemberNPSRatingRequest, options) {
            return localVarFp.submitMemberNpsRating(submitMemberNPSRatingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SubmitMemberPersonalAssistantRatingRequest} submitMemberPersonalAssistantRatingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitMemberPersonalAssistanceRating(submitMemberPersonalAssistantRatingRequest, options) {
            return localVarFp.submitMemberPersonalAssistanceRating(submitMemberPersonalAssistantRatingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SubmitMemberProviderRatingRequest} submitMemberProviderRatingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitMemberProviderRating(submitMemberProviderRatingRequest, options) {
            return localVarFp.submitMemberProviderRating(submitMemberProviderRatingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SubmitProviderAppointmentRatingRequest} submitProviderAppointmentRatingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitProviderAppointmentRating(submitProviderAppointmentRatingRequest, options) {
            return localVarFp.submitProviderAppointmentRating(submitProviderAppointmentRatingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SubmitProviderClinicRatingRequest} submitProviderClinicRatingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitProviderClinicRating(submitProviderClinicRatingRequest, options) {
            return localVarFp.submitProviderClinicRating(submitProviderClinicRatingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SubmitProviderCompanyRatingRequest} submitProviderCompanyRatingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitProviderCompanyRating(submitProviderCompanyRatingRequest, options) {
            return localVarFp.submitProviderCompanyRating(submitProviderCompanyRatingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SubmitProviderMemberRatingRequest} submitProviderMemberRatingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitProviderMemberRating(submitProviderMemberRatingRequest, options) {
            return localVarFp.submitProviderMemberRating(submitProviderMemberRatingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {SubmitProviderNPSRatingRequest} submitProviderNPSRatingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitProviderNpsRating(submitProviderNPSRatingRequest, options) {
            return localVarFp.submitProviderNpsRating(submitProviderNPSRatingRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SurveyApi - object-oriented interface
 * @export
 * @class SurveyApi
 * @extends {BaseAPI}
 */
class SurveyApi extends base_1.BaseAPI {
    /**
     *
     * @param {SurveyApiAddSurveyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyApi
     */
    addSurvey(requestParameters, options) {
        return exports.SurveyApiFp(this.configuration).addSurvey(requestParameters.addSurveyRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyApi
     */
    checkShowCompanyAdminNps(options) {
        return exports.SurveyApiFp(this.configuration).checkShowCompanyAdminNps(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyApi
     */
    checkShowMemberEmployerRetentionRating(options) {
        return exports.SurveyApiFp(this.configuration).checkShowMemberEmployerRetentionRating(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyApi
     */
    checkShowMemberNps(options) {
        return exports.SurveyApiFp(this.configuration).checkShowMemberNps(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SurveyApiCheckShowMemberProviderRatingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyApi
     */
    checkShowMemberProviderRating(requestParameters, options) {
        return exports.SurveyApiFp(this.configuration).checkShowMemberProviderRating(requestParameters.appointmentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyApi
     */
    checkShowProviderNpsRating(options) {
        return exports.SurveyApiFp(this.configuration).checkShowProviderNpsRating(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SurveyApiGetAverageMemberProviderRatingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyApi
     */
    getAverageMemberProviderRating(requestParameters, options) {
        return exports.SurveyApiFp(this.configuration).getAverageMemberProviderRating(requestParameters.providerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the next appointment uid ready for 5-Star survey.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyApi
     */
    nextAppointmentSurvey(options) {
        return exports.SurveyApiFp(this.configuration).nextAppointmentSurvey(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyApi
     */
    nextAppointmentToSurveyForMember(options) {
        return exports.SurveyApiFp(this.configuration).nextAppointmentToSurveyForMember(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the next clinic appointment uid ready for CSAT survey.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyApi
     */
    nextClinicAppointmentSurvey(options) {
        return exports.SurveyApiFp(this.configuration).nextClinicAppointmentSurvey(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyApi
     */
    nextClinicToSurveyForCompanyAdmin(options) {
        return exports.SurveyApiFp(this.configuration).nextClinicToSurveyForCompanyAdmin(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Gets the next Occupational Health Lab Order Request uid ready for CSAT survey.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyApi
     */
    nextVoucherSurvey(options) {
        return exports.SurveyApiFp(this.configuration).nextVoucherSurvey(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyApi
     */
    nextVoucherToSurveyForCompanyAdmin(options) {
        return exports.SurveyApiFp(this.configuration).nextVoucherToSurveyForCompanyAdmin(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SurveyApiShouldShowSurveyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyApi
     */
    shouldShowSurvey(requestParameters, options) {
        return exports.SurveyApiFp(this.configuration).shouldShowSurvey(requestParameters.showSurveyRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SurveyApiSubmitCompanyAdminClinicRatingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyApi
     */
    submitCompanyAdminClinicRating(requestParameters, options) {
        return exports.SurveyApiFp(this.configuration).submitCompanyAdminClinicRating(requestParameters.submitCompanyAdminClinicRatingRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SurveyApiSubmitCompanyAdminNpsRatingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyApi
     */
    submitCompanyAdminNpsRating(requestParameters, options) {
        return exports.SurveyApiFp(this.configuration).submitCompanyAdminNpsRating(requestParameters.submitCompanyAdminNPSRatingRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SurveyApiSubmitCompanyAdminVoucherRatingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyApi
     */
    submitCompanyAdminVoucherRating(requestParameters, options) {
        return exports.SurveyApiFp(this.configuration).submitCompanyAdminVoucherRating(requestParameters.submitCompanyAdminVoucherRatingRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SurveyApiSubmitMemberEmployerRetentionRatingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyApi
     */
    submitMemberEmployerRetentionRating(requestParameters, options) {
        return exports.SurveyApiFp(this.configuration).submitMemberEmployerRetentionRating(requestParameters.submitMemberEmployerRetentionRatingRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SurveyApiSubmitMemberEnjoyingVitableRatingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyApi
     */
    submitMemberEnjoyingVitableRating(requestParameters, options) {
        return exports.SurveyApiFp(this.configuration).submitMemberEnjoyingVitableRating(requestParameters.submitMemberEnjoyingVitableRatingRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SurveyApiSubmitMemberNpsRatingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyApi
     */
    submitMemberNpsRating(requestParameters, options) {
        return exports.SurveyApiFp(this.configuration).submitMemberNpsRating(requestParameters.submitMemberNPSRatingRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SurveyApiSubmitMemberPersonalAssistanceRatingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyApi
     */
    submitMemberPersonalAssistanceRating(requestParameters, options) {
        return exports.SurveyApiFp(this.configuration).submitMemberPersonalAssistanceRating(requestParameters.submitMemberPersonalAssistantRatingRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SurveyApiSubmitMemberProviderRatingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyApi
     */
    submitMemberProviderRating(requestParameters, options) {
        return exports.SurveyApiFp(this.configuration).submitMemberProviderRating(requestParameters.submitMemberProviderRatingRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SurveyApiSubmitProviderAppointmentRatingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyApi
     */
    submitProviderAppointmentRating(requestParameters, options) {
        return exports.SurveyApiFp(this.configuration).submitProviderAppointmentRating(requestParameters.submitProviderAppointmentRatingRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SurveyApiSubmitProviderClinicRatingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyApi
     */
    submitProviderClinicRating(requestParameters, options) {
        return exports.SurveyApiFp(this.configuration).submitProviderClinicRating(requestParameters.submitProviderClinicRatingRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SurveyApiSubmitProviderCompanyRatingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyApi
     */
    submitProviderCompanyRating(requestParameters, options) {
        return exports.SurveyApiFp(this.configuration).submitProviderCompanyRating(requestParameters.submitProviderCompanyRatingRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SurveyApiSubmitProviderMemberRatingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyApi
     */
    submitProviderMemberRating(requestParameters, options) {
        return exports.SurveyApiFp(this.configuration).submitProviderMemberRating(requestParameters.submitProviderMemberRatingRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {SurveyApiSubmitProviderNpsRatingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyApi
     */
    submitProviderNpsRating(requestParameters, options) {
        return exports.SurveyApiFp(this.configuration).submitProviderNpsRating(requestParameters.submitProviderNPSRatingRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.SurveyApi = SurveyApi;
/**
 * TagApi - axios parameter creator
 * @export
 */
exports.TagApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} tagId
         * @param {string} targetId
         * @param {AttachTagTargetRequest} attachTagTargetRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachTagTarget: (tagId, targetId, attachTagTargetRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tagId' is not null or undefined
            common_1.assertParamExists('attachTagTarget', 'tagId', tagId);
            // verify required parameter 'targetId' is not null or undefined
            common_1.assertParamExists('attachTagTarget', 'targetId', targetId);
            // verify required parameter 'attachTagTargetRequest' is not null or undefined
            common_1.assertParamExists('attachTagTarget', 'attachTagTargetRequest', attachTagTargetRequest);
            const localVarPath = `/v1/tags/{tag_id}/targets/{target_id}`
                .replace(`{${"tag_id"}}`, encodeURIComponent(String(tagId)))
                .replace(`{${"target_id"}}`, encodeURIComponent(String(targetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(attachTagTargetRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CreateTagRequest} createTagRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTag: (createTagRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createTagRequest' is not null or undefined
            common_1.assertParamExists('createTag', 'createTagRequest', createTagRequest);
            const localVarPath = `/v1/tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createTagRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} tagId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTag: (tagId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tagId' is not null or undefined
            common_1.assertParamExists('deleteTag', 'tagId', tagId);
            const localVarPath = `/v1/tags/{tag_id}`
                .replace(`{${"tag_id"}}`, encodeURIComponent(String(tagId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} tagTargetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTagTarget: (tagTargetId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tagTargetId' is not null or undefined
            common_1.assertParamExists('deleteTagTarget', 'tagTargetId', tagTargetId);
            const localVarPath = `/v1/tag-targets/{tag_target_id}`
                .replace(`{${"tag_target_id"}}`, encodeURIComponent(String(tagTargetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} tagId
         * @param {string} targetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detachTagTarget: (tagId, targetId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tagId' is not null or undefined
            common_1.assertParamExists('detachTagTarget', 'tagId', tagId);
            // verify required parameter 'targetId' is not null or undefined
            common_1.assertParamExists('detachTagTarget', 'targetId', targetId);
            const localVarPath = `/v1/tags/{tag_id}/targets/{target_id}`
                .replace(`{${"tag_id"}}`, encodeURIComponent(String(tagId)))
                .replace(`{${"target_id"}}`, encodeURIComponent(String(targetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} tagId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTag: (tagId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tagId' is not null or undefined
            common_1.assertParamExists('getTag', 'tagId', tagId);
            const localVarPath = `/v1/tags/{tag_id}`
                .replace(`{${"tag_id"}}`, encodeURIComponent(String(tagId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [limit]
         * @param {string} [name]
         * @param {number} [page]
         * @param {string} [targetId]
         * @param {'Member' | 'null'} [targetType] * &#x60;Member&#x60; - Member
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTags: (limit, name, page, targetId, targetType, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (targetId !== undefined) {
                localVarQueryParameter['target_id'] = targetId;
            }
            if (targetType !== undefined) {
                localVarQueryParameter['target_type'] = targetType;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} tagId
         * @param {UpdateTagRequest} updateTagRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTag: (tagId, updateTagRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'tagId' is not null or undefined
            common_1.assertParamExists('updateTag', 'tagId', tagId);
            // verify required parameter 'updateTagRequest' is not null or undefined
            common_1.assertParamExists('updateTag', 'updateTagRequest', updateTagRequest);
            const localVarPath = `/v1/tags/{tag_id}`
                .replace(`{${"tag_id"}}`, encodeURIComponent(String(tagId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateTagRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * TagApi - functional programming interface
 * @export
 */
exports.TagApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.TagApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} tagId
         * @param {string} targetId
         * @param {AttachTagTargetRequest} attachTagTargetRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachTagTarget(tagId, targetId, attachTagTargetRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.attachTagTarget(tagId, targetId, attachTagTargetRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {CreateTagRequest} createTagRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTag(createTagRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createTag(createTagRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} tagId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTag(tagId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteTag(tagId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} tagTargetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTagTarget(tagTargetId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteTagTarget(tagTargetId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} tagId
         * @param {string} targetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detachTagTarget(tagId, targetId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.detachTagTarget(tagId, targetId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} tagId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTag(tagId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTag(tagId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} [limit]
         * @param {string} [name]
         * @param {number} [page]
         * @param {string} [targetId]
         * @param {'Member' | 'null'} [targetType] * &#x60;Member&#x60; - Member
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTags(limit, name, page, targetId, targetType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listTags(limit, name, page, targetId, targetType, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} tagId
         * @param {UpdateTagRequest} updateTagRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTag(tagId, updateTagRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateTag(tagId, updateTagRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * TagApi - factory interface
 * @export
 */
exports.TagApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.TagApiFp(configuration);
    return {
        /**
         *
         * @param {string} tagId
         * @param {string} targetId
         * @param {AttachTagTargetRequest} attachTagTargetRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachTagTarget(tagId, targetId, attachTagTargetRequest, options) {
            return localVarFp.attachTagTarget(tagId, targetId, attachTagTargetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateTagRequest} createTagRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTag(createTagRequest, options) {
            return localVarFp.createTag(createTagRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} tagId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTag(tagId, options) {
            return localVarFp.deleteTag(tagId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} tagTargetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTagTarget(tagTargetId, options) {
            return localVarFp.deleteTagTarget(tagTargetId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} tagId
         * @param {string} targetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detachTagTarget(tagId, targetId, options) {
            return localVarFp.detachTagTarget(tagId, targetId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} tagId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTag(tagId, options) {
            return localVarFp.getTag(tagId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [limit]
         * @param {string} [name]
         * @param {number} [page]
         * @param {string} [targetId]
         * @param {'Member' | 'null'} [targetType] * &#x60;Member&#x60; - Member
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTags(limit, name, page, targetId, targetType, options) {
            return localVarFp.listTags(limit, name, page, targetId, targetType, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} tagId
         * @param {UpdateTagRequest} updateTagRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTag(tagId, updateTagRequest, options) {
            return localVarFp.updateTag(tagId, updateTagRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * TagApi - object-oriented interface
 * @export
 * @class TagApi
 * @extends {BaseAPI}
 */
class TagApi extends base_1.BaseAPI {
    /**
     *
     * @param {TagApiAttachTagTargetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagApi
     */
    attachTagTarget(requestParameters, options) {
        return exports.TagApiFp(this.configuration).attachTagTarget(requestParameters.tagId, requestParameters.targetId, requestParameters.attachTagTargetRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {TagApiCreateTagRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagApi
     */
    createTag(requestParameters, options) {
        return exports.TagApiFp(this.configuration).createTag(requestParameters.createTagRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {TagApiDeleteTagRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagApi
     */
    deleteTag(requestParameters, options) {
        return exports.TagApiFp(this.configuration).deleteTag(requestParameters.tagId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {TagApiDeleteTagTargetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagApi
     */
    deleteTagTarget(requestParameters, options) {
        return exports.TagApiFp(this.configuration).deleteTagTarget(requestParameters.tagTargetId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {TagApiDetachTagTargetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagApi
     */
    detachTagTarget(requestParameters, options) {
        return exports.TagApiFp(this.configuration).detachTagTarget(requestParameters.tagId, requestParameters.targetId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {TagApiGetTagRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagApi
     */
    getTag(requestParameters, options) {
        return exports.TagApiFp(this.configuration).getTag(requestParameters.tagId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {TagApiListTagsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagApi
     */
    listTags(requestParameters = {}, options) {
        return exports.TagApiFp(this.configuration).listTags(requestParameters.limit, requestParameters.name, requestParameters.page, requestParameters.targetId, requestParameters.targetType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {TagApiUpdateTagRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagApi
     */
    updateTag(requestParameters, options) {
        return exports.TagApiFp(this.configuration).updateTag(requestParameters.tagId, requestParameters.updateTagRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.TagApi = TagApi;
/**
 * TaskApi - axios parameter creator
 * @export
 */
exports.TaskApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CreateFollowUpAppointmentTaskRequest} createFollowUpAppointmentTaskRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFollowUpAppointmentTask: (createFollowUpAppointmentTaskRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createFollowUpAppointmentTaskRequest' is not null or undefined
            common_1.assertParamExists('createFollowUpAppointmentTask', 'createFollowUpAppointmentTaskRequest', createFollowUpAppointmentTaskRequest);
            const localVarPath = `/v1/follow-up-appointment-tasks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createFollowUpAppointmentTaskRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CreateTaskRequest} createTaskRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTask: (createTaskRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createTaskRequest' is not null or undefined
            common_1.assertParamExists('createTask', 'createTaskRequest', createTaskRequest);
            const localVarPath = `/v1/tasks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(createTaskRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} taskId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFollowUpAppointmentTask: (taskId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'taskId' is not null or undefined
            common_1.assertParamExists('deleteFollowUpAppointmentTask', 'taskId', taskId);
            const localVarPath = `/v1/follow-up-appointment-tasks/{task_id}`
                .replace(`{${"task_id"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} taskId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTask: (taskId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'taskId' is not null or undefined
            common_1.assertParamExists('deleteTask', 'taskId', taskId);
            const localVarPath = `/v1/tasks/{task_id}`
                .replace(`{${"task_id"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} taskId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFollowUpAppointmentTask: (taskId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'taskId' is not null or undefined
            common_1.assertParamExists('getFollowUpAppointmentTask', 'taskId', taskId);
            const localVarPath = `/v1/follow-up-appointment-tasks/{task_id}`
                .replace(`{${"task_id"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} taskId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTask: (taskId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'taskId' is not null or undefined
            common_1.assertParamExists('getTask', 'taskId', taskId);
            const localVarPath = `/v1/tasks/{task_id}`
                .replace(`{${"task_id"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [appointmentId]
         * @param {boolean} [appointmentScheduledIn]
         * @param {string} [assigneeId]
         * @param {number} [limit]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFollowUpAppointmentTasks: (appointmentId, appointmentScheduledIn, assigneeId, limit, page, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/follow-up-appointment-tasks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (appointmentId !== undefined) {
                localVarQueryParameter['appointment_id'] = appointmentId;
            }
            if (appointmentScheduledIn !== undefined) {
                localVarQueryParameter['appointment_scheduled_in'] = appointmentScheduledIn;
            }
            if (assigneeId !== undefined) {
                localVarQueryParameter['assignee_id'] = assigneeId;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {boolean} [defaultIn]
         * @param {boolean} [indicatesCompletionIn]
         * @param {number} [limit]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTaskStatuses: (defaultIn, indicatesCompletionIn, limit, page, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/task-statuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (defaultIn !== undefined) {
                localVarQueryParameter['default_in'] = defaultIn;
            }
            if (indicatesCompletionIn !== undefined) {
                localVarQueryParameter['indicates_completion_in'] = indicatesCompletionIn;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {boolean} [defaultIn]
         * @param {number} [limit]
         * @param {number} [page]
         * @param {boolean} [providerVisibleIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTaskTypes: (defaultIn, limit, page, providerVisibleIn, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/task-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (defaultIn !== undefined) {
                localVarQueryParameter['default_in'] = defaultIn;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (providerVisibleIn !== undefined) {
                localVarQueryParameter['provider_visible_in'] = providerVisibleIn;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [assigneeId]
         * @param {'Primary Care' | 'Occupational Health' | 'null'} [category] * &#x60;Primary Care&#x60; - Primary Care * &#x60;Occupational Health&#x60; - Occupational Health
         * @param {boolean} [completedIn]
         * @param {string} [creatorId]
         * @param {boolean} [deletedIn]
         * @param {'Patient' | 'Provider' | 'Care Team' | 'null'} [designation] * &#x60;Patient&#x60; - Patient * &#x60;Provider&#x60; - Provider * &#x60;Care Team&#x60; - Care Team
         * @param {string} [dueAfter]
         * @param {string} [dueBefore]
         * @param {string} [encounterId]
         * @param {number} [limit]
         * @param {string} [memberId]
         * @param {number} [page]
         * @param {'Normal' | 'STAT' | 'null'} [priority] * &#x60;Normal&#x60; - Normal * &#x60;STAT&#x60; - Stat
         * @param {string} [problemId]
         * @param {string} [statusId]
         * @param {string} [statusName]
         * @param {string} [taskContent]
         * @param {string} [ticketId]
         * @param {string} [typeId]
         * @param {string} [typeName]
         * @param {boolean} [visibleToMemberOnlyIn]
         * @param {boolean} [withoutAssigneeIn]
         * @param {boolean} [withoutEncounterIn]
         * @param {boolean} [withoutProblemIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTasks: (assigneeId, category, completedIn, creatorId, deletedIn, designation, dueAfter, dueBefore, encounterId, limit, memberId, page, priority, problemId, statusId, statusName, taskContent, ticketId, typeId, typeName, visibleToMemberOnlyIn, withoutAssigneeIn, withoutEncounterIn, withoutProblemIn, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/tasks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (assigneeId !== undefined) {
                localVarQueryParameter['assignee_id'] = assigneeId;
            }
            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }
            if (completedIn !== undefined) {
                localVarQueryParameter['completed_in'] = completedIn;
            }
            if (creatorId !== undefined) {
                localVarQueryParameter['creator_id'] = creatorId;
            }
            if (deletedIn !== undefined) {
                localVarQueryParameter['deleted_in'] = deletedIn;
            }
            if (designation !== undefined) {
                localVarQueryParameter['designation'] = designation;
            }
            if (dueAfter !== undefined) {
                localVarQueryParameter['due_after'] = (dueAfter instanceof Date) ?
                    dueAfter.toISOString() :
                    dueAfter;
            }
            if (dueBefore !== undefined) {
                localVarQueryParameter['due_before'] = (dueBefore instanceof Date) ?
                    dueBefore.toISOString() :
                    dueBefore;
            }
            if (encounterId !== undefined) {
                localVarQueryParameter['encounter_id'] = encounterId;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (memberId !== undefined) {
                localVarQueryParameter['member_id'] = memberId;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (priority !== undefined) {
                localVarQueryParameter['priority'] = priority;
            }
            if (problemId !== undefined) {
                localVarQueryParameter['problem_id'] = problemId;
            }
            if (statusId !== undefined) {
                localVarQueryParameter['status_id'] = statusId;
            }
            if (statusName !== undefined) {
                localVarQueryParameter['status_name'] = statusName;
            }
            if (taskContent !== undefined) {
                localVarQueryParameter['task_content'] = taskContent;
            }
            if (ticketId !== undefined) {
                localVarQueryParameter['ticket_id'] = ticketId;
            }
            if (typeId !== undefined) {
                localVarQueryParameter['type_id'] = typeId;
            }
            if (typeName !== undefined) {
                localVarQueryParameter['type_name'] = typeName;
            }
            if (visibleToMemberOnlyIn !== undefined) {
                localVarQueryParameter['visible_to_member_only_in'] = visibleToMemberOnlyIn;
            }
            if (withoutAssigneeIn !== undefined) {
                localVarQueryParameter['without_assignee_in'] = withoutAssigneeIn;
            }
            if (withoutEncounterIn !== undefined) {
                localVarQueryParameter['without_encounter_in'] = withoutEncounterIn;
            }
            if (withoutProblemIn !== undefined) {
                localVarQueryParameter['without_problem_in'] = withoutProblemIn;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} taskId
         * @param {UpdateTaskRequest} updateTaskRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTask: (taskId, updateTaskRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'taskId' is not null or undefined
            common_1.assertParamExists('updateTask', 'taskId', taskId);
            // verify required parameter 'updateTaskRequest' is not null or undefined
            common_1.assertParamExists('updateTask', 'updateTaskRequest', updateTaskRequest);
            const localVarPath = `/v1/tasks/{task_id}`
                .replace(`{${"task_id"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateTaskRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * TaskApi - functional programming interface
 * @export
 */
exports.TaskApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.TaskApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CreateFollowUpAppointmentTaskRequest} createFollowUpAppointmentTaskRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFollowUpAppointmentTask(createFollowUpAppointmentTaskRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createFollowUpAppointmentTask(createFollowUpAppointmentTaskRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {CreateTaskRequest} createTaskRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTask(createTaskRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createTask(createTaskRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} taskId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFollowUpAppointmentTask(taskId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteFollowUpAppointmentTask(taskId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} taskId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTask(taskId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteTask(taskId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} taskId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFollowUpAppointmentTask(taskId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getFollowUpAppointmentTask(taskId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} taskId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTask(taskId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTask(taskId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} [appointmentId]
         * @param {boolean} [appointmentScheduledIn]
         * @param {string} [assigneeId]
         * @param {number} [limit]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFollowUpAppointmentTasks(appointmentId, appointmentScheduledIn, assigneeId, limit, page, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listFollowUpAppointmentTasks(appointmentId, appointmentScheduledIn, assigneeId, limit, page, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {boolean} [defaultIn]
         * @param {boolean} [indicatesCompletionIn]
         * @param {number} [limit]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTaskStatuses(defaultIn, indicatesCompletionIn, limit, page, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listTaskStatuses(defaultIn, indicatesCompletionIn, limit, page, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {boolean} [defaultIn]
         * @param {number} [limit]
         * @param {number} [page]
         * @param {boolean} [providerVisibleIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTaskTypes(defaultIn, limit, page, providerVisibleIn, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listTaskTypes(defaultIn, limit, page, providerVisibleIn, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} [assigneeId]
         * @param {'Primary Care' | 'Occupational Health' | 'null'} [category] * &#x60;Primary Care&#x60; - Primary Care * &#x60;Occupational Health&#x60; - Occupational Health
         * @param {boolean} [completedIn]
         * @param {string} [creatorId]
         * @param {boolean} [deletedIn]
         * @param {'Patient' | 'Provider' | 'Care Team' | 'null'} [designation] * &#x60;Patient&#x60; - Patient * &#x60;Provider&#x60; - Provider * &#x60;Care Team&#x60; - Care Team
         * @param {string} [dueAfter]
         * @param {string} [dueBefore]
         * @param {string} [encounterId]
         * @param {number} [limit]
         * @param {string} [memberId]
         * @param {number} [page]
         * @param {'Normal' | 'STAT' | 'null'} [priority] * &#x60;Normal&#x60; - Normal * &#x60;STAT&#x60; - Stat
         * @param {string} [problemId]
         * @param {string} [statusId]
         * @param {string} [statusName]
         * @param {string} [taskContent]
         * @param {string} [ticketId]
         * @param {string} [typeId]
         * @param {string} [typeName]
         * @param {boolean} [visibleToMemberOnlyIn]
         * @param {boolean} [withoutAssigneeIn]
         * @param {boolean} [withoutEncounterIn]
         * @param {boolean} [withoutProblemIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTasks(assigneeId, category, completedIn, creatorId, deletedIn, designation, dueAfter, dueBefore, encounterId, limit, memberId, page, priority, problemId, statusId, statusName, taskContent, ticketId, typeId, typeName, visibleToMemberOnlyIn, withoutAssigneeIn, withoutEncounterIn, withoutProblemIn, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listTasks(assigneeId, category, completedIn, creatorId, deletedIn, designation, dueAfter, dueBefore, encounterId, limit, memberId, page, priority, problemId, statusId, statusName, taskContent, ticketId, typeId, typeName, visibleToMemberOnlyIn, withoutAssigneeIn, withoutEncounterIn, withoutProblemIn, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} taskId
         * @param {UpdateTaskRequest} updateTaskRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTask(taskId, updateTaskRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateTask(taskId, updateTaskRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * TaskApi - factory interface
 * @export
 */
exports.TaskApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.TaskApiFp(configuration);
    return {
        /**
         *
         * @param {CreateFollowUpAppointmentTaskRequest} createFollowUpAppointmentTaskRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFollowUpAppointmentTask(createFollowUpAppointmentTaskRequest, options) {
            return localVarFp.createFollowUpAppointmentTask(createFollowUpAppointmentTaskRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CreateTaskRequest} createTaskRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTask(createTaskRequest, options) {
            return localVarFp.createTask(createTaskRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} taskId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFollowUpAppointmentTask(taskId, options) {
            return localVarFp.deleteFollowUpAppointmentTask(taskId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} taskId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTask(taskId, options) {
            return localVarFp.deleteTask(taskId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} taskId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFollowUpAppointmentTask(taskId, options) {
            return localVarFp.getFollowUpAppointmentTask(taskId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} taskId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTask(taskId, options) {
            return localVarFp.getTask(taskId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [appointmentId]
         * @param {boolean} [appointmentScheduledIn]
         * @param {string} [assigneeId]
         * @param {number} [limit]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFollowUpAppointmentTasks(appointmentId, appointmentScheduledIn, assigneeId, limit, page, options) {
            return localVarFp.listFollowUpAppointmentTasks(appointmentId, appointmentScheduledIn, assigneeId, limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {boolean} [defaultIn]
         * @param {boolean} [indicatesCompletionIn]
         * @param {number} [limit]
         * @param {number} [page]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTaskStatuses(defaultIn, indicatesCompletionIn, limit, page, options) {
            return localVarFp.listTaskStatuses(defaultIn, indicatesCompletionIn, limit, page, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {boolean} [defaultIn]
         * @param {number} [limit]
         * @param {number} [page]
         * @param {boolean} [providerVisibleIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTaskTypes(defaultIn, limit, page, providerVisibleIn, options) {
            return localVarFp.listTaskTypes(defaultIn, limit, page, providerVisibleIn, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [assigneeId]
         * @param {'Primary Care' | 'Occupational Health' | 'null'} [category] * &#x60;Primary Care&#x60; - Primary Care * &#x60;Occupational Health&#x60; - Occupational Health
         * @param {boolean} [completedIn]
         * @param {string} [creatorId]
         * @param {boolean} [deletedIn]
         * @param {'Patient' | 'Provider' | 'Care Team' | 'null'} [designation] * &#x60;Patient&#x60; - Patient * &#x60;Provider&#x60; - Provider * &#x60;Care Team&#x60; - Care Team
         * @param {string} [dueAfter]
         * @param {string} [dueBefore]
         * @param {string} [encounterId]
         * @param {number} [limit]
         * @param {string} [memberId]
         * @param {number} [page]
         * @param {'Normal' | 'STAT' | 'null'} [priority] * &#x60;Normal&#x60; - Normal * &#x60;STAT&#x60; - Stat
         * @param {string} [problemId]
         * @param {string} [statusId]
         * @param {string} [statusName]
         * @param {string} [taskContent]
         * @param {string} [ticketId]
         * @param {string} [typeId]
         * @param {string} [typeName]
         * @param {boolean} [visibleToMemberOnlyIn]
         * @param {boolean} [withoutAssigneeIn]
         * @param {boolean} [withoutEncounterIn]
         * @param {boolean} [withoutProblemIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTasks(assigneeId, category, completedIn, creatorId, deletedIn, designation, dueAfter, dueBefore, encounterId, limit, memberId, page, priority, problemId, statusId, statusName, taskContent, ticketId, typeId, typeName, visibleToMemberOnlyIn, withoutAssigneeIn, withoutEncounterIn, withoutProblemIn, options) {
            return localVarFp.listTasks(assigneeId, category, completedIn, creatorId, deletedIn, designation, dueAfter, dueBefore, encounterId, limit, memberId, page, priority, problemId, statusId, statusName, taskContent, ticketId, typeId, typeName, visibleToMemberOnlyIn, withoutAssigneeIn, withoutEncounterIn, withoutProblemIn, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} taskId
         * @param {UpdateTaskRequest} updateTaskRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTask(taskId, updateTaskRequest, options) {
            return localVarFp.updateTask(taskId, updateTaskRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * TaskApi - object-oriented interface
 * @export
 * @class TaskApi
 * @extends {BaseAPI}
 */
class TaskApi extends base_1.BaseAPI {
    /**
     *
     * @param {TaskApiCreateFollowUpAppointmentTaskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskApi
     */
    createFollowUpAppointmentTask(requestParameters, options) {
        return exports.TaskApiFp(this.configuration).createFollowUpAppointmentTask(requestParameters.createFollowUpAppointmentTaskRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {TaskApiCreateTaskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskApi
     */
    createTask(requestParameters, options) {
        return exports.TaskApiFp(this.configuration).createTask(requestParameters.createTaskRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {TaskApiDeleteFollowUpAppointmentTaskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskApi
     */
    deleteFollowUpAppointmentTask(requestParameters, options) {
        return exports.TaskApiFp(this.configuration).deleteFollowUpAppointmentTask(requestParameters.taskId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {TaskApiDeleteTaskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskApi
     */
    deleteTask(requestParameters, options) {
        return exports.TaskApiFp(this.configuration).deleteTask(requestParameters.taskId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {TaskApiGetFollowUpAppointmentTaskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskApi
     */
    getFollowUpAppointmentTask(requestParameters, options) {
        return exports.TaskApiFp(this.configuration).getFollowUpAppointmentTask(requestParameters.taskId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {TaskApiGetTaskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskApi
     */
    getTask(requestParameters, options) {
        return exports.TaskApiFp(this.configuration).getTask(requestParameters.taskId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {TaskApiListFollowUpAppointmentTasksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskApi
     */
    listFollowUpAppointmentTasks(requestParameters = {}, options) {
        return exports.TaskApiFp(this.configuration).listFollowUpAppointmentTasks(requestParameters.appointmentId, requestParameters.appointmentScheduledIn, requestParameters.assigneeId, requestParameters.limit, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {TaskApiListTaskStatusesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskApi
     */
    listTaskStatuses(requestParameters = {}, options) {
        return exports.TaskApiFp(this.configuration).listTaskStatuses(requestParameters.defaultIn, requestParameters.indicatesCompletionIn, requestParameters.limit, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {TaskApiListTaskTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskApi
     */
    listTaskTypes(requestParameters = {}, options) {
        return exports.TaskApiFp(this.configuration).listTaskTypes(requestParameters.defaultIn, requestParameters.limit, requestParameters.page, requestParameters.providerVisibleIn, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {TaskApiListTasksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskApi
     */
    listTasks(requestParameters = {}, options) {
        return exports.TaskApiFp(this.configuration).listTasks(requestParameters.assigneeId, requestParameters.category, requestParameters.completedIn, requestParameters.creatorId, requestParameters.deletedIn, requestParameters.designation, requestParameters.dueAfter, requestParameters.dueBefore, requestParameters.encounterId, requestParameters.limit, requestParameters.memberId, requestParameters.page, requestParameters.priority, requestParameters.problemId, requestParameters.statusId, requestParameters.statusName, requestParameters.taskContent, requestParameters.ticketId, requestParameters.typeId, requestParameters.typeName, requestParameters.visibleToMemberOnlyIn, requestParameters.withoutAssigneeIn, requestParameters.withoutEncounterIn, requestParameters.withoutProblemIn, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {TaskApiUpdateTaskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskApi
     */
    updateTask(requestParameters, options) {
        return exports.TaskApiFp(this.configuration).updateTask(requestParameters.taskId, requestParameters.updateTaskRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.TaskApi = TaskApi;
/**
 * ToDoApi - axios parameter creator
 * @export
 */
exports.ToDoApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Completes a To-Do for a member (Patient Tasks + To-Do)
         * @param {string} memberId
         * @param {string} todoId
         * @param {CompleteMemberToDoRequest} completeMemberToDoRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeMemberTodo: (memberId, todoId, completeMemberToDoRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'memberId' is not null or undefined
            common_1.assertParamExists('completeMemberTodo', 'memberId', memberId);
            // verify required parameter 'todoId' is not null or undefined
            common_1.assertParamExists('completeMemberTodo', 'todoId', todoId);
            // verify required parameter 'completeMemberToDoRequest' is not null or undefined
            common_1.assertParamExists('completeMemberTodo', 'completeMemberToDoRequest', completeMemberToDoRequest);
            const localVarPath = `/v1/members/{member_id}/todos/{todo_id}/complete`
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)))
                .replace(`{${"todo_id"}}`, encodeURIComponent(String(todoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(completeMemberToDoRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Lists all To-Dos for a member (Patient Tasks + To-Do)
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMemberTodos: (memberId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'memberId' is not null or undefined
            common_1.assertParamExists('listMemberTodos', 'memberId', memberId);
            const localVarPath = `/v1/members/{member_id}/todos`
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ToDoApi - functional programming interface
 * @export
 */
exports.ToDoApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.ToDoApiAxiosParamCreator(configuration);
    return {
        /**
         * Completes a To-Do for a member (Patient Tasks + To-Do)
         * @param {string} memberId
         * @param {string} todoId
         * @param {CompleteMemberToDoRequest} completeMemberToDoRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeMemberTodo(memberId, todoId, completeMemberToDoRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.completeMemberTodo(memberId, todoId, completeMemberToDoRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Lists all To-Dos for a member (Patient Tasks + To-Do)
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMemberTodos(memberId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listMemberTodos(memberId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ToDoApi - factory interface
 * @export
 */
exports.ToDoApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.ToDoApiFp(configuration);
    return {
        /**
         * Completes a To-Do for a member (Patient Tasks + To-Do)
         * @param {string} memberId
         * @param {string} todoId
         * @param {CompleteMemberToDoRequest} completeMemberToDoRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeMemberTodo(memberId, todoId, completeMemberToDoRequest, options) {
            return localVarFp.completeMemberTodo(memberId, todoId, completeMemberToDoRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists all To-Dos for a member (Patient Tasks + To-Do)
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMemberTodos(memberId, options) {
            return localVarFp.listMemberTodos(memberId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ToDoApi - object-oriented interface
 * @export
 * @class ToDoApi
 * @extends {BaseAPI}
 */
class ToDoApi extends base_1.BaseAPI {
    /**
     * Completes a To-Do for a member (Patient Tasks + To-Do)
     * @param {ToDoApiCompleteMemberTodoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToDoApi
     */
    completeMemberTodo(requestParameters, options) {
        return exports.ToDoApiFp(this.configuration).completeMemberTodo(requestParameters.memberId, requestParameters.todoId, requestParameters.completeMemberToDoRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Lists all To-Dos for a member (Patient Tasks + To-Do)
     * @param {ToDoApiListMemberTodosRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToDoApi
     */
    listMemberTodos(requestParameters, options) {
        return exports.ToDoApiFp(this.configuration).listMemberTodos(requestParameters.memberId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ToDoApi = ToDoApi;
/**
 * UrgentCareOrderingApi - axios parameter creator
 * @export
 */
exports.UrgentCareOrderingApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} urgentCareOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicUrgentCareOrderDetails: (urgentCareOrderId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'urgentCareOrderId' is not null or undefined
            common_1.assertParamExists('getPublicUrgentCareOrderDetails', 'urgentCareOrderId', urgentCareOrderId);
            const localVarPath = `/v1/urgent-care-orders/public/{urgent_care_order_id}`
                .replace(`{${"urgent_care_order_id"}}`, encodeURIComponent(String(urgentCareOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} urgentCareOrderRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUrgentCareOrderRequest: (urgentCareOrderRequestId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'urgentCareOrderRequestId' is not null or undefined
            common_1.assertParamExists('getUrgentCareOrderRequest', 'urgentCareOrderRequestId', urgentCareOrderRequestId);
            const localVarPath = `/v1/urgent-care-order-requests/{urgent_care_order_request_id}`
                .replace(`{${"urgent_care_order_request_id"}}`, encodeURIComponent(String(urgentCareOrderRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {boolean} [cancelledIn]
         * @param {string} [companyId]
         * @param {boolean} [completedIn]
         * @param {boolean} [excludeCancelledUnlessResultedIn]
         * @param {boolean} [includeTagsIn]
         * @param {'LabCorp' | 'Quest' | 'Sunrise Medical'} [lab] * &#x60;LabCorp&#x60; - Lab Corp * &#x60;Quest&#x60; - Quest * &#x60;Sunrise Medical&#x60; - Sunrise Medical
         * @param {number} [limit]
         * @param {string} [memberId]
         * @param {boolean} [needsReviewedIn]
         * @param {boolean} [orderedIn]
         * @param {number} [page]
         * @param {string} [requestedOnEndDatetime]
         * @param {string} [requestedOnStartDatetime]
         * @param {'CVS MinuteClinic'} [urgentCare] * &#x60;CVS MinuteClinic&#x60; - Cvs Minute Clinic
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrderRequests: (cancelledIn, companyId, completedIn, excludeCancelledUnlessResultedIn, includeTagsIn, lab, limit, memberId, needsReviewedIn, orderedIn, page, requestedOnEndDatetime, requestedOnStartDatetime, urgentCare, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/order-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (cancelledIn !== undefined) {
                localVarQueryParameter['cancelled_in'] = cancelledIn;
            }
            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }
            if (completedIn !== undefined) {
                localVarQueryParameter['completed_in'] = completedIn;
            }
            if (excludeCancelledUnlessResultedIn !== undefined) {
                localVarQueryParameter['exclude_cancelled_unless_resulted_in'] = excludeCancelledUnlessResultedIn;
            }
            if (includeTagsIn !== undefined) {
                localVarQueryParameter['include_tags_in'] = includeTagsIn;
            }
            if (lab !== undefined) {
                localVarQueryParameter['lab'] = lab;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (memberId !== undefined) {
                localVarQueryParameter['member_id'] = memberId;
            }
            if (needsReviewedIn !== undefined) {
                localVarQueryParameter['needs_reviewed_in'] = needsReviewedIn;
            }
            if (orderedIn !== undefined) {
                localVarQueryParameter['ordered_in'] = orderedIn;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (requestedOnEndDatetime !== undefined) {
                localVarQueryParameter['requested_on_end_datetime'] = (requestedOnEndDatetime instanceof Date) ?
                    requestedOnEndDatetime.toISOString() :
                    requestedOnEndDatetime;
            }
            if (requestedOnStartDatetime !== undefined) {
                localVarQueryParameter['requested_on_start_datetime'] = (requestedOnStartDatetime instanceof Date) ?
                    requestedOnStartDatetime.toISOString() :
                    requestedOnStartDatetime;
            }
            if (urgentCare !== undefined) {
                localVarQueryParameter['urgent_care'] = urgentCare;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {PlaceOrderRequestsForMembersRequest} placeOrderRequestsForMembersRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placeOrderRequestsForMembers: (placeOrderRequestsForMembersRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'placeOrderRequestsForMembersRequest' is not null or undefined
            common_1.assertParamExists('placeOrderRequestsForMembers', 'placeOrderRequestsForMembersRequest', placeOrderRequestsForMembersRequest);
            const localVarPath = `/v1/order-requests/order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(placeOrderRequestsForMembersRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} urgentCareOrderRequestId
         * @param {RsvpToUrgentCareOrderRequest} rsvpToUrgentCareOrderRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rsvpToUrgentCareOrderRequest: (urgentCareOrderRequestId, rsvpToUrgentCareOrderRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'urgentCareOrderRequestId' is not null or undefined
            common_1.assertParamExists('rsvpToUrgentCareOrderRequest', 'urgentCareOrderRequestId', urgentCareOrderRequestId);
            // verify required parameter 'rsvpToUrgentCareOrderRequest' is not null or undefined
            common_1.assertParamExists('rsvpToUrgentCareOrderRequest', 'rsvpToUrgentCareOrderRequest', rsvpToUrgentCareOrderRequest);
            const localVarPath = `/v1/urgent-care-order-requests/{urgent_care_order_request_id}/rsvp`
                .replace(`{${"urgent_care_order_request_id"}}`, encodeURIComponent(String(urgentCareOrderRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(rsvpToUrgentCareOrderRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} urgentCareOrderRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendUrgentCareOrderInstructions: (urgentCareOrderRequestId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'urgentCareOrderRequestId' is not null or undefined
            common_1.assertParamExists('sendUrgentCareOrderInstructions', 'urgentCareOrderRequestId', urgentCareOrderRequestId);
            const localVarPath = `/v1/urgent-care-order-requests/{urgent_care_order_request_id}/send-instructions`
                .replace(`{${"urgent_care_order_request_id"}}`, encodeURIComponent(String(urgentCareOrderRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} urgentCareOrderedServiceId
         * @param {string} resultsFile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadUrgentCareOrderedServiceResult: (urgentCareOrderedServiceId, resultsFile, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'urgentCareOrderedServiceId' is not null or undefined
            common_1.assertParamExists('uploadUrgentCareOrderedServiceResult', 'urgentCareOrderedServiceId', urgentCareOrderedServiceId);
            // verify required parameter 'resultsFile' is not null or undefined
            common_1.assertParamExists('uploadUrgentCareOrderedServiceResult', 'resultsFile', resultsFile);
            const localVarPath = `/v1/urgent-care-ordered_services/{urgent_care_ordered_service_id}/upload-results`
                .replace(`{${"urgent_care_ordered_service_id"}}`, encodeURIComponent(String(urgentCareOrderedServiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (resultsFile !== undefined) {
                localVarFormParams.append('results_file', resultsFile);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * UrgentCareOrderingApi - functional programming interface
 * @export
 */
exports.UrgentCareOrderingApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.UrgentCareOrderingApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} urgentCareOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicUrgentCareOrderDetails(urgentCareOrderId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPublicUrgentCareOrderDetails(urgentCareOrderId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} urgentCareOrderRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUrgentCareOrderRequest(urgentCareOrderRequestId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUrgentCareOrderRequest(urgentCareOrderRequestId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {boolean} [cancelledIn]
         * @param {string} [companyId]
         * @param {boolean} [completedIn]
         * @param {boolean} [excludeCancelledUnlessResultedIn]
         * @param {boolean} [includeTagsIn]
         * @param {'LabCorp' | 'Quest' | 'Sunrise Medical'} [lab] * &#x60;LabCorp&#x60; - Lab Corp * &#x60;Quest&#x60; - Quest * &#x60;Sunrise Medical&#x60; - Sunrise Medical
         * @param {number} [limit]
         * @param {string} [memberId]
         * @param {boolean} [needsReviewedIn]
         * @param {boolean} [orderedIn]
         * @param {number} [page]
         * @param {string} [requestedOnEndDatetime]
         * @param {string} [requestedOnStartDatetime]
         * @param {'CVS MinuteClinic'} [urgentCare] * &#x60;CVS MinuteClinic&#x60; - Cvs Minute Clinic
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrderRequests(cancelledIn, companyId, completedIn, excludeCancelledUnlessResultedIn, includeTagsIn, lab, limit, memberId, needsReviewedIn, orderedIn, page, requestedOnEndDatetime, requestedOnStartDatetime, urgentCare, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listOrderRequests(cancelledIn, companyId, completedIn, excludeCancelledUnlessResultedIn, includeTagsIn, lab, limit, memberId, needsReviewedIn, orderedIn, page, requestedOnEndDatetime, requestedOnStartDatetime, urgentCare, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {PlaceOrderRequestsForMembersRequest} placeOrderRequestsForMembersRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placeOrderRequestsForMembers(placeOrderRequestsForMembersRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.placeOrderRequestsForMembers(placeOrderRequestsForMembersRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} urgentCareOrderRequestId
         * @param {RsvpToUrgentCareOrderRequest} rsvpToUrgentCareOrderRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rsvpToUrgentCareOrderRequest(urgentCareOrderRequestId, rsvpToUrgentCareOrderRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.rsvpToUrgentCareOrderRequest(urgentCareOrderRequestId, rsvpToUrgentCareOrderRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} urgentCareOrderRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendUrgentCareOrderInstructions(urgentCareOrderRequestId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sendUrgentCareOrderInstructions(urgentCareOrderRequestId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} urgentCareOrderedServiceId
         * @param {string} resultsFile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadUrgentCareOrderedServiceResult(urgentCareOrderedServiceId, resultsFile, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.uploadUrgentCareOrderedServiceResult(urgentCareOrderedServiceId, resultsFile, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * UrgentCareOrderingApi - factory interface
 * @export
 */
exports.UrgentCareOrderingApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.UrgentCareOrderingApiFp(configuration);
    return {
        /**
         *
         * @param {string} urgentCareOrderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicUrgentCareOrderDetails(urgentCareOrderId, options) {
            return localVarFp.getPublicUrgentCareOrderDetails(urgentCareOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} urgentCareOrderRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUrgentCareOrderRequest(urgentCareOrderRequestId, options) {
            return localVarFp.getUrgentCareOrderRequest(urgentCareOrderRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {boolean} [cancelledIn]
         * @param {string} [companyId]
         * @param {boolean} [completedIn]
         * @param {boolean} [excludeCancelledUnlessResultedIn]
         * @param {boolean} [includeTagsIn]
         * @param {'LabCorp' | 'Quest' | 'Sunrise Medical'} [lab] * &#x60;LabCorp&#x60; - Lab Corp * &#x60;Quest&#x60; - Quest * &#x60;Sunrise Medical&#x60; - Sunrise Medical
         * @param {number} [limit]
         * @param {string} [memberId]
         * @param {boolean} [needsReviewedIn]
         * @param {boolean} [orderedIn]
         * @param {number} [page]
         * @param {string} [requestedOnEndDatetime]
         * @param {string} [requestedOnStartDatetime]
         * @param {'CVS MinuteClinic'} [urgentCare] * &#x60;CVS MinuteClinic&#x60; - Cvs Minute Clinic
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrderRequests(cancelledIn, companyId, completedIn, excludeCancelledUnlessResultedIn, includeTagsIn, lab, limit, memberId, needsReviewedIn, orderedIn, page, requestedOnEndDatetime, requestedOnStartDatetime, urgentCare, options) {
            return localVarFp.listOrderRequests(cancelledIn, companyId, completedIn, excludeCancelledUnlessResultedIn, includeTagsIn, lab, limit, memberId, needsReviewedIn, orderedIn, page, requestedOnEndDatetime, requestedOnStartDatetime, urgentCare, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PlaceOrderRequestsForMembersRequest} placeOrderRequestsForMembersRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placeOrderRequestsForMembers(placeOrderRequestsForMembersRequest, options) {
            return localVarFp.placeOrderRequestsForMembers(placeOrderRequestsForMembersRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} urgentCareOrderRequestId
         * @param {RsvpToUrgentCareOrderRequest} rsvpToUrgentCareOrderRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rsvpToUrgentCareOrderRequest(urgentCareOrderRequestId, rsvpToUrgentCareOrderRequest, options) {
            return localVarFp.rsvpToUrgentCareOrderRequest(urgentCareOrderRequestId, rsvpToUrgentCareOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} urgentCareOrderRequestId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendUrgentCareOrderInstructions(urgentCareOrderRequestId, options) {
            return localVarFp.sendUrgentCareOrderInstructions(urgentCareOrderRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} urgentCareOrderedServiceId
         * @param {string} resultsFile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadUrgentCareOrderedServiceResult(urgentCareOrderedServiceId, resultsFile, options) {
            return localVarFp.uploadUrgentCareOrderedServiceResult(urgentCareOrderedServiceId, resultsFile, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * UrgentCareOrderingApi - object-oriented interface
 * @export
 * @class UrgentCareOrderingApi
 * @extends {BaseAPI}
 */
class UrgentCareOrderingApi extends base_1.BaseAPI {
    /**
     *
     * @param {UrgentCareOrderingApiGetPublicUrgentCareOrderDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UrgentCareOrderingApi
     */
    getPublicUrgentCareOrderDetails(requestParameters, options) {
        return exports.UrgentCareOrderingApiFp(this.configuration).getPublicUrgentCareOrderDetails(requestParameters.urgentCareOrderId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UrgentCareOrderingApiGetUrgentCareOrderRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UrgentCareOrderingApi
     */
    getUrgentCareOrderRequest(requestParameters, options) {
        return exports.UrgentCareOrderingApiFp(this.configuration).getUrgentCareOrderRequest(requestParameters.urgentCareOrderRequestId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UrgentCareOrderingApiListOrderRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UrgentCareOrderingApi
     */
    listOrderRequests(requestParameters = {}, options) {
        return exports.UrgentCareOrderingApiFp(this.configuration).listOrderRequests(requestParameters.cancelledIn, requestParameters.companyId, requestParameters.completedIn, requestParameters.excludeCancelledUnlessResultedIn, requestParameters.includeTagsIn, requestParameters.lab, requestParameters.limit, requestParameters.memberId, requestParameters.needsReviewedIn, requestParameters.orderedIn, requestParameters.page, requestParameters.requestedOnEndDatetime, requestParameters.requestedOnStartDatetime, requestParameters.urgentCare, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UrgentCareOrderingApiPlaceOrderRequestsForMembersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UrgentCareOrderingApi
     */
    placeOrderRequestsForMembers(requestParameters, options) {
        return exports.UrgentCareOrderingApiFp(this.configuration).placeOrderRequestsForMembers(requestParameters.placeOrderRequestsForMembersRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UrgentCareOrderingApiRsvpToUrgentCareOrderRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UrgentCareOrderingApi
     */
    rsvpToUrgentCareOrderRequest(requestParameters, options) {
        return exports.UrgentCareOrderingApiFp(this.configuration).rsvpToUrgentCareOrderRequest(requestParameters.urgentCareOrderRequestId, requestParameters.rsvpToUrgentCareOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UrgentCareOrderingApiSendUrgentCareOrderInstructionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UrgentCareOrderingApi
     */
    sendUrgentCareOrderInstructions(requestParameters, options) {
        return exports.UrgentCareOrderingApiFp(this.configuration).sendUrgentCareOrderInstructions(requestParameters.urgentCareOrderRequestId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UrgentCareOrderingApiUploadUrgentCareOrderedServiceResultRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UrgentCareOrderingApi
     */
    uploadUrgentCareOrderedServiceResult(requestParameters, options) {
        return exports.UrgentCareOrderingApiFp(this.configuration).uploadUrgentCareOrderedServiceResult(requestParameters.urgentCareOrderedServiceId, requestParameters.resultsFile, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.UrgentCareOrderingApi = UrgentCareOrderingApi;
/**
 * UserApi - axios parameter creator
 * @export
 */
exports.UserApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser: (userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            common_1.assertParamExists('getUser', 'userId', userId);
            const localVarPath = `/v1/user/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {RequestEmailChangeRequest} requestEmailChangeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestEmailChange: (requestEmailChangeRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'requestEmailChangeRequest' is not null or undefined
            common_1.assertParamExists('requestEmailChange', 'requestEmailChangeRequest', requestEmailChangeRequest);
            const localVarPath = `/v1/user/email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(requestEmailChangeRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {RequestPhoneNumberChangeRequest} requestPhoneNumberChangeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPhoneNumberChange: (requestPhoneNumberChangeRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'requestPhoneNumberChangeRequest' is not null or undefined
            common_1.assertParamExists('requestPhoneNumberChange', 'requestPhoneNumberChangeRequest', requestPhoneNumberChangeRequest);
            const localVarPath = `/v1/user/phone`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(requestPhoneNumberChangeRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {UpdateNotificationTokenRequest} updateNotificationTokenRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotificationToken: (updateNotificationTokenRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'updateNotificationTokenRequest' is not null or undefined
            common_1.assertParamExists('updateNotificationToken', 'updateNotificationTokenRequest', updateNotificationTokenRequest);
            const localVarPath = `/v1/push-notification-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updateNotificationTokenRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {UpdatePasswordRequest} updatePasswordRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePassword: (updatePasswordRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'updatePasswordRequest' is not null or undefined
            common_1.assertParamExists('updatePassword', 'updatePasswordRequest', updatePasswordRequest);
            const localVarPath = `/v1/user/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(updatePasswordRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {VerifyEmailChangeRequest} verifyEmailChangeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyEmailChange: (verifyEmailChangeRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'verifyEmailChangeRequest' is not null or undefined
            common_1.assertParamExists('verifyEmailChange', 'verifyEmailChangeRequest', verifyEmailChangeRequest);
            const localVarPath = `/v1/user/email/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(verifyEmailChangeRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {VerifyPhoneNumberChangeRequest} verifyPhoneNumberChangeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyPhoneNumberChange: (verifyPhoneNumberChangeRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'verifyPhoneNumberChangeRequest' is not null or undefined
            common_1.assertParamExists('verifyPhoneNumberChange', 'verifyPhoneNumberChangeRequest', verifyPhoneNumberChangeRequest);
            const localVarPath = `/v1/user/phone/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(verifyPhoneNumberChangeRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * UserApi - functional programming interface
 * @export
 */
exports.UserApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.UserApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser(userId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUser(userId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {RequestEmailChangeRequest} requestEmailChangeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestEmailChange(requestEmailChangeRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.requestEmailChange(requestEmailChangeRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {RequestPhoneNumberChangeRequest} requestPhoneNumberChangeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPhoneNumberChange(requestPhoneNumberChangeRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.requestPhoneNumberChange(requestPhoneNumberChangeRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {UpdateNotificationTokenRequest} updateNotificationTokenRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotificationToken(updateNotificationTokenRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateNotificationToken(updateNotificationTokenRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {UpdatePasswordRequest} updatePasswordRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePassword(updatePasswordRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updatePassword(updatePasswordRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {VerifyEmailChangeRequest} verifyEmailChangeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyEmailChange(verifyEmailChangeRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.verifyEmailChange(verifyEmailChangeRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {VerifyPhoneNumberChangeRequest} verifyPhoneNumberChangeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyPhoneNumberChange(verifyPhoneNumberChangeRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.verifyPhoneNumberChange(verifyPhoneNumberChangeRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * UserApi - factory interface
 * @export
 */
exports.UserApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.UserApiFp(configuration);
    return {
        /**
         *
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser(userId, options) {
            return localVarFp.getUser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {RequestEmailChangeRequest} requestEmailChangeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestEmailChange(requestEmailChangeRequest, options) {
            return localVarFp.requestEmailChange(requestEmailChangeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {RequestPhoneNumberChangeRequest} requestPhoneNumberChangeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPhoneNumberChange(requestPhoneNumberChangeRequest, options) {
            return localVarFp.requestPhoneNumberChange(requestPhoneNumberChangeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UpdateNotificationTokenRequest} updateNotificationTokenRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotificationToken(updateNotificationTokenRequest, options) {
            return localVarFp.updateNotificationToken(updateNotificationTokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {UpdatePasswordRequest} updatePasswordRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePassword(updatePasswordRequest, options) {
            return localVarFp.updatePassword(updatePasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {VerifyEmailChangeRequest} verifyEmailChangeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyEmailChange(verifyEmailChangeRequest, options) {
            return localVarFp.verifyEmailChange(verifyEmailChangeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {VerifyPhoneNumberChangeRequest} verifyPhoneNumberChangeRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyPhoneNumberChange(verifyPhoneNumberChangeRequest, options) {
            return localVarFp.verifyPhoneNumberChange(verifyPhoneNumberChangeRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
class UserApi extends base_1.BaseAPI {
    /**
     *
     * @param {UserApiGetUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    getUser(requestParameters, options) {
        return exports.UserApiFp(this.configuration).getUser(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UserApiRequestEmailChangeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    requestEmailChange(requestParameters, options) {
        return exports.UserApiFp(this.configuration).requestEmailChange(requestParameters.requestEmailChangeRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UserApiRequestPhoneNumberChangeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    requestPhoneNumberChange(requestParameters, options) {
        return exports.UserApiFp(this.configuration).requestPhoneNumberChange(requestParameters.requestPhoneNumberChangeRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UserApiUpdateNotificationTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    updateNotificationToken(requestParameters, options) {
        return exports.UserApiFp(this.configuration).updateNotificationToken(requestParameters.updateNotificationTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UserApiUpdatePasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    updatePassword(requestParameters, options) {
        return exports.UserApiFp(this.configuration).updatePassword(requestParameters.updatePasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UserApiVerifyEmailChangeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    verifyEmailChange(requestParameters, options) {
        return exports.UserApiFp(this.configuration).verifyEmailChange(requestParameters.verifyEmailChangeRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UserApiVerifyPhoneNumberChangeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    verifyPhoneNumberChange(requestParameters, options) {
        return exports.UserApiFp(this.configuration).verifyPhoneNumberChange(requestParameters.verifyPhoneNumberChangeRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.UserApi = UserApi;
/**
 * UtilityApi - axios parameter creator
 * @export
 */
exports.UtilityApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dummyEnumResponse: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/enums`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppVersion: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/app-versions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZendeskJwt: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/zendesk/auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheck: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ReportBugApiRequest} reportBugApiRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportBug: (reportBugApiRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'reportBugApiRequest' is not null or undefined
            common_1.assertParamExists('reportBug', 'reportBugApiRequest', reportBugApiRequest);
            const localVarPath = `/v1/bug-report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(reportBugApiRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * UtilityApi - functional programming interface
 * @export
 */
exports.UtilityApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.UtilityApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dummyEnumResponse(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.dummyEnumResponse(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppVersion(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAppVersion(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZendeskJwt(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getZendeskJwt(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheck(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.healthCheck(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {ReportBugApiRequest} reportBugApiRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportBug(reportBugApiRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportBug(reportBugApiRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * UtilityApi - factory interface
 * @export
 */
exports.UtilityApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.UtilityApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dummyEnumResponse(options) {
            return localVarFp.dummyEnumResponse(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppVersion(options) {
            return localVarFp.getAppVersion(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZendeskJwt(options) {
            return localVarFp.getZendeskJwt(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheck(options) {
            return localVarFp.healthCheck(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ReportBugApiRequest} reportBugApiRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportBug(reportBugApiRequest, options) {
            return localVarFp.reportBug(reportBugApiRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * UtilityApi - object-oriented interface
 * @export
 * @class UtilityApi
 * @extends {BaseAPI}
 */
class UtilityApi extends base_1.BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityApi
     */
    dummyEnumResponse(options) {
        return exports.UtilityApiFp(this.configuration).dummyEnumResponse(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityApi
     */
    getAppVersion(options) {
        return exports.UtilityApiFp(this.configuration).getAppVersion(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityApi
     */
    getZendeskJwt(options) {
        return exports.UtilityApiFp(this.configuration).getZendeskJwt(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityApi
     */
    healthCheck(options) {
        return exports.UtilityApiFp(this.configuration).healthCheck(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {UtilityApiReportBugRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilityApi
     */
    reportBug(requestParameters, options) {
        return exports.UtilityApiFp(this.configuration).reportBug(requestParameters.reportBugApiRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.UtilityApi = UtilityApi;
/**
 * WorkforceIntegrationApi - axios parameter creator
 * @export
 */
exports.WorkforceIntegrationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} integrationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkforceIntegration: (integrationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'integrationId' is not null or undefined
            common_1.assertParamExists('getWorkforceIntegration', 'integrationId', integrationId);
            const localVarPath = `/v1/workforce-integrations/{integration_id}`
                .replace(`{${"integration_id"}}`, encodeURIComponent(String(integrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} syncErrorId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkforceIntegrationSyncError: (syncErrorId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'syncErrorId' is not null or undefined
            common_1.assertParamExists('getWorkforceIntegrationSyncError', 'syncErrorId', syncErrorId);
            const localVarPath = `/v1/workforce-integration-sync-errors/{sync_error_id}`
                .replace(`{${"sync_error_id"}}`, encodeURIComponent(String(syncErrorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} operationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkforceIntegrationSyncOperation: (operationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'operationId' is not null or undefined
            common_1.assertParamExists('getWorkforceIntegrationSyncOperation', 'operationId', operationId);
            const localVarPath = `/v1/workforce-integration-operations/{operation_id}`
                .replace(`{${"operation_id"}}`, encodeURIComponent(String(operationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [companyId]
         * @param {string} [companyName]
         * @param {string} [createdAfter]
         * @param {string} [createdBefore]
         * @param {string} [duplicateMemberId]
         * @param {string} [duplicateMemberName]
         * @param {'Duplicate demographics' | 'Invalid demographics' | 'Unknown' | 'null'} [errorType] * &#x60;Duplicate demographics&#x60; - Duplicate Demographics * &#x60;Invalid demographics&#x60; - Invalid Demographics * &#x60;Unknown&#x60; - Unknown
         * @param {boolean} [fixableByEmployerIn]
         * @param {string} [hrisId]
         * @param {string} [integrationId]
         * @param {number} [limit]
         * @param {string} [operationId]
         * @param {number} [page]
         * @param {string} [resolvedById]
         * @param {boolean} [resolvedIn]
         * @param {string} [resolvedOnAfter]
         * @param {string} [resolvedOnBefore]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkforceIntegrationSyncErrors: (companyId, companyName, createdAfter, createdBefore, duplicateMemberId, duplicateMemberName, errorType, fixableByEmployerIn, hrisId, integrationId, limit, operationId, page, resolvedById, resolvedIn, resolvedOnAfter, resolvedOnBefore, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/workforce-integration-sync-errors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }
            if (companyName !== undefined) {
                localVarQueryParameter['company_name'] = companyName;
            }
            if (createdAfter !== undefined) {
                localVarQueryParameter['created_after'] = (createdAfter instanceof Date) ?
                    createdAfter.toISOString() :
                    createdAfter;
            }
            if (createdBefore !== undefined) {
                localVarQueryParameter['created_before'] = (createdBefore instanceof Date) ?
                    createdBefore.toISOString() :
                    createdBefore;
            }
            if (duplicateMemberId !== undefined) {
                localVarQueryParameter['duplicate_member_id'] = duplicateMemberId;
            }
            if (duplicateMemberName !== undefined) {
                localVarQueryParameter['duplicate_member_name'] = duplicateMemberName;
            }
            if (errorType !== undefined) {
                localVarQueryParameter['error_type'] = errorType;
            }
            if (fixableByEmployerIn !== undefined) {
                localVarQueryParameter['fixable_by_employer_in'] = fixableByEmployerIn;
            }
            if (hrisId !== undefined) {
                localVarQueryParameter['hris_id'] = hrisId;
            }
            if (integrationId !== undefined) {
                localVarQueryParameter['integration_id'] = integrationId;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (operationId !== undefined) {
                localVarQueryParameter['operation_id'] = operationId;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (resolvedById !== undefined) {
                localVarQueryParameter['resolved_by_id'] = resolvedById;
            }
            if (resolvedIn !== undefined) {
                localVarQueryParameter['resolved_in'] = resolvedIn;
            }
            if (resolvedOnAfter !== undefined) {
                localVarQueryParameter['resolved_on_after'] = (resolvedOnAfter instanceof Date) ?
                    resolvedOnAfter.toISOString() :
                    resolvedOnAfter;
            }
            if (resolvedOnBefore !== undefined) {
                localVarQueryParameter['resolved_on_before'] = (resolvedOnBefore instanceof Date) ?
                    resolvedOnBefore.toISOString() :
                    resolvedOnBefore;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [companyId]
         * @param {string} [createdAfter]
         * @param {string} [createdBefore]
         * @param {boolean} [errorOccurredIn]
         * @param {'Duplicate demographics' | 'Invalid demographics' | 'Unknown' | 'null'} [errorType] * &#x60;Duplicate demographics&#x60; - Duplicate Demographics * &#x60;Invalid demographics&#x60; - Invalid Demographics * &#x60;Unknown&#x60; - Unknown
         * @param {'Added' | 'Removed' | 'Updated' | 'Reactivated' | 'null'} [eventType] * &#x60;Added&#x60; - Added * &#x60;Removed&#x60; - Removed * &#x60;Updated&#x60; - Updated * &#x60;Reactivated&#x60; - Reactivated
         * @param {number} [limit]
         * @param {string} [operationId]
         * @param {number} [page]
         * @param {string} [personName]
         * @param {boolean} [resolvedIn]
         * @param {string} [resolvedOnAfter]
         * @param {string} [resolvedOnBefore]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkforceIntegrationSyncOperationEvents: (companyId, createdAfter, createdBefore, errorOccurredIn, errorType, eventType, limit, operationId, page, personName, resolvedIn, resolvedOnAfter, resolvedOnBefore, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/workforce-integration-operation-events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }
            if (createdAfter !== undefined) {
                localVarQueryParameter['created_after'] = (createdAfter instanceof Date) ?
                    createdAfter.toISOString() :
                    createdAfter;
            }
            if (createdBefore !== undefined) {
                localVarQueryParameter['created_before'] = (createdBefore instanceof Date) ?
                    createdBefore.toISOString() :
                    createdBefore;
            }
            if (errorOccurredIn !== undefined) {
                localVarQueryParameter['error_occurred_in'] = errorOccurredIn;
            }
            if (errorType !== undefined) {
                localVarQueryParameter['error_type'] = errorType;
            }
            if (eventType !== undefined) {
                localVarQueryParameter['event_type'] = eventType;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (operationId !== undefined) {
                localVarQueryParameter['operation_id'] = operationId;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (personName !== undefined) {
                localVarQueryParameter['person_name'] = personName;
            }
            if (resolvedIn !== undefined) {
                localVarQueryParameter['resolved_in'] = resolvedIn;
            }
            if (resolvedOnAfter !== undefined) {
                localVarQueryParameter['resolved_on_after'] = (resolvedOnAfter instanceof Date) ?
                    resolvedOnAfter.toISOString() :
                    resolvedOnAfter;
            }
            if (resolvedOnBefore !== undefined) {
                localVarQueryParameter['resolved_on_before'] = (resolvedOnBefore instanceof Date) ?
                    resolvedOnBefore.toISOString() :
                    resolvedOnBefore;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} integrationId
         * @param {boolean} [completedIn]
         * @param {string} [completedOnAfter]
         * @param {string} [completedOnBefore]
         * @param {string} [createdAfter]
         * @param {string} [createdBefore]
         * @param {number} [limit]
         * @param {number} [page]
         * @param {'Running' | 'Success' | 'Failure' | 'null'} [status] * &#x60;Running&#x60; - Running * &#x60;Success&#x60; - Success * &#x60;Failure&#x60; - Failure
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkforceIntegrationSyncOperations: (integrationId, completedIn, completedOnAfter, completedOnBefore, createdAfter, createdBefore, limit, page, status, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'integrationId' is not null or undefined
            common_1.assertParamExists('listWorkforceIntegrationSyncOperations', 'integrationId', integrationId);
            const localVarPath = `/v1/workforce-integrations/{integration_id}/operations`
                .replace(`{${"integration_id"}}`, encodeURIComponent(String(integrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (completedIn !== undefined) {
                localVarQueryParameter['completed_in'] = completedIn;
            }
            if (completedOnAfter !== undefined) {
                localVarQueryParameter['completed_on_after'] = (completedOnAfter instanceof Date) ?
                    completedOnAfter.toISOString() :
                    completedOnAfter;
            }
            if (completedOnBefore !== undefined) {
                localVarQueryParameter['completed_on_before'] = (completedOnBefore instanceof Date) ?
                    completedOnBefore.toISOString() :
                    completedOnBefore;
            }
            if (createdAfter !== undefined) {
                localVarQueryParameter['created_after'] = (createdAfter instanceof Date) ?
                    createdAfter.toISOString() :
                    createdAfter;
            }
            if (createdBefore !== undefined) {
                localVarQueryParameter['created_before'] = (createdBefore instanceof Date) ?
                    createdBefore.toISOString() :
                    createdBefore;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [companyId]
         * @param {string} [companyName]
         * @param {boolean} [excludeTerminatedAndInactiveIn]
         * @param {number} [limit]
         * @param {number} [page]
         * @param {'Pending' | 'Active' | 'Inactive' | 'Terminated' | 'null'} [status] * &#x60;Pending&#x60; - Pending * &#x60;Active&#x60; - Active * &#x60;Inactive&#x60; - Inactive * &#x60;Terminated&#x60; - Terminated
         * @param {'Automated' | 'Manual' | 'null'} [syncType] * &#x60;Automated&#x60; - Automated * &#x60;Manual&#x60; - Manual
         * @param {'HRIS' | 'ATS' | 'null'} [systemType] * &#x60;HRIS&#x60; - Hris * &#x60;ATS&#x60; - Ats
         * @param {'Finch' | 'HHAeXchange' | 'null'} [vendor] * &#x60;Finch&#x60; - Finch * &#x60;HHAeXchange&#x60; - Hha Exchange
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkforceIntegrations: (companyId, companyName, excludeTerminatedAndInactiveIn, limit, page, status, syncType, systemType, vendor, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/workforce-integrations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }
            if (companyName !== undefined) {
                localVarQueryParameter['company_name'] = companyName;
            }
            if (excludeTerminatedAndInactiveIn !== undefined) {
                localVarQueryParameter['exclude_terminated_and_inactive_in'] = excludeTerminatedAndInactiveIn;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (syncType !== undefined) {
                localVarQueryParameter['sync_type'] = syncType;
            }
            if (systemType !== undefined) {
                localVarQueryParameter['system_type'] = systemType;
            }
            if (vendor !== undefined) {
                localVarQueryParameter['vendor'] = vendor;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} companyId
         * @param {RegisterWorkforceIntegrationRequest} registerWorkforceIntegrationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerWorkforceIntegration: (companyId, registerWorkforceIntegrationRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyId' is not null or undefined
            common_1.assertParamExists('registerWorkforceIntegration', 'companyId', companyId);
            // verify required parameter 'registerWorkforceIntegrationRequest' is not null or undefined
            common_1.assertParamExists('registerWorkforceIntegration', 'registerWorkforceIntegrationRequest', registerWorkforceIntegrationRequest);
            const localVarPath = `/v1/companies/{company_id}/workforce-integrations`
                .replace(`{${"company_id"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(registerWorkforceIntegrationRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} syncErrorId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveWorkforceIntegrationSyncError: (syncErrorId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'syncErrorId' is not null or undefined
            common_1.assertParamExists('resolveWorkforceIntegrationSyncError', 'syncErrorId', syncErrorId);
            const localVarPath = `/v1/workforce-integration-sync-errors/{sync_error_id}/resolve`
                .replace(`{${"sync_error_id"}}`, encodeURIComponent(String(syncErrorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * WorkforceIntegrationApi - functional programming interface
 * @export
 */
exports.WorkforceIntegrationApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.WorkforceIntegrationApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} integrationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkforceIntegration(integrationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getWorkforceIntegration(integrationId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} syncErrorId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkforceIntegrationSyncError(syncErrorId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getWorkforceIntegrationSyncError(syncErrorId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} operationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkforceIntegrationSyncOperation(operationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getWorkforceIntegrationSyncOperation(operationId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} [companyId]
         * @param {string} [companyName]
         * @param {string} [createdAfter]
         * @param {string} [createdBefore]
         * @param {string} [duplicateMemberId]
         * @param {string} [duplicateMemberName]
         * @param {'Duplicate demographics' | 'Invalid demographics' | 'Unknown' | 'null'} [errorType] * &#x60;Duplicate demographics&#x60; - Duplicate Demographics * &#x60;Invalid demographics&#x60; - Invalid Demographics * &#x60;Unknown&#x60; - Unknown
         * @param {boolean} [fixableByEmployerIn]
         * @param {string} [hrisId]
         * @param {string} [integrationId]
         * @param {number} [limit]
         * @param {string} [operationId]
         * @param {number} [page]
         * @param {string} [resolvedById]
         * @param {boolean} [resolvedIn]
         * @param {string} [resolvedOnAfter]
         * @param {string} [resolvedOnBefore]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkforceIntegrationSyncErrors(companyId, companyName, createdAfter, createdBefore, duplicateMemberId, duplicateMemberName, errorType, fixableByEmployerIn, hrisId, integrationId, limit, operationId, page, resolvedById, resolvedIn, resolvedOnAfter, resolvedOnBefore, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listWorkforceIntegrationSyncErrors(companyId, companyName, createdAfter, createdBefore, duplicateMemberId, duplicateMemberName, errorType, fixableByEmployerIn, hrisId, integrationId, limit, operationId, page, resolvedById, resolvedIn, resolvedOnAfter, resolvedOnBefore, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} [companyId]
         * @param {string} [createdAfter]
         * @param {string} [createdBefore]
         * @param {boolean} [errorOccurredIn]
         * @param {'Duplicate demographics' | 'Invalid demographics' | 'Unknown' | 'null'} [errorType] * &#x60;Duplicate demographics&#x60; - Duplicate Demographics * &#x60;Invalid demographics&#x60; - Invalid Demographics * &#x60;Unknown&#x60; - Unknown
         * @param {'Added' | 'Removed' | 'Updated' | 'Reactivated' | 'null'} [eventType] * &#x60;Added&#x60; - Added * &#x60;Removed&#x60; - Removed * &#x60;Updated&#x60; - Updated * &#x60;Reactivated&#x60; - Reactivated
         * @param {number} [limit]
         * @param {string} [operationId]
         * @param {number} [page]
         * @param {string} [personName]
         * @param {boolean} [resolvedIn]
         * @param {string} [resolvedOnAfter]
         * @param {string} [resolvedOnBefore]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkforceIntegrationSyncOperationEvents(companyId, createdAfter, createdBefore, errorOccurredIn, errorType, eventType, limit, operationId, page, personName, resolvedIn, resolvedOnAfter, resolvedOnBefore, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listWorkforceIntegrationSyncOperationEvents(companyId, createdAfter, createdBefore, errorOccurredIn, errorType, eventType, limit, operationId, page, personName, resolvedIn, resolvedOnAfter, resolvedOnBefore, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} integrationId
         * @param {boolean} [completedIn]
         * @param {string} [completedOnAfter]
         * @param {string} [completedOnBefore]
         * @param {string} [createdAfter]
         * @param {string} [createdBefore]
         * @param {number} [limit]
         * @param {number} [page]
         * @param {'Running' | 'Success' | 'Failure' | 'null'} [status] * &#x60;Running&#x60; - Running * &#x60;Success&#x60; - Success * &#x60;Failure&#x60; - Failure
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkforceIntegrationSyncOperations(integrationId, completedIn, completedOnAfter, completedOnBefore, createdAfter, createdBefore, limit, page, status, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listWorkforceIntegrationSyncOperations(integrationId, completedIn, completedOnAfter, completedOnBefore, createdAfter, createdBefore, limit, page, status, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} [companyId]
         * @param {string} [companyName]
         * @param {boolean} [excludeTerminatedAndInactiveIn]
         * @param {number} [limit]
         * @param {number} [page]
         * @param {'Pending' | 'Active' | 'Inactive' | 'Terminated' | 'null'} [status] * &#x60;Pending&#x60; - Pending * &#x60;Active&#x60; - Active * &#x60;Inactive&#x60; - Inactive * &#x60;Terminated&#x60; - Terminated
         * @param {'Automated' | 'Manual' | 'null'} [syncType] * &#x60;Automated&#x60; - Automated * &#x60;Manual&#x60; - Manual
         * @param {'HRIS' | 'ATS' | 'null'} [systemType] * &#x60;HRIS&#x60; - Hris * &#x60;ATS&#x60; - Ats
         * @param {'Finch' | 'HHAeXchange' | 'null'} [vendor] * &#x60;Finch&#x60; - Finch * &#x60;HHAeXchange&#x60; - Hha Exchange
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkforceIntegrations(companyId, companyName, excludeTerminatedAndInactiveIn, limit, page, status, syncType, systemType, vendor, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listWorkforceIntegrations(companyId, companyName, excludeTerminatedAndInactiveIn, limit, page, status, syncType, systemType, vendor, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} companyId
         * @param {RegisterWorkforceIntegrationRequest} registerWorkforceIntegrationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerWorkforceIntegration(companyId, registerWorkforceIntegrationRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.registerWorkforceIntegration(companyId, registerWorkforceIntegrationRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} syncErrorId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveWorkforceIntegrationSyncError(syncErrorId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.resolveWorkforceIntegrationSyncError(syncErrorId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * WorkforceIntegrationApi - factory interface
 * @export
 */
exports.WorkforceIntegrationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.WorkforceIntegrationApiFp(configuration);
    return {
        /**
         *
         * @param {string} integrationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkforceIntegration(integrationId, options) {
            return localVarFp.getWorkforceIntegration(integrationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} syncErrorId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkforceIntegrationSyncError(syncErrorId, options) {
            return localVarFp.getWorkforceIntegrationSyncError(syncErrorId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} operationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkforceIntegrationSyncOperation(operationId, options) {
            return localVarFp.getWorkforceIntegrationSyncOperation(operationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [companyId]
         * @param {string} [companyName]
         * @param {string} [createdAfter]
         * @param {string} [createdBefore]
         * @param {string} [duplicateMemberId]
         * @param {string} [duplicateMemberName]
         * @param {'Duplicate demographics' | 'Invalid demographics' | 'Unknown' | 'null'} [errorType] * &#x60;Duplicate demographics&#x60; - Duplicate Demographics * &#x60;Invalid demographics&#x60; - Invalid Demographics * &#x60;Unknown&#x60; - Unknown
         * @param {boolean} [fixableByEmployerIn]
         * @param {string} [hrisId]
         * @param {string} [integrationId]
         * @param {number} [limit]
         * @param {string} [operationId]
         * @param {number} [page]
         * @param {string} [resolvedById]
         * @param {boolean} [resolvedIn]
         * @param {string} [resolvedOnAfter]
         * @param {string} [resolvedOnBefore]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkforceIntegrationSyncErrors(companyId, companyName, createdAfter, createdBefore, duplicateMemberId, duplicateMemberName, errorType, fixableByEmployerIn, hrisId, integrationId, limit, operationId, page, resolvedById, resolvedIn, resolvedOnAfter, resolvedOnBefore, options) {
            return localVarFp.listWorkforceIntegrationSyncErrors(companyId, companyName, createdAfter, createdBefore, duplicateMemberId, duplicateMemberName, errorType, fixableByEmployerIn, hrisId, integrationId, limit, operationId, page, resolvedById, resolvedIn, resolvedOnAfter, resolvedOnBefore, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [companyId]
         * @param {string} [createdAfter]
         * @param {string} [createdBefore]
         * @param {boolean} [errorOccurredIn]
         * @param {'Duplicate demographics' | 'Invalid demographics' | 'Unknown' | 'null'} [errorType] * &#x60;Duplicate demographics&#x60; - Duplicate Demographics * &#x60;Invalid demographics&#x60; - Invalid Demographics * &#x60;Unknown&#x60; - Unknown
         * @param {'Added' | 'Removed' | 'Updated' | 'Reactivated' | 'null'} [eventType] * &#x60;Added&#x60; - Added * &#x60;Removed&#x60; - Removed * &#x60;Updated&#x60; - Updated * &#x60;Reactivated&#x60; - Reactivated
         * @param {number} [limit]
         * @param {string} [operationId]
         * @param {number} [page]
         * @param {string} [personName]
         * @param {boolean} [resolvedIn]
         * @param {string} [resolvedOnAfter]
         * @param {string} [resolvedOnBefore]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkforceIntegrationSyncOperationEvents(companyId, createdAfter, createdBefore, errorOccurredIn, errorType, eventType, limit, operationId, page, personName, resolvedIn, resolvedOnAfter, resolvedOnBefore, options) {
            return localVarFp.listWorkforceIntegrationSyncOperationEvents(companyId, createdAfter, createdBefore, errorOccurredIn, errorType, eventType, limit, operationId, page, personName, resolvedIn, resolvedOnAfter, resolvedOnBefore, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} integrationId
         * @param {boolean} [completedIn]
         * @param {string} [completedOnAfter]
         * @param {string} [completedOnBefore]
         * @param {string} [createdAfter]
         * @param {string} [createdBefore]
         * @param {number} [limit]
         * @param {number} [page]
         * @param {'Running' | 'Success' | 'Failure' | 'null'} [status] * &#x60;Running&#x60; - Running * &#x60;Success&#x60; - Success * &#x60;Failure&#x60; - Failure
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkforceIntegrationSyncOperations(integrationId, completedIn, completedOnAfter, completedOnBefore, createdAfter, createdBefore, limit, page, status, options) {
            return localVarFp.listWorkforceIntegrationSyncOperations(integrationId, completedIn, completedOnAfter, completedOnBefore, createdAfter, createdBefore, limit, page, status, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [companyId]
         * @param {string} [companyName]
         * @param {boolean} [excludeTerminatedAndInactiveIn]
         * @param {number} [limit]
         * @param {number} [page]
         * @param {'Pending' | 'Active' | 'Inactive' | 'Terminated' | 'null'} [status] * &#x60;Pending&#x60; - Pending * &#x60;Active&#x60; - Active * &#x60;Inactive&#x60; - Inactive * &#x60;Terminated&#x60; - Terminated
         * @param {'Automated' | 'Manual' | 'null'} [syncType] * &#x60;Automated&#x60; - Automated * &#x60;Manual&#x60; - Manual
         * @param {'HRIS' | 'ATS' | 'null'} [systemType] * &#x60;HRIS&#x60; - Hris * &#x60;ATS&#x60; - Ats
         * @param {'Finch' | 'HHAeXchange' | 'null'} [vendor] * &#x60;Finch&#x60; - Finch * &#x60;HHAeXchange&#x60; - Hha Exchange
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWorkforceIntegrations(companyId, companyName, excludeTerminatedAndInactiveIn, limit, page, status, syncType, systemType, vendor, options) {
            return localVarFp.listWorkforceIntegrations(companyId, companyName, excludeTerminatedAndInactiveIn, limit, page, status, syncType, systemType, vendor, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} companyId
         * @param {RegisterWorkforceIntegrationRequest} registerWorkforceIntegrationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerWorkforceIntegration(companyId, registerWorkforceIntegrationRequest, options) {
            return localVarFp.registerWorkforceIntegration(companyId, registerWorkforceIntegrationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} syncErrorId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveWorkforceIntegrationSyncError(syncErrorId, options) {
            return localVarFp.resolveWorkforceIntegrationSyncError(syncErrorId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * WorkforceIntegrationApi - object-oriented interface
 * @export
 * @class WorkforceIntegrationApi
 * @extends {BaseAPI}
 */
class WorkforceIntegrationApi extends base_1.BaseAPI {
    /**
     *
     * @param {WorkforceIntegrationApiGetWorkforceIntegrationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkforceIntegrationApi
     */
    getWorkforceIntegration(requestParameters, options) {
        return exports.WorkforceIntegrationApiFp(this.configuration).getWorkforceIntegration(requestParameters.integrationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {WorkforceIntegrationApiGetWorkforceIntegrationSyncErrorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkforceIntegrationApi
     */
    getWorkforceIntegrationSyncError(requestParameters, options) {
        return exports.WorkforceIntegrationApiFp(this.configuration).getWorkforceIntegrationSyncError(requestParameters.syncErrorId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {WorkforceIntegrationApiGetWorkforceIntegrationSyncOperationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkforceIntegrationApi
     */
    getWorkforceIntegrationSyncOperation(requestParameters, options) {
        return exports.WorkforceIntegrationApiFp(this.configuration).getWorkforceIntegrationSyncOperation(requestParameters.operationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {WorkforceIntegrationApiListWorkforceIntegrationSyncErrorsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkforceIntegrationApi
     */
    listWorkforceIntegrationSyncErrors(requestParameters = {}, options) {
        return exports.WorkforceIntegrationApiFp(this.configuration).listWorkforceIntegrationSyncErrors(requestParameters.companyId, requestParameters.companyName, requestParameters.createdAfter, requestParameters.createdBefore, requestParameters.duplicateMemberId, requestParameters.duplicateMemberName, requestParameters.errorType, requestParameters.fixableByEmployerIn, requestParameters.hrisId, requestParameters.integrationId, requestParameters.limit, requestParameters.operationId, requestParameters.page, requestParameters.resolvedById, requestParameters.resolvedIn, requestParameters.resolvedOnAfter, requestParameters.resolvedOnBefore, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {WorkforceIntegrationApiListWorkforceIntegrationSyncOperationEventsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkforceIntegrationApi
     */
    listWorkforceIntegrationSyncOperationEvents(requestParameters = {}, options) {
        return exports.WorkforceIntegrationApiFp(this.configuration).listWorkforceIntegrationSyncOperationEvents(requestParameters.companyId, requestParameters.createdAfter, requestParameters.createdBefore, requestParameters.errorOccurredIn, requestParameters.errorType, requestParameters.eventType, requestParameters.limit, requestParameters.operationId, requestParameters.page, requestParameters.personName, requestParameters.resolvedIn, requestParameters.resolvedOnAfter, requestParameters.resolvedOnBefore, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {WorkforceIntegrationApiListWorkforceIntegrationSyncOperationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkforceIntegrationApi
     */
    listWorkforceIntegrationSyncOperations(requestParameters, options) {
        return exports.WorkforceIntegrationApiFp(this.configuration).listWorkforceIntegrationSyncOperations(requestParameters.integrationId, requestParameters.completedIn, requestParameters.completedOnAfter, requestParameters.completedOnBefore, requestParameters.createdAfter, requestParameters.createdBefore, requestParameters.limit, requestParameters.page, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {WorkforceIntegrationApiListWorkforceIntegrationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkforceIntegrationApi
     */
    listWorkforceIntegrations(requestParameters = {}, options) {
        return exports.WorkforceIntegrationApiFp(this.configuration).listWorkforceIntegrations(requestParameters.companyId, requestParameters.companyName, requestParameters.excludeTerminatedAndInactiveIn, requestParameters.limit, requestParameters.page, requestParameters.status, requestParameters.syncType, requestParameters.systemType, requestParameters.vendor, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {WorkforceIntegrationApiRegisterWorkforceIntegrationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkforceIntegrationApi
     */
    registerWorkforceIntegration(requestParameters, options) {
        return exports.WorkforceIntegrationApiFp(this.configuration).registerWorkforceIntegration(requestParameters.companyId, requestParameters.registerWorkforceIntegrationRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {WorkforceIntegrationApiResolveWorkforceIntegrationSyncErrorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkforceIntegrationApi
     */
    resolveWorkforceIntegrationSyncError(requestParameters, options) {
        return exports.WorkforceIntegrationApiFp(this.configuration).resolveWorkforceIntegrationSyncError(requestParameters.syncErrorId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.WorkforceIntegrationApi = WorkforceIntegrationApi;
/**
 * YouthMembershipApi - axios parameter creator
 * @export
 */
exports.YouthMembershipApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} companyYouthMembershipPlanEnrollmentId
         * @param {ConsentToCompanyYouthMembershipPlanEnrollmentRequest} consentToCompanyYouthMembershipPlanEnrollmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        consentToYouthMembershipPlanEnrollment: (companyYouthMembershipPlanEnrollmentId, consentToCompanyYouthMembershipPlanEnrollmentRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyYouthMembershipPlanEnrollmentId' is not null or undefined
            common_1.assertParamExists('consentToYouthMembershipPlanEnrollment', 'companyYouthMembershipPlanEnrollmentId', companyYouthMembershipPlanEnrollmentId);
            // verify required parameter 'consentToCompanyYouthMembershipPlanEnrollmentRequest' is not null or undefined
            common_1.assertParamExists('consentToYouthMembershipPlanEnrollment', 'consentToCompanyYouthMembershipPlanEnrollmentRequest', consentToCompanyYouthMembershipPlanEnrollmentRequest);
            const localVarPath = `/v1/company-youth-membership-plan-enrollments/{company_youth_membership_plan_enrollment_id}/consent`
                .replace(`{${"company_youth_membership_plan_enrollment_id"}}`, encodeURIComponent(String(companyYouthMembershipPlanEnrollmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(consentToCompanyYouthMembershipPlanEnrollmentRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} companyId
         * @param {boolean} [answeredIn]
         * @param {string} [companyId2]
         * @param {string} [companyMemberId]
         * @param {'Enrolled' | 'Unanswered' | 'null'} [status] * &#x60;Enrolled&#x60; - Enrolled * &#x60;Unanswered&#x60; - Unanswered
         * @param {boolean} [terminatedIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveCompanyYouthMembershipPlan: (companyId, answeredIn, companyId2, companyMemberId, status, terminatedIn, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyId' is not null or undefined
            common_1.assertParamExists('getActiveCompanyYouthMembershipPlan', 'companyId', companyId);
            const localVarPath = `/v1/companies/{company_id}/active-company-youth-membership-plan`
                .replace(`{${"company_id"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (answeredIn !== undefined) {
                localVarQueryParameter['answered_in'] = answeredIn;
            }
            if (companyId2 !== undefined) {
                localVarQueryParameter['company_id'] = companyId2;
            }
            if (companyMemberId !== undefined) {
                localVarQueryParameter['company_member_id'] = companyMemberId;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (terminatedIn !== undefined) {
                localVarQueryParameter['terminated_in'] = terminatedIn;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActiveYouthMembershipPlanEnrollmentsForMember: (memberId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'memberId' is not null or undefined
            common_1.assertParamExists('listActiveYouthMembershipPlanEnrollmentsForMember', 'memberId', memberId);
            const localVarPath = `/v1/members/{member_id}/active-youth-membership-enrollments`
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} companyYouthMembershipPlanId
         * @param {boolean} [answeredIn]
         * @param {string} [companyId]
         * @param {string} [companyMemberId]
         * @param {'Enrolled' | 'Unanswered' | 'null'} [status] * &#x60;Enrolled&#x60; - Enrolled * &#x60;Unanswered&#x60; - Unanswered
         * @param {boolean} [terminatedIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompanyYouthMembershipPlanEnrollments: (companyYouthMembershipPlanId, answeredIn, companyId, companyMemberId, status, terminatedIn, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyYouthMembershipPlanId' is not null or undefined
            common_1.assertParamExists('listCompanyYouthMembershipPlanEnrollments', 'companyYouthMembershipPlanId', companyYouthMembershipPlanId);
            const localVarPath = `/v1/company-youth-membership-plans/{company_youth_membership_plan_id}/enrollments`
                .replace(`{${"company_youth_membership_plan_id"}}`, encodeURIComponent(String(companyYouthMembershipPlanId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (answeredIn !== undefined) {
                localVarQueryParameter['answered_in'] = answeredIn;
            }
            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }
            if (companyMemberId !== undefined) {
                localVarQueryParameter['company_member_id'] = companyMemberId;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (terminatedIn !== undefined) {
                localVarQueryParameter['terminated_in'] = terminatedIn;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOpenYouthMembershipPlanEnrollmentsForMember: (memberId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'memberId' is not null or undefined
            common_1.assertParamExists('listOpenYouthMembershipPlanEnrollmentsForMember', 'memberId', memberId);
            const localVarPath = `/v1/members/{member_id}/open-youth-membership-enrollments`
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwtAuth required
            yield common_1.setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * YouthMembershipApi - functional programming interface
 * @export
 */
exports.YouthMembershipApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.YouthMembershipApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} companyYouthMembershipPlanEnrollmentId
         * @param {ConsentToCompanyYouthMembershipPlanEnrollmentRequest} consentToCompanyYouthMembershipPlanEnrollmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        consentToYouthMembershipPlanEnrollment(companyYouthMembershipPlanEnrollmentId, consentToCompanyYouthMembershipPlanEnrollmentRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.consentToYouthMembershipPlanEnrollment(companyYouthMembershipPlanEnrollmentId, consentToCompanyYouthMembershipPlanEnrollmentRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} companyId
         * @param {boolean} [answeredIn]
         * @param {string} [companyId2]
         * @param {string} [companyMemberId]
         * @param {'Enrolled' | 'Unanswered' | 'null'} [status] * &#x60;Enrolled&#x60; - Enrolled * &#x60;Unanswered&#x60; - Unanswered
         * @param {boolean} [terminatedIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveCompanyYouthMembershipPlan(companyId, answeredIn, companyId2, companyMemberId, status, terminatedIn, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getActiveCompanyYouthMembershipPlan(companyId, answeredIn, companyId2, companyMemberId, status, terminatedIn, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActiveYouthMembershipPlanEnrollmentsForMember(memberId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listActiveYouthMembershipPlanEnrollmentsForMember(memberId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} companyYouthMembershipPlanId
         * @param {boolean} [answeredIn]
         * @param {string} [companyId]
         * @param {string} [companyMemberId]
         * @param {'Enrolled' | 'Unanswered' | 'null'} [status] * &#x60;Enrolled&#x60; - Enrolled * &#x60;Unanswered&#x60; - Unanswered
         * @param {boolean} [terminatedIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompanyYouthMembershipPlanEnrollments(companyYouthMembershipPlanId, answeredIn, companyId, companyMemberId, status, terminatedIn, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listCompanyYouthMembershipPlanEnrollments(companyYouthMembershipPlanId, answeredIn, companyId, companyMemberId, status, terminatedIn, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOpenYouthMembershipPlanEnrollmentsForMember(memberId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listOpenYouthMembershipPlanEnrollmentsForMember(memberId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * YouthMembershipApi - factory interface
 * @export
 */
exports.YouthMembershipApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.YouthMembershipApiFp(configuration);
    return {
        /**
         *
         * @param {string} companyYouthMembershipPlanEnrollmentId
         * @param {ConsentToCompanyYouthMembershipPlanEnrollmentRequest} consentToCompanyYouthMembershipPlanEnrollmentRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        consentToYouthMembershipPlanEnrollment(companyYouthMembershipPlanEnrollmentId, consentToCompanyYouthMembershipPlanEnrollmentRequest, options) {
            return localVarFp.consentToYouthMembershipPlanEnrollment(companyYouthMembershipPlanEnrollmentId, consentToCompanyYouthMembershipPlanEnrollmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} companyId
         * @param {boolean} [answeredIn]
         * @param {string} [companyId2]
         * @param {string} [companyMemberId]
         * @param {'Enrolled' | 'Unanswered' | 'null'} [status] * &#x60;Enrolled&#x60; - Enrolled * &#x60;Unanswered&#x60; - Unanswered
         * @param {boolean} [terminatedIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveCompanyYouthMembershipPlan(companyId, answeredIn, companyId2, companyMemberId, status, terminatedIn, options) {
            return localVarFp.getActiveCompanyYouthMembershipPlan(companyId, answeredIn, companyId2, companyMemberId, status, terminatedIn, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActiveYouthMembershipPlanEnrollmentsForMember(memberId, options) {
            return localVarFp.listActiveYouthMembershipPlanEnrollmentsForMember(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} companyYouthMembershipPlanId
         * @param {boolean} [answeredIn]
         * @param {string} [companyId]
         * @param {string} [companyMemberId]
         * @param {'Enrolled' | 'Unanswered' | 'null'} [status] * &#x60;Enrolled&#x60; - Enrolled * &#x60;Unanswered&#x60; - Unanswered
         * @param {boolean} [terminatedIn]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompanyYouthMembershipPlanEnrollments(companyYouthMembershipPlanId, answeredIn, companyId, companyMemberId, status, terminatedIn, options) {
            return localVarFp.listCompanyYouthMembershipPlanEnrollments(companyYouthMembershipPlanId, answeredIn, companyId, companyMemberId, status, terminatedIn, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} memberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOpenYouthMembershipPlanEnrollmentsForMember(memberId, options) {
            return localVarFp.listOpenYouthMembershipPlanEnrollmentsForMember(memberId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * YouthMembershipApi - object-oriented interface
 * @export
 * @class YouthMembershipApi
 * @extends {BaseAPI}
 */
class YouthMembershipApi extends base_1.BaseAPI {
    /**
     *
     * @param {YouthMembershipApiConsentToYouthMembershipPlanEnrollmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YouthMembershipApi
     */
    consentToYouthMembershipPlanEnrollment(requestParameters, options) {
        return exports.YouthMembershipApiFp(this.configuration).consentToYouthMembershipPlanEnrollment(requestParameters.companyYouthMembershipPlanEnrollmentId, requestParameters.consentToCompanyYouthMembershipPlanEnrollmentRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {YouthMembershipApiGetActiveCompanyYouthMembershipPlanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YouthMembershipApi
     */
    getActiveCompanyYouthMembershipPlan(requestParameters, options) {
        return exports.YouthMembershipApiFp(this.configuration).getActiveCompanyYouthMembershipPlan(requestParameters.companyId, requestParameters.answeredIn, requestParameters.companyId2, requestParameters.companyMemberId, requestParameters.status, requestParameters.terminatedIn, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {YouthMembershipApiListActiveYouthMembershipPlanEnrollmentsForMemberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YouthMembershipApi
     */
    listActiveYouthMembershipPlanEnrollmentsForMember(requestParameters, options) {
        return exports.YouthMembershipApiFp(this.configuration).listActiveYouthMembershipPlanEnrollmentsForMember(requestParameters.memberId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {YouthMembershipApiListCompanyYouthMembershipPlanEnrollmentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YouthMembershipApi
     */
    listCompanyYouthMembershipPlanEnrollments(requestParameters, options) {
        return exports.YouthMembershipApiFp(this.configuration).listCompanyYouthMembershipPlanEnrollments(requestParameters.companyYouthMembershipPlanId, requestParameters.answeredIn, requestParameters.companyId, requestParameters.companyMemberId, requestParameters.status, requestParameters.terminatedIn, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {YouthMembershipApiListOpenYouthMembershipPlanEnrollmentsForMemberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YouthMembershipApi
     */
    listOpenYouthMembershipPlanEnrollmentsForMember(requestParameters, options) {
        return exports.YouthMembershipApiFp(this.configuration).listOpenYouthMembershipPlanEnrollmentsForMember(requestParameters.memberId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.YouthMembershipApi = YouthMembershipApi;
